import Vue from 'vue';
import numeric$1 from 'vue-numeric-input';
import axios from 'axios';
import { v4 } from 'uuid';
import colorParse from 'color-parser';

//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$1Y = {
  name: "Button",
  props: {
    border: {
      type: String,
      default: '0'
    },
    padding: {
      type: String,
      default: '2px 12px 2px'
    },
    bold: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    height: String,
    width: String,
    color: {
      type: String,
      default: '#000'
    },
    background: {
      type: String,
      default: '#FFF'
    },
    hoverBackground: {
      type: String,
      default: '#f9f9f9'
    },
    hoverColor: {
      type: String
    },
    activeBackground: {
      type: String,
      default: '#dcdcdc'
    },
    disableBackground: {
      type: String,
      default: '#f9f9f9'
    },
    disableColor: {
      type: String,
      default: '#999'
    },
    textAlign: {
      type: String,
      default: 'centre'
    },
    borderRadius: {
      type: String,
      default: '4px 4px 20px 4px'
    }
  },

  data() {
    return {
      isHover: false,
      isActive: false
    };
  },

  computed: {
    buttonStyle() {
      let style = {
        padding: this.padding,
        fontWeight: this.bold ? '600' : '300',
        width: this.width,
        height: this.height,
        backgroundColor: this.background,
        borderRadius: `${this.borderRadius} !important`,
        border: this.border,
        fontSize: '16px',
        textAlign: this.textAlign,
        color: this.color,
        verticalAlign: 'top',
        cursor: 'pointer',
        outline: 'none',
        userSelect: 'none'
      };

      if (this.disable) {
        style.backgroundColor = this.disableBackground;
        style.cursor = null;
        style.color = this.disableColor;
      } else if (this.isActive) style.backgroundColor = this.activeBackground;else if (this.isHover) {
        style.backgroundColor = this.hoverBackground;
        if (this.hoverColor) style.color = this.hoverColor;
      }

      return style;
    }

  },
  methods: {
    handlerOnClick(e) {
      if (this.disable) return;
      this.$emit('click', e);
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__$1Y = script$1Y;
/* template */

var __vue_render__$1Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('button', {
    staticClass: "Button",
    style: _vm.buttonStyle,
    on: {
      "click": _vm.handlerOnClick,
      "mouseover": function ($event) {
        _vm.isHover = true;
      },
      "mouseleave": function ($event) {
        _vm.isActive = _vm.isHover = false;
      },
      "mousedown": function ($event) {
        _vm.isActive = true;
      },
      "mouseup": function ($event) {
        _vm.isActive = false;
      }
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$1Y = [];
/* style */

const __vue_inject_styles__$1Y = undefined;
/* scoped */

const __vue_scope_id__$1Y = undefined;
/* module identifier */

const __vue_module_identifier__$1Y = undefined;
/* functional template */

const __vue_is_functional_template__$1Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1Y,
  staticRenderFns: __vue_staticRenderFns__$1Y
}, __vue_inject_styles__$1Y, __vue_script__$1Y, __vue_scope_id__$1Y, __vue_is_functional_template__$1Y, __vue_module_identifier__$1Y, false, undefined, undefined, undefined);

//
var script$1X = {
  name: "ButtonRed",
  components: {
    Button: __vue_component__$1Y
  },
  props: {
    padding: String,
    bold: Boolean,
    disable: Boolean,
    textAlign: String,
    height: String,
    width: String,
    borderRadius: String,
    color: {
      type: String,
      default: '#FFFFFF'
    },
    background: {
      type: String,
      default: '#EE2B45'
    },
    hoverColor: {
      type: String
    },
    hoverBackground: {
      type: String,
      default: '#EE6865'
    },
    border: {
      type: String
    },
    activeBackground: {
      type: String,
      default: '#c8263b'
    }
  },
  methods: {
    handlerOnClick(e) {
      this.$emit('click', e);
    }

  }
};

/* script */
const __vue_script__$1X = script$1X;
/* template */

var __vue_render__$1X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('Button', {
    staticClass: "ButtonRed",
    attrs: {
      "padding": _vm.padding,
      "bold": _vm.bold,
      "disable": _vm.disable,
      "height": _vm.height,
      "width": _vm.width,
      "textAlign": _vm.textAlign,
      "color": _vm.color,
      "background": _vm.background,
      "hoverColor": _vm.hoverColor,
      "hoverBackground": _vm.hoverBackground,
      "activeBackground": _vm.activeBackground,
      "disableBackground": '#f695a2',
      "disableColor": '#FFFFFF',
      "borderRadius": _vm.borderRadius,
      "border": _vm.border
    },
    on: {
      "click": _vm.handlerOnClick
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$1X = [];
/* style */

const __vue_inject_styles__$1X = undefined;
/* scoped */

const __vue_scope_id__$1X = undefined;
/* module identifier */

const __vue_module_identifier__$1X = undefined;
/* functional template */

const __vue_is_functional_template__$1X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1X,
  staticRenderFns: __vue_staticRenderFns__$1X
}, __vue_inject_styles__$1X, __vue_script__$1X, __vue_scope_id__$1X, __vue_is_functional_template__$1X, __vue_module_identifier__$1X, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
var script$1W = {
  name: "IconModalCloseSmall",
  props: {
    color: {
      default: 'black'
    }
  }
};

/* script */
const __vue_script__$1W = script$1W;
/* template */

var __vue_render__$1W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "width": "15",
      "height": "15",
      "viewBox": "0 0 15 15",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1 13.9997L14 1.00006",
      "stroke": _vm.color,
      "stroke-opacity": "0.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1 1.0004L14 14.0001",
      "stroke": _vm.color,
      "stroke-opacity": "0.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};

var __vue_staticRenderFns__$1W = [];
/* style */

const __vue_inject_styles__$1W = undefined;
/* scoped */

const __vue_scope_id__$1W = "data-v-7ab6dc0e";
/* module identifier */

const __vue_module_identifier__$1W = undefined;
/* functional template */

const __vue_is_functional_template__$1W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1W,
  staticRenderFns: __vue_staticRenderFns__$1W
}, __vue_inject_styles__$1W, __vue_script__$1W, __vue_scope_id__$1W, __vue_is_functional_template__$1W, __vue_module_identifier__$1W, false, undefined, undefined, undefined);

//
var script$1V = {
  name: "Modal",
  components: {
    ButtonRed: __vue_component__$1X,
    IconModalCloseSmall: __vue_component__$1W
  },
  props: {
    iconClose: {
      type: Boolean,
      default: true
    },
    onModalOK: {
      default: null
    },
    ownerWidth: {
      default: '100'
    },
    ownerHeight: {
      default: '100'
    },
    ownerDimensionsSizeUnit: {
      default: '%'
    },
    scaleX: {
      type: Number,
      default: 1
    },
    scaleY: {
      type: Number,
      default: 1
    },
    offsetX: {
      type: Number,
      default: 0
    },
    offsetY: {
      type: Number,
      default: 0
    },
    useBuiltInButtons: {
      type: Boolean,
      default: true
    },
    showCancelButton: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: false
    },
    buttonsBoxCustomClass: null,
    footerCustomClass: null,
    enableExternalClick: {
      type: Boolean,
      default: true
    },
    autoBodyHeight: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modalSizing: function () {
      return {
        height: this.ownerHeight === '100' ? 'auto' : this.ownerHeight * this.scaleY + this.ownerDimensionsSizeUnit,
        width: this.ownerWidth * this.scaleX + this.ownerDimensionsSizeUnit
      };
    },
    modalOffset: function () {
      if (this.offsetX > 0 && this.offsetY > 0) {
        return {
          marginLeft: this.offsetX + 'px',
          marginTop: this.offsetY + 'px'
        };
      }

      if (this.offsetX > 0) {
        return {
          marginLeft: this.offsetX + 'px'
        };
      }

      if (this.offsetY > 0) {
        return {
          marginTop: this.offsetY + 'px'
        };
      }

      return {};
    },

    buttonsBoxClass() {
      return this.buttonsBoxCustomClass || this.$style.modalFooterButtonBox;
    },

    bodyHeight: function () {
      return {
        height: this.autoBodyHeight ? 'auto' : 'calc(100vh - 120px)'
      };
    },

    footerClass() {
      return this.footerCustomClass || this.$style.modalFooterBox;
    }

  },
  methods: {
    close() {
      this.$emit('close');
    },

    exteranalClick() {
      if (this.enableExternalClick) {
        this.$emit('close');
      }
    }

  }
};

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$1V = script$1V;
/* template */

var __vue_render__$1V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask",
    on: {
      "click": _vm.exteranalClick
    }
  }, [_c('div', {
    staticClass: "modal-container",
    style: [_vm.modalSizing, _vm.modalOffset],
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm.iconClose ? _c('button', {
    staticClass: "btn-close-icon",
    on: {
      "click": _vm.close
    }
  }, [_c('IconModalCloseSmall')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-container-box"
  }, [_vm._t("default", [_c('div', {
    staticClass: "modal-header-box"
  }, [_c('div', {
    staticClass: "modal-header-slot"
  }, [_vm._t("header")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body-box",
    style: _vm.bodyHeight
  }, [_c('div', {
    staticClass: "modal-body-slot"
  }, [_vm._t("body")], 2)]), _vm._v(" "), _vm.useBuiltInButtons ? _c('div', {
    class: _vm.buttonsBoxClass
  }, [_c('div', {}, [_c('ButtonRed', {
    staticClass: "modal-button--ok",
    on: {
      "click": _vm.onModalOK
    }
  }, [_vm._t("okButtonText")], 2), _vm._v(" "), _c('div', [_vm._t("okAddition")], 2)], 1), _vm._v(" "), _vm.showCancelButton ? _c('button', {
    staticClass: "modal-button--cancel",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n              Отмена\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.showFooter ? _c('div', {
    class: _vm.footerClass
  }, [_vm._t("footer")], 2) : _vm._e()])], 2)])])]);
};

var __vue_staticRenderFns__$1V = [];
/* style */

const __vue_inject_styles__$1V = function (inject) {
  if (!inject) return;
  inject("data-v-157260f9_0", {
    source: ".src-components-Modal-modalFooterButtonBox-2x6w{display:flex;justify-content:space-between;align-items:center;padding:16px 20px 8px 15px}.src-components-Modal-modalFooterBox-26vk{display:flex;justify-content:space-between;align-items:center;padding:8px 20px 16px 15px}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "modalFooterButtonBox": "src-components-Modal-modalFooterButtonBox-2x6w",
      "modalFooterBox": "src-components-Modal-modalFooterBox-26vk"
    }
  }), inject("data-v-157260f9_1", {
    source: "@media (min-width:760px){.modal-body-box[data-v-157260f9]{font-size:16px!important}}@media (max-width:760px){.modal-header-box[data-v-157260f9]{font-size:18px!important}.modal-body-box[data-v-157260f9]{font-size:14px!important}.modal-button--ok[data-v-157260f9]{font-size:12px!important}.modal-button--cancel[data-v-157260f9]{font-size:12px!important}}.modal-mask[data-v-157260f9]{position:fixed;z-index:9998;top:0;left:0;width:100vw;height:100vh;background-color:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;transition:opacity .3s ease}.modal-container[data-v-157260f9]{position:relative;background-color:#fff;border-radius:8px 8px 40px 8px!important;box-shadow:0 2px 8px rgba(0,0,0,.33);transition:all .3s ease;font-family:'IBM Plex Sans',Avenir,Helvetica,Arial,sans-serif;font-display:swap}.modal-container-box[data-v-157260f9]{display:flex;justify-content:space-between;align-items:stretch;flex-flow:column}.modal-header-slot[data-v-157260f9]{margin-right:40px}.modal-header-box[data-v-157260f9]{border-radius:8px 8px 0 0!important;color:#131524;font-family:'IBM Plex Sans',Avenir,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;font-size:24px;line-height:40px;padding:8px 0 0 32px}.modal-body-box[data-v-157260f9]{overflow-y:auto;background:#fff;margin:8px 15px;flex-grow:1}.modal-body-slot p[data-v-157260f9]{padding:0 0;margin:0 0}.modal-body-slot .col-md-12 .col-xs-12[data-v-157260f9]{padding:0}.modal-enter .modal-container[data-v-157260f9],.modal-leave-active .modal-container[data-v-157260f9]{-webkit-transform:scale(1.1);transform:scale(1.1)}.modal-enter[data-v-157260f9]{opacity:0}.modal-leave-active[data-v-157260f9]{opacity:0}.modal-button--ok[data-v-157260f9]{background-color:#ee2b45;color:#fff;border:0 solid #000;border-radius:4px 4px 20px 4px!important;cursor:pointer;min-width:168px;height:32px;font-size:16px;font-weight:400!important;user-select:none;outline:0}.modal-button--ok-addition[data-v-157260f9]{display:flex;justify-content:flex-start;align-items:center}.modal-button--cancel[data-v-157260f9]{background-color:rgba(0,0,0,0);border:0 solid #000;border-radius:4px 4px 20px 4px!important;cursor:pointer;width:168px;height:32px;font-size:16px;font-weight:400!important;user-select:none;outline:0}.modal-button--cancel[data-v-157260f9]:active{background-color:rgba(0,0,0,.2)}.modal-button--cancel[data-v-157260f9]:hover{background-color:rgba(0,0,0,.1)}.btn-close-icon[data-v-157260f9]{position:absolute;top:15px;right:15px;cursor:pointer;border-radius:4px 4px 4px 4px!important;background:0 0;outline:0;border:0;padding:5px}.btn-close-icon[data-v-157260f9]:hover{background-color:rgba(0,0,0,.1)}.btn-close-icon[data-v-157260f9]:active{background-color:rgba(0,0,0,.2)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1V = "data-v-157260f9";
/* module identifier */

const __vue_module_identifier__$1V = undefined;
/* functional template */

const __vue_is_functional_template__$1V = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1V,
  staticRenderFns: __vue_staticRenderFns__$1V
}, __vue_inject_styles__$1V, __vue_script__$1V, __vue_scope_id__$1V, __vue_is_functional_template__$1V, __vue_module_identifier__$1V, false, createInjector, undefined, undefined);

var script$1U = {
  name: "IconAdd"
};

/* script */
const __vue_script__$1U = script$1U;
/* template */

var __vue_render__$1U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V20C23.5 21.933 21.933 23.5 20 23.5H4C2.067 23.5 0.5 21.933 0.5 20V4Z",
      "fill": "white",
      "stroke": "#6E7C8D",
      "stroke-linejoin": "bevel"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4.00098 11.7344L21.4765 11.7427",
      "stroke": "#6E7C8D",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12.7422 3.00024L12.7343 20.4757",
      "stroke": "#6E7C8D",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};

var __vue_staticRenderFns__$1U = [];
/* style */

const __vue_inject_styles__$1U = undefined;
/* scoped */

const __vue_scope_id__$1U = undefined;
/* module identifier */

const __vue_module_identifier__$1U = undefined;
/* functional template */

const __vue_is_functional_template__$1U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1U,
  staticRenderFns: __vue_staticRenderFns__$1U
}, __vue_inject_styles__$1U, __vue_script__$1U, __vue_scope_id__$1U, __vue_is_functional_template__$1U, __vue_module_identifier__$1U, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$1T = {
  name: "IconPen",

  data() {
    return {
      id: `id${new Date().getTime()}`
    };
  }

};

/* script */
const __vue_script__$1T = script$1T;
/* template */

var __vue_render__$1T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('rect', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "url(#" + _vm.id + "pattern)"
    }
  }), _vm._v(" "), _c('defs', [_c('pattern', {
    attrs: {
      "id": _vm.id + "pattern",
      "patternContentUnits": "objectBoundingBox",
      "width": "1",
      "height": "1"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#" + _vm.id + "image",
      "transform": "scale(0.0078125)"
    }
  })]), _vm._v(" "), _c('image', {
    attrs: {
      "id": _vm.id + "image",
      "width": "128",
      "height": "128",
      "xlink:href": "data:image/png;base64,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"
    }
  })])]);
};

var __vue_staticRenderFns__$1T = [];
/* style */

const __vue_inject_styles__$1T = undefined;
/* scoped */

const __vue_scope_id__$1T = "data-v-3886a250";
/* module identifier */

const __vue_module_identifier__$1T = undefined;
/* functional template */

const __vue_is_functional_template__$1T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1T,
  staticRenderFns: __vue_staticRenderFns__$1T
}, __vue_inject_styles__$1T, __vue_script__$1T, __vue_scope_id__$1T, __vue_is_functional_template__$1T, __vue_module_identifier__$1T, false, undefined, undefined, undefined);

var script$1S = {
  name: "IconXls"
};

/* script */
const __vue_script__$1S = script$1S;
/* template */

var __vue_render__$1S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.$style.box
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 482.14 482.14"
    },
    attrs: {
      "version": "1.1",
      "id": "Capa_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 482.14 482.14",
      "xml:space": "preserve",
      "width": "22",
      "height": "18"
    }
  }, [_c('path', {
    attrs: {
      "d": "M315.459,0H121.812C93.522,0,70.496,23.041,70.496,51.315v189.754h-5.013c-11.418,0-20.677,9.251-20.677,20.679v125.404\n\tc0,11.427,9.259,20.677,20.677,20.677h5.013v22.995c0,28.305,23.025,51.315,51.316,51.315h264.221c28.275,0,51.3-23.011,51.3-51.315\n\tV121.449L315.459,0z M97.446,283.228h22.576l7.612,15.87c2.584,5.281,4.524,9.551,6.588,14.452h0.252\n\tc2.064-5.547,3.744-9.425,5.942-14.452l7.353-15.87h22.45l-24.516,42.442l25.807,44.523h-22.71l-7.872-15.745\n\tc-3.223-6.068-5.287-10.575-7.747-15.618h-0.252c-1.813,5.043-4.002,9.55-6.714,15.618l-7.227,15.745h-22.45l25.162-44.004\n\tL97.446,283.228z M386.033,450.713H121.812c-10.955,0-19.874-8.92-19.874-19.889v-22.995h246.31c11.418,0,20.678-9.25,20.678-20.677\n\tV261.748c0-11.428-9.26-20.679-20.678-20.679h-246.31V51.315c0-10.938,8.92-19.858,19.874-19.858l181.89-0.19v67.233\n\tc0,19.638,15.934,35.587,35.585,35.587l65.863-0.189l0.741,296.925C405.892,441.793,396.987,450.713,386.033,450.713z\n\t M236.461,353.677v16.518h-54.327v-86.966h19.741v70.448H236.461z M269.785,333.678c-14.452-5.027-23.877-13.033-23.877-25.674\n\tc0-14.848,12.388-26.194,32.908-26.194c9.81,0,17.028,2.064,22.198,4.382l-4.39,15.871c-3.482-1.671-9.677-4.131-18.196-4.131\n\tc-8.518,0-12.646,3.879-12.646,8.387c0,5.547,4.901,8.006,16.13,12.26c15.358,5.675,22.585,13.681,22.585,25.943\n\tc0,14.577-11.229,26.966-35.098,26.966c-9.938,0-19.749-2.585-24.65-5.297l4.004-16.249c5.287,2.712,13.419,5.407,21.803,5.407\n\tc9.031,0,13.807-3.736,13.807-9.411C284.363,340.517,280.235,337.412,269.785,333.678z"
    }
  }), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g')])]);
};

var __vue_staticRenderFns__$1S = [];
/* style */

const __vue_inject_styles__$1S = function (inject) {
  if (!inject) return;
  inject("data-v-00300d92_0", {
    source: ".src-components-box-1c9y{width:24px;height:24px;border:1px solid #6e7c8d;border-radius:4px;display:flex;align-items:center;justify-content:center}.src-components-image-8SEC{width:19px;height:17px}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-box-1c9y",
      "image": "src-components-image-8SEC"
    }
  });
};
/* scoped */


const __vue_scope_id__$1S = undefined;
/* module identifier */

const __vue_module_identifier__$1S = undefined;
/* functional template */

const __vue_is_functional_template__$1S = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1S,
  staticRenderFns: __vue_staticRenderFns__$1S
}, __vue_inject_styles__$1S, __vue_script__$1S, __vue_scope_id__$1S, __vue_is_functional_template__$1S, __vue_module_identifier__$1S, false, createInjector, undefined, undefined);

var script$1R = {
  name: "IconClose"
};

/* script */
const __vue_script__$1R = script$1R;
/* template */

var __vue_render__$1R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "width": "8",
      "height": "8",
      "viewBox": "0 0 8 8",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1 6.99951L6.96583 0.999851",
      "stroke": "#6E7C8D",
      "stroke-opacity": "0.75",
      "stroke-width": "0.75",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1 1.00049L6.96583 7.00015",
      "stroke": "#6E7C8D",
      "stroke-opacity": "0.75",
      "stroke-width": "0.75",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};

var __vue_staticRenderFns__$1R = [];
/* style */

const __vue_inject_styles__$1R = undefined;
/* scoped */

const __vue_scope_id__$1R = undefined;
/* module identifier */

const __vue_module_identifier__$1R = undefined;
/* functional template */

const __vue_is_functional_template__$1R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1R,
  staticRenderFns: __vue_staticRenderFns__$1R
}, __vue_inject_styles__$1R, __vue_script__$1R, __vue_scope_id__$1R, __vue_is_functional_template__$1R, __vue_module_identifier__$1R, false, undefined, undefined, undefined);

var script$1Q = {
  name: "IconClose",
  props: {
    color: {
      type: String,
      default: '#202020'
    }
  }
};

/* script */
const __vue_script__$1Q = script$1Q;
/* template */

var __vue_render__$1Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "width": "11",
      "height": "11",
      "viewBox": "0 0 11 11",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1 10.4404L10.4406 1.0001",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1 1.00024L10.4406 10.4406",
      "stroke": _vm.color,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};

var __vue_staticRenderFns__$1Q = [];
/* style */

const __vue_inject_styles__$1Q = undefined;
/* scoped */

const __vue_scope_id__$1Q = undefined;
/* module identifier */

const __vue_module_identifier__$1Q = undefined;
/* functional template */

const __vue_is_functional_template__$1Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1Q,
  staticRenderFns: __vue_staticRenderFns__$1Q
}, __vue_inject_styles__$1Q, __vue_script__$1Q, __vue_scope_id__$1Q, __vue_is_functional_template__$1Q, __vue_module_identifier__$1Q, false, undefined, undefined, undefined);

//
var script$1P = {
  name: "ButtonWhite",
  components: {
    Button: __vue_component__$1Y
  },
  props: {
    padding: String,
    bold: Boolean,
    disable: Boolean,
    textAlign: String,
    height: String,
    width: String
  },
  methods: {
    handlerOnClick(e) {
      this.$emit('click', e);
    }

  }
};

/* script */
const __vue_script__$1P = script$1P;
/* template */

var __vue_render__$1P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('Button', {
    staticClass: "ButtonWhite",
    attrs: {
      "padding": _vm.padding,
      "bold": _vm.bold,
      "disable": _vm.disable,
      "height": _vm.height,
      "width": _vm.width,
      "textAlign": _vm.textAlign,
      "color": '#000',
      "background": '#FFF',
      "hoverBackground": '#CCC',
      "activeBackground": '#444'
    },
    on: {
      "click": _vm.handlerOnClick
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$1P = [];
/* style */

const __vue_inject_styles__$1P = undefined;
/* scoped */

const __vue_scope_id__$1P = undefined;
/* module identifier */

const __vue_module_identifier__$1P = undefined;
/* functional template */

const __vue_is_functional_template__$1P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1P,
  staticRenderFns: __vue_staticRenderFns__$1P
}, __vue_inject_styles__$1P, __vue_script__$1P, __vue_scope_id__$1P, __vue_is_functional_template__$1P, __vue_module_identifier__$1P, false, undefined, undefined, undefined);

function isEmpty(value) {
  return !hasValue$1(value);
}
function hasValue$1(value) {
  if (value === null) return false;
  if (value === undefined) return false;
  if (value === '') return false;
  if (value === 0) return true;
  if (typeof value === 'object' && Array.isArray(value) && value.length <= 0) return false;
  if (value) return true;
  return false;
}
function notEmptyString(str) {
  return (typeof str === 'string' || str instanceof String) && str.length > 0;
}
function concat(seporate, items) {
  if (!items) return '';
  let value = '';
  let any = false;

  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    if (!hasValue$1(item)) continue;

    if (!any) {
      value += item;
      any = true;
    } else {
      value += seporate + item;
    }

    any = true;
  }

  return value;
}
function concatTitle(title, value, ending) {
  if (hasValue$1(value)) {
    if (ending) {
      return concatEnding(title + value, ending);
    } else {
      return title + value;
    }
  }

  return '';
}
function concatEnding(value, ending, where) {
  if (hasValue$1(value)) {
    if (where) {
      if (where(value)) {
        return value + ending;
      } else {
        return value;
      }
    } else {
      return value + ending;
    }
  }

  return '';
}
function concatWithSeparator(stringArray, separator) {
  let result = '';

  if (Array.isArray(stringArray) && stringArray.length > 0) {
    stringArray.forEach(function (item) {
      if (item) {
        result += (result.length > 0 ? separator : '') + item;
      }
    });
  }

  return result;
}
function uniqueName(name, names) {
  if (!hasValue$1(name)) return null;
  if (!hasValue$1(names)) return name;
  let objectKeys = {};
  names.forEach(a => {
    objectKeys[a] = true;
  });
  let index = 0;
  let nextName = name;

  while (objectKeys[nextName]) {
    index++;
    nextName = name + " " + index;
  }

  return nextName;
}
function toString(v) {
  if (!hasValue$1(v)) return null;
  if (typeof v === 'object') return JSON.stringify(v);
  return v.toString();
}
function capitalizeFirstLetter(string) {
  return string && string.charAt(0).toUpperCase() + string.slice(1) || null;
}

var str = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isEmpty: isEmpty,
  hasValue: hasValue$1,
  notEmptyString: notEmptyString,
  concat: concat,
  concatTitle: concatTitle,
  concatEnding: concatEnding,
  concatWithSeparator: concatWithSeparator,
  uniqueName: uniqueName,
  toString: toString,
  capitalizeFirstLetter: capitalizeFirstLetter
});

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$1O = {
  name: "IconInfo",
  inject: {
    team: {
      default: () => ({
        nm: "default",
        stl: {}
      })
    }
  }
};

/* script */
const __vue_script__$1O = script$1O;
/* template */

var __vue_render__$1O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.team === 'dark' || _vm.team.nm === 'dark' ? _c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 18 18",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "9",
      "cy": "9",
      "r": "8.5",
      "stroke": "white"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9.208 5.432C8.78133 5.432 8.472 5.336 8.28 5.144C8.09867 4.952 8.008 4.70667 8.008 4.408V4.088C8.008 3.78933 8.09867 3.544 8.28 3.352C8.472 3.16 8.78133 3.064 9.208 3.064C9.624 3.064 9.928 3.16 10.12 3.352C10.312 3.544 10.408 3.78933 10.408 4.088V4.408C10.408 4.70667 10.312 4.952 10.12 5.144C9.928 5.336 9.624 5.432 9.208 5.432ZM8.184 6.648H10.232V15H8.184V6.648Z",
      "fill": "white"
    }
  })]) : _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "18",
      "height": "18",
      "fill": "none"
    }
  }, [_c('ellipse', {
    attrs: {
      "cx": "9.051",
      "cy": "8.983",
      "rx": "8.847",
      "ry": "8.797",
      "fill": "#292f36",
      "fill-opacity": ".4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9.31 5.415c-.427 0-.736-.096-.928-.288-.182-.192-.272-.437-.272-.736v-.32c0-.299.09-.544.272-.736.192-.192.501-.288.928-.288.416 0 .72.096.912.288a.997.997 0 0 1 .288.736v.32a.997.997 0 0 1-.288.736c-.192.192-.496.288-.912.288zM8.286 6.631h2.048v8.352H8.286z",
      "fill": "#fff"
    }
  })]);
};

var __vue_staticRenderFns__$1O = [];
/* style */

const __vue_inject_styles__$1O = undefined;
/* scoped */

const __vue_scope_id__$1O = "data-v-34f77024";
/* module identifier */

const __vue_module_identifier__$1O = undefined;
/* functional template */

const __vue_is_functional_template__$1O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1O,
  staticRenderFns: __vue_staticRenderFns__$1O
}, __vue_inject_styles__$1O, __vue_script__$1O, __vue_scope_id__$1O, __vue_is_functional_template__$1O, __vue_module_identifier__$1O, false, undefined, undefined, undefined);

var script$1N = {
  name: "Tooltip",
  props: {
    text: {
      type: String
    }
  },

  data() {
    return {
      position: null
    };
  },

  methods: {
    calc() {
      let root = this.$refs.root;
      if (!root) return null;
      let rect = root.getBoundingClientRect();
      let display = document.documentElement.getBoundingClientRect();
      const width = 240;
      const height = 200;
      let y = rect.top || rect.y;
      let x = rect.left || rect.x;
      let top = true;
      let left = null;

      if (y < height) {
        top = false;
      }

      if (x < width / 2) {
        left = true;
      }

      if (x + width / 2 > display.width) {
        left = false;
      }

      this.position = `tooltip-${top ? "top" : "bottom"}${left == null ? "" : left ? "-left" : "-right"}`;
    }

  }
};

/* script */
const __vue_script__$1N = script$1N;
/* template */

var __vue_render__$1N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', _vm._b({
    ref: "root",
    class: ['tooltip-multiline', _vm.position],
    on: {
      "mouseenter": _vm.calc
    }
  }, 'div', _vm.text && {
    'data-tooltip': _vm.text
  } || {}, false), [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$1N = [];
/* style */

const __vue_inject_styles__$1N = function (inject) {
  if (!inject) return;
  inject("data-v-5383ca6f_0", {
    source: "[data-tooltip][data-v-5383ca6f]{position:relative;display:inline-block}[data-tooltip][data-v-5383ca6f]:after,[data-tooltip][data-v-5383ca6f]:before{position:absolute;left:50%;transform:translate(-50%,-8px);z-index:1000;pointer-events:none;user-select:none;opacity:0;transition:opacity .35s ease .25s}[data-tooltip][data-v-5383ca6f]:before{content:attr(data-tooltip);font-family:\"IBM Plex Sans\",Avenir,Helvetica,Arial,sans-serif;border:1px solid #6e7c8d;background:#fff;color:#202020;padding:6px 12px;font-size:13px;font-weight:400;line-height:18px;white-space:nowrap;bottom:100%;border-radius:6px;box-shadow:0 5px 15px -5px rgba(0,0,0,.65)}[data-tooltip][data-v-5383ca6f]:active:after,[data-tooltip][data-v-5383ca6f]:active:before,[data-tooltip][data-v-5383ca6f]:focus:after,[data-tooltip][data-v-5383ca6f]:focus:before,[data-tooltip][data-v-5383ca6f]:hover:after,[data-tooltip][data-v-5383ca6f]:hover:before{opacity:1}[data-tooltip].tooltip-multiline[data-v-5383ca6f]:before{width:100vw;max-width:240px;white-space:normal}[data-tooltip][class*=tooltip-bottom][data-v-5383ca6f]:after,[data-tooltip][class*=tooltip-bottom][data-v-5383ca6f]:before{transform:translate(-50%,8px)}[data-tooltip][class*=tooltip-bottom][data-v-5383ca6f]:before{bottom:auto;top:100%}[data-tooltip][class*=tooltip-bottom][data-v-5383ca6f]:after{bottom:0;border:8px solid transparent;border-bottom-color:#fff}[data-tooltip].tooltip-bottom-left[data-v-5383ca6f]:before{transform:translate(-24px,8px)}[data-tooltip].tooltip-bottom-right[data-v-5383ca6f]:before{left:auto;right:50%;transform:translate(24px,8px)}[data-tooltip].tooltip-top-left[data-v-5383ca6f]:before{transform:translate(-24px,-8px)}[data-tooltip].tooltip-top-right[data-v-5383ca6f]:before{left:auto;right:50%;transform:translate(24px,-8px)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1N = "data-v-5383ca6f";
/* module identifier */

const __vue_module_identifier__$1N = undefined;
/* functional template */

const __vue_is_functional_template__$1N = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1N,
  staticRenderFns: __vue_staticRenderFns__$1N
}, __vue_inject_styles__$1N, __vue_script__$1N, __vue_scope_id__$1N, __vue_is_functional_template__$1N, __vue_module_identifier__$1N, false, createInjector, undefined, undefined);

var script$1M = {
  name: 'LabelInfo',
  inject: {
    team: {
      default: () => "default"
    }
  },
  components: {
    IconInfo: __vue_component__$1O,
    Tooltip: __vue_component__$1N
  },
  props: {
    description: String,
    className: String
  },
  computed: {
    labelClass() {
      const result = [this.$style.name];

      if (this.className) {
        result.push(this.className);
      }

      if (this.team === 'dark') {
        result.push(this.$style.dark);
      }

      if (this.team && this.team.stl && this.team.stl.textColor) {
        result.push(this.team.stl.textColor);
      }

      return result;
    }

  },
  methods: {
    notEmptyString
  }
};

/* script */
const __vue_script__$1M = script$1M;
/* template */

var __vue_render__$1M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "LabelInfo",
    class: [_vm.$style.header]
  }, [_c('div', {
    class: _vm.labelClass,
    on: {
      "click": function (e) {
        return _vm.$emit('clickName', e);
      }
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _vm.notEmptyString(_vm.description) ? _c('Tooltip', {
    class: _vm.$style.tooltip,
    attrs: {
      "text": _vm.description
    }
  }, [_c('IconInfo', {
    staticStyle: {
      "display": "block"
    }
  })], 1) : _vm._e()], 1);
};

var __vue_staticRenderFns__$1M = [];
/* style */

const __vue_inject_styles__$1M = function (inject) {
  if (!inject) return;
  inject("data-v-7f7baefe_0", {
    source: ".src-components-header-12yd{display:flex;align-items:center}.src-components-header-12yd>*+*{margin-left:10px}.src-components-name-H9GP{font-size:16px;color:#202020}.src-components-tooltip-MRbq{height:18px}.src-components-dark-klpp{color:#fff}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "header": "src-components-header-12yd",
      "name": "src-components-name-H9GP",
      "tooltip": "src-components-tooltip-MRbq",
      "dark": "src-components-dark-klpp"
    }
  });
};
/* scoped */


const __vue_scope_id__$1M = undefined;
/* module identifier */

const __vue_module_identifier__$1M = undefined;
/* functional template */

const __vue_is_functional_template__$1M = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1M,
  staticRenderFns: __vue_staticRenderFns__$1M
}, __vue_inject_styles__$1M, __vue_script__$1M, __vue_scope_id__$1M, __vue_is_functional_template__$1M, __vue_module_identifier__$1M, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$1L = {
  name: "TextInput",
  props: {
    tabindex: Number,
    placeholder: String,
    value: [String, Number],
    defaultValue: String,
    filter: Function,
    format: Function,
    inputRef: Function,
    maxlength: Number
  },

  data() {
    return {
      prevText: null,
      nextText: null,
      change: false
    };
  },

  watch: {
    value: {
      immediate: true,

      handler(v) {
        let {
          format,
          nextText
        } = this;
        if (nextText !== v) this.prevText = this.nextText = format && format(v) || v;
      }

    },
    defaultValue: {
      immediate: true,

      handler(v) {
        let {
          value,
          change,
          nextText,
          filter,
          format
        } = this;

        if (value === undefined && !change) {
          if (filter) v = filter(v);
          if (nextText !== v) this.prevText = this.nextText = format && format(v) || v;
        }
      }

    }
  },

  mounted() {
    //this.$refs.input.focus();
    this.inputRef && this.inputRef(this.$refs.input);
  },

  methods: {
    focus() {
      this.$refs.input.focus();
    },

    handlerOnClick(e) {
      this.$emit("click", e);
    },

    handlerOnBlur(e) {
      this.$emit("blur", e);
    },

    handlerOnKeyup(e) {
      this.$emit("keyup", e);
    },

    handlerOnInput(e) {
      let {
        filter,
        prevText,
        nextText,
        value
      } = this;
      this.change = true;

      if (filter) {
        let txt = filter(nextText, prevText);
        if (txt !== nextText) this.nextText = nextText = txt;
      }

      this.$emit("input", nextText, e);

      if (value !== undefined) {
        this.$nextTick(() => {
          let {
            prevText,
            nextText,
            value
          } = this;
          if (value === prevText && prevText !== nextText) this.nextText = prevText;else this.prevText = nextText;
        });
      }
    },

    handlerOnChange(e) {
      let {
        format,
        nextText
      } = this;
      if (format) this.prevText = this.nextText = format(nextText);
      this.$emit("change", nextText, e);
    }

  }
};

/* script */
const __vue_script__$1L = script$1L;
/* template */

var __vue_render__$1L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.nextText,
      expression: "nextText"
    }],
    ref: "input",
    staticClass: "TextInput",
    attrs: {
      "tabindex": _vm.tabindex,
      "type": "text",
      "size": "1",
      "maxlength": _vm.maxlength,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.nextText
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.nextText = $event.target.value;
      }, _vm.handlerOnInput],
      "change": _vm.handlerOnChange,
      "keyup": _vm.handlerOnKeyup,
      "blur": _vm.handlerOnBlur,
      "click": _vm.handlerOnClick,
      "keydown": function (e) {
        return _vm.$emit('keydown', e);
      }
    }
  });
};

var __vue_staticRenderFns__$1L = [];
/* style */

const __vue_inject_styles__$1L = function (inject) {
  if (!inject) return;
  inject("data-v-65d4258e_0", {
    source: ".TextInput[data-v-65d4258e]{height:32px;padding-left:5px;box-sizing:border-box}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1L = "data-v-65d4258e";
/* module identifier */

const __vue_module_identifier__$1L = undefined;
/* functional template */

const __vue_is_functional_template__$1L = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1L,
  staticRenderFns: __vue_staticRenderFns__$1L
}, __vue_inject_styles__$1L, __vue_script__$1L, __vue_scope_id__$1L, __vue_is_functional_template__$1L, __vue_module_identifier__$1L, false, createInjector, undefined, undefined);

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$8 = ".style-polza-module_box__pk1EM {\n  position: relative;\n  border-radius: 0px !important;\n  border: 0.75px solid #34495E;\n  padding: 4px 7px;\n}\n\n.style-polza-module_items__2BveC {\n  position: absolute;\n  top: 100%;\n  width: 100%;\n  z-index: 100;\n  margin-top: 4px;\n  box-sizing: border-box;\n  border-radius: 0px !important;\n  border: 0.75px solid #34495E;\n  background-color: white;\n}\n\n.style-polza-module_inputBox__2SThC {\n  position: relative;\n}\n.style-polza-module_inputBox__2SThC .style-polza-module_icon__3Xfcg {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 8px;\n  min-width: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.style-polza-module_input__BVDMA {\n  width: 100%;\n  box-sizing: border-box;\n  border-radius: 0px !important;\n  border: 1px solid #34495E;\n  height: 32px;\n  padding: 0 0 0 6px;\n  font-size: 16px;\n  font-family: \"Oswald\", sans-serif;\n}\n.style-polza-module_input__BVDMA:focus {\n  border: 1.5px solid #34495E;\n  outline: none;\n}\n\n.style-polza-module_name__39StH {\n  user-select: none;\n  cursor: pointer;\n  text-transform: uppercase;\n}\n\n.style-polza-module_filterTag__1G3-F {\n  padding: 3px 12px 3px 7px;\n  border: 1px solid #202020;\n  background-color: #FFFFFF;\n  color: #202020;\n  text-decoration: none;\n  text-align: left;\n  display: inline-block;\n  vertical-align: center;\n}\n.style-polza-module_filterTag__1G3-F:hover {\n  background-color: #F0F2F4;\n}\n\n.style-polza-module_item-box__2k4jN {\n  user-select: none;\n  padding: 1px 3px 1px 4px;\n  border-radius: 0 !important;\n  border: 1px solid rgba(41, 47, 54, 0.4);\n  background: #f0f2f3;\n  color: #34495E;\n  text-decoration: none;\n  text-align: left;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 16px;\n  line-height: 16px;\n  min-height: 20px;\n  box-sizing: border-box;\n  text-transform: uppercase;\n}\n.style-polza-module_item-box__2k4jN .style-polza-module_close__1GiCS {\n  margin: 2px 4px 0 5px;\n  cursor: pointer;\n  border-radius: 100% !important;\n  min-width: 10px;\n}\n.style-polza-module_item-box__2k4jN .style-polza-module_close__1GiCS:hover {\n  background-color: rgba(110, 124, 141, 0.1);\n}\n\n.style-polza-module_box2__1x2SV {\n  user-select: none;\n  padding: 1px 3px 1px 4px;\n  border-radius: 0 !important;\n  border: 1px solid rgba(41, 47, 54, 0.4);\n  background: #f0f2f3;\n  color: #34495E;\n  text-decoration: none;\n  text-align: left;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 16px;\n  line-height: 16px;\n  min-height: 20px;\n  box-sizing: border-box;\n}\n.style-polza-module_box2__1x2SV .style-polza-module_close__1GiCS {\n  margin: 2px 4px 0 5px;\n  cursor: pointer;\n  border-radius: 100% !important;\n  min-width: 10px;\n}\n.style-polza-module_box2__1x2SV .style-polza-module_close__1GiCS:hover {\n  background-color: rgba(110, 124, 141, 0.1);\n}\n\n.style-polza-module_keyword-items__buvAm {\n  padding-top: 5px;\n  background-color: #fff;\n  border: 0.75px solid #34495E;\n  border-radius: 0 !important;\n}\n\n.style-polza-module_keyword-itemsNoOverflow__YhcNT {\n  border-top: 0;\n  box-sizing: border-box;\n  border-radius: 0 !important;\n}";
var polzaStyle$1 = {"box":"style-polza-module_box__pk1EM","items":"style-polza-module_items__2BveC","inputBox":"style-polza-module_inputBox__2SThC","icon":"style-polza-module_icon__3Xfcg","input":"style-polza-module_input__BVDMA","name":"style-polza-module_name__39StH","filterTag":"style-polza-module_filterTag__1G3-F","item-box":"style-polza-module_item-box__2k4jN","close":"style-polza-module_close__1GiCS","box2":"style-polza-module_box2__1x2SV","keyword-items":"style-polza-module_keyword-items__buvAm","keyword-itemsNoOverflow":"style-polza-module_keyword-itemsNoOverflow__YhcNT"};
styleInject(css_248z$8);

var script$1K = {
  name: "TextEditor",
  components: {
    LabelInfo: __vue_component__$1M,
    TextInput: __vue_component__$1L
  },
  props: {
    name: String,
    tabindex: Number,
    description: String,
    placeholder: String,
    value: String,
    defaultValue: String,
    nameClass: String,
    inputClass: String,
    onChange: Function,
    onEnter: Function,
    fontSize: String,
    filter: Function,
    format: Function,
    inputRef: Function,
    maxlength: Number,
    disabled: {
      type: Boolean,
      default: false
    },
    isPolza: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showIcon() {
      let icon = this.$slots["icon"];
      return !!icon;
    }

  },

  data() {
    return {
      polzaStyle: polzaStyle$1
    };
  },

  methods: {
    focus() {
      this.$refs.textInput.focus();
    },

    hasValue: hasValue$1,

    handlerOnBlur(e) {
      this.$emit("blur", e);
    },

    handlerOnInput(v, e) {
      this.$emit("input", v, e);
    },

    handlerOnChange(v, e) {
      this.$emit("change", v, e);
    },

    change(e) {
      this.onEnter && this.onEnter(e.target.value);
    },

    getClass(className) {
      return this.isPolza && this.polzaStyle[className] || this.$style[className];
    }

  }
};

/* script */
const __vue_script__$1K = script$1K;
/* template */

var __vue_render__$1K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "TextEditor",
    class: _vm.$style.box
  }, [_c('LabelInfo', {
    class: _vm.$style.name,
    staticStyle: {
      "margin-bottom": "2px"
    },
    attrs: {
      "description": _vm.description
    }
  }, [_vm._t("name", [_vm._v(_vm._s(_vm.name))], null, _vm.name)], 2), _vm._v(" "), _c('div', {
    class: _vm.$style.inputBox
  }, [_c('TextInput', {
    ref: "textInput",
    class: [_vm.getClass('input'), _vm.inputClass],
    style: {
      paddingRight: _vm.showIcon ? '30px' : null,
      fontSize: _vm.fontSize
    },
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "value": _vm.value,
      "defaultValue": _vm.defaultValue,
      "fontSize": _vm.fontSize,
      "filter": _vm.filter,
      "format": _vm.format,
      "maxlength": _vm.maxlength,
      "inputRef": _vm.inputRef,
      "tabindex": _vm.tabindex
    },
    on: {
      "input": _vm.handlerOnInput,
      "change": _vm.handlerOnChange,
      "keyup": function (e) {
        return _vm.$emit('keyup', e);
      },
      "blur": _vm.handlerOnBlur,
      "click": function (e) {
        return _vm.$emit('click', e);
      },
      "keydown": function (e) {
        return _vm.$emit('keydown', e);
      }
    }
  }), _vm._v(" "), _vm.showIcon ? _c('div', {
    class: _vm.$style.icon
  }, [_vm._t("icon")], 2) : _vm._e()], 1)], 1);
};

var __vue_staticRenderFns__$1K = [];
/* style */

const __vue_inject_styles__$1K = function (inject) {
  if (!inject) return;
  inject("data-v-467158fe_0", {
    source: ".src-components-box-3WIU{display:flex;flex-direction:column;justify-content:space-between}.src-components-inputBox-2FEe{position:relative}.src-components-inputBox-2FEe .src-components-icon-3p5G{position:absolute;top:0;bottom:0;right:8px;min-width:18px;display:flex;align-items:center;justify-content:center}.src-components-input-1sog{width:100%;box-sizing:border-box;border-radius:4px!important;border:1px solid #6e7c8d;height:32px;padding:0 0 0 6px;font-size:16px;font-family:\"IBM Plex Sans\",Avenir,Helvetica,Arial,sans-serif}.src-components-input-1sog:focus{border:1.5px solid #6e7c8d;outline:0}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-box-3WIU",
      "inputBox": "src-components-inputBox-2FEe",
      "icon": "src-components-icon-3p5G",
      "input": "src-components-input-1sog"
    }
  });
};
/* scoped */


const __vue_scope_id__$1K = undefined;
/* module identifier */

const __vue_module_identifier__$1K = undefined;
/* functional template */

const __vue_is_functional_template__$1K = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1K,
  staticRenderFns: __vue_staticRenderFns__$1K
}, __vue_inject_styles__$1K, __vue_script__$1K, __vue_scope_id__$1K, __vue_is_functional_template__$1K, __vue_module_identifier__$1K, false, createInjector, undefined, undefined);

var script$1J = {
  name: "IconRadioButton",
  inject: {
    team: {
      default: () => ({
        nm: 'default',
        stl: {}
      })
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
};

/* script */
const __vue_script__$1J = script$1J;
/* template */

var __vue_render__$1J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm.team === 'dark' ? _c('div', [_vm.value ? _c('div', [_c('svg', {
    staticStyle: {
      "min-width": "24px",
      "min-height": "24px"
    },
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
      "fill": "white"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "4",
      "fill": "white"
    }
  })])]) : _c('div', [_c('svg', {
    staticStyle: {
      "min-width": "24px",
      "min-height": "24px"
    },
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
      "fill": "white"
    }
  })])])]) : _c('div', [_vm.value ? _c('div', [_c('svg', {
    staticStyle: {
      "min-width": "24px",
      "min-height": "24px"
    },
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
      "fill": "#6E7C8D"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "4",
      "fill": "#6E7C8D"
    }
  })])]) : _c('div', [_c('svg', {
    staticStyle: {
      "min-width": "24px",
      "min-height": "24px"
    },
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
      "fill": "#6E7C8D"
    }
  })])])])]);
};

var __vue_staticRenderFns__$1J = [];
/* style */

const __vue_inject_styles__$1J = undefined;
/* scoped */

const __vue_scope_id__$1J = undefined;
/* module identifier */

const __vue_module_identifier__$1J = undefined;
/* functional template */

const __vue_is_functional_template__$1J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1J,
  staticRenderFns: __vue_staticRenderFns__$1J
}, __vue_inject_styles__$1J, __vue_script__$1J, __vue_scope_id__$1J, __vue_is_functional_template__$1J, __vue_module_identifier__$1J, false, undefined, undefined, undefined);

//
var script$1I = {
  name: "RadioButton",
  inject: {
    team: {
      default: () => "default"
    }
  },
  components: {
    IconRadioButton: __vue_component__$1J
  },
  props: {
    value: [String, Number, Boolean],
    checked: Boolean,
    group: String,
    label: String,
    id: String
  },
  methods: {
    handlerChange(e) {
      this.$emit("change", e);
    }

  }
};

/* script */
const __vue_script__$1I = script$1I;
/* template */

var __vue_render__$1I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('label', {
    class: _vm.$style.box,
    on: {
      "click": _vm.handlerChange
    }
  }, [_c('IconRadioButton', {
    attrs: {
      "value": _vm.checked
    }
  }), _vm._v(" "), _c('span', {
    class: [_vm.team === 'dark' && _vm.$style.dark, _vm.$style.label]
  }, [_vm._v(_vm._s(_vm.label))])], 1);
};

var __vue_staticRenderFns__$1I = [];
/* style */

const __vue_inject_styles__$1I = function (inject) {
  if (!inject) return;
  inject("data-v-039d9540_0", {
    source: ".src-components-RadioButton-box-1vd1{display:flex;align-items:center;cursor:pointer}.src-components-RadioButton-box-1vd1 .src-components-RadioButton-label-3OJ2{margin-left:6px;user-select:none;white-space:nowrap}.src-components-RadioButton-dark-2M5u{color:#fff}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-RadioButton-box-1vd1",
      "label": "src-components-RadioButton-label-3OJ2",
      "dark": "src-components-RadioButton-dark-2M5u"
    }
  });
};
/* scoped */


const __vue_scope_id__$1I = undefined;
/* module identifier */

const __vue_module_identifier__$1I = undefined;
/* functional template */

const __vue_is_functional_template__$1I = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1I,
  staticRenderFns: __vue_staticRenderFns__$1I
}, __vue_inject_styles__$1I, __vue_script__$1I, __vue_scope_id__$1I, __vue_is_functional_template__$1I, __vue_module_identifier__$1I, false, createInjector, undefined, undefined);

//
var script$1H = {
  name: "LabelInfo",
  inject: {
    team: {
      default: () => "default"
    }
  },
  components: {
    IconInfo: __vue_component__$1O,
    Tooltip: __vue_component__$1N
  },
  props: {
    description: String,
    className: String
  },
  methods: {
    notEmptyString
  }
};

/* script */
const __vue_script__$1H = script$1H;
/* template */

var __vue_render__$1H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "LabelInfo",
    class: _vm.$style.header
  }, [_c('div', {
    class: [_vm.$style.name, _vm.team === 'dark' && _vm.$style.dark, _vm.className],
    on: {
      "click": function (e) {
        return _vm.$emit('clickName', e);
      }
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _vm.notEmptyString(_vm.description) ? _c('Tooltip', {
    class: _vm.$style.tooltip,
    attrs: {
      "text": _vm.description
    }
  }, [_c('IconInfo')], 1) : _vm._e()], 1);
};

var __vue_staticRenderFns__$1H = [];
/* style */

const __vue_inject_styles__$1H = function (inject) {
  if (!inject) return;
  inject("data-v-2295ea26_0", {
    source: ".src-components-LabelInfo-header-2TPb{display:flex;align-items:center}.src-components-LabelInfo-header-2TPb>*+*{margin-left:10px}.src-components-LabelInfo-name-1XaG{font-size:16px;line-height:1;color:#202020}.src-components-LabelInfo-tooltip-3zt4{height:18px}.src-components-LabelInfo-dark-33xc{color:#fff}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "header": "src-components-LabelInfo-header-2TPb",
      "name": "src-components-LabelInfo-name-1XaG",
      "tooltip": "src-components-LabelInfo-tooltip-3zt4",
      "dark": "src-components-LabelInfo-dark-33xc"
    }
  });
};
/* scoped */


const __vue_scope_id__$1H = undefined;
/* module identifier */

const __vue_module_identifier__$1H = undefined;
/* functional template */

const __vue_is_functional_template__$1H = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1H,
  staticRenderFns: __vue_staticRenderFns__$1H
}, __vue_inject_styles__$1H, __vue_script__$1H, __vue_scope_id__$1H, __vue_is_functional_template__$1H, __vue_module_identifier__$1H, false, createInjector, undefined, undefined);

var script$1G = {
  name: "RadioGroup",
  components: {
    RadioButton: __vue_component__$1I,
    LabelInfo: __vue_component__$1H
  },
  props: {
    classRadioButtonBox: String,
    classRadioButton: String,
    direction: {
      type: String,
      default: "row"
    },
    indent: {
      type: Number,
      default: 10
    },
    name: String,
    description: String,
    value: {
      type: [String, Number, Boolean],

      default() {
        return null;
      }

    },
    elements: {
      type: Array,

      default() {
        return [{
          value: true,
          label: "Да"
        }, {
          value: false,
          label: "Нет"
        }, {
          value: null,
          label: "Не важно"
        }];
      }

    }
  },
  computed: {
    radioButtonStyle() {
      if (this.direction === "row") return {
        marginLeft: this.indent + (this.indent !== "auto" ? "px" : "")
      };else return {
        marginTop: this.indent + "px"
      };
    }

  },
  methods: {
    handlerChange(value) {
      this.$emit("input", value);
    }

  }
};

/* script */
const __vue_script__$1G = script$1G;
/* template */

var __vue_render__$1G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.$style.root
  }, [_vm.description ? _c('LabelInfo', {
    class: _vm.$style.label,
    attrs: {
      "description": _vm.description
    }
  }, [_vm._v(_vm._s(_vm.name))]) : _vm._e(), _vm._v(" "), _c('div', {
    class: [_vm.$style.radioButtonBox, _vm.classRadioButtonBox],
    style: {
      flexDirection: _vm.direction,
      marginLeft: _vm.indent ? "-" + _vm.indent + "px" : null
    }
  }, _vm._l(_vm.elements, function (element, index) {
    return _c('RadioButton', {
      key: index,
      class: _vm.classRadioButton,
      style: Object.assign({}, _vm.radioButtonStyle, {
        minWidth: element.width,
        marginTop: '5px'
      }),
      attrs: {
        "label": element.label,
        "value": element.value,
        "checked": element.value === _vm.value
      },
      on: {
        "change": function () {
          return _vm.handlerChange(element.value);
        }
      }
    });
  }), 1)], 1);
};

var __vue_staticRenderFns__$1G = [];
/* style */

const __vue_inject_styles__$1G = function (inject) {
  if (!inject) return;
  inject("data-v-a67922fc_0", {
    source: ".src-components-RadioGroup-root-3jgh .src-components-RadioGroup-label-35BF{margin-bottom:5px}.src-components-RadioGroup-root-3jgh .src-components-RadioGroup-radioButtonBox-2Qj6{display:flex;align-items:flex-start;flex-direction:row;flex-wrap:wrap}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "root": "src-components-RadioGroup-root-3jgh",
      "label": "src-components-RadioGroup-label-35BF",
      "radioButtonBox": "src-components-RadioGroup-radioButtonBox-2Qj6"
    }
  });
};
/* scoped */


const __vue_scope_id__$1G = undefined;
/* module identifier */

const __vue_module_identifier__$1G = undefined;
/* functional template */

const __vue_is_functional_template__$1G = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1G,
  staticRenderFns: __vue_staticRenderFns__$1G
}, __vue_inject_styles__$1G, __vue_script__$1G, __vue_scope_id__$1G, __vue_is_functional_template__$1G, __vue_module_identifier__$1G, false, createInjector, undefined, undefined);

/* eslint-disable */
const dateRegex = /^([0-9]+)\.([0-9]+)\.([0-9]+)( ([0-9]{1,2})\:([0-9]{1,2}))?$/;
const minValidYear = 1970;
const maxValidYear = 3000;
const maxValidDay = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function pad$1(val, len) {
  val = String(val);
  len = len || 2;

  while (val.length < len) {
    val = '0' + val;
  }

  return val;
}
function dateFormat$1(date, format) {
  if (!(date instanceof Date)) {
    return null;
  }

  const d = pad$1(date.getDate());
  const m = pad$1(date.getMonth() + 1);
  const y = pad$1(date.getFullYear(), 4);

  if (format && format.indexOf('h') > 0) {
    const h = pad$1(date.getHours(), 2);
    const M = pad$1(date.getMinutes(), 2);
    return `${d}.${m}.${y} ${h}:${M}`;
  }

  return `${d}.${m}.${y}`;
}
function dateParse(dateString) {
  const invalidResult = {
    dateValue: null,
    isValid: false
  };

  function validResult(dateValue) {
    return {
      dateValue,
      isValid: true
    };
  }

  if (!dateString) {
    return validResult(null);
  }

  if (!dateString.match) {
    return invalidResult;
  }

  const match = dateString.trim().match(dateRegex);

  if (!match) {
    return invalidResult;
  }

  const year = parseInt(match[3]);

  if (year < minValidYear || year > maxValidYear) {
    return invalidResult;
  }

  const month = parseInt(match[2]) - 1;

  if (month < 0 || month > 11) {
    return invalidResult;
  }

  const incMaxValidDay = month == 1 && (year % 400 == 0 || year % 4 == 0 && year % 100 != 0) && 1 || 0;
  const day = parseInt(match[1]);

  if (day < 1 || day > maxValidDay[month] + incMaxValidDay) {
    return invalidResult;
  }

  if (match[5] != undefined && match[6] != undefined) {
    let h = parseInt(match[5]);
    let M = parseInt(match[6]);

    if (h >= 0 && h <= 24 && M >= 0 && M <= 60) {
      return validResult(new Date(year, month, day, h, M));
    }
  }

  return validResult(new Date(year, month, day));
}

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
function getTarget(node) {
  if (node === void 0) {
    node = document.body;
  }

  if (node === true) {
    return document.body;
  }

  return node instanceof window.Node ? node : document.querySelector(node);
}

const transfer = {
  inserted(el, binding) {
    const value = binding.value;
    if (value === false) return false;
    el.className = el.className ? el.className + " v-transfer" : "v-transfer";
    const parentNode = el.parentNode;
    if (!parentNode) return;
    const home = document.createComment("");
    let hasMovedOut = false;

    if (value !== false) {
      parentNode.replaceChild(home, el); // moving out, el is no longer in the document

      getTarget(value).appendChild(el); // moving into new place

      hasMovedOut = true;
    }

    if (!el.__transferDomData) {
      el.__transferDomData = {
        parentNode: parentNode,
        home: home,
        target: getTarget(value),
        hasMovedOut: hasMovedOut
      };
    }
  },

  componentUpdated(el, binding) {
    const value = binding.value;
    if (value === false) return false; // need to make sure children are done updating (vs. `update`)

    const ref$1 = el.__transferDomData;
    if (!ref$1) return; // homes.get(el)

    const parentNode = ref$1.parentNode;
    const home = ref$1.home;
    const hasMovedOut = ref$1.hasMovedOut; // recall where home is

    if (!hasMovedOut && value) {
      // remove from document and leave placeholder
      parentNode.replaceChild(home, el); // append to target

      getTarget(value).appendChild(el);
      el.__transferDomData = Object.assign({}, el.__transferDomData, {
        hasMovedOut: true,
        target: getTarget(value)
      });
    } else if (hasMovedOut && value === false) {
      // previously moved, coming back home
      parentNode.replaceChild(el, home);
      el.__transferDomData = Object.assign({}, el.__transferDomData, {
        hasMovedOut: false,
        target: getTarget(value)
      });
    } else if (value) {
      // already moved, going somewhere else
      getTarget(value).appendChild(el);
    }
  },

  unbind(el, binding) {
    const value = binding.value;
    if (value === false) return false;
    el.className = el.className.replace("v-transfer", "");
    const ref$1 = el.__transferDomData;
    if (!ref$1) return;

    if (el.__transferDomData.hasMovedOut === true) {
      el.__transferDomData.parentNode && el.__transferDomData.parentNode.appendChild(el);
    }

    el.__transferDomData = null;
  }

};
var script$1F = {
  name: "Calendar",
  directives: {
    transfer
  },
  props: {
    vueCalendarLang: Object,
    value: {
      type: [String, Date]
    },
    format: {
      default: "MM/dd/yyyy"
    },
    firstDayOfWeek: {
      // sunday
      default: 0
    },
    disabledDaysOfWeek: {
      type: Array,

      default() {
        return [];
      }

    },
    width: {
      type: String,
      default: "200px"
    },
    clearButton: {
      type: Boolean,
      default: false
    },
    inputClasses: {
      type: String,
      default: ""
    },
    lang: {
      type: String,
      default: "ru"
    },
    placeholder: {
      type: String
    },
    hasInput: {
      type: Boolean,
      default: true
    },
    pane: {
      type: Number,
      default: 1
    },
    borderWidth: {
      type: Number,
      default: 2
    },
    onDayClick: {
      type: Function,

      default() {}

    },
    changePane: {
      type: Function,

      default() {}

    },
    specialDays: {
      type: Object,

      default() {
        return {};
      }

    },
    rangeBus: {
      type: Function,

      default() {// return new Vue()
      }

    },
    rangeStatus: {
      type: Number,
      default: 0
    },
    onDrawDate: {
      type: Function,

      default() {}

    },
    maxDate: {
      type: String
    },
    minDate: {
      type: String
    },
    showDateOnly: {
      type: Boolean,
      default: false
    },
    transfer: {
      type: Boolean,
      default: false
    },
    elementId: [String]
  },

  data() {
    return {
      // inputValue: this.value,
      dateFormat: this.format,
      currDate: new Date(),
      dateRange: [],
      decadeRange: [],
      paneStyle: {
        width: ""
      },
      displayDayView: false,
      displayMonthView: false,
      displayYearView: false,
      rangeStart: false,
      rangeEnd: false
    };
  },

  computed: {
    // get real order of the daysOfWeek
    daysOfWeek() {
      const firstDay = this.firstDayOfWeek;

      if (firstDay == 0) {
        return this.text.daysOfWeek;
      }

      return this.text.daysOfWeek.slice(firstDay, 7).concat(this.text.daysOfWeek.slice(0, firstDay));
    },

    text() {
      return this.translations(this.lang);
    },

    isWrapperShow() {
      return this.displayDayView || this.displayMonthView || this.displayYearView;
    },

    inputValue: {
      get() {
        if (this.value instanceof Date) {
          return this.stringify(this.value);
        } else {
          return this.value;
        }
      },

      set(v) {
        this.$emit("input", v);
        this.currDate = this.parse(v);

        if (this.rangeStatus === 1 && this.eventbus) {
          this.eventbus.$emit("calendar-rangestart", this.currDate);
        }
      }

    },

    classes() {
      let classes = this.inputClasses;

      if (this.clearButton) {
        classes += " with-reset-button";
      }

      return classes;
    }

  },
  watch: {
    currDate() {
      this.getDateRange();
    },

    value(v) {
      this.inputValue = v instanceof Date ? this.stringify(v) : v;
    }

  },

  mounted() {
    this._blur = e => {
      if (this.transfer) {
        if (!this.$el.contains(e.target) && !this.$refs.popup.contains(e.target) && this.hasInput) this.close();
      } else if (!this.$el.contains(e.target) && this.hasInput) this.close();
    };

    this.$emit("child-created", this); // this.inputValue = this.value
    // this.dateFormat = this.format

    this.currDate = this.parse(this.inputValue) || this.parse(new Date());
    const year = this.currDate.getFullYear();
    const month = this.currDate.getMonth();
    this.changePane(year, month, this.pane);

    if (!this.hasInput) {
      this.displayDayView = true;
      this.updatePaneStyle();
    }

    if (this.rangeStatus) {
      this.eventbus = this.rangeBus();

      if (typeof this.eventbus === "object" && !this.eventbus.$on) {
        console.warn("Calendar rangeBus doesn't exist");
        this.rangeStatus = 0;
      }
    }

    if (this.rangeStatus === 2) {
      this._updateRangeStart = date => {
        this.rangeStart = date;
        this.currDate = date;
        this.inputValue = this.stringify(this.currDate);
      };

      this.eventbus.$on("calendar-rangestart", this._updateRangeStart);
    }

    document.addEventListener("click", this._blur);
  },

  beforeDestroy() {
    document.removeEventListener("click", this._blur);

    if (this.rangeStatus === 2) {
      this.eventbus.$off("calendar-rangestart", this._updateRangeStart);
    }
  },

  methods: {
    handleMouseOver(event) {
      let target = event.target; // this.rangeEnd = false

      if (!this.rangeStart) {
        return true;
      }

      if (event.type === "mouseout") {
        return true;
      }

      while (this.$el.contains(target) && !~target.className.indexOf("day-cell")) {
        target = target.parentNode;
      }

      if (~target.className.indexOf("day-cell") && !~target.className.indexOf("datepicker-item-gray")) {
        const rangeEnd = target.getAttribute("data-date");

        if (this.rangeStart < this.parse(rangeEnd)) {
          this.rangeEnd = this.parse(rangeEnd);
        }
      }
    },

    __OnDrawDate(e) {
      let date = e.date;
      let maxDate = this.parse(this.maxDate, false);
      let minDate = this.parse(this.minDate, false);

      if (this.isDate(maxDate)) {
        if (date.getTime() > maxDate.getTime()) {
          e.allowSelect = false;
        }
      }

      if (this.isDate(minDate)) {
        if (date.getTime() < minDate.getTime()) {
          e.allowSelect = false;
        }
      }

      this.$emit("drawdate", e);
      this.onDrawDate(e);
    },

    getItemClasses(d) {
      d.allowSelect = true;

      this.__OnDrawDate(d);

      const clazz = [];
      clazz.push(d.sclass);

      if (this.rangeStart && this.rangeEnd && d.sclass !== "datepicker-item-gray") {
        if (d.date > this.rangeStart && d.date < this.rangeEnd) {
          clazz.push("daytoday-range");
        }
        /* eslint-disable eqeqeq */


        if (this.stringify(d.date) == this.stringify(this.rangeStart)) {
          clazz.push("daytoday-start");
        }
        /* eslint-disable eqeqeq */


        if (this.stringify(d.date) == this.stringify(this.rangeEnd)) {
          clazz.push("daytoday-end");
        }
      }

      if (d.allowSelect == false) {
        clazz.push("datepicker-item-disabled");
      }

      return clazz.join(" ");
    },

    translations(lang) {
      let text = {
        daysOfWeek: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
        limit: "Limit reached ({{limit}} items max).",
        loading: "Загрузка...",
        minLength: "Min. Length",
        months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
        notSelected: "Ничего не выбрано",
        required: "Required",
        search: "Search"
      };
      return text;
    },

    close() {
      this.displayDayView = this.displayMonthView = this.displayYearView = false;
    },

    inputClick() {
      this.currDate = this.parse(this.inputValue) || this.parse(new Date());

      if (this.displayMonthView || this.displayYearView) {
        this.displayDayView = false;
      } else {
        this.displayDayView = !this.displayDayView;
      }

      this.updatePaneStyle();
    },

    getElOffset(el) {
      let top = el.offsetTop;
      let left = el.offsetLeft;
      let offsetParent = el.offsetParent;

      while (offsetParent && offsetParent != document.body) {
        top += offsetParent.offsetTop;
        left += offsetParent.offsetLeft;
        offsetParent = offsetParent.offsetParent;
      }

      return {
        top,
        left
      };
    },

    updatePaneStyle() {
      if (!(this.displayMonthView || this.displayYearView)) {
        this.$nextTick(function () {
          let {
            left,
            top
          } = this.getElOffset(this.$el);
          let offsetLeft = this.$el.offsetLeft;
          let elWidth = this.$el.offsetWidth;
          let offsetTop = top + this.$el.offsetHeight;
          let offsetWidth = this.$refs.popup.querySelector(".datepicker-inner").offsetWidth;
          let popWidth = this.pane * offsetWidth + this.borderWidth; // add border

          this.paneStyle.width = popWidth + "px";

          if (this.hasInput) {
            if (this.transfer) {
              this.paneStyle.left = left + "px";
              this.paneStyle.top = offsetTop + "px";

              if (popWidth + left > document.documentElement.clientWidth) {
                this.paneStyle.left = left + elWidth - popWidth + "px";
              }
            } else if (popWidth + offsetLeft > document.documentElement.clientWidth) {
              this.paneStyle.right = "0px";
            }
          } else {
            this.paneStyle.position = "initial";
          }

          this.$forceUpdate();
        });
      }
    },

    preNextDecadeClick(flag) {
      const year = this.currDate.getFullYear();
      const months = this.currDate.getMonth();
      const date = this.currDate.getDate();

      if (flag === 0) {
        this.currDate = new Date(year - 10, months, date);
      } else {
        this.currDate = new Date(year + 10, months, date);
      }
    },

    preNextMonthClick(flag) {
      const year = this.currDate.getFullYear();
      const month = this.currDate.getMonth();
      const date = this.currDate.getDate();

      if (flag === 0) {
        const preMonth = this.getYearMonth(year, month - 1);
        const lastDate = Math.min(this.getDayCount(preMonth.year, preMonth.month), date);
        this.currDate = new Date(preMonth.year, preMonth.month, lastDate);
        this.changePane(preMonth.year, preMonth.month, this.pane);
      } else {
        const nextMonth = this.getYearMonth(year, month + 1);
        const lastDate = Math.min(this.getDayCount(nextMonth.year, nextMonth.month), date);
        this.currDate = new Date(nextMonth.year, nextMonth.month, lastDate);
        this.changePane(nextMonth.year, nextMonth.month, this.pane);
      }
    },

    preNextYearClick(flag) {
      const year = this.currDate.getFullYear();
      const months = this.currDate.getMonth();
      const date = this.currDate.getDate();

      if (flag === 0) {
        this.currDate = new Date(year - 1, months, date);
      } else {
        this.currDate = new Date(year + 1, months, date);
      }
    },

    yearSelect(year) {
      this.displayYearView = false;
      this.displayMonthView = true;
      this.currDate = new Date(year, this.currDate.getMonth(), this.currDate.getDate());
    },

    daySelect(item, event) {
      let date = item.date;
      let el = event.target;

      if (item.allowSelect == false || el.classList[0] === "datepicker-item-disable") {
        return false;
      } else if (this.hasInput) {
        this.currDate = date;
        this.inputValue = this.stringify(this.currDate);
        this.displayDayView = false;
      } else {
        this.onDayClick(date, this.stringify(date));
      }
    },

    switchMonthView() {
      if (this.showDateOnly) {
        return true;
      }

      this.displayDayView = false;
      this.displayMonthView = true;
    },

    switchDecadeView() {
      this.displayMonthView = false;
      this.displayYearView = true;
    },

    monthSelect(year, index) {
      this.displayMonthView = false;
      this.displayDayView = true;
      this.currDate = new Date(year, index, this.currDate.getDate());
      this.changePane(year, index, this.pane);
    },

    getYearMonth(year, month) {
      if (month > 11) {
        year++;
        month = 0;
      } else if (month < 0) {
        year--;
        month = 11;
      }

      return {
        year: year,
        month: month
      };
    },

    getSpecailDay(v) {
      return this.specialDays[this.stringify(v)];
    },

    stringifyDecadeHeader(date, pan) {
      const yearStr = date.getFullYear().toString();
      const firstYearOfDecade = parseInt(yearStr.substring(0, yearStr.length - 1) + 0, 10) + pan * 10;
      const lastYearOfDecade = parseInt(firstYearOfDecade, 10) + 10;
      return firstYearOfDecade + "-" + lastYearOfDecade;
    },

    siblingsMonth(v, n) {
      return new Date(v.getFullYear(), v.getMonth() * 1 + n);
    },

    stringifyDayHeader(date, month = 0) {
      const d = this.siblingsMonth(date, month);
      return this.text.months[d.getMonth()] + " " + d.getFullYear();
    },

    parseMonth(date) {
      return this.text.months[date.getMonth()];
    },

    stringifyYearHeader(date, year = 0) {
      return date.getFullYear() + year;
    },

    isDate(value) {
      return !!(value && value.getFullYear);
    },

    stringify(date, format = this.dateFormat) {
      if (!date) date = this.parse(this.inputValue);
      if (!date) return "";
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const monthName = this.parseMonth(date);
      return format.replace(/yyyy/g, year).replace(/MMMM/g, monthName).replace(/MMM/g, monthName.substring(0, 3)).replace(/MM/g, ("0" + month).slice(-2)).replace(/dd/g, ("0" + day).slice(-2)).replace(/yy/g, year).replace(/M(?!a)/g, month).replace(/d/g, day);
    },

    parse(str, safe = true) {
      if (typeof str == "string") {
        let date;

        if (str.length === 10 && (this.dateFormat === "dd-MM-yyyy" || this.dateFormat === "dd/MM/yyyy")) {
          date = new Date(str.substring(6, 10), str.substring(3, 5) - 1, str.substring(0, 2));
        } else {
          date = new Date(str);
          date.setHours(0, 0, 0);
        }

        return isNaN(date.getFullYear()) ? safe ? new Date() : date : date;
      } else return str;
    },

    getDayCount(year, month) {
      const dict = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

      if (month === 1) {
        if (year % 400 === 0 || year % 4 === 0 && year % 100 !== 0) {
          return 29;
        }
      }

      return dict[month];
    },

    //
    prefixLen(date) {
      const firstDay = this.firstDayOfWeek;
      const wkday = date.getDay(); // frist Date

      return wkday >= firstDay ? wkday - firstDay : 7 - firstDay + wkday;
    },

    getDateRange() {
      this.dateRange = [];
      this.decadeRange = [];

      for (let p = 0; p < this.pane; p++) {
        let currMonth = this.siblingsMonth(this.currDate, p);
        let time = {
          year: currMonth.getFullYear(),
          month: currMonth.getMonth()
        };
        let yearStr = time.year.toString();
        this.decadeRange[p] = [];
        let firstYearOfDecade = yearStr.substring(0, yearStr.length - 1) + 0 - 1;

        for (let i = 0; i < 12; i++) {
          this.decadeRange[p].push({
            text: firstYearOfDecade + i + p * 10
          });
        }

        this.dateRange[p] = [];
        const currMonthFirstDay = new Date(time.year, time.month, 1);
        let firstDayWeek = this.prefixLen(currMonthFirstDay);
        const dayCount = this.getDayCount(time.year, time.month);

        if (firstDayWeek >= 1) {
          const preMonth = this.getYearMonth(time.year, time.month - 1);
          const prevMonthDayCount = this.getDayCount(preMonth.year, preMonth.month);

          for (let i = 0; i < firstDayWeek; i++) {
            const dayText = prevMonthDayCount - firstDayWeek + i + 1;
            this.dateRange[p].push({
              text: dayText,
              date: new Date(preMonth.year, preMonth.month, dayText),
              sclass: "datepicker-item-gray"
            });
          }
        }

        for (let i = 1; i <= dayCount; i++) {
          const date = new Date(time.year, time.month, i);
          const week = date.getDay();
          let sclass = "";
          this.disabledDaysOfWeek.forEach(el => {
            if (week === parseInt(el, 10)) sclass = "datepicker-item-disable";
          });

          if (i === this.currDate.getDate()) {
            if (this.inputValue) {
              const valueDate = this.parse(this.inputValue);

              if (valueDate) {
                if (valueDate.getFullYear() === time.year && valueDate.getMonth() === time.month) {
                  sclass = "datepicker-dateRange-item-active";
                }
              }
            }
          }

          this.dateRange[p].push({
            text: i,
            date: date,
            sclass: sclass
          });
        }

        if (this.dateRange[p].length < 42) {
          const nextMonthNeed = 42 - this.dateRange[p].length;
          const nextMonth = this.getYearMonth(time.year, time.month + 1);

          for (let i = 1; i <= nextMonthNeed; i++) {
            this.dateRange[p].push({
              text: i,
              date: new Date(nextMonth.year, nextMonth.month, i),
              sclass: "datepicker-item-gray"
            });
          }
        }
      }
    }

  }
};

/* script */
const __vue_script__$1F = script$1F;
/* template */

var __vue_render__$1F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "datepicker"
  }, [_vm.hasInput ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.inputValue,
      expression: "inputValue"
    }],
    staticClass: "form-control datepicker-input",
    class: _vm.classes,
    style: {
      width: _vm.width
    },
    attrs: {
      "id": _vm.elementId,
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.inputValue
    },
    on: {
      "click": _vm.inputClick,
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.inputValue = $event.target.value;
      }
    }
  }), _vm._v(" "), _vm.clearButton && _vm.value ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        _vm.inputValue = '';
      }
    }
  }, [_c('span', [_vm._v("×")])]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isWrapperShow,
      expression: "isWrapperShow"
    }, {
      name: "transfer",
      rawName: "v-transfer",
      value: _vm.transfer,
      expression: "transfer"
    }],
    ref: "popup",
    staticClass: "datepicker-wrapper",
    style: _vm.paneStyle
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.displayDayView,
      expression: "displayDayView"
    }],
    staticClass: "datepicker-popup",
    on: {
      "mouseover": _vm.handleMouseOver,
      "mouseout": _vm.handleMouseOver
    }
  }, [_c('div', {
    staticClass: "datepicker-ctrl"
  }, [_c('span', {
    staticClass: "datepicker-preBtn calendaricon-angle-left",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function ($event) {
        return _vm.preNextMonthClick(0);
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "datepicker-nextBtn calendaricon-angle-right",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function ($event) {
        return _vm.preNextMonthClick(1);
      }
    }
  })]), _vm._v(" "), _vm._l(_vm.pane, function (p, pan) {
    return [_c('div', {
      key: pan,
      staticClass: "datepicker-inner"
    }, [_c('div', {
      staticClass: "datepicker-body"
    }, [_c('p', {
      on: {
        "click": _vm.switchMonthView
      }
    }, [_vm._v("\n              " + _vm._s(_vm.stringifyDayHeader(_vm.currDate, pan)) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "datepicker-weekRange"
    }, _vm._l(_vm.daysOfWeek, function (w, index) {
      return _c('span', {
        key: index
      }, [_vm._v(_vm._s(w))]);
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "datepicker-dateRange"
    }, _vm._l(_vm.dateRange[pan], function (d, k) {
      return _c('span', {
        key: k,
        staticClass: "day-cell",
        class: _vm.getItemClasses(d),
        attrs: {
          "data-date": _vm.stringify(d.date)
        },
        on: {
          "click": function ($event) {
            return _vm.daySelect(d, $event);
          }
        }
      }, [_c('div', [d.sclass !== 'datepicker-item-gray' ? [_vm._v(_vm._s(_vm.getSpecailDay(d.date) || d.text))] : [_vm._v(_vm._s(d.text))], _vm._v(" "), d.sclass !== 'datepicker-item-gray' ? _c('div', [_vm._t(_vm.stringify(d.date))], 2) : _vm._e()], 2)]);
    }), 0)])])];
  })], 2), _vm._v(" "), !_vm.showDateOnly ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.displayMonthView,
      expression: "displayMonthView"
    }],
    staticClass: "datepicker-popup"
  }, [_c('div', {
    staticClass: "datepicker-ctrl"
  }, [_c('span', {
    staticClass: "datepicker-preBtn calendaricon-angle-left",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function ($event) {
        return _vm.preNextYearClick(0);
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "datepicker-nextBtn calendaricon-angle-right",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function ($event) {
        return _vm.preNextYearClick(1);
      }
    }
  })]), _vm._v(" "), _vm._l(_vm.pane, function (p, pan) {
    return [_c('div', {
      key: pan,
      staticClass: "datepicker-inner"
    }, [_c('div', {
      staticClass: "datepicker-body"
    }, [_c('p', {
      on: {
        "click": _vm.switchDecadeView
      }
    }, [_vm._v("\n              " + _vm._s(_vm.stringifyYearHeader(_vm.currDate, pan)) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "datepicker-monthRange"
    }, [_vm._l(_vm.text.months, function (m, $index) {
      return [_c('span', {
        key: $index,
        class: {
          'datepicker-dateRange-item-active': _vm.text.months[_vm.parse(_vm.value).getMonth()] === m && _vm.currDate.getFullYear() + pan === _vm.parse(_vm.value).getFullYear()
        },
        on: {
          "click": function ($event) {
            _vm.monthSelect(_vm.stringifyYearHeader(_vm.currDate, pan), $index);
          }
        }
      }, [_vm._v(_vm._s(m.substr(0, 3)))])];
    })], 2)])])];
  })], 2) : _vm._e(), _vm._v(" "), !_vm.showDateOnly ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.displayYearView,
      expression: "displayYearView"
    }],
    staticClass: "datepicker-popup"
  }, [_c('div', {
    staticClass: "datepicker-ctrl"
  }, [_c('span', {
    staticClass: "datepicker-preBtn calendaricon-angle-left",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function ($event) {
        return _vm.preNextDecadeClick(0);
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "datepicker-nextBtn calendaricon-angle-right",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function ($event) {
        return _vm.preNextDecadeClick(1);
      }
    }
  })]), _vm._v(" "), _vm._l(_vm.pane, function (p, pan) {
    return [_c('div', {
      key: pan,
      staticClass: "datepicker-inner"
    }, [_c('div', {
      staticClass: "datepicker-body"
    }, [_c('p', [_vm._v(_vm._s(_vm.stringifyDecadeHeader(_vm.currDate, pan)))]), _vm._v(" "), _c('div', {
      staticClass: "datepicker-monthRange decadeRange"
    }, [_vm._l(_vm.decadeRange[pan], function (decade, di) {
      return [_c('span', {
        key: di,
        class: {
          'datepicker-dateRange-item-active': _vm.parse(_vm.inputValue).getFullYear() === decade.text
        },
        on: {
          "click": function ($event) {
            $event.stopPropagation();
            return _vm.yearSelect(decade.text);
          }
        }
      }, [_vm._v(_vm._s(decade.text))])];
    })], 2)])])];
  })], 2) : _vm._e()])], 2);
};

var __vue_staticRenderFns__$1F = [];
/* style */

const __vue_inject_styles__$1F = function (inject) {
  if (!inject) return;
  inject("data-v-eaa747b4_0", {
    source: "/*!\r\n * vue2-calendar v2.2.5\r\n * (c) 2019 Terry <gidcai@gmail.com>\r\n * https://github.com/icai/vue2-calendar#readme\r\n */.datepicker{font-size:14px;font-family:Avenir,Helvetica,Arial,sans-serif;box-sizing:border-box;-webkit-tap-highlight-color:#0000;-webkit-font-smoothing:antialiased;color:rgba(0,0,0,.65098);position:relative;display:inline-block}.datepicker .form-control{box-sizing:border-box;display:block;width:100%;height:34px;padding:6px 12px;font-size:14px;line-height:1.42857;color:#555;background-color:#fff;background-image:none;border:1px solid #d9d9d9;border-radius:4px;box-shadow:none}.datepicker .form-control:focus,.datepicker .form-control:hover{outline:0;border-color:#40a9ff;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.datepicker button.close{padding:0;cursor:pointer;background:#0000;border:0;-webkit-appearance:none;float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.2;filter:alpha(opacity=20)}input.datepicker-input.with-reset-button{padding-right:25px}.datepicker>button.close{position:absolute;top:0;right:0;outline:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center}.datepicker>button.close:focus{opacity:.2}.datepicker-wrapper{position:absolute;z-index:1000;display:block!important}.datepicker-popup{border:1px solid #fff;border-radius:5px;background:#fff;margin-top:2px;box-shadow:0 2px 8px rgba(0,0,0,.15)}.datepicker-popup:after,.datepicker-popup:before{content:\" \";display:table}.datepicker-popup:after{clear:both}.datepicker-inner{width:218px;float:left}.datepicker-body{padding:10px 10px;text-align:center}.datepicker-body p{margin:0 0 10px}.datepicker-body span,.datepicker-ctrl p,.datepicker-ctrl span{display:inline-block;width:28px;line-height:28px;height:28px}.datepicker-ctrl p{width:65%}.datepicker-ctrl span{position:absolute}.datepicker-body span{text-align:center}.datepicker-monthRange span{width:48px;height:50px;line-height:45px}.datepicker-item-disable{background-color:#fff!important;cursor:not-allowed!important}.datepicker-item-disable,.datepicker-item-gray,.decadeRange span:first-child,.decadeRange span:last-child{color:#999}.datepicker-dateRange-item-active,.datepicker-dateRange-item-active:hover{background:#3276b1!important;color:#fff!important}.datepicker-item-disabled{color:#aaa;text-decoration:line-through}.datepicker-monthRange{margin-top:10px}.datepicker-ctrl p,.datepicker-ctrl span,.datepicker-dateRange span,.datepicker-monthRange span{cursor:pointer}.datepicker-ctrl i:hover,.datepicker-ctrl p:hover,.datepicker-dateRange span:hover,.datepicker-dateRange-item-hover,.datepicker-monthRange span:hover{background-color:#eee}.datepicker-dateRange .daytoday-end,.datepicker-dateRange .daytoday-end:hover,.datepicker-dateRange .daytoday-start,.datepicker-dateRange .daytoday-start:hover{background:#3276b1!important;color:#fff!important}.datepicker-dateRange .daytoday-range,.datepicker-dateRange .daytoday-range:hover{background-color:#ddd}.datepicker-weekRange span{font-weight:700}.datepicker-label{background-color:#f8f8f8;font-weight:700;padding:7px 0;text-align:center}.datepicker-ctrl{position:relative;line-height:30px;font-weight:700;text-align:center;top:3px}.month-btn{font-weight:700;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.datepicker-preBtn{left:2px;font-size:18px}.datepicker-nextBtn{right:2px;font-size:18px}@font-face{font-family:calendar;src:url(data:application/vnd.ms-fontobject;base64,rAUAAAQFAAABAAIAAAAAAAAAAAAAAAAAAAABAJABAAAAAExQAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAnWMjhgAAAAAAAAAAAAAAAAAAAAAAABAAYwBhAGwAZQBuAGQAYQByAAAADgBSAGUAZwB1AGwAYQByAAAAFgBWAGUAcgBzAGkAbwBuACAAMQAuADAAAAAQAGMAYQBsAGUAbgBkAGEAcgAAAAAAAAEAAAALAIAAAwAwT1MvMg+dCoQAAAC8AAAAYGNtYXAPUuKQAAABHAAAAFRnYXNwAAAAEAAAAXAAAAAIZ2x5ZrVRJOYAAAF4AAABNGhlYWQQzSHDAAACrAAAADZoaGVhBJsDOwAAAuQAAAAkaG10eAbbACEAAAMIAAAAGGxvY2EAwgBwAAADIAAAAA5tYXhwAAgAJwAAAzAAAAAgbmFtZWq4IzgAAANQAAABknBvc3QAAwAAAAAE5AAAACAAAwFuAZAABQAAApkCzAAAAI8CmQLMAAAB6wAzAQkAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADxBQMz/zQAzAMzAMwAAAABAAAAAAAAAAAAAAAgAAAAAAADAAAAAwAAABwAAQADAAAAHAADAAEAAAAcAAQAOAAAAAoACAACAAIAAQAg8QX//f//AAAAAAAg8QT//f//AAH/4w8AAAMAAQAAAAAAAAAAAAAAAQAB//8ADwABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAAAAAAAAAAAAIAADc5AQAAAAABABr/4wFmAh0AJAAAARQGDwEXHgEVFAYPAQ4BIyImJwEuATU0NjcBPgEzMhYfAR4BFQFmAwLh4QIDAwIdAwcDBAcC/vUCAwMCAQsCBwQDBwMdAgMB7gQHAuHhAgcEAwcDHAMDAwMBCgIIAwMIAgEKAwMDAxwDBgQAAAAAAQAH/+MBVAIdACQAAAEUBgcBDgEjIiYvAS4BNTQ2PwEnLgE1NDY/AT4BMzIWFwEeARUBVAMD/vYDBwMEBwIdAgQEAuHhAgQEAh0CBwQDBwMBCgMDAQADCAL+9gMDAwMcAwYEBAcC4eECBwQDBwMcAwMDA/72AggDAAAAAAEAAAABAACGI2OdXw889QALBAAAAAAA2CPvYwAAAADYI+9jAAD/4wFmAh0AAAAIAAIAAAAAAAAAAQAAAzP/NAAABAAAAAAAAWYAAQAAAAAAAAAAAAAAAAAAAAYEAAAAAAAAAAAAAAAAAAAAAYAAGgFbAAcAAAAAAAoAFAAeAFwAmgAAAAEAAAAGACUAAQAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAOAK4AAQAAAAAAAQAIAAAAAQAAAAAAAgAHAGkAAQAAAAAAAwAIADkAAQAAAAAABAAIAH4AAQAAAAAABQALABgAAQAAAAAABgAIAFEAAQAAAAAACgAaAJYAAwABBAkAAQAQAAgAAwABBAkAAgAOAHAAAwABBAkAAwAQAEEAAwABBAkABAAQAIYAAwABBAkABQAWACMAAwABBAkABgAQAFkAAwABBAkACgA0ALBjYWxlbmRhcgBjAGEAbABlAG4AZABhAHJWZXJzaW9uIDEuMABWAGUAcgBzAGkAbwBuACAAMQAuADBjYWxlbmRhcgBjAGEAbABlAG4AZABhAHJjYWxlbmRhcgBjAGEAbABlAG4AZABhAHJSZWd1bGFyAFIAZQBnAHUAbABhAHJjYWxlbmRhcgBjAGEAbABlAG4AZABhAHJGb250IGdlbmVyYXRlZCBieSBJY29Nb29uLgBGAG8AbgB0ACAAZwBlAG4AZQByAGEAdABlAGQAIABiAHkAIABJAGMAbwBNAG8AbwBuAC4AAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA);src:url(data:application/vnd.ms-fontobject;base64,rAUAAAQFAAABAAIAAAAAAAAAAAAAAAAAAAABAJABAAAAAExQAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAnWMjhgAAAAAAAAAAAAAAAAAAAAAAABAAYwBhAGwAZQBuAGQAYQByAAAADgBSAGUAZwB1AGwAYQByAAAAFgBWAGUAcgBzAGkAbwBuACAAMQAuADAAAAAQAGMAYQBsAGUAbgBkAGEAcgAAAAAAAAEAAAALAIAAAwAwT1MvMg+dCoQAAAC8AAAAYGNtYXAPUuKQAAABHAAAAFRnYXNwAAAAEAAAAXAAAAAIZ2x5ZrVRJOYAAAF4AAABNGhlYWQQzSHDAAACrAAAADZoaGVhBJsDOwAAAuQAAAAkaG10eAbbACEAAAMIAAAAGGxvY2EAwgBwAAADIAAAAA5tYXhwAAgAJwAAAzAAAAAgbmFtZWq4IzgAAANQAAABknBvc3QAAwAAAAAE5AAAACAAAwFuAZAABQAAApkCzAAAAI8CmQLMAAAB6wAzAQkAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADxBQMz/zQAzAMzAMwAAAABAAAAAAAAAAAAAAAgAAAAAAADAAAAAwAAABwAAQADAAAAHAADAAEAAAAcAAQAOAAAAAoACAACAAIAAQAg8QX//f//AAAAAAAg8QT//f//AAH/4w8AAAMAAQAAAAAAAAAAAAAAAQAB//8ADwABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAAAAAAAAAAAAIAADc5AQAAAAABABr/4wFmAh0AJAAAARQGDwEXHgEVFAYPAQ4BIyImJwEuATU0NjcBPgEzMhYfAR4BFQFmAwLh4QIDAwIdAwcDBAcC/vUCAwMCAQsCBwQDBwMdAgMB7gQHAuHhAgcEAwcDHAMDAwMBCgIIAwMIAgEKAwMDAxwDBgQAAAAAAQAH/+MBVAIdACQAAAEUBgcBDgEjIiYvAS4BNTQ2PwEnLgE1NDY/AT4BMzIWFwEeARUBVAMD/vYDBwMEBwIdAgQEAuHhAgQEAh0CBwQDBwMBCgMDAQADCAL+9gMDAwMcAwYEBAcC4eECBwQDBwMcAwMDA/72AggDAAAAAAEAAAABAACGI2OdXw889QALBAAAAAAA2CPvYwAAAADYI+9jAAD/4wFmAh0AAAAIAAIAAAAAAAAAAQAAAzP/NAAABAAAAAAAAWYAAQAAAAAAAAAAAAAAAAAAAAYEAAAAAAAAAAAAAAAAAAAAAYAAGgFbAAcAAAAAAAoAFAAeAFwAmgAAAAEAAAAGACUAAQAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAOAK4AAQAAAAAAAQAIAAAAAQAAAAAAAgAHAGkAAQAAAAAAAwAIADkAAQAAAAAABAAIAH4AAQAAAAAABQALABgAAQAAAAAABgAIAFEAAQAAAAAACgAaAJYAAwABBAkAAQAQAAgAAwABBAkAAgAOAHAAAwABBAkAAwAQAEEAAwABBAkABAAQAIYAAwABBAkABQAWACMAAwABBAkABgAQAFkAAwABBAkACgA0ALBjYWxlbmRhcgBjAGEAbABlAG4AZABhAHJWZXJzaW9uIDEuMABWAGUAcgBzAGkAbwBuACAAMQAuADBjYWxlbmRhcgBjAGEAbABlAG4AZABhAHJjYWxlbmRhcgBjAGEAbABlAG4AZABhAHJSZWd1bGFyAFIAZQBnAHUAbABhAHJjYWxlbmRhcgBjAGEAbABlAG4AZABhAHJGb250IGdlbmVyYXRlZCBieSBJY29Nb29uLgBGAG8AbgB0ACAAZwBlAG4AZQByAGEAdABlAGQAIABiAHkAIABJAGMAbwBNAG8AbwBuAC4AAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA#iefix) format(\"embedded-opentype\"),url(data:font/ttf;base64,AAEAAAALAIAAAwAwT1MvMg+dCoQAAAC8AAAAYGNtYXAPUuKQAAABHAAAAFRnYXNwAAAAEAAAAXAAAAAIZ2x5ZrVRJOYAAAF4AAABNGhlYWQQzSHDAAACrAAAADZoaGVhBJsDOwAAAuQAAAAkaG10eAbbACEAAAMIAAAAGGxvY2EAwgBwAAADIAAAAA5tYXhwAAgAJwAAAzAAAAAgbmFtZWq4IzgAAANQAAABknBvc3QAAwAAAAAE5AAAACAAAwFuAZAABQAAApkCzAAAAI8CmQLMAAAB6wAzAQkAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADxBQMz/zQAzAMzAMwAAAABAAAAAAAAAAAAAAAgAAAAAAADAAAAAwAAABwAAQADAAAAHAADAAEAAAAcAAQAOAAAAAoACAACAAIAAQAg8QX//f//AAAAAAAg8QT//f//AAH/4w8AAAMAAQAAAAAAAAAAAAAAAQAB//8ADwABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAAAAAAAAAAAAIAADc5AQAAAAABABr/4wFmAh0AJAAAARQGDwEXHgEVFAYPAQ4BIyImJwEuATU0NjcBPgEzMhYfAR4BFQFmAwLh4QIDAwIdAwcDBAcC/vUCAwMCAQsCBwQDBwMdAgMB7gQHAuHhAgcEAwcDHAMDAwMBCgIIAwMIAgEKAwMDAxwDBgQAAAAAAQAH/+MBVAIdACQAAAEUBgcBDgEjIiYvAS4BNTQ2PwEnLgE1NDY/AT4BMzIWFwEeARUBVAMD/vYDBwMEBwIdAgQEAuHhAgQEAh0CBwQDBwMBCgMDAQADCAL+9gMDAwMcAwYEBAcC4eECBwQDBwMcAwMDA/72AggDAAAAAAEAAAABAACGI2OdXw889QALBAAAAAAA2CPvYwAAAADYI+9jAAD/4wFmAh0AAAAIAAIAAAAAAAAAAQAAAzP/NAAABAAAAAAAAWYAAQAAAAAAAAAAAAAAAAAAAAYEAAAAAAAAAAAAAAAAAAAAAYAAGgFbAAcAAAAAAAoAFAAeAFwAmgAAAAEAAAAGACUAAQAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAOAK4AAQAAAAAAAQAIAAAAAQAAAAAAAgAHAGkAAQAAAAAAAwAIADkAAQAAAAAABAAIAH4AAQAAAAAABQALABgAAQAAAAAABgAIAFEAAQAAAAAACgAaAJYAAwABBAkAAQAQAAgAAwABBAkAAgAOAHAAAwABBAkAAwAQAEEAAwABBAkABAAQAIYAAwABBAkABQAWACMAAwABBAkABgAQAFkAAwABBAkACgA0ALBjYWxlbmRhcgBjAGEAbABlAG4AZABhAHJWZXJzaW9uIDEuMABWAGUAcgBzAGkAbwBuACAAMQAuADBjYWxlbmRhcgBjAGEAbABlAG4AZABhAHJjYWxlbmRhcgBjAGEAbABlAG4AZABhAHJSZWd1bGFyAFIAZQBnAHUAbABhAHJjYWxlbmRhcgBjAGEAbABlAG4AZABhAHJGb250IGdlbmVyYXRlZCBieSBJY29Nb29uLgBGAG8AbgB0ACAAZwBlAG4AZQByAGEAdABlAGQAIABiAHkAIABJAGMAbwBNAG8AbwBuAC4AAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA) format(\"truetype\"),url(data:font/woff;base64,d09GRgABAAAAAAVQAAsAAAAABQQAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABPUy8yAAABCAAAAGAAAABgD50KhGNtYXAAAAFoAAAAVAAAAFQPUuKQZ2FzcAAAAbwAAAAIAAAACAAAABBnbHlmAAABxAAAATQAAAE0tVEk5mhlYWQAAAL4AAAANgAAADYQzSHDaGhlYQAAAzAAAAAkAAAAJASbAztobXR4AAADVAAAABgAAAAYBtsAIWxvY2EAAANsAAAADgAAAA4AwgBwbWF4cAAAA3wAAAAgAAAAIAAIACduYW1lAAADnAAAAZIAAAGSargjOHBvc3QAAAUwAAAAIAAAACAAAwAAAAMBbgGQAAUAAAKZAswAAACPApkCzAAAAesAMwEJAAAAAAAAAAAAAAAAAAAAARAAAAAAAAAAAAAAAAAAAAAAQAAA8QUDM/80AMwDMwDMAAAAAQAAAAAAAAAAAAAAIAAAAAAAAwAAAAMAAAAcAAEAAwAAABwAAwABAAAAHAAEADgAAAAKAAgAAgACAAEAIPEF//3//wAAAAAAIPEE//3//wAB/+MPAAADAAEAAAAAAAAAAAAAAAEAAf//AA8AAQAAAAAAAAAAAAIAADc5AQAAAAABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAa/+MBZgIdACQAAAEUBg8BFx4BFRQGDwEOASMiJicBLgE1NDY3AT4BMzIWHwEeARUBZgMC4eECAwMCHQMHAwQHAv71AgMDAgELAgcEAwcDHQIDAe4EBwLh4QIHBAMHAxwDAwMDAQoCCAMDCAIBCgMDAwMcAwYEAAAAAAEAB//jAVQCHQAkAAABFAYHAQ4BIyImLwEuATU0Nj8BJy4BNTQ2PwE+ATMyFhcBHgEVAVQDA/72AwcDBAcCHQIEBALh4QIEBAIdAgcEAwcDAQoDAwEAAwgC/vYDAwMDHAMGBAQHAuHhAgcEAwcDHAMDAwP+9gIIAwAAAAABAAAAAQAAhiNjnV8PPPUACwQAAAAAANgj72MAAAAA2CPvYwAA/+MBZgIdAAAACAACAAAAAAAAAAEAAAMz/zQAAAQAAAAAAAFmAAEAAAAAAAAAAAAAAAAAAAAGBAAAAAAAAAAAAAAAAAAAAAGAABoBWwAHAAAAAAAKABQAHgBcAJoAAAABAAAABgAlAAEAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAAADgCuAAEAAAAAAAEACAAAAAEAAAAAAAIABwBpAAEAAAAAAAMACAA5AAEAAAAAAAQACAB+AAEAAAAAAAUACwAYAAEAAAAAAAYACABRAAEAAAAAAAoAGgCWAAMAAQQJAAEAEAAIAAMAAQQJAAIADgBwAAMAAQQJAAMAEABBAAMAAQQJAAQAEACGAAMAAQQJAAUAFgAjAAMAAQQJAAYAEABZAAMAAQQJAAoANACwY2FsZW5kYXIAYwBhAGwAZQBuAGQAYQByVmVyc2lvbiAxLjAAVgBlAHIAcwBpAG8AbgAgADEALgAwY2FsZW5kYXIAYwBhAGwAZQBuAGQAYQByY2FsZW5kYXIAYwBhAGwAZQBuAGQAYQByUmVndWxhcgBSAGUAZwB1AGwAYQByY2FsZW5kYXIAYwBhAGwAZQBuAGQAYQByRm9udCBnZW5lcmF0ZWQgYnkgSWNvTW9vbi4ARgBvAG4AdAAgAGcAZQBuAGUAcgBhAHQAZQBkACAAYgB5ACAASQBjAG8ATQBvAG8AbgAuAAAAAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==) format(\"woff\"),url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiID4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8bWV0YWRhdGE+R2VuZXJhdGVkIGJ5IEljb01vb248L21ldGFkYXRhPgo8ZGVmcz4KPGZvbnQgaWQ9ImNhbGVuZGFyIiBob3Jpei1hZHYteD0iMTAyNCI+Cjxmb250LWZhY2UgdW5pdHMtcGVyLWVtPSIxMDI0IiBhc2NlbnQ9IjgxOS4yIiBkZXNjZW50PSItMjA0LjgiIC8+CjxtaXNzaW5nLWdseXBoIGhvcml6LWFkdi14PSIxMDI0IiAvPgo8Z2x5cGggdW5pY29kZT0iJiN4MjA7IiBob3Jpei1hZHYteD0iMCIgZD0iIiAvPgo8Z2x5cGggdW5pY29kZT0iJiN4ZjEwNDsiIGdseXBoLW5hbWU9ImFuZ2xlLWxlZnQiIGhvcml6LWFkdi14PSIzODQiIGQ9Ik0zNTguMjg2IDQ5My43MTRjMC00LjU3MS0yLjI4Ni05LjcxNC01LjcxNC0xMy4xNDNsLTIyNC41NzEtMjI0LjU3MSAyMjQuNTcxLTIyNC41NzFjMy40MjktMy40MjkgNS43MTQtOC41NzEgNS43MTQtMTMuMTQzcy0yLjI4Ni05LjcxNC01LjcxNC0xMy4xNDNsLTI4LjU3MS0yOC41NzFjLTMuNDI5LTMuNDI5LTguNTcxLTUuNzE0LTEzLjE0My01LjcxNHMtOS43MTQgMi4yODYtMTMuMTQzIDUuNzE0bC0yNjYuMjg2IDI2Ni4yODZjLTMuNDI5IDMuNDI5LTUuNzE0IDguNTcxLTUuNzE0IDEzLjE0M3MyLjI4NiA5LjcxNCA1LjcxNCAxMy4xNDNsMjY2LjI4NiAyNjYuMjg2YzMuNDI5IDMuNDI5IDguNTcxIDUuNzE0IDEzLjE0MyA1LjcxNHM5LjcxNC0yLjI4NiAxMy4xNDMtNS43MTRsMjguNTcxLTI4LjU3MWMzLjQyOS0zLjQyOSA1LjcxNC04IDUuNzE0LTEzLjE0M3oiIC8+CjxnbHlwaCB1bmljb2RlPSImI3hmMTA1OyIgZ2x5cGgtbmFtZT0iYW5nbGUtcmlnaHQiIGhvcml6LWFkdi14PSIzNDciIGQ9Ik0zNDAgMjU2YzAtNC41NzEtMi4yODYtOS43MTQtNS43MTQtMTMuMTQzbC0yNjYuMjg2LTI2Ni4yODZjLTMuNDI5LTMuNDI5LTguNTcxLTUuNzE0LTEzLjE0My01LjcxNHMtOS43MTQgMi4yODYtMTMuMTQzIDUuNzE0bC0yOC41NzEgMjguNTcxYy0zLjQyOSAzLjQyOS01LjcxNCA4LTUuNzE0IDEzLjE0MyAwIDQuNTcxIDIuMjg2IDkuNzE0IDUuNzE0IDEzLjE0M2wyMjQuNTcxIDIyNC41NzEtMjI0LjU3MSAyMjQuNTcxYy0zLjQyOSAzLjQyOS01LjcxNCA4LjU3MS01LjcxNCAxMy4xNDNzMi4yODYgOS43MTQgNS43MTQgMTMuMTQzbDI4LjU3MSAyOC41NzFjMy40MjkgMy40MjkgOC41NzEgNS43MTQgMTMuMTQzIDUuNzE0czkuNzE0LTIuMjg2IDEzLjE0My01LjcxNGwyNjYuMjg2LTI2Ni4yODZjMy40MjktMy40MjkgNS43MTQtOC41NzEgNS43MTQtMTMuMTQzeiIgLz4KPC9mb250PjwvZGVmcz48L3N2Zz4=#calendar) format(\"svg\");font-weight:400;font-style:normal}[class*=\" calendaricon-\"],[class^=calendaricon-]{font-family:calendar!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.calendaricon-angle-left:before{content:\"\\F104\"}.calendaricon-angle-right:before{content:\"\\F105\"}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1F = undefined;
/* module identifier */

const __vue_module_identifier__$1F = undefined;
/* functional template */

const __vue_is_functional_template__$1F = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1F,
  staticRenderFns: __vue_staticRenderFns__$1F
}, __vue_inject_styles__$1F, __vue_script__$1F, __vue_scope_id__$1F, __vue_is_functional_template__$1F, __vue_module_identifier__$1F, false, createInjector, undefined, undefined);

//
var script$1E = {
  name: "DatePicker",
  components: {
    Calendar: __vue_component__$1F
  },
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    hasInput: {
      type: Boolean,
      default: true
    },
    onClick: {
      type: Function,

      default() {
        return () => {};
      }

    },
    value: {
      type: Date,
      default: new Date()
    }
  },
  data: function () {
    return {
      disabled: [],
      format: "yyyy/MM/dd",
      clear: true
    };
  },

  created() {//window.VueCalendarLang = () => {return CALENDAR_LANG;};
  }

};

/* script */
const __vue_script__$1E = script$1E;
/* template */

var __vue_render__$1E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('Calendar', {
    attrs: {
      "value": _vm.value,
      "disabled-days-of-week": _vm.disabled,
      "format": _vm.format,
      "clear-button": _vm.clear,
      "placeholder": _vm.placeholder,
      "firstDayOfWeek": 1,
      "hasInput": _vm.hasInput,
      "onDayClick": _vm.onClick
    }
  });
};

var __vue_staticRenderFns__$1E = [];
/* style */

const __vue_inject_styles__$1E = function (inject) {
  if (!inject) return;
  inject("data-v-4dc37cb4_0", {
    source: ".datepicker-body p{cursor:pointer}.datepicker-popup{border:none;border-radius:0;box-shadow:none;min-width:0!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1E = undefined;
/* module identifier */

const __vue_module_identifier__$1E = undefined;
/* functional template */

const __vue_is_functional_template__$1E = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1E,
  staticRenderFns: __vue_staticRenderFns__$1E
}, __vue_inject_styles__$1E, __vue_script__$1E, __vue_scope_id__$1E, __vue_is_functional_template__$1E, __vue_module_identifier__$1E, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$1D = {
  name: "IconDate"
};

/* script */
const __vue_script__$1D = script$1D;
/* template */

var __vue_render__$1D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "width": "17",
      "height": "14",
      "viewBox": "0 0 17 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 0V2",
      "stroke": "#292F36",
      "stroke-opacity": "0.4",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5 0V2",
      "stroke": "#292F36",
      "stroke-opacity": "0.4",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('mask', {
    attrs: {
      "id": "path-3-inside-1",
      "fill": "white"
    }
  }, [_c('rect', {
    attrs: {
      "y": "2",
      "width": "17",
      "height": "12",
      "rx": "1"
    }
  })]), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "2",
      "width": "17",
      "height": "12",
      "rx": "1",
      "stroke": "#292F36",
      "stroke-opacity": "0.4",
      "stroke-width": "4",
      "mask": "url(#path-3-inside-1)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2 6.5L15 6.5",
      "stroke": "#292F36",
      "stroke-opacity": "0.4"
    }
  })]);
};

var __vue_staticRenderFns__$1D = [];
/* style */

const __vue_inject_styles__$1D = undefined;
/* scoped */

const __vue_scope_id__$1D = undefined;
/* module identifier */

const __vue_module_identifier__$1D = undefined;
/* functional template */

const __vue_is_functional_template__$1D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1D,
  staticRenderFns: __vue_staticRenderFns__$1D
}, __vue_inject_styles__$1D, __vue_script__$1D, __vue_scope_id__$1D, __vue_is_functional_template__$1D, __vue_module_identifier__$1D, false, undefined, undefined, undefined);

var script$1C = {
  name: "DateInput",
  components: {
    "icon-date": __vue_component__$1D
  },
  props: {
    tabindex: Number,
    value: Date,
    classField: String,
    placeholder: String,
    format: null
  },

  data() {
    return {
      dateString: null,
      isValid: true,
      lastValidValue: null
    };
  },

  computed: {
    listeners() {
      return { ...this.$listeners,
        input: dateString => this.handleInput(dateString)
      };
    }

  },
  watch: {
    value() {
      if (document.activeElement !== this.$refs.input) {
        this.normalize();
      }
    }

  },

  created() {
    this.normalize();
  },

  methods: {
    handleFocus() {
      this.lastValidValue = this.value;
    },

    handleInput(e) {
      const dateString = e.target.value;
      this.dateString = dateString;
      const parseResult = dateParse(dateString);
      this.isValid = parseResult.isValid;

      if (this.isValid) {
        this.lastValidValue = parseResult.dateValue;
      }

      this.$emit("input", parseResult.dateValue);
    },

    handleBlur() {
      if (!this.isValid) {
        this.$emit("input", this.lastValidValue);
      } else {
        this.normalize();
      }

      setTimeout(() => this.$emit("customBlur"), 100);
    },

    normalize() {
      this.dateString = this.value && dateFormat$1(this.value, this.format) || "";
    },

    focus() {
      this.$refs.input.focus();
    },

    blur() {
      this.$refs.input.blur();
    }

  }
};

/* script */
const __vue_script__$1C = script$1C;
/* template */

var __vue_render__$1C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.$style.box
  }, [_c('input', _vm._g({
    ref: "input",
    class: [_vm.$style.dateValue, _vm.classField],
    attrs: {
      "tabindex": _vm.tabindex,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.dateString
    },
    on: {
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur
    }
  }, _vm.listeners)), _vm._v(" "), _c('div', {
    class: _vm.$style.iconBox,
    on: {
      "click": _vm.focus
    }
  }, [_c('icon-date', {
    class: _vm.$style.icon
  })], 1)]);
};

var __vue_staticRenderFns__$1C = [];
/* style */

const __vue_inject_styles__$1C = function (inject) {
  if (!inject) return;
  inject("data-v-549d3c42_0", {
    source: ".src-components-Calendar-box-3QFo{position:relative}.src-components-Calendar-iconBox-H2th{position:absolute;top:0;bottom:0;right:8px;display:flex;align-items:center}.src-components-Calendar-icon-28Hb{cursor:pointer}.src-components-Calendar-dateValue-2W4C{box-sizing:border-box;border-radius:4px!important;border:.75px solid #6e7c8d;height:32px;width:100%;padding:0 30px 0 6px;font-size:16px;font-family:\"IBM Plex Sans\",Avenir,Helvetica,Arial,sans-serif;outline:0!important}.src-components-Calendar-dateValue-2W4C:focus{border:1.5px solid #6e7c8d}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-Calendar-box-3QFo",
      "iconBox": "src-components-Calendar-iconBox-H2th",
      "icon": "src-components-Calendar-icon-28Hb",
      "dateValue": "src-components-Calendar-dateValue-2W4C"
    }
  });
};
/* scoped */


const __vue_scope_id__$1C = undefined;
/* module identifier */

const __vue_module_identifier__$1C = undefined;
/* functional template */

const __vue_is_functional_template__$1C = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1C,
  staticRenderFns: __vue_staticRenderFns__$1C
}, __vue_inject_styles__$1C, __vue_script__$1C, __vue_scope_id__$1C, __vue_is_functional_template__$1C, __vue_module_identifier__$1C, false, createInjector, undefined, undefined);

var script$1B = {
  name: "Calendar",
  components: {
    DatePickerBase: __vue_component__$1E,
    DateInput: __vue_component__$1C
  },
  props: {
    tabindex: Number,
    classField: String,
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: Date,
      default: null
    },
    enableTime: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      visible: false,
      calendarInput: false,
      dateSelected: null,
      dateSelectedText: "",
      lastValidValue: null,
      isValid: true,
      format: this.enableTime ? "dd.mm.yyyy hh:MM" : "dd.mm.yyyy"
    };
  },
  computed: {
    listeners() {
      return { ...this.$listeners,
        input: dateSelectedText => this.handleInput(dateSelectedText)
      };
    }

  },
  watch: {
    value() {
      if (document.activeElement !== this.$refs.input) {
        this.normalize();
      }
    }

  },

  mounted() {
    document.addEventListener("click", this.tryClose);
    document.addEventListener("keyup", this.tryClose);
    this.normalize();
  },

  methods: {
    async onClick() {
      this.dateSelected = this.value || new Date();
      this.visible = !this.visible;
    },

    async onDaySelect(date) {
      this.visible = false;
      this.$emit("input", this.initDate(date));
    },

    async todayClick() {
      this.visible = false;
      let date = new Date(); //date.setHours(0, 0, 0, 0);

      this.$emit("input", this.initDate(date));
    },

    initDate(date) {
      this.dateSelected = date;
      this.dateSelectedText = date && dateFormat$1(date, this.format) || "";
      return date;
    },

    tryClose(e) {
      let el = e.target;

      while (el) {
        if (el === this.$el) {
          return;
        }

        el = el.parentElement;
      }

      this.visible = false;
    },

    normalize() {
      this.dateSelectedText = this.value && dateFormat$1(this.value, this.format) || "";
    },

    handleInput(value) {
      if (value) {
        this.dateSelected = value;
      }

      this.$emit("input", value);
    },

    handleEscape() {
      this.visible = false;
      this.$refs.dateInput.blur();
    }

  }
};

/* script */
const __vue_script__$1B = script$1B;
/* template */

var __vue_render__$1B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.$style.box
  }, [_c('div', {
    on: {
      "click": _vm.onClick
    }
  }, [_c('DateInput', {
    ref: "dateInput",
    attrs: {
      "tabindex": _vm.tabindex,
      "value": _vm.value,
      "classField": _vm.classField,
      "placeholder": _vm.placeholder,
      "format": _vm.format
    },
    on: {
      "input": _vm.handleInput,
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
          return null;
        }

        return _vm.handleEscape($event);
      }
    }
  })], 1), _vm._v(" "), _vm.visible ? _c('div', {
    class: _vm.$style.calendarBox
  }, [_c('DatePickerBase', {
    class: _vm.$style.calendar,
    attrs: {
      "value": _vm.dateSelected,
      "onClick": _vm.onDaySelect,
      "hasInput": _vm.calendarInput
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.$style.footer
  }, [_c('a', {
    class: _vm.$style.todayBtn,
    on: {
      "click": _vm.todayClick
    }
  }, [_vm._v("сегодня")])])], 1) : _vm._e()]);
};

var __vue_staticRenderFns__$1B = [];
/* style */

const __vue_inject_styles__$1B = function (inject) {
  if (!inject) return;
  inject("data-v-0b86324c_0", {
    source: ".src-components-Calendar-box-1k92{position:relative}.src-components-Calendar-box-1k92 .src-components-Calendar-icon-2niv{position:absolute;bottom:10px;right:8px;cursor:pointer}.src-components-Calendar-box-1k92 .src-components-Calendar-input-olJl{padding:0 30px 0 6px;box-sizing:border-box}.src-components-Calendar-box-1k92 .src-components-Calendar-calendarBox-HJxf{position:absolute;z-index:100;box-sizing:border-box;width:230px;height:286px;border:1px solid #202020;border-radius:8px!important;background:#fff;padding:0 4px;margin-top:4px}.src-components-Calendar-box-1k92 .src-components-Calendar-calendar-bljf{position:absolute;top:0;opacity:1;font-family:\"IBM Plex Sans\",Avenir,Helvetica,Arial,sans-serif;font-display:swap;font-size:16px}.src-components-Calendar-box-1k92 .src-components-Calendar-footer-3FF8{position:absolute;bottom:0;left:0;right:0;text-align:center;line-height:30px;margin-bottom:4px}.src-components-Calendar-box-1k92 .src-components-Calendar-todayBtn-zR78{display:inline-block;padding:0 8px;color:#bbb;cursor:pointer;border-radius:4px!important}.src-components-Calendar-box-1k92 .src-components-Calendar-todayBtn-zR78:hover{background:#eee;color:#bbb;text-decoration:none}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-Calendar-box-1k92",
      "icon": "src-components-Calendar-icon-2niv",
      "input": "src-components-Calendar-input-olJl",
      "calendarBox": "src-components-Calendar-calendarBox-HJxf",
      "calendar": "src-components-Calendar-calendar-bljf",
      "footer": "src-components-Calendar-footer-3FF8",
      "todayBtn": "src-components-Calendar-todayBtn-zR78"
    }
  });
};
/* scoped */


const __vue_scope_id__$1B = undefined;
/* module identifier */

const __vue_module_identifier__$1B = undefined;
/* functional template */

const __vue_is_functional_template__$1B = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1B,
  staticRenderFns: __vue_staticRenderFns__$1B
}, __vue_inject_styles__$1B, __vue_script__$1B, __vue_scope_id__$1B, __vue_is_functional_template__$1B, __vue_module_identifier__$1B, false, createInjector, undefined, undefined);

var script$1A = Vue.extend({
  name: "modal-workboard",
  components: {},
  props: {
    maxWidth: Number
  }
});

/* script */
const __vue_script__$1A = script$1A;
/* template */

var __vue_render__$1A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.$style.modalWorkboard
  }, [_c('div', {
    class: _vm.$style.modalWorkboardWrapper
  }, [_c('div', {
    class: _vm.$style.modalWorkboardContent,
    style: "max-width:" + _vm.maxWidth + "px"
  }, [_c('span', {
    class: _vm.$style.modalWorkboardClose,
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._t("default")], 2)])]);
};

var __vue_staticRenderFns__$1A = [];
/* style */

const __vue_inject_styles__$1A = function (inject) {
  if (!inject) return;
  inject("data-v-61bb4288_0", {
    source: "body{margin:0}.src-components-modal-workboard-zqnd{display:block;width:100%;height:100%;position:fixed;z-index:90800;background-color:rgba(255,255,255,.25);font-family:\"IBM Plex Sans\",sans-serif;overflow:auto;top:0;left:0}.src-components-modal-workboard__content-2og0{position:relative;padding:8px 12px;max-width:90%;margin:0 auto;margin-top:10vh;background-color:#fff;border-radius:8px!important;border-bottom-right-radius:40px!important;box-shadow:-3px 0 10px rgba(0,0,0,.15),0 4px 4px rgba(0,0,0,.15)}.src-components-modal-workboard__close-18wG{position:absolute;top:0;right:8px;color:#aaa;font-size:28px!important;cursor:pointer;z-index:2120}.src-components-modal-workboard__close-18wG:focus,.src-components-modal-workboard__close-18wG:hover{color:#555;text-decoration:none}.src-components-modalStock-3OLk{display:flex;position:fixed;z-index:90800;left:0;top:0;width:100%;min-height:100%;overflow:auto;background-color:rgba(255,255,255,.25);font-family:\"IBM Plex Sans\",sans-serif}.src-components-modalStock__wrapper-XWc8{position:absolute;top:calc(50% - 2.5vh);left:50%;transform:translate(-50%,-50%)}.src-components-modalStock__container-1GgU{min-width:750px;position:relative;width:auto;max-height:calc(100vh - 55px);overflow-y:auto;background:#afafaf;border-radius:8px!important;border-bottom-right-radius:30px!important;padding:0 10px 10px;border:1px solid #888;box-shadow:-4px 0 10px rgba(0,0,0,.25),0 4px 4px rgba(0,0,0,.25)}.src-components-modalStock__body-3L5Y{background:#fff;border-radius:4px!important;padding:25px;border-bottom-right-radius:22px!important}.src-components-modalStock__title-3brN{font-family:\"IBM Plex Sans\",sans-serif;font-weight:100;font-size:28px;color:#fff;margin:0;line-height:24px;vertical-align:top;min-height:2px;margin:11px 0 12px 0}.src-components-modalStock__close-3toQ{position:absolute;top:0;right:8px;color:#202020;font-size:28px!important;cursor:pointer;z-index:2120}.src-components-modalStock__close-3toQ:focus,.src-components-modalStock__close-3toQ:hover{color:#555;text-decoration:none}.src-components-modal-1RZ6{display:flex;position:fixed;z-index:90800;left:0;top:0;width:100%;min-height:100%;overflow:auto;background-color:rgba(255,255,255,.25);font-family:\"IBM Plex Sans\",sans-serif}.src-components-modal__wrapper-1Fmx{position:absolute;top:calc(50% - 2.5vh);left:50%;transform:translate(-50%,-50%)}.src-components-modal__container-35Sb{position:relative;width:auto;max-height:calc(100vh - 55px);overflow-y:auto;background-color:#fff;border-radius:8px!important;border-bottom-right-radius:40px!important;padding:11px 16px 16px;border:1px solid #888;box-shadow:-4px 0 10px rgba(0,0,0,.25),0 4px 4px rgba(0,0,0,.25)}.src-components-modal__close-2A3W{position:absolute;top:0;right:8px;color:#aaa;font-size:28px!important;cursor:pointer;z-index:2120}.src-components-modal__close-2A3W:focus,.src-components-modal__close-2A3W:hover{color:#555;text-decoration:none}.src-components-modal_mid-jNnC .src-components-modal__container-35Sb{max-width:640px}.src-components-modal_sm-3Rlw .src-components-modal__container-35Sb{max-width:515px}.src-components-modal_sm-3Rlw .src-components-modalStock__container-1GgU{min-width:340px;max-width:400px}.src-components-modal_xl-2qI1{padding:0 20px}.src-components-modal_xl-2qI1 .src-components-modal__container-35Sb{max-width:1680px}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "modal-workboard": "src-components-modal-workboard-zqnd",
      "modal-workboard__content": "src-components-modal-workboard__content-2og0",
      "modal-workboard__close": "src-components-modal-workboard__close-18wG",
      "modalStock": "src-components-modalStock-3OLk",
      "modalStock__wrapper": "src-components-modalStock__wrapper-XWc8",
      "modalStock__container": "src-components-modalStock__container-1GgU",
      "modalStock__body": "src-components-modalStock__body-3L5Y",
      "modalStock__title": "src-components-modalStock__title-3brN",
      "modalStock__close": "src-components-modalStock__close-3toQ",
      "modal": "src-components-modal-1RZ6",
      "modal__wrapper": "src-components-modal__wrapper-1Fmx",
      "modal__container": "src-components-modal__container-35Sb",
      "modal__close": "src-components-modal__close-2A3W",
      "modal_mid": "src-components-modal_mid-jNnC",
      "modal_sm": "src-components-modal_sm-3Rlw",
      "modal_xl": "src-components-modal_xl-2qI1"
    }
  });
};
/* scoped */


const __vue_scope_id__$1A = undefined;
/* module identifier */

const __vue_module_identifier__$1A = undefined;
/* functional template */

const __vue_is_functional_template__$1A = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1A,
  staticRenderFns: __vue_staticRenderFns__$1A
}, __vue_inject_styles__$1A, __vue_script__$1A, __vue_scope_id__$1A, __vue_is_functional_template__$1A, __vue_module_identifier__$1A, false, createInjector, undefined, undefined);

var script$1z = {
  name: "file-input",
  components: {
    modalWorkboard: __vue_component__$1A,
    ButtonRed: __vue_component__$1X,
    Modal: __vue_component__$1V
  },
  props: {
    multiple: Boolean
  },

  data() {
    return {
      files: [],
      showError: false,
      invalidFileNames: [],
      extensions: ["7z", "ace", "doc", "docx", "gif", "jpg", "jpeg", "ods", "odt", "pdf", "png", "rar", "rtf", "tif", "txt", "xls", "xlsx", "xps", "zip"]
    };
  },

  methods: {
    processFile(event) {
      const files = Array.from(event.target.files);
      const validatedFiles = this.validateFilesExt(files);
      const component = this;
      const readers = [];
      validatedFiles.valid.forEach((file, i) => {
        readers[i] = new FileReader();
        readers[i].addEventListener("load", event => {
          component.files.push({
            Name: file.name,
            Content: event.target.result.split(",")[1]
          });
          component.$emit("load", component.files);
        }, false);

        if (file) {
          readers[i].readAsDataURL(file);
        }
      });

      if (validatedFiles.invalid.length > 0) {
        this.invalidFileNames = validatedFiles.invalid.map(item => item.name);
        this.showError = true;
      }
    },

    deleteFile(index) {
      this.files.splice(index, 1);
    },

    validateFilesExt(files) {
      const valid = [];
      const invalid = [];

      for (let i = 0; i < files.length; i++) {
        const ext = files[i].name.toLowerCase().match(/\.([^.]+)$/)[1];

        if (this.extensions.indexOf(ext) > -1) {
          valid.push(files[i]);
        } else {
          invalid.push(files[i]);
        }
      }

      return {
        valid,
        invalid
      };
    }

  }
};

/* script */
const __vue_script__$1z = script$1z;
/* template */

var __vue_render__$1z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('label', {
    class: _vm.$style.fileInput
  }, [_c('input', {
    ref: "fileInputControl",
    attrs: {
      "type": "file",
      "multiple": _vm.multiple,
      "accept": ".7z,.ace,.doc,.docx,.gif,.jpg,.jpeg,.ods,.odt,.pdf,.png,.rar,.rtf,.tif,.txt,.xls,.xlsx,.xps,.zip"
    },
    on: {
      "change": _vm.processFile
    }
  })]), _vm._v(" "), _c('Modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showError,
      expression: "showError"
    }],
    attrs: {
      "ownerWidth": "520",
      "ownerDimensionsSizeUnit": "px"
    },
    on: {
      "close": function ($event) {
        _vm.showError = false;
      }
    }
  }, [_c('div', {
    class: _vm.$style.box
  }, [_c('h2', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("Ошибка")]), _vm._v(" "), _c('p', [_vm._v("Следующие файлы имеют неподдерживаемый формат:")]), _vm._v(" "), _c('ul', _vm._l(_vm.invalidFileNames, function (item, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(item))]);
  }), 0), _vm._v(" "), _c('p', [_vm._v("\n        Поддерживаются следующие форматы файлов: 7z, ace, doc, docx, gif, jpg, jpeg, ods, odt, pdf,\n        png, rar, rtf, tif, txt, xls, xlsx, xps, zip.\n      ")]), _vm._v(" "), _c('ButtonRed', {
    attrs: {
      "width": "100px"
    },
    on: {
      "click": function ($event) {
        _vm.showError = false;
      }
    }
  }, [_vm._v("ОК")])], 1)])], 1);
};

var __vue_staticRenderFns__$1z = [];
/* style */

const __vue_inject_styles__$1z = function (inject) {
  if (!inject) return;
  inject("data-v-3f563300_0", {
    source: ".src-components-box-2leq{padding:7px 10px 10px 16px;box-sizing:border-box;max-height:100vh;overflow-y:auto;overflow-x:hidden}.src-components-fileInput-vhnq input{display:block;opacity:0}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-box-2leq",
      "fileInput": "src-components-fileInput-vhnq"
    }
  });
};
/* scoped */


const __vue_scope_id__$1z = undefined;
/* module identifier */

const __vue_module_identifier__$1z = undefined;
/* functional template */

const __vue_is_functional_template__$1z = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1z,
  staticRenderFns: __vue_staticRenderFns__$1z
}, __vue_inject_styles__$1z, __vue_script__$1z, __vue_scope_id__$1z, __vue_is_functional_template__$1z, __vue_module_identifier__$1z, false, createInjector, undefined, undefined);

var script$1y = {
  name: "files",
  components: {
    fileInput: __vue_component__$1z
  },
  props: {
    downloadPath: {
      type: String,
      default: null
    },
    value: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: 'Прикрепить документ'
    },
    preloadFileHandler: Function
  },

  data() {
    return {
      files: []
    };
  },

  watch: {
    value: {
      immediate: true,

      handler(v) {
        this.files = [...v];
      }

    }
  },
  computed: {
    defaultSlotIsEmpty() {
      return !this.$slots.default;
    }

  },
  methods: {
    async setFiles(data) {
      if (data && data.length > 0) {
        let index = data.length - 1;

        if (this.preloadFileHandler) {
          data[index] = await this.preloadFileHandler(data[index]);
        }

        this.files.push(data[index]);
        this.$emit("input", this.files);
      }
    },

    deleteFile(index) {
      this.$refs.fileInput.deleteFile(index);
      this.files = this.files.filter((f, i) => i != index);
      this.$emit("input", this.files);
    },

    handleClick() {
      this.$refs.fileInput.$refs.fileInputControl.click();
    }

  }
};

/* script */
const __vue_script__$1y = script$1y;
/* template */

var __vue_render__$1y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.$style.divfiles
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.defaultSlotIsEmpty,
      expression: "defaultSlotIsEmpty"
    }],
    class: _vm.$style.filesButton,
    attrs: {
      "type": "button"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('file-input', {
    ref: "fileInput",
    attrs: {
      "multiple": true
    },
    on: {
      "load": _vm.setFiles
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.defaultSlotIsEmpty,
      expression: "!defaultSlotIsEmpty"
    }],
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('ul', {
    class: _vm.$style.filesList
  }, _vm._l(_vm.files, function (file, index) {
    return _c('li', {
      key: index
    }, [file.Guid ? _c('span', [_c('a', {
      attrs: {
        "href": "" + _vm.downloadPath + file.Guid
      }
    }, [_vm._v("\n          " + _vm._s(file.Name) + "\n        ")]), _vm._v(" "), _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function ($event) {
          return _vm.deleteFile(index);
        }
      }
    }, [_vm._v("×")])]) : _c('span', [_vm._v("\n        " + _vm._s(file.Name) + "\n        "), _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function ($event) {
          return _vm.deleteFile(index);
        }
      }
    }, [_vm._v("×")])])]);
  }), 0)]);
};

var __vue_staticRenderFns__$1y = [];
/* style */

const __vue_inject_styles__$1y = function (inject) {
  if (!inject) return;
  inject("data-v-2aac0a83_0", {
    source: ".src-components-divfiles-3EN4{margin-bottom:16px}.src-components-divfiles-3EN4 .src-components-filesList-2PKC{padding-left:0;margin:0;margin-top:8px;margin-left:8px}.src-components-divfiles-3EN4 .src-components-filesList-2PKC li{list-style:none}.src-components-divfiles-3EN4 .src-components-filesList-2PKC li button{display:inline-block;margin-left:4px;position:relative;top:2px;background-color:transparent;border:0;font-size:20px;cursor:pointer}.src-components-divfiles-3EN4 .src-components-filesButton-28qe{min-height:32px;padding-left:30px;margin-left:8px;background-color:transparent;border:0;text-align:left;position:relative;overflow:hidden}.src-components-divfiles-3EN4 .src-components-filesButton-28qe span{display:flex;align-items:center;min-height:32px;font-size:16px;margin-left:8px;pointer-events:none}.src-components-divfiles-3EN4 .src-components-filesButton-28qe:before{box-sizing:border-box;display:block;content:\"\";width:32px;height:32px;border:1px #6e7c8d solid;border-radius:4px!important;padding:5px;background-size:80%;background-repeat:no-repeat;background-position:center;position:absolute;left:0;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cdefs/%3E%3Cpath fill='%234d4d4d' d='M446.661 37.298c-49.731-49.731-130.641-49.731-180.372 0L76.378 227.208c-5.861 5.861-5.861 15.356 0 21.217 5.861 5.861 15.356 5.861 21.217 0l189.91-189.91c36.865-36.836 101.073-36.836 137.938 0 38.023 38.023 38.023 99.901 0 137.924l-265.184 268.17c-22.682 22.682-62.2 22.682-84.881 0-23.4-23.4-23.4-61.467 0-84.867l254.576-257.577c8.498-8.498 23.326-8.498 31.825 0 8.776 8.776 8.776 23.063 0 31.84L117.826 400.958c-5.06 5.06-5.06 16.156 0 21.217 5.861 5.861 15.356 5.861 21.217 0l243.952-246.954c20.485-20.485 20.485-53.789 0-74.273-19.839-19.839-54.449-19.81-74.258 0L54.161 358.524c-34.826 34.826-34.826 92.474 0 127.301C71.173 502.837 93.781 512 117.825 512s46.654-9.163 63.651-26.174L446.66 217.655c49.731-49.731 49.731-130.627.001-180.357z'/%3E%3C/svg%3E\")}.src-components-divfiles-3EN4 label{height:32px;position:absolute;left:0;top:0}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "divfiles": "src-components-divfiles-3EN4",
      "filesList": "src-components-filesList-2PKC",
      "filesButton": "src-components-filesButton-28qe"
    }
  });
};
/* scoped */


const __vue_scope_id__$1y = undefined;
/* module identifier */

const __vue_module_identifier__$1y = undefined;
/* functional template */

const __vue_is_functional_template__$1y = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1y,
  staticRenderFns: __vue_staticRenderFns__$1y
}, __vue_inject_styles__$1y, __vue_script__$1y, __vue_scope_id__$1y, __vue_is_functional_template__$1y, __vue_module_identifier__$1y, false, createInjector, undefined, undefined);

var css_248z$7 = ".style-module_spinner__2MTw4 {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.9);\n  border-radius: 3px !important;\n}\n.style-module_spinner__2MTw4 > div {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}";
var style$5 = {"spinner":"style-module_spinner__2MTw4"};
styleInject(css_248z$7);

//
//
//
//
//
//
//
//
var script$1x = {
  name: 'PulseLoader',
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },

  data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        width: this.size,
        height: this.size,
        margin: this.margin,
        borderRadius: this.radius,
        display: 'inline-block',
        animationName: 'v-pulseStretchDelay',
        animationDuration: '0.75s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'cubic-bezier(.2,.68,.18,1.08)',
        animationFillMode: 'both'
      },
      spinnerDelay1: {
        animationDelay: '0.12s'
      },
      spinnerDelay2: {
        animationDelay: '0.24s'
      },
      spinnerDelay3: {
        animationDelay: '0.36s'
      }
    };
  }

};

/* script */
const __vue_script__$1x = script$1x;
/* template */

var __vue_render__$1x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-pulse v-pulse1",
    style: [_vm.spinnerStyle, _vm.spinnerDelay1]
  }), _vm._v(" "), _c('div', {
    staticClass: "v-pulse v-pulse2",
    style: [_vm.spinnerStyle, _vm.spinnerDelay2]
  }), _vm._v(" "), _c('div', {
    staticClass: "v-pulse v-pulse3",
    style: [_vm.spinnerStyle, _vm.spinnerDelay3]
  })]);
};

var __vue_staticRenderFns__$1x = [];
/* style */

const __vue_inject_styles__$1x = function (inject) {
  if (!inject) return;
  inject("data-v-ab3dcbba_0", {
    source: "@-webkit-keyframes v-pulseStretchDelay{0%,80%{-webkit-transform:scale(1);transform:scale(1);-webkit-opacity:1;opacity:1}45%{-webkit-transform:scale(.1);transform:scale(.1);-webkit-opacity:.7;opacity:.7}}@keyframes v-pulseStretchDelay{0%,80%{-webkit-transform:scale(1);transform:scale(1);-webkit-opacity:1;opacity:1}45%{-webkit-transform:scale(.1);transform:scale(.1);-webkit-opacity:.7;opacity:.7}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1x = undefined;
/* module identifier */

const __vue_module_identifier__$1x = undefined;
/* functional template */

const __vue_is_functional_template__$1x = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1x,
  staticRenderFns: __vue_staticRenderFns__$1x
}, __vue_inject_styles__$1x, __vue_script__$1x, __vue_scope_id__$1x, __vue_is_functional_template__$1x, __vue_module_identifier__$1x, false, createInjector, undefined, undefined);

//
var script$1w = {
  name: 'spinner',
  components: {
    pulseLoader: __vue_component__$1x
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      style: style$5,
      color: '#cc181e'
    };
  }

};

/* script */
const __vue_script__$1w = script$1w;
/* template */

var __vue_render__$1w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.loading ? _c('div', {
    class: [_vm.style.spinner]
  }, [_c('pulse-loader', {
    attrs: {
      "loading": _vm.loading,
      "color": _vm.color
    }
  })], 1) : _vm._e();
};

var __vue_staticRenderFns__$1w = [];
/* style */

const __vue_inject_styles__$1w = undefined;
/* scoped */

const __vue_scope_id__$1w = undefined;
/* module identifier */

const __vue_module_identifier__$1w = undefined;
/* functional template */

const __vue_is_functional_template__$1w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1w,
  staticRenderFns: __vue_staticRenderFns__$1w
}, __vue_inject_styles__$1w, __vue_script__$1w, __vue_scope_id__$1w, __vue_is_functional_template__$1w, __vue_module_identifier__$1w, false, undefined, undefined, undefined);

var css_248z$6 = "@charset \"UTF-8\";\n.dadata_suggestions-nowrap__3m_gy {\n  white-space: nowrap;\n}\n\n/**\n * Основной INPUT\n */\n.dadata_suggestions-input__3cM0S {\n  -ms-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  width: 100%;\n}\n.dadata_suggestions-input__3cM0S::-ms-clear {\n  display: none;\n}\n\n.dadata_suggestions-wrapper__2R9AV {\n  position: relative;\n  margin: 0;\n  padding: 0;\n  vertical-align: top;\n  -webkit-text-size-adjust: 100%;\n}\n\n/**\n * Выпадающий блок с найденными подсказками\n */\n.dadata_suggestions-suggestions__3NbMe {\n  background: #fff;\n  border: 1px solid #999;\n  -ms-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  cursor: default;\n  left: 0;\n  min-width: 100%;\n  position: absolute;\n  z-index: 9999;\n  -webkit-text-size-adjust: 100%;\n}\n.dadata_suggestions-suggestions__3NbMe strong {\n  font-weight: normal;\n  color: #3399ff;\n}\n.dadata_suggestions-suggestions__3NbMe.dadata_suggestions-mobile__B3f9M {\n  border-style: none;\n}\n.dadata_suggestions-suggestions__3NbMe.dadata_suggestions-mobile__B3f9M .dadata_suggestions-suggestion__1AyXA {\n  border-bottom: 1px solid #ddd;\n}\n\n/**\n * Контейнер для одной подсказки\n */\n.dadata_suggestions-suggestion__1AyXA {\n  padding: 4px 4px;\n  overflow: hidden;\n}\n.dadata_suggestions-suggestion__1AyXA:hover {\n  background: #f7f7f7;\n}\n\n/**\n * Выбранная (активная) подсказка\n */\n.dadata_suggestions-selected__UDx4u {\n  background: #f0f0f0;\n}\n.dadata_suggestions-selected__UDx4u:hover {\n  background: #f0f0f0;\n}\n\n/**\n * Информационный блок в верхней части выпадашки с подсказками\n */\n.dadata_suggestions-hint__1bROA {\n  padding: 4px 4px;\n  white-space: nowrap;\n  overflow: hidden;\n  color: #777;\n  font-size: 85%;\n  line-height: 20px;\n}\n\n/**\n * Дополнительный текст в подсказке, который идет второй строкой\n */\n.dadata_suggestions-subtext__1iZXE {\n  color: #777;\n}\n\n/**\n * Размещает дополнительный текст в одну строку с основным текстом подсказки\n */\n.dadata_suggestions-subtext_inline__ZnXnR {\n  display: inline-block;\n  min-width: 6em;\n  vertical-align: bottom;\n  margin: 0 0.5em 0 0;\n}\n\n/**\n * Разделитель нескольких дополнительных текстов\n */\n.dadata_suggestions-subtext-delimiter__2ctRL {\n  display: inline-block;\n  width: 2px;\n}\n\n/**\n * Выделяет подсказку\n */\n.dadata_suggestions-subtext_label__38Q-e {\n  margin: 0 0 0 0.25em;\n  -webkit-border-radius: 3px;\n  -moz-border-radius: 3px;\n  border-radius: 3px;\n  padding: 0 3px;\n  background: #f5f5f5;\n  font-size: 85%;\n}\n\n.dadata_suggestions-value__17xmO[data-suggestion-status=LIQUIDATED] {\n  position: relative;\n}\n.dadata_suggestions-value__17xmO[data-suggestion-status=LIQUIDATED]:after {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 50%;\n  border-top: 1px solid rgba(0, 0, 0, 0.4);\n  content: \"\";\n}\n\n/**\n * Промо-блок\n */\n.dadata_suggestions-promo__399cu {\n  font-size: 85%;\n  display: none;\n  color: #777;\n  padding: 4px;\n  text-align: center;\n}\n.dadata_suggestions-promo__399cu a {\n  color: #777;\n  display: block;\n  filter: grayscale(100%);\n  line-height: 20px;\n  text-decoration: none;\n}\n.dadata_suggestions-promo__399cu a:hover {\n  filter: grayscale(0);\n}\n.dadata_suggestions-promo__399cu svg {\n  height: 20px;\n  vertical-align: bottom;\n}\n\n@media screen and (min-width: 600px) {\n  .dadata_suggestions-promo__399cu {\n    position: absolute;\n    top: 0;\n    right: 0;\n    text-align: left;\n  }\n}";
var dadataStyle = {"suggestions-nowrap":"dadata_suggestions-nowrap__3m_gy","suggestions-input":"dadata_suggestions-input__3cM0S","suggestions-wrapper":"dadata_suggestions-wrapper__2R9AV","suggestions-suggestions":"dadata_suggestions-suggestions__3NbMe","suggestions-mobile":"dadata_suggestions-mobile__B3f9M","suggestions-suggestion":"dadata_suggestions-suggestion__1AyXA","suggestions-selected":"dadata_suggestions-selected__UDx4u","suggestions-hint":"dadata_suggestions-hint__1bROA","suggestions-subtext":"dadata_suggestions-subtext__1iZXE","suggestions-subtext_inline":"dadata_suggestions-subtext_inline__ZnXnR","suggestions-subtext-delimiter":"dadata_suggestions-subtext-delimiter__2ctRL","suggestions-subtext_label":"dadata_suggestions-subtext_label__38Q-e","suggestions-value":"dadata_suggestions-value__17xmO","suggestions-promo":"dadata_suggestions-promo__399cu"};
styleInject(css_248z$6);

var script$1v = {
  name: "ModalEdit1",
  components: {
    Modal: __vue_component__$1V,
    IconAdd: __vue_component__$1U,
    IconCloseSmall: __vue_component__$1R,
    ButtonRed: __vue_component__$1X,
    IconXls: __vue_component__$1S,
    IconPen: __vue_component__$1T,
    TextEditor: __vue_component__$1K,
    RadioGroup: __vue_component__$1G,
    Calendar: __vue_component__$1B,
    ButtonClean: __vue_component__$1P,
    IconClose: __vue_component__$1Q,
    files: __vue_component__$1y,
    spinner: __vue_component__$1w //vueSuggestions

  },
  props: {
    value: Object,
    downloadPath: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    dadataToken: {
      type: String,
      default: "3db6c68e556f692b2d7bcf6219631978513954e3"
    }
  },

  data() {
    return {
      showNameEditor: false,
      trade: {},
      dadataStyle
    };
  },

  watch: {
    value: {
      immediate: true,

      handler(v) {
        this.trade = Object.assign({}, v);
      }

    }
  },
  methods: {
    close() {
      this.$emit("close");
    },

    save() {
      this.$emit("save", this.trade);
    },

    getDadataOptions(type) {
      return {
        token: this.dadataToken,
        type: type
      };
    }

  }
};

/* script */
const __vue_script__$1v = script$1v;
/* template */

var __vue_render__$1v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('Modal', {
    attrs: {
      "ownerWidth": "650",
      "ownerDimensionsSizeUnit": "px",
      "useBuiltInButtons": false,
      "showFooter": true,
      "enableExternalClick": false
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    class: _vm.$style.box
  }, [_c('div', {
    class: [_vm.$style.flex, _vm.$style.mr5],
    staticStyle: {
      "align-items": "baseline"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showNameEditor,
      expression: "!showNameEditor"
    }],
    class: _vm.$style.name,
    staticStyle: {
      "position": "relative"
    }
  }, [_vm._v(_vm._s(_vm.trade.Name))]), _vm._v(" "), _c('TextEditor', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showNameEditor,
      expression: "showNameEditor"
    }],
    staticStyle: {
      "width": "550px"
    },
    on: {
      "blur": function ($event) {
        _vm.showNameEditor = false;
      }
    },
    model: {
      value: _vm.trade.Name,
      callback: function ($$v) {
        _vm.$set(_vm.trade, "Name", $$v);
      },
      expression: "trade.Name"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showNameEditor,
      expression: "!showNameEditor"
    }],
    class: _vm.$style.editIcon,
    on: {
      "click": function ($event) {
        _vm.showNameEditor = true;
      }
    }
  }, [_c('IconPen')], 1)], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.header1,
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_vm._v("Параметры проекта:")]), _vm._v(" "), _c('div', {
    class: [_vm.$style.flex, _vm.$style.mr5],
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "63px",
      "width": "244px",
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._v("Место поставки")]), _vm._v(" "), _c('div', [_c('vue-suggestions', {
    class: _vm.$style.deliveryAddress,
    attrs: {
      "options": _vm.getDadataOptions('ADDRESS'),
      "model": _vm.trade.DeliveryAddress,
      "field-value": "unrestricted_value"
    },
    on: {
      "update:model": function ($event) {
        return _vm.$set(_vm.trade, "DeliveryAddress", $event);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('div', [_vm._v("Дата окончания приема заявок")]), _vm._v(" "), _c('Calendar', {
    staticStyle: {
      "margin-top": "4px",
      "width": "244px"
    },
    attrs: {
      "enable-time": true
    },
    model: {
      value: _vm.trade.ApplicationEndDateInner,
      callback: function ($$v) {
        _vm.$set(_vm.trade, "ApplicationEndDateInner", $$v);
      },
      expression: "trade.ApplicationEndDateInner"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    class: _vm.$style.flex,
    staticStyle: {
      "margin-top": "3px"
    }
  }, [_c('RadioGroup', {
    attrs: {
      "indent": 62,
      "elements": [{
        value: true,
        label: 'Возможен самовывоз'
      }, {
        value: false,
        label: 'Только доставка'
      }]
    },
    model: {
      value: _vm.trade.PickupIsPossible,
      callback: function ($$v) {
        _vm.$set(_vm.trade, "PickupIsPossible", $$v);
      },
      expression: "trade.PickupIsPossible"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.title,
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_vm._v("Условия оплаты")]), _vm._v(" "), _c('div', {
    class: [_vm.$style.flex, _vm.$style.mr5],
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('RadioGroup', {
    attrs: {
      "indent": 52,
      "elements": [{
        value: true,
        label: 'Только постоплата или защита сделки'
      }, {
        value: false,
        label: 'Возможен аванс, предоплата'
      }]
    },
    model: {
      value: _vm.trade.OnlyPostpayment,
      callback: function ($$v) {
        _vm.$set(_vm.trade, "OnlyPostpayment", $$v);
      },
      expression: "trade.OnlyPostpayment"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.multilineTitle,
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_vm._v("Дополнительные требования к договору поставки")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.trade.AdditionalRequirements,
      expression: "trade.AdditionalRequirements"
    }],
    class: _vm.$style.multiline,
    staticStyle: {
      "margin-right": "28px"
    },
    attrs: {
      "placeholder": "Требования к упаковке, сопровождающим документам, гарантиям и прочее"
    },
    domProps: {
      "value": _vm.trade.AdditionalRequirements
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.$set(_vm.trade, "AdditionalRequirements", $event.target.value);
      }
    }
  }), _vm._v(" "), _c('files', {
    attrs: {
      "downloadPath": _vm.downloadPath
    },
    model: {
      value: _vm.trade.ConvertedDocuments,
      callback: function ($$v) {
        _vm.$set(_vm.trade, "ConvertedDocuments", $$v);
      },
      expression: "trade.ConvertedDocuments"
    }
  }), _vm._v(" "), _c('spinner', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.loading,
      expression: "!loading"
    }],
    class: [_vm.$style.flex, _vm.$style.mr5],
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('ButtonRed', {
    attrs: {
      "height": "32px",
      "width": "125px"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Сохранить")]), _vm._v(" "), _c('ButtonClean', {
    attrs: {
      "height": "32px",
      "width": "115px"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('IconClose', {
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v("Отменить")], 1)], 1)], 1)]);
};

var __vue_staticRenderFns__$1v = [];
/* style */

const __vue_inject_styles__$1v = function (inject) {
  if (!inject) return;
  inject("data-v-25d76405_0", {
    source: ".src-components-box-35CX{padding:7px 10px 10px 16px;box-sizing:border-box;max-height:100vh;overflow-y:auto;overflow-x:hidden;margin-right:30px}.src-components-box-35CX::-webkit-scrollbar{width:5px}.src-components-box-35CX::-webkit-scrollbar-track{box-shadow:inset 0 0 5px grey;border-radius:10px;height:90%}.src-components-box-35CX::-webkit-scrollbar-thumb{background:grey;border-radius:10px}.src-components-flex-1We5{display:flex;align-items:center;flex-wrap:wrap;min-width:0}.src-components-mr5-1L53>*{margin-right:5px}.src-components-name-3D6f{font-size:24px;color:#202020}.src-components-title-3c29{font-size:16px;line-height:1.4px}.src-components-header1-2ZA8{font-weight:600;font-size:16px;line-height:1.4;color:#000}.src-components-multilineTitle-2exo{font-size:16px;line-height:1.2;color:#202020;width:100%}.src-components-multiline-1CP5{min-height:117px;height:117px;width:100%;font-size:16px;font-family:\"IBM Plex Sans\",Avenir,Helvetica,Arial,sans-serif;max-width:600px;border-radious:5px}.src-components-editIcon-1Rjs{cursor:pointer}.src-components-deliveryAddress-3CQy{width:100%;box-sizing:border-box;border-radius:4px!important;border:1px solid #6e7c8d;height:32px;padding:0 0 0 6px!important;font-size:16px;font-family:\"IBM Plex Sans\",Avenir,Helvetica,Arial,sans-serif;text-align:left;outline-color:#6e7c8d}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-box-35CX",
      "flex": "src-components-flex-1We5",
      "mr5": "src-components-mr5-1L53",
      "name": "src-components-name-3D6f",
      "title": "src-components-title-3c29",
      "header1": "src-components-header1-2ZA8",
      "multilineTitle": "src-components-multilineTitle-2exo",
      "multiline": "src-components-multiline-1CP5",
      "editIcon": "src-components-editIcon-1Rjs",
      "deliveryAddress": "src-components-deliveryAddress-3CQy"
    }
  });
};
/* scoped */


const __vue_scope_id__$1v = undefined;
/* module identifier */

const __vue_module_identifier__$1v = undefined;
/* functional template */

const __vue_is_functional_template__$1v = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1v,
  staticRenderFns: __vue_staticRenderFns__$1v
}, __vue_inject_styles__$1v, __vue_script__$1v, __vue_scope_id__$1v, __vue_is_functional_template__$1v, __vue_module_identifier__$1v, false, createInjector, undefined, undefined);

var script$1u = {
  name: "IconRemove"
};

/* script */
const __vue_script__$1u = script$1u;
/* template */

var __vue_render__$1u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 18 18",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H14C15.933 0.5 17.5 2.067 17.5 4V14C17.5 15.933 15.933 17.5 14 17.5H4C2.067 17.5 0.5 15.933 0.5 14V4Z",
      "fill": "white",
      "stroke": "#6E7C8D",
      "stroke-linejoin": "bevel"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5 12.9998L13 4.99996",
      "stroke": "#6E7C8D",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5 5.00024L13 13",
      "stroke": "#6E7C8D",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};

var __vue_staticRenderFns__$1u = [];
/* style */

const __vue_inject_styles__$1u = undefined;
/* scoped */

const __vue_scope_id__$1u = undefined;
/* module identifier */

const __vue_module_identifier__$1u = undefined;
/* functional template */

const __vue_is_functional_template__$1u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1u,
  staticRenderFns: __vue_staticRenderFns__$1u
}, __vue_inject_styles__$1u, __vue_script__$1u, __vue_scope_id__$1u, __vue_is_functional_template__$1u, __vue_module_identifier__$1u, false, undefined, undefined, undefined);

var script$1t = {
  name: "NumberInput",
  components: {
    numeric: numeric$1
  },
  props: {
    value: Number
  },
  methods: {
    up() {
      const newValue = this.model + 1;
      this.$emit("input", newValue);
    },

    down() {
      const newValue = this.model - 1;

      if (newValue > 0) {
        this.$emit("input", newValue);
      }
    },

    emitInput(newValue) {
      this.$emit("input", isNaN(newValue) ? null : newValue);
    }

  },
  computed: {
    model: {
      get() {
        return this.value;
      },

      set(value) {
        this.$emit("input", value);
      }

    }
  }
};

/* script */
const __vue_script__$1t = script$1t;
/* template */

var __vue_render__$1t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.$style.numberInput
  }, [_c('numeric', {
    attrs: {
      "value": _vm.model,
      "min": 1,
      "precision": 0,
      "controls": false,
      "size": "100%"
    },
    on: {
      "input": function ($event) {
        return _vm.emitInput($event);
      }
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.$style.numberInputButtons
  }, [_c('div', [_c('button', {
    staticStyle: {
      "margin-bottom": "3px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.up
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.down
    }
  })])])], 1);
};

var __vue_staticRenderFns__$1t = [];
/* style */

const __vue_inject_styles__$1t = function (inject) {
  if (!inject) return;
  inject("data-v-67b42746_0", {
    source: ".src-components-numberInput-GrQ3{display:flex}.src-components-numberInput-GrQ3 input{border:1px solid #6e7c8d!important;-webkit-appearance:none;-moz-appearance:textfield;font-family:\"IBM Plex Sans\",sans-serif;font-size:16px;font-weight:500;border-radius:4px!important;padding:6px;padding-left:8px;outline-color:#6e7c8d;font-weight:400}.src-components-numberInput-GrQ3 input::-webkit-inner-spin-button,.src-components-numberInput-GrQ3 input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.src-components-numberInput__buttons-1Is7{display:flex;flex-direction:column;justify-content:space-between;margin-left:4px;padding:6px 0}.src-components-numberInput-GrQ3 button:first-child{transform:rotate(180deg)}.src-components-numberInput-GrQ3 button{display:block;width:12px;height:7px;background-image:url(\"data:image/svg+xml,%3Csvg width='12' height='7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.101 6.416a2 2 0 01-2.202 0l-3.73-2.46C-.487 2.862.287.285 2.27.285h7.46c1.983 0 2.757 2.577 1.101 3.67l-3.73 2.46z' fill='%23202020'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-position:center;background-color:transparent;border:0;cursor:pointer}.src-components-numberInputButtons-AUf3{display:flex;align-items:center;margin-left:5px}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "numberInput": "src-components-numberInput-GrQ3",
      "numberInput__buttons": "src-components-numberInput__buttons-1Is7",
      "numberInputButtons": "src-components-numberInputButtons-AUf3"
    }
  });
};
/* scoped */


const __vue_scope_id__$1t = undefined;
/* module identifier */

const __vue_module_identifier__$1t = undefined;
/* functional template */

const __vue_is_functional_template__$1t = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1t,
  staticRenderFns: __vue_staticRenderFns__$1t
}, __vue_inject_styles__$1t, __vue_script__$1t, __vue_scope_id__$1t, __vue_is_functional_template__$1t, __vue_module_identifier__$1t, false, createInjector, undefined, undefined);

//'Fz223', 'Fz44', 'Pprf615', 'Commercial'
const organizationLevelsEnum$1 = Object.freeze({
  Fz223: "Fz223",
  Fz44: "Fz44",
  Pprf615: "Pprf615",
  Commercial: "Commercial",
  Small: "Small"
});

function isString$1(x) {
  return typeof x === 'string' || x instanceof String;
}
function isNumber$1(x) {
  return typeof x === 'number' && isFinite(x);
}
function isArray$1(x) {
  return x && typeof x === 'object' && x.constructor === Array;
}
function isFunction(x) {
  return typeof x === 'function';
}
function isObject(x) {
  return x && typeof x === 'object' && x.constructor === Object;
}
function isNull(x) {
  return x === null;
}
function isUndefined(x) {
  return typeof x === 'undefined';
}
function isBoolean(x) {
  return typeof x === 'boolean';
}
function isDate(x) {
  return x instanceof Date;
}

var types = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isString: isString$1,
  isNumber: isNumber$1,
  isArray: isArray$1,
  isFunction: isFunction,
  isObject: isObject,
  isNull: isNull,
  isUndefined: isUndefined,
  isBoolean: isBoolean,
  isDate: isDate
});

function toMoney$1(nStr, range = 2) {
  if (nStr !== 0 && !nStr) return;
  let type = typeof nStr;
  if (type === "string") nStr = nStr.replace(',', '.');
  nStr = parseFloat(nStr).toFixed(range);
  nStr += '';
  let x = nStr.split('.');
  let x1 = x[0];
  let x2 = x.length > 1 && x[1] !== '00' ? ',' + x[1] : '';
  const rgx = /(\d+)(\d{3})/;

  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + '\u00A0' + '$2');
  }

  return x1 + x2;
}
/*
 * Привести к формату с плавающей запятой, например 19,2 или 1,50 или 0,731.
 * @param value Входное значение.
 * @return Отформатированная строка.
 */

function toFloatString(value) {
  if (value == null) {
    return null;
  }

  if (value == parseInt(value)) {
    return toMoney$1(value, 0);
  }

  let valueYText = ''; //3 знака после запятой если 0 целых - 0,154

  /*
  if(value < 1) {
    valueYText =  toMoney(value, 3);
  }
  */
  //2 знака после запятой если однозначное целое - 1,54

  if (value < 10) {
    valueYText = toMoney$1(value, 2);
  } //1 знак после запятой если десятичные - 15,4
  else if (value < 100) {
      valueYText = toMoney$1(value, 1);
    } else {
      valueYText = toMoney$1(value, 0);
    }

  valueYText = valueYText.replace(/(,[0-9]*[1-9])0+$|,0*$/, '$1');
  return valueYText;
}
function dhms(t) {
  let cd = 24 * 60 * 60 * 1000;
  let ch = 60 * 60 * 1000;
  let cm = 60 * 1000;
  let cs = 1000;
  let d = Math.floor(t / cd);
  let h = Math.floor((t - d * cd) / ch);
  let m = Math.floor((t - d * cd - h * ch) / cm);
  let s = Math.round((t - d * cd - h * ch - m * cm) / cs);

  let pad = function (n) {
    return n < 10 ? '0' + n : n;
  };

  if (s === 60) {
    m++;
    s = 0;
  }

  if (m === 60) {
    h++;
    m = 0;
  }

  if (h === 24) {
    d++;
    h = 0;
  }

  if (d <= 0) return `${pad(h)}:${pad(m)}:${pad(s)}`;
  let wordDay = getCorrect(d, 'день', 'дня', 'дней');
  return `${d} ${wordDay} ${pad(h)}:${pad(m)}:${pad(s)}`;
}
function getCorrect(number, ending1, ending2, ending5) {
  if (!ending1) ending1 = '';
  if (!ending2) ending2 = '';
  if (!ending5) ending5 = '';
  if (!number) number = 0;
  if (number === 0) return ending5;
  number = number % 100;
  if (number >= 11 && number <= 19) return ending5;
  let i = number % 10;

  switch (i) {
    case 1:
      return ending1;

    case 2:
    case 3:
    case 4:
      return ending2;

    default:
      return ending5;
  }
}
function to00(number) {
  number = parseInt(number, 10);
  if (number <= 9) return `0${number}`;
  if (number === 0) return `0${number}`;
  if (!number) return '';
  return number.toString();
}
function getOrganizationLevelText(value) {
  switch (value) {
    case 2:
      return '223-ФЗ';

    case 3:
      return 'Коммерческие';

    case 4:
      return '44-ФЗ';

    case 5:
      return '615-ППРФ';

    case 6:
      return 'Закупки малого объема';
  }

  return null;
}
function parseDate(str) {
  let ms = Date.parse(str);
  return !isNaN(ms) && new Date(ms) || null;
}
function addTimeZone(date, tz) {
  let dt = date;
  if (!dt) return null;

  if (dt.includes('T')) {
    if (!dt.includes('Z') && !dt.includes('+')) {
      dt = dt + (tz || 'Z');
    }
  }

  return dt;
}
function isNullFalse(val) {
  if (val == null) {
    return false;
  }

  return val;
}
function convertOrganizationLevels(levels) {
  if (levels && levels.length > 0) {
    let result = [];
    levels.forEach(function (item) {
      switch (item) {
        case organizationLevelsEnum$1.Fz223:
          result.push('223-fz');
          break;

        case organizationLevelsEnum$1.Commercial:
          result.push('Commercial');
          break;

        case organizationLevelsEnum$1.Fz44:
          result.push('44-fz');
          break;

        case organizationLevelsEnum$1.Pprf615:
          result.push('615-pp');
          break;

        case organizationLevelsEnum$1.Small:
          result.push('Small');
          break;

        default:
          result.push(item);
      }
    });
    return result;
  } else {
    return levels;
  }
}
function getArrayFromString(value, separator = ",") {
  if (value === null || value === undefined) return null;
  if (typeof value === 'object' && Array.isArray(value)) return value;
  return value.split(separator);
}
function getIntArrayFromString(value, separator = ",") {
  if (value === null || value === undefined) return null;
  if (typeof value === 'object' && Array.isArray(value)) return value;
  let strings = value.split(separator);
  let result = [];
  strings.forEach(function (item) {
    result.push(item * 1);
  });
  return result;
}
function stringFromArray(value, separator = ",") {
  if (value === null || value === undefined) return null;
  if (typeof value !== 'object' && !Array.isArray(value)) return value;

  if (typeof value === 'object' && Array.isArray(value)) {
    value = value.map(a => {
      if (typeof a === 'object') return a.key;else return a;
    });
  }

  return value.join(separator);
}
function parseKey(a) {
  if (a && a.key && a.key.includes('{')) {
    return JSON.parse(a.key);
  } else {
    return {
      key: a.key
    };
  }
}
function tryParse(str) {
  if (str && str.includes('{')) {
    return JSON.parse(str).key;
  } else {
    return str;
  }
}
function treeToString(vl) {
  if (!vl || vl.length <= 0) return null;
  let str = vl.map(a => `${parseKey(a).key}|${a.parents && a.parents.map(tryParse).join(';') || ''}`).join(',');
  return str;
}
function stringTreeParce(vl) {
  if (!vl) return;
  let itms = vl.split(',').map(a => {
    let keyParents = a.split('|');
    let key = keyParents && keyParents.length > 0 && keyParents[0];
    let parents = keyParents && keyParents.length > 1 && keyParents[1] && keyParents[1].split(';') || null;
    return {
      key,
      parents
    };
  });
  return itms;
}
function pad(val, len) {
  val = String(val);
  len = len || 2;

  while (val.length < len) {
    val = '0' + val;
  }

  return val;
}
function dateFormat(date) {
  if (!(date instanceof Date)) {
    return null;
  }

  const d = pad(date.getDate());
  const m = pad(date.getMonth() + 1);
  const y = pad(date.getFullYear(), 4);
  return `${d}.${m}.${y}`;
}
function dateFormatV2(date) {
  if (!(date instanceof Date)) {
    return null;
  }

  const d = pad(date.getDate());
  const m = pad(date.getMonth() + 1);
  const y = pad(date.getFullYear(), 4);
  return `${y}.${m}.${d}`;
}
function dateTimeFormat(date, {
  withSeconds,
  softSpace
} = {}) {
  if (!(date instanceof Date)) {
    return null;
  }

  const d = pad(date.getDate());
  const m = pad(date.getMonth() + 1);
  const y = pad(date.getFullYear(), 4);
  const H = date.getHours();
  const M = pad(date.getMinutes());
  const sp = softSpace && ' ' || '\xa0';

  if (withSeconds) {
    const S = pad(date.getSeconds());
    return `${d}.${m}.${y}${sp}${H}:${M}:${S}`;
  }

  return `${d}.${m}.${y}${sp}${H}:${M}`;
}
function getDatePart(date) {
  const d = pad(date.getDate());
  const m = pad(date.getMonth() + 1);
  const y = pad(date.getFullYear(), 4);
  return new Date(`${y}-${m}-${d}`);
}
function moneyFormat(sum, {
  hidePenny,
  hideZeroPenny,
  showPlusSign,
  softSpace
} = {}) {
  if (!isNumber$1(sum)) {
    return null;
  }

  if (sum === 0) {
    return hidePenny || hideZeroPenny ? '0' : '0,00';
  }

  const sp = softSpace && ' ' || '\xa0';
  const sign = sum < 0 && '-' || showPlusSign && '+' || '';

  if (sum < 0) {
    sum = -sum;
  }

  const money = Math.floor(sum).toString();
  let a = 0;
  let b = (money.length - 1) % 3 + 1;
  const groups = [];

  while (a < money.length) {
    groups.push(money.substring(a, b));
    a = b;
    b += 3;
  }

  const penny = Math.floor(sum * 100) % 100;

  if (hidePenny || hideZeroPenny && penny > 0) {
    return `${sign}${groups.join(sp)}`;
  }

  return `${sign}${groups.join(sp)},${pad(penny)}`;
}
function currencyCodeToText(code) {
  if (code == 643) return "₽";else if (code == 36) return "AUD";else if (code == 986) return "BRL";else if (code == 933) return "BYN";else if (code == 124) return "CAD";else if (code == 756) return "CHF";else if (code == 156) return "CNY";else if (code == 978) return "EUR";else if (code == 826) return "GBP";else if (code == 348) return "HUF";else if (code == 356) return "INR";else if (code == 392) return "JPY";else if (code == 398) return "KZT";else if (code == 752) return "SEK";else if (code == 702) return "SGD";else if (code == 980) return "UAH";else if (code == 840) return "USD";else if (code == 860) return "UZS";else if (code == 710) return "ZAR";
  return null;
}
function toBoolean(v, posibleNull = true) {
  if (v === true) return true;
  if (v === false) return false;
  if (v === 0) return false;
  if (v === 1) return true;
  if (posibleNull && v === null) return null;
  if (posibleNull && v === undefined) return null;
  if (v === null || v === undefined) return false;

  if (typeof v === 'string') {
    if (posibleNull && v === '') return null;
    let txt = v.toLowerCase();
    if (txt === 'true') return true;
    if (txt === 'false') return false;
    if (txt === '1') return true;
    if (txt === '0') return false;
    if (txt === 'да') return true;
    if (txt === 'нет') return false;
    if (txt === 'yes') return true;
    if (txt === 'no') return false;
    if (txt === 'y') return true;
    if (txt === 'n') return false;
    if (posibleNull && txt === 'null') return null;
    if (posibleNull && txt === 'undefined') return null;
  }

  return !!v;
}
function stringToNumber(value) {
  if (value === null) return 0;
  let res = value.replace(/\s/g, '').replace(',', '.');
  let int = parseInt(res, 10);
  let decimal = parseFloat(res);
  return int === decimal ? int : decimal;
}

var converter = /*#__PURE__*/Object.freeze({
  __proto__: null,
  toMoney: toMoney$1,
  toFloatString: toFloatString,
  dhms: dhms,
  getCorrect: getCorrect,
  to00: to00,
  getOrganizationLevelText: getOrganizationLevelText,
  parseDate: parseDate,
  addTimeZone: addTimeZone,
  isNullFalse: isNullFalse,
  convertOrganizationLevels: convertOrganizationLevels,
  getArrayFromString: getArrayFromString,
  getIntArrayFromString: getIntArrayFromString,
  stringFromArray: stringFromArray,
  parseKey: parseKey,
  tryParse: tryParse,
  treeToString: treeToString,
  stringTreeParce: stringTreeParce,
  pad: pad,
  dateFormat: dateFormat,
  dateFormatV2: dateFormatV2,
  dateTimeFormat: dateTimeFormat,
  getDatePart: getDatePart,
  moneyFormat: moneyFormat,
  currencyCodeToText: currencyCodeToText,
  toBoolean: toBoolean,
  stringToNumber: stringToNumber
});

var script$1s = {
  name: "MoneyEditor",
  components: {
    TextEditor: __vue_component__$1K
  },
  props: {
    tabindex: Number,
    classField: String,
    name: {
      type: String
    },
    description: {
      type: String
    },
    placeholder: {
      type: String
    },
    value: {
      type: Number
    },
    defaultValue: {
      type: String
    },
    inputClass: {
      type: String
    },
    fontSize: {
      type: String
    },
    format: {
      type: Function
    },
    isPolza: {
      type: Boolean,
      default: false
    },
    currency: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      text: ""
    };
  },

  watch: {
    value: {
      handler(v) {
        this.text = v && v.toString();
      },

      immediate: true
    }
  },
  methods: {
    toMoney: toMoney$1,

    toMoneyWithCurrency(x) {
      let v = this.toMoney(x);

      if (v != null && v != '' && this.currency) {
        v = `${v} ${this.currency}`;
      }

      return v;
    },

    filter(n) {
      if (n === null || n === undefined) return n;

      if (this.currency) {
        n = n.replace(` ${this.currency}`, '');
      }

      let txt = n.replace(/[^0-9 | ^, | ^. | ^\s]/gi, "");
      txt = txt.replace(".", ",");
      let txtArray = txt.split(",");

      if (txtArray.length > 1) {
        let end = txtArray[txtArray.length - 1];
        txtArray[txtArray.length - 1] = "";
        txt = txtArray.join("");

        if (end && end.length > 2) {
          end = end.replace(/\s/gi, "");

          if (end.length > 2) {
            end = end.substring(0, 2);
          }
        }

        txt = txt + "," + end;
      }

      return txt;
    },

    handlerOnInput(v, e) {
      this.text = v;
      let number = null;

      if (!v) {
        this.$emit("input", null, e);
      } else {
        let sNumber = v.replace(/\s/gi, "").replace(",", ".");
        number = parseFloat(sNumber);
        this.$emit("input", number, e);
      }

      setTimeout(() => this.$emit("change", v, e), 100);
    }

  }
};

/* script */
const __vue_script__$1s = script$1s;
/* template */

var __vue_render__$1s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('TextEditor', {
    staticClass: "MoneyEditor",
    attrs: {
      "tabindex": _vm.tabindex,
      "inputClass": _vm.classField,
      "maxlength": 20,
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "filter": _vm.filter,
      "format": _vm.toMoneyWithCurrency,
      "isPolza": _vm.isPolza,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.handlerOnInput
    },
    model: {
      value: _vm.text,
      callback: function ($$v) {
        _vm.text = $$v;
      },
      expression: "text"
    }
  });
};

var __vue_staticRenderFns__$1s = [];
/* style */

const __vue_inject_styles__$1s = undefined;
/* scoped */

const __vue_scope_id__$1s = "data-v-6db65ee6";
/* module identifier */

const __vue_module_identifier__$1s = undefined;
/* functional template */

const __vue_is_functional_template__$1s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1s,
  staticRenderFns: __vue_staticRenderFns__$1s
}, __vue_inject_styles__$1s, __vue_script__$1s, __vue_scope_id__$1s, __vue_is_functional_template__$1s, __vue_module_identifier__$1s, false, undefined, undefined, undefined);

var script$1r = {
  name: "MoneyRange",
  inject: {
    team: {
      default: () => ({
        nm: "default",
        stl: {}
      })
    }
  },
  components: {
    MoneyEditor: __vue_component__$1s,
    LabelInfo: __vue_component__$1M
  },
  props: {
    minTabindex: Number,
    maxTabindex: Number,
    name: String,
    classField: String,
    description: String,
    minValue: Number,
    maxValue: Number,
    isPolza: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hasValue: hasValue$1
  }
};

/* script */
const __vue_script__$1r = script$1r;
/* template */

var __vue_render__$1r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "MoneyRange"
  }, [_c('div', {
    class: _vm.$style.name
  }, [_c('LabelInfo', {
    staticStyle: {
      "margin-bottom": "2px"
    },
    attrs: {
      "description": _vm.description
    }
  }, [_vm._v("\n      " + _vm._s(_vm.name) + "\n    ")])], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.box
  }, [_c('MoneyEditor', {
    class: _vm.$style.item,
    attrs: {
      "tabindex": _vm.minTabindex,
      "value": _vm.minValue,
      "classField": _vm.classField,
      "placeholder": "с",
      "isPolza": _vm.isPolza
    },
    on: {
      "input": function (a) {
        return _vm.$emit('input', {
          maxValue: _vm.maxValue,
          minValue: a
        });
      }
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.$style.separate
  }, [_c('svg', {
    attrs: {
      "width": "17",
      "height": "1",
      "viewBox": "0 0 17 1",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('line', {
    attrs: {
      "y1": "0.5",
      "x2": "16.0312",
      "y2": "0.5",
      "stroke": _vm.team === 'dark' ? '#FFF' : 'black'
    }
  })])]), _vm._v(" "), _c('MoneyEditor', {
    class: _vm.$style.item,
    attrs: {
      "tabindex": _vm.maxTabindex,
      "value": _vm.maxValue,
      "placeholder": "по",
      "classField": _vm.classField,
      "isPolza": _vm.isPolza
    },
    on: {
      "input": function (a) {
        return _vm.$emit('input', {
          maxValue: a,
          minValue: _vm.minValue
        });
      }
    }
  })], 1)]);
};

var __vue_staticRenderFns__$1r = [];
/* style */

const __vue_inject_styles__$1r = function (inject) {
  if (!inject) return;
  inject("data-v-702d7d69_0", {
    source: ".src-components-box-uPK1{display:flex;align-items:center}.src-components-separate-18o3{margin:0 5px 7px 6px;width:17px}.src-components-item-25YF{flex:1}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-box-uPK1",
      "separate": "src-components-separate-18o3",
      "item": "src-components-item-25YF"
    }
  });
};
/* scoped */


const __vue_scope_id__$1r = undefined;
/* module identifier */

const __vue_module_identifier__$1r = undefined;
/* functional template */

const __vue_is_functional_template__$1r = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1r,
  staticRenderFns: __vue_staticRenderFns__$1r
}, __vue_inject_styles__$1r, __vue_script__$1r, __vue_scope_id__$1r, __vue_is_functional_template__$1r, __vue_module_identifier__$1r, false, createInjector, undefined, undefined);

var script$1q = {
  name: "ModalEdit1",
  components: {
    Modal: __vue_component__$1V,
    IconAdd: __vue_component__$1U,
    IconClose: __vue_component__$1Q,
    ButtonRed: __vue_component__$1X,
    IconXls: __vue_component__$1S,
    IconPen: __vue_component__$1T,
    TextEditor: __vue_component__$1K,
    RadioGroup: __vue_component__$1G,
    Calendar: __vue_component__$1B,
    ButtonClean: __vue_component__$1P,
    IconRemove: __vue_component__$1u,
    NumberInput: __vue_component__$1t,
    MoneyEditor: __vue_component__$1s,
    MoneyRange: __vue_component__$1r
  },
  props: {
    value: {
      type: Object,

      default() {
        return {};
      }

    }
  },
  watch: {
    value: {
      handler(v) {
        this.v = JSON.parse(JSON.stringify(v));
      },

      immediate: true
    }
  },

  data() {
    return {
      specificationTextEditor: null,
      specificationEdited: null,
      v: {
        specifications: null,
        description: null,
        budget: null,
        price: null,
        count: null,
        name: null
      }
    };
  },

  methods: {
    save() {
      this.$emit("input", this.v);
      this.$emit("close");
    },

    close() {
      this.$emit("close");
    },

    specificationRemove(specification, index) {
      let specifications = this.value.specifications;
      if (!specifications) return;
      this.value.specifications = specifications.filter(a => a != specification);
    },

    specificationAdd() {
      if (!this.specifications) this.specifications = [];
      this.value.specifications.push({
        name: "Новая характеристика",
        value: "",
        comment: "",
        type: "string"
      });
    },

    specificationEdit(specification, index) {
      this.specificationEdited = specification;
      this.$nextTick(() => {
        let specificationTextEditor = this.specificationTextEditor;

        if (specificationTextEditor) {
          specificationTextEditor.focus();
        }
      });
    }

  }
};

/* script */
const __vue_script__$1q = script$1q;
/* template */

var __vue_render__$1q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('Modal', {
    attrs: {
      "ownerWidth": "650",
      "ownerDimensionsSizeUnit": "px",
      "useBuiltInButtons": false,
      "showFooter": true,
      "enableExternalClick": false
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    class: _vm.$style.box
  }, [_c('div', {
    class: _vm.$style.name
  }, [_vm._v("Позиция 1")]), _vm._v(" "), _c('div', {
    class: [_vm.$style.fw, _vm.$style.label],
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('div', {
    class: [_vm.$style.flex, _vm.$style.mrb2010]
  }, [_c('TextEditor', {
    class: [_vm.$style.f1],
    attrs: {
      "nameClass": _vm.$style.label,
      "name": "Наименование"
    },
    model: {
      value: _vm.v.name,
      callback: function ($$v) {
        _vm.$set(_vm.v, "name", $$v);
      },
      expression: "v.name"
    }
  }), _vm._v(" "), _c('div', [_c('TextEditor', {
    staticStyle: {
      "width": "222px",
      "margin-right": "10px"
    },
    attrs: {
      "nameClass": _vm.$style.label,
      "name": "ОКПД2",
      "placeholder": "ОКПД2"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    class: [_vm.$style.flex, _vm.$style.mr5],
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_c('div', {
    class: [_vm.$style.label],
    staticStyle: {
      "margin-right": "8px",
      "width": "183px"
    }
  }, [_vm._v("\n        Требуемое количество\n      ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "84px"
    }
  }, [_c('NumberInput', {
    class: _vm.$style.numberInputMidle,
    staticStyle: {
      "width": "63px"
    },
    attrs: {
      "nameClass": _vm.$style.label,
      "defaultValue": "2000"
    },
    model: {
      value: _vm.v.count,
      callback: function ($$v) {
        _vm.$set(_vm.v, "count", $$v);
      },
      expression: "v.count"
    }
  })], 1), _vm._v(" "), _c('TextEditor', {
    staticStyle: {
      "width": "45px"
    },
    attrs: {
      "nameClass": _vm.$style.label,
      "inputClass": _vm.$style.inputMidle,
      "defaultValue": "кг"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: [_vm.$style.flex],
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_c('div', {
    class: [_vm.$style.label],
    staticStyle: {
      "width": "78px"
    }
  }, [_vm._v("Бюджет")]), _vm._v(" "), _c('MoneyEditor', {
    staticStyle: {
      "width": "93px"
    },
    attrs: {
      "nameClass": _vm.$style.label,
      "classField": _vm.$style.inputMidle,
      "defaultValue": "2 000 000"
    },
    model: {
      value: _vm.v.budget,
      callback: function ($$v) {
        _vm.$set(_vm.v, "budget", $$v);
      },
      expression: "v.budget"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: [_vm.$style.flex],
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_c('div', {
    class: [_vm.$style.label],
    staticStyle: {
      "width": "78px"
    }
  }, [_vm._v("Цена")]), _vm._v(" "), _c('MoneyEditor', {
    staticStyle: {
      "width": "93px"
    },
    attrs: {
      "nameClass": _vm.$style.label,
      "classField": _vm.$style.inputMidle,
      "defaultValue": "1 000"
    },
    model: {
      value: _vm.v.price,
      callback: function ($$v) {
        _vm.$set(_vm.v, "price", $$v);
      },
      expression: "v.price"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: [_vm.$style.title],
    staticStyle: {
      "margin-top": "19px"
    }
  }, [_vm._v("\n      Требования к характеристикам товара (спецификация позиции)\n    ")]), _vm._v(" "), _c('div', {
    class: [_vm.$style.fw]
  }, [_c('div', {
    class: [_vm.$style.specifications],
    staticStyle: {
      "margin-top": "4px"
    }
  }, _vm._l(_vm.value.specifications, function (specification, index) {
    return _c('div', {
      key: index,
      class: [_vm.$style.specification, _vm.$style.flex]
    }, [_vm.specificationEdited != specification ? _c('div', {
      class: [_vm.$style.grey],
      staticStyle: {
        "width": "127px"
      },
      on: {
        "click": function ($event) {
          return _vm.specificationEdit(specification, index);
        }
      }
    }, [_vm._v("\n            " + _vm._s(specification.name) + "\n          ")]) : _vm._e(), _vm._v(" "), _vm.specificationEdited == specification ? _c('TextEditor', {
      class: [_vm.$style.specificationValue],
      staticStyle: {
        "width": "127px"
      },
      attrs: {
        "nameClass": _vm.$style.label,
        "inputClass": _vm.$style.inputSmall,
        "inputRef": function (r) {
          return _vm.specificationTextEditor = r;
        }
      },
      on: {
        "blur": function ($event) {
          _vm.specificationEdited = null;
        }
      },
      model: {
        value: specification.name,
        callback: function ($$v) {
          _vm.$set(specification, "name", $$v);
        },
        expression: "specification.name"
      }
    }) : _vm._e(), _vm._v(" "), specification.type == 'number-range' ? _c('MoneyRange', {
      class: [_vm.$style.specificationValue],
      staticStyle: {
        "width": "193px"
      },
      attrs: {
        "nameClass": _vm.$style.label,
        "classField": _vm.$style.inputSmall
      },
      model: {
        value: specification.value,
        callback: function ($$v) {
          _vm.$set(specification, "value", $$v);
        },
        expression: "specification.value"
      }
    }) : specification.type == 'number' ? _c('MoneyEditor', {
      class: [_vm.$style.specificationValue],
      staticStyle: {
        "width": "193px"
      },
      attrs: {
        "nameClass": _vm.$style.label,
        "classField": _vm.$style.inputSmall
      },
      model: {
        value: specification.value,
        callback: function ($$v) {
          _vm.$set(specification, "value", $$v);
        },
        expression: "specification.value"
      }
    }) : _c('TextEditor', {
      class: [_vm.$style.specificationValue],
      staticStyle: {
        "width": "193px"
      },
      attrs: {
        "nameClass": _vm.$style.label,
        "inputClass": _vm.$style.inputSmall
      },
      model: {
        value: specification.value,
        callback: function ($$v) {
          _vm.$set(specification, "value", $$v);
        },
        expression: "specification.value"
      }
    }), _vm._v(" "), _c('div', {
      class: [_vm.$style.flex, _vm.$style.f1]
    }, [_c('TextEditor', {
      class: [_vm.$style.specificationComment, _vm.$style.f1],
      staticStyle: {
        "width": "192px",
        "margin-right": "18px"
      },
      attrs: {
        "nameClass": _vm.$style.label,
        "placeholder": "Комментарий",
        "inputClass": _vm.$style.inputSmall
      },
      model: {
        value: specification.comment,
        callback: function ($$v) {
          _vm.$set(specification, "comment", $$v);
        },
        expression: "specification.comment"
      }
    }), _vm._v(" "), _c('IconRemove', {
      staticStyle: {
        "cursor": "pointer"
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.specificationRemove(specification, index);
        }
      }
    })], 1)], 1);
  }), 0)]), _vm._v(" "), _c('div', {
    class: [_vm.$style.flex, _vm.$style.mr5],
    staticStyle: {
      "margin-top": "17px"
    }
  }, [_c('IconAdd', {
    staticStyle: {
      "width": "18px",
      "height": "18px",
      "cursor": "pointer"
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.specificationAdd($event);
      }
    }
  }), _vm._v(" "), _c('span', {
    class: [_vm.$style.specificationAdd],
    on: {
      "click": _vm.specificationAdd
    }
  }, [_vm._v("Добавить требование")])], 1), _vm._v(" "), _c('TextEditor', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "nameClass": _vm.$style.label,
      "name": "Дополнительные требования",
      "placeholder": "Текстовое описание"
    },
    model: {
      value: _vm.v.description,
      callback: function ($$v) {
        _vm.$set(_vm.v, "description", $$v);
      },
      expression: "v.description"
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.$style.flex, _vm.$style.mr5],
    staticStyle: {
      "margin-top": "18px"
    }
  }, [_c('ButtonRed', {
    attrs: {
      "height": "32px",
      "width": "128px"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Сохранить")]), _vm._v(" "), _c('ButtonClean', {
    attrs: {
      "height": "32px"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('IconClose'), _vm._v(" Отменить")], 1)], 1)], 1)]);
};

var __vue_staticRenderFns__$1q = [];
/* style */

const __vue_inject_styles__$1q = function (inject) {
  if (!inject) return;
  inject("data-v-0ab00304_0", {
    source: ".src-components-box-3ytM{padding:8px 16px 10px 16px;box-sizing:border-box}.src-components-name-bkXn{font-size:16px;line-height:1.2}.src-components-label-2cc0{font-size:16px;line-height:1.2}.src-components-flex-1UV2{display:flex;align-items:center;flex-wrap:wrap;min-width:0}.src-components-fw-2rZ1{overflow:hidden}.src-components-f1-31gX{flex:1}.src-components-mr5-22Fd>*{margin-right:5px}.src-components-mrb2010-24qo{margin-right:-26px;margin-bottom:-10px}.src-components-mrb2010-24qo>*{margin-right:26px;margin-bottom:10px}.src-components-grey-3hBf{color:#6e7c8d}.src-components-inputMidle-18Qi{height:24px;min-height:24px;max-height:24px;font-size:16px}.src-components-inputSmall-3bxv{height:22px;min-height:22px;max-height:22px}.src-components-numberInputMidle-12ww input{height:24px;min-height:24px;max-height:24px;font-size:16px}.src-components-specifications-Nw-M{margin-right:-33px;margin-bottom:-8px}.src-components-specifications-Nw-M .src-components-specification-_gNU>*{margin-right:33px;margin-bottom:8px}.src-components-specificationAdd-1bd-{font-size:13px;cursor:pointer}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-box-3ytM",
      "name": "src-components-name-bkXn",
      "label": "src-components-label-2cc0",
      "flex": "src-components-flex-1UV2",
      "fw": "src-components-fw-2rZ1",
      "f1": "src-components-f1-31gX",
      "mr5": "src-components-mr5-22Fd",
      "mrb2010": "src-components-mrb2010-24qo",
      "grey": "src-components-grey-3hBf",
      "inputMidle": "src-components-inputMidle-18Qi",
      "inputSmall": "src-components-inputSmall-3bxv",
      "numberInputMidle": "src-components-numberInputMidle-12ww",
      "specifications": "src-components-specifications-Nw-M",
      "specification": "src-components-specification-_gNU",
      "specificationAdd": "src-components-specificationAdd-1bd-"
    }
  });
};
/* scoped */


const __vue_scope_id__$1q = undefined;
/* module identifier */

const __vue_module_identifier__$1q = undefined;
/* functional template */

const __vue_is_functional_template__$1q = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1q,
  staticRenderFns: __vue_staticRenderFns__$1q
}, __vue_inject_styles__$1q, __vue_script__$1q, __vue_scope_id__$1q, __vue_is_functional_template__$1q, __vue_module_identifier__$1q, false, createInjector, undefined, undefined);

var script$1p = {
  name: "IconChat"
};

/* script */
const __vue_script__$1p = script$1p;
/* template */

var __vue_render__$1p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "width": "26",
      "height": "24",
      "viewBox": "0 0 26 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "x": "0.5",
      "y": "0.5",
      "width": "24.3095",
      "height": "23",
      "rx": "2.5",
      "stroke": "#6E7C8D"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2.6084 6C2.6084 4.61929 3.72769 3.5 5.1084 3.5H15.9814C17.3621 3.5 18.4814 4.61929 18.4814 6V13.7143C18.4814 15.095 17.3621 16.2143 15.9814 16.2143H10.8978C9.75819 16.2143 8.68996 16.7691 8.03455 17.7013L7.65667 18.2388L6.20322 16.8606C5.76561 16.4456 5.1855 16.2143 4.58242 16.2143C3.4922 16.2143 2.6084 15.3305 2.6084 14.2403V6Z",
      "stroke": "#202020"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.4953 17.6905C18.4283 17.6905 19.9953 16.1235 19.9953 14.1905V12.2381V5.5H20.2005C21.5812 5.5 22.7005 6.61929 22.7005 8V15.7143C22.7005 17.095 21.5812 18.2143 20.2005 18.2143H15.9382C14.7522 18.2143 13.6468 18.8149 13.0015 19.8101L12.7474 20.2021L11.461 18.8795C11.1198 18.5288 10.7094 18.2539 10.2566 18.072L10.504 17.6905H16.4953Z",
      "fill": "#EE2B45",
      "stroke": "#EE2B45"
    }
  })]);
};

var __vue_staticRenderFns__$1p = [];
/* style */

const __vue_inject_styles__$1p = undefined;
/* scoped */

const __vue_scope_id__$1p = undefined;
/* module identifier */

const __vue_module_identifier__$1p = undefined;
/* functional template */

const __vue_is_functional_template__$1p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1p,
  staticRenderFns: __vue_staticRenderFns__$1p
}, __vue_inject_styles__$1p, __vue_script__$1p, __vue_scope_id__$1p, __vue_is_functional_template__$1p, __vue_module_identifier__$1p, false, undefined, undefined, undefined);

var script$1o = {
  name: "IconWord"
};

/* script */
const __vue_script__$1o = script$1o;
/* template */

var __vue_render__$1o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.$style.box
  }, [_c('svg', {
    staticClass: "IconWord",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 48 48",
      "width": "20px",
      "height": "20px"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#2196F3",
      "d": "M41,10H25v28h16c0.553,0,1-0.447,1-1V11C42,10.447,41.553,10,41,10z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M25 15.001H39V17H25zM25 19H39V21H25zM25 23.001H39V25.001H25zM25 27.001H39V29H25zM25 31H39V33.001H25z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#0D47A1",
      "d": "M27 42L6 38 6 10 27 6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M21.167,31.012H18.45l-1.802-8.988c-0.098-0.477-0.155-0.996-0.174-1.576h-0.032c-0.043,0.637-0.11,1.162-0.197,1.576l-1.85,8.988h-2.827l-2.86-14.014h2.675l1.536,9.328c0.062,0.404,0.111,0.938,0.143,1.607h0.042c0.019-0.498,0.098-1.051,0.223-1.645l1.97-9.291h2.622l1.785,9.404c0.062,0.348,0.119,0.846,0.17,1.511h0.031c0.02-0.515,0.073-1.035,0.16-1.563l1.503-9.352h2.468L21.167,31.012z"
    }
  })])]);
};

var __vue_staticRenderFns__$1o = [];
/* style */

const __vue_inject_styles__$1o = function (inject) {
  if (!inject) return;
  inject("data-v-eb6d8c0a_0", {
    source: ".src-components-box-1V6v{width:24px;height:24px;border:1px solid #6e7c8d;border-radius:4px;display:flex;align-items:center;justify-content:center}.src-components-image-3upf{width:19px;height:17px}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-box-1V6v",
      "image": "src-components-image-3upf"
    }
  });
};
/* scoped */


const __vue_scope_id__$1o = undefined;
/* module identifier */

const __vue_module_identifier__$1o = undefined;
/* functional template */

const __vue_is_functional_template__$1o = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1o,
  staticRenderFns: __vue_staticRenderFns__$1o
}, __vue_inject_styles__$1o, __vue_script__$1o, __vue_scope_id__$1o, __vue_is_functional_template__$1o, __vue_module_identifier__$1o, false, createInjector, undefined, undefined);

//
var script$1n = {
  name: "ButtonGrey",
  components: {
    Button: __vue_component__$1Y
  },
  props: {
    hoverBackground: {
      type: String,
      default: '#C4C4C4'
    },
    background: {
      type: String,
      default: '#6E7C8D'
    },
    hoverColor: {
      type: String
    },
    color: {
      type: String,
      default: '#fff'
    },
    hoverColor: {
      type: String
    },
    hoverBackground: {
      type: String,
      default: '#EE6865'
    },
    border: {
      type: String
    },
    padding: String,
    bold: Boolean,
    disable: Boolean,
    textAlign: String,
    height: String,
    width: String,
    borderRadius: String,
    border: String
  },
  methods: {
    handlerOnClick(e) {
      this.$emit('click', e);
    }

  }
};

/* script */
const __vue_script__$1n = script$1n;
/* template */

var __vue_render__$1n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('Button', {
    staticClass: "ButtonGrey",
    attrs: {
      "padding": _vm.padding,
      "bold": _vm.bold,
      "disable": _vm.disable,
      "height": _vm.height,
      "width": _vm.width,
      "textAlign": _vm.textAlign,
      "color": _vm.color,
      "hoverColor": _vm.hoverColor,
      "background": _vm.background,
      "hoverColor": _vm.hoverColor,
      "hoverBackground": _vm.hoverBackground,
      "activeBackground": '#444',
      "borderRadius": _vm.borderRadius,
      "border": _vm.border
    },
    on: {
      "click": _vm.handlerOnClick
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$1n = [];
/* style */

const __vue_inject_styles__$1n = undefined;
/* scoped */

const __vue_scope_id__$1n = undefined;
/* module identifier */

const __vue_module_identifier__$1n = undefined;
/* functional template */

const __vue_is_functional_template__$1n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1n,
  staticRenderFns: __vue_staticRenderFns__$1n
}, __vue_inject_styles__$1n, __vue_script__$1n, __vue_scope_id__$1n, __vue_is_functional_template__$1n, __vue_module_identifier__$1n, false, undefined, undefined, undefined);

//
var script$1m = {
  name: "ButtonWhite",
  components: {
    Button: __vue_component__$1Y
  },
  props: {
    border: {
      type: String,
      default: '1px solid #000'
    },
    padding: String,
    bold: Boolean,
    disable: Boolean,
    textAlign: String,
    height: String,
    width: String,
    borderRadius: String
  },
  methods: {
    handlerOnClick(e) {
      this.$emit('click', e);
    }

  }
};

/* script */
const __vue_script__$1m = script$1m;
/* template */

var __vue_render__$1m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('Button', {
    staticClass: "ButtonWhite",
    attrs: {
      "padding": _vm.padding,
      "bold": _vm.bold,
      "disable": _vm.disable,
      "height": _vm.height,
      "width": _vm.width,
      "textAlign": _vm.textAlign,
      "color": '#000',
      "background": '#FFF',
      "hoverBackground": '#f9f9f9',
      "activeBackground": '#444',
      "border": _vm.border,
      "borderRadius": _vm.borderRadius
    },
    on: {
      "click": _vm.handlerOnClick
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$1m = [];
/* style */

const __vue_inject_styles__$1m = undefined;
/* scoped */

const __vue_scope_id__$1m = undefined;
/* module identifier */

const __vue_module_identifier__$1m = undefined;
/* functional template */

const __vue_is_functional_template__$1m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1m,
  staticRenderFns: __vue_staticRenderFns__$1m
}, __vue_inject_styles__$1m, __vue_script__$1m, __vue_scope_id__$1m, __vue_is_functional_template__$1m, __vue_module_identifier__$1m, false, undefined, undefined, undefined);

function isIE() {
  return false;
  /*if(navigator.userAgent.includes('MSIE') || navigator.appVersion.includes('Trident/') > -1){
    return true;
  }
    return false;*/
}

//
var script$1l = {
  name: "LoaderSmall",
  props: {
    zoom: {
      type: Number,
      default: 1
    },
    delay: {
      type: [String, Number],
      default: 250
    }
  },

  data() {
    return {
      show: false
    };
  },

  computed: {
    isIEBrowser() {
      return isIE();
    },

    delayMilliseconds() {
      if (!this.delay) return 0;
      return parseInt(this.delay);
    }

  },

  mounted() {
    if (this.delayMilliseconds && this.delayMilliseconds > 0) {
      let th = this;
      setTimeout(() => {
        th.show = true;
      }, this.delayMilliseconds);
    } else {
      this.show = true;
    }
  }

};

/* script */
const __vue_script__$1l = script$1l;
/* template */

var __vue_render__$1l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.show && _vm.isIEBrowser ? _c('div', {
    style: "font-seze: " + _vm.zoom * 10 + "px !important;"
  }, [_vm._v("\n  ...\n")]) : _vm.show ? _c('div', {
    class: _vm.$style.ldsLoader,
    style: "font-seze: " + _vm.zoom * 10 + "px !important;"
  }, [_c('div'), _c('div'), _c('div')]) : _vm._e();
};

var __vue_staticRenderFns__$1l = [];
/* style */

const __vue_inject_styles__$1l = function (inject) {
  if (!inject) return;
  inject("data-v-0ea7a94a_0", {
    source: ".src-components-ldsLoader-20Rc{display:inline-block!important;position:relative!important;width:5.9em!important;height:1em!important}.src-components-ldsLoader-20Rc div{display:inline-block!important;position:absolute!important;width:1em!important;border-radius:.3em!important;background:#c4c4c4!important;animation:src-components-ldsLoader-20Rc 1.2s cubic-bezier(0,.5,.5,1) infinite}.src-components-ldsLoader-20Rc div:nth-child(1){left:.05em!important;animation-delay:-.24s}.src-components-ldsLoader-20Rc div:nth-child(2){left:1.3em!important;animation-delay:-.12s}.src-components-ldsLoader-20Rc div:nth-child(3){left:2.55em!important;animation-delay:0}@keyframes src-components-ldsLoader-20Rc{0%{background:#000}100%,50%{height:1em}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "ldsLoader": "src-components-ldsLoader-20Rc"
    }
  });
};
/* scoped */


const __vue_scope_id__$1l = undefined;
/* module identifier */

const __vue_module_identifier__$1l = undefined;
/* functional template */

const __vue_is_functional_template__$1l = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1l,
  staticRenderFns: __vue_staticRenderFns__$1l
}, __vue_inject_styles__$1l, __vue_script__$1l, __vue_scope_id__$1l, __vue_is_functional_template__$1l, __vue_module_identifier__$1l, false, createInjector, undefined, undefined);

var script$1k = {
  inject: {
    team: {
      default: () => 'default'
    }
  },
  name: "IconRub",
  props: {
    color: {
      type: String,
      default: null
    },
    width: {
      type: String,
      default: null
    },
    height: {
      type: String,
      default: null
    }
  },
  computed: {
    w() {
      if (this.height && !this.width) {
        return this.height;
      }

      return this.width || '10px';
    },

    h() {
      return this.height || '12px';
    }

  }
};

/* script */
const __vue_script__$1k = script$1k;
/* template */

var __vue_render__$1k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "width": _vm.w,
      "height": _vm.h,
      "viewBox": "0 0 10 12",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3.104 9.888V12H1.76V9.888H.48v-1.12h1.28V7.216H.48v-1.12h1.28V.832h4.448c1.003 0 1.77.288 2.304.864.544.576.816 1.355.816 2.336 0 .981-.272 1.76-.816 2.336-.533.565-1.301.848-2.304.848H3.104v1.552h4.4v1.12h-4.4zm0-3.792h3.104c.533 0 .944-.139 1.232-.416.299-.277.448-.672.448-1.184v-.88c0-.512-.15-.907-.448-1.184-.288-.277-.699-.416-1.232-.416H3.104v4.08z",
      "fill": _vm.color || (_vm.team == 'dark' ? '#fff' : '#000')
    }
  })]);
};

var __vue_staticRenderFns__$1k = [];
/* style */

const __vue_inject_styles__$1k = undefined;
/* scoped */

const __vue_scope_id__$1k = undefined;
/* module identifier */

const __vue_module_identifier__$1k = undefined;
/* functional template */

const __vue_is_functional_template__$1k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1k,
  staticRenderFns: __vue_staticRenderFns__$1k
}, __vue_inject_styles__$1k, __vue_script__$1k, __vue_scope_id__$1k, __vue_is_functional_template__$1k, __vue_module_identifier__$1k, false, undefined, undefined, undefined);

var css_248z$5 = ".drop-down-list-module_box__3Ir0d {\n  position: relative;\n  user-select: none;\n}\n\n.drop-down-list-module_value__2gIHL {\n  padding-right: 22px;\n  cursor: pointer;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.drop-down-list-module_icon__1d-ma {\n  position: absolute;\n  top: 9px;\n  right: 6px;\n  cursor: pointer;\n  fill: #3C3C3C;\n}\n\n.drop-down-list-module_items__25jbP {\n  position: absolute;\n  top: 100%;\n  width: 100%;\n  z-index: 100;\n  box-sizing: border-box;\n  border-radius: 4px !important;\n  border: 0.75px solid #6E7C8D;\n  background-color: white;\n}";
var style$4 = {"box":"drop-down-list-module_box__3Ir0d","value":"drop-down-list-module_value__2gIHL","icon":"drop-down-list-module_icon__1d-ma","items":"drop-down-list-module_items__25jbP"};
styleInject(css_248z$5);

var css_248z$4 = ".static-text-module_box__1JPuw {\n  position: relative;\n  border-radius: 4px !important;\n  border: 0.75px solid #6E7C8D;\n  padding: 4px 7px;\n}";
var style$3 = {"box":"static-text-module_box__1JPuw"};
styleInject(css_248z$4);

//
var script$1j = {
  name: 'static-text',
  props: {
    text: String
  },

  data() {
    return {
      style: style$3
    };
  }

};

/* script */
const __vue_script__$1j = script$1j;
/* template */

var __vue_render__$1j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', _vm._g({
    class: _vm.style.box
  }, _vm.$listeners), [_vm._t("default", [_c('span', [_vm._v(_vm._s(_vm.text))])], {
    "text": _vm.text
  })], 2);
};

var __vue_staticRenderFns__$1j = [];
/* style */

const __vue_inject_styles__$1j = undefined;
/* scoped */

const __vue_scope_id__$1j = undefined;
/* module identifier */

const __vue_module_identifier__$1j = undefined;
/* functional template */

const __vue_is_functional_template__$1j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1j,
  staticRenderFns: __vue_staticRenderFns__$1j
}, __vue_inject_styles__$1j, __vue_script__$1j, __vue_scope_id__$1j, __vue_is_functional_template__$1j, __vue_module_identifier__$1j, false, undefined, undefined, undefined);

var css_248z$3 = ".items-list-module_box__TjZ3z {\n  list-style-type: none;\n  margin: 0;\n  padding: 4px 7px;\n}\n\n.items-list-module_item__oR5Sq {\n  cursor: pointer;\n}\n.items-list-module_item__oR5Sq:hover {\n  background-color: #F0F2F4;\n}";
var style$2 = {"box":"items-list-module_box__TjZ3z","item":"items-list-module_item__oR5Sq"};
styleInject(css_248z$3);

//
var script$1i = {
  name: 'items-list',
  props: {
    items: Array,
    getItemKey: {
      type: Function,
      default: item => item.key
    },
    getItemText: {
      type: Function,
      default: item => item.text
    }
  },

  data() {
    return {
      style: style$2
    };
  }

};

/* script */
const __vue_script__$1i = script$1i;
/* template */

var __vue_render__$1i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('ul', {
    class: _vm.style.box
  }, _vm._l(_vm.items, function (item) {
    return _c('li', {
      key: _vm.getItemKey(item),
      class: _vm.style.item,
      on: {
        "click": function ($event) {
          return _vm.$emit('select', item);
        }
      }
    }, [_vm._t("item", [_c('span', [_vm._v(_vm._s(item))])], {
      "item": item
    })], 2);
  }), 0)]);
};

var __vue_staticRenderFns__$1i = [];
/* style */

const __vue_inject_styles__$1i = undefined;
/* scoped */

const __vue_scope_id__$1i = undefined;
/* module identifier */

const __vue_module_identifier__$1i = undefined;
/* functional template */

const __vue_is_functional_template__$1i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1i,
  staticRenderFns: __vue_staticRenderFns__$1i
}, __vue_inject_styles__$1i, __vue_script__$1i, __vue_scope_id__$1i, __vue_is_functional_template__$1i, __vue_module_identifier__$1i, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
var script$1h = {
  name: 'icon-down'
};

/* script */
const __vue_script__$1h = script$1h;
/* template */

var __vue_render__$1h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "width": "12",
      "height": "8",
      "viewBox": "0 0 12 8",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.10149 6.84463C6.43333 7.2855 5.56667 7.2855 4.89852 6.84463L1.16876 4.38363C-0.487009 3.29111 0.286514 0.714283 2.27024 0.714283L9.72976 0.714283C11.7135 0.714283 12.487 3.29111 10.8312 4.38363L7.10149 6.84463Z"
    }
  })]);
};

var __vue_staticRenderFns__$1h = [];
/* style */

const __vue_inject_styles__$1h = undefined;
/* scoped */

const __vue_scope_id__$1h = undefined;
/* module identifier */

const __vue_module_identifier__$1h = undefined;
/* functional template */

const __vue_is_functional_template__$1h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1h,
  staticRenderFns: __vue_staticRenderFns__$1h
}, __vue_inject_styles__$1h, __vue_script__$1h, __vue_scope_id__$1h, __vue_is_functional_template__$1h, __vue_module_identifier__$1h, false, undefined, undefined, undefined);

//
var script$1g = {
  name: 'drop-down-list',
  components: {
    StaticText: __vue_component__$1j,
    ItemsList: __vue_component__$1i,
    IconDown: __vue_component__$1h
  },
  props: {
    value: Object,
    items: Array,
    getItemKey: {
      type: Function,
      default: item => item.key
    },
    getItemText: {
      type: Function,
      default: item => item.text
    }
  },

  data() {
    return {
      style: style$4,
      isOpened: false
    };
  },

  computed: {
    valueText() {
      return this.value && this.getItemText(this.value);
    }

  },
  methods: {
    tryClose(e) {
      if (!this.isOpened) {
        return;
      }

      let el = e.target;

      while (el) {
        if (el === this.$el) {
          return;
        }

        el = el.parentElement;
      }

      this.isOpened = false;
    },

    handleSelect(item) {
      this.isOpened = false;
      this.$emit('input', item);
    }

  },

  mounted() {
    document.addEventListener('click', this.tryClose);
    document.addEventListener('keyup', this.tryClose);
  }

};

/* script */
const __vue_script__$1g = script$1g;
/* template */

var __vue_render__$1g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.style.box
  }, [_c('static-text', {
    attrs: {
      "text": _vm.valueText
    },
    on: {
      "click": function ($event) {
        _vm.isOpened = !_vm.isOpened;
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var text = ref.text;
        return [_c('div', {
          class: _vm.style.value
        }, [_vm._t("selectedItem", [_c('span', [_vm._v(_vm._s(text))])], {
          "text": text
        }), _vm._v(" "), _c('icon-down', {
          class: _vm.style.icon
        })], 2)];
      }
    }], null, true)
  }), _vm._v(" "), _c('items-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isOpened,
      expression: "isOpened"
    }],
    class: [_vm.style.items, 'itemsList'],
    attrs: {
      "items": _vm.items,
      "getItemKey": _vm.getItemKey
    },
    on: {
      "select": _vm.handleSelect
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (ref) {
        var item = ref.item;
        return [_vm._t("item", [_c('span', [_vm._v(_vm._s(_vm.getItemText(item)))])], {
          "item": item
        })];
      }
    }], null, true)
  })], 1);
};

var __vue_staticRenderFns__$1g = [];
/* style */

const __vue_inject_styles__$1g = undefined;
/* scoped */

const __vue_scope_id__$1g = undefined;
/* module identifier */

const __vue_module_identifier__$1g = undefined;
/* functional template */

const __vue_is_functional_template__$1g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1g,
  staticRenderFns: __vue_staticRenderFns__$1g
}, __vue_inject_styles__$1g, __vue_script__$1g, __vue_scope_id__$1g, __vue_is_functional_template__$1g, __vue_module_identifier__$1g, false, undefined, undefined, undefined);

var css_248z$2 = ".text-input-module_box__2MR2S {\n  position: relative;\n}\n\n.text-input-module_value__1BEIG {\n  box-sizing: border-box;\n  border-radius: 4px !important;\n  border: 0.75px solid #6E7C8D;\n  height: 32px;\n  width: 100%;\n  padding: 0 6px;\n  outline: none !important;\n}\n.text-input-module_value__1BEIG:focus {\n  border: 1.5px solid #6E7C8D;\n  padding: 0 5.25px;\n}";
var style$1 = {"box":"text-input-module_box__2MR2S","value":"text-input-module_value__1BEIG"};
styleInject(css_248z$2);

//
var script$1f = {
  name: 'text-input',
  props: {
    tabindex: Number,
    value: String,
    placeholder: String
  },

  data() {
    return {
      style: style$1
    };
  },

  computed: {
    listeners() {
      return { ...this.$listeners,
        input: ev => this.$emit('input', ev.target.value)
      };
    }

  }
};

/* script */
const __vue_script__$1f = script$1f;
/* template */

var __vue_render__$1f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.style.box
  }, [_c('input', _vm._g({
    class: _vm.style.value,
    attrs: {
      "tabindex": _vm.tabindex,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  }, _vm.listeners))]);
};

var __vue_staticRenderFns__$1f = [];
/* style */

const __vue_inject_styles__$1f = undefined;
/* scoped */

const __vue_scope_id__$1f = undefined;
/* module identifier */

const __vue_module_identifier__$1f = undefined;
/* functional template */

const __vue_is_functional_template__$1f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1f,
  staticRenderFns: __vue_staticRenderFns__$1f
}, __vue_inject_styles__$1f, __vue_script__$1f, __vue_scope_id__$1f, __vue_is_functional_template__$1f, __vue_module_identifier__$1f, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
var script$1e = {
  name: 'PulseLoader',
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },

  data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        width: this.size,
        height: this.size,
        margin: this.margin,
        borderRadius: this.radius,
        display: 'inline-block',
        animationName: 'v-pulseStretchDelay',
        animationDuration: '0.75s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'cubic-bezier(.2,.68,.18,1.08)',
        animationFillMode: 'both'
      },
      spinnerDelay1: {
        animationDelay: '0.12s'
      },
      spinnerDelay2: {
        animationDelay: '0.24s'
      },
      spinnerDelay3: {
        animationDelay: '0.36s'
      }
    };
  }

};

/* script */
const __vue_script__$1e = script$1e;
/* template */

var __vue_render__$1e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-pulse v-pulse1",
    style: [_vm.spinnerStyle, _vm.spinnerDelay1]
  }), _vm._v(" "), _c('div', {
    staticClass: "v-pulse v-pulse2",
    style: [_vm.spinnerStyle, _vm.spinnerDelay2]
  }), _vm._v(" "), _c('div', {
    staticClass: "v-pulse v-pulse3",
    style: [_vm.spinnerStyle, _vm.spinnerDelay3]
  })]);
};

var __vue_staticRenderFns__$1e = [];
/* style */

const __vue_inject_styles__$1e = function (inject) {
  if (!inject) return;
  inject("data-v-353277ab_0", {
    source: "@-webkit-keyframes v-pulseStretchDelay{0%,80%{-webkit-transform:scale(1);transform:scale(1);-webkit-opacity:1;opacity:1}45%{-webkit-transform:scale(.1);transform:scale(.1);-webkit-opacity:.7;opacity:.7}}@keyframes v-pulseStretchDelay{0%,80%{-webkit-transform:scale(1);transform:scale(1);-webkit-opacity:1;opacity:1}45%{-webkit-transform:scale(.1);transform:scale(.1);-webkit-opacity:.7;opacity:.7}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1e = undefined;
/* module identifier */

const __vue_module_identifier__$1e = undefined;
/* functional template */

const __vue_is_functional_template__$1e = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1e,
  staticRenderFns: __vue_staticRenderFns__$1e
}, __vue_inject_styles__$1e, __vue_script__$1e, __vue_scope_id__$1e, __vue_is_functional_template__$1e, __vue_module_identifier__$1e, false, createInjector, undefined, undefined);

var css_248z$1 = ".customer-contacts-module_box__2Rkc2 {\n  background: white;\n}\n\n.customer-contacts-module_organization__k6O78 {\n  margin-top: 4px;\n  line-height: 23px;\n}\n.customer-contacts-module_organization__k6O78 .itemsList {\n  max-height: 120px;\n  overflow-y: auto;\n}\n\n.customer-contacts-module_filters__3RVrZ {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  font-size: 13px;\n  line-height: 23px;\n  margin-top: 0;\n}\n.customer-contacts-module_filters__3RVrZ > * {\n  margin-top: 8px;\n}\n\n.customer-contacts-module_filterText__29zsa {\n  min-width: 180px;\n  margin-right: 8px;\n}\n\n.customer-contacts-module_sortOrder__1IAI7 {\n  min-width: 160px;\n}\n\n.customer-contacts-module_floats__1Nkvx:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n.customer-contacts-module_contacts__31oH5 {\n  margin-top: 8px;\n  box-sizing: border-box;\n}\n\n.customer-contacts-module_contactsHeader__tYLmx {\n  font-size: 16px;\n  color: white;\n  border: 1px solid #4C576A;\n  border-bottom: none;\n  border-radius: 8px 8px 0px 0px !important;\n  padding: 4px 8px;\n}\n\n.customer-contacts-module_contactsBody__1immV {\n  border: 1px solid #4C576A;\n  border-bottom: none;\n  border-radius: 8px 8px 0px 0px !important;\n  border: solid #6E7C8D;\n  border-width: 1px 1px 0px 1px;\n  max-height: 500px;\n  min-height: 6px;\n  overflow-y: scroll;\n}\n.customer-contacts-module_contactsBody__1immV::-webkit-scrollbar {\n  width: 8px;\n}\n.customer-contacts-module_contactsBody__1immV::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0);\n}\n.customer-contacts-module_contactsBody__1immV::-webkit-scrollbar-thumb {\n  background: #C4C4C4;\n  border: 0 solid rgba(0, 0, 0, 0);\n  border-radius: 4px !important;\n}\n\n.customer-contacts-module_contactsFooter__q7rLg {\n  color: white;\n  height: 8px;\n  border: 1px solid #4C576A;\n  border-top: none;\n  border-radius: 0px 0px 8px 8px !important;\n}\n\na.customer-contacts-module_discloseLink__1tZMa, a.customer-contacts-module_discloseLink__1tZMa:hover {\n  color: #337ab7 !important;\n}\n\n.customer-contacts-module_noContacts__3IUmM {\n  padding: 4px 8px;\n}\n\n.customer-contacts-module_contact__1XDiU {\n  border-bottom: 1px solid #6E7C8D;\n  padding-bottom: 4px;\n}\n.customer-contacts-module_contact__1XDiU:last-child {\n  border-bottom: none;\n}\n\n.customer-contacts-module_contactDate__Y4TQl {\n  color: #6E7C8D;\n  float: right;\n  font-size: 10px;\n  margin: 8px 8px 0px 0px;\n}\n\n.customer-contacts-module_contactBadge__2BH-F {\n  float: left;\n  border: 1px solid #6E7C8D;\n  border-radius: 4px 4px 15px 4px !important;\n  font-size: 13px;\n  margin: 8px 0px 0px 8px;\n  padding: 0px 8px 0px 4px;\n}\n\n.customer-contacts-module_contactDataColumns__2uRQh {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 8px;\n}\n\n.customer-contacts-module_contactDataColumn__3FRWD {\n  width: 45%;\n  margin: 0px 8px;\n}\n\n.customer-contacts-module_contactDataBig__3cc3T {\n  font-size: 16px;\n  line-height: 16px;\n}\n.customer-contacts-module_contactDataBig__3cc3T em {\n  background: yellow;\n  font-style: normal;\n}\n\n.customer-contacts-module_contactData__1acSs {\n  color: #202020;\n  font-size: 13px;\n  line-height: 16px;\n  word-wrap: break-word;\n}\n\n.customer-contacts-module_contactCategories__1-ddM {\n  display: flex;\n  margin: 8px 0px 0px 0px;\n  font-size: 13px;\n  line-height: 16px;\n}\n\n.customer-contacts-module_contactCategoriesHeader__26WhY, .customer-contacts-module_contactCategoriesFirst__3p8Ci, .customer-contacts-module_contactCategoriesMore__3EdyY {\n  white-space: nowrap;\n}\n\n.customer-contacts-module_contactCategoriesHeader__26WhY {\n  margin-left: 8px;\n}\n\n.customer-contacts-module_contactCategoriesFirst__3p8Ci {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 135px;\n}\n\n.customer-contacts-module_contactCategoriesMore__3EdyY {\n  user-select: none;\n  cursor: pointer;\n  margin-left: auto;\n  margin-right: 8px;\n}\n\n.customer-contacts-module_contactCategoriesAll__cppkp {\n  width: 100%;\n}\n.customer-contacts-module_contactCategoriesAll__cppkp ul {\n  margin: 8px 8px 0px 8px;\n  padding: 0;\n  list-style-type: none;\n  max-height: 100px;\n  overflow-y: scroll;\n  line-height: 13px;\n}\n.customer-contacts-module_contactCategoriesAll__cppkp ul::-webkit-scrollbar {\n  width: 8px;\n}\n.customer-contacts-module_contactCategoriesAll__cppkp ul::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0);\n}\n.customer-contacts-module_contactCategoriesAll__cppkp ul::-webkit-scrollbar-thumb {\n  background: #C4C4C4;\n  border: 0 solid rgba(0, 0, 0, 0);\n  border-radius: 4px !important;\n}\n.customer-contacts-module_contactCategoriesAll__cppkp li {\n  margin-bottom: 0.3em;\n}\n\n.customer-contacts-module_contactCategoriesHide__an37g {\n  user-select: none;\n  cursor: pointer;\n  float: right;\n  margin-right: 8px;\n}";
var style = {"box":"customer-contacts-module_box__2Rkc2","organization":"customer-contacts-module_organization__k6O78","filters":"customer-contacts-module_filters__3RVrZ","filterText":"customer-contacts-module_filterText__29zsa","sortOrder":"customer-contacts-module_sortOrder__1IAI7","floats":"customer-contacts-module_floats__1Nkvx","contacts":"customer-contacts-module_contacts__31oH5","contactsHeader":"customer-contacts-module_contactsHeader__tYLmx","contactsBody":"customer-contacts-module_contactsBody__1immV","contactsFooter":"customer-contacts-module_contactsFooter__q7rLg","discloseLink":"customer-contacts-module_discloseLink__1tZMa","noContacts":"customer-contacts-module_noContacts__3IUmM","contact":"customer-contacts-module_contact__1XDiU","contactDate":"customer-contacts-module_contactDate__Y4TQl","contactBadge":"customer-contacts-module_contactBadge__2BH-F","contactDataColumns":"customer-contacts-module_contactDataColumns__2uRQh","contactDataColumn":"customer-contacts-module_contactDataColumn__3FRWD","contactDataBig":"customer-contacts-module_contactDataBig__3cc3T","contactData":"customer-contacts-module_contactData__1acSs","contactCategories":"customer-contacts-module_contactCategories__1-ddM","contactCategoriesHeader":"customer-contacts-module_contactCategoriesHeader__26WhY","contactCategoriesFirst":"customer-contacts-module_contactCategoriesFirst__3p8Ci","contactCategoriesMore":"customer-contacts-module_contactCategoriesMore__3EdyY","contactCategoriesAll":"customer-contacts-module_contactCategoriesAll__cppkp","contactCategoriesHide":"customer-contacts-module_contactCategoriesHide__an37g"};
styleInject(css_248z$1);

//
const sortOrders = [{
  name: "По релевантности",
  value: 1
}, {
  name: "По алфавиту",
  value: 2
}];

function createSimpleCustomerDataGetter(apiBaseAddress, authTokenGetter, timeout, maxCount) {
  return async function (inn, kpp) {
    let headers = {};
    const authToken = authTokenGetter();

    if (!authToken) {
      return {
        error: "denied"
      };
    }

    headers["Authorization"] = "Bearer " + authToken;

    try {
      const response = await axios({
        method: "post",
        baseURL: apiBaseAddress,
        url: "/api/contacts/customer/search-simple",
        data: {
          customer: {
            inn,
            kpp
          },
          maxCount
        },
        headers,
        timeout
      });
      return response.data;
    } catch (e) {
      if (e.response && (e.response.status == 401 || e.response.status == 403)) {
        return {
          error: "denied"
        };
      }

      throw e;
    }
  };
}

function createCustomerInnDataGetter(apiBaseAddress, authTokenGetter, timeout, maxCount) {
  return async function (inn) {
    try {
      const response = await axios({
        method: "post",
        baseURL: apiBaseAddress,
        url: "/api/contacts/customer/search-inn",
        data: {
          inn,
          maxCount
        },
        timeout
      });
      return response.data;
    } catch (e) {
      if (e.response && (e.response.status == 401 || e.response.status == 403)) {
        return {
          error: "denied"
        };
      }

      throw e;
    }
  };
}

function createCustomerDataGetter(apiBaseAddress, authTokenGetter, timeout, categories, maxCount) {
  return async function (inn, kpp) {
    let headers = {};
    const authToken = authTokenGetter();

    if (!authToken) {
      return {
        error: "denied"
      };
    }

    headers["Authorization"] = "Bearer " + authToken;

    try {
      const response = await axios({
        method: "post",
        baseURL: apiBaseAddress,
        url: "/api/contacts/customer/search",
        data: {
          customer: {
            inn,
            kpp
          },
          categories,
          maxCount
        },
        headers,
        timeout
      });
      return response.data;
    } catch (e) {
      if (e.response && (e.response.status == 401 || e.response.status == 403)) {
        return {
          error: "denied"
        };
      }

      throw e;
    }
  };
}

var script$1d = {
  name: "CustomerContacts",
  components: {
    DropDownList: __vue_component__$1g,
    StaticText: __vue_component__$1j,
    TextInput: __vue_component__$1f,
    PulseLoader: __vue_component__$1e
  },
  props: {
    customers: {
      type: Array,

      default() {
        return [];
      }

    },
    externalContacts: {
      type: Array,

      default() {
        return [];
      }

    },
    getCustomerData: {
      type: Function,
      default: () => ({
        error: "not configured"
      })
    },
    showDiscloseLink: {
      type: Boolean,
      default: false
    },
    showOrganizations: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      style,
      customer: this.customers && this.customers.length && this.customers[0] || {},
      filterText: "",
      sortOrder: sortOrders[0],
      customersData: {},
      customerData: {}
    };
  },

  computed: {
    sortOrders() {
      return sortOrders;
    },

    hasCustomerData() {
      return this.customerData && !this.customerData.loading && !this.customerData.error;
    },

    hasCustomerDataContacts() {
      return this.hasCustomerData && this.customerData.contacts;
    },

    contacts() {
      return this.hasCustomerDataContacts && this.customerData.contacts.filter(x => x.visible) || [];
    }

  },

  mounted() {
    this.selectCustomer();
  },

  methods: {
    createSimpleCustomerDataGetter,
    createCustomerInnDataGetter,
    createCustomerDataGetter,

    splitValues(value, regex = /\s*;\s*/) {
      if (!value) return null;
      if (!value.length) return value;
      let v = value;
      v = v.filter(a => a);
      v = v.map(a => a.split(regex));
      v = v.reduce((r, a) => {
        return r.concat(a);
      }, []);
      return v;
    },

    sortContacts(contacts) {
      if (!contacts) {
        if (!this.hasCustomerDataContacts) {
          return;
        }

        contacts = this.customerData.contacts;
      }

      if (this.sortOrder.value == 1) {
        contacts.sort((x, y) => x.relevanceOrder - y.relevanceOrder);
      } else {
        contacts.sort((x, y) => x.alphabeticOrder - y.alphabeticOrder);
      }
    },

    filterContacts(contacts) {
      if (!contacts) {
        if (!this.hasCustomerDataContacts) {
          return;
        }

        contacts = this.customerData.contacts;
      }

      const filterText = this.filterText.trim().toLowerCase();
      const showAll = !filterText.length;

      for (const i in contacts) {
        let contact = contacts[i];
        const visible = showAll || contact.name && contact.name.toLowerCase().includes(filterText);
        contact.visible = visible;
        contact.nameHtml = visible && !showAll && contact.name.replace(new RegExp(filterText, "gi"), "<em>$&</em>") || contact.name;
      }
    },

    selectCustomer() {
      const customerId = this.customer.inn + "-" + this.customer.kpp;

      if (!this.customersData[customerId] || this.customersData[customerId].error) {
        this.$set(this.customersData, customerId, {
          loading: true,
          error: false
        });
        this.loadCustomerData(customerId, this.customer.inn, this.customer.kpp);
      }

      this.customerData = this.customersData[customerId];
      this.sortContacts();
      this.filterContacts();
    },

    async loadCustomerData(id, inn, kpp) {
      const data = await this.tryGetCustomerData(inn, kpp);

      if (!this.customersData[id] || !this.customersData[id].loading) {
        return;
      }

      this.customersData[id].loading = false;

      if (data.error) {
        this.customersData[id].error = data.error;
        return;
      }

      let contacts = data.contacts || [];

      if (this.externalContacts && this.externalContacts.length) {
        const externalContacts = this.externalContacts.filter(x => x.inn === inn && x.kpp === kpp);

        if (externalContacts.length) {
          contacts = contacts.concat(externalContacts);
          contacts.sort((a, b) => a.name > b.name && 1 || a.name < b.name && -1 || 0);
          contacts.forEach((x, i) => {
            x.alphabeticOrder = i;
          });
        }
      }

      contacts = contacts.map(x => ({ ...x,
        visible: true,
        showAllCategories: false,
        nameHtml: x.name
      }));
      this.$set(this.customersData[id], "timezone", data.timezone);
      this.$set(this.customersData[id], "contacts", contacts);
      this.sortContacts(this.customersData[id].contacts);
      this.filterContacts(this.customersData[id].contacts);
    },

    async tryGetCustomerData(inn, kpp) {
      let attempt = 0;

      while (attempt < 3) {
        try {
          return await this.getCustomerData(inn, kpp);
        } catch (e) {
          ++attempt;
        }
      }

      return {
        error: true
      };
    }

  }
};

/* script */
const __vue_script__$1d = script$1d;
/* template */

var __vue_render__$1d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.style.box
  }, [_vm.showOrganizations ? [_vm._v("\n    Организация\n    "), _vm.customers && _vm.customers.length && _vm.customers.length > 1 ? _c('drop-down-list', {
    class: _vm.style.organization,
    attrs: {
      "items": _vm.customers,
      "get-item-key": function (item) {
        return item.inn + '_' + item.kpp;
      },
      "get-item-text": function (item) {
        return item.name;
      }
    },
    on: {
      "input": _vm.selectCustomer
    },
    model: {
      value: _vm.customer,
      callback: function ($$v) {
        _vm.customer = $$v;
      },
      expression: "customer"
    }
  }) : _c('static-text', {
    class: _vm.style.organization,
    attrs: {
      "text": _vm.customer.name
    }
  })] : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.style.filters
  }, [_c('text-input', {
    class: _vm.style.filterText,
    attrs: {
      "placeholder": "Начните вводить ФИО"
    },
    on: {
      "input": function ($event) {
        return _vm.filterContacts();
      }
    },
    model: {
      value: _vm.filterText,
      callback: function ($$v) {
        _vm.filterText = $$v;
      },
      expression: "filterText"
    }
  }), _vm._v(" "), _c('drop-down-list', {
    class: _vm.style.sortOrder,
    attrs: {
      "items": _vm.sortOrders,
      "get-item-key": function (item) {
        return item.value;
      },
      "get-item-text": function (item) {
        return item.name;
      }
    },
    on: {
      "input": function ($event) {
        return _vm.sortContacts();
      }
    },
    model: {
      value: _vm.sortOrder,
      callback: function ($$v) {
        _vm.sortOrder = $$v;
      },
      expression: "sortOrder"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: _vm.style.contacts
  }, [_c('div', {
    class: _vm.style.contactsBody
  }, [_c('div', [!_vm.customerData || _vm.customerData.loading ? _c('div', {
    class: _vm.style.noContacts
  }, [_c('pulse-loader', {
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "color": "grey"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.customerData && _vm.customerData.error ? _c('div', {
    class: _vm.style.noContacts,
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_vm.customerData.error === 'denied' && _vm.showDiscloseLink ? _c('a', {
    class: _vm.style.discloseLink,
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.$emit('disclose');
      }
    }
  }, [_vm._v("Показать контакты")]) : _vm.customerData.error === 'denied' ? _c('span', [_vm._v("данная информация для Вас недоступна, обратитесь в\n            техподдержку")]) : _c('span', [_vm._v("\n            при поиске данных произошла ошибка,\n            "), _c('a', {
    class: _vm.style.discloseLink,
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.selectCustomer($event);
      }
    }
  }, [_vm._v("нажмите сюда для повторного поиска")])])]) : _vm._e(), _vm._v(" "), _vm.hasCustomerData && !_vm.contacts.length ? _c('div', {
    class: _vm.style.noContacts,
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_vm._v("\n          отсутствуют\n        ")]) : _vm._e(), _vm._v(" "), _vm._l(_vm.contacts, function (contact) {
    return _c('div', {
      key: contact.id,
      class: _vm.style.contact
    }, [_c('div', {
      class: _vm.style.floats
    }, [contact.badge && contact.badge.length ? _c('div', {
      class: _vm.style.contactBadge
    }, [_vm._v("\n              " + _vm._s(contact.badge) + "\n            ")]) : _vm._e(), _vm._v(" "), contact.date ? _c('div', {
      class: _vm.style.contactDate
    }, [_vm._v("\n              данные актуальны на " + _vm._s(contact.date) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      class: _vm.style.contactDataColumns
    }, [_c('div', {
      class: _vm.style.contactDataColumn
    }, [_c('div', {
      class: _vm.style.contactDataBig,
      domProps: {
        "innerHTML": _vm._s(contact.nameHtml)
      }
    })]), _vm._v(" "), _c('div', {
      class: _vm.style.contactDataColumn
    }, [_c('div', {
      class: _vm.style.contactDataBig
    }, [_vm._v(_vm._s(contact.position))])])]), _vm._v(" "), _c('div', {
      class: _vm.style.contactDataColumns
    }, [_c('div', {
      class: _vm.style.contactDataColumn
    }, _vm._l(_vm.splitValues(contact.emails), function (email) {
      return _c('div', {
        key: email,
        class: _vm.style.contactData
      }, [_vm._v("\n                " + _vm._s(email) + "\n              ")]);
    }), 0), _vm._v(" "), _c('div', {
      class: _vm.style.contactDataColumn
    }, _vm._l(contact.phones, function (phone) {
      return _c('div', {
        key: phone,
        class: _vm.style.contactData
      }, [_vm._v("\n                " + _vm._s(phone) + "\n              ")]);
    }), 0)]), _vm._v(" "), contact.categories && contact.categories.length ? _c('div', {
      class: _vm.style.contactCategories
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !contact.showAllCategories,
        expression: "!contact.showAllCategories"
      }],
      class: _vm.style.contactCategoriesHeader
    }, [_vm._v("\n              Курируемые категории ТРУ:\n            ")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !contact.showAllCategories,
        expression: "!contact.showAllCategories"
      }],
      class: _vm.style.contactCategoriesFirst
    }, [_c('strong', [_vm._v(_vm._s(contact.categories[0].code))]), _vm._v("\n              - " + _vm._s(contact.categories[0].name) + "\n            ")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !contact.showAllCategories,
        expression: "!contact.showAllCategories"
      }],
      class: _vm.style.contactCategoriesMore,
      on: {
        "click": function ($event) {
          contact.showAllCategories = !contact.showAllCategories;
        }
      }
    }, [_vm._v("\n              еще\n              "), _c('svg', {
      attrs: {
        "width": "10",
        "height": "8",
        "viewBox": "0 0 10 8",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M2.46973 0.81178L4.88784 4.60831L4.99984 4.60777L7.38168 0.788386L9.76565 0.777031L5.66772 7.10062L4.27573 7.10725L0.0697579 0.823211L2.46973 0.81178Z",
        "fill": "#202020"
      }
    })])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: contact.showAllCategories,
        expression: "contact.showAllCategories"
      }],
      class: _vm.style.contactCategoriesAll
    }, [_c('div', {
      class: _vm.style.contactCategoriesHide,
      on: {
        "click": function ($event) {
          contact.showAllCategories = !contact.showAllCategories;
        }
      }
    }, [_vm._v("\n                скрыть\n                "), _c('svg', {
      attrs: {
        "width": "10",
        "height": "7",
        "viewBox": "0 0 10 7",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M7.37582 6.35265L4.97507 2.54512L4.86307 2.54515L2.46382 6.35362L0.0798176 6.35408L4.20658 0.0492748L5.59858 0.0490026L9.77582 6.35219L7.37582 6.35265Z",
        "fill": "#202020"
      }
    })])]), _vm._v(" "), _c('div', {
      class: _vm.style.contactCategoriesHeader
    }, [_vm._v("\n                Курируемые категории ТРУ:\n              ")]), _vm._v(" "), _c('ul', _vm._l(contact.categories, function (category) {
      return _c('li', {
        key: category.code
      }, [_c('strong', [_vm._v(_vm._s(category.code))]), _vm._v("\n                  - " + _vm._s(category.name) + "\n                ")]);
    }), 0)])]) : _vm._e()]);
  })], 2)]), _vm._v(" "), _c('div', {
    class: _vm.style.contactsFooter
  })])], 2);
};

var __vue_staticRenderFns__$1d = [];
/* style */

const __vue_inject_styles__$1d = undefined;
/* scoped */

const __vue_scope_id__$1d = undefined;
/* module identifier */

const __vue_module_identifier__$1d = undefined;
/* functional template */

const __vue_is_functional_template__$1d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1d,
  staticRenderFns: __vue_staticRenderFns__$1d
}, __vue_inject_styles__$1d, __vue_script__$1d, __vue_scope_id__$1d, __vue_is_functional_template__$1d, __vue_module_identifier__$1d, false, undefined, undefined, undefined);

const OFFER_CARD_URI_TEMPLATE = "https://otc.ru/marketplace-b2b/offer";
const API_ADDRESSBOOK = "https://otc.ru/microservices-otc/addressbook";

var script$1c = {
  name: "Contacts",
  components: {
    CustomerContacts: __vue_component__$1d
  },
  props: {
    inn: String,
    kpp: String,
    name: String
  },
  computed: {
    authToken() {
      return null;
    },

    getCustomerData() {
      let authToken = this.authToken;
      let reqest = __vue_component__$1d.methods.createCustomerInnDataGetter(process.env.VUE_APP_API_ADDRESSBOOK || API_ADDRESSBOOK, () => authToken, 1000, 50);
      return reqest;
    }

  },
  methods: {}
};

/* script */
const __vue_script__$1c = script$1c;
/* template */

var __vue_render__$1c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.$style.box
  }, [_c('div', {
    class: _vm.$style.header
  }, [_c('div', [_vm._v("Контакты")])]), _vm._v(" "), _c('CustomerContacts', {
    class: _vm.$style.contacts,
    attrs: {
      "showOrganizations": false,
      "customers": [{
        inn: _vm.inn,
        kpp: _vm.kpp,
        name: _vm.name
      }],
      "getCustomerData": _vm.getCustomerData
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.$style.bottom
  })], 1);
};

var __vue_staticRenderFns__$1c = [];
/* style */

const __vue_inject_styles__$1c = function (inject) {
  if (!inject) return;
  inject("data-v-bfe59634_0", {
    source: ".src-components-OfferForProcedurePage-ModalContacts-box-1E2P{background-color:#6e7c8d;border-radius:8px 8px 22px 8px!important}.src-components-OfferForProcedurePage-ModalContacts-header-31Um{color:#fff;height:24px;display:flex;align-items:center;justify-content:space-between;padding:0 16px 0 8px}.src-components-OfferForProcedurePage-ModalContacts-contacts-1GAx{padding:0 5px 5px;border-radius:8px 8px 12px 8px!important}.src-components-OfferForProcedurePage-ModalContacts-bottom-1jow{height:10px;max-height:10px}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-OfferForProcedurePage-ModalContacts-box-1E2P",
      "header": "src-components-OfferForProcedurePage-ModalContacts-header-31Um",
      "contacts": "src-components-OfferForProcedurePage-ModalContacts-contacts-1GAx",
      "bottom": "src-components-OfferForProcedurePage-ModalContacts-bottom-1jow"
    }
  });
};
/* scoped */


const __vue_scope_id__$1c = undefined;
/* module identifier */

const __vue_module_identifier__$1c = undefined;
/* functional template */

const __vue_is_functional_template__$1c = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1c,
  staticRenderFns: __vue_staticRenderFns__$1c
}, __vue_inject_styles__$1c, __vue_script__$1c, __vue_scope_id__$1c, __vue_is_functional_template__$1c, __vue_module_identifier__$1c, false, createInjector, undefined, undefined);

var script$1b = {
  name: "ModalContacts",
  components: {
    Contacts: __vue_component__$1c,
    Modal: __vue_component__$1V
  },
  props: {
    inn: [Number, String],
    kpp: [Number, String],
    name: [Number, String]
  }
};

/* script */
const __vue_script__$1b = script$1b;
/* template */

var __vue_render__$1b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('Modal', {
    attrs: {
      "iconClose": false,
      "ownerWidth": "400",
      "ownerDimensionsSizeUnit": "px",
      "useBuiltInButtons": false,
      "showFooter": true
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    class: _vm.$style.close,
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('close');
      }
    }
  }, [_vm._v("✖")]), _vm._v(" "), _c('Contacts', _vm._b({}, 'Contacts', _vm.$props, false))], 1)]);
};

var __vue_staticRenderFns__$1b = [];
/* style */

const __vue_inject_styles__$1b = function (inject) {
  if (!inject) return;
  inject("data-v-377ceafe_0", {
    source: ".src-components-OfferForProcedurePage-ModalContacts-close-FRdR{position:absolute;color:#fff;font-size:14px;line-height:1;cursor:pointer;display:block;right:5px;top:5px}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "close": "src-components-OfferForProcedurePage-ModalContacts-close-FRdR"
    }
  });
};
/* scoped */


const __vue_scope_id__$1b = undefined;
/* module identifier */

const __vue_module_identifier__$1b = undefined;
/* functional template */

const __vue_is_functional_template__$1b = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1b,
  staticRenderFns: __vue_staticRenderFns__$1b
}, __vue_inject_styles__$1b, __vue_script__$1b, __vue_scope_id__$1b, __vue_is_functional_template__$1b, __vue_module_identifier__$1b, false, createInjector, undefined, undefined);

var script$1a = {
  name: "CheckBoxSmall",
  components: {
    IconInfo: __vue_component__$1O,
    Tooltip: __vue_component__$1N
  },
  props: {
    disable: {
      type: Boolean
    },
    name: {
      type: String
    },
    description: {
      type: String
    },
    value: {
      type: Boolean,
      default: undefined
    },
    defaultValue: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      stateValue: undefined
    };
  },

  computed: {
    checked() {
      if (this.value !== undefined) {
        return this.value;
      }

      if (this.defaultValue !== undefined) {
        if (this.stateValue !== undefined) {
          return this.stateValue;
        } else {
          return this.defaultValue;
        }
      }

      return false;
    }

  },
  methods: {
    hasValue: hasValue$1,

    handlerOnInput() {
      let v = !this.checked;
      this.stateValue = v;
      this.$emit("input", v);
    }

  }
};

/* script */
const __vue_script__$1a = script$1a;
/* template */

var __vue_render__$1a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "CheckBoxSmall",
    class: _vm.$style.box
  }, [_c('div', {
    class: _vm.$style.value,
    on: {
      "click": _vm.handlerOnInput
    }
  }, [!!_vm.checked ? [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M13.3333 2H2.66667C2.29848 2 2 2.29848 2 2.66667V13.3333C2 13.7015 2.29848 14 2.66667 14H13.3333C13.7015 14 14 13.7015 14 13.3333V2.66667C14 2.29848 13.7015 2 13.3333 2ZM2.66667 0C1.19391 0 0 1.19391 0 2.66667V13.3333C0 14.8061 1.19391 16 2.66667 16H13.3333C14.8061 16 16 14.8061 16 13.3333V2.66667C16 1.19391 14.8061 0 13.3333 0H2.66667Z",
      "fill": "#6E7C8D"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4 8.04883L7.13691 11.0781L12.3651 6.02933",
      "stroke": "#6E7C8D",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])] : _vm.checked === null ? [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M13.3333 2H2.66667C2.29848 2 2 2.29848 2 2.66667V13.3333C2 13.7015 2.29848 14 2.66667 14H13.3333C13.7015 14 14 13.7015 14 13.3333V2.66667C14 2.29848 13.7015 2 13.3333 2ZM2.66667 0C1.19391 0 0 1.19391 0 2.66667V13.3333C0 14.8061 1.19391 16 2.66667 16H13.3333C14.8061 16 16 14.8061 16 13.3333V2.66667C16 1.19391 14.8061 0 13.3333 0H2.66667Z",
      "fill": "#6E7C8D"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "5",
      "y": "5",
      "width": "6",
      "height": "6",
      "rx": "2",
      "fill": "#6E7C8D"
    }
  })])] : [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M13.3333 2H2.66667C2.29848 2 2 2.29848 2 2.66667V13.3333C2 13.7015 2.29848 14 2.66667 14H13.3333C13.7015 14 14 13.7015 14 13.3333V2.66667C14 2.29848 13.7015 2 13.3333 2ZM2.66667 0C1.19391 0 0 1.19391 0 2.66667V13.3333C0 14.8061 1.19391 16 2.66667 16H13.3333C14.8061 16 16 14.8061 16 13.3333V2.66667C16 1.19391 14.8061 0 13.3333 0H2.66667Z",
      "fill": _vm.disable ? '#d0cfcf' : '#6E7C8D'
    }
  })])]], 2), _vm._v(" "), _c('div', {
    class: _vm.$style.name,
    style: {
      color: _vm.disable && !_vm.checked ? '#d0cfcf' : null
    }
  }, [_vm._v("\n    " + _vm._s(_vm.name) + "\n  ")]), _vm._v(" "), _vm.hasValue(_vm.description) ? _c('div', [_c('Tooltip', {
    attrs: {
      "text": _vm.description
    }
  }, [_c('IconInfo')], 1)], 1) : _vm._e()]);
};

var __vue_staticRenderFns__$1a = [];
/* style */

const __vue_inject_styles__$1a = function (inject) {
  if (!inject) return;
  inject("data-v-00f48a52_0", {
    source: ".src-components-CheckBoxSmall-box-2JxS{user-select:none;box-sizing:border-box;display:flex;align-items:flex-start;flex-wrap:nowrap}.src-components-CheckBoxSmall-box-2JxS>*+*{margin-left:10px}.src-components-CheckBoxSmall-box-2JxS .src-components-CheckBoxSmall-value-2SqJ{display:flex;align-items:center;justify-content:center;cursor:pointer;margin-top:1px;width:16px;height:16px;min-width:16px;min-height:16px;max-width:16px;max-height:16px}.src-components-CheckBoxSmall-box-2JxS .src-components-CheckBoxSmall-name-1rXG{margin-top:2px;font-size:16px;line-height:16px;color:#202020;word-wrap:break-word}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-CheckBoxSmall-box-2JxS",
      "value": "src-components-CheckBoxSmall-value-2SqJ",
      "name": "src-components-CheckBoxSmall-name-1rXG"
    }
  });
};
/* scoped */


const __vue_scope_id__$1a = undefined;
/* module identifier */

const __vue_module_identifier__$1a = undefined;
/* functional template */

const __vue_is_functional_template__$1a = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1a,
  staticRenderFns: __vue_staticRenderFns__$1a
}, __vue_inject_styles__$1a, __vue_script__$1a, __vue_scope_id__$1a, __vue_is_functional_template__$1a, __vue_module_identifier__$1a, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$19 = {
  name: "TextInput",
  props: {
    tabindex: Number,
    placeholder: String,
    value: [String, Number],
    defaultValue: String,
    filter: Function,
    format: Function,
    inputRef: Function,
    maxlength: Number,
    minValue: Number
  },

  data() {
    return {
      prevText: null,
      nextText: null,
      change: false
    };
  },

  watch: {
    value: {
      immediate: true,

      handler(v) {
        let {
          format,
          nextText
        } = this;

        if (nextText !== v) {
          this.prevText = this.nextText = format && format(v) || v;
        }
      }

    },
    defaultValue: {
      immediate: true,

      handler(v) {
        let {
          value,
          change,
          nextText,
          filter,
          format
        } = this;

        if (value === undefined && !change) {
          if (filter) v = filter(v);
          if (nextText !== v) this.prevText = this.nextText = format && format(v) || v;
        }
      }

    }
  },

  mounted() {
    //this.$refs.input.focus();
    this.inputRef && this.inputRef(this.$refs.input);
  },

  methods: {
    focus() {
      this.$refs.input.focus();
    },

    handlerOnClick(e) {
      this.$emit('click', e);
    },

    handlerOnBlur(e) {
      this.$emit('blur', e);
    },

    handlerOnKeyup(e) {
      this.$emit('keyup', e);
    },

    handlerOnInput(e) {
      let {
        filter,
        prevText,
        nextText,
        value
      } = this;
      this.change = true;

      if (filter) {
        let txt = filter(nextText, prevText);
        if (txt !== nextText) this.nextText = nextText = txt;
      }

      this.$emit('input', nextText, e);

      if (value !== undefined) {
        this.$nextTick(() => {
          let {
            prevText,
            nextText,
            value
          } = this;
          if (value === prevText && prevText !== nextText) this.nextText = prevText;else this.prevText = nextText;
        });
      }
    },

    handlerOnChange(e) {
      let {
        format,
        nextText
      } = this;

      if (this.minValue != null && (!nextText || nextText < this.minValue)) {
        nextText = this.minValue.toString();
      }

      if (format) this.prevText = this.nextText = format(nextText);
      this.$emit('change', nextText, e);
    }

  }
};

/* script */
const __vue_script__$19 = script$19;
/* template */

var __vue_render__$19 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.nextText,
      expression: "nextText"
    }],
    ref: "input",
    staticClass: "TextInput",
    attrs: {
      "tabindex": _vm.tabindex,
      "type": "text",
      "size": "1",
      "maxlength": _vm.maxlength,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.nextText
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.nextText = $event.target.value;
      }, _vm.handlerOnInput],
      "change": _vm.handlerOnChange,
      "keyup": _vm.handlerOnKeyup,
      "blur": _vm.handlerOnBlur,
      "click": _vm.handlerOnClick,
      "keydown": function (e) {
        return _vm.$emit('keydown', e);
      }
    }
  });
};

var __vue_staticRenderFns__$19 = [];
/* style */

const __vue_inject_styles__$19 = function (inject) {
  if (!inject) return;
  inject("data-v-1b0b0853_0", {
    source: ".TextInput[data-v-1b0b0853]{height:32px;padding-left:5px;box-sizing:border-box}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$19 = "data-v-1b0b0853";
/* module identifier */

const __vue_module_identifier__$19 = undefined;
/* functional template */

const __vue_is_functional_template__$19 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$19 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$19,
  staticRenderFns: __vue_staticRenderFns__$19
}, __vue_inject_styles__$19, __vue_script__$19, __vue_scope_id__$19, __vue_is_functional_template__$19, __vue_module_identifier__$19, false, createInjector, undefined, undefined);

function flatTree(v) {
  if (typeof v === 'object' && !Array.isArray(v)) return v;

  let flt = (array, kv, prntKey, po) => {
    if (!kv) kv = {};
    if (!array || array.length <= 0) return kv;
    array.forEach(a => {
      if (!a) return;
      let key;
      if (hasValue(a.key)) key = a.key;else if (hasValue(a.id)) key = a.id;
      let child = a['child'];
      let value = {};

      for (let k in a) if (k !== 'child' && k !== 'key' && k !== 'id' && k !== 'hasChildren') value[k] = a[k];

      kv[key] = value;
      value['parent'] = hasValue(prntKey) ? prntKey : value['parent'];

      if (!hasValue(value['parent'])) {
        if (!kv['root']) kv['root'] = [];
        kv['root'].push(key);
      }

      if (po) {
        if (!po['child']) po['child'] = [];
        po['child'].push(key);
      }

      if (child && child.length > 0) {
        flt(child, kv, key, value);
      }
    });
    return kv;
  };

  let obj = flt(v);
  return obj;
}
function flatDict(v) {
  if (typeof v === 'object' && !Array.isArray(v)) return v;
  let kv = {};
  let array = v;
  if (!array || array.length <= 0) return kv;
  array.forEach(a => {
    if (!a || a.key === a.parent) return;
    let key;
    if (hasValue(a.key)) key = a.key;else if (hasValue(a.id)) key = a.id;
    let value = kv[key] || (kv[key] = {});

    for (let k in a) if (k !== 'child' && k !== 'key' && k !== 'id' && k !== 'hasChildren') value[k] = a[k];

    let pk = value['parent'];

    if (!hasValue(pk)) {
      if (!kv['root']) kv['root'] = [];
      kv['root'].push(key);
    } else {
      let po = kv[pk] || (kv[pk] = {});
      if (!po['child']) po['child'] = [];
      po['child'].push(key);
    }
  });
  return kv;
}
function toObj(array, getKey, getValue) {
  if (!array || array.length <= 0) return {};
  let obj = {};

  for (let i = 0; i < array.length; i++) {
    let item = array[i];
    if (!item) continue;
    let key;
    if (getKey) key = getKey(item);else key = item.key;
    if (!key) continue;
    let value;
    if (getValue) value = getValue(item);else value = item.value;
    obj[key] = value;
  }

  return obj;
}
function toArray(obj, map) {
  if (!obj) return [];

  if (Array.isArray(obj)) {
    let array = obj;
    if (!map) return array;else return array.map(map);
  }

  if (typeof obj !== 'object') {
    return [obj];
  }

  let keys = Object.keys(obj);
  let array = [];

  for (let i = 0; i < keys.length; i++) {
    let key = keys[i];
    let v = obj[key];

    if (map) {
      let item = map(obj);
      if (item) array.push(item);
    } else {
      array.push({
        key: key,
        value: v
      });
    }
  }

  return array;
} //--//

function objectOrArray(val, ifObject, ifArray) {
  if (!val) return val;

  if (typeof val === 'object') {
    if (Array.isArray(val)) {
      return ifArray(val);
    } else {
      return ifObject(val);
    }
  }

  return val;
}

function toCustomKeys(str, modifier) {
  if (!str) return '';
  if (!modifier) modifier = b => b;
  return String(str).replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, '').replace(/[^A-Za-z0-9]+/g, '$').replace(/([a-z0-9])([A-Z])/g, (m, a, b) => `${a}$${b}`).toLowerCase().replace(/(\$)(\w)/g, (m, a, b) => modifier(b));
}

function customKeys(obj, modifier) {
  if (!obj) return null;
  let target = objectOrArray(obj, o => {
    const res = {};

    for (const key in o) {
      let val = o[key];
      val = objectOrArray(val, v => customKeys(v, modifier), v => v.map(a => customKeys(a, modifier)));
      let nextKey = toCustomKeys(key, modifier);
      let old = res[nextKey];

      if (old && typeof old === 'object' && typeof val === 'object') {
        res[nextKey] = { ...old,
          ...val
        };
      } else {
        res[nextKey] = val;
      }
    }

    return res;
  }, o => {
    let res = o.map(a => customKeys(a, modifier));
    return res;
  });
  return target;
}
function camelKeys(obj) {
  return customKeys(obj, b => hasValue(b) ? b.toUpperCase() : b);
}
function lowerKeys(obj) {
  return customKeys(obj, b => b);
}
function lowerArray(array) {
  if (array && array.length > 0) {
    for (let i = 0; i < array.length; i++) {
      if (typeof array[i] === 'string') {
        array[i] = array[i].toLowerCase();
      }
    }
  }
}
function lowerCaseObjectArray(array) {
  if (!array) return;

  for (let i = 0; i < array.length; i++) {
    let keys = Object.keys(array[i]);

    for (let k = 0; k < keys.length; k++) {
      let key = keys[k];

      if (typeof array[i][key] === 'string') {
        array[i][key] = array[i][key].toLowerCase();
      }
    }
  }
}
function uuidv4$1() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = Math.random() * 16 | 0;
    let v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}
function allowDotsParse(obj) {
  let keys = Object.keys(obj);
  let target = {};

  for (let i = 0; i < keys.length; i++) {
    let key = keys[i];

    if (!key.includes('.')) {
      target[key] = obj[key];
    } else {
      let paths = key.split('.');
      let current = target;
      let last = null;
      let max = paths.length - 1;

      for (let j = 0; j < max; j++) {
        let path = paths[j];
        last = current[path];

        if (!last) {
          last = {};
        }

        current[path] = last;
        current = last;
      }

      let endPath = paths[paths.length - 1];
      last[endPath] = obj[key];
    }
  }

  return target;
}
function allowDotsSerialize(obj) {
  if (!obj) return obj;

  let serialize = v => {
    let any = false;
    let current = v;

    do {
      any = false;
      let ks = Object.keys(current);
      let trg = {};

      for (let i = 0; i < ks.length; i++) {
        let key = ks[i];
        let val = current[key];

        if (val && typeof val === 'object' && !Array.isArray(val)) {
          let nstKeys = Object.keys(val);

          for (let j = 0; j < nstKeys.length; j++) {
            let nstKey = nstKeys[j];
            let nstVal = val[nstKey];
            let newKey = key + '.' + nstKey;
            trg[newKey] = nstVal;
            if (typeof nstVal === 'object' && !Array.isArray(val)) any = true;
          }
        } else {
          trg[key] = val;
        }
      }

      current = trg;
    } while (any);

    return current;
  };

  let target = serialize(obj);
  return target;
}

function hasValue(value) {
  if (value === null) return false;
  if (value === undefined) return false;
  if (value === '') return false;
  if (value === 0) return true;
  if (typeof value === 'object' && Array.isArray(value) && value.length <= 0) return false;
  if (value) return true;
  return false;
}

function clearEmpty(obj) {
  if (!obj) return;
  let trg = {};
  let keys = Object.keys(obj);

  for (let i = 0; i < keys.length; i++) {
    let key = keys[i];
    let val = obj[key];
    if (!hasValue(val)) continue;
    trg[key] = val;
  }

  return trg;
}
function get(v, path, map, def) {
  if (v === null || v === undefined) return v;
  if (path && typeof path === 'string') path = path.split('.');

  if (path && path.length > 0) {
    let key = path[0];

    if (typeof v === 'object') {
      if (path.length > 1) {
        let relativePath = [...path];
        relativePath.splice(0, 1);
        let val = get(v[key], relativePath);
        return map ? map(val) : val;
      } else if (v[key] !== null && v[key] !== undefined) {
        return map ? map(v[key]) : v[key];
      } else {
        return def !== undefined ? def : v[key];
      }
    }
  } else {
    return v !== null && v !== undefined ? map(v) : def !== undefined ? def : v;
  }

  return undefined;
}

var obj = /*#__PURE__*/Object.freeze({
  __proto__: null,
  flatTree: flatTree,
  flatDict: flatDict,
  toObj: toObj,
  toArray: toArray,
  customKeys: customKeys,
  camelKeys: camelKeys,
  lowerKeys: lowerKeys,
  lowerArray: lowerArray,
  lowerCaseObjectArray: lowerCaseObjectArray,
  uuidv4: uuidv4$1,
  allowDotsParse: allowDotsParse,
  allowDotsSerialize: allowDotsSerialize,
  clearEmpty: clearEmpty,
  get: get
});

const applicationStateEnum = {
  /// <summary>
  /// Черновик
  /// </summary>
  Draft: 1,
  /// <summary>
  /// Подана
  /// </summary>
  Complete: 2,
  /// <summary>
  /// Допущена
  /// </summary>
  Accepted: 3,
  /// <summary>
  /// Допущена по первой части
  /// </summary>
  AcceptedByPart1: 11,
  /// <summary>
  /// Допущена по второй части
  /// </summary>
  AcceptedByPart2: 8,
  /// <summary>
  /// Не допущена
  /// </summary>
  Rejected: 4,
  /// <summary>
  /// Не допущена по первой части
  /// </summary>
  RejectedByPart1: 9,
  /// <summary>
  /// Не допущена по второй части
  /// </summary>
  RejectedByPart2: 10,
  /// <summary>
  /// Отозвана
  /// </summary>
  Withdrawn: 5,
  /// <summary>
  /// Отозвана системой при отказе от лота
  /// </summary>
  WithdrawnBySystem: 6,
  /// <summary>
  /// Отменена
  /// </summary>
  Canceled: 7,
  /// <summary>
  /// Признан победителем
  /// </summary>
  Winner: 20,
  /// <summary>
  /// Не признан победителем
  /// </summary>
  Loser: 21,
  /// <summary>
  /// Постквалификация пройдена
  /// </summary>
  PostqualificationAccepted: 14,
  /// <summary>
  /// Постквалификация не пройдена
  /// </summary>
  PostqualificationRejected: 15,
  /// <summary>
  /// Приглашена к постквалификации
  /// </summary>
  AccessedToPostqualification: 16,
  /// <summary>
  /// Отстранена от процедуры
  /// </summary>
  RemovedFromTrade: 17,
  /// <summary>
  /// Ожидает корректировки
  /// </summary>
  CorrectionWaiting: 18,
  /// <summary>
  /// Не актуальна
  /// </summary>
  NotActual: 22,
  /// <summary>
  /// Временная копия
  /// </summary>
  TempCopy: 23,
  /// <summary>
  /// В обработке
  /// </summary>
  Processing: 24
};
var applicationStateEnum$1 = Object.freeze(applicationStateEnum);

const applicationItemStateEnum = {
  Undefined: 0,
  Winner: 1,
  Loser: 2,
  Rejected: 3
};
var applicationItemStateEnum$1 = Object.freeze(applicationItemStateEnum);

var script$18 = {
  name: "CounterpartySlider",
  components: {
    IconRub: __vue_component__$1k
  },
  inject: {
    team: {
      default: () => "default"
    }
  },
  props: {
    pointClass: String,
    modePoint: {
      type: String,
      default: "point",

      validator(v) {
        return ["point", "line"].includes(v);
      }

    },
    modeText: {
      type: String,
      default: "in",

      validator(v) {
        return ["in", "bottom"].includes(v);
      }

    },
    textPoint: {
      type: String,
      default: null
    },
    textPointIconRub: {
      type: Boolean,
      default: true
    },
    styleBackground: {
      type: String,
      default: "linear-gradient(90deg, #EE2B45 0%, #B14BDE 50.83%, #34BDF3 100%)"
    },
    backgroundAdaptive: {
      type: Boolean,
      default: null
    },
    backgroundAdaptiveColor: {
      type: String,
      default: null
    },
    text1: {
      type: String,
      default: null
    },
    text2: {
      type: String,
      default: null
    },
    value: {
      type: Number,
      default: 30
    },
    stylePointMarginLeft: {
      type: [String, Number],
      default: null
    },
    stylePointMarginRight: {
      type: [String, Number],
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    textPadding: {
      type: String
    },
    zoom: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      animationShowTextPoint: true,
      animationShowTextPointId: null,
      animationValue: null,
      animationId: null
    };
  },

  computed: {
    marginLeft() {
      let margin = this.stylePointMarginLeft;
      if (this.modePoint == "piont" && !margin) margin = 14;
      if (!margin) return 0;
      let sMargin = `${parseInt(margin)}em`;
      return sMargin;
    },

    marginRight() {
      let margin = this.stylePointMarginRight;
      if (this.modePoint == "piont" && !margin) margin = 14;
      if (!margin) return 0;
      let sMargin = `${parseInt(margin)}em`;
      return sMargin;
    },

    v() {
      if (this.value === 0) return 0;
      if (this.animationId) return this.animationValue;
      return this.value || 0;
    },

    sliderBackgroundStyle() {
      if (!this.backgroundAdaptive) return {};
      return {
        right: this.marginRight,
        left: this.marginLeft
      };
    },

    sliderPointStyle() {
      return {
        right: this.marginRight,
        left: this.marginLeft
      };
    }

  },
  watch: {
    value: {
      handler(v) {
        if (this.animationShowTextPointId) {
          clearInterval(this.animationShowTextPointId);
          this.animationShowTextPointId = true;
        }

        this.animationShowTextPoint = false;
        this.animationShowTextPointId = setTimeout(() => {
          this.animationShowTextPoint = true;
        }, 3000);
      },

      immediate: true
    },
    loading: {
      handler(v) {
        if (this.animationId) {
          let animationId = this.animationId;
          this.animationId = null;
          clearInterval(animationId);
        }

        if (v) {
          this.animationValue = 0;
          this.animationId = setInterval(() => {
            this.animationValue = this.animationValue ? 0 : 100;
          }, 1 * 3000);
        }
      },

      immediate: true
    }
  },
  methods: {
    getRandomValue() {
      return Math.floor(Math.random() * 100);
    }

  }
};

/* script */
const __vue_script__$18 = script$18;
/* template */

var __vue_render__$18 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: [_vm.$style.box, _vm.team == 'dark' && _vm.$style.dark],
    style: "font-size: " + 10 * _vm.zoom + "px; line-height: 1;"
  }, [_c('div', {
    class: _vm.$style.slider
  }, [_c('div', {
    class: _vm.$style.sliderBackgroundBox
  }, [_c('div', {
    class: [_vm.$style.sliderBackground],
    style: "background: " + _vm.styleBackground + "; right: 0%"
  })]), _vm._v(" "), _vm.v < 100 ? _c('div', {
    class: _vm.$style.sliderBackgroundBox
  }, [_c('div', {
    class: [_vm.backgroundAdaptive && _vm.$style.jag],
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "bottom": "0",
      "top": "0"
    },
    style: "width: " + parseInt(_vm.marginRight) / 10 + "em;"
  })]) : _vm._e(), _vm._v(" "), _vm.v < 100 ? _c('div', {
    class: _vm.$style.sliderBackgroundBox
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "0",
      "right": "0",
      "bottom": "0",
      "top": "0"
    },
    style: _vm.marginLeft && _vm.marginRight && "left: " + parseInt(_vm.marginLeft) / 10 + "em; right: " + parseInt(_vm.marginRight) / 10 + "em;" || ''
  }, [_c('div', {
    class: [_vm.$style.sliderBackground, _vm.$style.slideLeftAnimation, _vm.backgroundAdaptive && _vm.$style.sliderBackgroundAdaptive],
    staticStyle: {
      "right": "0"
    },
    style: {
      left: _vm.v + "%"
    }
  })])]) : _vm._e(), _vm._v(" "), _vm.backgroundAdaptive ? _c('div', {
    class: _vm.$style.sliderBackgroundBox,
    style: "border: " + (_vm.backgroundAdaptive ? _vm.team == 'dark' ? '1px solid white' : '1px solid black' : 'none')
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "bottom": "0",
      "top": "0",
      "left": "1.4em",
      "right": "1.4em"
    },
    style: _vm.marginLeft && _vm.marginRight && "left: " + parseInt(_vm.marginLeft) / 10 + "em; right: " + parseInt(_vm.marginRight) / 10 + "em;" || ''
  }, [_c('div', {
    class: [_vm.$style.sliderBackground, _vm.$style.slideLeftAnimation],
    staticStyle: {
      "right": "0"
    },
    style: {
      left: _vm.v + "%"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "right": "50%"
    }
  }, [_c('div', {
    class: [_vm.modePoint == 'line' ? _vm.$style.pointLine : _vm.$style.point, _vm.pointClass]
  }, [_vm.animationShowTextPoint && _vm.textPoint && _vm.value >= 10 && _vm.value <= 90 ? _c('div', {
    class: _vm.$style.pointText,
    staticStyle: {
      "left": "0.5em"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.textPoint))]), _vm._v(" "), _vm.textPointIconRub ? _c('div', {
    staticStyle: {
      "margin-left": "0.5em"
    }
  }, [_c('IconRub')], 1) : _vm._e()]) : _vm._e()])])])])]), _vm._v(" "), _vm.animationShowTextPoint && _vm.textPoint && (_vm.value < 10 || _vm.value > 90) ? _c('div', {
    class: _vm.$style.pointText,
    staticStyle: {
      "position": "absolute",
      "top": "-1.8em"
    },
    style: _vm.value < 10 ? "left: 0" : "right: 0"
  }, [_c('div', [_vm._v(_vm._s(_vm.textPoint))]), _vm._v(" "), _vm.textPointIconRub ? _c('div', {
    staticStyle: {
      "margin-left": "0.5em"
    }
  }, [_c('IconRub')], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.modeText == 'in' ? [_c('div', {
    class: _vm.$style.textBox,
    style: "left: 0.8em;"
  }, [_c('div', {
    class: [_vm.$style.text],
    style: 'color: white'
  }, [_vm._v(_vm._s(_vm.text1))])]), _vm._v(" "), _c('div', {
    class: _vm.$style.textBox,
    style: "right: 0.8em;"
  }, [_c('div', {
    class: [_vm.$style.text],
    style: !_vm.backgroundAdaptive && 'color: white'
  }, [_vm._v("\n          " + _vm._s(_vm.text2) + "\n        ")])])] : _vm._e()], 2), _vm._v(" "), _vm.modeText == 'bottom' ? [_c('div', {
    style: "display: flex; justify-content: space-between; margin: " + (_vm.modePoint === 'point' ? 0.6 : 1.2) + "em 0.8em 0"
  }, [_c('div', {
    class: _vm.$style.text,
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.text1))]), _vm._v(" "), _c('div', {
    class: _vm.$style.text,
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.text2))])])] : _vm._e()], 2);
};

var __vue_staticRenderFns__$18 = [];
/* style */

const __vue_inject_styles__$18 = function (inject) {
  if (!inject) return;
  inject("data-v-41ab8159_0", {
    source: ".src-components-box-14CJ{font-size:10px;line-height:1}.src-components-sliderBackgroundAdaptive-1XI3{background-color:#fff}.src-components-jag-3xFh{background-color:#364150}.src-components-sliderBackgroundBox-1hwZ{border-radius:1.2em 1.2em 1.2em 1.2em!important;overflow:hidden;position:absolute;left:0;right:0;top:0;bottom:0}.src-components-slider-2qFJ{height:2.4em;border-radius:1.2em!important;position:relative;display:flex;align-items:center;justify-content:space-between;padding:0 10px}.src-components-slideLeftAnimation-1JPW{transition:left 3s linear}.src-components-slideRightAnimation-37cr{transition:right 3s linear}.src-components-sliderBackground-37hd{display:flex;justify-content:flex-start;align-items:center;position:absolute;left:0;top:0;bottom:0}.src-components-sliderBackgroundNo100-3pmk{border-radius:1.2em 0 0 1.2em!important}.src-components-sliderPoint-111P{display:flex;align-items:center}.src-components-textBox-1JDX{height:100%;position:absolute;top:0;bottom:.2em;display:flex;align-items:center}.src-components-text-3woK{line-height:1.6em;font-size:1.6em;color:#53565a}.src-components-point-5PPA{position:relative;width:.1em;min-width:3.2em;max-width:3.2em;max-height:3.2em;min-height:3.2em;height:3.2em;border:.2em solid #34bdf3;background-color:#fff;border-radius:100%!important}.src-components-pointLine-ueWs{position:relative;width:.1em;min-width:.1em;max-width:.1em;border:.1em dashed #fff;height:4em;max-height:4em;min-height:4em}.src-components-pointText-2bGD{position:relative;top:-1.8em;color:#53565a;font-size:1.6em;line-height:1;display:flex;align-items:center;justify-content:center;white-space:nowrap}.src-components-dark--Y-T .src-components-pointText-2bGD{color:#fff}.src-components-dark--Y-T .src-components-text-3woK{color:#fff}.src-components-dark--Y-T .src-components-sliderBackgroundAdaptive-1XI3{background-color:#364150}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-box-14CJ",
      "sliderBackgroundAdaptive": "src-components-sliderBackgroundAdaptive-1XI3",
      "jag": "src-components-jag-3xFh",
      "sliderBackgroundBox": "src-components-sliderBackgroundBox-1hwZ",
      "slider": "src-components-slider-2qFJ",
      "slideLeftAnimation": "src-components-slideLeftAnimation-1JPW",
      "slideRightAnimation": "src-components-slideRightAnimation-37cr",
      "sliderBackground": "src-components-sliderBackground-37hd",
      "sliderBackgroundNo100": "src-components-sliderBackgroundNo100-3pmk",
      "sliderPoint": "src-components-sliderPoint-111P",
      "textBox": "src-components-textBox-1JDX",
      "text": "src-components-text-3woK",
      "point": "src-components-point-5PPA",
      "pointLine": "src-components-pointLine-ueWs",
      "pointText": "src-components-pointText-2bGD",
      "dark": "src-components-dark--Y-T"
    }
  });
};
/* scoped */


const __vue_scope_id__$18 = undefined;
/* module identifier */

const __vue_module_identifier__$18 = undefined;
/* functional template */

const __vue_is_functional_template__$18 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$18 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$18,
  staticRenderFns: __vue_staticRenderFns__$18
}, __vue_inject_styles__$18, __vue_script__$18, __vue_scope_id__$18, __vue_is_functional_template__$18, __vue_module_identifier__$18, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$17 = {
  name: "InfoItem",
  props: {
    name: String,
    value: String,
    showPoints: {
      type: Boolean,

      default() {
        return true;
      }

    }
  },

  data() {
    return {};
  }

};

/* script */
const __vue_script__$17 = script$17;
/* template */

var __vue_render__$17 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "InfoItem"
  }, [_c('div', {
    staticClass: "infoItemItemName"
  }, [_vm._t("name", [_vm._v("\n      " + _vm._s(_vm.name) + "\n    ")])], 2), _vm._v(" "), _vm.showPoints ? _c('div', {
    staticClass: "infoItemItemPoints"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "infoItemItemValue"
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.value))])], 2)]);
};

var __vue_staticRenderFns__$17 = [];
/* style */

const __vue_inject_styles__$17 = function (inject) {
  if (!inject) return;
  inject("data-v-65d78840_0", {
    source: ".InfoItem[data-v-65d78840]{font-size:16px;display:flex;justify-content:space-between;align-items:flex-end}.InfoItem .infoItemItemPoints[data-v-65d78840]{height:1px;margin:0 5px 3px 5px;flex-grow:1;border-bottom:2px dotted rgba(41,47,54,.2)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$17 = "data-v-65d78840";
/* module identifier */

const __vue_module_identifier__$17 = undefined;
/* functional template */

const __vue_is_functional_template__$17 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$17 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$17,
  staticRenderFns: __vue_staticRenderFns__$17
}, __vue_inject_styles__$17, __vue_script__$17, __vue_scope_id__$17, __vue_is_functional_template__$17, __vue_module_identifier__$17, false, createInjector, undefined, undefined);

var script$16 = {
  name: "InfoList",
  components: {
    InfoItem: __vue_component__$17
  },
  props: {
    items: {
      type: Array
    }
  }
};

/* script */
const __vue_script__$16 = script$16;
/* template */

var __vue_render__$16 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "InfoList"
  }, _vm._l(_vm.items, function (item, index) {
    return _c('InfoItem', {
      key: index,
      attrs: {
        "name": item.name,
        "value": item.value
      },
      scopedSlots: _vm._u([{
        key: "name",
        fn: function () {
          return [_vm._t("name", null, null, item)];
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), [_vm._t("default", null, null, item)]], 2);
  }), 1);
};

var __vue_staticRenderFns__$16 = [];
/* style */

const __vue_inject_styles__$16 = function (inject) {
  if (!inject) return;
  inject("data-v-31f21b52_0", {
    source: ".InfoList>*+*[data-v-31f21b52]{margin-top:15px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$16 = "data-v-31f21b52";
/* module identifier */

const __vue_module_identifier__$16 = undefined;
/* functional template */

const __vue_is_functional_template__$16 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$16 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$16,
  staticRenderFns: __vue_staticRenderFns__$16
}, __vue_inject_styles__$16, __vue_script__$16, __vue_scope_id__$16, __vue_is_functional_template__$16, __vue_module_identifier__$16, false, createInjector, undefined, undefined);

var base = {
  name: "CounterpartyWidget",
  props: {
    reliability: Object,
    limit: Object,
    contractExecutionRisks: Object
  },
  computed: {
    contractExecutionRisksLoading() {
      if (!this.contractExecutionRisks) return false;
      let loading = this.contractExecutionRisks.loading;
      let dataIsEmpty = this.contractExecutionRisks.dataIsEmpty !== false;
      return loading && dataIsEmpty;
    },

    reliabilityLoading() {
      return get(this.reliability, "loading") && get(this.reliability, "dataIsEmpty") !== false;
    },

    sliderInvert() {
      let slider = this.slider;
      let invert = 100 - slider;
      if (invert == 1) return 0;
      return invert;
    },

    slider() {
      let defaultMaxValue = 99;
      let v = get(this.reliability, "data.failureProbabilityPercent"); //Категория вероятности срыва контракта.

      if (v != null) {
        /*
        from(%)	to(%)	category
        0	0.5	Very_low
        0.5	1	Low
        1	2.5	Averege
        2.5	7	High
        7	100	Very_high
        */
        let percent_position = 0;
        let min_border = 0;
        let max_border = 0;

        if (v >= 0 && v < 0.5) {
          percent_position = 0;
          min_border = 0;
          max_border = 0.5;
        } else if (v >= 0.5 && v < 1) {
          min_border = 0.5;
          max_border = 1;
          percent_position = 20;
        } else if (v >= 1 && v < 2.5) {
          min_border = 1;
          max_border = 2.5;
          percent_position = 40;
        } else if (v >= 2.5 && v < 7) {
          min_border = 2.5;
          max_border = 7;
          percent_position = 60;
        } else {
          min_border = 7;
          max_border = 100;
          percent_position = 80;
        }

        let diff = max_border - min_border;

        if (diff <= 0) {
          return defaultMaxValue;
        }

        let result = percent_position + (v - min_border) / diff * 20;

        if (result > defaultMaxValue) {
          return defaultMaxValue;
        }

        return result;
      } //Категория риска займа.
      else {
          v = get(this.reliability, "data.creditRatingCategory");

          if (!v) {
            return defaultMaxValue;
          }

          v = v.toUpperCase();
          if (v == "AAA") return 10;
          if (v == "AA") return 20;
          if (v == "A") return 30;
          if (v == "BBB") return 40;
          if (v == "BB") return 50;
          if (v == "B") return 60;
          if (v == "CCC") return 70;
          if (v == "CC") return 80;
          if (v == "C") return 90;
          if (v == "D") return defaultMaxValue;
          return defaultMaxValue;
        }
    },

    showRisks() {
      return this.hasTender;
    },

    risksLoading() {
      if (!this.contractExecutionRisks) return false;

      if (this.contractExecutionRisks.data && (this.contractExecutionRisks.data.tenderPrice || this.contractExecutionRisks.data.tenderPrice == 0)) {
        return false;
      }

      return this.contractExecutionRisks.loading;
    },

    limitLoading() {
      if (!this.limit) return false;
      return this.limit.loading && this.limit.dataIsEmpty !== false;
    },

    risks() {
      let contractExecutionRisks = {};

      if (this.contractExecutionRisks && this.contractExecutionRisks.data) {
        contractExecutionRisks = this.contractExecutionRisks.data;
      }

      const result = {
        tenderPrice: null,
        revenue: null,
        revenueRate: 0,
        assets: null,
        assetsRate: 0,
        contractsSum: null,
        contractsSumRate: 0,
        maxContractPrice: null,
        maxContractPriceRate: 0,
        ...contractExecutionRisks
      };

      if (result.revenueRate == null) {
        result.revenueRate = 1;
      }

      if (result.assetsRate == null) {
        result.assetsRate = 1;
      }

      if (result.contractsSumRate == null) {
        result.contractsSumRate = 1;
      }

      if (result.maxContractPriceRate == null) {
        result.maxContractPriceRate = 2;
      }

      result.loading = this.risksLoading;
      return result;
    },

    limitText() {
      let limit = get(this.limit, "data.limit");
      let nmc = get(this.risks, "tenderPrice");
      if (nmc == 0 && limit > 0) return "0";
      if (limit >= nmc) return toMoney$1(nmc);
      return toMoney$1(limit);
    },

    limitSlider() {
      let nmc = get(this.risks, "tenderPrice");
      let limit = get(this.limit, "data.limit");
      if (!nmc || !limit) return 0;
      if (nmc == 0 && limit > 0) return 0;
      if (limit >= nmc) return 100;
      let r = limit / nmc * 100;
      if (!r) r = 1;
      return Math.floor(r);
    }

  }
};

//
var script$15 = {
  name: "Loader",
  props: {
    zoom: Number,
    text: String,
    height: Number,
    color: String,
    delay: {
      type: [String, Number],

      default() {
        return 0;
      }

    }
  },

  data() {
    return {
      show: false
    };
  },

  computed: {
    isIEBrowser() {
      return isIE();
    },

    showLoader() {
      return this.show || !this.delayMilliseconds || this.delayMilliseconds < 0;
    },

    delayMilliseconds() {
      if (!this.delay) return 0;
      return parseInt(this.delay);
    }

  },

  mounted() {
    if (this.delayMilliseconds && this.delayMilliseconds > 0) {
      let th = this;
      setTimeout(() => {
        th.show = true;
      }, this.delayMilliseconds);
    } else {
      this.show = true;
    }
  }

};

/* script */
const __vue_script__$15 = script$15;
/* template */

var __vue_render__$15 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.showLoader ? _c('div', {
    class: _vm.$style.loader,
    style: {
      'font-size': 10 * _vm.zoom + " px !important",
      'min-height': _vm.height ? _vm.height / 10 + "em" : null,
      'background-color': _vm.color ? _vm.color : null
    }
  }, [_vm.text ? _c('div', {
    style: {
      'margin-bottom': !_vm.isIEBrowser ? '1em' : null
    }
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]) : _vm._e(), _vm._v(" "), !_vm.text && _vm.isIEBrowser ? _c('div', {
    staticStyle: {
      "font-size": "1.6em",
      "line-height": "1"
    }
  }, [_vm._v("\n    Загрузка, подождите пожалуйста ...\n  ")]) : _vm._e(), _vm._v(" "), !_vm.isIEBrowser ? _c('div', {
    class: _vm.$style.ldsLoader
  }, [_c('div'), _c('div'), _c('div')]) : _vm._e()]) : _vm._e();
};

var __vue_staticRenderFns__$15 = [];
/* style */

const __vue_inject_styles__$15 = function (inject) {
  if (!inject) return;
  inject("data-v-716c7890_0", {
    source: ".src-components-loader-3vqi{padding:1em;display:flex;justify-content:center!important;align-items:center!important;flex-direction:column}.src-components-ldsLoader-3FIH{display:inline-block!important;position:relative!important;width:5.9em!important;height:1.7em!important}.src-components-ldsLoader-3FIH div{display:inline-block!important;position:absolute!important;width:1.7em!important;border-radius:.5em!important;background:#c4c4c4!important;animation:src-components-ldsLoader-3FIH 1.2s cubic-bezier(0,.5,.5,1) infinite}.src-components-ldsLoader-3FIH div:nth-child(1){left:.1em!important;animation-delay:-.24s}.src-components-ldsLoader-3FIH div:nth-child(2){left:2.1em!important;animation-delay:-.12s}.src-components-ldsLoader-3FIH div:nth-child(3){left:4.1em!important;animation-delay:0}@keyframes src-components-ldsLoader-3FIH{0%{background:#000}100%,50%{height:1.7em}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "loader": "src-components-loader-3vqi",
      "ldsLoader": "src-components-ldsLoader-3FIH"
    }
  });
};
/* scoped */


const __vue_scope_id__$15 = undefined;
/* module identifier */

const __vue_module_identifier__$15 = undefined;
/* functional template */

const __vue_is_functional_template__$15 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$15 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$15,
  staticRenderFns: __vue_staticRenderFns__$15
}, __vue_inject_styles__$15, __vue_script__$15, __vue_scope_id__$15, __vue_is_functional_template__$15, __vue_module_identifier__$15, false, createInjector, undefined, undefined);

var script$14 = {
  name: "CounterpartyLoading",
  components: {
    Loader: __vue_component__$15,
    LoaderSmall: __vue_component__$1l
  },
  props: {
    zoom: {
      type: Number,
      default: 1
    },
    mode: {
      type: String,
      default: null,

      validator(v) {
        return [null, "small"].includes(v);
      }

    },
    value: {
      type: [Boolean, Object, String, Number, Array],
      default: null
    },
    loading: {
      type: [Boolean, Object],
      default: true
    },
    height: String
  },
  computed: {
    style() {
      if (!this.height) return {};
      return {
        height: this.height
      };
    },

    showLoader() {
      // если есть значение то не показываем лоадер
      if (this.value != null) return false; // показываем лоадер если нужно показать лоадер

      if (this.loading) return true;
      return false;
    }

  }
};

/* script */
const __vue_script__$14 = script$14;
/* template */

var __vue_render__$14 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: [_vm.showLoader && _vm.$style.loadingBox],
    style: _vm.style
  }, [_vm.showLoader && _vm.mode == null ? _c('Loader', {
    attrs: {
      "zoom": _vm.zoom
    }
  }) : _vm.showLoader && _vm.mode == 'small' ? _c('LoaderSmall', {
    attrs: {
      "zoom": _vm.zoom
    }
  }) : [_vm._t("default")]], 2);
};

var __vue_staticRenderFns__$14 = [];
/* style */

const __vue_inject_styles__$14 = function (inject) {
  if (!inject) return;
  inject("data-v-101cc077_0", {
    source: ".src-components-loadingBox-2HoO{display:flex;align-items:center}.src-components-loadingBox-2HoO>*{flex:1}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "loadingBox": "src-components-loadingBox-2HoO"
    }
  });
};
/* scoped */


const __vue_scope_id__$14 = undefined;
/* module identifier */

const __vue_module_identifier__$14 = undefined;
/* functional template */

const __vue_is_functional_template__$14 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$14 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$14,
  staticRenderFns: __vue_staticRenderFns__$14
}, __vue_inject_styles__$14, __vue_script__$14, __vue_scope_id__$14, __vue_is_functional_template__$14, __vue_module_identifier__$14, false, createInjector, undefined, undefined);

const ImageNoPhoto = null;
const PURCHASER_TERMS_TYPE__CUSTOMER_TERMS = {
  Value: 1,
  Name: 'CustomerTerms'
};
const PURCHASER_TERMS_TYPE__PURCHASER_TERMS = {
  Value: 2,
  Name: 'PurchaserTerms'
};
var script$13 = {
  name: "OfferForProcedure",
  mixins: [base],
  components: {
    ButtonGrey: __vue_component__$1n,
    ButtonRed: __vue_component__$1X,
    ButtonWhite: __vue_component__$1m,
    Modal: __vue_component__$1V,
    Loader: __vue_component__$1l,
    InfoList: __vue_component__$16,
    IconRub: __vue_component__$1k,
    IconChat: __vue_component__$1p,
    Slider: __vue_component__$18,
    IconXls: __vue_component__$1S,
    IconWord: __vue_component__$1o,
    CounterpartyLoading: __vue_component__$14,
    ModalContacts: __vue_component__$1b,
    CheckBoxSmall: __vue_component__$1a,
    TextInput: __vue_component__$19
  },
  props: {
    counterparty: Object,
    urlCounterpartyPage: String,
    inn: String,
    kpp: String,
    externalId: [String, Number],
    externalSource: String,
    name: String,
    specs: Array,
    price: Number,
    unit: String,
    thumbnailUrl: String,
    supplierOffersCount: Number,
    small: {
      type: Boolean,
      default: false
    },
    applicationItemState: {
      type: Number,
      default: 0
    },
    applicationItemStateName: {
      type: String,
      default: null
    },
    state: {
      type: Number,
      default: null
    },
    stateName: null,
    amount: null,
    nds: null,
    fullNds: null,
    dealId: null,
    isItemInDeal: {
      type: Boolean,
      default: false
    },
    terms: {
      type: Object
    },
    buyBtnName: String,
    rejectBtnName: String,
    setBtnVisible: {
      type: Boolean,
      default: false
    },
    showBuyBtn: {
      type: Boolean,
      default: false
    },
    showRejectBtn: {
      type: Boolean,
      default: false
    },
    hideTermsTitle: {
      type: Boolean,
      default: false
    },
    showSignatureLink: {
      type: Boolean,
      default: false
    },
    setCheckboxVisible: {
      type: Boolean,
      default: false
    },
    cbValue: {
      type: Boolean,
      default: false
    },
    setTextboxVisible: {
      type: Boolean,
      default: false
    },
    tbValue: String,
    cbName: String,
    tbName: String,
    lotItemIndex: {
      type: Number,
      default: null
    },
    lotItemName: {
      type: String,
      default: null
    },
    showCompanyRisk: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      count: 1,
      modalContacts: null,
      chatVisible: false,
      applicationStateEnum: applicationStateEnum$1,
      applicationItemStateEnum: applicationItemStateEnum$1
    };
  },

  computed: {
    stateDisplayParams() {
      let state = this.state;
      let applicationItemState = this.applicationItemState;

      if (state == applicationStateEnum$1.Draft) {
        return {
          color: "#F4B50A"
        };
      }

      if (applicationItemState == applicationItemStateEnum$1.Winner) {
        return {
          color: "#62BEC1",
          text: this.applicationItemStateName
        };
      }

      if (applicationItemState == applicationItemStateEnum$1.Loser) {
        return {
          color: "#EE2B45",
          text: this.applicationItemStateName
        };
      }

      if (applicationItemState == applicationItemStateEnum$1.Rejected) {
        return {
          color: "#EE2B45",
          text: this.applicationItemStateName
        };
      }

      if (state == applicationStateEnum$1.Complete || state == applicationStateEnum$1.Winner) {
        return {
          color: "#62BEC1" //text: "Подтверждено",

        };
      }

      if (state == applicationStateEnum$1.Rejected || state == applicationStateEnum$1.Canceled) {
        return {
          color: "#EE2B45" //text: "Отклонено",

        };
      }

      return {
        color: "grey"
      };
    },

    city() {
      let counteragentAddresses = get(this.counterparty, "data.counteragentAddresses");
      if (!counteragentAddresses) return null;
      let addresses = counteragentAddresses.find(a => a.addressType == 1);
      if (!addresses) return null;
      return addresses.city;
    },

    shortNameLoading() {
      return get(this.counterparty, "loading") && get(this.counterparty, "dataIsEmpty") !== false;
    },

    shortName() {
      return get(this.counterparty, "data.shortName") || get(this.counterparty, "data.fullName");
    },

    stopFactors() {
      let reliabilityData = this.reliability && this.reliability.data;
      let stopResults = reliabilityData && reliabilityData.stopResults;
      if (!stopResults || stopResults.length <= 0) return [{
        style: {
          visibility: "hidden"
        }
      }]; // отображаем скрытый элемент чтобы просто занимал место

      let contRed = stopResults.filter(a => a.value === true).length;
      let contGreen = stopResults.filter(a => a.value === false).length;
      let contYellow = stopResults.filter(a => a.value === null).length;
      return [{
        value: contGreen,
        style: {
          backgroundColor: "#5FD18F"
        }
      }, {
        value: contRed,
        style: {
          backgroundColor: "#E43C46"
        }
      }, {
        value: contYellow,
        style: {
          backgroundColor: "#F4B50A"
        }
      }].filter(a => a.value);
    },

    sliderStyleBackground() {
      return "linear-gradient(90deg, rgba(52, 189, 243, 0.6) 0%, rgba(177, 75, 222, 0.6) 50.83%, rgba(238, 43, 69, 0.6) 100%);";
    },

    nameText() {
      let name = this.name;
      if (!name) return name;
      if (name.length <= 1) return name;
      name = `${name[0].toUpperCase()}${name.substring(1)}`;
      return name;
    },

    shortSpecs() {
      let specs = this.specs;
      if (!specs) return null;
      return specs.slice(0, 3);
    },

    extendedCardUri() {},

    officeCitiesText() {},

    imgNoPhoto() {
      return ImageNoPhoto;
    },

    isCustomerTerms() {
      return this.terms && (this.terms.purchaserTermsType == PURCHASER_TERMS_TYPE__CUSTOMER_TERMS.Value || this.terms.purchaserTermsType == PURCHASER_TERMS_TYPE__CUSTOMER_TERMS.Name);
    },

    isPurchaserTerms() {
      return this.terms && (this.terms.purchaserTermsType == PURCHASER_TERMS_TYPE__PURCHASER_TERMS.Value || this.terms.purchaserTermsType == PURCHASER_TERMS_TYPE__PURCHASER_TERMS.Name);
    },

    isRejectBtnVisible() {
      if (this.setBtnVisible) {
        return this.showRejectBtn;
      }

      switch (this.applicationItemState) {
        case this.applicationItemStateEnum.Undefined:
          {
            return this.state == this.applicationStateEnum.Complete || this.state == this.applicationStateEnum.Accepted;
          }

        case this.applicationItemStateEnum.Winner:
          {
            return false;
          }

        case this.applicationItemStateEnum.Loser:
          {
            return false;
          }

        case this.applicationItemStateEnum.Rejected:
          {
            return false;
          }
      }
    },

    isBuyBtnVisible() {
      if (this.setBtnVisible) {
        return this.showBuyBtn;
      }

      switch (this.applicationItemState) {
        case this.applicationItemStateEnum.Undefined:
          {
            return this.state == this.applicationStateEnum.Complete || this.state == this.applicationStateEnum.Accepted;
          }

        case this.applicationItemStateEnum.Winner:
          {
            return false;
          }

        case this.applicationItemStateEnum.Loser:
          {
            return false;
          }

        case this.applicationItemStateEnum.Rejected:
          {
            return false;
          }
      }
    }

  },
  methods: {
    concatTitle,
    toMoney: toMoney$1,

    searchSupplierOffers(name, inn, kpp) {
      let url = seo.getSupplierSeoUrl(name, inn);
      window.history.pushState(null, null, url);
    },

    getSpecValueTypeCode(type) {
      switch (type) {
        case "Int":
        case "Int32":
        case "Int64":
          return 2;

        case "Decimal":
          return 3;

        case "Boolean":
          return 4;

        case "Date":
        case "DateTime":
          return 5;

        case "File":
          return 6;

        default:
          return 1;
      }
    },

    reject() {
      this.$emit("reject", this.key);
    },

    buy() {
      this.$emit("buy", this.key);
    },

    showSignature() {
      this.$emit("showSignature", this.key);
    },

    changeCbValue() {
      this.$emit("changeCbValue", this.key);
    },

    changeTbValue(event) {
      this.$emit("changeTbValue", event);
    },

    createDeal() {
      this.$emit("createDeal", this.key);
    },

    goToDeal(dealId) {
      this.$emit("goToDeal", this.dealId);
    },

    openChat() {
      this.$emit('openChat');
    },

    chatEnable() {
      try {
        if (window.chatEnable == true) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        console.log(e);
        return false;
      }
    }

  }
};

/* script */
const __vue_script__$13 = script$13;
/* template */

var __vue_render__$13 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.$style.box
  }, [_vm.small && _vm.stateDisplayParams ? _c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('div', {
    class: _vm.$style.tag,
    style: {
      backgroundColor: _vm.stateDisplayParams.color
    }
  }, [_vm._v("\n      " + _vm._s(_vm.stateDisplayParams.text || _vm.stateName) + "\n    ")])]) : _vm._e(), _vm._v(" "), this.lotItemIndex && this.lotItemName ? _c('div', {
    class: _vm.$style.row
  }, [_c('div', {
    class: _vm.$style.optionTitle
  }, [_vm._v("Позиция №" + _vm._s(this.lotItemIndex))]), _vm._v(" "), _c('div', {
    class: _vm.$style.positionName
  }, [_vm._v(_vm._s(this.lotItemName))])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.lc
  }, [_c('div', {
    class: _vm.$style.company
  }, [_c('CounterpartyLoading', {
    class: [_vm.$style.flex],
    staticStyle: {
      "color": "#53565A",
      "cursor": "pointer",
      "margin-bottom": "1em"
    },
    attrs: {
      "loading": _vm.shortNameLoading,
      "value": _vm.shortName,
      "zoom": 0.5,
      "mode": "small"
    }
  }, [_c('div', {
    class: _vm.$style.companyName
  }, [_vm._v("\n            " + _vm._s(_vm.shortName || _vm.nameText) + "\n          ")]), _vm._v(" "), _c('a', {
    class: _vm.$style.companyLink,
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "target": "_blank",
      "href": _vm.urlCounterpartyPage + "?inn=" + _vm.inn + "&externalId=" + _vm.externalId
    }
  }, [_vm._v("Перейти к карточке контрагента >")])]), _vm._v(" "), _vm.showCompanyRisk ? _c('div', {
    class: [_vm.$style.companyInfo0, _vm.$style.flex],
    staticStyle: {
      "position": "relative",
      "top": "-3px"
    }
  }, [_c('div', {
    class: _vm.$style.companyRisk
  }, [!(_vm.reliabilityLoading && !_vm.sliderInvert) ? _c('div', {
    class: _vm.$style.companyInfoSliderTitle
  }, [_vm._v("\n              Риски\n            ")]) : _vm._e(), _vm._v(" "), _vm.reliabilityLoading && !_vm.sliderInvert ? _c('div', {
    class: _vm.$style.companyInfoSliderTitle
  }, [_vm._v("\n              рассчитываем скоринг ...\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.$style.companyInfoSlider
  }, [_c('Slider', {
    attrs: {
      "value": _vm.sliderInvert,
      "text1": "Не справится",
      "text2": "Справится",
      "pointClass": _vm.$style.pointSlider,
      "styleBackground": _vm.sliderStyleBackground,
      "zoom": 0.7
    }
  })], 1)]), _vm._v(" "), _c('div', {
    class: _vm.$style.companyImprest
  }, [!(_vm.risksLoading || _vm.limitLoading) ? _c('div', {
    class: _vm.$style.companyInfoSliderTitle
  }, [_vm._v("\n              Аванс\n            ")]) : _vm._e(), _vm._v(" "), _vm.risksLoading || _vm.limitLoading ? _c('div', {
    class: _vm.$style.companyInfoSliderTitle
  }, [_vm._v("\n              рассчитываем лимит ...\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.$style.companyInfoSlider
  }, [_c('Slider', {
    attrs: {
      "border": '1px solid black',
      "value": _vm.limitSlider,
      "text1": "Сумма",
      "text2": "НМЦ",
      "pointClass": _vm.$style.pointSlider,
      "styleBackground": _vm.sliderStyleBackground,
      "zoom": 0.7
    }
  })], 1)]), _vm._v(" "), _c('div', {
    class: _vm.$style.companyImprestStopFactors
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "0.5em"
    },
    style: {
      fontSize: 6 + "px"
    }
  }, _vm._l(_vm.stopFactors, function (item, i) {
    return _c('div', {
      key: i,
      staticStyle: {
        "color": "#fff",
        "border-radius": "100% !important",
        "width": "2.5em",
        "height": "2.5em",
        "margin-right": "0.2em",
        "margin-top": "1em",
        "background-color": "gray",
        "display": "flex",
        "align-items": "center",
        "justify-content": "center",
        "font-weight": "bold"
      },
      style: item.style
    }, [_c('div', {
      staticStyle: {
        "font-size": "1.6em",
        "line-height": "1.6em",
        "position": "relative"
      }
    }, [_vm._v("\n                  " + _vm._s(item.value) + "\n                ")])]);
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.$style.companyInfo1,
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    class: _vm.$style.companyContact
  }), _vm._v(" "), _c('div', {
    class: _vm.$style.companyAddress
  }, [_c('span', {
    class: _vm.$style.supplierContacts,
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        _vm.modalContacts = {
          inn: _vm.inn,
          name: _vm.name
        };
      }
    }
  }, [_vm._v("Контакты поставщика >")]), _vm._v(" "), _vm.city ? _c('span', [_vm._v("Офисы в ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.city))])])]), _vm._v(" "), _vm.modalContacts ? _c('ModalContacts', _vm._b({
    attrs: {
      "inn": _vm.inn
    },
    on: {
      "close": function ($event) {
        _vm.modalContacts = null;
      }
    }
  }, 'ModalContacts', _vm.modalContacts, false)) : _vm._e(), _vm._v(" "), _c('div', {
    class: [_vm.$style.companyInfo2, _vm.$style.flex],
    staticStyle: {
      "margin-top": "3px"
    }
  }, [_vm.chatEnable() ? _c('div', {
    class: _vm.$style.flex
  }, [_c('IconChat'), _vm._v(" "), _c('div', {
    class: _vm.$style.divLinkChat,
    on: {
      "click": function ($event) {
        return _vm.openChat();
      }
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "3px"
    }
  }, [_vm._v("Чат с поставщиком")])])], 1) : _vm._e(), _vm._v(" "), _vm.chatEnable() ? _c('div', {
    class: _vm.$style.flex
  }, [_c('IconChat'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "3px"
    }
  }, [_vm._v("Онлайн переговоры")])], 1) : _vm._e(), _vm._v(" "), _vm.supplierOffersCount ? _c('div', {
    class: _vm.$style.companyInfo3,
    on: {
      "click": function ($event) {
        return _vm.searchSupplierOffers(_vm.name, _vm.inn, _vm.kpp);
      }
    }
  }, [_c('span', [_vm._v("Все товары поставщика (" + _vm._s(_vm.supplierOffersCount) + ") >")])]) : _vm._e()]), _vm._v(" "), _c('div', [_vm.isCustomerTerms ? [_c('div', [_vm._v("\n              " + _vm._s('Согласен выполнить поставку/работы/оказать услуги в соответствии с требованиями заказчика') + "\n            ")])] : _vm._e(), _vm._v(" "), _vm.isPurchaserTerms ? [!_vm.hideTermsTitle ? _c('div', [_vm._v("\n              " + _vm._s('Предложение по условиям поставки') + "\n            ")]) : _vm._e(), _vm._v(" "), _vm.terms ? _c('div', {
    class: _vm.$style.termsContainer
  }, [_c('div', {
    class: _vm.$style.terms
  }, [_c('div', {
    class: _vm.$style.termsCol12
  }, [_vm.terms.deliveryAddress ? _c('div', {
    class: _vm.$style.flex
  }, [_c('div', {
    class: _vm.$style.termsCol1
  }, [_vm._v(_vm._s('Место поставки'))]), _vm._v(" "), _c('div', {
    class: _vm.$style.termsCol2
  }, [_vm._v(_vm._s(_vm.terms.deliveryAddress))])]) : _vm._e(), _vm._v(" "), _vm.terms.deliveryRegion ? _c('div', {
    class: _vm.$style.flex
  }, [_c('div', {
    class: _vm.$style.termsCol1
  }, [_vm._v(_vm._s('Регион поставки'))]), _vm._v(" "), _c('div', {
    class: _vm.$style.termsCol2
  }, [_vm._v(_vm._s(_vm.terms.deliveryRegion))])]) : _vm._e(), _vm._v(" "), _vm.terms.paymentTerms ? _c('div', {
    class: _vm.$style.flex
  }, [_c('div', {
    class: _vm.$style.termsCol1
  }, [_vm._v(_vm._s('Условия оплаты'))]), _vm._v(" "), _c('div', {
    class: _vm.$style.termsCol2
  }, [_vm._v(_vm._s(_vm.terms.paymentTerms))])]) : _vm._e(), _vm._v(" "), _vm.terms.supplyDate ? _c('div', {
    class: _vm.$style.flex
  }, [_c('div', {
    class: _vm.$style.termsCol1
  }, [_vm._v(_vm._s('Срок поставки'))]), _vm._v(" "), _c('div', {
    class: _vm.$style.termsCol2
  }, [_vm._v(_vm._s(_vm.terms.supplyDate))])]) : _vm._e()]), _vm._v(" "), _vm.terms.additionalContractTerms ? _c('div', {
    class: _vm.$style.termsCol3
  }, [_c('div', [_vm._v(_vm._s('Дополнительные требования к договору:'))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.terms.additionalContractTerms))])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _vm.terms && _vm.terms.contractTemplates && _vm.terms.contractTemplates.length > 0 ? _c('div', _vm._l(_vm.terms.contractTemplates, function (doc) {
    return _c('a', {
      key: doc.FileGuid,
      class: _vm.$style.flex,
      attrs: {
        "href": doc.url
      }
    }, [doc.name.indexOf('.doc') > 0 ? _c('IconWord') : _vm._e(), _vm._v(" "), doc.name.indexOf('.xls') > 0 ? _c('IconXls') : _vm._e(), _vm._v(" "), _c('span', {
      class: _vm.$style.contractLink
    }, [_vm._v(_vm._s(doc.name))])], 1);
  }), 0) : _vm._e(), _vm._v(" "), _vm.showSignatureLink ? _c('div', {
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('a', {
    on: {
      "click": _vm.showSignature
    }
  }, [_vm._v("Посмотреть ЭП")])]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), !_vm.small && _vm.stateDisplayParams ? _c('div', {
    staticStyle: {
      "position": "relative",
      "top": "5px"
    }
  }, [_c('div', {
    class: _vm.$style.tag,
    style: {
      backgroundColor: _vm.stateDisplayParams.color
    }
  }, [_vm._v("\n            " + _vm._s(_vm.stateDisplayParams.text) + "\n          ")])]) : _vm._e()], 1), _vm._v(" "), !_vm.small ? _c('div', [_c('div', {
    class: _vm.$style.productInfo
  }, [_c('div', {
    class: _vm.$style.image,
    staticStyle: {
      "margin-top": "12px"
    },
    style: {
      background: "url(" + (_vm.thumbnailUrl || _vm.imgNoPhoto) + ") center center no-repeat",
      backgroundSize: 'cover'
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_c('div', [_c('a', {
    class: _vm.$style.name,
    attrs: {
      "href": _vm.extendedCardUri,
      "target": "_blank"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.nameText) + "\n              ")])]), _vm._v(" "), _c('div', {
    class: _vm.$style.characteristics,
    staticStyle: {
      "position": "relative",
      "top": "-3px"
    }
  }, _vm._l(_vm.shortSpecs, function (spec, index) {
    return _c('div', {
      key: index,
      class: _vm.$style.characteristic
    }, [_c('div', {
      class: _vm.$style.characteristicName
    }, [_vm._v("\n                  " + _vm._s(spec.name) + "\n                ")]), _vm._v(" "), _c('div', {
      class: _vm.$style.characteristicValue
    }, [_vm._v("\n                  " + _vm._s(spec.value) + "\n                ")])]);
  }), 0), _vm._v(" "), _c('div', {
    class: [_vm.$style.characteristicsExport, _vm.$style.flex],
    staticStyle: {
      "margin-top": "1px"
    }
  }, [_c('div', {
    class: _vm.$style.flex
  }, [_c('IconXls', {
    staticStyle: {
      "margin-right": "2px"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Выгрузка в эксель")])], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.flex
  }, [_c('IconXls', {
    staticStyle: {
      "margin-right": "2px"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Выгрузка в эксель")])], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.companyAllDocumentsLink
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Все документы >")])])]), _vm._v(" "), _c('div', {
    class: _vm.$style.companyDeliveryText,
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_vm._v("\n              Доставка здесь можно написать условия доставки/самовывоза\n            ")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: [_vm.$style.rc, !_vm.small && _vm.$style.rcNoSmall]
  }, [_c('div', [_c('div', {
    class: _vm.$style.flex,
    staticStyle: {
      "align-items": "baseline"
    }
  }, [_c('div', {
    class: _vm.$style.price
  }, [_c('span', [_vm._v(_vm._s(_vm.toMoney(_vm.price * _vm.amount) || 0))]), _vm._v(" "), _c('IconRub', {
    attrs: {
      "color": "#202020",
      "height": "18px"
    }
  })], 1), _vm._v(" "), _c('span', {
    class: _vm.$style.priceText
  }, [_vm._v("(в т.ч. НДС " + _vm._s(_vm.toMoney(_vm.fullNds)) + " Р)")])]), _vm._v(" "), _c('div', {
    class: _vm.$style.priceText
  }, [_vm._v("\n          " + _vm._s(_vm.toMoney(_vm.amount)) + " " + _vm._s(_vm.unit) + " по " + _vm._s(_vm.toMoney(_vm.price)) + " Р/" + _vm._s(_vm.unit) + " (в т.ч. НДС\n          " + _vm._s(_vm.toMoney(_vm.nds)) + " Р)\n        ")])]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_vm.isRejectBtnVisible ? _c('ButtonGrey', {
    attrs: {
      "height": "32px",
      "width": _vm.setBtnVisible ? '300px' : '155px',
      "hoverBackground": "#ee6865"
    },
    on: {
      "click": _vm.reject
    }
  }, [_vm._v("\n            " + _vm._s(_vm.rejectBtnName || "Отклонить") + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _vm.isBuyBtnVisible ? _c('div', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('ButtonRed', {
    attrs: {
      "height": "32px",
      "width": _vm.setBtnVisible ? '300px' : '155px'
    },
    on: {
      "click": _vm.buy
    }
  }, [_vm._v("\n            " + _vm._s(_vm.buyBtnName || "Купить") + "\n          ")])], 1) : _vm._e(), _vm._v(" "), !_vm.isItemInDeal && (_vm.state == _vm.applicationStateEnum.Winner || _vm.applicationItemState == _vm.applicationItemStateEnum.Winner) ? _c('div', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('ButtonRed', {
    attrs: {
      "height": "32px"
    },
    on: {
      "click": _vm.createDeal
    }
  }, [_vm._v("\n            Создать электронный договор\n          ")])], 1) : _vm._e(), _vm._v(" "), _vm.isItemInDeal && (_vm.state == _vm.applicationStateEnum.Winner || _vm.applicationItemState == _vm.applicationItemStateEnum.Winner) ? _c('div', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('ButtonRed', {
    attrs: {
      "height": "32px"
    },
    on: {
      "click": _vm.goToDeal
    }
  }, [_vm._v("\n            Перейти к договору\n          ")])], 1) : _vm._e()])]), _vm._v(" "), _vm.setCheckboxVisible ? _c('div', {
    staticStyle: {
      "width": "100%",
      "padding-top": "10px"
    }
  }, [_c('CheckBoxSmall', {
    attrs: {
      "defaultValue": _vm.cbValue,
      "name": _vm.cbName
    },
    on: {
      "input": _vm.changeCbValue
    }
  }), _vm._v(" "), _vm.setTextboxVisible ? _c('span', {
    staticStyle: {
      "line-height": "2.5",
      "font-size": "15px"
    }
  }, [_vm._v(_vm._s(_vm.tbName))]) : _vm._e(), _vm._v(" "), _vm.setTextboxVisible ? _c('TextInput', {
    staticStyle: {
      "width": "100%",
      "border-radius": "4px!important"
    },
    attrs: {
      "defaultValue": _vm.tbValue
    },
    on: {
      "input": function ($event) {
        return _vm.changeTbValue($event);
      }
    }
  }) : _vm._e()], 1) : _vm._e()])]);
};

var __vue_staticRenderFns__$13 = [];
/* style */

const __vue_inject_styles__$13 = function (inject) {
  if (!inject) return;
  inject("data-v-fb73bbd2_0", {
    source: "@charset \"UTF-8\";.src-components-OfferForProcedurePage-tag-1Kgq{font-size:13px;color:#fff;border-radius:4px 4px 4px 4px!important;height:16px;display:inline-block;padding:0 5px;font-size:13px;line-height:1.2}.src-components-OfferForProcedurePage-box-2tch{box-sizing:border-box;background-color:#fff;padding:4px 8px 16px;border:1px solid #6e7c8d;border-radius:4px 4px 20px 4px!important;overflow:hidden;margin-top:2px}.src-components-OfferForProcedurePage-box-2tch .src-components-OfferForProcedurePage-container-1hA1{display:flex;justify-content:space-between;align-items:stretch;margin-right:-20px;flex-wrap:wrap}.src-components-OfferForProcedurePage-box-2tch .src-components-OfferForProcedurePage-container-1hA1>*{margin-right:20px}.src-components-OfferForProcedurePage-box-2tch .src-components-OfferForProcedurePage-container-1hA1 .src-components-OfferForProcedurePage-lc-1MSL{flex-basis:340px;flex:1;display:flex;flex-direction:column;justify-content:space-between}.src-components-OfferForProcedurePage-box-2tch .src-components-OfferForProcedurePage-container-1hA1 .src-components-OfferForProcedurePage-rc-m1Xz{width:303px;min-width:303px;display:flex;flex-direction:column;justify-content:space-between}.src-components-OfferForProcedurePage-box-2tch .src-components-OfferForProcedurePage-container-1hA1 .src-components-OfferForProcedurePage-rcNoSmall-1oeY{justify-content:flex-end!important}.src-components-OfferForProcedurePage-image-SgEp{width:86px;height:86px;min-width:86px;min-height:86px;max-width:86px;max-height:86px;border-radius:4px!important;color:#fff;border:1px solid #6e7c8d;background-color:#fff}.src-components-OfferForProcedurePage-productInfo-3ykT{display:flex;margin-right:-7px}.src-components-OfferForProcedurePage-productInfo-3ykT>*{margin-right:7px}.src-components-OfferForProcedurePage-productInfo-3ykT .src-components-OfferForProcedurePage-name-1hZr{font-family:Regular;line-height:1.2;color:#202020;text-decoration:none;word-wrap:break-word;font-size:24px}.src-components-OfferForProcedurePage-productInfo-3ykT .src-components-OfferForProcedurePage-characteristics-3jW0{display:table}.src-components-OfferForProcedurePage-productInfo-3ykT .src-components-OfferForProcedurePage-characteristics-3jW0 .src-components-OfferForProcedurePage-characteristic-3F8J{display:table-row}.src-components-OfferForProcedurePage-productInfo-3ykT .src-components-OfferForProcedurePage-characteristics-3jW0 .src-components-OfferForProcedurePage-characteristic-3F8J .src-components-OfferForProcedurePage-characteristicName-3Cda{display:table-cell;font-size:16px;line-height:1.2;color:#202020;margin-right:5px}.src-components-OfferForProcedurePage-productInfo-3ykT .src-components-OfferForProcedurePage-characteristics-3jW0 .src-components-OfferForProcedurePage-characteristic-3F8J .src-components-OfferForProcedurePage-characteristicValue-22AY{padding-left:26px}.src-components-OfferForProcedurePage-companyName-pwTj{font-size:20px;font-family:Regular;color:#202020;word-wrap:break-word;min-width:0}.src-components-OfferForProcedurePage-companyAllDocumentsLink-1H6D{font-size:13px;line-height:1.2;color:#005baa}.src-components-OfferForProcedurePage-companyDeliveryText-3qSo{font-size:13px;line-height:1.4;color:#6e7c8d}.src-components-OfferForProcedurePage-companyInfo0-LUdp>*{margin-right:20px}.src-components-OfferForProcedurePage-companyInfo2-2eGf>*{margin-right:30px}.src-components-OfferForProcedurePage-characteristicsExport-31gS>*{margin-right:32px}.src-components-OfferForProcedurePage-companyLink-25pL{font-size:13px;line-height:1.4;text-decoration-line:underline;color:#005baa;margin-top:3px}.src-components-OfferForProcedurePage-companyAddress-27dx{font-size:16px;line-height:1.2;color:#202020}.src-components-OfferForProcedurePage-companyInfoSliderTitle-3PD7{font-size:13px;line-height:1.4;color:#53565a}.src-components-OfferForProcedurePage-pointSlider-1bxZ{position:relative;width:.1em;min-width:2.4em;max-width:2.4em;max-height:2.4em;min-height:2.4em;height:2.4em;border:.3em solid #34bdf3;background-color:#fff;border-radius:100%!important}.src-components-OfferForProcedurePage-companyImprestStopFactors-2nVU{position:relative;top:5px}.src-components-OfferForProcedurePage-companyInfoSlider-2mdP{min-width:260px}.src-components-OfferForProcedurePage-additionalInfo-3i0c{display:flex;flex-wrap:wrap;margin-right:-35px}.src-components-OfferForProcedurePage-additionalInfo-3i0c>*{margin-top:4px;margin-right:35px}.src-components-OfferForProcedurePage-additionalInfo-3i0c .src-components-OfferForProcedurePage-showAll-2xp0{font-size:16px;line-height:1.4;text-decoration:underline;color:#000;cursor:pointer}.src-components-OfferForProcedurePage-price-3gb-{font-size:24px;line-height:1.4;color:#202020;display:flex;align-items:center;flex-wrap:wrap}.src-components-OfferForProcedurePage-priceText-OV2C{font-size:13px;line-height:1.4;color:#202020}.src-components-OfferForProcedurePage-discounts-VfCj{font-size:16px;line-height:1.4;line-height:16px;text-decoration-line:underline;color:#202020}.src-components-OfferForProcedurePage-warehouseDelivery-36ml{display:flex;align-items:center}.src-components-OfferForProcedurePage-warehouseInfo-1BAp{font-size:16px;line-height:1.4;color:#6e7c8d}.src-components-OfferForProcedurePage-warehouseInfo-1BAp .src-components-OfferForProcedurePage-showOther-2cbz{font-size:13px;line-height:1.4;text-decoration-line:underline;color:#6e7c8d;height:13px;width:30px;padding-left:4px}.src-components-OfferForProcedurePage-warehouseInfo-1BAp .src-components-OfferForProcedurePage-address-3yh2{color:#202020}.src-components-OfferForProcedurePage-countBox-8KwG{display:flex;align-items:center;margin-left:5px}.src-components-OfferForProcedurePage-countBox-8KwG>*{margin-right:4px}.src-components-OfferForProcedurePage-header2--VhG{display:flex;align-items:center;flex-wrap:wrap;min-width:0}.src-components-OfferForProcedurePage-flex-26vQ{display:flex;align-items:center;flex-wrap:wrap;min-width:0}.src-components-OfferForProcedurePage-basketPhoto-3MtU{width:64px;height:64px;border:#000 1px solid;margin:8px 8px 8px 0;max-height:64px;overflow:hidden;border-radius:4px!important}.src-components-OfferForProcedurePage-modalBasketButtonsBox-2MgC{display:flex;justify-content:center;align-items:center;padding:16px 20px 8px 15px}.src-components-OfferForProcedurePage-modalFooterBox-2A52{display:flex;justify-content:center;align-items:center;padding:8px 20px 16px 15px}.src-components-OfferForProcedurePage-divLinkChat-21fw{cursor:pointer}.src-components-OfferForProcedurePage-supplierContacts-3vWZ{margin-right:38px;cursor:pointer;color:#005baa}.src-components-OfferForProcedurePage-termsContainer-i6fT{width:656px}.src-components-OfferForProcedurePage-terms-4IbY{display:flex}.src-components-OfferForProcedurePage-terms-4IbY .src-components-OfferForProcedurePage-flex-26vQ{align-items:unset}.src-components-OfferForProcedurePage-termsCol1-1EWO{width:120px}.src-components-OfferForProcedurePage-termsCol2-34s5{width:224px}.src-components-OfferForProcedurePage-termsCol12-xp8j{width:360px}.src-components-OfferForProcedurePage-termsCol3-3TP9{width:296px}.src-components-OfferForProcedurePage-contractLink-1c4y{color:#005baa;margin-left:4px;cursor:pointer}.src-components-OfferForProcedurePage-positionName-1WYW{font-family:IBM Plex Sans;font-style:normal;font-weight:500;font-size:16px;line-height:18px;color:#202020;width:80%;margin-right:30px;padding-top:3px}.src-components-OfferForProcedurePage-optionTitle-3GUI{font-family:IBM Plex Sans;font-style:normal;font-weight:400;font-size:16px;line-height:24px;width:13%;color:#6e7c8d}.src-components-OfferForProcedurePage-row-2KAW{display:flex;margin-bottom:5px}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "tag": "src-components-OfferForProcedurePage-tag-1Kgq",
      "box": "src-components-OfferForProcedurePage-box-2tch",
      "container": "src-components-OfferForProcedurePage-container-1hA1",
      "lc": "src-components-OfferForProcedurePage-lc-1MSL",
      "rc": "src-components-OfferForProcedurePage-rc-m1Xz",
      "rcNoSmall": "src-components-OfferForProcedurePage-rcNoSmall-1oeY",
      "image": "src-components-OfferForProcedurePage-image-SgEp",
      "productInfo": "src-components-OfferForProcedurePage-productInfo-3ykT",
      "name": "src-components-OfferForProcedurePage-name-1hZr",
      "characteristics": "src-components-OfferForProcedurePage-characteristics-3jW0",
      "characteristic": "src-components-OfferForProcedurePage-characteristic-3F8J",
      "characteristicName": "src-components-OfferForProcedurePage-characteristicName-3Cda",
      "characteristicValue": "src-components-OfferForProcedurePage-characteristicValue-22AY",
      "companyName": "src-components-OfferForProcedurePage-companyName-pwTj",
      "companyAllDocumentsLink": "src-components-OfferForProcedurePage-companyAllDocumentsLink-1H6D",
      "companyDeliveryText": "src-components-OfferForProcedurePage-companyDeliveryText-3qSo",
      "companyInfo0": "src-components-OfferForProcedurePage-companyInfo0-LUdp",
      "companyInfo2": "src-components-OfferForProcedurePage-companyInfo2-2eGf",
      "characteristicsExport": "src-components-OfferForProcedurePage-characteristicsExport-31gS",
      "companyLink": "src-components-OfferForProcedurePage-companyLink-25pL",
      "companyAddress": "src-components-OfferForProcedurePage-companyAddress-27dx",
      "companyInfoSliderTitle": "src-components-OfferForProcedurePage-companyInfoSliderTitle-3PD7",
      "pointSlider": "src-components-OfferForProcedurePage-pointSlider-1bxZ",
      "companyImprestStopFactors": "src-components-OfferForProcedurePage-companyImprestStopFactors-2nVU",
      "companyInfoSlider": "src-components-OfferForProcedurePage-companyInfoSlider-2mdP",
      "additionalInfo": "src-components-OfferForProcedurePage-additionalInfo-3i0c",
      "showAll": "src-components-OfferForProcedurePage-showAll-2xp0",
      "price": "src-components-OfferForProcedurePage-price-3gb-",
      "priceText": "src-components-OfferForProcedurePage-priceText-OV2C",
      "discounts": "src-components-OfferForProcedurePage-discounts-VfCj",
      "warehouseDelivery": "src-components-OfferForProcedurePage-warehouseDelivery-36ml",
      "warehouseInfo": "src-components-OfferForProcedurePage-warehouseInfo-1BAp",
      "showOther": "src-components-OfferForProcedurePage-showOther-2cbz",
      "address": "src-components-OfferForProcedurePage-address-3yh2",
      "countBox": "src-components-OfferForProcedurePage-countBox-8KwG",
      "header2": "src-components-OfferForProcedurePage-header2--VhG",
      "flex": "src-components-OfferForProcedurePage-flex-26vQ",
      "basketPhoto": "src-components-OfferForProcedurePage-basketPhoto-3MtU",
      "modalBasketButtonsBox": "src-components-OfferForProcedurePage-modalBasketButtonsBox-2MgC",
      "modalFooterBox": "src-components-OfferForProcedurePage-modalFooterBox-2A52",
      "divLinkChat": "src-components-OfferForProcedurePage-divLinkChat-21fw",
      "supplierContacts": "src-components-OfferForProcedurePage-supplierContacts-3vWZ",
      "termsContainer": "src-components-OfferForProcedurePage-termsContainer-i6fT",
      "terms": "src-components-OfferForProcedurePage-terms-4IbY",
      "termsCol1": "src-components-OfferForProcedurePage-termsCol1-1EWO",
      "termsCol2": "src-components-OfferForProcedurePage-termsCol2-34s5",
      "termsCol12": "src-components-OfferForProcedurePage-termsCol12-xp8j",
      "termsCol3": "src-components-OfferForProcedurePage-termsCol3-3TP9",
      "contractLink": "src-components-OfferForProcedurePage-contractLink-1c4y",
      "positionName": "src-components-OfferForProcedurePage-positionName-1WYW",
      "optionTitle": "src-components-OfferForProcedurePage-optionTitle-3GUI",
      "row": "src-components-OfferForProcedurePage-row-2KAW"
    }
  });
};
/* scoped */


const __vue_scope_id__$13 = undefined;
/* module identifier */

const __vue_module_identifier__$13 = undefined;
/* functional template */

const __vue_is_functional_template__$13 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$13 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$13,
  staticRenderFns: __vue_staticRenderFns__$13
}, __vue_inject_styles__$13, __vue_script__$13, __vue_scope_id__$13, __vue_is_functional_template__$13, __vue_module_identifier__$13, false, createInjector, undefined, undefined);

const instance = axios.create({
  timeout: 300000
});
function urlConcat(url, relativeUri) {
  if (relativeUri && url) {
    if (relativeUri[0] !== "/" && url[url.length - 1] !== "/") relativeUri = "/" + relativeUri;else if (relativeUri[0] === "/" && url[url.length - 1] === "/") relativeUri = relativeUri.substring(1);
  }

  let fullUrl = url + relativeUri;
  return fullUrl;
}
async function httpPost(url, body, {
  headers,
  withCredentials,
  authToken
} = {}) {
  if (authToken) headers = { ...headers,
    'Authorization': 'Bearer ' + authToken
  };
  let data = await instance.post(url, body, {
    headers,
    withCredentials,
    mode: "no-cors"
  }).then(a => a && a.data || null);
  return data;
}
async function httpGet(url, params, {
  authToken,
  noCache = false,
  withCredentials = true
} = {}) {
  let options = {
    params: params,
    withCredentials
  };
  if (noCache) options.headers = { ...options.headers,
    'Pragma': 'no-cache',
    mode: "no-cors"
  };
  if (authToken) options.headers = { ...options.headers,
    'Authorization': 'Bearer ' + authToken,
    mode: "no-cors"
  };
  return (await instance.get(url, options)).data;
}

var http = /*#__PURE__*/Object.freeze({
  __proto__: null,
  urlConcat: urlConcat,
  httpPost: httpPost,
  httpGet: httpGet
});

function create({
  loading,
  data,
  dataIsEmpty,
  error,
  fetchId
} = {}) {
  return {
    loading: loading === undefined ? false : loading,
    data: data === undefined ? {} : data,
    dataIsEmpty: dataIsEmpty === undefined ? null : dataIsEmpty,
    error: error === undefined ? null : error,
    fetchId: fetchId === undefined ? null : fetchId
  };
}
function reset(data) {
  data.fetchId = null;
  data.loading = false;
  data.data = {};
  data.dataIsEmpty = null;
  data.error = null;
}
async function ensure(data, fetcher) {
  if (data.loading || data.data) {
    return;
  }

  await fetch(data, fetcher);
}
async function fetch(data, fetcher) {
  const fetchId = v4(); // console.log('START ' + fetchId);

  data.loading = true;
  data.data = null;
  data.dataIsEmpty = null;
  data.error = null;
  data.fetchId = fetchId;

  while (true) {
    try {
      const newData = await fetcher();

      if (data.fetchId != fetchId) {
        // console.log('STALE AFTER FETCH ' + fetchId);
        return;
      }

      let compleat = !newData || !newData.timeToRefresh; // возможно что бэк вернул только часть данных
      // в таком случае нужно отрисовать их
      // и повторить запрос позже

      update(data, newData, null, !compleat);

      if (compleat) {
        data.fetchId = null;
        return;
      } // console.log('DELAY ' + fetchId);
      // delay


      await new Promise(resolve => setTimeout(resolve, newData.timeToRefresh * 1000));

      if (data.fetchId != fetchId) {
        // console.log('STALE AFTER DELAY ' + fetchId);
        return;
      }
    } catch (e) {
      if (data.fetchId == fetchId) {
        // console.log('ERROR ' + fetchId);
        update(data, null, e);
      }

      return;
    }
  }
}

function update(data, newData, error, loading) {
  // console.log('UPDATE START');
  // console.log({ data, newData, error});
  data.loading = loading;
  data.error = error;
  data.data = !error && newData || {};
  data.dataIsEmpty = !newData;

  if (newData) {
    let dataIsEmpty = true;

    for (let k in newData) {
      let a = newData[k];

      if (a) {
        if (typeof a === "object" && Array.isArray(a)) {
          if (a.length > 0) {
            dataIsEmpty = false;
            break;
          }
        } else {
          dataIsEmpty = false;
          break;
        }
      }
    }

    data.dataIsEmpty = dataIsEmpty;
  } // console.log('UPDATE END');
  // console.log({ data, newData, error});


  return true;
}

var asyncData = /*#__PURE__*/Object.freeze({
  __proto__: null,
  create: create,
  reset: reset,
  ensure: ensure,
  fetch: fetch
});

var script$12 = {
  name: "OfferForProcedurePage",
  components: {
    OfferForProcedure: __vue_component__$13
  },
  props: {
    apiCounteragent: {
      type: String,
      default: "/microservices-otc/counteragent/api/"
    },
    urlCounterpartyPage: {
      type: String,
      default: "/counterparty"
    },
    inn: String,
    kpp: String,
    externalId: [String, Number],
    externalSource: String,
    name: String,
    specs: Array,
    price: Number,
    unit: String,
    amount: null,
    nds: null,
    fullNds: null,
    thumbnailUrl: String,
    deliveryQntFrom: Number,
    state: Number,
    stateName: null,
    small: null,
    applicationItemState: {
      type: Number,
      default: 0
    },
    applicationItemStateName: {
      type: String,
      default: null
    },
    AddOrganization: Number,
    IdObject: Number,
    dealId: null,
    isItemInDeal: {
      type: Boolean,
      default: false
    },
    terms: Object,
    buyBtnName: String,
    rejectBtnName: String,
    setBtnVisible: {
      type: Boolean,
      default: false
    },
    showBuyBtn: {
      type: Boolean,
      default: false
    },
    showRejectBtn: {
      type: Boolean,
      default: false
    },
    hideTermsTitle: {
      type: Boolean,
      default: false
    },
    showSignatureLink: {
      type: Boolean,
      default: false
    },
    setCheckboxVisible: {
      type: Boolean,
      default: false
    },
    cbValue: {
      type: Boolean,
      default: false
    },
    cbName: String,
    setTextboxVisible: {
      type: Boolean,
      default: false
    },
    tbValue: String,
    tbName: String,
    lotItemIndex: Number,
    lotItemName: String,
    showCompanyRisk: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      reliability: create({
        loading: true
      }),
      limit: create({
        loading: true
      }),
      contractExecutionRisks: create({
        loading: true
      }),
      counterparty: create({
        loading: true
      })
    };
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      let param = {
        inn: this.inn,
        externalId: this.externalId,
        isWidget: true
      };
      await Promise.all([fetch(this.counterparty, () => httpPost(urlConcat(this.apiCounteragent, "counteragent/get"), param)), fetch(this.reliability, () => httpPost(urlConcat(this.apiCounteragent, "counteragent/get-reliability"), param)), fetch(this.limit, () => httpPost(urlConcat(this.apiCounteragent, "counteragent/get-limit"), param)), fetch(this.contractExecutionRisks, () => httpPost(urlConcat(this.apiCounteragent, "counteragent/get-contract-execution-risks"), param))]);
    }

  }
};

/* script */
const __vue_script__$12 = script$12;
/* template */

var __vue_render__$12 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('OfferForProcedure', _vm._b({
    attrs: {
      "inn": _vm.inn,
      "externalId": _vm.externalId,
      "urlCounterpartyPage": _vm.urlCounterpartyPage,
      "lotItemIndex": _vm.lotItemIndex,
      "lotItemName": _vm.lotItemName,
      "showCompanyRisk": _vm.showCompanyRisk
    },
    on: {
      "reject": function (d) {
        return _vm.$emit('reject', d);
      },
      "buy": function (d) {
        return _vm.$emit('buy', d);
      },
      "showSignature": function (d) {
        return _vm.$emit('showSignature', d);
      },
      "changeCbValue": function (d) {
        return _vm.$emit('changeCbValue', d);
      },
      "changeTbValue": function (d) {
        return _vm.$emit('changeTbValue', d);
      },
      "createDeal": function (d) {
        return _vm.$emit('createDeal', d);
      },
      "goToDeal": function (d) {
        return _vm.$emit('goToDeal', d);
      },
      "openChat": function () {
        return _vm.$emit('openChat');
      }
    }
  }, 'OfferForProcedure', Object.assign({}, _vm.$props, _vm.$data), false));
};

var __vue_staticRenderFns__$12 = [];
/* style */

const __vue_inject_styles__$12 = undefined;
/* scoped */

const __vue_scope_id__$12 = undefined;
/* module identifier */

const __vue_module_identifier__$12 = undefined;
/* functional template */

const __vue_is_functional_template__$12 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$12 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$12,
  staticRenderFns: __vue_staticRenderFns__$12
}, __vue_inject_styles__$12, __vue_script__$12, __vue_scope_id__$12, __vue_is_functional_template__$12, __vue_module_identifier__$12, false, undefined, undefined, undefined);

var script$11 = {
  name: 'FilterTag',
  inject: {
    team: {
      default: () => 'default'
    }
  },
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    styleSelected: [Object, String],
    classSelected: String,
    isPolza: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      polzaStyle: polzaStyle$1
    };
  },

  computed: {
    envName() {
      return this.isPolza ? "polza" : "default";
    }

  },
  methods: {
    getClass(className) {
      return this.isPolza && this.polzaStyle[className] || this.$style[className];
    }

  }
};

/* script */
const __vue_script__$11 = script$11;
/* template */

var __vue_render__$11 = function () {
  var _obj;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', _vm._g({
    class: (_obj = {}, _obj[_vm.getClass('filterTag')] = true, _obj[_vm.$style.selectedTag] = _vm.selected, _obj[_vm.$style.darkNoSelected] = _vm.team === 'dark' && !_vm.selected, _obj[_vm.classSelected] = _vm.selected, _obj),
    style: _vm.selected && _vm.styleSelected
  }, _vm.$listeners), [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$11 = [];
/* style */

const __vue_inject_styles__$11 = function (inject) {
  if (!inject) return;
  inject("data-v-5b2ef4e8_0", {
    source: ".src-components-filterTag-N_tG{padding:3px 12px 3px 7px;border-radius:4px 4px 20px 4px!important;border:1px solid #202020;background-color:#fff;color:#202020;text-decoration:none;text-align:left;display:inline-block;vertical-align:center}.src-components-filterTag-N_tG:hover{background-color:#f0f2f4}.src-components-selectedTag-3nwJ{background-color:#f0f2f4;color:#000;border:1px solid #000}.src-components-darkNoSelected-d2i6{background-color:rgba(0,0,0,.2)}.src-components-darkNoSelected-d2i6:hover{background-color:#000}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "filterTag": "src-components-filterTag-N_tG",
      "selectedTag": "src-components-selectedTag-3nwJ",
      "darkNoSelected": "src-components-darkNoSelected-d2i6"
    }
  });
};
/* scoped */


const __vue_scope_id__$11 = undefined;
/* module identifier */

const __vue_module_identifier__$11 = undefined;
/* functional template */

const __vue_is_functional_template__$11 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$11 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$11,
  staticRenderFns: __vue_staticRenderFns__$11
}, __vue_inject_styles__$11, __vue_script__$11, __vue_scope_id__$11, __vue_is_functional_template__$11, __vue_module_identifier__$11, false, createInjector, undefined, undefined);

//'Fz223', 'Fz44', 'Pprf615', 'Commercial'
const organizationLevelsEnum = {
  Fz223: 'Fz223',
  Fz44: 'Fz44',
  Pprf615: 'Pprf615',
  Commercial: 'Commercial',
  Small: 'Small'
};
Object.freeze(organizationLevelsEnum);

function toMoney(nStr, range = 2) {
  if (nStr !== 0 && !nStr) return;
  let type = typeof nStr;

  if (type === "string") {
    nStr = nStr.replace(',', '.');
  }

  nStr = parseFloat(nStr).toFixed(range);
  nStr += '';
  let x = nStr.split('.');
  let x1 = x[0];
  let x2 = x.length > 1 && x[1] !== '00' ? ',' + x[1] : '';
  const rgx = /(\d+)(\d{3})/;

  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + '\u00A0' + '$2');
  }

  return x1 + x2;
}

//
var script$10 = {
  name: "Scale",
  props: {
    zoom: {
      type: Number,
      default: 1
    },
    firstControlPoint: {
      default: 0.01
    },
    secondControlPoint: {
      default: 0.02
    },
    multiplier: {
      default: 100
    },
    scalePrefix: {
      default: "%"
    },
    grey: {
      default: false
    },
    background: {
      default: "rgba(0, 0, 0, 0)"
    },
    labelClass: {
      default: null
    },
    labelYPos: {
      default: 65
    }
  },

  data() {
    let mask0 = v4();
    let mask1 = v4();
    let mask2 = v4();
    let mask3 = v4(); // для уникальности градиента, иначе все шкалы на одной странице используют градиент первой

    return {
      mask0,
      mask1,
      mask2,
      mask3,
      id: v4().slice(0, 6)
    };
  },

  computed: {
    firstControlPointValue() {
      return toMoney(this.firstControlPoint * this.multiplier, 2) + this.scalePrefix;
    },

    secondControlPointValue() {
      return toMoney(this.secondControlPoint * this.multiplier, 2) + this.scalePrefix;
    },

    fills() {
      const result = [{
        id: "paint0-" + this.id
      }, {
        id: "paint1-" + this.id
      }, {
        id: "paint2-" + this.id
      }, {
        id: "paint3-" + this.id
      }];

      for (let fill of result) {
        fill.url = "url(#" + fill.id + ")";
      }

      return result;
    }

  }
};

/* script */
const __vue_script__$10 = script$10;
/* template */

var __vue_render__$10 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.$style.scaleBox,
    style: "font-size: " + 10 * _vm.zoom + "px"
  }, [_c('svg', {
    attrs: {
      "width": "24em",
      "height": "24em",
      "viewBox": "0 0 240 240",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('ellipse', {
    attrs: {
      "cx": "120",
      "cy": "119.999",
      "rx": "120",
      "ry": "120",
      "transform": "rotate(-90 120 119.999)",
      "fill": _vm.background
    }
  }), _vm._v(" "), _c('mask', {
    attrs: {
      "id": _vm.mask0,
      "mask-type": "alpha",
      "maskUnits": "userSpaceOnUse",
      "x": "0",
      "y": "0",
      "width": "241",
      "height": "182"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M120 0C53.7265 -2.89693e-06 0.000808716 53.7256 0.000808716 120C0.000808716 139.167 4.49491 157.286 12.4869 173.358C16.5086 181.446 26.7946 183.343 34.2652 178.266V178.266C41.7453 173.183 43.5182 163.032 39.9151 154.736C35.2915 144.091 32.7281 132.345 32.7281 119.999C32.7281 71.7997 71.8013 32.7265 120.001 32.7265C168.2 32.7265 207.273 71.7997 207.273 119.999C207.273 132.345 204.709 144.092 200.086 154.737C196.483 163.032 198.255 173.183 205.736 178.267V178.267C213.206 183.344 223.492 181.446 227.514 173.358C235.506 157.286 240 139.168 240 120C240 53.7257 186.274 2.89693e-06 120 0Z",
      "fill": _vm.fills[0].url
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "mask": "url(#" + _vm.mask0 + ")"
    }
  }, [_c('mask', {
    attrs: {
      "id": _vm.mask1,
      "mask-type": "alpha",
      "maskUnits": "userSpaceOnUse",
      "x": "-50",
      "y": "-50",
      "width": "340",
      "height": "340"
    }
  }, [_c('circle', {
    attrs: {
      "r": "120",
      "transform": "matrix(0.707107 0.707107 0.707107 -0.707107 120 120)",
      "fill": "#fff"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "mask": "url(#" + _vm.mask1 + ")"
    }
  }, [_c('path', {
    attrs: {
      "d": "M31.291 31.2914L120 -57.4184L208.709 31.291L120 120L31.291 31.2914Z",
      "fill": _vm.fills[1].url,
      "stroke": "white",
      "stroke-width": "4"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "r": "87.2724",
      "transform": "matrix(-1 0 0 1 120 120.001)",
      "fill": "white"
    }
  })]), _vm._v(" "), _c('mask', {
    attrs: {
      "id": _vm.mask2,
      "mask-type": "alpha",
      "maskUnits": "userSpaceOnUse",
      "x": "-50",
      "y": "-50",
      "width": "340",
      "height": "340"
    }
  }, [_c('circle', {
    attrs: {
      "r": "120",
      "transform": "matrix(0.707107 -0.707107 -0.707107 -0.707107 120.001 120)",
      "fill": "#fff"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "mask": "url(#" + _vm.mask2 + ")"
    }
  }, [_c('path', {
    attrs: {
      "d": "M31.2909 208.709L-57.4189 120L31.2906 31.29L120 119.999L31.2909 208.709Z",
      "fill": _vm.fills[2].url,
      "stroke": "white",
      "stroke-width": "4"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "r": "87.2724",
      "transform": "matrix(0 1 1 0 120 120)",
      "fill": _vm.background
    }
  })]), _vm._v(" "), _c('mask', {
    attrs: {
      "id": _vm.mask3,
      "mask-type": "alpha",
      "maskUnits": "userSpaceOnUse",
      "x": "-50",
      "y": "-50",
      "width": "340",
      "height": "340"
    }
  }, [_c('circle', {
    attrs: {
      "r": "120",
      "transform": "matrix(-0.707107 0.707107 0.707107 0.707107 119.999 120)",
      "fill": "#fff"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "mask": "url(#" + _vm.mask3 + ")"
    }
  }, [_c('path', {
    attrs: {
      "d": "M208.709 31.2915L297.419 120L208.709 208.71L120 120.001L208.709 31.2915Z",
      "fill": _vm.fills[3].url,
      "stroke": "white",
      "stroke-width": "4"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "r": "87.2724",
      "transform": "matrix(0 -1 -1 0 120 120)",
      "fill": "#fff"
    }
  })])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "60",
      "y": _vm.labelYPos
    }
  }, [_c('tspan', {
    class: [_vm.$style.label],
    staticStyle: {
      "float": "right"
    },
    style: _vm.labelClass
  }, [_vm._v("\n        " + _vm._s(_vm.firstControlPointValue) + "\n      ")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "180",
      "y": _vm.labelYPos,
      "text-anchor": "end"
    }
  }, [_c('tspan', {
    class: [_vm.$style.label],
    style: _vm.labelClass
  }, [_vm._v("\n        " + _vm._s(_vm.secondControlPointValue) + "\n      ")])]), _vm._v(" "), _c('defs', [_c('linearGradient', {
    attrs: {
      "id": _vm.fills[0].id,
      "x1": "240",
      "y1": "54.1629",
      "x2": "0.000432883",
      "y2": "54.1629",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": _vm.grey ? '#E2E2E2' : '#E43C47'
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.497159",
      "stop-color": _vm.grey ? '#F4F4F4' : '#F6C503'
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": _vm.grey ? '#BBB' : '#52B8DF'
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": _vm.fills[1].id,
      "x1": "31.2905",
      "y1": "31.291",
      "x2": "201.818",
      "y2": "31.3643",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": _vm.grey ? '#BBB' : '#648FDF'
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": _vm.grey ? '#AAA' : '#B149DD'
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": _vm.fills[2].id,
      "x1": "31.2905",
      "y1": "208.709",
      "x2": "31.3638",
      "y2": "38.1816",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": _vm.grey ? '#DDD' : '#52B8DF'
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": _vm.grey ? '#BBB' : '#648FDF'
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": _vm.fills[3].id,
      "x1": "208.709",
      "y1": "31.291",
      "x2": "208.636",
      "y2": "201.818",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": _vm.grey ? '#AAA' : '#D841DD'
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": _vm.grey ? '#888' : '#EE2B45'
    }
  })], 1)], 1)])]);
};

var __vue_staticRenderFns__$10 = [];
/* style */

const __vue_inject_styles__$10 = function (inject) {
  if (!inject) return;
  inject("data-v-611b7c56_0", {
    source: ".src-components-Speedometer-scaleBox-3a_o{z-index:0;line-height:1em}.src-components-Speedometer-label-2TDg{font-style:normal;font-weight:400;font-size:1em;line-height:1em;fill:#999}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "scaleBox": "src-components-Speedometer-scaleBox-3a_o",
      "label": "src-components-Speedometer-label-2TDg"
    }
  });
};
/* scoped */


const __vue_scope_id__$10 = undefined;
/* module identifier */

const __vue_module_identifier__$10 = undefined;
/* functional template */

const __vue_is_functional_template__$10 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$10 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$10,
  staticRenderFns: __vue_staticRenderFns__$10
}, __vue_inject_styles__$10, __vue_script__$10, __vue_scope_id__$10, __vue_is_functional_template__$10, __vue_module_identifier__$10, false, createInjector, undefined, undefined);

//
var script$$ = {
  name: "Speedometer",
  inject: {
    team: {
      default: () => "default"
    }
  },
  components: {
    Scale: __vue_component__$10
  },
  props: {
    zoom: {
      type: Number,
      default: 1
    },
    minValue: {
      default: 0
    },
    value: {
      default: 0
    },
    maxValue: {
      default: 1
    },
    firstControlPoint: {
      default: 1 / 3
    },
    secondControlPoint: {
      default: 2 / 3
    },
    label: {
      default: ""
    },
    measurePostfix: {
      default: "%"
    },
    multiplier: {
      default: 100
    },
    background: {
      default: "rgba(0, 0, 0, 0)"
    },
    labelClass: {
      default: null
    },
    labelYPos: {
      default: 65
    }
  },

  data() {
    return {
      initialRotation: -32,
      degreeMultiplier: 240,
      degreeCorrector: 30
    };
  },

  computed: {
    rotateDegree() {
      if (this.value === 0 || this.maxValue === 0) return this.initialRotation;
      if (this.value < this.firstControlPoint) return this.value / this.firstControlPoint / 3 * this.degreeMultiplier - this.degreeCorrector;
      if (this.value >= this.firstControlPoint && this.value < this.secondControlPoint) return (1 + (this.value - this.firstControlPoint) / (this.secondControlPoint - this.firstControlPoint)) / 3 * this.degreeMultiplier - this.degreeCorrector;
      if (this.value >= this.secondControlPoint && this.value < this.maxValue) return (2 + (this.value - this.secondControlPoint) / (this.maxValue - this.secondControlPoint)) / 3 * this.degreeMultiplier - this.degreeCorrector;else if (this.value >= this.maxValue) return 1 * this.degreeMultiplier - this.degreeCorrector;
      return this.initialRotation;
    }

  },
  methods: {}
};

/* script */
const __vue_script__$$ = script$$;
/* template */

var __vue_render__$$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: [_vm.$style.speedometerBox, _vm.team === 'dark' && _vm.$style.dark],
    style: {
      fontSize: 10 * _vm.zoom + "px",
      width: '24.5em'
    }
  }, [_c('div', {
    class: [_vm.$style.scaleBox, 'safari_hide'],
    style: {
      height: '19.5em',
      width: '24em'
    }
  }, [_c('Scale', _vm._b({
    attrs: {
      "zoom": _vm.zoom,
      "grey": _vm.value == null,
      "background": _vm.background,
      "labelClass": _vm.labelClass,
      "labelYPos": _vm.labelYPos
    }
  }, 'Scale', {
    firstControlPoint: _vm.firstControlPoint,
    secondControlPoint: _vm.secondControlPoint
  }, false)), _vm._v(" "), _vm.value != null ? _c('div', {
    class: _vm.$style.arrow,
    style: {
      transform: 'rotate(' + _vm.rotateDegree + 'deg)'
    }
  }, [_c('svg', {
    attrs: {
      "width": "13.9em",
      "height": "3em",
      "viewBox": "0 0 139 30",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M3.30731 11.455C1.46386 11.6086 0.0458984 13.1496 0.0458984 14.9995C0.0458984 16.8493 1.46385 18.3904 3.30731 18.544L68.8069 24.0023C74.0739 24.4412 78.5911 20.2847 78.5911 14.9995C78.5911 9.71422 74.0739 5.55776 68.8069 5.99667L3.30731 11.455ZM70.0002 18.681C72.0336 18.681 73.682 17.0326 73.682 14.9992C73.682 12.9658 72.0336 11.3174 70.0002 11.3174C67.9668 11.3174 66.3184 12.9658 66.3184 14.9992C66.3184 17.0326 67.9668 18.681 70.0002 18.681Z",
      "fill": "#C4C4C4"
    }
  })])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: [_vm.$style.speedometerText, 'safari_show'],
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.value * 100) + "%")]), _vm._v(" "), _c('div', {
    class: [_vm.$style.label, _vm.team === 'dark' && _vm.$style.labelDark]
  }, [_vm._t("label", [_vm._v(_vm._s(_vm.label))], null, {
    label: _vm.label
  })], 2)]);
};

var __vue_staticRenderFns__$$ = [];
/* style */

const __vue_inject_styles__$$ = function (inject) {
  if (!inject) return;
  inject("data-v-e29ca31a_0", {
    source: "@media not all and (min-resolution:.001dpcm){@media{.safari_hide{display:none}.safari_show{display:block!important}}}",
    map: undefined,
    media: undefined
  }), inject("data-v-e29ca31a_1", {
    source: ".src-components-Speedometer-speedometerText-2SEf{height:auto;color:#fff;font-size:20px}.src-components-Speedometer-speedometerBox-HIYT{display:flex;flex-direction:column;align-items:center;text-align:center}.src-components-Speedometer-speedometerBox-HIYT .src-components-Speedometer-scaleBox-1auN{overflow:hidden;position:relative}.src-components-Speedometer-speedometerBox-HIYT .src-components-Speedometer-arrow-15ec{position:absolute;left:0;top:51%;right:0;transition:transform 2s ease-in-out;line-height:1em!important;display:flex;align-items:center;justify-content:center}.src-components-Speedometer-dark-1pAw .src-components-Speedometer-label-2Hmw{color:#fff!important}.src-components-Speedometer-labelDark-22JR{color:#fff!important}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "speedometerText": "src-components-Speedometer-speedometerText-2SEf",
      "speedometerBox": "src-components-Speedometer-speedometerBox-HIYT",
      "scaleBox": "src-components-Speedometer-scaleBox-1auN",
      "arrow": "src-components-Speedometer-arrow-15ec",
      "dark": "src-components-Speedometer-dark-1pAw",
      "label": "src-components-Speedometer-label-2Hmw",
      "labelDark": "src-components-Speedometer-labelDark-22JR"
    }
  });
};
/* scoped */


const __vue_scope_id__$$ = undefined;
/* module identifier */

const __vue_module_identifier__$$ = undefined;
/* functional template */

const __vue_is_functional_template__$$ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$$,
  staticRenderFns: __vue_staticRenderFns__$$
}, __vue_inject_styles__$$, __vue_script__$$, __vue_scope_id__$$, __vue_is_functional_template__$$, __vue_module_identifier__$$, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$_ = {
  props: {
    region: Object,
    index: Number,
    fill: String,
    stroke: String
  },

  data() {
    return {
      isActive: false
    };
  },

  methods: {
    handlerMousemove(e) {
      this.$emit('mousemove', e, this.region);
    },

    handlerMouseover(e) {
      this.isActive = true;
      this.$emit('mouseover', e, this.region);
    },

    handlerMouseout(e) {
      this.isActive = false;
      this.$emit('mouseout', e, this.region);
    }

  }
};

/* script */
const __vue_script__$_ = script$_;
/* template */

var __vue_render__$_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('path', {
    staticClass: "state",
    class: {
      regionActive: _vm.isActive
    },
    attrs: {
      "fill": _vm.fill,
      "index": _vm.index,
      "stroke": _vm.stroke ? _vm.stroke : '#fff',
      "d": _vm.region.path
    },
    on: {
      "mousemove": _vm.handlerMousemove,
      "mouseover": _vm.handlerMouseover,
      "mouseout": _vm.handlerMouseout
    }
  });
};

var __vue_staticRenderFns__$_ = [];
/* style */

const __vue_inject_styles__$_ = undefined;
/* scoped */

const __vue_scope_id__$_ = undefined;
/* module identifier */

const __vue_module_identifier__$_ = undefined;
/* functional template */

const __vue_is_functional_template__$_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$_,
  staticRenderFns: __vue_staticRenderFns__$_
}, __vue_inject_styles__$_, __vue_script__$_, __vue_scope_id__$_, __vue_is_functional_template__$_, __vue_module_identifier__$_, false, undefined, undefined, undefined);

var data_json = [{
  "id": 306,
  "name": "Белгородская область",
  "kladr": "3100000000000",
  "path": "m93.304,272.29-5.4464,3.3036,0.08928,2.6786,1.6964,1.875,0.08929,3.125,0.44643,1.6964,2.8571,1.6071,2.8571,0.44643l1.608,2.23-2.5,3.3036-0.35714,2.1429,1.0714,1.6071,2.3214,1.5179,0.17857,2.9464,1.1607,1.5179,0.71428,0.89285,4.7321-4.375,3.75-5.4464,2.0536-0.89285,0.80357-4.1072,1.0714-0.89285,0.53571-1.3393-2.5-2.8571-3.5714-4.1071-2.7679-0.26786-2.9464-1.1607-2.6786-1.6964-2.5893-1.6072-1.9643-1.6071z",
  "city_population": 1045099,
  "fed_okrug": "Центральный федеральный округ",
  "country_population": 507722,
  "area": 27134,
  "city_natural_increase": -247,
  "city_migration_increase": 3709,
  "country_natural_increase": -3470,
  "country_migration_increase": 2209,
  "average_nominal_wage": 25456,
  "average_consumer_rate": 19403,
  "average_annual_buzy": 698.1,
  "per_capita_income": 28327
}, {
  "id": 307,
  "name": "Брянская область",
  "kladr": "3200000000000",
  "path": "m97.679,258.62,0.26786-1.7857,2.3214-1.5179,0.44643-1.1607,0-1.4286-1.6071-1.9643-1.7857-2.1429-1.6964-1.9643-2.3214-1.875-1.5179-0.89286-1.6964-0.26786-0.89286-1.1607,0.17857-2.3214,1.3393-1.6071,3.125-2.1429,2.6786-1.875,0.89286-1.7857,0.98214-0.71428,1.6964,0.26786,0.625,1.25,0.625,1.5178,1.0714,2.2322,1.1607,0.80357,5.8929,0.26785,2.1429-0.35714,1.4286,0.53572,3.125,0.89285,2.3214,0,0.71429,1.9643,0,2.2321-0.17857,1.1607-0.98214,1.5178-0.71429,0.53572-0.26786,1.4286,0.26786,1.5179,0,1.25-0.80357,1.4286-1.4286,1.5178-1.7857,0.71429-1.6964,0.17857-1.7857-0.71428-1.4286,0.71428-0.26786,0.89286-2.4107,0.80357-1.0714,1.4286-1.3393,1.25-1.4286,0.17857-1.4286-0.71428z",
  "city_population": 856270,
  "fed_okrug": "Центральный федеральный округ",
  "country_population": 364802,
  "area": 34857,
  "city_natural_increase": -2327,
  "city_migration_increase": -1030,
  "country_natural_increase": -3050,
  "country_migration_increase": -792,
  "average_nominal_wage": 21679,
  "average_consumer_rate": 18759,
  "average_annual_buzy": 522.2,
  "per_capita_income": 25375
}, {
  "id": 308,
  "name": "Владимирская область",
  "path": "m167.41,247.73,1.6072,1.7857,2.0536,1.25,1.1607,1.0714,1.3393,0.35714,0.80357,0.89286,0.0893,1.5178-0.89285,1.7857-0.35715,1.0714,1.25,0.625,1.7857,0.26785,1.0714,1.1607,0.17857,1.9643,0.98214,1.875,1.0714,1.25,1.3393,1.25,1.3393,1.3393,1.3393,1.1607,1.7857,1.875,0.89286,1.3393-0.17857,0.98214-0.89286,0.71429l-0.18,0.98,0.53571,0.71429,0.44643,0.71428,0.0893,1.6072-1.7857,0.53571-2.2321-0.0893-1.1607-1.0714-4.4643-0.0893h-5.1786l-1.7857,0.53571-0.71429-1.6964-1.6964-1.9643-1.6071-2.6786-0.80357-4.1964-0.0893-4.1071-0.17857-2.0536-0.44643-0.44643-0.71428,0.44643-1.1607,0.26785-1.4286-1.25-0.26786-2.5893,0.71429-2.0536,1.1607-2.0536,0.44643-1.7857,1.3393-1.0714z",
  "city_population": 1084920,
  "fed_okrug": "Центральный федеральный округ",
  "country_population": 304920,
  "area": 29084,
  "city_natural_increase": -4393,
  "city_migration_increase": -345,
  "country_natural_increase": -2510,
  "country_migration_increase": -1197,
  "average_nominal_wage": 23877,
  "average_consumer_rate": 16326,
  "average_annual_buzy": 693.2,
  "per_capita_income": 23732,
  "kladr": "3300000000000"
}, {
  "id": 309,
  "name": "Воронежская область",
  "path": "m100.089,310.77,0-6.0714,0.08929-1.1607,3.75-3.2143,2.5-3.6607,1.3393-1.4286,0.35714-1.875,2.4107-0.71428,0.35714-2.5893,0.625-1.7857,1.0714-0.35714,0.625-2.0536,1.3393-1.7857,1.1607-1.0714,0.98214-0.53571,0.89286,1.1607,0.44643,0,0.71429-1.0714,0.53571-0.71428,1.1607-0.17857,0.89286,0.89285,1.25,1.1607,1.4286,1.4286,1.1607,1.5179,0.80357,0.89285-0.26786,2.1429,0,1.6071,1.875,1.0714,2.3214,1.3393,0.80357,1.3393-0.0893,1.7857-0.89285,1.5178-0.44643,0.98215,1.5179,1.25,1.875,1.7857,1.9643,2.2321,1.3393,1.6964,1.1607,1.9643-0.26786,2.3214,0,2.0536-2.1429,1.0714-0.71428,0.17857-4.2857-1.875-2.6786-1.7857-2.1429-1.4286-1.6964-1.1607-0.53571-0.17857-0.71429,0.80357-0.44643,1.25-1.4286,1.9643-1.6964,0.44643-2.8571,0.80357-3.5714,1.1607-3.2143,0.0893-2.5-0.17857-2.3214-1.25-2.3214-1.0714z",
  "city_population": 1571715,
  "fed_okrug": "Центральный федеральный округ",
  "country_population": 763265,
  "area": 52216,
  "city_natural_increase": -2467,
  "city_migration_increase": 9441,
  "country_natural_increase": -7416,
  "country_migration_increase": 2772,
  "average_nominal_wage": 24906,
  "average_consumer_rate": 21222,
  "average_annual_buzy": 1051.7,
  "per_capita_income": 30109,
  "kladr": "3600000000000"
}, {
  "id": 310,
  "name": "Ивановская область",
  "kladr": "3700000000000",
  "path": "m174.26,252.7,2.0203-1.1364s0.94702-0.50507,1.1996-0.50507c0.25254,0,2.5885,0.31567,2.5885,0.31567l2.7148,1.1364,2.3991,1.1364,1.2627,1.1996s1.4521,1.0102,1.7046,1.1996c0.25254,0.18941,1.4521,1.2627,1.4521,1.2627l1.7046,0.63135,1.1364-0.88388h0.88388l0.50508,0.82074,0.1894,1.1996,1.0102,0.75762,1.5152,0.82074,1.0102,0.63135,0.44194,1.0102-0.69448,1.0733-0.12626,0.88388,0.75761,0.37881,0.88388-0.56821,1.389,0.63134,0.69448,0.94702,0.25254,1.2627-0.25254,0.50508-1.894,0.69448-2.9673,0.82075-3.0936,0.50507-2.3991,1.5152-3.4724,0.50508-0.94702-0.12627-1.7678-2.3991-3.5987-3.4724-2.7148-3.3461-0.82075-2.7779-0.88388-1.0102-2.1466-0.44195-0.69448-0.56821,0.50507-1.4521,0.56821-1.3258z",
  "city_population": 832557,
  "fed_okrug": "Центральный федеральный округ",
  "country_population": 190778,
  "area": 21437,
  "city_natural_increase": -3403,
  "city_migration_increase": -1714,
  "country_natural_increase": -1428,
  "country_migration_increase": -526,
  "average_nominal_wage": 21161,
  "average_consumer_rate": 15653,
  "average_annual_buzy": 481.5,
  "per_capita_income": 22560
}, {
  "id": 311,
  "name": "Калужская область",
  "kladr": "4000000000000",
  "path": "m119.196,239.61,1.6071-1.25,1.6071-1.3393l1.161-0.27,1.429,0.63,0.80357,1.4286,1.0714,1.25,1.7857,0.80357,1.7857,0.35715,3.125,0.0893,1.875-0.0893,1.6071-1.0714,2.4107-0.0893,1.4286,0.44643,0.98214,2.0536,0.26786,1.4286,1.25,0.625,1.6071,0.98215,0.98214,0.80357,0.53572,1.25-0.53572,2.0536-1.0714,1.7857-1.4286,1.9643-1.1607,1.25-0.89286,0.44643-3.75-1.25-2.6786-1.0714-2.6786,0.0893-1.875,0.44642-1.0714,1.25-1.5179-0.44642-1.0714,0.0893-1.0714,0.80357-2.0536,1.0714-0.89286-0.89286-1.0714-0.80357-1.9643-1.25-1.5179-0.89285-0.89286-0.44643v-1.0714-2.4107l-0.08929-0.625,1.1607-1.6964,1.0714-1.875v-1.7857l-0.26786-1.6071z",
  "city_population": 773018,
  "fed_okrug": "Центральный федеральный округ",
  "country_population": 243450,
  "area": 29777,
  "city_natural_increase": -1053,
  "city_migration_increase": -122,
  "country_natural_increase": -1373,
  "country_migration_increase": 1834,
  "average_nominal_wage": 29939,
  "average_consumer_rate": 18346,
  "average_annual_buzy": 487.5,
  "per_capita_income": 27550
}, {
  "id": 312,
  "name": "Костромская область",
  "kladr": "4400000000000",
  "path": "m198.7,245,1.389,0.12627,1.2627-0.75762,1.5152-1.389,1.894-0.75762,1.894,1.1364,1.894,1.5152,2.5254,0.12627,0.63135-0.75761,0.75761,0.50507,1.2627,2.1466,2.2728,2.2728,1.5152,1.5152,1.1364,1.894,0.3788,2.2728,1.2627,1.7678,1.5152,1.6415,2.5254,1.389,1.7678,1.5152,1.7678,1.894,2.0203,0.88388,1.894,0.12627,2.0203-2.0203,1.6415-0.3788,0.63135,1.894,1.1364,1.0102-0.12627,1.6415-1.6415,1.5152-0.12627,1.894-0.3788,2.5254s-1.7678,0.75761-2.3991,0.75761c-0.63134,0-6.3134-0.12626-6.3134-0.12626l-3.1567,0.12626-1.1364,1.1364-1.2627,0.50507-2.0203-0.75761-1.5152-0.75762-2.0203-0.3788-1.0102-1.5152-0.88388-1.6415-0.75762-0.63135-1.1364-0.12627-0.88388,0.50508-2.1466,0.75762-3.283-0.25254-1.7678-0.50508-2.0203-1.2627-0.50508-0.50508,0.25254-0.63134v-1.1364l-1.389-1.2627-0.88389-0.50508-0.63134,0.37881-0.38556,0.10695-0.53571-0.35714,0.0893-0.89286,0.71429-0.625,0.0893-0.98214-0.89285-0.71429-1.7857-1.0714-0.98214-0.98215-0.26786-0.98214-0.71428-0.89286h-0.98215l-0.89285,0.625-0.625,0.0893-1.25-0.71429-1.4286-0.80357-1.3393-1.25-1.7857-1.3393-0.69-0.57,1.07-0.71,2.05-0.54,2.3214-0.71428,2.8571-2.0536,3.3036-1.6964z",
  "city_population": 466345,
  "fed_okrug": "Центральный федеральный округ",
  "country_population": 182017,
  "area": 60211,
  "city_natural_increase": -693,
  "city_migration_increase": 140,
  "country_natural_increase": -1610,
  "country_migration_increase": -777,
  "average_nominal_wage": 21796,
  "average_consumer_rate": 14595,
  "average_annual_buzy": 296.2,
  "per_capita_income": 22466
}, {
  "id": 313,
  "name": "Курская область",
  "kladr": "4600000000000",
  "path": "m93.482,271.84,0-4.6429l-0.357-1.61-1.786-1.97-0.714-1.07,1.3393-1.0714,3.75-1.3393,2.7679-1.3393,2.6786,0.0893,0.53571,1.0714,1.25-0.0893,1.7857-1.1607h0.80357l0.98214,0.44643,1.4286,1.6071,0.53571,0.80357,0.08929,1.6964,1.0714,0.89286,1.0714,0.71428h0.89286l1.0714,1.25,0.17857,3.2143v2.4107l-0.89286,0.98214v1.5179,1.1607l1.0714,1.25,1.1607,0.98214,0.89286,0.17857,1.5179,0.53571,1.0714,1.6072,1.6071,1.5178-0.71429,1.1607-0.80357,0.89286-0.89286-0.80358-1.9643,1.25-1.4286,1.1607-0.53571,0.80357-3.4821-4.1071-2.2321-2.3214-0.98214-0.53572-3.3036-0.625-2.8571-1.5178-3.6607-2.1429-2.4107-1.9643z",
  "city_population": 760118,
  "fed_okrug": "Центральный федеральный округ",
  "country_population": 363047,
  "area": 29997,
  "city_natural_increase": -893,
  "city_migration_increase": 7770,
  "country_natural_increase": -4280,
  "country_migration_increase": 44,
  "average_nominal_wage": 23921,
  "average_consumer_rate": 17600,
  "average_annual_buzy": 565,
  "per_capita_income": 25814
}, {
  "id": 314,
  "name": "Липецкая область",
  "kladr": "4800000000000",
  "path": "m116.875,278.45,1.5179,1.875,1.0714,0.89286,1.1607,0.71428,1.1607,1.0714,2.5,2.2321,1.25,1.5179,0.625,1.4286-0.44643,2.5893,0.53572,0.625,2.5,1.3393,1.875,1.7857,1.0714-0.17857,1.0714-0.625,0.44643-0.80357,0.0893-5.8036,0.35714-0.71428,1.4286-0.80357,2.3214-0.17857,2.0536-1.1607,1.3393-0.44643,0.17857-1.6964,0.625-1.3393,1.25-1.5179-0.80357-1.1607-2.6786-0.98215-0.53571-0.53571-0.17858-0.71429,1.0714-1.3393,0-1.6071-2.1428-0.35715-1.0714,0.44643-1.6072,0.80357-0.98214,0.89286-1.1607,0.625-1.4286,0.0893-1.3393-1.5179-1.6964-1.6964-0.80357-0.98214-2.4107,0.89285-3.125,1.6964-1.1607,1.6072-1.6071,1.4286z",
  "city_population": 742100,
  "fed_okrug": "Центральный федеральный округ",
  "country_population": 414200,
  "area": 24047,
  "city_natural_increase": -1061,
  "city_migration_increase": -17,
  "country_natural_increase": -3236,
  "country_migration_increase": 2542,
  "average_nominal_wage": 24524,
  "average_consumer_rate": 20229,
  "average_annual_buzy": 541,
  "per_capita_income": 27657
}, {
  "id": 315,
  "name": "Московская область",
  "kladr": "5000000000000",
  "path": "m146.07,234.16,3.5714,0.26785,2.3214-0.89285,1.4286-0.44643,0.53571,0.625,0.0893,1.7857,0,1.1607-0.17857,1.3393,1.5178,0.89286,2.9464,0.44643,1.7857,0.89285,2.0536,0.89286,2.7678,0.89286,1.7857,0.26786,1.25,0.53571,0.26786,1.6071-0.0893,1.5179-0.44643,1.6964-1.5179,0.625-2.1428,1.1607-1.6072,1.3393-0.0893,1.25-0.625,1.7857-1.1607,1.5179-0.35714,1.6071,0.17857,1.6072,0.0893,0.89285,1.1607,1.0714,1.0714,0.625,1.1607-1.0714,0.625,0.44643,0,1.5179-0.0893,3.2143-0.44643,1.1607-1.3393-0.44643-1.875-0.17857-1.6072,0.17857-0.80357,0.89286-2.0536,0.0893-1.6071-0.35714-1.25-0.71429-1.0714-1.1607-1.6071-0.625-1.6964,0-0.44643,0.80357-0.17857,1.1607-1.0714,0.53571-1.4286,0.0893-0.80357-0.80358-0.17858-0.625,1.1607-2.4107,0.26786-1.9643-0.53572-1.6964-1.1607-1.5179-1.1607-1.5179-1.0714-0.89286,0.625-1.25,2.5-2.9464,1.1607-2.6786-0.71429-1.7857-1.6071-1.6071-1.6071-0.98215-0.53572-0.35714-0.625-1.875-0.80357-1.25-0.80357-0.80357,0.625-1.5179,2.5893-1.3393z m4,16 a3,3 0 1,0 6,0a3,3 0 1,0 -6,0z",
  "city_population": 6069597,
  "fed_okrug": "Центральный федеральный округ",
  "country_population": 1360298,
  "area": 45799,
  "city_natural_increase": 4340,
  "city_migration_increase": 66873,
  "country_natural_increase": -4364,
  "country_migration_increase": 20730,
  "average_nominal_wage": 40643,
  "average_consumer_rate": 26390,
  "average_annual_buzy": 3071.2,
  "per_capita_income": 37622
}, {
  "id": 316,
  "name": "Орловская область",
  "kladr": "5700000000000",
  "path": "m104.732,258.27,1.0714-1.875,2.2321-0.26786,0.89286-1.6071,0.89286-0.53572,1.9643,0.89286,1.6964-0.0893,1.6071-0.71429,1.0714-1.5179,0.89286-0.53571,0.98214,0.17857,1.3393,0.98214,1.9643,0.89286,1.1607,0.89286,0.35714,0.89285,0.71429,1.3393,0.17857,2.0536,0,3.6607,0.98214,1.7857,1.4286,1.875,0.80357,1.25,0.71429,1.7857-0.26786,1.5179-3.9286,1.875-1.9643,0.98214-1.0714,2.1429-1.875,1.0714-1.875,1.0714-2.4107-0.89286-1.9643-1.6071-0.44643-1.6964,0.44643-1.9643,0.44643-0.89285,0.08928-4.4643-0.89286-1.6964-1.7857-0.53571-1.7857-1.4286-0.08929-1.6072-1.3393-1.5178-1.6071-1.6964z",
  "city_population": 504028,
  "fed_okrug": "Центральный федеральный округ",
  "country_population": 251320,
  "area": 24652,
  "city_natural_increase": -2030,
  "city_migration_increase": 445,
  "country_natural_increase": -1881,
  "country_migration_increase": -2044,
  "average_nominal_wage": 21772,
  "average_consumer_rate": 16511,
  "average_annual_buzy": 383,
  "per_capita_income": 22840
}, {
  "id": 317,
  "name": "Рязанская область",
  "kladr": "6200000000000",
  "path": "m144.55,265.59-1.9643,2.6786-2.1429,3.125-0.625,2.7679-0.80357,1.7857,0.17857,0.80357,1.6964,0.71429,1.9643,1.3393,0.44643,1.5179-0.26786,0.89286,1.4286,1.1607,1.9643,0,1.1607,0.71429,0.0893,1.875,0.44643,1.1607,1.25,0.44643,1.5179-0.625,1.9643,0,1.5179,0.98214,0.625,1.7857,1.0714,1.1607,2.6786-0.17857,3.125,0,2.9464-2.0536,3.0357-2.9464,1.5179-2.2321,1.0714-1.7857-0.98214-2.2321-0.53572-3.125-2.0536-2.0536-1.25-1.6964-0.44643-2.8571-0.53571-1.6072-0.35715-0.98214-2.1428-0.35714-3.4822,0.26786-0.625,0.80357-2.1428-0.17857-1.875-0.71429-1.875-1.0714-1.9643-0.89286-1.0714,0.35715-0.80357,1.4286-1.4286,0.89286-1.6071-0.44643z",
  "city_population": 807668,
  "fed_okrug": "Центральный федеральный округ",
  "country_population": 319334,
  "area": 39605,
  "city_natural_increase": -3336,
  "city_migration_increase": 1758,
  "country_natural_increase": -2000,
  "country_migration_increase": -1757,
  "average_nominal_wage": 25482,
  "average_consumer_rate": 15997,
  "average_annual_buzy": 491.9,
  "per_capita_income": 24219
}, {
  "id": 318,
  "name": "Смоленская область",
  "kladr": "6700000000000",
  "path": "M109.375,237.55,110,235.95,110.179,234.52,109.732,233l-0.08928-1.4286,1.5179-1.3393,0.71429-1.6071,0.08929-3.125,0.35714-1.875,2.4107-2.5,2.5-1.9643,1.875-1.7857s1.875-1.3393,2.2321-1.5179c0.35714-0.17857,2.5-1.5178,2.5-1.5178l2.5,0.0893,3.0357,3.4822,1.875,3.4821,2.5,3.6607,1.4286,0.89286,2.7679,0.53571h2.0536l0.80357,0.71429,1.1607,1.875,1.1607,1.3393,1.25,1.6071,1.0714,1.4286,0.17857,1.3393-0.98214,1.25-1.875,0.89285-1.875,0.53572-0.89286,1.25-0.44643,0.89285-1.875,0.44643-1.7857,0.625-1.6072,0.35715h-3.0357l-3.75-0.80358-1.7857-1.7857-1.4286-1.3393-1.1607-0.26785-1.1607,0.71428-2.2321,1.5179-1.1607,0.44643-1.7857-0.44643-4.1071-0.98214-2.4107-0.35715z",
  "city_population": 685548,
  "fed_okrug": "Центральный федеральный округ",
  "country_population": 267532,
  "area": 49779,
  "city_natural_increase": -2469,
  "city_migration_increase": -1965,
  "country_natural_increase": -3106,
  "country_migration_increase": 1379,
  "average_nominal_wage": 23470,
  "average_consumer_rate": 17290,
  "average_annual_buzy": 482.2,
  "per_capita_income": 24763
}, {
  "id": 319,
  "name": "Тамбовская область",
  "kladr": "6800000000000",
  "path": "m142.77,279.43-1.6964,2.1429-0.35714,1.7857-0.80358,0.89286-2.6786,0.98214-1.875,0.44643-1.5178,0.71429-0.71429,1.4286,0,2.1429,0.26786,2.3214-0.71429,1.875-1.5179,0.53571-0.44642,1.4286-0.44643,1.6964-0.625,1.1607,0.08928,0.625,2.3214,2.1429,2.2321,2.1429,1.6072,2.2321,1.4286,2.0536,0.98214,0,2.1429,0,1.9643-1.25,2.5-1.25,1.6964-1.0714,4.0179-0.26785,1.0714-0.98215v-3.6607c0-0.35714,0.0893-2.3214,0.0893-2.3214l1.5179-1.1607s0.71429-0.71429,0.80357-1.0714c0.0893-0.35714-0.26785-4.6429-0.26785-4.6429l1.4286-1.0714-0.80357-2.1428-1.7857-1.4286-2.3214,0.26786-0.89285,0.625-1.1607-0.80357-0.89286-1.3393v-1.3393l-1.875-0.80357h-1.3393l-0.89286-1.0714-0.26786-1.3393z",
  "city_population": 628905,
  "fed_okrug": "Центральный федеральный округ",
  "country_population": 410609,
  "area": 34462,
  "city_natural_increase": -2777,
  "city_migration_increase": -1134,
  "country_natural_increase": -3890,
  "country_migration_increase": -4325,
  "average_nominal_wage": 21725,
  "average_consumer_rate": 18370,
  "average_annual_buzy": 500.2,
  "per_capita_income": 25076
}, {
  "id": 320,
  "name": "Тверская область",
  "path": "m128.661,216.66,3.2143-0.625,2.2321-1.6072,1.3393-1.6071,0.17857-1.4286-0.80357-1.4286-0.26786-1.3393,0.35714-0.89286,1.4286-0.89285,1.6964-0.625,1.1607,0.44643,1.5179,1.5178,1.0714,0.98215,0.98215,0.53571,1.6964,0.17857,2.4107,0.35714,1.3393,0.98215,1.3393,0.26785,3.2143,0.44643,1.5178,0,1.25,0.71429,0.80358,0.71428,1.875,0.35715,1.7857-0.17857,1.875-1.6072,1.25-1.25,0.71429,0.44643,0.625,0.80357,1.4286,0.44643,1.4286,0.17857,0.53571,1.5179,0.17857,2.4107,0.35715,0.80358,1.1607,0.71428,1.4286,0.80357,1.0714,0.26786,1.875,0.35714,0.98214,0.26786,1.25,1.0714,0.44643,1.3393,0.98214,1.0714,0.80358,0.53572,1.7857-0.35715,1.3393,0.0893,1.25,0.71429,1.6071,0.89285,0,1.5179-0.625,1.6964-1.25,1.6071-1.6071,0.44643-1.25,0.98214-1.5179,1.3393-0.89286,1.0714-0.44643,0.71428-0.26785,1.5179-0.44643,1.0714-1.25,1.4286-0.53572,1.4286-0.35714,2.0536-2.0536,1.9643-2.0536,1.3393-1.0714,0.17858-0.53571-0.71429-0.26786-1.7857-1.6964-0.71429-3.8393-0.89286-3.8393-1.6071-3.0357-0.80357-1.5178-1.0714-0.0893-3.0357-0.35714-1.6964-3.3036,0.80357-3.4822,0.26786-1.3393-0.89286-3.4821-4.4643-1.5179-2.0536-3.3036-0.625-2.7679-0.53571-1.4286-1.7857z",
  "city_population": 981322,
  "fed_okrug": "Центральный федеральный округ",
  "country_population": 316143,
  "area": 84201,
  "city_natural_increase": -5162,
  "city_migration_increase": 325,
  "country_natural_increase": -3271,
  "country_migration_increase": -2219,
  "average_nominal_wage": 24804,
  "average_consumer_rate": 17130,
  "average_annual_buzy": 570.3,
  "per_capita_income": 23450,
  "kladr": "6900000000000"
}, {
  "id": 321,
  "name": "Тульская область",
  "path": "m123.482,256.3,3.2143-2.0536,0.98214-0.17857,1.6071,0.80357,0.98215-0.80357,0.71428-1.0714,3.125,0,1.6072,0.625,2.0536,0.35714,1.4286,0.80358,2.4107,0.35714,1.4286,0.71428,0.53572,1.0714,0.98214,1.0714,1.25,1.4286,0.71429,1.6072-0.35715,1.6964-0.98214,1.1607-0.71428,1.6964-1.3393,1.9643-1.6964,2.0536-1.0714,1.875-0.71428,0.98215-0.53572,0.35714-1.7857,0-2.5,0.89286-1.5179,1.0714-1.3393,0.26785-2.0536-1.3393-2.0536-2.5893-0.26786-2.0536-0.53571-1.4286-1.6071-2.5l-1.413-2.14-0.179-2.23z",
  "city_population": 1121260,
  "fed_okrug": "Центральный федеральный округ",
  "country_population": 378226,
  "area": 25679,
  "city_natural_increase": -7046,
  "city_migration_increase": 1700,
  "country_natural_increase": -2954,
  "country_migration_increase": 1176,
  "average_nominal_wage": 27555,
  "average_consumer_rate": 18163,
  "average_annual_buzy": 742.9,
  "per_capita_income": 26286,
  "kladr": "7100000000000"
}, {
  "id": 322,
  "name": "Ярославская область",
  "path": "m184.11,228.33,1.7678,1.5784,1.9572,0.50507,1.7678,0.50508,1.3258,1.6415,1.9572,1.5784,1.5784,0.0631,1.0733-0.69448,0.82075,0.31568,0.3788,1.4521,0.12627,3.4093-0.0631,2.6516,0.25254,1.5152,0.88388,1.0102,0.56821,0.94702-0.37881,1.0733-1.7046,1.1364-2.7148,1.3258-3.283,2.2097-1.6415,1.0733-3.3461,0.88388-2.4622-0.1894-2.1466-0.63135-2.6516-0.69448-2.1466,0.63135-1.8309,1.0733-1.7046-0.88388-1.4521-1.0102-1.894-1.1364-1.1364-1.1996-0.25254-1.3258,0.56821-1.4521,2.0203-0.88388,2.2097-1.1996,1.6415-2.7779,1.0102-2.9673,1.1996-1.2627,0.75762-2.4622,1.6415-1.8309,1.9572-1.8309,2.7148-1.5152z",
  "city_population": 1038398,
  "fed_okrug": "Центральный федеральный округ",
  "country_population": 232865,
  "area": 36177,
  "city_natural_increase": -2481,
  "city_migration_increase": 2268,
  "country_natural_increase": -1898,
  "country_migration_increase": 2394,
  "average_nominal_wage": 26748,
  "average_consumer_rate": 17461,
  "average_annual_buzy": 622.3,
  "per_capita_income": 27369,
  "kladr": "7600000000000"
}, {
  "id": 325,
  "name": "Республика Карелия",
  "path": "M246.94,136.91l-2.28,1.53,0.12,1.62-1,2.28-1.9,2.04-1.88,0.87-4.31-0.13-0.88,1-2.28,2.16h-2.91l-2.4,0.38-0.13,4.03-0.62,1.9-2.91,0.38-1.87,0.25,0.12,1.4,0.88,1.5-1.78,1.29-1.25,0.5-3.41-0.91-1.66,1.16-0.37,2.9-0.13,4.16-1.25,2.28-2.65,1.62-3.41,1.16-8.72-0.12-3.53-0.91-5.19-0.75-4.28-0.75,0.88,1.87-0.13,1.54,0.07,0.53-0.94,5.65-2.53,1.5-2.03,3.32-2.91,1.87-0.13,1.66,2.66,1.25,1.91,0.75,1,2.4,2.9,0.25,5.07-0.75,1.65-0.9,2.25,0.53,1.78,1.37,1.38-1.62,1.12-0.78,1.78,4.69,1.5,0.62,2.91,1.53,0.06,0.69-0.12,2.69,0.06,1.78-1.63,1.53,1,1.12,2.29,0.5,1.75-0.62,2.53-1,0.62-0.5,1.91,1.5,1,1.9,1.03,1.88,3.16,0.25,3.28-3.03,0.75-1.5,1.25-1.38,2.4-1.28,2.03-1.75,0.5-1.15-0.37-1.25-1.91-0.63-1-1.03,0.13-1.63,1.37-2.4,1.78-1.91,1.66-1.87,1.25-2.16,1.38,0.25,1.78,1.53h1.9l0.88-0.53,0.12-2,1.5-2.03,0.25-1.75-0.25-3.16-0.5-1.53,0.63-1.78,1.4-0.87,1.38-0.63,3.03-2.53,0.5-1.13,0.53-1.28h1.38l3.4-0.62,2.16-1,1.5-1.28v-1.88-3.4l0.25-2.54,1.03-0.87v-1.16l-0.12-2-0.78-1.15-2-0.38-1.41-0.37-0.63-0.88v-0.75l0.63-1.15,1.28-1,0.75-0.63-0.38-1.03-1.65-2.37-1.88-2.29-1.4-2.15-1.75-2.53z",
  "city_population": 503010,
  "fed_okrug": "Северо-западный федеральный округ",
  "country_population": 124305,
  "area": 180520,
  "city_natural_increase": -616,
  "city_migration_increase": 569,
  "country_natural_increase": -1308,
  "country_migration_increase": -1303,
  "average_nominal_wage": 30704,
  "average_consumer_rate": 18422,
  "average_annual_buzy": 289.6,
  "per_capita_income": 25734,
  "kladr": "1000000000000"
}, {
  "id": 326,
  "name": "Республика Коми",
  "path": "m254.63,259.27,2.1466-0.63134,0.63134-0.88388,1.894,0.12627,1.6415,1.894,2.1466,0.25254,2.1466-0.50508,1.5152-1.894,0.50508-1.5152-0.63135-0.88389,0.63135-1.5152,2.1466-1.2627,4.5457-1.894,2.6516-1.1364,0.25254-1.5152-0.50508-2.5254-2.1466-0.88389-3.283,0.12627-2.3991,1.6415-2.3991-0.75761s-0.50508-1.0102-1.2627-1.0102-1.5152-0.25253-1.5152-0.25253l0.50507-3.0305,1.7678-0.37881,1.389-1.5152,0.50508-1.894,2.1466-0.50508,2.2728,0.12627,0.63135-1.7678-0.63135-0.63134-0.63134-2.1466,0.63134-1.389,4.5457-2.0203v-1.2627l-1.0102-2.5254-0.63135-1.6415-1.6415-1.7678-0.63134-1.1364,0.25254-1.6415,1.2627-0.63134,1.7678,0.75761,1.5152,2.1466,1.6415,1.5152,2.2728,1.894,2.6516,1.2627,1.7678,1.1364,0.50508,1.7678,1.5152,1.5152,3.1567,0.3788,1.894,1.2627,2.9042,0.50507,0.88388,1.2627h2.0203l1.0102-0.63134-0.25254-1.5152-0.75761-1.5152,0.50507-1.0102,0.88389-1.5152s0.25253-1.1364-0.12627-1.6415c-0.37881-0.50508-1.1364-1.1364-1.1364-1.1364v-0.88388l2.7779-3.283,3.1567-2.1466,1.894-2.0203,1.0102-0.88388,2.3991,0.63134,3.4093,0.12627,2.5254,0.75762,4.2932,0.50507,2.1466,0.63135,3.283,0.12627,2.3991-0.50508,1.5152,0.12627,0.12627,1.894,1.2627,1.0102,2.1466,2.1466,5.3033,4.672,7.4499,4.672,6.4397,3.7881,5.177,3.0305,5.5558,3.283,2.7779,1.894,2.2728,0.25254h3.283l2.1466-1.0102,2.5254-2.3991,1.6415-1.2627,2.7779,0.25253,2.3991-0.12626,2.0203-0.63135,1.5152-0.88388,1.6415-0.37881,3.1567,0.12627,1.6415,0.25254-0.50508,1.5152-0.88388,1.1364-1.1364,0.63134-0.50508,1.894,1.2627,1.7678,1.2627,1.389,0.12627,1.894-1.1364,1.389-0.88388,0.25254-0.75762,1.389-2.0203,0.25254-2.3991-0.12627-2.1466,0.88388-2.5254,1.389-1.389,1.1364-3.0305-0.12627-2.1466-0.50507h-3.1567-2.0203l-1.0102,0.3788-1.389,1.5152-0.75762,0.88389-2.1466,1.6415-1.5152,0.50508h-2.3991l-2.3991-0.25254-1.5152,0.50508-2.9042,2.0203-2.2728,1.2627-1.5152,1.0102-1.5152,0.3788-1.2627-0.12626-1.2627-1.0102-0.12626-1.894-0.63135-1.389-1.6415,0.88388-1.5152,1.389-1.0102,1.2627-0.88388,0.50508-1.2627,0.50507-0.75762,0.37881-0.12627,1.7678-0.3788,1.7678-0.63135,1.389-0.88388,1.1364-1.0102,1.6415-1.894,1.6415-1.6415,1.389-1.2627,0.75762-2.7779,3.283-1.894,2.6516-1.1364,3.0305-0.50507,1.6415-1.5152,1.6415-2.0203,0.88388-1.5152,0.63134-1.7678,1.0102h-2.2728l-3.1567-1.0102-3.1567-1.6415-4.4194-2.1466-0.75761-0.3788-2.5254,0.50507h-3.283l-3.0305-0.88388-2.9042-1.389-1.0102,0.25254-1.6415-0.12627-1.5152-1.2627-2.2728-2.3991-1.894-0.88388-0.63135-1.5152-2.2728-3.0305-5.8084-1.1364-1.389-0.63134-1.7678,0.63134-0.75761,0.75762v0.75761l0.37881,0.88389v1.6415,1.0102l-0.50508,0.3788-1.389-0.63134-0.88388-0.37881-1.1364,0.25254-1.5152,0.88388-1.5152,0.50508-1.1364-0.25254-0.88389-1.389-0.88388-0.63135-2.2728-0.88388-6.0609-1.1364-1.2627,0.25254-1.1364,1.1364-0.63135,1.5152-1.1364,0.37881-1.6415-1.389v-1.1364l1.0102-1.389,0.50507-0.75761-0.50507-1.0102-1.1364-1.0102-1.1364-1.0102-0.3788-0.75761,1.5152-1.2627,1.1364-2.5254,1.6415-1.0102,1.6415-0.3788,1.894-1.2627,0.88388-2.3991,1.2627-1.2627z",
  "city_population": 663678,
  "fed_okrug": "Северо-западный федеральный округ",
  "country_population": 187308,
  "area": 416774,
  "city_natural_increase": 1342,
  "city_migration_increase": -5679,
  "country_natural_increase": -197,
  "country_migration_increase": -3059,
  "average_nominal_wage": 41365,
  "average_consumer_rate": 20892,
  "average_annual_buzy": 425.3,
  "per_capita_income": 33328,
  "kladr": "1100000000000"
}, {
  "id": 328,
  "name": "Ненецкий автономный округ",
  "path": "m290.27,198.54,1.6071-0.89286,1.4286-1.1607,2.0536-1.0714,1.1607-1.25,0.625-3.3929,1.1607-1.6071s1.4286-0.80358,2.4107-1.0714c0.98215-0.26786,2.3214-0.26786,2.6786-0.26786,0.35714,0,1.5178-0.98214,2.0536-1.5179,0.53571-0.53571,3.0357-2.5,3.0357-2.5l0.71429-1.0714v-2.2321l1.25-1.9643s0.89285,0.17857,0.98214,0.625c0.0893,0.44642,0.26786,1.5178,0.625,1.6964,0.35714,0.17858,1.875,1.4286,1.875,1.4286l1.6964,1.1607,0.98214,0.89286-0.0893,1.3393-0.625,1.4286-0.44643,1.7857v1.6964l-0.26786,1.0714-0.44643,0.80357-0.26786,1.25-1.25,0.71428-1.3393-0.625-1.25-0.98214-0.625-0.80357-2.3214-0.53572h-3.0357c-0.44643,0-2.1429,1.1607-2.1429,1.1607l-0.80357,1.4286,0.17857,1.0714s0.53571,0.89286,0.625,1.25c0.0893,0.35714-0.71429,1.1607-0.71429,1.1607l-0.89285,1.6072s-0.26786,1.1607-0.0893,1.4286c0.17857,0.26785,0.625,0.80357,1.1607,1.25,0.53572,0.44643,1.875,1.5178,2.1429,1.6964,0.26786,0.17857,1.875,0.89285,1.875,0.89285s2.3214,0.17857,2.8571,0.17857c0.53572,0,1.9643-0.26785,1.9643-0.26785s1.5179-0.98215,1.875-1.1607c0.35714-0.17857,1.9643-1.1607,1.9643-1.1607s1.0714-0.44643,1.4286-0.35714c0.35714,0.0893,1.3393,0.98214,1.3393,0.98214l2.3214,0.17857s0.35714-0.44643,0.71429-0.80357c0.35714-0.35714,0.53571-0.71429,0.98214-0.35714,0.44643,0.35714,1.875,1.3393,1.875,1.3393l1.7857,0.44643h5.0893l2.5893,0.0893s0.80357,0.80357,1.25,0.89285c0.44642,0.0893,3.3928,0.53572,3.3928,0.53572l1.5179,1.4286,0.71429,1.9643,1.1607,0.17858,0.71429-1.5179,0.89285-1.0714,1.875-0.17857,0.89286,0.53571,2.1429,0.17857,2.5893,0.44643-0.44643,0.80357-0.98214,0.80358-1.6964,0.625-0.80357,0.98214-0.71428,0.98214-1.6964,0.71429-0.26786,1.0714,1.3393,0.98214,1.25,0.53571,0.625,2.0536,0.71428,0.35715,1.6964-0.80357s1.3393-0.89286,1.6071-0.89286c0.26786,0,3.3036,0.53571,3.3036,0.53571l2.6786,1.3393,1.5178,1.3393,1.4286,0.89286,4.4643,0.17857,0.71429,0.71429,1.5178-0.26786,2.5893-0.35714,1.7857-1.3393,0.625-1.7857s0.53572,0.625,0.53572,1.1607c0,0.53572-1.6964,2.7679-1.6964,2.7679l-0.71429,1.7857v1.0714l-1.1607,1.1607-0.89286,0.625-0.44643,0.98214,0.44643,0.80357h1.4286l0.80357-1.6071,0.17858-0.53572,1.5178-0.0893,1.5179,1.25,2.3214,0.35714,1.1607-0.89286,1.3393-1.1607,0.53571-0.89286-0.71428-1.0714-0.35715-1.4286,1.5179-1.1607,0.71429-1.875-0.53572-1.6964-1.25-0.80357-0.71428-3.3929-0.26786-3.125s-0.26786-0.89286,0.0893-1.25c0.35714-0.35714,2.2321-1.6964,2.2321-1.6964l1.3393,0.17857,1.1607,1.4286,1.0714,1.9643,0.35714,2.1429-0.89286,3.3036,0.89286,1.0714,2.8571,2.4107,2.7679,2.8572,3.3929,2.5893,2.1428,3.3036,1.6964,3.3929,0.80357,1.875,0.17858,1.6071-1.0714,1.1607-0.98215,2.0536-0.98214,1.5179h-2.5c-0.44643,0-3.6607-0.17858-3.6607-0.17858l-2.1429,0.98215-2.7679,0.71428h-3.0357l-1.7857-0.17857-2.4107,1.875-3.0357,2.4107-1.6072,0.53571-2.7678-0.0893-2.0536-0.53571-4.2857-2.4107-23.036-13.929-7.6786-6.875-1.25-1.1607v-1.3393l-0.98214-0.625-2.4107,0.625-5.0893-0.44642-5.625-0.98215-5.1786-0.80357-3.125-0.26786-4.1071-2.3214-2.0536-0.44643-1.7857,0.625-1.7857-0.26786-1.5179-1.7857-4.2857-8.4822-0.98215-2.4107z",
  "city_population": 31792,
  "fed_okrug": "Северо-западный федеральный округ",
  "country_population": 12120,
  "area": 176810,
  "city_natural_increase": 304,
  "city_migration_increase": 316,
  "country_natural_increase": 60,
  "country_migration_increase": -215,
  "average_nominal_wage": 71230,
  "average_consumer_rate": 24139,
  "average_annual_buzy": 33.2,
  "per_capita_income": 70924,
  "kladr": "8300000000000"
}, {
  "id": 329,
  "name": "Архангельская область",
  "path": "M421.06,151.03l-3.56,1.06-2.16,0.91-3.56,0.19-1.59,0.87s-1.26-1.07-1.97-1.25c-0.72-0.18-0.91,1.1-0.91,1.1l-1.78,2.65-2.69,1.63-3.03,0.87-2.31,1.78s-2.15,0.37-3.22,0.72c-1.07,0.36-2.5,0.19-2.5,0.19l-1.59,0.72,1.06,1.78-2.16,1.25,0.38,0.72,1.25,1.44,1.78,1.59,1.78,1.78,0.91,1.63,1.4-0.72,0.91-1.97,2.16-0.72,1.25-0.53,1.93-0.19,0.91-1.59h1.97l1.25,0.87,1.59-1.25,1.1-1.25,2.65-0.15,0.72-0.57,3.41,0.72,1.78-1.06,0.34-1.44,2.69-0.34s1.07-0.01,2.5-1.44l0.72,1.06,2.84-0.68s1.98-0.19,2.69-0.19,3.03-0.38,3.03-0.38h2.31l2.35,1.25,1.78,0.91,1.25-0.72,0.72-0.87,4.28,1.06,1.97-1.44,3.22,0.19,4.09-0.72,1.25-1.59,1.97-2.88s-1.26-0.89-1.97-1.25-2.69-1.44-2.69-1.44l-3.22,0.57-4.43,1.59-4.32-0.91-2.5-0.15-3.18-0.72-1.63-0.91-1.59-1.78-1.44,0.72-1.97,1.06-2.5-0.15-3.22-0.91-2.5-0.72zm-35.53,14.47l-2.5,0.53-1.78,1.63-2.5-0.38s-1.44-1.06-1.44-0.34v1.78l0.72,1.59-2.12,1.25-2.88,1.1-1.06,1.25h-2.16l-0.72-1.1-1.59-0.87-2.69,2.12-0.15,3.03,1.93,2.69,1.44,2.16s1.26,2.14,0.91,3.03c-0.36,0.89-4.28,2.5-4.28,2.5l1.06,2.5,1.25,1.59v1.97l2.31,0.53,2.88,1.97,2.12,2.31,1.97,0.38s1.06-1.07,1.06-1.78c0-0.72-0.15-4.48-0.15-5.38,0-0.89,1.59-8.37,1.59-8.37l0.34-1.44,4.13-2.69s0.88-1.07,2.31-1.97c1.43-0.89,4.66-3.03,4.66-3.03l1.78-1.4s0.71-1.64,0-1.82c-0.72-0.17-1.62-0.53-2.16-1.25-0.53-0.71-3.03-2.65-3.03-2.65l-1.25-1.44zm-132.28,14.34l-0.63,0.63-2.28,0.25-0.87-0.13-1.78,0.91v1.38l-0.63,1.65-1.15,0.75-0.13,1.38,0.91,0.78,0.87,0.87-0.12,1.25-1.25,1.28-1.66,1.5-1.65,0.13-1.38-1-0.62-1.53-1.41-2-1.25-1.03-2.03,0.53h-1l-2.41-1.66-1,0.38-1.66,2.15-1.37,2-1.66,1.78-1.25,2.66,0.38,1,1,1.28,1.78,0.25,0.12,1-0.12,1-2.78,2.41-2.16,0.87-1.87,3.03-2.53,2.53-2.91,0.5-1.13,0.13-0.5,0.91-0.28,1.87-0.87,2.16-1.75,2.03-0.13,1.87,1.25,2.79,1.5,1.28,2.04,3.53,3.78,4.15,1.28,0.75,3.15,0.38,0.38,0.65,1.37,1.38,1.66,2.53,1.38,0.5,0.5,1.66,0.9,1.5,3.28,0.5,1.63,0.25,0.78,1.4,0.37,2.13,0.75,1.15,2.41,0.88,1.5,0.75,1.28-0.5,1.13-0.25,1.37,0.75,0.91,1.66-1.03,1.25-0.13,1.53,0.66,1,1.25,0.75,1,1.03,1.03,0.62,0.75-0.37,1.25-0.25,1.41,0.5,1,1.37,0.5,0.91,0.24,2,0.26,1.03h0.65l0.88-0.16,0.87-0.5,0.63-0.37h1.03l0.75,0.75,0.62,0.91,0.88,0.25,1.4,0.25,1.88-0.5,1.41-0.5,1.37-1.79v-0.87l-0.37-0.66-0.26-0.5,0.26-1,0.5-0.5,2.78-1.28,2.4-1,1.66-1.12,1.87-0.78,0.5-0.75,0.13-1.38-0.75-1.53-1.13-0.87-2.15-0.13h-1.5l-1.53,0.5-1,0.75h-1.28l-0.63-0.12-1-1.13-1.53-0.37-0.75-0.38,0.25-1.53v-1.13l1.66-0.5,0.74-0.78,0.76-0.87,0.62-1.63,0.53-0.37,1.5-0.53,1.78,0.25,1-0.5-0.12-1.38-0.5-0.87-0.5-1.66,0.25-0.88,0.87-0.62,1-0.53,1.41-0.63,1.37-0.75,0.38-0.75v-0.5l-0.88-1.9-0.75-1.41-0.9-1.62-1-0.75-0.63-1.28,0.38-1.88,0.62-0.5h1.28l0.88,0.38,1,0.87,1.41,2.16,2.65,2.37,1,0.91s1.65,0.49,2.28,0.75c0.63,0.25,1.38,1,1.38,1l0.5,0.62,0.37,1.03,0.53,1,1,0.63,1.38,0.37h1.41l1.12,0.53,0.88,0.88,2.03,0.5h1.37l0.28,0.88,1,0.53,1,0.25,0.88-0.54,0.78-0.74-0.13-1.26-1.03-1.03,0.38-0.87,0.78-1,0.37-1.53-0.25-1-1.15-0.75-0.13-1.28,0.91-0.88,3.15-3.28,1.88-1.12,1.91-1.79,0.25-1.25-0.63-0.5-1.65-0.9-1.63-1-2.16-0.25-1.25,0.62h-1.4l-1.5-1.12-1.03-1.78-0.75-1.75-1.5-3.16-1.41-2.28-0.75-1.41-0.88-2.25-0.12-1.15-2.41,0.25-0.75-0.63-1.53-1.12s0.25-0.5,0.88-0.5,1.02-0.41,1.53-0.66c0.5-0.25,0.25-0.87,0.25-0.87s-0.37-1-0.88-1.76c-0.5-0.75-0.77-0.77-1.28-1.15-0.5-0.38-0.75-1.75-0.75-1.75l-1.25-0.41-2.03-0.5-1.66,0.13-1.5,0.53-1.9,0.12-0.88-0.65-1.62-1-2.03-0.13h-2.78-2.53l-1.63,0.75-0.91,0.75-0.37,1.66-1.13,1.37-1.12,2.04-1.28,0.87h-2.41c-0.63,0-1.75-1-1.75-1l-1.03-1c-0.51-0.51,0-2.03,0-2.03s0.13-1.53,0-2.16-1.5-1-1.5-1l-2.03-0.87s1.65-0.78,2.16-1.16c0.5-0.38,0.37-1,0.37-1v-2.28c0-0.63-0.25-2-0.25-2l-0.75-1.91zm110.16,1l-0.19,1.1,0.53,1.78,1.44,0.72,0.53-0.72v-1.63l-0.38-1.25h-1.93zm-28.22,6.19l-2.35,0.78-1.4,2.07-2.88,1.43-0.25,1.07,1.78,1.43,2.13,0.97,3.22-0.44,3.5-0.9,0.25-1.6-0.78-1.96-1.1-1.88-2.12-0.97z",
  "city_population": 874891,
  "fed_okrug": "Северо-западный федеральный округ",
  "country_population": 247375,
  "area": 413103,
  "city_natural_increase": 127,
  "city_migration_increase": -2723,
  "country_natural_increase": -1718,
  "country_migration_increase": -5396,
  "average_nominal_wage": 35592,
  "average_consumer_rate": 21727,
  "average_annual_buzy": 555.9,
  "per_capita_income": 31145,
  "kladr": "2900000000000"
}, {
  "id": 330,
  "name": "Вологодская область",
  "path": "m215.36,208.76c0.12627,2.5254-1.389,5.0508-1.389,5.0508l-1.5152,1.894s-0.3788,1.0102-0.3788,1.7678c0,0.75762,0.12626,1.389,0.12626,1.389s0.63135,1.389,1.894,2.1466c1.2627,0.75761,2.0203,2.7779,2.0203,2.7779l1.0102,1.894,1.5152,1.2627,1.2627,1.0102,1.1364,1.894,1.2627,0.37881,3.1567,0.50508,1.5152,2.2728,1.0102,1.894,1.7678,0.63135,0.25254,0.63135,1.0102,2.2728,1.2627,0.75761,2.6516,0.25254,1.5152,0.12627,0.50507,2.7779,1.2627,2.0203,2.7779,1.389,1.389,0.12627,1.0102-0.63134,1.389,0.12627,1.0102,0.50507,0.75761,1.0102-0.63134,1.5152-0.75762,1.389,0.25254,0.75762,1.2627,1.1364,0.75761,0.50508,1.0102,0.50507,0.3788,0.63135v1.0102l-1.5152,1.5152-2.0203,0.63135-2.0203,0.75761-4.2931-0.25254-1.2627,0.88389,0.25253,1.1364,0.88389,1.2627v2.6516,1.1364l-1.0102,1.1364-0.75761-0.63134-1.1364-1.0102-0.37881-1.5152-1.0102-0.12626-1.6415,1.0102-1.0102,1.0102h-1.7678l-3.0305-1.5152-2.1466-2.1466-2.0203-1.1364-1.894-1.6415-2.0203-2.7779v-1.894l-1.894-2.7779-2.5254-2.2728-1.5152-2.0203-1.2627-1.7678-0.63135,0.75761-1.6415,0.12627-1.6415-0.25254-2.2728-1.894-0.88388-0.50508-1.2627,0.63135-2.7779,1.7678-0.63135,0.37881-1.2627,0.12627-0.88388-0.50508-0.50508-1.2627-0.63134-1.894,0.25254-4.0406-0.50508-2.5254-0.50508-1.2627-1.2627,0.12627-1.2627,0.37881-0.88388-0.25254-1.389-1.2627-1.6415-1.7678-4.0406-1.0102-1.2627-1.1364-0.50508-1.0102,0.63135-2.0203-0.50508-0.88388-1.0102-0.75761-1.1364-0.63135-1.894-0.37881-0.25254-0.12627,0.50508-2.7779-0.50508-1.6415-0.63134-1.2627-0.88388-0.88389-0.37881-0.50507-0.12627-1.0102-0.25254-1.5152,0.63135-0.88388,0.75761-0.88388,1.389-0.25254h1.6415l0.88388,1.2627,1.0102,0.88388,1.1364-0.50507,0.25253-1.1364,1.2627-0.25254,1.1364-0.63135,0.75761-1.1364,0.12627-1.5152,3.283-3.6618,1.2627-0.88388h1.7678l2.0203-0.37881,1.389-0.75762,0.88388-0.63134h1.1364l1.5152,0.88388h1.2627l0.88389,0.75762,0.50507,0.88388,1.389,0.63134h1.1364l1.389-0.3788,1.5152-0.50508,1.1364-0.37881,0.63135-0.25253,0.88388,0.12627,1.0102,0.88388,1.2627,1.6415,0.50507,1.2627z",
  "city_population": 854700,
  "fed_okrug": "Северо-западный федеральный округ",
  "country_population": 329377,
  "area": 144527,
  "city_natural_increase": 1454,
  "city_migration_increase": -708,
  "country_natural_increase": -2716,
  "country_migration_increase": -1355,
  "average_nominal_wage": 27445,
  "average_consumer_rate": 15418,
  "average_annual_buzy": 571.9,
  "per_capita_income": 25602,
  "kladr": "3500000000000"
}, {
  "id": 331,
  "name": "Калининградская область",
  "path": "m74.107,152.55,0,2.2322,0.53571,2.5,2.0536,5.1786,1.4286,3.4821,1.9643,3.6607,2.5,1.0714,3.75-0.44642,1.9643-1.3393,0.625-1.7857-0.44643-4.2857-0.89286-2.8571-1.5179-1.6071-2.4107-0.53572-0.98214-0.71428,0-3.0357-0.80357-1.4286-1.6964-1.6071-1.6071-0.26786-0.35714,1.25-0.625,1.3393-0.625,0.89285-1.4286-0.35714z",
  "city_population": 767640,
  "fed_okrug": "Северо-западный федеральный округ",
  "country_population": 219695,
  "area": 15125,
  "city_natural_increase": -752,
  "city_migration_increase": 7004,
  "country_natural_increase": 309,
  "country_migration_increase": 934,
  "average_nominal_wage": 28262,
  "average_consumer_rate": 17877,
  "average_annual_buzy": 473.9,
  "per_capita_income": 25897,
  "kladr": "3900000000000"
}, {
  "id": 332,
  "name": "Ленинградская область",
  "path": "m153.49,177.57,1.7678-1.6415,1.5152,0,2.2728-1.894,2.5254-0.50507,2.2728,0.63134,2.9042,2.1466,2.7779,1.5152,0.75761,2.5254,0.12627,1.389,1.0102,1.1364,1.1364-0.37881,0.75761-2.0203-0.12627-2.3991-0.88388-1.6415-0.88388-1.894,0.12626-2.0203,1.1364-1.2627-0.25254-1.894-0.75762-1.0102,0-0.37881,1.2627-0.25254,3.283,0.25254,3.5355,1.2627,2.2728,0.12627,1.894,0.12627,1.2627,1.1364,0.63135,1.2627,0,1.7678-0.37881,1.6415-0.25254,2.1466-0.63134,1.7678-2.1466,1.2627-0.75761,1.0102-1.0102,1.894-1.0102,1.1364-1.7678,1.1364-0.63135,1.2627,0.25254,1.1364,1.389,0.75762,2.1466,0.25253,1.0102,0.88389,0.25254,1.6415,1.0102,0.75762,2.1466,0.12627,1.1364-0.50508,3.4093-0.25254,1.7678-0.63134,2.0203-0.25254,1.5152,0.75761,1.0102,1.6415,1.1364-1.2627,1.389-1.7678,0.75762,0.88388,0.50507,2.0203,0.63135,2.2728,2.1466,0.50507,1.2627,0.75762,1.1364,1.0102,0.12626,1.2627,0.12627,1.6415-0.12627,1.7678-1.2627,0.75761-2.2728-0.25254-1.389-0.88388-1.389-0.25254-0.75761,0.88388-1.5152,1.0102-3.0305,0-1.5152,0.3788-2.7779,3.0305-1.0102,1.389-0.37881,2.1466-1.6415,1.0102-1.1364,0.12627-0.3788,1.2627-1.2627,0.63134-0.63135-1.0102-1.1364-1.1364-2.2728-0.12627-0.75761,0-1.1364-3.0305,0-2.9042-1.0102-1.5152-0.88389-1.894-0.12627-1.6415-2.2728-0.88388-0.88388-0.63135s-0.37881-1.0102-0.37881-1.5152c0-0.50507-0.25254-3.4093-0.25254-3.4093l-0.75761-1.1364-2.3991-0.25254-1.389,0.75761-0.75762-0.50507-0.12627-1.2627-0.63134-0.88389-1.0102,0.63135-2.1466,0.3788-2.7779-0.88388-1.5152-0.88388-3.283-0.37881-1.2627-0.88388-1.0102-0.75762,0.63135-1.2627,0.88388-2.1466,0.88388-1.389,0.12627-1.2627z m16,4 a3,3 0 1,0 6,0a3,3 0 1,0 -6,0z",
  "city_population": 1148207,
  "fed_okrug": "Северо-западный федеральный округ",
  "country_population": 644422,
  "area": 83908,
  "city_natural_increase": -5803,
  "city_migration_increase": 1682,
  "country_natural_increase": -3025,
  "country_migration_increase": 10463,
  "average_nominal_wage": 33996,
  "average_consumer_rate": 18476,
  "average_annual_buzy": 743.2,
  "per_capita_income": 24719,
  "kladr": "4700000000000"
}, {
  "id": 333,
  "name": "Мурманская область",
  "path": "m247.31,136.92,1.1364-1.5152,1.5152-0.75761,2.9042,0,4.2932,0.12626,2.1466-0.50507,2.5254-1.6415,0.88388-2.0203,0.12627-3.5355,1.5152-3.4093,1.0102-1.0102,4.7982,0,2.3991-0.63134,1.0102-1.2627,1.7678-0.12627,2.3991,1.0102,3.0305,1.894,2.2728,1.894,2.6516,0,2.2728-0.25253,0.25254,2.3991,1.894,0.3788,1.7678,1.0102,0,2.2728,0,1.7678-1.0102,0.63134-1.5152-0.3788-0.75761-1.1364-0.25254-0.63134-0.88388,1.0102-0.25254,0.63135,0.50508,1.1364,1.1364,0.88388,0.50507,0.75762-0.3788,1.0102-1.0102,0.63134,0,0.75762,1.1364,1.2627,0.88388,1.5152,0.88388,1.7678,2.0203,2.1466,0.75761,1.7678,0,1.7678,0,1.1364-0.50507,1.1364-0.25254,2.0203-0.12627,5.5558,0,5.5558-0.75762,1.389-0.25253,1.894,0.63134,0.88389,0.63135,1.0102-0.12627,4.0406,0,3.5355-0.63135,1.389-1.7678,1.1364-0.88389,0.88388,0,1.0102-0.25254,0.88389-1.1364,0.88388-2.7779,0.75761-3.6618,0.12627-3.1567,0.50508-1.6415,0.37881-2.5254-0.50508-2.0203-0.75761-1.894-1.389-1.894-2.2728-1.7678-2.2728-1.1364-1.894-0.63135-2.2728-0.3788-2.3991-1.2627-2.6516-1.1364-2.0203-0.3788-1.6415-0.37881-3.9143,0-1.7678,0-1.389-0.88388-0.88389-0.12627-2.9042,0-2.1466,0.75761-1.5152,0.12627-1.1364,0-1.5152-0.88388,0-0.63135,0.88388-0.88388,1.389-0.75762,1.894-0.25253,0.63135-3.5355,0-2.6516-0.25254-0.75761-1.5152,1.389-2.0203,1.1364-0.75761,0.25254-1.0102-1.7678-2.2728-1.5152-1.7678-1.2627-2.7779-1.2627-1.2627z",
  "city_population": 700877,
  "fed_okrug": "Северо-западный федеральный округ",
  "country_population": 57110,
  "area": 144902,
  "city_natural_increase": 164,
  "city_migration_increase": -4758,
  "country_natural_increase": 112,
  "country_migration_increase": 374,
  "average_nominal_wage": 45989,
  "average_consumer_rate": 24903,
  "average_annual_buzy": 397.8,
  "per_capita_income": 36875,
  "kladr": "5100000000000"
}, {
  "id": 334,
  "name": "Новгородская область",
  "path": "m153.12,188.27,1.5179,1.25,2.1428,0.35714,2.1429,0.17857,1.25,1.1607,2.5,0.53571,2.3214-0.0893,1.0714-0.89286,0.44643,0.625,0.0893,1.7857,2.1429-0.53571,2.3214,0.0893,0.80357,0.80358,0.17857,2.5,0.17857,2.5,0.53572,1.0714,1.3393,0.17858,1.3393,0.44642,0.26785,2.1429,0.71429,1.6964,0.98214,0.80357,0.44643,2.9464,0.0893,2.2321,0.89285,1.4286-0.53571,0.98215-0.71429,0.53571,0,1.6071,0.17858,1.5179,1.4286,1.3393,0.625,0.53571,0.0893,1.9643,0,1.9643-0.17857,1.3393-1.25,0.53571-0.71428-0.26785-0.625-0.80358-0.71429-0.80357-0.17857-1.1607-0.98214-0.80357-0.80358-0.625-2.0536,0-1.5178-0.53572-0.53572-0.35714-1.5178-0.53571-0.71429-0.26786,0-0.44643s-0.26786-1.25-0.26786-1.6964c0-0.44643-0.0893-2.0536-0.0893-2.0536l-0.625-0.98214h-1.7857l-0.89285-0.44643-0.44643-0.98214-0.98215-0.625-0.53571,0.625-0.89286,1.0714-1.6964,1.4286h-2.1428c-0.35715,0-1.5179,0.0893-1.5179,0.0893l-0.71429-1.0714-1.0714-0.71428-2.3214-0.17857-2.6786-0.0893-1.5179-0.44643-1.3393-0.98214-2.3214-0.44643h-2.1428l-0.89286-1.1607-1.25-1.0714-0.53571-0.71429-1.1607-0.71428,0.98214-2.7679,0.71429-0.44643,1.1607-1.5179,1.0714-1.0714,2.0536-0.625,2.5-1.9643,0.625-1.9643,0.0893-3.5714,0.98214-2.5893,1.0714-1.25,1.1607,0.26786z",
  "city_population": 433882,
  "fed_okrug": "Северо-западный федеральный округ",
  "country_population": 178941,
  "area": 54501,
  "city_natural_increase": -1566,
  "city_migration_increase": -805,
  "country_natural_increase": -1884,
  "country_migration_increase": 1244,
  "average_nominal_wage": 26346,
  "average_consumer_rate": 19756,
  "average_annual_buzy": 303.4,
  "per_capita_income": 25780,
  "kladr": "5300000000000"
}, {
  "id": 335,
  "name": "Псковская область",
  "path": "m125.268,213.98,0.35714-2.1428-0.26786-2.1429-1.4286-1.875-1.3393-1.4286-0.08929-1.6964,0.98214-0.71429,0.17857-1.6964-0.89286-0.98215-1.25-1.875,0-4.1964,1.5179-0.89285,3.75-2.2322,0.80357-2.4107,0.53572-1.7857,1.875-1.25,2.4107-0.0893,1.3393-1.6071,0.98214-1.6964s1.25-0.625,1.6072-0.80357c0.35714-0.17857,2.8571-0.71429,2.8571-0.71429l1.5179-0.0893,1.0714,0.53571-0.625,1.5179-0.71428,0.89285-0.17857,0.98215,1.6071,0.26785,1.25-1.7857,0.98214-2.0536,1.1607-1.5179,1.6071-0.71428h1.6071l1.5179-1.5179,1.1607-0.625h1.4286l0.98214,0.98214,0.625,1.5179,0.98214,1.6071-0.26786,1.6964-0.89285,0.98214-0.35715,1.3393-0.80357,1.6071-0.17857,1.1607h-1.4286-0.80357l-0.71429-0.53572-0.80357,0.53572-0.625,0.80357-0.53571,1.5178-0.53572,2.1429-0.0893,2.5-0.35715,1.875-1.1607,1.25-1.3393,0.98214h-1.7857l-1.5179,1.3393-0.53571,1.7857-1.3393,0.53572-0.44643,1.0714-0.17857,1.4286-1.7857,0.89286-1.7857,0.80357-0.625,1.6964,0.625,1.5178,0.625,0.625-0.26785,1.4286s-0.0893,0.44643-0.44643,0.80358c-0.35714,0.35714-1.1607,1.3393-1.1607,1.3393l-1.4286,0.80357-2.3214,0.89286-1.0714,0.0893-1.1607-0.89286-0.89286-0.89286z",
  "city_population": 454402,
  "fed_okrug": "Северо-западный федеральный округ",
  "country_population": 188092,
  "area": 55399,
  "city_natural_increase": -2144,
  "city_migration_increase": -435,
  "country_natural_increase": -2514,
  "country_migration_increase": 359,
  "average_nominal_wage": 21553,
  "average_consumer_rate": 16837,
  "average_annual_buzy": 318.3,
  "per_capita_income": 21726,
  "kladr": "6000000000000"
}, {
  "id": 338,
  "name": "Республика Адыгея",
  "path": "m51.786,356.21,2.4107-1.4286,2.5-2.6786,0.35714-2.1428-0.26786-3.9286-1.0714-2.7679-2.9464-0.98214l-2.412-1.78-2.232-3.75-1.5179-1.1607-1.3393,0.71428-0.17857,2.1429,1.6071,1.875,0.80357,2.5893,1.1607,1.6964,1.6071-0.35714,1.5179,0.44643-0.44643,2.9464-2.9464,2.3214-3.394,0.71-2.8571,0.35715-0.17857,3.8393,1.0714,1.7857h1.7857l5.3571-2.9464,0.35714,1.7857z",
  "city_population": 214643,
  "fed_okrug": "Южный федеральный округ",
  "country_population": 238968,
  "area": 7792,
  "city_natural_increase": 90,
  "city_migration_increase": 1727,
  "country_natural_increase": -308,
  "country_migration_increase": 800,
  "average_nominal_wage": 22087,
  "average_consumer_rate": 16340,
  "average_annual_buzy": 149.2,
  "per_capita_income": 22639,
  "kladr": "0100000000000"
}, {
  "id": 339,
  "name": "Республика Калмыкия",
  "path": "m74.554,348.71,0.98214,1.6071,1.1607,1.0714,1.1607,1.6964,0.80357,1.1607,1.1607,0.71429,2.5893,0.44643,1.3393,0.625,0.98214,1.6071s0.98214,1.7857,1.25,2.2321c0.26786,0.44643,0.98214,2.4107,0.98214,2.4107l0.17857,4.9107v3.2143l0.89286,2.2321,3.3036,4.1964,1.25,2.0536-0.17857,2.5893-1.4286,1.875,0.89286,1.3393,4.375,4.7321,0.53571,1.25,0.35714,0.98215,0.89286,0.53571,1.4286,0.0893,1.6071-0.26786,1.7857-0.53572,2.2321-0.89285,2.3214-0.26786,0.713-0.71,0.625-2.15-0.268-1.16-2.232-1.34-0.982-0.71,0.08928-1.3393,1.0714-0.625,1.7857,0.0893,1.4286-1.25-0.53572-0.71428-0.71428-2.0536-0.268-1.7-0.179-1.16h1.0714l1.6964,1.25,1.7857,0.80357,2.6786-0.17857h0.89286l0.53571-1.1607-0.17857-2.4107-0.08929-3.8393v-6.3393-0.98214l-0.08929-2.2321,2.9464-2.8572,0.17857-1.3393-1.4286-0.625v-3.2143l-1.0714-1.1607-1.1607-0.35715-2.5-0.17857-0.625-1.4286-0.17857-0.80357-1.25,0.26786-0.625,1.0714h-1.3393l-1.25-0.0893-1.071-0.98-0.804-0.71-2.321-0.27-0.98214,0.35715-0.71429,0.80357-0.71429,0.35714-0.26786,1.1607-0.35714,0.80357,0.35714,0.625,1.0714,0.35714,1.0714-0.44643,0.89286,0.35714,0.08929,0.98215-0.44643,1.5178-5,3.125-3.3929,0.26786-2.3214,1.3393-1.5179,0.53571-3.8393-1.7857-0.53571-0.35715-0.08929-3.3928-0.71429-1.4286-2.3214-2.2322-0.625-1.25-1.9643-0.80357h-3.5714z",
  "city_population": 125783,
  "fed_okrug": "Южный федеральный округ",
  "country_population": 151992,
  "area": 74731,
  "city_natural_increase": 688,
  "city_migration_increase": -1258,
  "country_natural_increase": 360,
  "country_migration_increase": -1621,
  "average_nominal_wage": 20109,
  "average_consumer_rate": 7050,
  "average_annual_buzy": 111.3,
  "per_capita_income": 14216,
  "kladr": "0800000000000"
}, {
  "id": 340,
  "name": "Краснодарский край",
  "path": "m51.607,356.48-0.08929,2.0536,0.98214,3.8393,0.35714,0.80357,2.2321,0.0893,3.75-4.5536,1.4286-1.9643,1.9643-1.0714,2.6786-4.0178-0.26786-3.3929,0.17857-1.6964,0.89286-1.5179,1.3393,0,1.7857,1.5179,1.3393,0,2.5893-3.0357,0.08929-1.9643-0.89286-0.98214-2.2321-1.3393,0.17857-2.9464,2.8571-3.125,0.08929-1.4286-2.7679-2.9464-3.75-0.71428-0.80357-0.89286,1.6071-1.25,0.17857-2.4107-2.1429-1.6072-2.5893-0.80357-1.6071-1.6964-1.25-0.98214-0.89286-0.0893-1.3393,2.2322-0.625,0.98214,1.0714,1.4286-0.35714,1.5179-0.80357,0.625-2.7679-0.26786-0.89286-0.89286-1.9643,0.0893-1.875,0.71429-3.0357,1.7857-1.6964,0-1.3393-1.4286-1.6071-0.625-1.1607-1.4286,0-2.6786-2.2321-0.26786-1.25,0.625-0.35714,2.9464-0.089286,13.214,0.71429,5.8929,0.98214,3.6607-0.089286,2.3214-0.625,2.7679-0.089286,2.4107,0.17857,2.0536,1.5179,0.89285,0.71429,0.625,1.6071,1.5179,0.89286,1.0714,0.89286,0.89286l7.947-4.27-0.804-1.25-0.357-1.43-5.089,2.68h-1.875l-1.25-1.875,0.35714-3.5714,6.25-1.4286,2.7679-2.3214,0.71429-2.5893-1.3393-0.80357-1.9643,0.44642-1.1607-1.5178-0.71429-2.6786-1.3393-1.7857-0.17857-1.25,0.08929-1.1607,1.3393-0.80357,1.3393,0.625,1.0714,1.3393,1.0714,1.9643,1.3393,1.7857,2.3214,1.3393,1.6964,0.89285s0.625,0.26786,0.71429,0.625c0.08929,0.35715,0.89286,2.6786,0.89286,2.6786v4.0178l-0.08929,1.3393-1.0714,1.0714-1.875,1.5178-1.6071,1.4286z",
  "city_population": 3043750,
  "fed_okrug": "Южный федеральный округ",
  "country_population": 2531095,
  "area": 75485,
  "city_natural_increase": 6435,
  "city_migration_increase": 40439,
  "country_natural_increase": -3696,
  "country_migration_increase": 17297,
  "average_nominal_wage": 26767,
  "average_consumer_rate": 25238,
  "average_annual_buzy": 2322.6,
  "per_capita_income": 31373,
  "kladr": "2300000000000"
}, {
  "id": 341,
  "name": "Астраханская область",
  "path": "m116.873,350.94,1.6415-1.389,1.1364-0.63135,1.7678,1.2627,2.0203,0.63135,2.2728,0.50508,0.88388,1.0102,2.1466,0.88388,0.75761,1.1364,0.63134,1.1364,0,1.389,0,0.88389-1.5152,0.3788-1.1364,1.389-0.12627,1.0102,0.63134,1.389,1.0102,1.1364-0.37881,2.1466-0.75762,1.0102-1.7678,0.88389-0.25254,1.1364,0.50508,0.88388,1.7678,1.1364,2.2728,1.5152,1.389,1.6415,0.63134,1.0102,0,1.5152-1.0102,1.1364-0.25254,2.0203-1.0102,1.0102,0,2.2728,0,2.7779-0.75761,0.3788-1.7678-0.3788-1.894-0.75762-0.63134,0.37881-0.37881,2.1466,1.6415,2.1466,1.1364,1.2627,0.88388,1.0102,0.50508,0.63134,0.12627,1.2627-3.9143,0.25253-3.0305,0.63135-2.1466,0-1.894-1.2627-2.0203-1.5152-5.4296,0-1.0102-0.37881-1.1364-1.1364,0.37881-2.9042-0.88388-1.0102-2.2728-1.6415,0-1.6415,1.0102-0.3788,1.5152,0,1.389-1.0102-0.63134-1.389-0.75761-4.0406,0.63134-0.3788,1.2627,0.75761,2.9042,1.389,2.0203-0.25254,1.2627-0.12627,0.50508-1.6415-0.25254-5.4296,0.12627-5.0508-0.25254-4.2931,2.1466-2.2728,1.0102-1.1364,0.12627-1.389-1.2627-0.50508-0.25254-2.1466z",
  "city_population": 677736,
  "fed_okrug": "Южный федеральный округ",
  "country_population": 341721,
  "area": 49024,
  "city_natural_increase": 1624,
  "city_migration_increase": -3467,
  "country_natural_increase": 673,
  "country_migration_increase": -1491,
  "average_nominal_wage": 25499,
  "average_consumer_rate": 18084,
  "average_annual_buzy": 434.7,
  "per_capita_income": 24065,
  "kladr": "3000000000000"
}, {
  "id": 342,
  "name": "Волгоградская область",
  "path": "m115.893,313.18,1.5179-0.98214,1.875-0.0893,1.1607-1.0714,1.1607-1.6072,0-1.25,1.1607-0.98214,1.9643,1.25,2.5,1.9643,3.3036,2.1428,3.9286,1.5179,1.4286,1.5179,0.625,2.1428,0.44643,1.4286,2.8571,0.35714,0.44643,1.4286,2.5893,0.80357,1.7857,1.7857,1.6964,1.6964,0.17857,2.2322-1.5179,1.25-1.6071,2.2321-1.4286,1.3393-0.26786,1.25,0.89286,2.2321,2.9464,1.875,1.6964,1.875,1.7857,1.1607,1.25,3.3036,1.0714,1.875,0.0893,1.25-0.71428,0.53572-1.3393,0.44643-0.71429,0.53571-2.8571,0.26786-4.6429-0.0893-1.6964,0.26786-0.71429,1.6071,0,2.8572-0.17857,1.1607-1.6964,1.25-1.3393,0.98214-4.0178-0.0893-1.0714-0.0893-1.3393-3.0357-1.4286-1.0714-1.875-1.0714-1.0714-0.625l-2.256-0.46-2.054-1.25-1.071-0.18-1.1607,0.625-0.98214,0.71429-1.25,0.26785-2.1429-0.0893-0.89286-1.1607-0.35714-1.25-1.4286,0.26786-0.89286,1.1607h-1.25l-1.875-0.71428-1.25-0.80357-1.3393-0.35715-1.4286,0.17858-1.4286,1.25h-0.89286l-1.4286-2.5-1.25-1.4286-1.0714-0.71428,0.448-1.44,0.893-1.52,1.607-1.43,0.179-0.89-1.6964-2.1429-0.44643-1.0714,1.4286-0.80358,0.625-1.875,0.625-0.53571,1.25-0.35714,1.6071,0.0893h3.0357l1.7857-0.625,1.9643-2.5893,0.89286-4.0179,0.625-1.4286,2.8571-2.0536,1.1607-1.6964,0.35714-3.3036v-2.2322z",
  "city_population": 1948037,
  "fed_okrug": "Южный федеральный округ",
  "country_population": 587808,
  "area": 112877,
  "city_natural_increase": -3633,
  "city_migration_increase": -1712,
  "country_natural_increase": -2160,
  "country_migration_increase": -3955,
  "average_nominal_wage": 24361,
  "average_consumer_rate": 16178,
  "average_annual_buzy": 1221.2,
  "per_capita_income": 21724,
  "kladr": "3400000000000"
}, {
  "id": 343,
  "name": "Ростовская область",
  "path": "m67.5,323.45,2.0536,0.98214,1.4286-0.17857,0.625-0.89286-0.44643-1.1607-1.25-0.89286-1.9643-1.3393-0.89286-1.1607-0.35714-0.71428,1.0714-1.4286l2.231-1.08,1.6071-0.26786,1.0714,0.35714,1.4286,1.3393,1.5179,0.35714,1.6964-0.89286,0.89286,0.44643,1.072,1.06,1.339,1.79,0.268,1.33,1.607-0.08,1.3393-0.80358,1.6964-0.0893,1.3393-0.0893,0.35714-1.5178,0.53571-1.4286,1.25-1.6071,1.3393-1.0714,1.6964,1.0714,0.71429,0.35714,0.89286-1.875,0.44643-0.71428,2.6786-0.26786,1.875-1.6964,2.3214-0.17857,2.0536,1.1607,2.1429,1.25,0.98214,0.53571,3.9286,0.0893h2.2321l1.5179-0.98215h1.3393l0.71429,0.625,0.26786,1.6964-0.08929,1.9643v1.875l-0.08929,1.0714-0.981,1.34-1.25,0.98214-1.25,0.71429-0.80357,0.35714-0.35714,1.25-0.44643,1.6072-0.08929,1.4286-0.44643,1.1607-0.625,1.4286-1.4286,1.5179-1.6964,0.53571h-3.125l-1.608-0.36-1.518,0.53-0.625,1.97-0.982,0.62-0.80357,0.53572,0.17857,0.89285,1.3393,1.4286,0.71429,1.4286-1.1607,1.4286-1.3393,0.89285-0.80357,1.7857-0.08929,0.80357,0.98214,0.53571,1.1607,1.1607,0.625,1.0714,0.80357,0.80357,0.71429,1.3393v1.0714l-0.71429,0.80357,0.53572,0.625,1.4286,0.35715,0.625-0.53572,0.71429-0.0893,0.35714,0.98214v1.4286l-1.3393,1.3393-2.1429,1.0714-2.0536,1.1607-3.3929,0.0893-0.80357,0.80357-1.3393,0.80357-1.696,0.46-1.429-0.71-1.696-0.71-0.893-0.9-0.178-2.23-0.179-1.52-1.696-2.14-1.1607-0.80357-0.17857-1.25-0.80357-0.89286-1.7857-0.0893h-2.7679l-2.8571-0.0893-1.3393-0.17857-1.6071-1.7857-0.98214-0.71429v-0.89286l1.3393-1.5178v-1.5179l-0.625-1.25-1.875-1.4286-0.71429-0.625,0.26786-2.2322,2.7679-3.2143,0.08928-1.6071-1.9643-2.2322-1.3393-0.89285-2.411-0.55-1.0714-0.35714-0.08929-0.71429,1.0714-1.0714,0.26786-1.1607z",
  "city_population": 2874842,
  "fed_okrug": "Южный федеральный округ",
  "country_population": 1357662,
  "area": 100967,
  "city_natural_increase": -3458,
  "city_migration_increase": 2074,
  "country_natural_increase": -4224,
  "country_migration_increase": -472,
  "average_nominal_wage": 25008,
  "average_consumer_rate": 20913,
  "average_annual_buzy": 1901.8,
  "per_capita_income": 26546,
  "kladr": "6100000000000"
}, {
  "id": 345,
  "name": "Республика Дагестан",
  "path": "m64.939,403.74,2.6516,1.2627,3.6618,0.50507,1.7678-2.0203,2.1466,2.0203,2.3991-1.6415,0.25254-1.7678,1.6415-2.1466,3.0305,0.50508,3.7881-2.9042-0.50508-1.894-4.7982-0.50508,0.75762-3.1567-1.0102-0.63134,0.63135-2.2728-3.1567-2.7779,1.5152-0.50508,3.9143,0.88388,0-1.389-1.0102-1.2627,8.3338-0.25254,4.9245,5.4296,1.2627,1.894-0.37881,2.2728-5.3033-0.3788,0.50508,2.5254,1.5152,3.0304-1.0102,3.5355-2.3991,2.7779-1.2627,0.25254,4.5457,0.75761-5.5558,2.1466-0.50508,2.0203-0.75762,0.50508-3.0305,0.50507-0.25254,4.7982-1.2627,0.88388-1.1364,13.132-9.0914-0.12627-3.6618-2.2728-1.389-0.88388,0-11.617-3.283-5.9346,0.37881-2.9042,1.2627-0.37881z",
  "city_population": 1372739,
  "fed_okrug": "Северо-Кавказкий федеральный округ",
  "country_population": 1668969,
  "area": 50270,
  "city_natural_increase": 14580,
  "city_migration_increase": -1481,
  "country_natural_increase": 24099,
  "country_migration_increase": -11909,
  "average_nominal_wage": 19239,
  "average_consumer_rate": 22311,
  "average_annual_buzy": 999.6,
  "per_capita_income": 26739,
  "kladr": "0500000000000"
}, {
  "id": 346,
  "name": "Республика Ингушетия",
  "path": "m63.393,395.68,0.08929,5.2679,17.946-8.5714-1.3393-1.25-2.9464-1.25-1.5179-1.9643-2.4107,2.4107-4.1071-2.6786-1.875,1.0714,0.08929,5.8929-1.5179,1.0714z",
  "city_population": 200144,
  "fed_okrug": "Северо-Кавказкий федеральный округ",
  "country_population": 280555,
  "area": 3628,
  "city_natural_increase": 2664,
  "city_migration_increase": 3582,
  "country_natural_increase": 4426,
  "country_migration_increase": -1789,
  "average_nominal_wage": 21481,
  "average_consumer_rate": 5761,
  "average_annual_buzy": 79,
  "per_capita_income": 14683,
  "kladr": "0600000000000"
}, {
  "id": 347,
  "name": "Республика Кабардино-Балкария",
  "path": "m50.982,375.86c0.26786,0.35715,2.5893,4.7322,2.5893,4.7322l0.98214,3.9286,4.6429,1.1607,2.8571-1.0714,3.2143,1.5179,4.375-1.875,0.26786-3.125-5.9821-2.3214-1.875-5.0893-2.2321-1.1607-4.375,0.71429z",
  "city_population": 450167,
  "fed_okrug": "Северо-Кавказкий федеральный округ",
  "country_population": 412087,
  "area": 12470,
  "city_natural_increase": 2483,
  "city_migration_increase": -2032,
  "country_natural_increase": 2558,
  "country_migration_increase": -1464,
  "average_nominal_wage": 20866,
  "average_consumer_rate": 13976,
  "average_annual_buzy": 304.5,
  "per_capita_income": 19108,
  "kladr": "0700000000000"
}, {
  "id": 348,
  "name": "Республика Карачаево-Черкесия",
  "path": "m43.482,361.39,2.2321,8.4821,5.0893,6.25,4.375-2.6786,5.3571-0.89286,0.08929-3.3928,3.75-1.0714-6.6964-7.2321-2.2321,2.4107-2.8571,0.26786-1.6071-4.5536,0.44643-2.1429z",
  "city_population": 199840,
  "fed_okrug": "Северо-Кавказкий федеральный округ",
  "country_population": 267957,
  "area": 14277,
  "city_natural_increase": 543,
  "city_migration_increase": -904,
  "country_natural_increase": 721,
  "country_migration_increase": -1623,
  "average_nominal_wage": 20511,
  "average_consumer_rate": 8680,
  "average_annual_buzy": 166.3,
  "per_capita_income": 17255,
  "kladr": "0900000000000"
}, {
  "id": 349,
  "name": "Республика Северная Осетия-Алания",
  "path": "m75.583,387.43-2.2728,2.6516-4.1669-2.6516-2.0203,1.1364-0.37881,5.8084-1.1364,1.389-2.2728-0.12627-5.9346-2.6516-3.0305-3.283,0.12627-4.9245,4.672,0.75761,0.37881-0.88388,2.5254-0.12627,3.283,1.5152,4.0406-1.894s-0.12627-3.5355,0.75761-2.7779c0.88388,0.75762,1.389,1.2627,1.389,1.2627l0.25254,3.5355z",
  "city_population": 451519,
  "fed_okrug": "Северо-Кавказкий федеральный округ",
  "country_population": 251778,
  "area": 7987,
  "city_natural_increase": 1893,
  "city_migration_increase": -2373,
  "country_natural_increase": 857,
  "country_migration_increase": -1902,
  "average_nominal_wage": 21267,
  "average_consumer_rate": 15548,
  "average_annual_buzy": 293.7,
  "per_capita_income": 22007,
  "kladr": "1500000000000"
}, {
  "id": 350,
  "name": "Чеченская Республика",
  "path": "m63.482,401.04,1.0714,2.5,3.125,1.6964,3.4821,0.44642,2.1429-1.9643,2.1429,1.7857,2.5-1.5178-0.08929-1.6072,1.875-2.1428,2.8571,0.44642,3.8393-2.8571-0.625-1.9643-4.4643-0.53572,0.44643-2.7679z",
  "city_population": 490338,
  "fed_okrug": "Северо-Кавказкий федеральный округ",
  "country_population": 923108,
  "area": 15647,
  "city_natural_increase": 9673,
  "city_migration_increase": -529,
  "country_natural_increase": 15389,
  "country_migration_increase": -629,
  "average_nominal_wage": 22304,
  "average_consumer_rate": 12261,
  "average_annual_buzy": 388.5,
  "per_capita_income": 22914,
  "kladr": "2000000000000"
}, {
  "id": 351,
  "name": "Ставропольский край",
  "path": "m63.929,367.73-3.4821,0.98215,0.17857,3.75,1.5179,1.25,1.7857,4.6428,6.5179,3.0357,1.3393,1.3393,0.08929,3.0357,3.8393,1.7857,1.6071,2.5893,3.2143,0.625,0.71429-1.4286-2.8571-3.125,1.5179-0.53572,3.5714,0.80357,0.17857-1.1607-0.98214-1.3393,7.7679-0.0893,1.6964-1.5179,0.26786-3.5714-5.2679-7.5-0.17857-9.4643-3.4821-6.0714-4.9107-0.98214-1.5179-2.7679-5.0893-5.7143-0.98214-0.625-1.5179,1.3393-2.7679-2.0536-1.4286,0.80357-0.80357,1.0714-0.08929,1.6071,0.35714,1.3393,0.35714,1.1607-0.71429,1.6071-0.98214,1.4286-1.9643,2.2322-1.875,1.0714-0.71428,0.98214-0.98214,2.3214z",
  "city_population": 1637492,
  "fed_okrug": "Северо-Кавказкий федеральный округ",
  "country_population": 1168324,
  "area": 66160,
  "city_natural_increase": 3887,
  "city_migration_increase": 738,
  "country_natural_increase": -5,
  "country_migration_increase": -2496,
  "average_nominal_wage": 23245,
  "average_consumer_rate": 19265,
  "average_annual_buzy": 1235.3,
  "per_capita_income": 22971,
  "kladr": "2600000000000"
}, {
  "id": 353,
  "name": "Республика Башкортостан",
  "path": "m241.5,329.86,2.3991-1.6415,2.5254-1.6415,1.5152-0.25254,1.894,2.6516,2.2728,2.2728,2.9042,0,2.6516,2.5254,1.7678,2.5254,1.1364,1.7678,1.7678,0,1.2627,2.1466,2.6517,2.3991,2.2728,1.6415,2.0203,1.7678,1.2627,1.1364,0.88389,1.389-0.37881,1.1364-1.6415,0.63134-0.88388,1.2627,0.25254,1.389,1.389,0.63135-0.63135,1.2627-1.5152,0.50508-1.2627-0.75762-2.3991,0.37881,0,1.0102-1.5152-0.25254-0.50508-0.88388-1.5152-1.0102-4.5457,0-1.1364-0.37881,0-1.2627,1.7678-1.2627,0.12627-1.389-1.0102-0.88389-1.6415-1.1364-2.5254,0.25254-1.0102,2.1466-1.7678,2.6516-0.88388,2.0203,0.50508,3.0305,1.894,1.0102,2.0203-0.75761,1.6415,0.75761,1.0102,2.0203,2.5254,0.12627,2.0203,0.75761,2.7779,0,1.7678-0.50508,1.5152,1.1364-0.63135,1.389-1.894,1.5152-1.2627,1.1364-1.0102,1.389-1.2627,0-1.2627-0.63134-2.1466-0.75762-1.6415-0.3788-1.6415,1.2627-0.3788,1.5152-0.63135,1.389-2.3991,2.6516-1.6415,2.3991-3.9143,3.6618-1.894,1.5152-0.25254,2.0203-0.63134,1.5152-2.9042-0.25254-1.6415,1.7678-1.2627,1.389-0.50507,0.63135-2.0203,0-1.1364-2.0203-0.50508-0.63134-5.4296-0.63135-1.389-2.1466-2.7779,0.88388-1.2627-0.12627,0-0.50507,3.4093-4.4194,0-1.6415-0.88389-0.63134,0-1.1364,1.7678-1.1364,1.0102-1.389,0-2.0203-0.25253-0.50508-1.894-0.12627-2.2728,1.2627-1.7678-1.1364-1.1364-2.3991,1.2627-2.3991,1.0102-1.894-0.25254-2.5254,0-0.75761,0.88389-1.5152,0-3.1567-2.5254-2.9042-0.12627-2.0203,1.0102-2.6516,2.0203-4.1669,2.9042-2.1466,3.9143-3.1567,1.0102-2.1466-0.88389-1.389-0.12627-0.12627,0-0.75761,1.389-0.25254,2.3991,0.75762,1.389,0.12626,1.7678-0.63134,2.6516-0.25254,1.7678-0.12627,0.88388-0.63134,0-1.7678z",
  "city_population": 2517571,
  "fed_okrug": "Приволжкий федеральный округ",
  "country_population": 1548648,
  "area": 142947,
  "city_natural_increase": 8454,
  "city_migration_increase": -4447,
  "country_natural_increase": -3450,
  "country_migration_increase": -1480,
  "average_nominal_wage": 25928,
  "average_consumer_rate": 21621,
  "average_annual_buzy": 1759.9,
  "per_capita_income": 27744,
  "kladr": "0200000000000"
}, {
  "id": 354,
  "name": "Республика Марий Эл",
  "path": "m211.51,286.29,2.2728,2.336,2.4622,2.0834,2.7779,1.1364,2.9673,0.0631,2.4622,2.0834,1.5784,1.6415,0.44194,1.3258,0.63134,0.94702-0.3788,1.6415-0.56821,1.1364-0.0631,1.8309-1.5152,1.389-0.88388,0.56821-1.4521-0.12627-1.1996-1.5152-1.1996-0.44194-1.389-0.82075-1.7046-0.12627-0.50508,0.88389-1.7046,0.88388-2.5885,0.12627-1.9572-0.82075-1.1364-0.69448-0.88388-3.0305-0.37881-4.7351-1.1996-1.4521-4.0406-0.0631-1.3258-0.1894-0.63134-1.0733,0-2.0834,0.0631-3.0936,0.37881-1.8309,1.0102-1.0733,0.82075-0.63134,2.5885,0.3788,2.2728,0.88389,2.9673,1.7678z",
  "city_population": 450684,
  "fed_okrug": "Приволжкий федеральный округ",
  "country_population": 234128,
  "area": 23375,
  "city_natural_increase": 966,
  "city_migration_increase": 384,
  "country_natural_increase": -495,
  "country_migration_increase": -2425,
  "average_nominal_wage": 21947,
  "average_consumer_rate": 12399,
  "average_annual_buzy": 304.4,
  "per_capita_income": 18533,
  "kladr": "1200000000000"
}, {
  "id": 355,
  "name": "Республика Мордовия",
  "path": "m157.59,290.05,1.875,2.1429,2.6786,1.7857,1.7857,1.1607,1.7857,2.7679,0.44642,2.4107,2.0536,2.1429,2.5893,0.0893,1.6071,0.26786,0.89286,2.2321,0.71429,1.4286,2.0536,0.89286,1.7857,0.35714,1.25,0.625,0.53572,0.80358,5.8928,0.17857,2.6786-3.5714,0.35715-0.53572,0.71428-1.3393,0.0893-2.1429-0.0893-1.9643-1.7857-0.98215-0.35714-2.5-0.0893-0.80357-1.6964,0,0,0.17857-0.80357,0.89286-1.3393,0.80357-5.2678,0-2.5893-2.3214,0.17857-3.5714-1.1607-1.0714-0.17857-0.80358,1.0714-1.0714,0-1.6072-2.5893-0.53571-1.7857-0.0893-0.80357-1.25-0.71429-1.6964-1.25,1.1607-2.1429,2.3214-2.4107,1.5178-1.5179,0.98215-2.9464,0.26785z",
  "city_population": 506001,
  "fed_okrug": "Приволжкий федеральный округ",
  "country_population": 303173,
  "area": 26128,
  "city_natural_increase": -437,
  "city_migration_increase": 4691,
  "country_natural_increase": -3091,
  "country_migration_increase": -2598,
  "average_nominal_wage": 22029,
  "average_consumer_rate": 10881,
  "average_annual_buzy": 362.9,
  "per_capita_income": 17878,
  "kladr": "1300000000000"
}, {
  "id": 356,
  "name": "Республика Татарстан",
  "path": "m190.93,308.14,0.0631,1.1364,0.44194,1.0733,0.88389,1.0102,1.5152,0.63134,1.8309,1.4521,1.5152,0.75762,1.389,0.44194,1.4521,1.0733,1.389,1.0102,2.4622,0.44194,1.4521,0.0631,1.7046,0.88388,0.12627,2.2097-0.37881,2.9042,0.44195,1.4521,2.0834,1.1996,1.0733,0.75761,2.9042,0.18941,0.82075,0.69448,0.56821,1.7046,1.3258,2.1466,0.63134,2.5885,0.88389,1.7678,1.6415,1.894,1.389,2.2728,1.6415,1.1364,0.88388,0.88388,1.1996,0.0631,2.9042-1.8309,2.9042-2.7148,0.44194-0.63135,0-1.894-1.0102-1.0102-0.0631-0.88388,1.8309-0.25254,1.2627,0.31567,0.75762,0.56822,1.3258,0.3788,1.6415-0.31567,1.1996-0.69448,2.9042-0.12627,1.5152-0.37881,0-0.94701-0.37881-1.2627-1.1996-1.5784-0.63134-1.2627-1.5152-0.44194-0.88389-1.2627s1.2627-1.0102,1.5784-1.1364c0.31567-0.12627,2.2728-0.75762,2.2728-0.75762l0.0631-1.4521s-1.1364-0.18941-1.389-0.50508c-0.25254-0.31567-0.69448-0.94702-0.69448-0.94702l2.0203-1.3258,2.0203-1.389,0.12626-1.1364-0.69447-0.82075h-1.5152l-0.69448,0.0631-1.1364,1.3258-0.56821,0.69448h-1.894l-0.12627,0.88388-0.12627,1.3258-0.82075,1.1364-1.5152-0.12627-0.75761-1.4521-1.1364-0.94702-0.82075,1.0102-1.7678-0.31567-0.56821-2.2728-1.4521-0.88388-0.63135-1.2627,0.12627-1.3258-1.1364-1.3258,0.0631-2.6516,0.12627-3.0936,0.63135-0.94702-0.25254-1.0102-0.69448-1.0733-0.56821-0.56821-1.0102,0.44194-0.88388,0.37881-1.0102-0.12627-1.0733-0.88389-0.88388-0.82074-1.8309-0.69448-1.4521-0.44195-0.94702,0.94702-1.8309,0.75762-1.8309,0.1894-1.6415-0.31567-1.9572-1.0733-1.389,0.50508h-2.7148l-2.0834,0.0631-1.389,1.1364-0.0631,0.88389,0.69448,0.50507,0.12627,0.82075-0.82075,1.0733-1.5152,1.2627-2.6516,1.0733-1.5784,0.69448-1.1364-0.75762-2.0834-0.82075z",
  "city_population": 2976966,
  "fed_okrug": "Приволжкий федеральный округ",
  "country_population": 909363,
  "area": 67847,
  "city_natural_increase": 14394,
  "city_migration_increase": 1982,
  "country_natural_increase": -4274,
  "country_migration_increase": 1591,
  "average_nominal_wage": 29147,
  "average_consumer_rate": 23232,
  "average_annual_buzy": 1806.6,
  "per_capita_income": 32163,
  "kladr": "1600000000000"
}, {
  "id": 357,
  "name": "Удмуртская Республика",
  "path": "m261.7,302.33-0.12627,1.389-2.0203,2.7779-1.5152,1.389,0.12626,1.389-1.6415,1.0102-1.1364,1.5152-1.5152,2.3991-0.50508,1.894-0.50508,3.1567-2.0203,1.0102-2.2728,0.12627-0.63135,1.1364-0.37881,3.0304-0.12627,1.389-3.0304,2.0203-2.2728,1.389-1.0102,0-1.2627-1.5152-1.7678-0.75762-0.63134-1.2627,1.389-1.1364,2.0203-0.75761,0.50508-1.1364-0.37881-0.50508-1.5152-0.88388,0.25254-0.88389,2.7779-1.7678,1.0102-1.1364-0.50507-1.0102-0.75762-0.63134-2.0203,0.63134-1.1364,1.389-1.5152,0.63135-1.0102,0.25253-0.3788,1.5152-0.63135,0.75762-0.88388,0.25254-0.75762-1.0102-1.389-1.2627-0.75761,0.37881-1.2627,0.37881-0.88388-0.88389-0.63135-1.1364-1.0102-1.0102-0.63135-1.0102,0-1.1364,1.6415-0.88389,1.1364-1.1364,0.25254-2.0203,0.25254-1.0102,3.1567-0.50507,1.6415-0.50508,0.37881-4.4194s0-1.2627,0.63135-1.5152c0.63134-0.25253,1.2627-0.3788,1.2627-0.3788l1.2627,0.63134s1.6415,1.894,2.3991,1.389c0.75761-0.50507,1.894-0.88388,1.894-0.88388s2.3991-1.0102,2.2728-1.6415c-0.12627-0.63134,0.25254-1.6415,0.25254-1.6415l0.3788-1.389,2.1466-2.2728,1.2627-0.75761,2.2728-0.50508,1.6415,0.37881,0.88388,1.1364v0.75761l0.25254,0.63135,1.0102,0.12627,1.6415,0.3788,0.63135,0.50508,0.63134,1.6415,0.75762,0.75761z",
  "city_population": 996004,
  "fed_okrug": "Приволжкий федеральный округ",
  "country_population": 520727,
  "area": 42061,
  "city_natural_increase": 2304,
  "city_migration_increase": -2316,
  "country_natural_increase": 326,
  "country_migration_increase": -622,
  "average_nominal_wage": 24694,
  "average_consumer_rate": 15265,
  "average_annual_buzy": 732.8,
  "per_capita_income": 24465,
  "kladr": "1800000000000"
}, {
  "id": 358,
  "name": "Чувашская Республика",
  "path": "m189.11,299.07,1.3393-0.89286,2.9464,0.44643,1.3393,0.44643,1.0714-1.3393,0.26786-1.7857,2.2321-1.1607,2.2321-2.2322,3.125,0.0893,2.6786,0,1.25,1.5179,0.35715,2.9464-0.17857,1.5179,0.35714,1.25,0.71428,1.1607-0.0893,0.71428-1.3393,0.625-4.1071-0.0893-1.3393,0.53571-0.80357,0.80357,0,0.89286,1.1607,0.71428-0.17857,0.89286-1.3393,1.1607-1.7857,1.25-2.1429,0.98214-1.3393,0.44643-1.3393-1.3393-2.5-0.44643-0.98215-0.625-0.98214-1.3393-0.80357-0.80357,0.80357-3.5714z",
  "city_population": 766202,
  "fed_okrug": "Приволжкий федеральный округ",
  "country_population": 469790,
  "area": 18343,
  "city_natural_increase": 3242,
  "city_migration_increase": 3348,
  "country_natural_increase": -2351,
  "country_migration_increase": -5682,
  "average_nominal_wage": 21369,
  "average_consumer_rate": 12967,
  "average_annual_buzy": 551.7,
  "per_capita_income": 18492,
  "kladr": "2100000000000"
}, {
  "id": 359,
  "name": "Пермский край",
  "path": "M272.06,274.03l-2.28,1.16,0.5,1.5-0.5,3.53,0.5,1.28,1.41,2.41,2.25,1.62,0.65,1.66-1.4,2.12-2.41,1.03-2.87,0.63-1.66,0.87-1.13,1.54,0.5,1.24,0.63,1.38-0.13,1.03-1.9,1.63-0.38,2.4-0.87,1.6-0.13-0.19-1,0.12-1.28,2.5-2,2.29-0.15,1.53-0.88,0.87-2,2.03-1.91,3.41-0.62,3.9-1.28,0.88-2.25,0.38-1.28,0.78-0.63,4.9,2.53,2.66,2.13,2.28,2.53,0.25,2.28,1.5,3.41,4.94,1,0.37,1.28-0.12,1.12-1.25,0.88-1.28,1.03-1.75,1.25-1.66,1.28,0.88,1.5,1.28h2.41l2.03-0.91,0.5-1.75,0.25-1.91,0.87-0.75,0.88-1,0.78-0.5,2.5,2.75h3.69l0.87-1,0.5-1.5,0.25-1.65,0.88-1.25,4.69-0.38,2.15-0.78,0.63-1.5-0.63-0.62-0.12-1.41,1.12-1.38,0.75-1.03v-1.37l-0.5-0.88-0.62-1.03,0.25-1.75,1-1.53,2.03-1.5,3.15-0.5,1.88-1.91,2.28-1.62,2.28-1.66,2.28-1.65,0.88-0.75,0.5-1.25,1-1.78s0.9-1.12,1.53-1.75c0.63-0.64,1.62-1.91,1.62-1.91l1.16-1.37,0.25-1.66-2.41-0.38-2.65-0.75-2.66-1.65-2.75-1.38-2.66-1.28-2.53,0.66-3.15,0.12-3.66-0.9-2.9-1.63-1.63,0.85-0.41-0.22-1.9-1.25-1.38-2.03-1.12-1.13-2.28-0.78-0.13-1.63-1.12-1.28-1.41-1.5-1.91-0.5-2.62-0.25-2.41-0.78z",
  "city_population": 1993873,
  "fed_okrug": "Приволжкий федеральный округ",
  "country_population": 638885,
  "area": 160236,
  "city_natural_increase": 1818,
  "city_migration_increase": -1628,
  "country_natural_increase": -427,
  "country_migration_increase": -2386,
  "average_nominal_wage": 28528,
  "average_consumer_rate": 20376,
  "average_annual_buzy": 1246,
  "per_capita_income": 32053,
  "kladr": "5900000000000"
}, {
  "id": 360,
  "name": "Кировская область",
  "path": "m237.59,265.33,1.2627-0.88388,0.12627-2.0203,0-2.0203-1.0102-1.389-0.12627-1.6415,1.5152-0.37881,3.9143,0.25254,2.5254-0.88388,2.6516-1.1364,0.63134-1.389,1.1364-0.63134,2.7779,0.25254,1.389,1.7678,0.12627,2.7779-0.63134,3.0305-1.0102,1.389-0.75761,2.7779-1.894,0.75762-2.0203,0.12626-1.6415,1.7678-0.63134,1.6415-1.0102,0.63134-0.75761,0.88389,0.75761,1.389,1.6415,0.88388,1.0102,1.389-1.6415,1.894,0.12626,1.894,1.1364,0.88389,1.2627,0.50507,0.88388-1.389,0.88388-1.894,2.7779,0,3.1567,0.3788,4.2932,1.2627,1.7678,2.2728,2.1466-0.12627,2.1466-1.6415,1.6415,0.37881,1.2627,1.0102,0.75762,1.894s1.0102,1.5152,1.389,1.7678c0.3788,0.25254,2.5254,1.894,2.5254,1.894l0.25254,1.5152-0.88389,2.0203-2.0203,1.1364-3.5355,0.25253-1.2627,0.63135-1.2627,1.5152-0.25254,1.389,1.0102,1.389,0.12627,1.1364-1.5152,1.1364-0.75762,1.389-0.12627,2.1466-1.2627,1.0102-2.7779,0.12627-1.1364-1.2627-1.0102-2.5254-2.0203-0.12627-1.389-0.3788v-1.894l-2.0203-1.1364-3.1567,0.75761-1.7678,1.389s-1.2627,1.0102-1.2627,1.5152c0,0.50508-0.3788,2.2728-0.50507,2.7779-0.12627,0.50508-1.6415,1.5152-1.6415,1.5152l-2.5254,1.1364-1.894-0.50507-1.2627-1.389-1.5152,0.25253s-0.75761,0.50508-1.0102,1.389c-0.25254,0.88389-0.12627,2.7779-0.12627,2.7779l0.12627,1.894-2.0203,0.63135-3.4093,0.3788-0.25254,1.1364v1.389l-0.3788,1.389-1.7678,0.88389h-0.63135l-0.63134-1.5152-0.50508-0.37881,0.12627-2.5254,0.25254-2.5254,0.50508-1.5152-0.88389-1.6415-0.25254-1.2627,0.75762-2.9042,0.63134-2.5254-1.0102-1.5152-1.6415-2.5254-2.1466-1.5152-0.88388-0.63134-3.9144-0.12627-1.7678-1.2627-1.6415-1.5152-1.6415-1.5152-0.50507-0.50508,0.50507-1.0102,1.2627-1.6415,0.25254-1.0102,1.1364-0.75761,1.5152,0.50507,1.894,1.389,1.389-0.75761,2.1466-0.63135,1.389-1.2627v-1.5152l-1.2627-1.894-0.63135-1.5152s-0.78918-1.1049-0.85231-1.2627c-0.0631-0.15784,0.56821-0.69448,0.56821-0.69448l0.97858-0.63135,0.75762-0.75761s2.2728-0.0316,2.8095-0.0316c0.53664,0,3.1567,0.0631,3.8828,0.0631,0.72605,0,3.7881-0.44194,3.7881-0.44194l1.4521-0.59978s0.12626-1.5784,0.15783-1.7993c0.0316-0.22097,0.47351-2.4938,0.47351-2.4938l2.0203-2.3991z",
  "city_population": 986012,
  "fed_okrug": "Приволжкий федеральный округ",
  "country_population": 306099,
  "area": 120374,
  "city_natural_increase": -869,
  "city_migration_increase": 200,
  "country_natural_increase": -2342,
  "country_migration_increase": -3863,
  "average_nominal_wage": 22118,
  "average_consumer_rate": 15309,
  "average_annual_buzy": 625.2,
  "per_capita_income": 22170,
  "kladr": "4300000000000"
}, {
  "id": 361,
  "name": "Нижегородская область",
  "path": "m186.25,271.57,4.2857-0.53571,2.5-1.4286,3.5714-0.71428,2.6786-1.0714,1.25-0.17857,2.3214,1.25,1.7857,1.0714,2.6786-0.17857,1.4286,0,2.6786-1.0714,1.25,0.17857,1.4286,1.9643,1.0714,2.1429,2.5,0.17857,2.5,1.7857,1.0714,1.25,0.89286,2.5,1.25,1.4286-0.17858,1.6071-1.25,0.89286-1.7857,0.17857-0.71429,0.89286-1.6071,0-0.71428-0.89286-1.7857-1.0714-1.6071,0.71429,0,1.6071-1.25,1.4286-1.25,0.53572-2.1429-0.89286-2.1429-1.6071-3.0357-0.89286-1.7857,0-1.0714,0.89286-0.71429,1.7857,0,2.8571-0.17857,2.8572,0.53571,1.0714-1.0714,1.4286-2.3214,1.4286-1.4286,0.89285,0,1.4286-0.35715,0.89285-0.89285,0.71429-2.8572-0.35714-1.0714-0.17858-0.89285,0-0.71429,0.53572-0.38692,0.34215-0.69448-0.12626-0.44194-0.50508-0.50508-3.0936-1.5784-0.12627-1.5784,1.4521-2.2097,0.44194-3.9775-0.25253-2.0834-2.0203,0.1894-3.3461-1.2627-1.389-0.0631-0.75761,1.0102-1.4521-0.0631-1.0733-3.7249-0.63135-1.1996-0.75761-1.0733-2.7148,1.1364-2.336-1.1996-3.3461,2.0203-0.50507,3.283-0.12627,5.9978,0.12627,1.2627,0.88388,2.0203,0.1894,2.0203-0.75761,0.12627-1.5152-0.94702-1.4521,0.63135-1.0733z",
  "city_population": 2582521,
  "fed_okrug": "Приволжкий федеральный округ",
  "country_population": 666752,
  "area": 76624,
  "city_natural_increase": -4464,
  "city_migration_increase": -762,
  "country_natural_increase": -6174,
  "country_migration_increase": 1464,
  "average_nominal_wage": 26481,
  "average_consumer_rate": 20749,
  "average_annual_buzy": 1650.9,
  "per_capita_income": 30837,
  "kladr": "5200000000000"
}, {
  "id": 362,
  "name": "Оренбургская область",
  "path": "m185.89,352.82,0.53571,1.4286,0.71429,1.6071-1.0714,1.6072,1.0714,1.4286,3.0357,0.17857,1.9643-0.35714,2.5,0,0.17857,2.3214-0.89286,2.6786,0.35714,1.0714,3.5714,1.6071,2.1429,1.4286,0.17857,3.5714,0,4.1071,0,1.4286-1.25,0.89286,0,1.9643,0,0.71428,0.71429,1.0714,1.0714,0.89286,1.7857-2.5,0-1.4286,0.89286-0.89286,1.4286,0,1.0714,2.3214-0.17858,1.4286-0.71428,1.25-0.35714,1.4286l0.36,1.43,1.25,0.89286,2.3214,1.25,1.7857,0.89286h1.9643,2.5l1.4286-1.0714,1.6071,0.17857,1.9643,1.0714,0.89285,1.6071,0.35715,1.7857,1.0714,1.25h1.7857l0.89286-0.89285h1.25l1.6071,0.53571,1.25,1.4286,0.53571,2.6786-0.17857,3.5714,1.7857,1.6072,1.4286,0.89285,1.0714,1.6072,1.0714,0.53571,1.6071-0.71429,1.4286-0.17857,1.6071,1.4286v1.25l1.9643,1.7857,1.25,0.71428,2.1429,0.35715h2.6786l1.4286-0.17857,1.25-0.89286,1.25-1.0714,0.89286-0.89286-0.17858-1.25-2.3214-3.2143-1.0714-1.25v-3.75l-0.71429-2.1429-0.17857-2.1429,1.0714-2.3214,1.9643-1.4286-1.4286-1.7857-3.0357-2.8571-1.9643,0.35714-1.4286-0.17857-0.89286-1.25h-2.3214l-1.4286,1.25-1.0714,1.25-0.53572,1.0714h-2.5l-1.0714-2.5-3.2143-0.17858-2.8572-0.35714-0.89285-2.5-1.08,0.33-1.79,0.89h-1.4286l-0.17857-1.0714,1.4286-1.7857,2.5-2.5-0.53-1.78-0.71-0.36v-0.89286l2.5-1.9643,0.35715-1.0714v-2.1429h-1.7857l-2.1429,0.71429-1.6071,0.17857-1.4286-1.9643-0.53571-2.3214,1.25-1.7857,1.0714-0.89286v-1.6071l-0.35714-2.3214,1.0714-0.89285,0.17857-3.0357-1.25-1.9643-1.7857-1.7857-0.17857-1.6071,1.0714-2.8571,1.6072-2.5,0.89285-1.7857-0.53571-1.25-2.1429-1.6071-1.4286-2.1429-1.25-1.4286-1.6071,1.7857-1.4286,1.4286-4.1072,2.5-1.4286,1.9643-0.35714,1.9643-0.53571,0.35714-1.9643,0.17857-2.1429-0.35714-1.9643,0.53571-1.9643,1.4286-2.8571,0.53572-1.0714,0.71428-1.4286,1.7857-2.1429,1.25h-2.5z",
  "city_population": 1194560,
  "fed_okrug": "Приволжкий федеральный округ",
  "country_population": 795783,
  "area": 123702,
  "city_natural_increase": 346,
  "city_migration_increase": -3081,
  "country_natural_increase": -13,
  "country_migration_increase": -3600,
  "average_nominal_wage": 24591,
  "average_consumer_rate": 15931,
  "average_annual_buzy": 1022.3,
  "per_capita_income": 22948,
  "kladr": "5600000000000"
}, {
  "id": 363,
  "name": "Пензенская область",
  "path": "m157.05,289.96,1.6964,1.7857,2.0536,1.5179,1.25,0.98214,1.6964,0.625,1.25,1.875,0.71429,1.6071,0.26785,1.9643,0.98215,0.98214,1.0714,1.0714,2.6786,0.17857,1.6964,0.0893,0.625,2.1429,0.89286,1.7857,1.6964,0.71429,2.1429,0.26785,1.4286,1.0714,0.625,1.0714-1.5179,0.89286-0.89286,0.98214,0.0893,4.1071-0.26786,3.4822-2.7679,1.25-1.0714-0.0893-0.89286,1.6071-1.9643,0.98215-1.1607-1.7857-0.98214-0.98214-5.9822-0.0893-1.1607-1.875-0.89286-0.89285-3.125-0.71429-0.98214-1.6071-1.25-1.6964-2.1429-0.71429-2.4107-1.3393-1.6071-1.0714-2.5,0.0893-0.71429-1.875,0.26786-2.5,1.1607-0.89285,3.8393-0.80357,0.89285-2.4107,0-3.4821,1.3393-1.6964,1.3393-1.6071-0.26786-2.5893,0-1.9643,1.1607-0.89286z",
  "city_population": 917092,
  "fed_okrug": "Приволжкий федеральный округ",
  "country_population": 424990,
  "area": 43352,
  "city_natural_increase": -2316,
  "city_migration_increase": -40,
  "country_natural_increase": -3284,
  "country_migration_increase": -1275,
  "average_nominal_wage": 23192,
  "average_consumer_rate": 15445,
  "average_annual_buzy": 658.9,
  "per_capita_income": 21829,
  "kladr": "5800000000000"
}, {
  "id": 364,
  "name": "Самарская область",
  "path": "m180.98,329.96,1.3393,2.1428,0.71428,2.8572,0.44643,2.8571,0,2.1429,0.625,2.3214-0.0893,2.8571,0.35714,2.4107,0.53571,2.1429,0.625,1.9643,0.71429,0.98214,5.8929,0.0893,3.0357-1.6071,1.25-1.9643,1.9643-0.35715,1.6964-0.0893,2.1429-1.4286,1.4286-0.89286,1.25-0.17857,1.6072,0.625,1.7857-0.17857,0.80357-1.875,1.0714-2.3214,4.375-2.5893,1.7857-1.4286,1.1607-2.0536-0.625-1.5179-0.80357-1.7857-0.35715-2.5-1.1607-1.25-0.71429-2.4107-3.6607-0.26785-2.3214-1.6964-1.4286-0.80357-3.5714,2.3214-1.9643,2.2322-2.4107,0.0893-0.98214-0.98214-2.2321-2.4107-2.4107-1.875-1.0714-1.0714-0.89285,0.26785-1.6072,0.71429-1.6964-0.0893-1.5178-0.80357-1.0714,0-0.625,0.98215-0.53572,1.0714-0.80357,1.5179-0.17857,1.3393,0,0.98214-0.0893,0.71429z",
  "city_population": 2567606,
  "fed_okrug": "Приволжкий федеральный округ",
  "country_population": 637377,
  "area": 53565,
  "city_natural_increase": -2400,
  "city_migration_increase": -7306,
  "country_natural_increase": -2250,
  "country_migration_increase": 5255,
  "average_nominal_wage": 26849,
  "average_consumer_rate": 20351,
  "average_annual_buzy": 1503.7,
  "per_capita_income": 27732,
  "kladr": "6300000000000"
}, {
  "id": 365,
  "name": "Саратовская область",
  "path": "m137.23,308.27-0.17857,3.0357-0.26786,1.25-2.2321,1.1607,1.4286,1.6964,1.0714,3.2143,2.2321,0.71429,0.98215,0.80357,0.89285,1.0714,1.7857,0.625,2.5893,2.5,0.89286,1.0714,0,1.875-1.5179,2.0536-2.4107,2.8571-0.44643,1.25,0.44643,1.6964,0.71429,0.89286,2.1428,1.1607,4.0179,3.9286,1.7857,4.5536,1.25,1.4286,1.25,1.3393,0.26786,1.9643-0.71428,2.5-0.53572,2.4107,0.26786,1.7857,0.89286,1.0714,1.6071,0.44643,1.6964,0,1.6964-1.1607,1.25-1.0714,0.44642-2.6786,0.0893-1.875,2.2321-0.625,3.3036,1.25,1.6964,0.35714,1.6072,0,1.3393-1.5179,0.44643-0.53571,1.6071,0.35714,1.3393,1.0714,1.5178,0.89286,4.6429,0,1.1607-1.1607,1.3393,0.17857,0.89286,0.80358,1.6071-0.53572,0-1.7857-0.89286-1.9643-0.35714-1.3393-0.17857-3.9286-0.0893-2.0536-0.71428-1.25,0.0893-2.8571-0.35714-1.6071,0-2.5-0.80357-1.3393-1.1607-1.6071-2.5-1.0714-1.6072-2.0536-2.5893-0.0893-1.0714-0.35714-1.7857-1.6964-0.625-1.25-0.44642-0.89286-1.7857-2.4107-5.625-0.26786-0.53571-0.17857-1.9643-2.5893-3.125-0.89286-2.2321-2.9464-6.1607-3.3036-2.3214,0-1.0714-1.6964,0.44643-2.5-0.80357-0.35714-3.8393,2.1428-1.5179,0.35715z",
  "city_population": 1872881,
  "fed_okrug": "Приволжкий федеральный округ",
  "country_population": 607356,
  "area": 101240,
  "city_natural_increase": -3899,
  "city_migration_increase": 3470,
  "country_natural_increase": -2786,
  "country_migration_increase": -2280,
  "average_nominal_wage": 22528,
  "average_consumer_rate": 13810,
  "average_annual_buzy": 1171.8,
  "per_capita_income": 20070,
  "kladr": "6400000000000"
}, {
  "id": 366,
  "name": "Ульяновская область",
  "path": "m188.57,305.32-1.875,2.6786-0.98215,1.4286-4.8214-0.26785-0.80358,0.26785-1.7857,1.4286-0.80357,1.1607,0,2.3214,0,2.5893,0,1.6964-1.7857,1.4286-1.0714,0.26786-0.89286,0-1.25,1.25-1.25,1.0714-0.625,0.26786,0.89286,1.9643,1.6071,1.6071,2.3214,0.44643,1.5178,0.17857,1.25,1.6072,1.5179,0.80357,2.1429,0.17857,0.89286-0.625,0.0893-1.875,0.17857-1.6964,1.0714-1.6964,0.35714-1.3393,1.3393-0.26786,0.80357,0.53571,1.3393,0.625,1.875-0.17857,1.3393-0.98214,1.0714,0.17857,1.6964,1.4286,2.0536,1.875,1.5179,1.6072,0.80357,1.4286,2.3214,0.17857,1.1607-1.5179,2.8572-2.0536,2.0536-1.1607,0.26785-2.3214,0-3.5714-1.875-1.1607-3.6607-0.0893-2.0536-1.4286-0.98214-1.1607-2.5-0.26785-0.98215-1.5179-3.0357-1.5179-0.80357-1.5179-0.625-2.0536z",
  "city_population": 940423,
  "fed_okrug": "Приволжкий федеральный округ",
  "country_population": 313040,
  "area": 37181,
  "city_natural_increase": -821,
  "city_migration_increase": 257,
  "country_natural_increase": -2922,
  "country_migration_increase": -1442,
  "average_nominal_wage": 22846,
  "average_consumer_rate": 14915,
  "average_annual_buzy": 583.3,
  "per_capita_income": 22782,
  "kladr": "7300000000000"
}, {
  "id": 368,
  "name": "Курганская область",
  "path": "m285.69,383.01,2.3991,1.894,3.283,0.88388,4.2932,1.2627,3.1567,0.75762,4.1669-0.50508,2.5254,0.25254,2.9042,1.0102,3.5355,1.1364,3.5355,0.88388,3.283,1.0102,3.4093-0.12627,2.3991-1.2627,3.6618,0,1.0102-1.5152,0-1.894-1.5152-2.1466-1.389-2.7779s-1.5152-0.12627-2.1466-0.37881c-0.63135-0.25254-2.2728-1.6415-2.2728-1.6415l-0.75761-3.1567-1.389-1.7678-2.6516-1.2627-1.5152-1.6415-1.2627-2.2728-1.6415-1.5152-1.389-1.2627-1.0102-1.389,0.50508-2.3991,1.389-1.2627,1.1364-1.894-2.5254,0.37881-3.0305,0.12627-1.389,0.50507-0.75762,0.50508-1.2627-0.37881-2.0203-1.0102-1.7678-1.7678-2.0203-1.389-1.7678-0.75761h-1.2627l-3.0305,0.63134-1.7678-0.12627v1.1364l0.63135,0.88388-0.50508,2.2728v2.2728l-0.25253,2.1466-0.88389,1.1364-2.5254,1.1364-1.389,1.1364-1.5152,1.2627-1.7678,0.88388-0.50507,1.2627,0.63134,1.1364,1.894,1.894,1.389,1.389,0.63134,1.7678v1.894l-0.50507,1.7678z",
  "city_population": 527347,
  "fed_okrug": "Уральский федеральный округ",
  "country_population": 326603,
  "area": 71488,
  "city_natural_increase": -255,
  "city_migration_increase": -2466,
  "country_natural_increase": -2127,
  "country_migration_increase": -3070,
  "average_nominal_wage": 22064,
  "average_consumer_rate": 13369,
  "average_annual_buzy": 368.3,
  "per_capita_income": 19151,
  "kladr": "4500000000000"
}, {
  "id": 369,
  "name": "Свердловская область",
  "path": "m316.13,291.72,1.7678-1.1364,1.1364,1.389,0.88388,2.3991,2.6516,1.5152,2.9042,2.1466,1.2627,2.3991,2.2728,2.7779,0.12627,1.7678,0.63135,2.0203,0.75761,1.5152-0.63134,1.7678-1.894,1.894-0.63135,1.7678-0.25253,4.7982,0.3788,2.7779,0.63135,1.0102-1.0102,2.9042-1.5152,1.7678-0.37881,2.3991,2.0203,1.2627,2.3991,2.0203,0.75761,2.0203,0.12627,2.6516-0.63134,1.6415,0,2.9042,0.75761,2.3991-0.25254,1.894s-0.88388,0.88388-0.88388,1.389c0,0.50508-0.50508,2.7779-0.50508,2.7779l-1.2627,1.2627-2.0203,0.12627-1.1364,0.88388h-3.0304l-1.5152-0.88388-2.1466,0.25254-1.389,1.1364-0.88388,1.389-0.25254,2.9042-0.75761,1.1364-1.1364,1.0102-1.7678,0.50508-3.0305,0.25254-2.0203,0.25254-1.0102,0.88388-1.894-0.37881-1.389-1.1364-1.894-1.894-2.5254-1.6415-1.5152-0.63135-2.2728,0.37881-1.894,0.3788-1.389-0.12626-1.6415-1.389-1.894-2.2728h-2.2728c-0.50508,0-1.6415-0.75761-1.6415-0.75761l-4.672-3.1567-1.6415-1.7678-2.9042-0.3788-1.389,0.12627-0.88389,0.12627-1.2627-1.2627-3.9143-3.283-3.1567-3.0305-0.50507-1.389,2.0203-2.9042,1.389-2.7779,0.75762-0.25253,1.6415,1.1364,1.1364,0.75761h2.7779l1.5152-1.389,0.50507-1.7678,0.12627-1.7678,2.5254-1.7678,1.7678,2.0203,1.2627,0.63134h2.3991l1.6415-1.1364,0.75761-2.0203,0.50508-1.894,3.7881-0.75762,2.5254-0.3788,1.389-1.2627v-1.0102l-0.88388-1.389,1.7678-2.1466,0.25254-1.1364v-1.389l-1.0102-1.6415,1.0102-2.5254,2.1466-1.6415,3.283-0.88388,1.1364-0.75762,8.0812-6.1872,0.88388-1.6415,1.6415-2.7779,2.1466-2.5254z",
  "city_population": 3664950,
  "fed_okrug": "Уральский федеральный округ",
  "country_population": 665702,
  "area": 194307,
  "city_natural_increase": 2582,
  "city_migration_increase": 6310,
  "country_natural_increase": -1572,
  "country_migration_increase": -4786,
  "average_nominal_wage": 30691,
  "average_consumer_rate": 27503,
  "average_annual_buzy": 2021.1,
  "per_capita_income": 34820,
  "kladr": "6600000000000"
}, {
  "id": 371,
  "name": "Ханты-Мансийский автономный округ",
  "path": "m359.64,260.32,0,3.75-0.53572,3.2143-1.6071,2.3214-2.3214,2.3214-0.89286,1.25,1.9643,1.9643,1.7857,2.3214,5,1.9643,4.8214,0.17857,3.5714,1.4286,2.3214,2.6786,0,1.4286-2.1429,1.7857,1.4286,1.4286,2.3214,2.8572,1.9643,1.0714,2.1428-1.0714,1.7857-0.89286s1.6071,0.71429,1.9643,0c0.35715-0.71429,0.89286-2.1429,0.89286-2.1429l1.6071,2.1429,1.4286,2.8571,1.9643,1.6072s0.35714,2.1428,0.35714,2.8571v4.6429l1.9643,3.3928s0.35714,0.17857,0.71429,0.89286c0.35714,0.71429,0,2.1429,0,2.1429l1.0714,1.25,2.5,0.53571,3.75,0.71429,1.4286,0.89285s2.8571,2.1429,3.5714,2.6786c0.71429,0.53571,1.25,1.6071,2.1429,1.9643,0.89286,0.35714,3.5714,0.53572,3.5714,0.53572l2.8571,0.35714,0.89286,1.0714s0.35714,1.6071,0.71428,2.6786c0.35715,1.0714,1.4286,1.7857,1.4286,1.7857l3.0357,0.17857,1.7857,0.53572,0.35715,1.9643,0.35714,1.4286,1.0714,2.5c1.9643,0.17857,2.5,0.17857,3.5714,0.17857s3.3928,1.0714,3.3928,1.0714l1.9643,0.71428,2.8571,0.35714,2.8572-1.0714,3.2143-1.9643,3.0357,0.53571,1.9643,2.6786s0.35714,1.7857,1.0714,2.1428c0.71429,0.35715,2.8571,0.53572,2.8571,0.53572l2.3214,1.6071,0.71429,2.3214,1.9643,0.71428,2.6786-0.89285,1.9643,1.6071,1.0714,3.0357v2.3214l-0.35714,1.6072-0.53572,1.9643,3.0357,1.9643,2.5,1.7857,0.35714,2.3214v1.0714l-3.75,1.7857-2.6786,0.53572-3.2143,0.17857-3,0.15-1.61-1.07-1.7857-0.71428-2.3214,0.35714-2.3214,1.6071-2.6786,1.0714-2.1429-1.9643s-2.8571-0.35714-3.5714-0.35714c-0.71429,0-2.3214-1.7857-2.3214-1.7857l-0.89286-1.25-3.9286,0.17857h-3.5714l-1.6071-2.5s-1.25-0.89286-2.1429-0.89286c-0.89286,0-4.4643-1.25-4.4643-1.25l-2.5-2.3214h-1.25c-0.71428,0-2.3214,1.25-2.3214,1.25l-2.5,2.1429-1.7857,2.6786-2.8571,2.5-1.6071,3.3929-4.4643,1.6071-3.5714,0.89286-0.35714,2.1429-0.71429,2.1428-2.6786,1.25h-2.8571l-5.8929-5.5357-3.9286-0.89286-1.0714-1.4286-0.53571-4.1071-1.0714-1.25-1.0714-5.3572-0.53571-1.7857-3.5714-3.2143h-5.5357l-3.0357-0.35714-1.9643-2.8571-1.6071-0.53572-4.4643,3.0357-3.3929,0.71428h-5.1786l-5,0.71429-4.2857,0.53571h-3.5714l-1.4286-0.17857-0.53571-2.8571-0.35714-3.2143,0.89285-3.2143-0.89285-3.2143-2.3214-2.1428-1.0714-0.89286-1.0714-1.0714,1.25-2.6786,1.4286-2.3214-0.17857-2.1429-0.71429-3.2143,0.71429-5.5357,1.4286-1.7857,1.4286-2.1429-0.71428-2.3214-1.0714-3.5714-1.9643-2.6786-2.3214-3.3928-3.3928-2.1429-1.7857-1.9643-1.0714-2.6786,3.3929-2.1429,1.6071-2.6786,2.3214-4.8214,2.1429-2.6786,2.5-1.9643,3.5714-3.3929,1.6071-1.7857,1.7857-3.3929-0.17858-1.7857,0.89286-1.0714,2.1429-1.0714,1.4286-1.9643,1.6071-1.0714,1.25,0.17857,0.89286,2.3214,0.35714,1.0714,1.4286,0.35714,2.5-0.71428,3.0357-1.6071,1.4286-1.25,1.25-1.0714,2.5-0.53572z",
  "city_population": 1500341,
  "fed_okrug": "Уральский федеральный округ",
  "country_population": 126414,
  "area": 534801,
  "city_natural_increase": 15600,
  "city_migration_increase": -634,
  "country_natural_increase": 927,
  "country_migration_increase": -1214,
  "average_nominal_wage": 60068,
  "average_consumer_rate": 26482,
  "average_annual_buzy": 914.6,
  "per_capita_income": 44538,
  "kladr": "8600000000000"
}, {
  "id": 372,
  "name": "Ямало-Ненецкий автономный округ",
  "path": "m396.25,234.25,1.4286,2.6786,1.6071,1.7857,1.6072,2.6786,1.0714,3.0357,0.89286,2.8572,3.0357,0.17857,1.7857-1.6072,1.4286-1.25-0.53571-3.2143s-0.89286-1.4286-0.53572-2.3214c0.35715-0.89286,1.7857-2.5,1.7857-2.5v-2.3214l-2.1429-1.6071-1.25-2.5s0.71429-1.6071,1.4286-1.9643c0.71429-0.35714,3.75-2.3214,3.75-2.3214s1.6071-3.75,1.9643-4.4643c0.35714-0.71429,0.35714-4.8214,0.35714-4.8214l0.89286-1.4286,7.5-2.1429,4.8214-3.5714,5.7143-6.0714,3.2143-2.1429,2.1428-0.71429,1.7857,2.3214,3.3928,0.35714,1.7857,1.25,1.0714,2.6786,0.17857,1.7857-0.89286,3.75-2.1429,2.6786-2.3214,2.8571-3.0357,1.6072-1.25,1.0714-0.35714,1.9643,1.0714,2.1429,0.17857,2.8571-0.89286,2.8571-2.1429,2.6786-1.7857,3.2143-2.6786,4.4643-1.25,3.5714-0.89286,2.1429-0.17857,2.5,0.35714,2.6786,0.71429,2.3214-0.71429,1.4286-3.0357,2.1429-1.0714,3.2143-0.89286,3.2143h-3.2143l-2.3214,1.25-2.1429,3.3929-3.5714,0.53571-2.3214,1.25-1.4286,1.4286h-3.5714l-1.4286-1.0714-1.0714-2.6786-0.71429,0.53572v1.6071l-1.9643-1.4286-0.71428-1.9643-1.0714,0.71429-0.17857,1.9643,1.7857,2.1428,2.5,2.1429,2.5,1.25,3.2143,1.0714,2.1429,1.25,2.1428-0.89286,3.5714-1.7857,3.0357-0.71429,3.75-1.0714,2.3214-3.0357,3.2143-2.6786,3.3929-1.6072,2.1428-1.7857-0.17857-2.1429-0.89286-2.3214-0.17857-1.7857,2.1429-2.1429,4.2857-0.89285h3.3929l1.4286,1.4286,1.25,3.0357v2.8571,3.0357l-1.6071,1.4286-1.25,2.5,0.17857,3.5714,1.7857,1.25,3.2143,0.71428,2.1429,2.8572,1.9643,3.2143,0.53572-0.71428-0.53572-4.1072-2.5-3.2143-3.75-1.0714v-2.8571l2.3214-3.0357s1.7857-0.35714,1.9643-1.0714c0.17857-0.71428,0.17857-3.5714,0.17857-3.5714l-0.89286-3.9286-2.6786-2.6786-2.6786-3.2143-0.89286-1.4286h-2.1428s-0.53572,1.25-1.4286,1.25c-0.89285,0-2.6786-1.25-2.6786-1.25l-1.6071-1.0714-0.53571-2.5,1.4286-3.75,2.3214-3.2143,2.1428-2.6786,3.0357-1.25,0.17857-4.4643-0.17857-3.0357v-3.0357l0.17857-2.3214,1.7857-2.3214,1.4286-1.4286,2.1429-0.35715,3.2143-0.53571,2.3214-2.5,1.7857-1.0714,1.25,2.1429-1.9643,2.3214-0.89285,1.4286-1.0714,4.4643-1.25,2.5,1.25,1.7857,2.6786,2.1429h2.8571l1.4286,2.1428,2.3214,2.5,1.7857,0.35715-1.4286-2.1429v-2.5s-1.25-1.25-1.9643-1.6071c-0.71429-0.35715-3.5714-2.8572-3.5714-2.8572l-1.25-3.5714-0.17857-1.4286s1.9643-0.71428,2.6786-0.71428c0.71429,0,3.2143,0.89285,3.2143,0.89285l0.89285,1.7857,1.6072,0.17857,1.25-0.71429-0.35715-1.9643,0.17858-1.9643,1.4286-0.35714,1.6071,0.71429,1.7857,1.4286,1.25,1.0714,0.89286,1.7857-0.35714,1.7857-2.3214,2.5-3.0357,1.25,1.0714,1.4286,2.6786,2.1428,0.35714,2.8572,0.17857,3.3928-0.71429,2.6786-2.5,1.4286-2.6786,1.4286-3.5714,1.7857-2.1428,2.1429,0.35714,2.6786,1.4286,2.5,1.25,2.5,1.6071,1.0714h3.3929,2.5l1.7857,1.6071,0.53571,3.0357,0.17857,3.3928v2.8572l-1.9643,3.2143-1.7857,2.5h-2.6786l-0.71429,0.53572,0.53572,1.9643,0.71428,1.7857-0.53571,2.5-0.89286,1.25,2.3214,3.3928,0.53572,1.7857,0.35714,1.7857-1.25,1.7857-1.0714,1.25,0.89286,2.1428-0.17857,2.5-1.6072,1.6072,1.6072,1.7857,2.1428,1.9643,1.6072,1.4286-0.17858,3.3928-1.4286,2.3214-0.17857,2.6786,2.3214,2.1429,4.6429,0.89286,0.89285,1.4286-1.4286,2.1429-0.53571,3.3928-0.89286,2.3214-2.6786,1.4286s-0.89286,0.53572-1.6071,1.0714c-0.71429,0.53572-1.7857,2.8572-1.7857,2.8572l1.9643,1.7857,0.17857,2.3214-1.4286,2.1429-1.25,2.5-2.6786,2.3214-2.8572,2.8572-0.89285-1.7857-1.6072-2.1428-1.7857-1.0714-1.9643,0.71428-1.9643-0.71428-0.71429-1.6072-1.25-1.25-2.5-0.89285-2.1428-0.89286-0.71429-1.6071-0.89286-1.7857-1.4286-1.4286-2.8571-0.17857-2.5,1.4286-2.5,1.0714-2.6786,0.17857-4.1072-1.6071-3.5714-0.35714-2.1429-0.17858-0.89286-1.9643-1.0714-2.3214v-1.4286l-3.3928-0.71429-2.3214-0.53571-0.89286-2.5-0.71429-2.3214s1.4286-0.17857-1.0714-0.35714-5.5357-1.0714-5.5357-1.0714l-1.4286-0.53572-3.2143-2.5-2.5-1.6071-2.8572-1.0714-3.2143-1.25-1.25-0.89285-0.17857-2.1429-2.8572-3.9286,0.17857-6.7857-1.25-1.7857-2.3214-2.8571-1.0714-2.1429-0.53572-0.53572-1.0714,1.25-0.53571,0.71429h-1.4286l-2.6786,0.89286-1.25,0.35714-1.6072-0.35714-2.1428-2.3214-1.7857-1.6071,0.53572-0.89286,1.4286-1.6071-0.35714-1.7857-2.5-2.3214-3.0357-1.4286-4.2857,0.35714-3.0357-1.25-2.6786-0.89285-3.3929-4.2857,2.3214-2.5,2.5-3.75,0.17857-5.3571,0.35715-1.4286,3.75-1.0714,2.6786-2.5,1.4286-1.4286h3.75,3.3929l3.9286,0.53571,1.7857-1.25,3.5714-1.6071,3.3929-0.53571,2.5-1.25,2.3214-1.25,0.35714-2.8572-2.1429-2.3214-0.71428-1.25,0.53571-1.6071,2.3214-1.4286,0.35714-1.25,1.92-2.87z",
  "city_population": 448917,
  "fed_okrug": "Уральский федеральный округ",
  "country_population": 87409,
  "area": 769250,
  "city_natural_increase": 4914,
  "city_migration_increase": -10581,
  "country_natural_increase": 1177,
  "country_migration_increase": -1391,
  "average_nominal_wage": 77272,
  "average_consumer_rate": 29580,
  "average_annual_buzy": 375.8,
  "per_capita_income": 66869,
  "kladr": "8900000000000"
}, {
  "id": 373,
  "name": "Тюменская область",
  "path": "m329.02,389.7,2.0536,0.80357,2.1428,1.1607,1.6072,1.3393,1.6071,1.5179,1.7857,0.71428,2.3214,0.17858,0.89286-1.0714,1.6071-1.875,0.53572-2.3214,0.625-2.1429,2.2321-1.7857,1.875-0.44643,1.25-2.5,1.6964-1.0714,2.9464,0.26786,1.6071-1.6072s0.625-2.3214,0.53571-2.6786c-0.0893-0.35714-0.80357-2.5893-0.80357-2.5893l-0.89285-1.875-0.625-3.3036-0.71429-2.2322v-1.7857l1.5179-1.9643,2.2321-2.5,1.4286-1.4286,3.125-0.26786,0.35714,1.4286-0.89285,1.6071-1.6964,1.6964-0.17857,1.25,2.5,0.35714,4.0178,0.35714,1.9643,1.6072,3.0357,1.7857,1.5179-1.25,2.9464-0.17857,2.1429,1.4286,3.3928,1.0714s2.5-0.98214,2.9464-1.1607c0.44643-0.17857,3.5714-0.44642,3.5714-0.44642l0.89286-0.98215-0.53572-1.0714-1.6964-1.25-2.9464-2.2321-1.0714-1.4286s-1.6964-0.44643-2.3214-0.44643-2.6786-0.80357-2.6786-0.80357l-0.17857-2.6786-0.26786-2.4107-1.3393-1.3393-0.44642-2.2321-0.53572-3.5714-0.35714-0.89286-2.4107-2.7679-1.1607-0.71428s-2.6786-0.26786-2.9464-0.26786h-5.0893l-0.98215-0.26786s-0.625-1.5178-0.625-1.875c0-0.35714-0.98214-1.5178-0.98214-1.5178l-1.875-0.35715-1.25,1.25-2.4107,1.875-2.1429,0.89286h-3.0357l-4.6428,0.0893-2.9464,0.26785s-1.4286,0.53572-1.7857,0.625c-0.35714,0.0893-4.375,0.0893-4.375,0.0893l-3.0357-0.0893-1.4286,0.35715-0.89286,1.5178-0.53571,2.3214-0.89286,1.3393-2.3214,0.71428-1.6071,0.53572-1.5179,0.35714-1.7857-0.17857-1.3393-0.625-1.4286,0.17857c-0.35714,0.17857-1.6964,1.0714-1.6964,1.0714l-1.1607,2.1429-0.35715,2.4107-1.6071,2.3214-2.1429,2.5893-0.98214,1.5179,0.26786,1.25,0.71428,1.3393,1.5179,1.25,1.25,1.6071,1.6964,1.875,1.0714,1.6964s3.0357,0.98214,3.0357,1.5179c0,0.53571,1.6964,2.9464,1.6964,2.9464l0.625,1.875,1.6071,1.4286,1.875,0.71428,1.0714,0.80357,1.4286,2.3214,1.0714,1.4286v1.6072z",
  "city_population": 2944840,
  "fed_okrug": "Уральский федеральный округ",
  "country_population": 717085,
  "area": 160122,
  "city_natural_increase": 6615,
  "city_migration_increase": 18308,
  "country_natural_increase": 846,
  "country_migration_increase": -375,
  "average_nominal_wage": 35869,
  "average_consumer_rate": 24916,
  "average_annual_buzy": 682.8,
  "per_capita_income": 28950,
  "kladr": "7200000000000"
}, {
  "id": 374,
  "name": "Челябинская область",
  "path": "m272.18,347.66,1.7678-0.88388,2.7779,0.50507,2.3991,2.1466,2.3991,1.7678,3.0305,1.894,2.9042,0,1.5152,1.6415,1.6415,2.3991,0.75761,1.894-0.63135,3.1567,0,2.7779-0.88388,1.389-1.7678,0.63135-1.6415,1.1364-0.75762,1.2627-2.0203,0.63135-1.894,1.5152,0,1.1364,1.5152,1.5152,2.0203,2.0203,1.1364,2.3991-0.37881,2.7779-0.75762,1.7678-2.3991-0.63135-2.6516-0.50507-3.283-0.37881-2.0203-0.50508-1.5152-1.7678-2.0203-1.7678-1.1364-1.1364-1.1364,0.50508-1.5152,1.1364-0.88388,1.0102,0,1.894,1.6415,1.2627-0.37881,0.75761-2.2728,0.63135v1.0102c0,0.50508,0.75761,2.0203,0.75761,2.0203l2.0203,1.7678,0.12627,1.894-1.5152,0.63134-1.5152-1.5152-1.389-1.2627-2.2728-0.63134-3.283,0.12627-1.5152,0.25253-0.63134,1.2627,1.0102,1.389-0.37881,1.894-1.0102,1.6415-4.5457,0.25254-1.6415-0.88389-1.6415-0.63134,0.50507-2.0203,1.6415-0.88388-0.75761-1.7678-2.0203-2.3991-1.6415-1.0102-1.894,0.12627-1.389-0.63135,0.63134-2.7779,1.7678-2.6516,4.4194-4.1669,3.7881-4.672,1.2627-2.9042,1.389-0.88389,2.5254,0.25254,2.0203,1.0102h2.0203l1.894-2.2728,2.2728-1.894,0.50508-1.389-1.5152-1.2627-2.1466,0.50507h-3.0304l-2.7779-0.88388h-1.5152l-0.88388-1.894-1.389-0.50507-1.7678,0.63134-1.0102-0.37881-0.88389-0.63134-0.63134-1.894-0.12627-1.6415,3.6618-5.6821,0.75762-0.63135,1.7678,0.37881,1.7678,0.88388,0.63134,1.1364-0.3788,0.75762-1.2627,1.1364v1.1364l-0.12627,0.12627,0.75761,0.63135,2.6516,0.12627h2.2728l1.5152,1.0102,1.2627,1.1364,1.1364-0.63135,0.50507-0.75761,2.0203,0.12627,1.7678,0.37881,1.1364-1.2627-0.37881-1.0102-0.75761-0.88388,0.25253-1.5152,1.5152-1.0102,0.63135-1.1364z",
  "city_population": 2894599,
  "fed_okrug": "Уральский федеральный округ",
  "country_population": 608967,
  "area": 88529,
  "city_natural_increase": 700,
  "city_migration_increase": 3746,
  "country_natural_increase": -624,
  "country_migration_increase": -380,
  "average_nominal_wage": 29642,
  "average_consumer_rate": 16241,
  "average_annual_buzy": 1647.6,
  "per_capita_income": 24584,
  "kladr": "7400000000000"
}, {
  "id": 376,
  "name": "Республика Алтай",
  "path": "m422.32,478.89-0.44643,2.1428s-0.17857,1.875,0,2.5893c0.17857,0.71429,1.1607,2.3214,1.1607,2.3214l3.3036,0.89286s0.98215,1.1607,1.0714,1.6071c0.0893,0.44643,0.0893,3.3036,0.0893,3.3036s0.17857,0.89286,0.53571,1.6071c0.35715,0.71429,1.25,1.875,1.7857,2.2322,0.53571,0.35714,1.6071,1.25,2.4107,1.3393,0.80357,0.0893,3.125,0.0893,3.5714,0.0893,0.44643,0,4.0179,0.0893,4.0179,0.0893s1.0714,0.53572,1.6071,0.89286c0.53571,0.35714,1.4286,1.25,1.7857,1.875,0.35715,0.625,1.5179,1.6964,2.0536,1.9643,0.53571,0.26785,1.1607,0.80357,1.7857,1.1607,0.625,0.35714,1.6964,0.71429,2.4107,0.80357,0.71429,0.0893,2.9464-0.44643,3.3929-0.71428,0.44643-0.26786,2.3214-0.89286,3.4821-0.89286s4.7322-0.35714,5-0.44643c0.26786-0.0893,3.5714-1.3393,4.1964-1.3393s1.4286-0.89285,1.6071-1.25c0.17858-0.35714,0.625-1.9643,0.17858-2.7678-0.44643-0.80357-0.80358-1.0714-1.4286-1.4286-0.625-0.35715-1.4286-1.25-1.25-1.7857,0.17858-0.53571,1.9643-1.1607,2.4107-1.1607,0.44643,0,2.5,1.0714,2.5,0.26785,0-0.80357-1.6964-2.2321-1.6964-2.2321s-0.98214-1.3393-1.25-1.7857c-0.26786-0.44643-1.875-1.9643-1.875-1.9643s-2.2321-2.7679-2.0536-4.1071c0.17857-1.3393-0.0893-3.3929-0.0893-3.3929s-0.625-1.3393-0.71428-1.6964c-0.0893-0.35714-1.3393-0.17857-1.3393-0.17857l-1.5179,1.5179s-1.4286-0.26786-1.5178-0.80357c-0.0893-0.53572-0.71429-2.5893-0.71429-2.5893s-0.35714-1.7857-0.44643-2.1429c-0.0893-0.35714-0.17857-1.9643-0.17857-1.9643l1.6964-1.3393,2.8571-1.3393,0.35715-1.1607-1.3393-1.6071-0.80357-0.625-2.1429-0.53571-1.9643,0.98214s-1.0714-0.625-1.4286-0.80357c-0.35714-0.17857-1.0714-0.89286-1.0714-0.89286l-0.89286-1.7857s0-1.0714-0.71429-0.89286c-0.71428,0.17857-0.89285,0.71428-0.89285,0.71428s-1.1607,1.1607-1.1607,1.5179c0,0.35714-0.625,1.4286-0.625,1.4286l-0.98214,1.0714s-1.6071,0.44643-1.9643,0.44643h-3.0357c-0.35714,0-1.1607,0.71429-1.5179,1.0714-0.35714,0.35714-1.1607,1.9643-1.1607,1.9643l-1.5179,1.0714-0.98214,0.625-2.3214,0.71429h-2.3214l-4.1071,0.71428-4.1071,0.625-1.0714,0.625-0.0893,0.98215s0.0893,0.89285,0.53572,0.98214c0.44642,0.0893,1.6071,0.80357,1.6071,0.80357l0.44643,0.89286-0.0893,0.89286-1.875,0.625z",
  "city_population": 63410,
  "fed_okrug": "Сибирский федеральный округ",
  "country_population": 153681,
  "area": 92903,
  "city_natural_increase": 505,
  "city_migration_increase": 47,
  "country_natural_increase": 1173,
  "country_migration_increase": -267,
  "average_nominal_wage": 22903,
  "average_consumer_rate": 10564,
  "average_annual_buzy": 90.7,
  "per_capita_income": 18267,
  "kladr": "0400000000000"
}, {
  "id": 377,
  "name": "Республика Бурятия",
  "path": "m543.39,476.39s1.6072,0.98214,2.3214,1.1607c0.71429,0.17857,2.8572,1.25,3.3929,1.3393,0.53571,0.0893,1.7857,0.71428,2.5,0.98214,0.71429,0.26786,1.875,0.98214,2.5893,1.3393,0.71428,0.35714,2.2321,0.53571,3.2143,0.625,0.98214,0.0893,2.8571,0.89285,3.4821,1.0714,0.625,0.17858,2.1429,1.0714,2.9464,1.1607,0.80357,0.0893,1.5179,0,2.7679,0.625s2.7679,1.3393,3.125,1.5179c0.35714,0.17857,0.71429,0.26785,0.80357,0.98214,0.0893,0.71428,0,2.6786,0.0893,3.0357,0.0893,0.35715,0.26785,1.6964,0.625,2.0536,0.35714,0.35715,1.6071,1.9643,2.5893,2.5893,0.98215,0.625,1.4286,1.6964,1.9643,2.1429,0.53571,0.44643,2.3214,1.875,2.8571,1.9643,0.53572,0.0893,2.3214,0.625,2.7679,0.625,0.44643,0,5.0893,0.44643,5.0893,0.44643s1.7857-0.80357,2.7679-1.25c0.98214-0.44643,4.0179-1.25,4.4643-1.5179,0.44643-0.26785,1.5178-0.98214,2.6786-1.0714,1.1607-0.0893,4.1964-0.0893,5.0893-0.0893,0.89286,0,4.1072,0.0893,4.1072,0.0893s2.3214-0.0893,3.125,0.44642c0.80357,0.53572,1.6071,1.6072,1.9643,2.1429,0.35715,0.53572,0.625,1.4286,1.0714,1.6071,0.44643,0.17858,1.4286,0.35715,1.875,0.35715,0.44643,0,2.1429-0.26786,2.5-0.35715,0.35714-0.0893,2.2321-0.44642,2.2321-0.44642l0.0893-2.6786s-0.0893-1.7857,0.53571-2.0536c0.625-0.26785,4.4643-1.5178,4.8214-1.6964,0.35715-0.17857,1.25-1.6071,1.25-1.6071s-2.5-0.625-3.3036-0.625c-0.80357,0-1.25-1.4286-1.25-1.4286l1.0714-1.5179,0.17857-1.9643,0.98214-1.0714,0.80358-1.3393s-0.625-0.98214-0.80358-1.3393c-0.17857-0.35715-0.0893-1.4286-0.0893-1.4286l2.2321-1.1607,3.125-0.35714,2.4107-1.1607,3.4821-2.4107,1.7857-0.625s1.4286,0.0893,1.875,0.26786c0.44643,0.17857,2.4107,0.53571,2.5893,0.17857,0.17857-0.35714,1.6071-1.9643,2.0536-2.3214,0.44643-0.35714,2.6786-2.1429,2.6786-2.1429l1.4286-1.1607s0.98215-1.25,1.4286-1.5179c0.44643-0.26786,1.875-1.0714,2.4107-1.0714,0.53571,0,0.98214,0,1.3393-0.26785,0.35715-0.26786,1.1607-1.25,1.3393-1.6072,0.17857-0.35714,1.0714-0.80357,1.6071-0.89285,0.53572-0.0893,5-1.3393,5-1.3393l2.6786-1.5179s1.875-1.5178,2.0536-1.875c0.17857-0.35714,1.6071-2.8571,1.6071-2.8571l0.98214-1.875s-0.26786-1.4286-0.71428-1.7857c-0.44643-0.35715-2.1429-1.6072-2.1429-1.6072l-2.5-1.25s-1.25-0.80357-1.1607-1.6071c0.0893-0.80357,7.5-5.625,7.5-5.625s0.98215-1.6964,1.0714-2.0536c0.0893-0.35714,0.89286-1.9643,1.25-2.3214,0.35715-0.35714,2.5-2.0536,2.5-2.0536s1.4286-0.625,1.875-0.71429c0.44643-0.0893,3.5714-1.5178,3.5714-1.5178l1.25-0.98215s0.44643-2.0536,0.44643-2.5893c0-0.53572-0.80357-3.8393-0.80357-3.8393s-1.0714-0.53571-1.4286-0.89285c-0.35715-0.35715-1.25-0.80358-2.1429-0.80358-0.89286,0-2.6786,0-3.125-0.625-0.44643-0.625-1.3393-1.25-1.6964-1.875-0.35714-0.625-1.1607-1.7857-1.25-2.2321-0.0893-0.44643-0.80357-2.4107-0.98214-2.7679-0.17857-0.35714-1.0714-2.3214-1.0714-2.3214l-2.0536-3.5714-1.0714-2.7679,0.26786-2.0536,1.0714-0.625,0.80357-1.25,1.4286-1.875,0.625-0.98214-2.3214-1.25s-1.875,0.44642-2.2321,0.71428c-0.35715,0.26786-0.98215,1.3393-0.98215,1.3393s0.35715,0.625,0,0.80357c-0.35714,0.17857-2.3214,0.44643-2.3214,0.44643l-1.25,0.89285-0.71429,1.9643v1.6071l-0.98214,0.98215-2.0536,1.0714-1.3393,0.98215-1.1607,1.3393s-1.6964,0.0893-2.0536,0.0893c-0.35714,0-2.0536-0.625-2.0536-0.625l-2.6786,0.17857-2.3214-0.0893-1.9643-1.4286-1.4286,0.26786-2.0536-0.35714s-0.80357-0.71429-1.1607-0.71429c-0.35714,0-2.1429,0.625-2.1429,0.625l-1.5178,1.3393-0.98215,1.0714-2.6786,0.26785-1.9643-0.0893-2.3214,0.44643-2.2322,1.1607-3.3928,1.7857-2.3214,0.98215-1.3393,0.89285-0.89285,1.1607s-0.0893,0.35714,0.0893,0.71428c0.17857,0.35715,0.98214,1.4286,0.98214,1.4286l1.6072,0.80357,0.98214,0.89285,0.83,0.91,0.0893,1.1607-1.6071,2.1428-0.35714,2.2322-0.35715,1.875v2.6786l0.80358,1.6071,1.1607,1.4286s0.26786-0.44643,0.71429-0.80357c0.44642-0.35714,1.1607-2.3214,1.1607-2.3214v-2.0536l0.0893-2.0536,0.98214-1.875,1.6964-1.25,1.1607-0.17857,0.89286,1.1607s-0.0893,1.25-0.26786,1.6964c-0.17857,0.44643-0.53571,0.98214-0.35714,1.3393,0.17857,0.35714,0.89286,1.4286,0.89286,1.4286l-0.17858,2.7678s-0.35714,2.3214-0.35714,2.6786c0,0.35714-0.26786,2.5893-0.26786,3.0357v2.5893c0,0.89285,0,1.5178,0.0893,2.1428s0.0893,1.6964-0.0893,2.1429c-0.17857,0.44643-0.44642,1.25-0.71428,1.9643-0.26786,0.71428-0.35714,1.25-0.44643,1.9643-0.0893,0.71429-1.0714,1.6964-1.0714,1.6964s-0.71428,0.26786-0.98214-0.625-1.6071-0.98214-1.6071-0.98214-0.71429,0.44642-1.0714,0.98214c-0.35715,0.53571-0.89286,1.25-0.35715,1.6964,0.53572,0.44643,1.5179,1.6071,1.5179,1.6071s0.625,0.35714,0.26786,1.1607c-0.35714,0.80358-1.1607,1.0714-1.6964,1.4286-0.53571,0.35714-1.5179,0.89285-1.6964,1.25-0.17857,0.35714-0.71428,1.4286-0.71428,1.7857,0,0.35714-0.44643,2.0536-0.44643,2.0536l-1.3393,0.98214-1.875,1.3393s-2.2321,0.71429-2.6786,0.98214c-0.44643,0.26786-2.5,1.4286-2.8571,1.7857-0.35715,0.35714-0.53572,1.25-1.4286,1.6071-0.89286,0.35714-3.125,1.3393-3.125,1.3393l-0.98215,0.26785s-0.35714,0.80357-0.35714,1.1607c0,0.35714-0.26786,2.2321-0.26786,2.7678,0,0.53572-0.26785,0.98215-0.625,1.6964-0.35714,0.71429-0.98214,1.6964-1.6071,1.7857-0.625,0.0893-2.7679,0.71428-3.2143,0.89285-0.44642,0.17858-2.5,0.89286-3.0357,0.98215-0.53571,0.0893-2.8571,1.0714-2.8571,1.0714l-0.71429,0.80357-1.5179,1.1607-2.0536,0.71429-1.4286,0.80357-1.6964-1.0714-0.35714-0.98214-0.44643-1.25s-0.35714-0.35715-1.25-0.26786c-0.89286,0.0893-2.0536,0.44643-2.0536,0.44643s-1.3393-1.4286-1.6071-1.875c-0.26786-0.44643-1.875-3.125-1.875-3.125l-1.54-1.99-1.34-1.61s-1.1607-0.71429-1.6964-0.71429c-0.53571,0-2.6786-0.17857-3.0357-0.17857-0.35715,0-1.6072-0.89285-1.7857-1.1607-0.17857-0.26786-3.4821-4.2857-3.4821-4.2857l-1.875-0.89285-2.8571-1.9643-1.9643-2.2321-1.0714-1.6964-0.89286-0.625s-0.89285-0.26786-1.25,0.0893c-0.35714,0.35714-0.80357,0.53571-1.3393,0.89285-0.53572,0.35715-1.875,1.4286-1.875,1.4286l-1.3393,1.25-1.9643,1.1607-1.4286,0.89286s-0.89286,1.0714-0.98215,1.6071c-0.0893,0.53571-0.26785,1.1607-0.26785,2.0536,0,0.89286-0.35715,3.3036-0.35715,3.3036z",
  "city_population": 579310,
  "fed_okrug": "Сибирский федеральный округ",
  "country_population": 404600,
  "area": 351334,
  "city_natural_increase": 3906,
  "city_migration_increase": -945,
  "country_natural_increase": 1889,
  "country_migration_increase": -1061,
  "average_nominal_wage": 28386,
  "average_consumer_rate": 18258,
  "average_annual_buzy": 412.1,
  "per_capita_income": 25486,
  "kladr": "0300000000000"
}, {
  "id": 378,
  "name": "Республика Тыва",
  "path": "m461.96,477.02,0.26786-1.6964s0.89286-0.625,1.6071-0.625c0.71429,0,1.6964,0.71428,2.4107,0.89286,0.71428,0.17857,2.7678,0.71428,3.0357,0.71428,0.26786,0,1.0714-0.80357,1.3393-1.25,0.26785-0.44643,1.9643-2.6786,1.9643-2.6786s0-1.25,0.625-1.6071c0.625-0.35715,1.875-0.35715,2.3214-0.35715,0.44643,0,1.6071-0.17857,2.3214,0.26786,0.71429,0.44643,1.1607,3.0357,1.1607,3.0357s0.89286,0.89285,1.1607,0.89285c0.26786,0,2.1429-0.80357,2.1429-0.80357s1.4286,0.17857,1.7857,0.44643c0.35714,0.26786,3.0357,0.89286,3.0357,0.89286s1.6964,1.6071,2.2322,1.6071c0.53571,0,1.6964,0.26786,2.6786-0.0893,0.98214-0.35714,2.8571-0.80357,3.3929-1.25,0.53571-0.44642,5.5357-1.9643,5.9821-2.5,0.44643-0.53571,7.0536-5.9821,7.0536-5.9821l2.1429-2.8571s-0.17857-1.875-0.17857-2.9464,1.0714-2.3214,1.4286-2.5893c0.35714-0.26785,2.8571,0.0893,3.3036,0.17858,0.44643,0.0893,4.375,0.89285,4.7321,0.80357,0.35714-0.0893,4.2857-0.44643,4.2857-0.44643l2.4107-2.2321s1.5179-0.35715,2.4107,0.0893c0.89286,0.44643,3.6607,2.5,4.1964,2.7679,0.53572,0.26786,3.75,2.3214,3.75,2.3214l1.6072,1.5178s1.25,0.71429,1.7857,0.44643c0.53571-0.26785,2.3214-0.89285,2.3214-0.89285l1.6071,0.53571,0.35714,1.25s0.53572,0.89286,0.53572,1.25-0.89286,1.6071-0.89286,1.6071-0.71428,0.53572-0.80357,1.1607c-0.0893,0.625-0.26786,4.1071-0.26786,4.1071s-0.0893,2.3214-0.0893,2.7679c0,0.44643-0.71429,2.1428-0.71429,2.1428l-1.4286,2.4107s-1.5179,1.3393-1.875,1.875c-0.35714,0.53571-2.2321,1.3393-2.4107,1.6964-0.17858,0.35714-0.71429,1.875-0.71429,1.875s-0.71429,1.875-0.71429,2.4107c0,0.53572-0.0893,3.3929-0.0893,3.9286,0,0.53572,0.53571,2.5,1.0714,3.2143,0.53571,0.71428,1.25,1.6071,1.25,2.0536,0,0.44643-0.80357,2.3214-1.1607,2.7679-0.35714,0.44643-4.8214,4.1964-4.8214,4.1964l-2.0536,1.25-2.1428,0.17857s-1.7857-0.98215-2.1429-0.89286c-0.35714,0.0893-2.3214,0.17857-2.6786,0.17857-0.35715,0-1.7857-0.89286-1.7857-0.89286s-1.6964-0.35714-2.1428-0.625c-0.44643-0.26785-1.7857-1.1607-1.7857-1.1607s-2.7679-0.26786-3.2143-0.26786c-0.44643,0-2.8572-0.17857-3.2143-0.53571l-2.0536-2.0536s-0.71429-1.4286-0.80357-1.9643c-0.0893-0.53571-0.17857-2.5-0.17857-2.5s-0.80358-0.80357-1.3393-1.25c-0.53571-0.44643-2.1429-0.89286-2.9464-0.89286-0.80357,0-3.9286,0.17858-3.9286,0.17858s-1.9643,0.53571-2.2321,0.625c-0.26786,0.0893-1.25,0.71428-1.875,0.80357-0.625,0.0893-2.0536,0.0893-1.9643-0.80357,0.0893-0.89286,1.25-1.6964,1.3393-2.0536,0.0893-0.35714-0.0893-1.0714-0.71429-1.3393-0.625-0.26786-2.1429-0.17857-3.0357,0.0893-0.89286,0.26786-2.3214,0.80358-2.8572,0.89286-0.53571,0.0893-3.3928,0.71429-3.3928,0.71429s-2.1429,0.89285-2.6786,1.0714c-0.53572,0.17857-3.8393,1.1607-3.8393,1.1607l-3.0357,1.5179-2.4107,1.1607-2.5893-0.26786-2.1429-0.98214-1.5179-0.71428-1.25-1.25c0-0.44643,0.35714-0.98215,0.35714-0.98215l2.4107-0.44643,1.7857,0.53572s1.25-0.35714,0.17857-1.0714c-1.0714-0.71429-4.4643-5.0893-4.4643-5.0893l-1.48-2.44s-1.0714-1.4286-1.0714-1.7857v-2.5893z",
  "city_population": 172125,
  "fed_okrug": "Сибирский федеральный округ",
  "country_population": 146579,
  "area": 168604,
  "city_natural_increase": 2445,
  "city_migration_increase": -519,
  "country_natural_increase": 1795,
  "country_migration_increase": -1861,
  "average_nominal_wage": 28322,
  "average_consumer_rate": 7441,
  "average_annual_buzy": 101.5,
  "per_capita_income": 15255,
  "kladr": "1700000000000"
}, {
  "id": 379,
  "name": "Республика Хакасия",
  "path": "m470.27,432.11c0.53572,0.35715,1.9643,1.875,1.9643,1.875l1.3393,1.6072s0.26785,0.625,1.1607,0.80357c0.89286,0.17857,2.0536,0.17857,2.0536,0.17857s0.35714-0.35714,0.80357-0.80357,0.625-0.98214,0.98215-1.25c0.35714-0.26786,0.89285-0.89286,1.3393-0.80357,0.44643,0.0893,0.71429,0.26785,1.3393,0.71428,0.625,0.44643,1.3393,1.25,2.2321,1.25,0.89286,0,2.5,0.80357,2.5,0.80357s0.44643,1.875,0.625,2.3214c0.17857,0.44643,0.53571,2.9464,0.53571,2.9464s0.35715,1.5179,0.71429,2.4107c0.35714,0.89285,0.98214,2.0536,1.0714,2.4107,0.0893,0.35714-0.0893,3.125-0.17857,3.3929-0.0893,0.26785-0.80357,1.875-0.89286,2.2321-0.0893,0.35714,0,2.5893,0,2.5893l1.5179,1.5179,0.625,1.875s-1.25,1.4286-1.4286,1.6964c-0.17858,0.26786-2.2322,1.3393-2.5893,1.875-0.35714,0.53571-1.4286,3.0357-1.4286,3.0357s-1.6071,1.9643-2.1429,2.2322c-0.53571,0.26785-2.8571,1.0714-3.125,1.5178-0.26786,0.44643-1.6964,1.6964-1.6964,1.6964l-2.7678,0.0893s-1.3393,0.17857-1.6072,0.625c-0.26785,0.44643-0.53571,1.4286-1.0714,1.875-0.53571,0.44643-1.0714,1.25-1.1607,1.6071-0.0893,0.35714-0.89286,1.0714-0.89286,1.0714s0.0893,0.71429-1.0714,0.625c-1.1607-0.0893-2.9464-0.35714-2.9464-0.35714l-1.7857-1.1607-1.6071,0.44643-0.625,0.80357-0.26786,0.89286-2.5,1.0714s-0.625,0.89286-1.1607,0.35714c-0.53572-0.53571-1.25-2.3214-1.25-2.3214l-0.625-2.5893v-1.5179s0.17857-1.0714,0.53571-1.25c0.35714-0.17857,2.5-1.6071,2.5-1.6071s1.3393-0.98215,1.6964-1.0714c0.35714-0.0893,2.1429-0.44643,2.1429-0.44643l1.9643-1.0714,1.5179-2.0536,1.3393-1.0714-0.44643-1.6071s-1.25-1.25-1.4286-1.6071c-0.17858-0.35715-0.44643-1.25-0.44643-1.25l1.6071-2.2322,0.0893-1.875s-1.0714-1.1607-1.1607-1.5178c-0.0893-0.35715-0.0893-1.25-0.0893-1.25l2.5893-1.5179,1.0714-1.875,1.1607-1.9643,0.53572-1.6964-3.5714-1.1607s-0.89286-1.25-0.71429-1.7857c0.17858-0.53572,1.7857-2.4107,1.7857-2.4107s0.89286-1.875,0.89286-2.3214c0-0.44642-1.0714-2.8571-1.0714-2.8571s0-0.71428,0.26785-1.1607c0.26786-0.44643,1.25-0.98215,1.25-0.98215z",
  "city_population": 371452,
  "fed_okrug": "Сибирский федеральный округ",
  "country_population": 166402,
  "area": 61569,
  "city_natural_increase": 601,
  "city_migration_increase": 1773,
  "country_natural_increase": 71,
  "country_migration_increase": -1460,
  "average_nominal_wage": 29935,
  "average_consumer_rate": 14758,
  "average_annual_buzy": 224,
  "per_capita_income": 20784,
  "kladr": "1900000000000"
}, {
  "id": 380,
  "name": "Алтайский край",
  "path": "m381.25,435.14,1.7857,5,1.7857,5.1786,1.6071,6.7857,0.89286,8.5714,0.35714,8.2143,0.35714,2.8571,2.3214-0.53571,1.7857-0.53572,0.89285-0.53571,0.17857-1.9643,1.25-1.6071,1.25-0.35714,1.7857,0.53571,0.89286,1.9643,0.89285,2.8571,2.3214,2.8571,1.9643,1.6071,4.6428,0,3.3929-0.35714,2.5-0.89286,2.3214,0,3.3929,1.4286,1.0714,1.9643,2.3214,0.53572,2.3214-0.53572-0.17857-1.4286-1.6071-1.0714-1.0714-0.89286,0.35714-1.6071,0.71429-0.35714,2.5-0.35714,4.4643-0.71429,3.75-0.17857,2.6786-0.71429,2.3214-1.9643,1.0714-1.9643s0.53572-0.71428,1.25-0.71428c0.71429,0,3.3929-0.17858,3.3929-0.17858l1.9643-0.17857,1.0714-1.7857s0.53572-2.1429,1.25-2.5c0.71429-0.35714,0.89286-2.3214,0.89286-2.3214l0.71429-2.1429-0.35715-1.0714-0.71428-1.0714,0.71428-0.89286,1.25-0.53571-0.17857-1.0714-1.4286-1.6072-1.0714-1.0714c-0.17857-0.71429-0.89286-2.8572-0.89286-2.8572l-1.7857-1.7857-0.17857-0.89286-0.53572-2.1429-1.6071-1.4286-2.5-1.9643-1.74-1.79s-1.6072,1.0714-2.3214,1.4286c-0.71429,0.35715-1.7857,0.71429-1.7857,0.71429l-2.5,0.17857-2.5-0.35714-3.0357-0.17857-4.8214,0.71428-2.5,1.6072-1.6071,1.7857-1.0714,0.71429-0.89286,0.35714-1.4286-1.25-0.35714-0.89286,0.35714-0.89286,0.17857-1.7857-0.17857-1.4286-2.3214-1.6071-1.9643-1.25-1.0714-1.25-0.17857-0.89286-1.9643-0.17857-4.2857,0.17857-1.25,1.25-2.1429,0.53571-3.75-0.53571-4.2857,0.17857-2.6786,1.25h-2.5l-3.3929-0.17857z",
  "city_population": 1331678,
  "fed_okrug": "Сибирский федеральный округ",
  "country_population": 1034814,
  "area": 167996,
  "city_natural_increase": 278,
  "city_migration_increase": -582,
  "country_natural_increase": -3859,
  "country_migration_increase": -3875,
  "average_nominal_wage": 20090,
  "average_consumer_rate": 14496,
  "average_annual_buzy": 1066.6,
  "per_capita_income": 20989,
  "kladr": "2200000000000"
}, {
  "id": 381,
  "name": "Забайкальский край",
  "path": "m618.41,500.07s1.1364,1.1364,1.6415,1.5152c0.50508,0.3788,1.6415,1.6415,2.2728,1.894,0.63134,0.25254,2.6516,1.6415,2.6516,1.6415s2.9042,1.0102,3.4093,1.0102h5.5558c1.1364,0,3.283,0.75762,3.283,0.75762s0.88388,0.63134,2.0203-0.25254c1.1364-0.88389,2.3991-1.6415,2.3991-1.6415s0.75762,0.25254,1.6415,0.63135c0.88388,0.3788,1.5152,1.2627,2.1466,1.2627,0.63135,0,3.4093-1.7678,3.4093-1.7678s2.6516-2.2728,3.1567-2.7779c0.50507-0.50508,2.5254-0.88388,3.5355-1.2627,1.0102-0.37881,5.4296-0.50508,5.4296-0.50508s1.894-1.2627,2.2728-1.894c0.37881-0.63135,1.7678-3.4093,1.894-3.9143,0.12627-0.50508,2.7779-2.3991,3.4093-2.9042,0.63135-0.50508,4.9245-2.5254,5.177-3.0305,0.25253-0.50508,2.0203-1.5152,2.0203-1.5152l3.1567,1.2627,2.9042,1.2627s2.2728,0.25254,2.9042,0.25254c0.63135,0,2.2728-0.50508,2.7779-0.88388,0.50508-0.37881,3.1567-1.7678,3.1567-1.7678s3.283,0.25254,3.7881,0.50508c0.50508,0.25253,1.7678,0.88388,2.3991,1.1364,0.63135,0.25254,3.9144,1.389,3.9144,1.389s3.6618,0.3788,4.4194,0.25254c0.75762-0.12627,2.5254-1.7678,2.7779-2.3991,0.25254-0.63134,0.75762-2.3991,1.6415-2.9042,0.88388-0.50507,4.2932-1.5152,4.2932-1.5152s1.389-0.12627,1.5152-1.6415c0.12627-1.5152,0.37881-2.9042-0.25254-3.5355-0.63135-0.63134-1.389-0.88388-1.7678-1.7678-0.3788-0.88389,0.88389-8.9651,0.88389-8.9651l1.6415-3.7881,1.2627-4.2932s1.389-2.2728,1.2627-2.9042c-0.12627-0.63134-0.37881-3.9143-0.37881-3.9143l-1-2.41s-1.1364-0.88388-1.5152-1.389c-0.37881-0.50507-1.0102-0.37881-1.5152-1.0102-0.50508-0.63135-1.7678-1.1364-1.7678-1.7678,0-0.63134-0.25254-1.5152,0.37881-2.0203,0.63134-0.50508,3.0305-3.0305,3.7881-3.4093,0.75761-0.37881,4.5457-2.5254,4.9245-3.0305,0.37881-0.50507,1.389-1.6415,1.7678-2.1466,0.37881-0.50508,0.88388-0.50508,0.63135-1.6415-0.25254-1.1364-2.6516-3.5355-2.6516-3.5355s-0.63135-0.88389-1.5152-0.88389c-0.88389,0-3.1567-0.3788-3.1567-1.0102,0-0.63134-0.37881-1.2627-0.12627-2.0203,0.25254-0.75762,2.0203-2.2728,2.2728-2.9042,0.25254-0.63135,0.37881-1.894,0.37881-1.894l-2.3991-1.6415-2.6516,0.12627s-0.25254-0.25253-0.25254-0.88388c0-0.63134,0.63135-2.7779,0.88388-3.283,0.25254-0.50507,0.50508-1.5152,0.63135-2.1466,0.12627-0.63134-0.25254-1.7678-0.75761-2.3991-0.50508-0.63135-1.5152-1.389-1.5152-1.389s-1.1364-0.50508-1.6415,0.12627c-0.50508,0.63134-1.1364,1.5152-1.1364,1.5152s-1.1364,0.12627-1.6415-0.25254c-0.50508-0.37881-0.88388-4.1669-0.88388-4.1669s-0.88389-1.2627-1.6415-1.389c-0.75762-0.12627-1.6415-0.12627-2.1466,0.50508-0.50507,0.63134-1.0102,1.0102-1.7678,1.5152-0.75762,0.50508-1.2627,1.1364-1.894,0.75762-0.63134-0.37881-1.389-0.75762-1.2627-1.389,0.12627-0.63135,0.75761-1.6415,0.88388-2.1466,0.12627-0.50507-1.7678-2.1466-1.7678-2.1466l-3.283-0.12627-1.1364-1.1364c-0.12627-0.75761,0.25254-2.5254,0.25254-2.5254l-1.389-1.5152-2.7779-4.0406-1.2627-1.894-3.1567-0.3788-1.1364-2.0203-0.25254-2.9042-1.2627-0.3788h-1.2627l-1.6415,0.63134-1.6415-1.0102-3.0304-0.63135-1.894,0.75762-0.37881,1.0102-0.12627,1.894,0.37881,1.894-0.25254,1.5152-0.50507,2.0203,0.75761,2.0203,0.50508,1.389,1.7678,1.5152,0.88389,0.88388,0.25254,1.894s-0.25254,1.0102-0.75762,1.389c-0.50507,0.37881-3.0305,1.2627-3.0305,1.2627s-2.3991,0.63134-2.9042,0.75761c-0.50508,0.12627-3.4093,0.75762-3.4093,0.75762l-1.389,1.5152-0.25254,1.6415,0.75762,2.5254,1.7678,3.283,1.6415,3.7881,0.75762,2.9042,2.0203,2.2728,1.2627,1.1364,2.1466,0.25254,2.2728,0.50507,1.7678,1.389,0.50507,1.6415,0.12627,1.894v2.3991l-1.894,1.6415-3.0305,1.2627-2.5254,1.2627-2.1466,2.0203-1.0102,1.7678-0.75761,2.1466-2.6516,1.6415-1.894,1.389-2.0203,1.5152-0.88388,0.88388v0.75762l0.88388,0.88388c0.50508,0.12627,2.1466,1.2627,2.1466,1.2627l1.894,1.0102s0.75762,0.88389,0.88389,1.389c0.12627,0.50508,0,1.5152-0.12627,2.1466-0.12627,0.63134-2.0203,3.6618-2.0203,3.6618l-1.894,1.6415-3.6618,2.0203-3.1567,0.63135-2.1466,1.0102s-0.75761,0.37881-1.1364,1.0102c-0.3788,0.63135-1.6415,1.2627-1.6415,1.2627l-2.2728,0.50507-1.0102,0.88388s-1.2627,0.88389-1.6415,1.389c-0.37881,0.50508-3.5355,2.9042-3.5355,2.9042l-0.88389,1.389s-0.75761,1.1364-1.389,1.2627c-0.63134,0.12627-2.2728,0.12627-2.2728,0.12627l-2.3991-0.88388-1.6415,1.389s-1.6415,0.37881-2.1466,0.88388c-0.50508,0.50508-2.7779,1.7678-2.7779,1.7678l-2.3991,0.63134s-1.894-0.25253-2.5254,0.12627c-0.63134,0.37881-1.2627,1.5152-1.2627,1.5152l0.63135,1.5152,0.25254,0.88388-0.88389,1.894s-1.0102,0.75762-1.0102,1.2627-0.88388,2.0203-0.88388,2.0203-0.50508,0.88388,0.25253,1.389c0.75762,0.50507,2.5254,0.88388,2.5254,0.88388s1.389-0.12627,1.5152,0.50508c0.12627,0.63134-1.1364,1.6415-1.1364,1.6415l-2.6516,0.75762-2.0203,1.2627-0.88389,1.6415z",
  "city_population": 734455,
  "fed_okrug": "Сибирский федеральный округ",
  "country_population": 345038,
  "area": 431892,
  "city_natural_increase": 2140,
  "city_migration_increase": -1773,
  "country_natural_increase": 627,
  "country_migration_increase": -5434,
  "average_nominal_wage": 30931,
  "average_consumer_rate": 15159,
  "average_annual_buzy": 477,
  "per_capita_income": 23023,
  "kladr": "7500000000000"
}, {
  "id": 382,
  "name": "Красноярский край",
  "path": "M531.66,122.41c-0.45,0.04-1,0.37-1,0.37-0.9,0.72-1.25,0.77-0.94,1.13,0.31,0.35,0.19,0.55,0.9,0.78,0.72,0.22,0.91,0.49,1.44,0,0.54-0.49,0.77-1.24,0.41-1.69s-0.37-0.64-0.81-0.59zm11.56,0.65c-0.22,0.02-0.44,0.11-0.6,0.38-0.31,0.53-0.49,1.57-0.62,1.84s-0.2,0.74-0.78,0.88c-0.58,0.13-1.39,0.54-1.75,0.09s-1.03-1.51-1.25-1.69-1.04-0.74-1.13-0.03c-0.09,0.72,0.19,1.51,0.19,1.91s-0.18,0.99-0.4,1.12c-0.23,0.14-1.06,0.25-1.29,0.56-0.22,0.32-0.62,0.49-0.62,1.16s-0.27,1.67-0.31,1.94c-0.05,0.27-0.32,0.26-0.63,0.75s-1.09,1.87-1.09,1.87,0.89,0.62,1.15,0.85c0.27,0.22,0.42,0.77,0.38,1-0.05,0.22-0.13,1.05-0.53,1.19-0.4,0.13-1.43,0-1.78-0.13-0.36-0.13-1.01-0.48-1.5-0.44-0.49,0.05-1.01,0.23-1.19,0.63s-0.71,0.38-0.13,1.18c0.58,0.81,0.87,1.53,1,1.76,0.14,0.22,0.29,1.51,0.07,1.87-0.23,0.36-1,1.13-1.22,1.53-0.23,0.4-0.44,0.71-0.22,1.16,0.22,0.44,0.66,0.8,1.15,0.94,0.5,0.13,3.66,0.71,3.66,0.71s0.28-0.36,0.81-0.71c0.54-0.36,1.36-0.77,1.85-0.41s0.52,0.8,0.65,1.25c0.14,0.45,0.41,2.02,0.5,2.37,0.09,0.36,0.49,0.58,0.94,1.16s1.59,1.37,2.22,1.59c0.63,0.23,1.05,0.55,1.72,0.6,0.67,0.04,2.85,0.82,2.94,1.09s0.31,1,0.31,1,0.54,0.52,0.81,0.56c0.27,0.05,2.22,0.19,2.22,0.19,1.38-0.76,2.23-0.8,2.5-0.94,0.27-0.13,0.84-0.03,1.37-1.06,0.54-1.03,0.76-1.35,0.63-2.06-0.13-0.72-0.34-0.93-0.87-1.6-0.54-0.66-1.5-1.24-1.1-1.56,0.4-0.31,1.56-0.8,1.88-1.15,0.31-0.36,0.54-1.32,0.4-2.35-0.13-1.02-0.15-2.5-0.47-2.9-0.31-0.41-0.73-0.92-1.4-1.19s-1.23-0.67-1.81-0.53c-0.59,0.13-1.92,0.25-2.19,0.03s-0.62-0.83-0.85-1.5c-0.22-0.67-0.5-1.13-0.5-1.53s1.16-3.63,1.16-3.63,0.71-0.29,0.84-0.56c0.14-0.27,0.36-0.76,0.22-1.66-0.13-0.89-0.39-1.55-1.28-2.09s-2.09-1.72-2.09-1.72v-0.97c0-0.35-0.15-1.73-0.28-2-0.14-0.27-0.48-0.72-0.97-0.72-0.25,0-0.5-0.05-0.72-0.03zm17.72,22.91c-0.13,0.02-0.25,0.07-0.35,0.19-0.4,0.44-0.72,1.12-0.9,1.34s-0.51,0.09-0.91,0-0.89-0.43-1.16-0.03c-0.26,0.4-0.67,0.74-0.71,1.19-0.05,0.44,0.09,1.75,0.09,2.46,0,0.72,0.09,1.8,0,2.6s-0.2,1.3-0.78,1.66c-0.58,0.35-0.91,0.4-1.31,0.93-0.41,0.54-1.13,1.25-1.13,1.88,0,0.62,0.06,1.45-0.66,2.03-0.71,0.58-1.14,0.56-0.96,1.4,0.17,0.85,0.22,0.93,0.84,1.38s2.79,0.63,3.28,0.5,1.26-0.77,1.66-1.22,1.61-0.99,2.28-1.12c0.67-0.14,1.17-0.08,2.16-0.13,0.98-0.04,1.54-0.39,2.03-0.65,0.49-0.27,0.54-0.54,1.43-0.54,0.9,0,1.74,0,2.1-0.31,0.35-0.31,1.35-1.19,1.62-1.5s0.88-1.05,0.97-1.5,0.18-1.3,0-1.75,0.15-1.15-1.19-1.28-1.57,0.07-1.84-0.38c-0.27-0.44-1.03-0.88-1.03-1.37s0.08-1.02-0.19-1.37c-0.27-0.36-0.79-0.81-1.28-0.72s-1.31,0.58-1.53,0.62c-0.22,0.05-0.71-0.09-0.85-0.4-0.13-0.32-0.21-1.11-0.21-1.91s-0.25-1.63-0.25-1.63c-0.34-0.13-0.83-0.43-1.22-0.37zm5.22,20.03c-0.62,0.05-1.16,0.75-1.16,0.75s-1.62,1.95-2.16,2.84c-0.53,0.9-0.86,1.08-1.93,1.25-1.08,0.18-1.82,1.63-1.82,1.63s-0.51,1.23-0.68,2.12c-0.18,0.9-1.25,3.07-1.25,3.07v1.93l0.87,1.63s1.6,1.05,1.78,2.12c0.18,1.08-2.12-0.68-2.12-0.68s-2.14-0.73-3.03-0.91c-0.9-0.18-1.64,0.01-3.07,0.19-1.42,0.18-1.25,0.34-1.25,0.34l0.72,1.63s1.61,1.4,1.25,2.65c-0.35,1.25-1.4-0.53-1.4-0.53l-1.97-0.87s-1.98,0.16-2.88,0.87c-0.89,0.72-1.25,0.91-1.97,0.91-0.71,0-1.59-0.71-2.12-1.78-0.54-1.08-0.91-0.91-1.63-1.44-0.71-0.54-3.2,0-4.09,0s-2.32,1.79-3.75,1.97-1.78,0.53-1.78,0.53l0.34,2.12-1.97,1.1-2.12,0.53-2.16,0.53c-0.71,0.18-2.12-0.19-2.12-0.19l-1.97-0.34-1.44,0.87-0.53,0.57-2.84,0.15-2.16,0.91s-2.49,2.13-4.09,2.31c-1.61,0.18-0.19,0.53-0.19,0.53s1.06,0.91,1.06,1.63c0,0.71-0.7,0.87-0.87,1.4-0.18,0.54-1.45-0.33-2.35-0.68-0.89-0.36-1.25,0-1.25,0s0.2,1.04,0.38,1.93c0.18,0.9,1.06,1.28,1.06,2.35s-0.19,2.12-0.19,2.12,0.53,2.69,0.53,3.41v2.69c0,0.89-0.87,1.59-0.87,1.59s-1.25,0.72-3.03,0.72c-1.79,0-0.91-0.72-0.91-0.72l0.72-0.91-0.53-1.4-1.97-0.38-2.31,1.25-1.78-0.53h-3.22-3.94c-1.43,0-1.95-1.07-2.84-1.25-0.9-0.18-2.88-0.34-2.88-0.34s-2.14-0.02-3.03,0.34-1.97,1.06-1.97,1.06v3.07,3.03s-1.6,0.69-1.78,1.4c-0.18,0.72,0.01,2.68,0.19,3.75,0.18,1.08,1.05,0.72,2.12,1.25,1.07,0.54,2.16,1.25,2.16,1.25l0.53,0.57,0.34,1.78s0.57,1.94,0.57,2.65c0,0.72,1.25,1.97,1.25,1.97s0.68,1.63,0.68,2.35c0,0.71-0.51,1.22-0.87,1.93-0.36,0.72-0.73,1.61-0.91,2.5-0.18,0.9,0,2.16,0,2.16l0.38,2.84s-0.2,2.88-0.38,3.6c-0.18,0.71-0.89,1.42-1.78,1.78s-1.25,2.12-1.25,2.12,0.01,2.7,0.19,3.6c0.18,0.89,0.88,1.42,1.59,1.78,0.72,0.36,1.25,1.78,1.25,1.78l-0.87,1.78-1.78-0.34-1.44-1.78-0.91-1.82v-2.5s-0.54-1.76-1.97-2.65c-1.42-0.9,0.19-1.63,0.19-1.63s1.08-1.25,1.44-1.97c0.36-0.71,1.06-1.78,1.06-1.78s1.8-1.6,2.16-2.5c0.35-0.89-0.38-1.4-0.38-1.4l-1.06,0.68-1.78,1.82-1.78-0.91s0.69-1.25,0.87-1.78c0.18-0.54,0.54-1.79,0.72-2.5,0.18-0.72,0.35-1.6,1.06-2.31,0.72-0.72,2.35-0.19,2.35-0.19l1.25-1.25v-1.63l-1.1-1.59s-1.4-0.17-3.9-0.34c-2.5-0.18-0.72-1.25-0.72-1.25l-0.72-1.82s-0.72-1.76-1.44-2.12c-0.71-0.36-1.94-3.04-2.65-3.75-0.72-0.72-1.1-1.44-1.82-2.16-0.71-0.71-2.11-1.78-3.18-2.5-1.08-0.71-1.97-1.4-1.97-1.4l-1.63,0.34s-1.05,1.07-0.15,2.5c0.89,1.43,1.06,1.44,1.06,1.44l1.25-0.28,0.97,0.18,1.22,0.5,1.15,1.07,1.06,0.71,0.91,1.07,0.53,0.9,0.1,0.94-0.6,1.63-1.68,1.84-1.29,0.81-1.93,0.88,0.81,1.15s2.04,1.71,2.22,1.85c0.18,0.13,0.69,0.9,0.69,0.9l0.31,2.85,0.09,2.59s-0.33,2.1-0.37,2.28c-0.05,0.18-0.63,0.88-0.63,0.88l-7.09,3.97-1.44,0.9-1.25,0.94-0.66,0.81s0.3,2.37,0.35,2.6c0.04,0.22,0.64,1.18,0.69,1.4,0.04,0.23,1.28,2.69,1.28,2.69s1.15,1.2,1.46,1.69c0.32,0.49,2.16,0.31,2.16,0.31h3.44c0.4,0,1.34,0.5,1.34,0.5s1.3,0.98,1.35,1.16c0.04,0.17,0.37,1.31,0.37,1.31l0.38,3.34s0.09,3.42,0.09,3.69-0.5,1.56-0.5,1.56l-0.34,1.22c-0.04-0.01-0.07-0.03-0.1-0.06l-1.15,2.06-1.82,1.69-1.68,0.28-1.6,0.28,0.16,1.41s1,1.98,1,2.34-0.01,1.68-0.19,2.13c-0.18,0.44-0.81,1.68-0.81,1.68l0.47,1.19,1.15,1.69,0.88,2.41,0.47,1.68-1.16,1.97-1,1.63,0.72,1.93s0.08,1.53-0.09,1.97c-0.18,0.45-1.07,1.16-1.07,1.16l-0.43,1.19s4.1,3.63,5,4.53c0.89,0.89,0.15,1.52,0.15,2.06s-0.72,2.5-0.72,2.5l-1.25,2.22,0.1,1.87s1.54,1.46,1.72,1.82c0.17,0.35,1.68,0.78,2.22,0.87,0.53,0.09,2.78,0.38,2.78,0.38l1.25,1.31-0.19,0.81-1.16,1.63-0.72,3.28s-0.8,2.07-1.15,2.34c-0.36,0.27-1.44,1.16-1.44,1.16l-2.22,1.15-1.72,2.41,0.38,0.97,1.34,1,0.25,1.78-0.81,1.78-1.25,2.78-1.5,1.41-2.31,2.34-1.72,1.6-1.5,2.25s-0.9,2.92-0.81,4c0.08,1.07,0.96,0.72,0.96,0.72s1.62,1.07,2.16,1.34,1.51,0.99,1.78,1.34c0.27,0.36,1,1.24,1,1.69v1.53l-0.81,0.88-1.25,0.81-3.41,1.25-1.69,0.34-2.4-0.25s-1,0.43-0.91,0.78c0.09,0.36,0.72,1.63,0.72,1.63s0.45,1.24,0.63,1.69c0.17,0.44,0.27,0.88,0.72,1.06,0.44,0.18,0.09,2.97,0.09,2.97s-0.89,2.3-1.16,2.75c-0.27,0.44-0.46,1.25-0.37,1.87,0.09,0.63,0.72,1,0.72,1s1.7,0.69,2.06,0.78,2.94,1.1,2.94,1.1,3.13,0.72,3.84,0.72,2.58,0.06,3.56,0.15,2.5,1,2.5,1,1,0.87,1.53,1.41c0.54,0.53,0.25,4.64,0.25,5s2.88,0.19,3.5,0.28c0.63,0.09,2.32,0.81,2.32,0.81s0.43,1.33,0.43,1.69-0.43,1.88-0.43,1.88l-1.78,0.9-3.47,1.5-0.57,1.06s-1.13,4.74-1.4,5.19,0.53,1.88,0.53,1.88l1.5,0.62,2.25,1.06s3.47,2.25,4.09,2.79c0.63,0.53-0.09,0.96-0.09,0.96l-0.97,1.82-5.44,4.72-0.72,1.96-0.18,1.5s-0.44,3.58-0.44,3.94,0.34,1.53,0.34,1.53,1.81,1.15,2.25,1.5c0.45,0.36,1.88,1,1.88,1l0.72,1.41s0.79,1.54,1.06,2.34c0.27,0.81-0.72,0.97-0.72,0.97l-3.56,2.94-1.97,0.91s-1.35,1.33-1.44,1.87,0.81,0.97,0.81,0.97l0.97,1.44,1,1.34s1.95,0.73,2.75,0.91c0.81,0.17,1.63-0.57,1.63-0.57s1.42-1.95,2.4-2.22c0.99-0.26,0.53,0.46,1.07,0.72,0.53,0.27,1.96,0.61,2.59,0.88s2.22,1.34,2.22,1.34l0.81,2.06,1.78,7.41,0.82,2.5-1.26,4.13s0.1,2.05,0.19,2.4c0.09,0.36,0.8,1.24,1.07,1.6,0.26,0.35,0.43,2.15,0.43,2.15l-0.97,1.35-2.4,1.5-1.1,1.78s-2.3,3.32-2.65,3.59c-0.36,0.27-2.06,1.14-2.6,1.41-0.53,0.27-2.06,1.44-2.06,1.44s0.27,1.06,0.63,1.15c0.35,0.09,0.53,2.16,0.53,2.16l0.81,1.06,1.88-0.44,3.21,0.78,2.5,0.91s1.25,0.88,1.79,1.06c0.53,0.18,3.4-0.44,3.4-0.44s5.87-2.32,6.31-2.59c0.45-0.27,1.72-1.06,1.72-1.06s2.5-1.89,3.03-2.25c0.54-0.36,3.74-2.14,4.1-2.41,0.35-0.27,1.44-1.78,1.44-1.78l0.9-2.12s0.16-1.99,0.25-2.44,0.53-1.5,0.53-1.5l0.72-1.25,2.16-0.19,3.12,0.44,2.32,0.19s3.57,0.1,4.37-0.35c0.8-0.44,0.45-0.72,0.63-1.34,0.17-0.63-0.27-0.9-0.63-1.35-0.36-0.44-1-1.33-1.53-1.78-0.54-0.44-1.25-1.15-1.25-1.15s-2.31-4.22-2.31-4.75c0-0.54,0.81-1.15,2.15-1.69s3.91-0.97,3.91-0.97l2.06-1.19-0.09-2.65,0.47-1.78s1.16-2.8,1.25-3.07c0.09-0.26,1.51-2.93,1.68-3.56,0.18-0.62,0.62-1.79,1.07-2.59,0.44-0.81,1.62-1.68,2.15-2.03,0.54-0.36,1.68-1.91,2.13-2.44,0.44-0.54,1.09-2.22,1.09-2.22l-0.19-4.09s-2.13-2.42-2.4-3.22c-0.27-0.81,0.07-1.43,0.34-1.78,0.27-0.36,1.61-1.88,1.97-2.5,0.36-0.63,0.81-2.53,0.81-2.97,0-0.45,0.98-1.5,1.88-2.13,0.89-0.62,2.83-0.18,3.28,0s1.09,0.81,1.72,1.35c0.62,0.53,3.28,0.68,3.28,0.68s1.07-1.42,1.25-1.87,0.98-1.77,1.25-2.22,1.53-1.07,2.25-1.16c0.71-0.09,1.69,0.63,1.69,0.63s0.97,1.78,1.15,2.31c0.18,0.54,1.18,1.61,1.53,1.97,0.36,0.36,1.26,1.8,1.35,2.16,0.09,0.35,1.06,0.33,2.22,0.15s0.09-1.4,0.09-1.4v-2.16s-0.62-2.16-0.62-2.78c0-0.63,0.71-1.78,0.71-1.78s2.5-0.8,3.03-1.06c0.54-0.27-0.08-1.17,0.1-1.97,0.18-0.81,1.33-1.7,1.69-1.88,0.35-0.18,2.96-0.61,3.4-0.87,0.45-0.27,1.41-1.25,1.41-1.25l0.62-2.69,0.28-2.88s-0.02-0.11-0.03-0.12c0.09-0.06,0.32-0.22,0.32-0.22l1.31,0.19s0.6-0.58,1.31-0.94c0.72-0.36,0.79,0.03,0.97,0.03s0.68,1.11,0.81,1.47c0.14,0.36,0.36,1.26,0.41,1.53,0.04,0.27,1.38,0.68,1.56,0.72s1.55,0.47,1.81,0.56c0.27,0.09,1.66,1.08,1.97,1.44,0.32,0.36,1.04,0.45,2.38,0.94s1.53-0.28,1.53-0.28l0.65-0.63s0.23-1.4,0.32-1.94c0.09-0.53,0.72-0.87,0.72-0.87s1.51-1.22,1.87-1.63c0.36-0.4,0.5-0.87,0.5-0.87s0.34-2.99,0.16-3.13c-0.18-0.13-1.38-0.71-1.78-0.84-0.41-0.13-1.6-1.46-2-2.13-0.41-0.66,0.3-1.16,0.43-1.43,0.14-0.27,1.41-1.06,1.63-1.28,0.22-0.23,1.06-0.78,1.59-1,0.54-0.23,0.27-2.9,0.22-3.35-0.04-0.44-0.7-0.44-1.81-0.62-1.12-0.18-1.97-0.85-1.97-0.85s-1.52-1.52-2.19-2.28-0.22-2.76-0.22-3.03,0.17-4.1,0.13-4.9c-0.05-0.81,0.54-1.63,0.72-1.85s2.37-0.49,2.59-0.53,1.9-0.99,2.35-1.34c0.44-0.36,0.59-1.19,0.59-1.19s-0.37-1.3-0.5-1.75c-0.14-0.45,0.72-1.65,1.03-1.88,0.31-0.22,1.91-1.37,1.91-1.37s1.07-6.86,1.25-7.13c0.17-0.26-0.32-1.59-0.32-1.59s-1.19-3.62-1.28-3.84c-0.09-0.23-0.68-1.65-0.5-2.32s1.27-1.02,1.41-1.25c0.13-0.22,0.07-0.97-0.16-1.15-0.22-0.18-1.03-1.16-1.03-1.16s0.58-3.41,0.63-3.81c0.04-0.4,0.28-1.69,0.28-1.69l1.22-0.84s3.79-0.07,4.06-0.07,2.03-0.79,2.44-1.06c0.4-0.27,0.13-1.66,0-1.84-0.14-0.18-1.19-1.94-1.19-1.94h-2.28l-2.5,0.06-2.1-0.43-1.03-0.41s-2.49-0.25-2.72-0.25c-0.22,0-1.5-0.16-1.5-0.16l-0.65-0.25s-0.13-1.6-0.13-1.87,0.48-0.55,1.07-0.91c0.58-0.35,0.93-0.94,0.93-0.94s-0.17-0.98-0.43-1.34c-0.27-0.36-0.1-0.97-0.1-0.97s2.29-2.76,2.38-2.93c0.09-0.18,0.62-1.04,0.62-1.04s0.89-1.56,1.06-2.18c0.18-0.63-0.59-1.16-0.59-1.16s-3.42-4.04-3.78-4.44-1.14-1.64-1.31-1.9c-0.18-0.27-0.91-1.24-1-1.69s0.31-1.41,0.31-1.41l1.09-3.47-0.56-1.06s-1.07-0.96-1.16-1.09c-0.09-0.14-1-0.75-1-0.75s-0.63-0.55-0.5-0.91c0.14-0.36,1.36-0.56,1.63-0.56s2.31-0.69,2.31-0.69,1.39-0.56,1.56-0.78c0.18-0.22-0.03-1.16-0.03-1.16s-1.56-17.7-1.56-18.06-0.65-1.56-0.78-1.78c-0.14-0.22-2.19-2.34-2.19-2.34l-0.72-5.16h0.06s1.85,0.06,2.47,0.06c0.63,0,0.97-0.84,0.97-0.84l2.5-2.06,1.53-1.38s0.57-0.52,0.88-0.56c0.31-0.05,1.26,0.58,1.44,0.62,0.17,0.05,1.47,0.6,1.47,0.6s0.99-0.52,1.43-0.66c0.45-0.13,0.75-0.62,0.75-0.62l-0.31-5.94,4.16-2.16s0.93-1.1,0.93-1.28,0.57-1.87,0.57-1.87l4.47-3.1s1.78-2.23,2.18-2.5-0.03-0.62-0.03-0.62l-1.25-1.85s-1.07-1.29-1.78-1.47c-0.71-0.17-0.91-1.09-0.91-1.09l0.29-5-0.6-0.47-2.84-2.31-3.41-2.69-0.72-1.97-0.34-1.4-1.06-1.78,0.15-0.91,1.25-2.69-1.4-1.4-1.63-1.97-0.72,1.59s-1.43-0.53-2.5-0.53-1.06,1.44-1.06,1.44-1.95,0.71-2.84,1.25c-0.9,0.53-1.25,1.78-1.25,1.78s-1.45,1.25-2.16,1.25-2.14,0.01-3.03,0.19c-0.89,0.17-1.43,1.41-1.97,2.12-0.54,0.72-1.44,2.33-2.16,2.69-0.71,0.36-0.71,0.34-1.78,0.34s-0.16-0.7,0.38-2.31c0.53-1.61,1.95-1.79,2.31-2.5s0.72-1.78,0.72-1.78l2.5-0.91s0.54-3.02,1.44-3.37c0.89-0.36,3.75-0.53,3.75-0.53s1.22-1.63,1.4-2.35c0.18-0.71,1.44-1.58,1.97-2.65,0.54-1.08,0.72-1.79,0.72-2.5,0-0.72,0.91-1.82,0.91-1.82l2.5-2.12s1.58-1.6,1.93-2.31c0.36-0.72,2.16-1.97,2.16-1.97l2.16-1.97,2.31-2.5s0.19-1.44,0.19-2.16c0-0.71-0.72-1.78-0.72-1.78s-1.26-0.9-1.97-1.44c-0.72-0.53-1.78-0.7-1.78-1.59s0.16-0.72,0.34-1.44c0.18-0.71,0.72,0,0.72,0l1.44,1.1,0.15-1.25-0.15-2.35-0.53-1.97-2.69-0.68-1.78-1.1h-2.16c-0.71,0-0.52-0.69-0.87-1.4-0.36-0.72-0.37-1.62-0.91-2.69s-2.31-0.19-2.31-0.19l-1.78,0.91c-0.72,0.35-0.73,0.52-1.44,1.06-0.72,0.54-1.61-0.37-3.22-0.91-1.61-0.53-1.77,0.02-2.84,0.38-1.08,0.36,0.17,0.88,0.53,1.59,0.35,0.72,0,1.44,0,1.44l-2.35-0.19s-1.06-0.35-1.78-1.25c-0.71-0.89,0.19-1.06,0.19-1.06s1.25-1.43,1.25-2.5-0.72-1.25-0.72-1.25h-2.69c-1.25,0-1.96-0.17-3.03-0.34-1.07-0.18-1.25-0.37-1.97-1.44-0.71-1.07,0.57-0.53,0.57-0.53l1.4-1.25,1.25-0.72,2.69,0.34s0.9,0.56,1.97,0.38,0.19-0.72,0.19-0.72l-1.63-1.06s-1.77,0.34-2.84,0.34-2.16-0.72-2.16-0.72l-1.97-0.87s-1.41-1.45-2.12-1.63c-0.09-0.02-0.2-0.04-0.28-0.03zm-45.94,3.34c-0.85,0.32-1.23-0.03-1.5,0.82-0.27,0.84-0.34,0.96,0.16,1.18,0.49,0.23,0.87,0.53,1.4,0.44,0.54-0.09,1.24-0.47,1.06-1.09-0.17-0.63-1.12-1.35-1.12-1.35zm20.84,3.82c-0.33,0-0.47,0.12-0.94,0.56-0.62,0.58-1.62,1.37-1.71,1.9-0.09,0.54,0.12,0.96-0.19,1.54s-1.55,1.81-2,2.12-2.51,0.16-2.6,0.47c-0.08,0.31-0.37,0.52,0.04,0.87,0.4,0.36,2.91,0.63,3.72,0.54,0.8-0.09,3.3-0.3,3.74-0.35,0.45-0.04,0.71,0.28,0.66-0.43-0.04-0.72-0.72-1.36-0.4-1.85,0.31-0.49,0.6-0.65,0.78-0.97,0.17-0.31,0.49-1.06,0.31-1.47-0.18-0.4-0.72-0.95-0.72-1.53s-0.28-1.37-0.28-1.37c-0.18-0.01-0.3-0.04-0.41-0.03zm-45.53,6.62c-0.49,0-2.1,0.86-2.19,1.13-0.09,0.26-0.56,0.38,0.07,0.97,0.62,0.58,0.39,0.88,1.15,0.84,0.76-0.05,1.55-0.67,2.22-0.63,0.67,0.05,1,0.79,1.31,0.79,0.32,0,0.62-0.23,0.66-0.72s-0.42-0.89-0.59-1.07c-0.18-0.17-0.54-0.18-0.54-0.18-0.31-0.45-1.6-1.13-2.09-1.13zm-2.06,6.25c-0.54,0.18-1.01,0.45-1.5,0.63-0.49,0.17-0.81,0.17-1.13,0.43-0.31,0.27-0.72,0.46-0.72,0.82,0,0.35,0.15,0.5,0.6,0.81s0.52,0.62,1.19,0.62,1.89-0.5,2.03-0.81c0.13-0.31,0.48-0.94,0.53-1.25,0.04-0.31-1-1.25-1-1.25zm-51.31,9.13l-2.35,2.12-0.34,1.78,1.97,0.38,1.25,0.87h2.5l1.25-0.87v-1.78l-1.63-2.16-2.65-0.34zm59.09,4.4c-0.49,0.14-1.47,0.59-1.25,1.03,0.22,0.45,0.5,0.8,0.91,0.75,0.4-0.04,0.74-0.01,0.87-0.5,0.14-0.49-0.22-1.25-0.22-1.25l-0.31-0.03zm97.34,1.78c-0.09,0.01-0.18,0.07-0.28,0.22-0.38,0.6-0.53,1.69-0.4,2.1,0.12,0.41-0.42,0.87,0.12,1.31s0.62,1.22,1.53,1.25c0.92,0.03,1.9,0.47,2.63-0.06,0.72-0.54,1.43-1.69,1.65-2.19,0.22-0.51,0.32-1.22,0.07-1.53-0.26-0.32-0.62-0.81-1.13-0.88-0.5-0.06-1.19,0.16-1.19,0.16-1.07,0.31-0.99,0.66-1.78,0.31-0.59-0.26-0.92-0.72-1.22-0.69zm-135.37,0.22l-1.97,0.19-1.44,1.44,0.53,1.06,1.63-0.91,1.44,0.57,0.34,1.59,1.25,0.34,0.72-0.87-0.53-1.06-1.97-2.35zm27.09,1.13c-0.49,0.01-1.04,0.1-0.9,0.5,0.17,0.53,1.09,0.75,2.03,0.75s2.97,0.08,3.06,0.44c0.09,0.35,0.68,1.56,0.91,1.65,0.22,0.09,0.92,0.13,0.97-0.41,0.04-0.53-0.44-1.13-0.76-1.4-0.31-0.27-2.09-1.25-2.09-1.25-0.45-0.09-2.24-0.28-2.78-0.28-0.13,0-0.27-0.01-0.44,0zm10.31,1.12c-0.71,0.23-0.93,0.25-0.93,0.88,0,0.62-0.1,1.06,0.43,1.15,0.54,0.09,0.85,0.33,1.26,0.07,0.4-0.27,0.59-0.91,0.37-1.22s-1.13-0.88-1.13-0.88zm-44.71,1.16l-1.44,1.25,0.72,0.87,1.78-1.06-1.06-1.06zm6.4,2.31v1.78l2.35-0.53v-1.25h-2.35zm133.35,1.5c-1.05,0.29-1.25,0.28-2.07,0.6-0.82,0.31-1.49,0.24-1.87,0.74-0.38,0.51-0.44,0.28-0.66,1.29s-0.69,0.99,0.1,1.31c0.79,0.31,1.39,0.29,2.31-0.41,0.91-0.69,1.71-1.09,2.19-1.65,0.47-0.57,0.84-1.19,0.84-1.35s-0.84-0.53-0.84-0.53zm-122.41,0.5c-0.4,0.63-0.65,1.16-0.87,1.56-0.23,0.41-0.68,0.77-1.13,1.66s-0.81,1.32-0.81,2.03c0,0.72,0.24,1.18,0.68,1.41,0.45,0.22,0.34,0.5,0.57,0.5,0.22,0,0.82,0.09,1.31,0s1.03-0.19,1.03-0.5v-1.88c0-0.53-0.31-3.37-0.31-3.59s-0.47-1.19-0.47-1.19zm-16.47,0.69l-1.06,0.87v1.25l1.44,0.57,0.87-1.25-1.25-1.44z",
  "city_population": 2220245,
  "fed_okrug": "Сибирский федеральный округ",
  "country_population": 655545,
  "area": 2366797,
  "city_natural_increase": 6418,
  "city_migration_increase": 5887,
  "country_natural_increase": -1454,
  "country_migration_increase": -3134,
  "average_nominal_wage": 36071,
  "average_consumer_rate": 18669,
  "average_annual_buzy": 1413.3,
  "per_capita_income": 27123,
  "kladr": "2400000000000"
}, {
  "id": 383,
  "name": "Иркутская область",
  "path": "M599.41,325.78c-0.12,0.03-0.22,0.12-0.22,0.34,0,0.45,0.53,1.54,0.53,1.54l0.37,1.06s-0.26,0.88-0.62,1.06-1.78,0.63-1.78,0.63l-2.69,0.09s-1.61,0.26-1.88,0.44c-0.26,0.18-0.9,0.73-0.9,1.09s-0.44,1.96-0.53,2.31c-0.09,0.36-0.16,1.97-0.16,1.97s0.18,0.78,0.63,1.41c0.44,0.62,0.43,1.81,0.43,1.81l-1.25,1.16s0.26,1.67,0.35,2.03,1,3.4,1,3.4l0.43,2.5s-0.28,1.42-0.28,1.69-0.96,4.57-0.96,4.57-0.09,0.98-0.54,1.24c-0.44,0.27-2.06,1.88-2.06,1.88s-0.19,0.99-0.19,1.34c0,0.36,0.37,1.06,0.19,1.5-0.18,0.45-1.97,1.72-1.97,1.72l-2.59,0.72-1.31,0.88-0.29,3.84-0.09,2.22v1.81c0,0.36,0.27,1.34,0.72,1.78,0.45,0.45,2.16,1.97,2.16,1.97l2.21,0.53,1.16,0.78,0.1,2.25s-0.37,1.33-0.82,1.5c-0.44,0.18-2.75,1.82-2.75,1.82l-0.53,1.15,0.97,1.16,1.97,1.59s0.78,0.1,0.87,0.72c0.09,0.63-0.15,2.6-0.15,2.6l-0.47,1.43-1.25,1.07-1.41,1.43-0.19,1.6-1.24,0.81-2.79-0.28-1.59-1.35-1.78-0.68-2.25-0.63s-0.45-0.74-0.63-1.19c-0.17-0.44-0.34-1.68-0.34-1.68l-1.25-0.72-1.87,1-1.26,0.09-0.18,1.69-0.35,2.41-0.53,1.53-0.9,0.97-1.6,0.53s-1.89,0.28-2.25,0.37c-0.35,0.09-1.34,1.41-1.34,1.41s-0.53,0.8-0.44,1.15c0.09,0.36,0.19,1.25,0.19,1.25l-1.16,0.91-2.06,0.81s-0.44,0.9-0.44,1.25c0,0.36,0.16,1.97,0.16,1.97l0.37,1.5,0.1,1.63s0.7,0.7,0.43,1.06c-0.26,0.36-2.78,0.62-2.78,0.62l-1.93-2.78-1-1.5-1.07-2.34-1.06-0.69h-1.72l-1.59,1.69s-0.89,0.81-1.16,1.44c-0.27,0.62,0.01,1.78-1.15,1.78s-3.22-0.38-3.22-0.38l-1.25-1.15-1.97-0.44-1.34-0.19s-0.62,0.64-0.97,0.91c-0.36,0.27-1.35,1.25-1.35,1.25v0.62l-0.72,1.88-1.15,2.22-0.81,0.9-0.29,1.35,0.63,1.68s0.45,0.9,0.81,1.25c0.36,0.36,0.63,0.35,0.72,0.97,0.09,0.63,0.19,2.6,0.19,2.6l-0.38,2.4-0.97,1.88s-1.88,1.79-2.15,2.06-2.13,1.61-2.13,1.97-1.62,4.19-1.62,4.19l-1.25,2.25s-0.69,2.11-0.78,2.56-0.63,3.59-0.63,3.59-0.09,1.33-0.62,1.6c-0.54,0.26-3.69,0.81-3.69,0.81s-2.12,1.07-2.56,1.34c-0.45,0.27-0.72,0.63-0.72,0.63s-0.19,0.52-0.1,0.87c0.09,0.36,1.16,2.25,1.16,2.25l1.44,2.66,1.06,0.56,0.97,1.06,1.09,1.69v0.81l1.25-0.43s0.9-0.91,1.25-1c0.36-0.09,1.78,0.28,1.78,0.28l1.44,0.87s1.43,0.91,1.78,1c0.36,0.09,2.03,1.41,2.03,1.41l4.32,2.87s0.34,0.82,1.06,0.82c0.71,0,2.41-0.38,2.41-0.38l1.78-0.34,1.06,1.15,0.28,1.16,0.28,1.53,2.56-0.81,2.44-2.41s2.14-2.16,3.13-2.34c0.98-0.18,2.12,1.19,2.12,1.19s0.72,1.58,1.25,2.03c0.54,0.44,2.43,2.32,2.78,2.59,0.36,0.27,3.03,1.53,3.03,1.53l2.22,2.66c0.45,0.53,2.52,3.22,2.97,3.22s2.84,0.18,3.38,0.09c0.53-0.09,1.96,0.63,2.5,1.25,0.53,0.63,1.78,2.69,1.78,2.69s1.27,1.69,1.62,1.78c0.36,0.09,1.16,1.88,1.16,1.88s0.89,1.62,1.25,1.53,2.31-0.63,2.31-0.63,0.73,0.15,0.91,0.69c0.18,0.53,0.87,2.59,0.87,2.59s1.18,0.62,1.53,0.53c0.36-0.09,1.88-1.25,1.88-1.25s1.77-0.26,2.12-0.43c0.36-0.18,1.44-0.82,0.82-1.44-0.05-0.04-0.11-0.06-0.16-0.09,0.05-0.01,0.34-0.07,0.34-0.07l1.69-0.62,8.75-2.88s1-1.76,1-2.03,0.63-2.06,0.63-2.06l0.06-2.06,0.81-0.82,1.78-0.96,2.25-0.82,1.16-1.68,1.06-0.82,5.44-2.59,1.62-1.31,0.82-1.1,0.62-2.5,1.94-1.15s1.27-0.9,1.62-1.35c0.36-0.44,0.35-0.97,0.35-0.97l-0.63-0.81-1.25-1.25-0.34-0.81s0.18-0.96,0.62-1.41c0.45-0.44,0.71-0.63,1.07-0.72,0.35-0.09,1.25,0.35,1.25,0.35l1,1.09,0.87-0.47,0.63-1.78s0.81-2.14,0.9-2.5,0.25-1.69,0.25-1.69-0.25-3.05-0.25-3.5v-2.5s0.44-4.01,0.53-4.37,0.35-2.13,0.35-2.13l-0.1-1.87s-0.44-1.17-0.62-1.44-0.16-0.81-0.16-0.81,0.63-1.05,0.72-1.41c0.09-0.35-0.37-0.81-0.37-0.81s-0.54-0.71-0.72-1.06c-0.18-0.36-0.88,0.15-0.88,0.15l-1.44,0.91s-0.79,1.26-1.15,1.53-0.44,1.31-0.44,1.31l-0.28,4.38-0.81,1.34-1.53-0.09c-0.34-0.63-0.73-1.32-0.79-1.6-0.08-0.44-0.43-2.67-0.34-3.65s0.97-4.38,0.97-4.38l1.25-1.25s0.09-1.52-0.53-2.06c-0.63-0.53-1.87-1.07-2.41-1.34-0.53-0.27-1.72-1.35-1.72-1.97,0-0.63,0.92-1.77,1.19-2.13,0.27-0.35,3.93-1.51,4.28-1.78,0.36-0.27,3.57-2.15,3.57-2.15l3.65-1.07,2.78,0.25,2.13-0.34,1.34-2.5,2.88-0.81s1.87,1.25,2.4,1.25c0.54,0,2.22-0.72,2.22-0.72s1.07,0.64,1.25,1,1.63,1.34,1.63,1.34l1.93-0.37s1.35-0.44,2.07-0.35c0.71,0.09,1.7,0.98,2.06,1.07s2.75-0.72,2.75-0.72l1.09-1.5,2.5-1.16s1.35-1.08,1.35-1.53,0.15-3.22,0.15-3.22,1.25-0.61,1.88-0.97c0.62-0.35,2.15-0.18,2.15-0.18s0.17-1.34,0.35-1.79c0.18-0.44,1.33-1.34,1.78-1.43s2.44,0.37,2.44,0.37l1.15,0.97-1.34,1.44-0.72,1.15,0.72,0.72s2.31-0.45,2.94-0.72c0.62-0.26,2.24-0.44,2.78-0.53,0.53-0.09,2.84-1.15,2.84-1.15s0.91-1.08,0.91-1.44-0.2-1.71-0.38-2.16c-0.18-0.44-2.21-1.14-2.65-1.59-0.45-0.45-0.54-2.58-0.72-2.94s-0.9-1.9-0.63-2.44c0.27-0.53,1.06-1.78,1.06-1.78l-0.62-2.5s-0.01-2.48,0.34-2.84c0.36-0.36,2.07-1,2.07-1l2.93,0.81s0.9,1.15,1.35,1.06c0.44-0.09,2.15-0.53,2.15-0.53l0.25-3.56-0.87-1.16s-1.27-1.42-1.63-1.68c-0.35-0.27-1.25-1.25-1.25-1.25l-1.68-2.97-0.25-2.6-0.72-1.68-2.25-0.54-1.78,0.97-3.13,1.53-1.97,0.44-0.72-0.72-0.78-2.84-1-1.59-2.75-2.35-2.34-1.68-2.66-0.91-2.78-0.06s-2.49,0.8-2.84,1.15c-0.36,0.36-1.45,1.52-1.72,1.88-0.27,0.35-0.88,2.5-0.88,2.5l-0.28,2.12v2.5s-0.17,1.36-0.43,1.72c-0.27,0.36-3.94,2.03-3.94,2.03l-1.16,1.72-0.19,2.66-0.97,2.25-2.15,2.22s-0.6,0.63-0.69,0.09-0.62-2.22-0.62-2.22l-2.16-2.34s-0.44-1.23-1.06-0.78c-0.63,0.44-1.63,1.31-1.63,1.31l-3.28,1s-0.89,0.43-1.25,0.87c-0.36,0.45-2.97,0.72-2.97,0.72l-2.03,0.28-2.16,2.5s-0.62,1.26-1.24,0.82c-0.63-0.45-2.22-2.35-2.22-2.35l-0.82-1.59-0.53-2.94,0.16-5.56-0.06-2.56,1.5-2.6,1.87-3.03s0.44-1.61,0.44-2.06-0.53-3.03-0.53-3.03l-2.03-2.25-4.94-3.66s-0.63-0.71-0.63-1.25c0-0.53,0.1-2.31,0.1-2.31l1.15-1.97s0.63-0.35,0-1.06c-0.62-0.72-3.18-4.57-3.18-4.57l0.15-5.34s0.02-0.65-0.34-1.09c-0.36-0.45-2.59-3.28-2.59-3.28l-1.54-1.88s-0.24-0.62-0.68-0.62c-0.45,0-2.16,0.68-2.16,0.68s-1.17,0.82-1.44,0.29c-0.27-0.54-0.25-2.6-0.25-2.6s-0.29-1.16,0.16-1.25,1.62-0.44,1.62-0.44h1.5l0.29-1.43-1.79-1.97-1.53-1.35-1.4-0.06s-0.14-0.03-0.25,0z",
  "city_population": 1900566,
  "fed_okrug": "Сибирский федеральный округ",
  "country_population": 508871,
  "area": 774846,
  "city_natural_increase": 2711,
  "city_migration_increase": -3946,
  "country_natural_increase": 1290,
  "country_migration_increase": -2168,
  "average_nominal_wage": 32704,
  "average_consumer_rate": 13594,
  "average_annual_buzy": 1146.9,
  "per_capita_income": 22458,
  "kladr": "3800000000000"
}, {
  "id": 384,
  "name": "Кемеровская область",
  "path": "m472.14,414.79-0.71428,2.3214,0.89286,1.6072,2.5,1.4286,1.7857,1.6071,1.25,2.5,0.17857,0.89286s-0.89286,1.4286-1.6071,2.1429c-0.71429,0.71428-4.2857,2.3214-4.2857,2.3214l-1.7857,1.7857-1.7857,1.7857v1.6072l1.0714,1.7857,0.17858,1.7857-1.9643,2.5s-1.25,1.0714-1.0714,1.7857c0.17857,0.71428,1.0714,1.4286,1.7857,1.6071,0.71428,0.17857,2.8571,0.89286,2.8571,0.89286l-0.71429,1.4286-1.25,1.7857-0.53571,1.6072-1.7857,0.71428-1.4286,1.6072,0.71429,1.25,1.25,1.25-0.89286,2.5-1.25,1.6071,0.53572,1.25,1.7857,1.7857-0.35714,1.6072-1.6072,1.9643-2.5,2.1429h-1.9643l-0.71429-1.7857-1.9643-1.25-2.6786-0.35714-1.4286,1.0714-2.1428-1.4286-0.71429-2.3214-1.0714-0.71429,0.17857-2.5-0.53571-2.5,0.89286-1.9643,0.71428-1.6071-2.1428-2.6786-1.6072-2.6786-1.25-1.4286-0.71428-2.3214-0.89286-1.7857-2.3214-2.1429-1.7857-1.6071-0.71429-1.25v-1.7857l-0.35714-4.6428,0.17857-2.5,0.71429-2.3214,1.25-1.4286,0.71428-1.25-1.4286-1.9643v-0.89286l-0.35714-2.5,1.6071-0.35714,4.4643-0.53571,2.5-0.89286,3.0357-0.89286,1.0714-0.35714,0.71428-0.89286h1.6072,1.9643,2.5l1.7857,0.35715,1.4286,0.35714,0.89286,0.89286,1.9643,0.53571,1.6071-0.17857,2.5-0.71429z",
  "city_population": 2325808,
  "fed_okrug": "Сибирский федеральный округ",
  "country_population": 383596,
  "area": 95725,
  "city_natural_increase": -4262,
  "city_migration_increase": -318,
  "country_natural_increase": -1160,
  "country_migration_increase": -1623,
  "average_nominal_wage": 28263,
  "average_consumer_rate": 14259,
  "average_annual_buzy": 1238.2,
  "per_capita_income": 21845,
  "kladr": "4200000000000"
}, {
  "id": 385,
  "name": "Новосибирская область",
  "path": "m371.43,421.57,4.1071,0.71429l4.4643-0.17858c1.25-0.17857,2.1429-0.71428,2.1429-0.71428l-2.14,3.4h-3.0357l-0.89285,2.1428s1.0714,1.9643,1.7857,2.5c0.71429,0.53572,2.6786,3.0357,2.6786,3.0357l0.53572,2.1428,2.3214,0.35715h1.4286s2.6786,0.35714,3.3928,0.35714c0.71429,0,0.89286,0,1.9643-0.35714,1.0714-0.35715,3.2143-0.71429,4.6429-0.71429h3.5714s2.6786,0.17857,3.5714-0.35714c0.89286-0.53572,0.89286-1.0714,2.3214-1.25,1.4286-0.17857,3.0357-0.17857,3.9286-0.17857,0.89286,0,1.9643-0.17857,1.9643-0.17857s0,1.6071,0.89286,2.1428c0.89285,0.53572,4.1071,2.6786,4.1071,2.6786l0.71428,0.71429c0.17858,0.71429-0.17857,2.5-0.17857,3.2143,0,0.71428-1.0714,0.71428-0.17857,1.6071,0.89286,0.89286,1.9643,1.4286,1.9643,1.4286l2.3214-1.9643,2.3214-2.3214s2.1429-0.53572,2.8572-0.53572c0.71428,0,3.0357,0,3.75-0.17857,0.71428-0.17857,1.4286-0.71429,2.6786-0.17857,1.25,0.53571,2.3214,0.71428,3.3929,0.71428,1.0714,0,3.5714-1.25,3.5714-1.25s1.7857-2.1428,1.9643-2.8571c0.21-0.7-0.33-4.45-0.33-4.45v-3.75c0-0.71429,0.71428-2.3214,1.25-2.6786,0.53571-0.35714,1.7857-0.89285,1.7857-1.7857,0-0.89286-0.89286-1.6071-0.89286-1.6071s-0.89285-0.53572-0.89285-1.4286c0-0.89286,0.35714-3.2143-0.53572-3.0357-0.89285,0.17857-4.1071,1.7857-4.1071,1.7857s0,0.17857-1.4286,0.17857-2.5,0-2.6786-0.71429c-0.17857-0.71428,0.35714-5,0.35714-5l0.53571-2.6786,0.17858-2.1429-2.8572,1.4286s-1.6071,0.53572-2.5,0.71429c-0.9,0.18-4.47-0.71-4.47-0.71l-2.1429-0.71428-1.4286-2.1429-1.4286-2.8571s-2.5,0.53571-3.2143,0.71428c-0.71428,0.17858-1.9643,0.53572-1.9643,0.53572l-2.3214-1.25-1.0714-3.3929v-1.25l-3.0357-1.7857s-1.9643-1.6072-2.6786-2.1429c-0.71428-0.53571-3.3928-1.7857-3.3928-1.7857s-3.3929-1.25-4.1072-1.6072c-0.71428-0.35714-1.9643-1.25-2.6786-1.6071-0.71428-0.35714-3.9286-1.4286-3.9286-1.4286l-1.9643,0.17857s-0.35715,1.0714-0.53572,1.9643c-0.17857,0.89285-1.0714,2.3214-1.0714,2.3214l-1.4286,1.0714-0.89286,1.6072,0.17858,2.1428-0.71429,1.4286h-3.2143l-2.5-0.35714-2.1428,0.89286-2.1429,2.3214-1.4286,1.9643-0.71429,2.6786,0.71429,1.9643,1.7857,2.6786v1.7857l-2.1428,3.5714z",
  "city_population": 2194747,
  "fed_okrug": "Сибирский федеральный округ",
  "country_population": 585955,
  "area": 177756,
  "city_natural_increase": 4614,
  "city_migration_increase": 13436,
  "country_natural_increase": -1564,
  "country_migration_increase": -1071,
  "average_nominal_wage": 28046,
  "average_consumer_rate": 18548,
  "average_annual_buzy": 1344.7,
  "per_capita_income": 24186,
  "kladr": "5400000000000"
}, {
  "id": 386,
  "name": "Омская область",
  "path": "m388.39,368.89,0.71428,2.5-1.25,1.6071-1.25,1.9643,0.53572,1.6071,0.71428,1.9643-1.25,1.9643s-1.0714,1.25-1.0714,2.1429c0,0.89286,0.17857,3.0357,0.17857,3.0357l1.7857,1.6072,0.35714,2.3214-0.53571,3.3929-1.9643,0.89286-1.25,1.6071,0.71429,2.3214-0.35715,1.9643-3.9286,0.17857s-1.4286-0.89286-2.3214-1.0714c-0.89285-0.17857-3.3928,2.8571-3.3928,2.8571l-2.5,2.1429-0.89286,4.2857,0.53571,0.89286,1.9643,2.1429,0.35714,2.6786-1.6071,2.6786-1.0714,1.7857-0.17857,3.0357-2.5,2.1429s-2.3214,1.0714-3.0357,1.0714h-4.8214l-1.6072-0.71428c-2.1428,1.4286-3.75,0-3.75,0l-1.6071-0.71429-1.9643-0.35714h-1.0714l0.35714-1.7857,1.7857-1.0714,0.71429-1.4286-2.3214-1.25-2.1429-2.3214-1.9643,0.89285-0.89286-0.71428v-3.75l-1.4286-0.89286-2.8571,0.35714-2.8572-0.89285-0.89285-0.53572-0.17857-2.1428,2.1428-2.6786,0.71429-2.3214,0.35714-2.6786v-4.1071l0.71429-2.1429,1.4286-3.9286,1.6071-2.5,2.3214-0.53571,1.0714-1.25,1.0714-1.7857,1.6071-0.89285h2.6786l1.6071-1.4286,0.89286-3.9286-1.4286-3.2143-0.71429-3.0357-1.25-3.3928,0.35715-1.6072,4.4643-4.6428,1.0714-0.89286h2.6786l0.17857,1.6071-1.25,1.6072-1.7857,1.25-0.17857,1.4286,1.4286,0.35714,3.2143,0.35714,2.3214,0.17857,2.1429,1.4286,1.9643,1.4286,1.0714,0.35714,1.0714-0.71429,1.9643-0.35714,2.3214,0.35714,3.5714,1.6072h2.5l2.1428-1.0714h2.1429z",
  "city_population": 1432165,
  "fed_okrug": "Сибирский федеральный округ",
  "country_population": 541264,
  "area": 141140,
  "city_natural_increase": 2104,
  "city_migration_increase": 2009,
  "country_natural_increase": -21,
  "country_migration_increase": -3809,
  "average_nominal_wage": 27234,
  "average_consumer_rate": 17255,
  "average_annual_buzy": 941.3,
  "per_capita_income": 25858,
  "kladr": "5500000000000"
}, {
  "id": 387,
  "name": "Томская область",
  "path": "m454.64,359.43,1.25,3.2143,1.25,2.3214s-0.53571,2.3214-0.71428,3.0357c-0.17857,0.71429-1.6071,3.0357-1.6071,3.0357s0.53571,1.25,1.6071,1.9643c1.0714,0.71429,5.8929,1.7857,5.8929,1.7857l5.3571,0.17857s3.75,0.89285,4.1071,1.6071c0.35714,0.71429,0.89286,1.0714,0.89286,2.1429,0,1.0714,0.35714,4.2857,0.35714,4.2857s1.25,0.35714,2.6786,0.35714,3.0357,0.35715,3.0357,0.35715,0.35714,2.1428,0.35714,2.6786c0,0.53571-0.89286,1.7857-1.9643,1.7857s-3.75,1.6072-3.75,1.6072-1.25,2.6786-1.25,3.75-0.89285,3.5714-0.53571,4.2857c0.35714,0.71429,4.4643,1.7857,5.1786,2.1429,0.71429,0.35714,3.2143,2.6786,3.2143,2.6786s-0.71429,1.6071-1.6072,2.6786c-0.89285,1.0714-4.1071,3.0357-5.3571,4.6429-1.25,1.6071-0.35714,2.8571-0.35714,2.8571l-0.71429,1.6071-3.2143,0.53572-3.2143,0.35714-1.4286-1.6071-1.9643-0.17857-4.66-0.57h-2.3214l-1.25,1.0714s-2.1429,1.0714-3.2143,1.25c-1.0714,0.17857-5.3571,1.25-6.0714,1.25-0.71428,0-6.4286,0.71429-6.4286,0.71429l-3.3928,1.4286h-2.3214l-0.35715-1.9643,0.71429-2.1429-0.35714-2.3214,1.7857-2.3214-0.53571-1.4286s-1.0714-0.17858-1.9643,0.53571c-0.89286,0.71429-4.4643,1.0714-4.4643,1.0714l-4.2857-0.17857-1.9643-2.3214-0.89286-3.0357s-1.25-1.0714-2.6786-0.71428c-1.4286,0.35714-1.6072,1.25-2.6786,1.25s-2.5,0-3.0357-0.89286c-0.53571-0.89286-0.89285-3.0357-0.89285-3.0357l-0.9-2.33s-1.6071-0.89286-2.5-1.6071c-0.89286-0.71429-3.2143-2.3214-3.2143-2.3214l-5.1786-2.3214-4.2857-1.9643-4.6429-1.7857-2.6786-1.0714-1.7857-2.5v-3.0357l1.6072-2.8572,0.35714-1.7857-0.53571-2.3214,1.25-3.0357,0.71428-3.3929,1.9643-1.0714,3.3928-2.8571s0-2.1429,0.71429-2.3214c0.71429-0.17857,5.7143-1.6071,5.7143-1.6071l1.9643-1.7857,1.25-2.6786,2.5-1.6071,1.6071-3.2143s1.0714-1.0714,1.7857-1.7857c0.71428-0.71429,2.1428-1.4286,2.1428-1.4286l1.9643-0.35715,2.1429,1.7857,2.1428,1.0714,2.5,0.35714,2.8572,1.4286,1.0714,1.6071,3.0357,0.89286h3.3929l2.1428,0.35714,1.25,1.6072,2.6786,0.71428,2.3214,0.71429,2.1429,1.7857,1.25-0.89286,1.7857-0.53571,2.1428-1.4286,2.1429-0.17857,1.6071,0.71428,1.7857,0.89286z",
  "city_population": 780547,
  "fed_okrug": "Сибирский федеральный округ",
  "country_population": 298376,
  "area": 314391,
  "city_natural_increase": 2314,
  "city_migration_increase": 1899,
  "country_natural_increase": -113,
  "country_migration_increase": -1791,
  "average_nominal_wage": 34041,
  "average_consumer_rate": 14987,
  "average_annual_buzy": 483.7,
  "per_capita_income": 24860,
  "kladr": "7000000000000"
}, {
  "id": 389,
  "name": "Республика Саха (Якутия)",
  "path": "M701.25,126.75l-1.44,1.06-1.25,1.63s1.44,0.87,2.16,0.87c0.71,0,2.69-1.97,2.69-1.97l-2.16-1.59zm18.47,12.09c-0.18-0.01-0.4,0.02-0.63,0.07-1.78,0.35-4.81,1.93-4.81,1.93s-1.41,1.1-2.12,1.1c-0.72,0-2.35-0.38-2.35-0.38-0.71,0-2.5,1.25-2.5,1.25l-1.4,1.78s-1.1-0.51-1.1,0.38-0.35,1.96,0.72,2.5c1.07,0.53,1.61,1.06,2.5,1.06s3.22-0.72,3.22-0.72l1.97-0.87,1.97,1.06s0.51-0.9,1.4-1.44c0.9-0.53,3.4-2.31,3.75-3.03,0.36-0.71,0.72-3.22,0.72-3.22s-0.11-1.36-1.34-1.47zm-19.81,7.1c-0.15,0.01-0.29,0.05-0.44,0.09-1.25,0.36-2.85,0.19-3.56,0.19-0.72,0-0.91,0.19-0.91,0.19s-0.88,1.58-1.59,1.93c-0.72,0.36-1.99,0.74-3.07,0.57-1.07-0.18-3.75-1.25-3.75-1.25s-1.93-0.02-1.93,1.59,3.03,3.41,3.03,3.41l1.06,1.4s-2.51,0.73-3.41,0.38c-0.89-0.36-2.65-2.16-2.65-2.16l-3.22-0.72s-2.88,0.2-2.88,1.1c0,0.89-0.68,2.67-0.68,3.56s-0.9,3.04,0.53,3.94c1.43,0.89,1.79,3.03,1.97,3.75,0.17,0.71,0.7,1.77,2.84,2.31,2.14,0.53,4.29,0.53,5,1.06,0.71,0.54,1.77,1.07,2.84,0.53,1.08-0.53,1.82-2.65,1.82-2.65l2.12-1.97s1.61-1.44,2.5-2.16c0.89-0.71,2.7-0.54,4.13-1.44,1.42-0.89,2.31-3.75,2.31-3.75v-5l-0.38-4.43s-0.68-0.58-1.68-0.47zm106.25,5.62c-0.45,0.09-0.75,4.1-0.75,4.1l-7.32,1.65-3.28,0.63-4.53-6.06-7.84-0.13-0.38,0.87-5.68,1.66-1.76,2.13-6.06,6.31v2.78l-2.15,1.91-3.29,5.03-4.93-2.38-3.41-0.37-1.75,2h-4.56l-3.41,1.78-1.75-1.53,4.28-2.91-2.28-1.62-3.03-0.13-8.84,4.03,1.9,5.44-0.87,4.78-2.66,2.91-1.65-2.13,3.03-7.47-1.75-0.37-2.66,4.03-3.03,2.03-1-0.75,1-3.16,2.28-0.74,2.91-2.66-7.1,1.75-9.22,5.31-6.68,0.25,3.65,3.66-3.65,3.4-0.5,3.03,0.37,1.16,3.91-1.78-1,4.03,4.81,2.91-0.91,2.9-2-1.37-3.68,1,1.28,3.41,2.4-0.26-1.03,2.66-3.9-0.5-4.28-1.66-3.53,0.26-2.41,3.15-0.63,4.06h-6.46l-1.76-1.53-2.4-2-0.5,4.41,0.87,0.87-0.12,1.41,1.65,0.87-0.9,2.54,1.66,6.18-3.29-1.4-1,1.15-9.87-5.31v-4.94l-2.25,0.13-1.78,2.41-2-3.41,3.65-0.63-0.5-2.9-4.43-1.66,0.75-0.87,0.12-2.53-5.28-4.04-5.31-2.53-1,3.66-7.35,0.65-2.37-1.65-4.19,2.15v2.13l4.19,4.69-10.94,5.31-10.28-1.16,0.44-4.4-12.07,0.19-3.96,3.78h-2.85l-1.09,1.09,2.66,2.87h-2.13l-2.91-2.06,1.19-2.09-0.87-1.38-1.54-1.78,0.07,2.28-1.5,1.07-3.85-1.32s-2.9,3.53-2.84,3.78c0.06,0.26,2.66,3.29,2.66,3.29l-1.41,3.34,1.59,2.09,0.19,2.78,7.38,5.82-0.32,5.47,2.53,1.9,1.63,2.53-2.53,2.72-4.41,3.03-0.69,2.63-4.81,2.78,0.25,6.12-2.25,1.1-2.97-1.28-5.65,4.75-4.44,0.09,0.06,1.97,5.38,6.59,1.78,20.1-6.35,1.97,4.19,3.4-1.78,4.19v1.25l7.16,8.84-4.57,6.69,0.97,1.6-2.4,1.87,0.09,2.25,5.63,0.34,0.71,0.72,9.1,0.19,3.31,3.31-0.53,1.6-3.31,0.34,0.19,3.94,4.03-1.06,5.06,6.59-0.53,5.53,3.84,5.19-1.97,3.4,0.53,2.13,7.69,6.53v4.37l-3.75,6.44,0.28,10.78,3.85,4.13,3.37-3.94,3.75,0.09,1.88-1.34,2.68-0.62,2.41-2.07,3.56,3.85,0.38,2.31,4-5.06,0.09-4.13,5.38-2.75-0.29-6.25,2.32-4.12,3.84-1.5,4.91,1.06,6.15,4.91,0.57,3.84,1.31,0.87,4.03-1.4,2.5-2.06,2.69,1.06,0.87,4.47,3.13,4.56,2.15,1.78v3.03l2.32,1.35,0.71,4.71,3.94,0.19,0.97,1.35,1.53,4.09,8.38-0.25,3.31-1.97,5.53,1.16,3.56,1.97,11-0.72,5.54,3.75,2.21,0.53,5.19-2.6h2.6l3.03,2.26,2.78-0.19,3.22-3.94,5.68-0.06,2.5-1.97h7.88l0.19-3.75,10.68-5.09,0.82-3.04-4.28-4.12,2.31-1.69,0.62-4.03-1.34-1.69-2.41,0.38-2.03-1.44,2.75-4.03-2.84-1.6,0.25-1.87,1.53-1.97-1.44-1.44-3.47-1.15-0.53-1.6,3.38-1.43-1.88-0.91-0.19-5.25-0.87-0.62-0.19-1.88,2.78-1.25-1.62-1.25v-2.94l5.47-1.97,3.12,0.16,0.25-1.78,6.53,0.09v-2.75l-1.25-1.53,1.16-1.25,3.47-0.62,3.31-2.22,1.34-6,5-0.44,0.1-2.06s-5.29-4.9-5.47-5.25c-0.18-0.36-0.88-3.94-0.88-3.94l-3.56-2.59v-5.97l2.94-7.16-1.69-9.19,0.78-3.12,13.5,0.72,0.25-5.28,5.19-1.16,3.47,1.87,0.81-2.31-2.41-3.69,1.69-0.62,0.19-2.75-7.16-8.5,0.1-4.37-3.13-1.5-0.09-4.04-1.78-1.15,1.09-2.13,3.81-0.47,1.35-1.78,4.28,0.38,0.09-2.44-3.37-1.5,0.15-3.31,5.47-0.53v-3.57l5.63,0.44,5.62-8.03,0.44-2.5-6.06-6.06-0.19-1.88,2.31-3.4-0.97-1.79-3.31,0.19-1.5-2.34,4.72-1.41-0.09-1.53-2.07-0.97-0.25-1.34,2.13-3.75,5.72-1.97-0.78-3.56,5.15,0.68-0.62-5.43,1.34,0.28,0.19-3.59-2.69-0.63-2.94-4.53-7.59-0.28-4.19-1.88,0.72-3.47h-3.12l-0.19-1.62,8.12-10.44,1.07-7.84s-9.81-5.72-10.25-5.63zm-135.1,8.56c-0.12,0.03-0.23,0.08-0.34,0.19-0.89,0.9-1.07,1.79-0.53,2.5,0.53,0.72,1.06,1.63,1.78,2.35,0.71,0.71,2.31,1.25,2.31,1.25s0.71-1.1,0.53-1.82c-0.18-0.71-1.97-2.84-1.97-2.84s-0.94-1.78-1.78-1.63zm28.94,7.35l-2.31,0.34s-1.07,0.91-1.25,1.63c-0.18,0.71-0.9,1.24,0,1.78,0.89,0.53,3.75,1.25,3.75,1.25s1.6-0.02,1.78,0.87c0.18,0.9,0.18,1.8,0,2.69s-0.53,1.78-0.53,1.78l0.72,0.72,1.93-0.53s0.74-0.72,1.82-0.72h2.65s1.44-0.53,1.97-1.25c0.54-0.71,1.97-1.25,1.97-1.25h2.69s1.41-0.52,0.87-1.59c-0.53-1.07-1.76-1.62-2.65-2.16-0.9-0.53-3.22-2.31-3.22-2.31h-2.5l-3.6,0.34-2.84,0.38-1.25-1.97zm-17,10.15c-0.12,0-0.22,0.01-0.31,0.04-0.72,0.17-1.44,1.4-1.44,1.4s0.37,1.78,2.16,1.78c1.78,0,2.3,0.55,2.65-0.34,0.36-0.89-0.87-2.31-0.87-2.31s-1.37-0.55-2.19-0.57z",
  "city_population": 630435,
  "fed_okrug": "Дальневосточный федеральный округ",
  "country_population": 332365,
  "area": 3083523,
  "city_natural_increase": 4734,
  "city_migration_increase": -1690,
  "country_natural_increase": 3446,
  "country_migration_increase": -3697,
  "average_nominal_wage": 54631,
  "average_consumer_rate": 24146,
  "average_annual_buzy": 482.1,
  "per_capita_income": 37847,
  "kladr": "1400000000000"
}, {
  "id": 390,
  "name": "Камчатский край",
  "path": "M918.56,146.75l-1.65,0.84c-0.26,0.13-1.25,0.88-1.25,0.88l-0.13,1,0.13,2.78,0.25,1.16-0.88,2.43-1.72,4.69-0.93,1.56-0.44,1.41-0.06,1.81s-0.22,1.03-0.47,1.22c-0.26,0.19-0.82,0.13-0.82,0.13h-1.81-2.59l-1.6-0.19-1.68-0.31s-0.53,0.25-0.85,0.25c-0.31,0-0.68,0.56-1,0.75-0.31,0.19-1.37,0.74-1.56,1-0.19,0.25-1.28,0.78-1.59,0.9-0.32,0.13-1.38,1-1.63,1.19s-0.78,0.56-1.22,0.63c-0.44,0.06-0.94-0.32-0.94-0.32s-0.62-0.99-0.74-1.25c-0.13-0.25-0.97-1.72-0.97-1.72s-0.07-1.31-0.13-1.62c-0.06-0.32-0.06-1.47-0.12-1.72-0.07-0.25-0.13-1.06-0.13-1.06s0.25-1.22,0.31-1.66c0.07-0.44,0.38-0.75,0.38-0.75s0-0.56-0.19-0.87c-0.19-0.32-0.81,0.06-0.81,0.06l-1.75,0.44-1.97,0.81-1.66,0.5-1.18,0.19-2.04-0.25s-1.62-0.38-1.87-0.57-1.03-0.12-1.03-0.12l-0.63,0.56-0.87,1.16-0.63,0.81-0.84,0.88s-1.31,0.74-1.56,0.87c-0.26,0.13-0.94,0.59-0.94,0.59l-1.22,1.32-1.44,2.28s-2.27,2.28-2.59,2.47-1.18,0.87-1.44,1.12c-0.25,0.25-1.34,0.38-1.72,0.44s-0.74,0.62-1,0.94c-0.25,0.31-1.15,1.28-1.15,1.28l-0.81,0.56s-0.75-0.31-1.13-0.31-0.44,0.31-0.44,0.31l-0.97,1.91-1,2.18s-0.5,1.59-0.5,1.91,0.63,0.44,0.88,0.63c0.25,0.18,1.65,0.8,2.03,1.06,0.38,0.25,1,0.84,1.31,1.15,0.32,0.32,1.41,1.32,1.41,1.32s-0.13,0.43-0.06,0.68c0.06,0.26,0.37,1.15,0.68,1.66,0.32,0.51,0.94,0.81,0.94,0.81s4.09,1.16,4.35,1.28c0.25,0.13,1.09,1.32,1.09,1.32l0.37,0.68s1.13,0.85,1.44,1.04c0.32,0.18,1.22,0.31,1.22,0.31l0.62,0.62,0.44,1.19s-0.31,1.59-0.37,1.97c-0.07,0.38-0.07,0.99,0,1.37,0.06,0.38,1.12-0.06,1.12-0.06s1.4-0.31,1.97-0.25,1.56,0.25,1.56,0.25,1.22,0.4,1.35,0.66c0.12,0.25,0.75,1.18,0.75,1.18l1.15,1.5,1.25,1.72,1.85,1.32,2,1.65,1,1.31s0.84-0.99,1.03-1.31c0.19-0.31,0-0.74,0-1.19,0-0.44-0.37-0.71-0.75-0.96-0.38-0.26-0.97-1.19-1.35-1.63-0.37-0.44-0.56-0.84-0.56-0.84s-0.81-1.06-1.06-1.31c-0.25-0.26-1.09-0.94-1.34-1.19-0.26-0.26-1.25-1.34-1.69-1.97s0-0.75,0-1.06c0-0.32,0.87-1.04,0.87-1.04s0.94-1.3,1.19-1.62,0.44-1.21,0.5-1.59,0.47-1.31,0.85-1.5c0.37-0.19,1.18-0.38,1.68-0.44,0.51-0.06,1.84,0.5,1.97,0.81,0.13,0.32-0.62,0.69-0.75,0.94-0.12,0.25,0,1.59-0.06,2.16-0.06,0.56,0.12,1.71,0.12,2.28,0,0.56,0.75,1.37,0.75,1.37s1.13,1.4,1.44,1.72c0.32,0.32,1.28,0.93,1.59,1.19,0.32,0.25,1.57,1.65,1.57,1.65l3.34,2.32,0.97,0.59s0.75,1.25,0.81,1.69c0.07,0.44,0.44,0.93,0.44,0.93s1.03,0.22,1.34,0.47c0.32,0.26,0.63,1.31,0.63,1.69s-0.12,1.03-0.44,1.47c-0.31,0.44-1.21,0.93-1.53,1.25s-0.69,0.75-0.69,0.75-0.06,5.68-0.06,6.25,0.75,1.78,1,2.16,1.21,2.14,1.72,2.9c0.5,0.76,0.69,1.12,0.69,1.44s0.25,1.66,0.25,1.66,0.56,10.46,0.62,11.09,0.59,1.03,0.78,1.41,0.75,0.93,1,1.18c0.26,0.26,0.75,0.84,0.88,1.16,0.12,0.32,0.97,1.62,0.97,1.62s0.74,2.78,0.87,3.54c0.13,0.75,0.13,1.72,0.13,1.72s1.31,3.96,1.31,4.4v1.47s-0.81,1.75-1.13,2.13c-0.31,0.37-0.06,1.77-0.06,2.09,0,0.31-1.34,2.46-1.84,2.84-0.51,0.38-1.31,1-1.44,1.38s0.25,1.03,0.25,1.03l1.81,0.87,2.28,0.94s1.09,2.15,1.47,2.66c0.38,0.5,0.56,1.59,0.56,1.9,0,0.32,0.32,3.47,0.44,4.16,0.13,0.69,0.38,1.65,0.56,2.09,0.19,0.45,1.79,1.5,1.79,1.5s2.21,3.94,2.34,4.25c0.13,0.32,0.81,1.69,1.06,2,0.08,0.1,0.29,0.25,0.53,0.41,0.62,0.78,3.07,1.94,3.07,1.94l0.93,0.62s4.63,4.25,4.69,4.5c0.06,0.26,2.78,2.32,2.78,2.32s2.34,0.84,2.6,1.03c0.25,0.19,1.68,0.75,1.68,0.75l14.91,10.22,2.03,1.21,3.03,0.94s1.19,1.59,1.44,1.72,3.15,1.19,3.59,1.19c0.45,0,1.47,1,1.47,1s2.59,2.78,2.97,3.03,2.56,1.91,2.56,1.91,2.09,1.18,2.47,1.18,2.85-0.5,2.85-0.5l0.68-0.62v-2.03s-0.06-1.69-0.06-1.88,0-1.21-0.25-1.53-0.81-0.88-0.81-0.88,0.18-1.52,0.44-1.96c0.25-0.45,0.43-0.69,0.43-1.07s-0.31-1.15-0.56-1.4c-0.25-0.26-0.5-1.19-0.5-1.19s-0.06-2.34-0.31-2.66c-0.25-0.31-1.09-0.99-1.28-1.62s-0.5-1.03-0.63-1.41c-0.12-0.38-1.37-1.62-1.62-2.06-0.26-0.44-1.53-1.59-1.72-1.84-0.19-0.26-0.31-1.28-0.5-2.1s-1.02-0.75-1.78-0.75-1.12-0.06-1.38-0.25c-0.25-0.19,0.5-0.43,0.75-0.56,0.26-0.13,1.09-0.9,1.28-1.22,0.19-0.31,0.5-1.37,0.5-1.37l0.69-4.22,1.91-1.6c0.38-0.31,0.25-0.93-0.19-1.31s-1.09-0.25-1.41-0.31c-0.31-0.06-0.8-0.84-1.31-1.16-0.5-0.31-0.84-0.81-1.28-1s-1.24-0.31-2.06-0.56-1.4-1.03-1.91-1.47c-0.5-0.44-0.44-1-0.5-1.25s-0.06-1.96-0.06-2.84v-1.22s-0.97-2.78-0.97-3.1c0-0.31,0.03-1.05,0.16-1.43,0.12-0.38,0.49-0.69,0.75-0.94,0.25-0.25,1.43-0.78,1.43-0.78l1.47-0.88s0.38-1.71,0.38-2.59-0.5-2.25-0.63-2.56c-0.12-0.32-1.34-0.72-1.34-0.72s-1.5-1.19-1.94-1.19-2.46-0.56-2.9-0.69c-0.45-0.12-1.6-0.78-1.85-0.9-0.25-0.13-1.71-1.25-2.09-1.56-0.38-0.32-1.25-1.1-1.5-1.41-0.26-0.32-0.75-1.44-0.88-1.75-0.12-0.32-0.84-1.66-0.84-1.66s0-0.55-0.13-1.12c-0.12-0.57-0.18-1.65-0.18-2.41s1.02-0.62,1.28-0.62c0.25,0,1.68-0.25,2-0.32,0.31-0.06,1.03-0.74,1.22-1,0.19-0.25,0.37-1.77,0.31-2.09s-0.65-0.81-1.22-1-0.94-0.78-1.12-0.84c-0.19-0.07-2.16-0.88-2.16-0.88s-2.06-0.69-2.5-0.75-0.59,0.44-0.84,0.63c-0.26,0.19-0.5,0.37-1.32,0.37s-1.22-0.44-1.22-0.44l-0.87-1.18s-1.18,0.06-1.81,0.06c-0.64,0-0.91-0.59-1.16-0.91-0.25-0.31-1.06-0.56-1.06-0.56s-0.47-0.19-0.69-0.28c0-0.06,0.19-3.44,0.13-3.69-0.07-0.25-0.66-1.21-0.91-1.47-0.25-0.25-1.37-0.44-1.94-0.44s-1.4,0.6-1.84,0.85-1.06,0.75-1.31,0.94c-0.26,0.19-0.13,1.12-0.13,1.68,0,0.57-0.34,1.03-0.72,1.35-0.38,0.31-0.68,0.25-1.31,0.25s-1.12-0.19-1.63-0.31c-0.5-0.13-0.77-0.56-1.03-0.82-0.25-0.25-1.06-0.96-1.37-1.47-0.32-0.5-0.19-1.05-0.25-1.62-0.07-0.57-0.84-1.65-1.1-2.16-0.25-0.5-1.24-2.34-1.37-2.59s-0.56-1.28-1-1.91-0.9-1.99-1.28-2.62-0.74-1.09-1.5-2.1-0.78-0.56-1.35-0.68c-0.56-0.13-0.99-0.78-1.5-1.35-0.5-0.57-0.84-0.93-1.15-1.75-0.32-0.82-0.37-0.83-0.94-2.15-0.57-1.33-0.07-1.09,0.19-1.66,0.25-0.57,1.06-0.62,1.06-0.62l0.47-0.88s-0.38-1.59-0.31-2.09c0.06-0.51,0.36-0.56,1.06-0.75,0.69-0.19,1.56,0.75,1.94,0.75s1.59-0.5,1.9-0.82c0.32-0.31,0.32-1.08,0.32-1.71,0-0.64-0.62-1-1.13-1.13s-0.94-0.56-0.94-1.06c0-0.51,0.25-1.21,0.25-1.91,0-0.69,0-0.74-0.06-1.25-0.06-0.5-0.12-0.53-0.25-0.91-0.13-0.37,0.06-1.18,0.19-1.68,0.12-0.51,0.56-0.44,0.94-0.38,0.37,0.07,1.24,0.69,1.62,0.94s0.65,0.62,0.84,1,1,1.09,1.63,1.16c0.63,0.06,1.15-0.38,1.15-0.38s-0.09-0.52-0.34-1.09-0.81-1.44-1-1.81c-0.19-0.38-0.5-1.22-0.75-1.6s-0.44-0.5-0.44-0.75,0.69-2.09,0.69-2.41v-3.78c0-0.82,0.19-1.4,0.38-1.72,0.19-0.31,0.87-1.24,1.25-2.06s0.84-1.15,1.09-1.9c0.25-0.76,0.87-1.4,1.44-2.16s0.77-1,1.15-1.12c0.38-0.13,2.91,0.06,3.29,0.06,0.37,0,1.96-0.44,2.65-0.56,0.7-0.13,2.71-0.31,3.41-0.57,0.69-0.25,0.25-0.59,0.18-0.84-0.06-0.25-1.27-0.94-1.65-1.06-0.38-0.13-1.12-0.69-1.38-0.94-0.25-0.25-0.5-1.16-0.5-1.16s-0.59-2.96-0.65-3.28c-0.07-0.31-0.75-1.56-0.75-1.56s-0.13-5.18-0.13-5.63c0-0.44-0.68-2.02-1.37-2.34-0.7-0.32-0.91-0.99-0.91-1.5s0-0.96-0.12-1.59c-0.13-0.64-0.75-1.37-1-1.88-0.26-0.5,0.12-0.78,0.12-1.22s-0.12-1.18-0.5-1.5c-0.38-0.31-0.68-0.49-0.94-0.75-0.25-0.25-0.46-0.9-0.46-1.53s0.28-1,0.34-1.31c0.06-0.32,0.06-1.09-0.06-1.53-0.13-0.44-0.35-1.06-0.41-1.31-0.06-0.26-0.37-1.22-0.37-1.22s-0.5-0.44-0.69-0.44-0.94-0.19-0.94-0.19l-1.78-0.31s-1.69-0.44-1.81-0.69c-0.13-0.25-1.04-0.69-1.04-0.69l-1.56-0.59zm7.25,70.22c-0.88,0.44-1.12,0.43-1.06,1s0.37,1.09,0.63,1.47c0.25,0.38,0.44,0.93,0,1.44-0.45,0.5-1.45,0.52-1.19,1.15,0.25,0.63,0.49,1.06,0.75,1.31,0.25,0.26,0.81,0.9,0.94,1.41,0.12,0.51-0.01,1.06,0.31,1.56,0.31,0.51,0.31,0.69,0.69,0.69,0.37,0,0.59,0.32,0.65-0.5s-0.06-0.95,0-2.84c0.06-1.9,0-2.84,0.06-3.41,0.07-0.57,0.26-1.37,0-1.75-0.25-0.38-1.28-0.9-1.4-1.22-0.13-0.31-0.38-0.31-0.38-0.31zm58.91,12.47c-1.07,0.71-1.16,0.62-1.16,1.15,0,0.54-0.18,0.9,0.53,0.72,0.72-0.18,0.91-0.18,1-0.62,0.09-0.45-0.37-1.25-0.37-1.25zm-10.97,4.53c-0.63,0.45-1.08,0.2-0.81,1.09,0.27,0.9,0.44,1.16,1.15,1.25,0.72,0.09,0.73,0.1,2.07,0.1s2.31,0.06,3.03,0.06c0.71,0,0.99,0.36,1.43,0,0.45-0.36,0.63-0.07,0.54-0.78-0.09-0.72-1.24-0.9-2.22-0.81-0.98,0.08-1.52,0.34-3.13-0.19-1.6-0.54-2.06-0.72-2.06-0.72z",
  "city_population": 245625,
  "fed_okrug": "Дальневосточный федеральный округ",
  "country_population": 69116,
  "area": 464275,
  "city_natural_increase": 720,
  "city_migration_increase": -640,
  "country_natural_increase": -210,
  "country_migration_increase": -1023,
  "average_nominal_wage": 57404,
  "average_consumer_rate": 22149,
  "average_annual_buzy": 182.7,
  "per_capita_income": 41102,
  "kladr": "4100000000000"
}, {
  "id": 391,
  "name": "Приморский край",
  "path": "m852.68,473.71c0,0.53571,0.53571,1.25,0.53571,1.25l1.4286,1.4286s0.35715,1.0714,0.44643,1.4286c0.0893,0.35714-0.625,2.0536-0.625,2.0536l-1.1607,2.7679s-0.0893,2.2321,0,2.5893c0.0893,0.35715,0.625,1.0714,0.89285,1.5179,0.26786,0.44643,0.80358,1.1607,0.80358,1.5179,0,0.35714-0.80358,1.9643-0.80358,1.9643v1.9643c0,0.44643-0.44642,1.9643-0.44642,1.9643s-0.17858,0.0893-0.17858,1.0714v2.7679c0,0.71429-0.26785,3.0357-0.35714,3.3929-0.0893,0.35714-1.9643,0.53571-2.3214,0.53571-0.35714,0-1.3393-0.98214-1.3393-0.98214s-0.98215-1.6071-1.1607-2.0536c-0.17857-0.44643-1.3393-1.5179-1.3393-1.875,0-0.35715-0.26786-1.6072-0.89286-1.7857-0.625-0.17857-1.5179,0.26786-1.5179,0.26786s-0.53571,0.89286-0.625,1.25c-0.0893,0.35714,0,0.98214-0.0893,1.4286-0.0893,0.44643-0.71429,2.5-0.71429,2.5s-0.625,0.625-1.1607,0.89286c-0.53572,0.26786-2.2322,1.0714-2.2322,1.6071,0,0.53572,1.0714,0.71429,2.1429,2.0536,1.0714,1.3393,3.125,4.6429,3.125,4.6429l2.5,4.2857,1.4286,4.9107s0.44643,1.6071,0.625,2.1429c0.17857,0.53571,0.89286,1.1607,0.98215,1.9643,0.0893,0.80357,0.53571,2.5-0.35715,2.8571-0.89285,0.35715-4.0178,1.0714-4.0178,1.0714l-0.71429,0.625,1.1607,0.71429s0.625,0.44643,1.0714,0.53571c0.44643,0.0893,0.53572,1.4286,0.98215,1.4286,0.44642,0,1.875-0.35714,2.4107-0.71428,0.53571-0.35714,1.3393-0.625,2.1429-0.625,0.80357,0,1.4286-0.44643,1.4286-1.0714,0-0.625-0.625-3.3929-0.625-3.8393,0-0.44642,1.5179-2.5893,1.5179-2.5893v-2.1429c0-0.35714-0.17858-1.4286,0.35714-1.5179,0.53571-0.0893,2.9464-0.71428,2.9464-0.71428s0-1.1607,1.0714-0.26786c1.0714,0.89286,1.5178,2.9464,1.5178,2.9464s1.875,0.35714,2.2322,0.17857c0.35714-0.17857,0.98214-0.625,1.5178-0.98214,0.53572-0.35714,2.5893-0.53572,3.3929-0.53572,0.80357,0,2.1429-0.44642,2.1429-0.44642l-0.26786-1.1607s2.0536-1.25,2.5-1.5179c0.44643-0.26785,2.2321-1.1607,2.8571-1.7857s1.5179-1.4286,1.9643-2.4107c0.44643-0.98215,1.3393-3.125,1.5179-3.4822,0.17857-0.35714,1.1607-2.5,1.4286-3.2143,0.26785-0.71429,0.89285-2.3214,1.3393-3.125,0.44643-0.80357,1.5179-2.8572,1.5179-2.8572s-0.0893-2.3214-0.0893-2.8571c0-0.53571-0.26785-1.875-0.625-2.8571-0.35714-0.98214-0.53571-1.1607-0.44642-2.1429,0.0893-0.98214,0.98214-1.6071,1.6071-2.0536,0.625-0.44643,1.0714-1.4286,1.0714-1.9643,0-0.53571-1.25-2.9464-1.25-2.9464s0.0893-1.1607,0.35714-1.6964c0.26786-0.53572,1.5179-1.7857,1.5179-1.7857l0.17857-2.9464s0.80357-2.2321,0.80357-2.6786c0-0.44643,0.26786-3.9286,0.26786-3.9286l0.89285-2.1429s0.26786-3.3928,0.26786-3.9286c0-0.53571-0.53571-5-0.53571-5.5357,0-0.53572-0.17857-4.1071-0.17857-4.7321s-0.71429-2.1429-0.71429-2.5893c0-0.44643,0.0893-2.1429,0.26786-2.5893,0.17857-0.44643,0.98214-1.9643,0.98214-1.9643s-0.0893-2.0536-0.0893-2.5893c0-0.53571,0.17858-1.6964-0.44642-1.7857s-2.3214,0.80357-2.3214,0.80357l-1.7857,0.71429-1.5178,0.17857-0.71429-0.44643-1.0714-1.4286s-0.26786-1.4286-0.26786-1.7857c0-0.35714-0.53571-1.1607-0.53571-1.1607l-1.25-1.3393-1.3393-1.3393-1.4286-0.71429-1.0714,0.17857s-0.98214,0.17858-1.0714,0.53572c-0.0893,0.35714-0.53572,0.44643-0.80358,0.80357-0.26785,0.35714-1.1607,1.3393-1.1607,1.3393l-0.53571,1.0714-0.44643,1.0714-0.80357,0.80357-0.17858,0.71429,0.35715,0.80357,0.89285,0.98214s0,0.71429,0.53572,0.80358c0.53571,0.0893,1.0714,0.0893,1.0714,0.0893h1.3393l1.25,0.625,0.71429,0.80357,0.0893,1.3393-0.26785,1.4286-0.44643,1.25-0.53572,0.71429-1.5178,0.89285-1.7857,0.89286-0.89285,0.89286,0.26785,0.80357,1.9643,0.80357,0.80357,0.98214-0.0893,0.71429-0.80357,1.0714-1.0714,1.0714-1.875,0.89286-1.7857,0.98214-3.64,1.44-1.6964,0.44643-1.9643,0.26786-0.89286-0.44643-1.25-0.71429s-0.53571-0.26786-0.89285,0c-0.35715,0.26786-0.625,0.98214-0.625,0.98214l-1.5179,1.0714-0.53571,1.6964,0.0893,1.3393s0.35714,0.71428,0.44643,1.1607c0.08,0.44,0.08,1.33,0.08,1.33l-0.0893,1.6071-0.98214,1.0714z",
  "city_population": 1484340,
  "fed_okrug": "Дальневосточный федеральный округ",
  "country_population": 440214,
  "area": 164673,
  "city_natural_increase": -447,
  "city_migration_increase": -191,
  "country_natural_increase": -1062,
  "country_migration_increase": -2600,
  "average_nominal_wage": 33807,
  "average_consumer_rate": 21769,
  "average_annual_buzy": 970.5,
  "per_capita_income": 33018,
  "kladr": "2500000000000"
}, {
  "id": 392,
  "name": "Хабаровский край",
  "path": "m809.82,276.93c0.53572-0.71428,1.4286-1.4286,1.9643-2.3214,0.53571-0.89285,1.7857-2.5,1.7857-2.5s1.7857-0.17857,4.1072,0.17858c2.3214,0.35714,4.4643,1.4286,5.7143,2.1428,1.25,0.71429,2.6786,1.25,3.0357,2.3214,0.35714,1.0714,1.6071,2.1429,1.6071,3.3929s-1.4286,3.5714-1.4286,4.2857c0,0.71429-0.17857,2.5,0.71428,3.3929,0.89286,0.89286,0.71429,1.6071,1.7857,1.4286,1.0714-0.17857,3.9286-1.0714,5-1.25,1.0714-0.17857,3.3929,0,5,0.53572,1.6071,0.53571,2.8571,0.89285,3.2143,1.6071,0.35715,0.71428,1.0714,1.4286,0.89286,2.5-0.17857,1.0714-2.5,2.8571-2.5,2.8571l0.17857,1.4286,0.89286,1.6072s1.6071,0.71428-0.35714,0.89285c-1.9643,0.17857-3.0357-0.71428-3.0357-0.71428s0.17857-0.17857,0-1.0714c-0.17857-0.89286-0.71428-1.7857-1.7857-1.4286-1.0714,0.35714-2.3214,1.9643-3.0357,2.5-0.71428,0.53571-2.8571,3.0357-2.8571,3.0357s-1.9643,0.71429-2.8571,1.7857c-0.89286,1.0714-4.1071,4.6428-4.1071,4.6428s-0.17858,1.25-1.0714,2.5c-0.89286,1.25-2.3214,2.3214-2.5,3.5714-0.17857,1.25,0,4.1071,0,4.1071s1.4286,1.0714,1.6071,2.3214c0.17857,1.25-0.89286,1.9643-1.25,2.8572-0.35714,0.89285-1.4286,0.53571-1.4286,1.7857s0.17857,5.7143,0.17857,5.7143l-0.35714,4.8214-0.35715,4.1072s-1.0714,1.9643-1.25,3.2143c-0.17857,1.25-0.35714,2.6786-0.35714,3.3929,0,0.71429-0.17857,3.0357-0.17857,3.75,0,0.71429-0.71429,1.9643-0.89286,2.6786-0.17857,0.71429-1.0714,1.25-0.17857,1.9643,0.89286,0.71428,1.9643,1.9643,1.9643,1.9643l-1.7857,3.3929-0.17857,1.9643-1.7857,3.3928-1.25,3.75-0.35715,4.1072-0.71428,1.6071-3.2143,4.1071,0.35715,2.6786s2.1428,1.0714,2.8571,1.0714c0.71428,0,3.3929,0.53572,4.4643-0.17857s2.5-1.4286,3.2143-1.7857c0.71429-0.35715,1.6071-0.89286,2.8571,0.35714s2.5,4.4643,2.5,4.4643,0.17857,1.4286,1.4286,1.0714c1.25-0.35714,1.9643-2.1428,1.9643-2.1428l-1.0714-2.1429,0.53572-2.6786-0.53572-1.7857-1.6071-2.5s-1.7857-1.4286-2.5-1.4286c-0.71429,0-3.75,1.4286-3.75,1.4286s-1.9643,2.3214-1.6071,1.4286c0.35714-0.89285,1.9643-3.3928,1.9643-3.3928l1.6071-0.35715,1.25-1.7857s0.89286-0.71429,1.9643-0.71429,3.2143-1.25,3.2143-1.25,1.25-2.6786,1.0714-0.89285c-0.12,1.78-1.72,4.28-1.72,4.28l1.0714,2.1429,1.9643,2.1429,0.53572,1.7857-0.17857,2.6786,2.3214,1.4286v1.6072,2.8571l1.7857-0.71429c0.71429-0.71428,2.1429-4.2857,2.1429-4.2857l0.89285-3.2143v-2.1428s-1.6071-1.7857-0.89285-1.9643c0.71428-0.17857,4.6428-2.1429,4.6428-2.1429s2.1429-0.53571,3.0357-0.53571c0.89286,0,4.1071,0.17857,4.8214,0.35714,0.71428,0.17857,4.4643,1.6071,4.4643,1.6071s4.4643,1.25,5.1786,1.25c0.71429,0,1.9643,1.7857,1.9643,1.7857s-0.89286,1.9643,0.53571,2.8571c1.4286,0.89286,4.8214,3.0357,4.8214,3.0357l3.75,2.1428s1.4286,3.3929,1.4286,4.2857c0,0.89285-0.17857,4.6428-0.17857,5.7143,0,1.0714,0,5,0.53572,5.7143,0.53571,0.71428,1.0714,2.3214,2.1428,3.2143,1.0714,0.89286,3.2143,4.2857,3.2143,4.2857l2.5,1.25,3.0357,6.9643s1.4286,1.4286,1.6072,2.3214c0.17857,0.89286,1.6071,3.0357,1.7857,3.75,0.17857,0.71429,1.6071,5,1.7857,5.7143,0.17857,0.71428-0.53572,8.5714-0.53572,8.5714l0.53572,3.3928s0,1.25-0.89286,1.9643c-0.89286,0.71429-3.5714,1.6071-3.5714,1.6071l-1.4286,0.17857-1.4286-1.7857-0.53572-2.6786-3.0357-3.0357s-1.9643-1.25-2.6786-0.71428c-0.71429,0.53571-2.3214,1.9643-2.3214,1.9643s-0.89286,1.7857-1.25,2.5c-0.35714,0.71429-1.4286,1.25-0.89286,2.3214,0.53572,1.0714,1.9643,2.6786,1.9643,2.6786s0.35714-0.71428,2.1428-0.53571c1.79,0.18,2.14,2.68,2.14,2.68l-0.89286,3.2143s-1.9643,1.25-2.6786,1.6071c-0.71428,0.35714-2.8571,1.25-1.7857,2.1429,1.0714,0.89285,2.3214,1.25,2.3214,1.25s0.71428,1.25,0,1.9643c-0.71429,0.71429-2.3214,2.1429-2.3214,2.1429s-1.7857,0.35714-3.0357,1.25-3.2143,1.4286-4.2857,1.6071c-1.0714,0.17857-2.8571,1.25-4.1071,0s-2.1429-0.89285-2.5,0.17857c-0.35715,1.0714-1.6072,0.89286-1.7857,1.9643-0.17857,1.0714,0,2.8571,0.35715,3.5714,0.35714,0.71428,0,3.0357,0,3.0357s-2.3214,1.9643-2.5,1.25c-0.17858-0.71428,0.17857-2.3214-0.35715-3.2143-0.53571-0.89286-2.3214-2.5-2.3214-2.5s-2.8571-1.4286-1.7857-2.3214c1.0714-0.89286,2.8571-2.6786,3.2143-3.2143,0.35714-0.53571,0.35714-3.0357,0.35714-3.0357s-2.1429-0.89286-2.6786-1.7857c-0.53572-0.89285-1.0714-3.3928-1.0714-4.1071,0-0.71428-0.71429-3.3929,0.17857-3.75,0.89286-0.35714,2.8571-1.9643,2.8571-1.9643l0.53572-1.9643s-0.53572-0.35714-2.1429-0.35714c-1.6071,0-2.5-0.17857-3.9286,0.89285s-1.4286,1.0714-2.5,2.5-2.1429,2.6786-3.2143,3.2143c-1.0714,0.53571-2.6786,0.71429-2.6786,0.71429s-4.1071-0.71429-4.2857-1.4286c-0.17857-0.71428-1.6072-1.9643-2.5-1.9643-0.89286,0-2.1429,0.35714-3.2143,0.89286-1.06,0.55-1.95,0.73-2.84,0.73-0.89286,0-4.2857,1.0714-4.2857,1.0714s-2.1428,1.7857-3.2143,1.7857c-1.0714,0-2.1014,0.40945-2.28-0.66198-0.17857-1.0714-1.0823-3.4216-1.0823-3.4216l-1.5332-4.3507s-2.6677-0.69261-3.7392-0.87119c-1.0714-0.17857-3.8221-0.85138-3.8221-0.85138l-2.4892-1.1525s-2.1249-2.2078-1.7678-2.9221c0.35714-0.71428,1.7028-4.0044,2.4171-4.5401,0.71428-0.53572,1.2608-1.4069,1.2608-1.4069l-1.25-2.3214s-1.7965-1.2085-0.90368-1.7442c0.89286-0.53571,3.7608-2.0058,3.7608-2.0058l2.0906-4.0892,1.5025-3.2341,3.5498-2.6767-0.89285-1.9643-2.4171-1.7118-0.11357-1.6288,2.5306-1.1237,4.1071-0.71428,2.6786-0.89286,1.0714-1.25-0.53571-1.6071-1.986-1.47-1.0083-2.5108-0.0631-2.4477-1.47-2.0058-1.7226-0.67282-2.2583,1.7442s-1.6703,1.0823-2.3846,1.4394c-0.73,0.34-2.87,0.19-2.87,0.19l-2.3214,1.25-0.44008,2.5-0.80992,2.3214-2.5,1.0714-2.1429,0.53571-0.53571,2.4585-1.4809,1.4286-2.3431-0.17857-0.99746-2.4585-1.0714-2.5s-1.2608-0.51404-1.9751-0.69262c-0.71428-0.17857-4.4534,0.51405-4.4534,0.51405l-1.7857-0.17857-1.7857-1.25,1.9643-5.5357,0.89286-4.1072s1.25-2.3214,1.9643-3.0357c0.71428-0.71429,3.0357-5,3.0357-5l0.35714-2.6786s-0.53571-1.25-1.6071-1.6072c-1.0714-0.35714-5.3571,0.17858-5.3571,0.17858l-2.6786,0.53571s-3.3424,2.5325-4.0567,1.8182c-0.71428-0.71429-1.1219-3.9611-1.1219-3.9611s-3.0376-1.6288-3.0376-2.5217c0-0.89286,1.9662-1.5855,1.9662-1.5855s0.53571-1.0714,0.71428-2.1429c0.17857-1.0714-0.20024-2.8138-0.20024-2.8138l-2.6281-0.77741s-1.4069-0.89472-2.1212-1.0733c-0.71428-0.17857,1.1996-2.2998,1.1996-2.2998l0.89286-1.6072-0.35714-1.0714s-2.2493-0.54655-2.2493-1.2608c0-0.71429,1.6505-3.3604,1.6505-3.3604l-1.5873-1.6703-2.5415-0.82971-0.80806-1.618s0.69262-0.73594,1.5855-1.0931c0.89286-0.35714,1.0498-0.61866,1.0498-0.61866l-1.3852-0.89286v-2.4062c0-0.71429-0.074-2.3304-0.074-2.3304s-1.2718-1.1078-1.4502-2.345c-0.1894-1.3131,2.6371-1.7532,2.6371-1.7532l-0.93619-0.82972-0.49238-1.4917,0.2417-2.1339,2.7525-0.86037,2.9094-0.89285,2.4477,0.1371,0.70345-1.8922,3.2034,0.21106,2.9203,0.0108s0.35715-1.7749,0.35715-2.4892c0-0.71428-1.8705-1.618-1.4286-2.2691,0.40112-0.59101,1.5657-0.89285,2.4585-1.0714,0.89286-0.17858,3.9286-0.71429,4.1072-1.4286,0.17857-0.71428,2.5829-6.1562,2.5829-6.1562s0.96683-1.0083,1.6811-1.1869c0.71429-0.17857,3.9286-0.93432,3.9286-0.93432l-1.764-2.794-3.0051-2.8246-1.6378-4.8539-2.3214-2.1428-1.4286-1.7857v-5.3571l3.0357-6.7857-1.0714-3.2143-0.72512-5.8585,0.81889-2.85s3.5498,0.11543,4.264,0.29401c0.71428,0.17857,7.7634,0.22004,7.7634,0.22004s0.95599-4.0152,1.3131-4.7295c0.35714-0.71428,1.3871-0.826,2.28-1.0046,0.89286-0.17857,3.3495-0.62051,3.3495-0.62051l2.5433,1.1562,1.6071-1.0714z",
  "city_population": 1095052,
  "fed_okrug": "Дальневосточный федеральный округ",
  "country_population": 239180,
  "area": 787633,
  "city_natural_increase": 644,
  "city_migration_increase": -1888,
  "country_natural_increase": 530,
  "country_migration_increase": -3039,
  "average_nominal_wage": 38041,
  "average_consumer_rate": 26212,
  "average_annual_buzy": 716.5,
  "per_capita_income": 36666,
  "kladr": "2700000000000"
}, {
  "id": 393,
  "name": "Амурская область",
  "path": "m692.32,397.46,4.6429-0.17857,2.3214-0.17858,3.5714-1.7857,2.6786,0.35714,3.5714,1.0714,2.1429,1.0714,2.6786,0.53571,4.4643-0.53571,3.0357,0,2.3214,0.53571,2.8571,2.1429,2.1429,0.89286,2.8571,0.35714,2.3214-1.7857,2.3214-0.71429,1.9643,0,2.1429,1.4286,2.1429,0.71429,2.5-0.71429,1.7857-1.9643,1.7857-1.25,4.1072,0,2.5-1.4286,2.1428-0.89286,3.75,0,1.4286,0,1.25-0.71429,0.53571-2.5,1.6071-1.0714,4.2857-2.3214,2.3214-0.89286,3.5714-1.9643,2.8572-1.4286,5-0.89286,3.0357,0,1.6071,1.4286l-0.37,3.2s-1.25,1.6071-1.9643,2.6786c-0.71429,1.0714-1.6072,2.6786-1.9643,3.3929-0.35714,0.71429-1.25,2.1429-1.25,2.1429s-0.53571,2.8571-0.71429,3.5714c-0.17857,0.71428-1.0714,2.8571-1.0714,2.8571s-1.25,1.7857-1.0714,2.5c0.17857,0.71428,1.25,1.25,1.25,1.25l0.89285,0.71428,3.2143-0.71428s1.7857-0.17857,2.6786-0.17857c0.89286,0,2.5,0.89285,2.5,0.89285l0.53572,1.9643,0.89285,2.6786s0.17857,0.53572,1.6072,0.53572,2.6786-1.4286,2.6786-1.4286l0.17857-2.3214s1.0714-0.89286,1.9643-0.89286c0.89286,0,2.5-0.53572,2.5-0.53572l1.25-2.1428,0.35715-2.5,1.9643-1.7857,2.3214,0.17857c0.71,0.19,3.03-1.6,3.03-1.6l1.4286-1.4286s0.89285-1.0714,1.9643-0.35714c1.0714,0.71428,2.3214,2.5,2.3214,2.5v2.8571l0.53572,1.6071,1.9643,1.7857s1.6071,0.71428,1.25,1.6071c-0.35714,0.89286-2.8571,1.9643-3.5714,1.9643-0.71428,0-3.5714,0.89285-3.5714,0.89285l-1.6071,0.17857-1.96,0.89s-0.71429,0.17857-0.17858,1.0714c0.53572,0.89286,1.9643,1.7857,1.9643,1.7857l1.25,0.89286,0.35714,1.9643-3.2143,2.3214-1.6072,3.0357-0.17857,2.1429-1.6071,2.3214-2.6786,0.89285-1.6071,1.4286,1.9643,1.9643,0.35714,1.7857-2.3214,2.3214-1.25,3.5714,1.6071,2.8571s3.5714,1.4286,4.2857,1.6072c0.71429,0.17857,4.8214,0.71428,4.8214,0.71428s1.4286,0.71429,1.9643,1.25c0.53571,0.53572,0.71428,3.2143,0.71428,3.2143l0.35715,2.5s0,0.53571,0.71428,1.0714c0.71429,0.53571,0,3.5714,0,3.5714l-0.71428,2.8571-0.53572,1.7857-1.25,1.7857-3.2143,0.35714-4.1072-0.17857-2.8571-1.4286-1.77-0.53-3.04,1.07h-3.3929-2.5l-3.2143,0.89286s-2.6786-0.35714-3.5714-0.53572c-0.89286-0.17857-3.5714-2.1428-3.5714-2.1428l-3.22-2.67-1.07-2.15-1.43-2.14-1.7857-1.0714-1.0714-1.9643s0-1.0714-0.71428-1.6072c-0.71429-0.53571-2.6786-0.71428-2.6786-0.71428l-0.89286-1.25-1.7857-2.8571-1.9643-2.5s-1.25-1.4286-1.9643-1.6072c-0.72-0.18-1.79-0.36-2.15-1.43-0.35715-1.0714-2.3214-2.6786-2.3214-2.6786l-2.8572-1.4286-2.6786-1.4286-3.0357-0.17857-2.6786-0.17858s-0.71429,0.89286-1.6072,1.0714c-0.89285,0.17857-4.4643-0.35714-4.4643-0.35714l-3.5714-1.25-2.3214,0.35714-1.9643,0.89286-1.6072,1.4286-3.75,0.71429s-3.2143,0.71428-3.3928,0c-0.17858-0.71429-2.8572-4.1072-2.8572-4.1072l-1.7857-1.4286h-1.6071l-1.0714-1.0714v-2.1428l2.1428-2.1429,0.17858-1.4286-0.89286-1.4286-1.25-0.89286-2.1429-0.17857s-0.71428,1.0714-0.71428,0,0.71428-3.3929,0.71428-3.3929l0.89286-2.3214-0.35714-1.9643-1.25-1.7857-1.7857-0.71428-1.25,0.71428-1.25,0.71429-1.25-0.17857s-0.35714-0.71429-0.35714-1.4286c0-0.71429-1.25-2.6786-1.25-2.6786l-0.71429-0.71428-1.7857-0.17857-0.89286,0.89285-1.4286,0.89286-2.5,0.53572s-0.35714-0.35715-0.17857-1.0714c0.17857-0.71429,0.71428-2.5,0.71428-2.5l-1.25-1.4286-0.51-0.52-1.79-0.18h-2.1429l-0.35714-1.0714v-2.1429z",
  "city_population": 539535,
  "fed_okrug": "Дальневосточный федеральный округ",
  "country_population": 262216,
  "area": 361908,
  "city_natural_increase": 36,
  "city_migration_increase": -2581,
  "country_natural_increase": -452,
  "country_migration_increase": -1187,
  "average_nominal_wage": 32902,
  "average_consumer_rate": 20336,
  "average_annual_buzy": 422.1,
  "per_capita_income": 30232,
  "kladr": "2800000000000"
}, {
  "id": 394,
  "name": "Магаданская область",
  "path": "m859.64,182.46s1.0714,0.71428,2.1429,1.25c1.0714,0.53571,3.0357,2.1429,3.2143,2.8571,0.17857,0.71429,0.17857,2.3214,1.0714,2.8571,0.89286,0.53572,3.5714,1.0714,3.5714,1.0714l1.9643,0.89286,1.0714,1.7857,3.0357,1.6072s0.71429,1.0714,0.17857,1.9643c-0.53571,0.89286,0,2.6786,0,2.6786l2.5-0.35714,2.8572,0.35714,1.6071,2.3214,1.9643,2.6786,2.1429,1.0714,1.9643,2.1429,1.0714,1.9643,0.17857,2.5s-0.35715,2.5,0,3.2143c0.35714,0.71429,1.0714,3.75,1.0714,3.75l1.0714,1.7857s0.53572,1.0714,0.53572,1.7857c0,0.71428-0.89286,2.1429-0.89286,2.1429l0.17857,1.7857-1.9643-0.53571-0.35715-1.9643s0.35715-0.71429-0.53571-0.35714c-0.89286,0.35714-1.7857,1.4286-1.7857,1.4286s-0.35715,0.89286-1.0714-0.53572c-0.71429-1.4286-1.7857-1.9643-1.7857-1.9643s-1.6071-0.71429-1.6071-1.9643-1.7857-2.3214-1.7857-2.3214l-1.6072-1.4286s-0.35714,1.7857-0.35714,2.5c0,0.71429,1.4286,1.4286-0.35714,1.4286s-4.1072,0.71429-4.1072,0.71429l-0.89285,1.0714-0.35715,2.6786-1.25,1.25-2.6786,2.8571-0.35714,2.3214-1.0714,1.9643,0.53572,2.3214,1.4286,1.4286s0.53571,0.71428,0.53571,1.4286v2.6786l0.17857,1.6071,1.6072,1.4286,0.17857,4.4643v4.4643l0.17857,3.0357,1.7857,2.6786,1.0714,3.0357,0.35714,0.89285,1.9643,0.35715,1.0714-1.25,1.9643-1.0714s1.6072-0.17857,2.3214-0.17857c0.71429,0,1.6072,0.89285,1.6072,0.89285l0.17857,0.89286-1.7857,1.4286-1.7857,0.71429v1.0714l-0.71429,0.89285-1.7857,0.89286-1.25,0.53571-0.53572,0.71429-0.17857,2.6786v2.3214l-0.89285,0.71429-1.7857-0.89286-0.71428,1.4286-0.53572,2.5-1.0714,1.25-3.2143,0.71429-1.25-0.17858-0.53572-1.6071,2.5-1.6071,1.25-1.9643s1.9643-1.7857,0.53572-1.7857-2.6786,1.0714-2.6786,1.0714l-0.89286,1.25-0.89286,0.53571s-0.89286,0.35714-1.7857-0.17857c-0.89286-0.53571-2.3214-0.71429-2.3214-0.71429s-1.25,0.89286-1.25,1.4286c0,0.53571,0.35714,1.4286-0.53572,1.4286-0.89285,0-3.2143,0.17857-3.2143,0.17857l-2.5,1.6071-2.5,0.89286-1.0714,2.1429,0.35714,1.7857,0.53572,1.9643,0.35714,0.89285,1.6071,1.0714s0.17857,0.89286-1.7857,0.89286h-4.4643l-1.0714,2.1429-1.0714,1.25-2.5,0.35714-2.1429-2.8571-2.6786-1.25s-1.9643-0.71429-2.6786-0.71429c-0.71429,0-3.3929,0.17857-3.3929,0.17857l-2.1429,0.89286-1.7857,0.17857-1.25-0.89286-1.0714-1.7857-0.17857-2.3214,1.25-1.9643,0.17857-2.5-2.5-3.9286-2.3214-1.4286-2.3214-1.25-2.6786-0.71428-2.6786-0.71429-2.1429,0.71429-1.0714,1.4286-1.0714,1.9643-0.89285,1.25h-1.25l-1.25-1.9643-0.17857-0.89286,1.25-0.71429,0.35714-1.4286v-1.25l-1.25-1.25-5.7143-6.7857s-0.35714-1.0714-0.35714-1.7857v-3.2143l-1.78-0.88-0.89286-0.35714-0.17857-3.0357-0.53572-1.4286-1.0714-0.35714-0.35714-1.25,1.6071-1.4286,2.1429-0.17857,1.0714-0.53572,1.0714-1.0714,2.1429-0.17857,1.9643,0.17857,0.53572-1.0714-1.25-1.9643-1.4286-1.25-0.35714-2.1429s1.25-0.53571,1.9643-0.53571c0.71428,0,3.5714-1.0714,3.5714-1.0714l-0.17858-2.6786s0.53572-0.35714,1.25-0.35714c0.71429,0,3.9286,0.35714,3.9286,0.35714l2.1428-1.7857,4.1072-6.4286-0.17858-3.0357-1.4286-1.4286-2.6786-2.8572s-1.25-0.89285-1.4286-1.6071c-0.17857-0.71428-0.35714-1.7857-0.35714-1.7857l2.1428-2.3214,0.17858-1.6071-1.25-1.25-2.5,0.17857-0.71429-0.53572-1.0714-1.0714v-0.71429l3.06-0.86,1.25-1.0714-0.53572-1.4286-1.25-0.89285-0.17857-1.6072,2.1429-3.0357,3.75-1.25,2.1428-1.25-1.25-2.5s0.17858-0.35714,0.89286-0.35714c0.71429,0,3.3929,0.71428,3.3929,0.71428l1.0714-0.17857-0.53572-3.5714v-1.6071l1.4286-0.53572,0.2-2.66-0.17858-0.53571h2.5l1.6072,0.53571,0.53571,1.9643,1.0714,1.0714s0.53571,0.53571,1.25,0.53571,3.75-0.71428,3.75-0.71428l3.5714-0.71429,2.3214-0.35714,2.6786-1.0714,2.3214-1.4286,2.3214-0.89286,1.9643-0.17857,2.8571-0.35714,2.5-1.6072z",
  "city_population": 139298,
  "fed_okrug": "Дальневосточный федеральный округ",
  "country_population": 6248,
  "area": 462464,
  "city_natural_increase": 81,
  "city_migration_increase": -1618,
  "country_natural_increase": -76,
  "country_migration_increase": -113,
  "average_nominal_wage": 65996,
  "average_consumer_rate": 25362,
  "average_annual_buzy": 85.7,
  "per_capita_income": 50262,
  "kladr": "4900000000000"
}, {
  "id": 395,
  "name": "Сахалинская область",
  "path": "M973.16,321.59c-0.45,0.19-0.81,0.37-1.19,0.94s-0.31,1.53-0.5,1.85c-0.19,0.31-1.53,1.12-1.53,1.12-0.51,0.51-0.87,1.06-2,1.25-1.14,0.19-2.59-0.23-2.85,0.66-0.25,0.88,0.06,2.12,0.69,2.25,0.63,0.12,1.53,0.44,2.1,0.25,0.56-0.19,1.56-1.25,1.56-1.25s0.62,0.3,1,0.93c0.38,0.64,0.97,1.78,0.97,2.03,0,0.26,0.19,1.06-0.07,1.57-0.25,0.5-0.81,2.78-0.56,3.03s1.24,0.9,1.94,0.9c0.69,0,1.09,0.17,1.78-0.78,0.69-0.94,0.93-1.74,1.25-2.56s0.78-1.9,1.09-2.16c0.32-0.25,0.48-1.02-0.22-1.65-0.69-0.63-0.93-1.75-1-2.06-0.06-0.32-0.56-1.09-0.24-1.53,0.31-0.45,1.12-1.31,1-1.69-0.13-0.38-1.38-1.09-1.82-1.47s-0.96-1.82-1.4-1.63zm2.15,20.44s-0.43,0.15-0.69,0.85c-0.25,0.69-0.5,1.74-0.31,2.31s0.56,1.4,0.81,1.78c0.26,0.38,0.75,1.31,0.88,1.62,0.13,0.32,0.53,0.72,1.03,0.91,0.51,0.19,1.12,0.07,1.25-0.44,0.13-0.5,0.19-1.4,0.19-2.03s-0.19-2.15-0.19-2.53,0.07-0.87-0.31-1.31-2.66-1.16-2.66-1.16zm2.53,9.22c-0.56,0.19-1.9,0.5-2.15,0.69-0.26,0.19-0.63,0.52-0.5,1.03,0.12,0.5-0.2,1.24,0.5,1.69,0.69,0.44,2.15,0.96,2.53,1.09s0.55,0.44,1.19,0.13c0.63-0.32,1.09-0.59,1.03-1.41-0.07-0.82-0.59-1.62-0.78-1.88-0.19-0.25-1.5-1.34-1.5-1.34h-0.32zm-117,4.5l-1.87,1.25s0.5,1.12,0,1.12h-1.78s-1.26,0.78-0.5,1.29c0.76,0.5,2.4,0.87,3.03,1,0.63,0.12,1.52,0.65,2.16,1.15,0.63,0.51,1.49,0.87,1.74,1.63,0.26,0.76,0.63,2.28,0.63,2.28l0.91,1.62-0.54,2.16-1.74,0.13s-0.91-1.14-1.41-0.13c-0.51,1.01-0.5,1.77-0.5,2.41,0,0.63,0.27,1.24,0.91,1.37,0.63,0.13,1.48,0.4,2.74,1.41,1.27,1.01,2.03,2.9,2.29,3.53,0.25,0.63,0.24,2.65,0.5,3.41,0.25,0.75,1.4,2.02,2.03,2.53,0.63,0.5,2.03,2.52,2.28,3.03,0.25,0.5,1.25,2.4,1.5,2.9,0.25,0.51,1.78,1.75,1.78,1.75s1.24,1.15,2,1.66,3.8,1.37,4.56,1.37,3.03,0.66,3.28,1.16c0.26,0.51,2.78,5.66,2.78,5.66l5.57,8.34s2.52,2.15,3.15,2.66c0.64,0.5,2.4,3.9,2.91,4.65,0.51,0.76,2.12,4.44,2.5,4.94,0.38,0.51,3.69,5.06,3.69,5.06s2.77,1.88,3.4,2c0.64,0.13,3.41,1.91,3.41,1.91s2.65,2.9,2.78,3.41c0.13,0.5,0.75,3.53,0.75,3.53l2.16,3.4,3.15,2.66,2.5,5.19,0.53,2.25s0,2.15,0.5,2.53c0.51,0.38,5.29,4.06,5.29,4.06l1.65,0.88,1.78,0.25v-2.54s-0.9-1.65-1.15-2.15c-0.26-0.51-0.88-3.03-0.88-3.03s-0.5-0.74-0.5-1.63c0-0.88,0.75-2.4,0.75-2.4s1.53-0.25,2.16-0.25,1.24-0.12,2.25-0.63c1.01-0.5,2.41-0.37,2.41-0.37l2.28,2,1.37,0.78s0.5-1.4,0.5-2.03c0-0.64,0.01-1.53-0.62-2.41-0.64-0.88-1.63-1.88-1.63-1.88l-2.03-1.65s-0.99-1.38-1.75-1.25-1.15,0.24-1.41,0.75c-0.25,0.5,1.52,2.66,0,2.28-1.51-0.38-2.4-0.9-2.78-1.41-0.38-0.5-1.62-1.87-1.62-1.87s-2.4-1.28-3.03-1.53c-0.64-0.26-2.4-0.88-3.04-0.88-0.63,0-4.06-1.15-4.06-1.15l-2.12-2.38-2.41-6.31s-1.12-1.65-1.25-2.41-1.03-3.15-1.16-3.65c-0.12-0.51-0.37-2.28-0.62-2.78-0.25-0.51-1-2.29-1-2.29l-0.53-3.28,1.78-1.62s2.77-1.03,3.41-1.03c0.63,0,5.06-0.13,5.06-0.13l2.4,0.63s2,0.25,2.5,0.25c0.51,0,1.03,0.51,1.16-0.5s-1.53-2-1.53-2l-3.53-0.53-3.66-1.26-2.4-1.78-18.57-15.25-1.5-1.28-1.78-0.12s-0.87,0.13-1.25-0.63-0.4-1.27-1.15-1.9c-0.76-0.64-2.5-1.88-2.5-1.88s-1.52-0.25-2.66-0.5-3.66-1.4-3.66-1.4l-0.4-2.79-1.38-1.25-0.62-1.28,1.25-1.62-0.25-1.91-2.53-2.12-3.54-0.79s-2.4-0.99-2.65-1.5c-0.25-0.5,0.12-2.15,0.12-2.15s-0.62-1.12-1.12-1.5c-0.51-0.38-4.28-1.91-4.28-1.91l-2.91-1.9-1.03-2.63s0.01-1.91-0.63-1.91c-0.63,0-2.78-0.87-2.78-0.87zm119.16,7.94c-0.88,0.25-1.53,0.4-1.72,0.97-0.19,0.56,0.06,1.24,0.31,1.43,0.26,0.19,0.84,0.69,1.47,0.57,0.63-0.13,1.56-0.19,1.82-0.57,0.25-0.38-1.13-1.46-1.32-1.78-0.19-0.31-0.56-0.62-0.56-0.62zm1.75,4.06c-0.51,0.25-1.19,0.56-1.37,1.06-0.19,0.51,0.36,1.37,1,1.75,0.63,0.38,1.05,0.63,1.56,0.06,0.5-0.56,1.09-1.62,1.03-1.93-0.06-0.32-2.22-0.94-2.22-0.94zm0.19,6.97c-0.18,0.01-0.34,0.06-0.5,0.16-0.63,0.37-0.82,1.18-0.82,1.56s0.88,3.09,0.88,3.47-0.87,2.4-1,2.9c-0.13,0.51-0.01,1.33,0.62,2.6,0,0,1.13-0.25,1.38-0.25s1.72-0.94,1.84-1.19c0.13-0.25,0.44-2.28,0.44-2.91s-0.06-2.02-0.12-2.47c-0.07-0.44-0.63-1.4-0.63-1.78s-0.31-1.43-0.69-1.69c-0.28-0.18-0.87-0.44-1.4-0.4zm-4.41,14.53s-1.28,0.03-1.53,0.16c-0.25,0.12-0.69,0.49-0.81,0.75-0.13,0.25-0.57-0.07,0.06,0.62,0.63,0.7,1.02,1.38,1.66,1.38,0.63,0,2.06,0.65,2.31,0.65s1.03-0.21,1.22-0.47c0.19-0.25,0.75-0.49,0.31-1.18-0.44-0.7-0.97-1.06-1.22-1.19s-2-0.72-2-0.72zm1.81,6.47c-0.19,0.31-1.37,1.18-1.43,1.44-0.07,0.25-0.32,0.74-0.38,1.25-0.06,0.5-0.31,1.77-0.31,2.09s-0.53,1.59-0.78,2.16c-0.26,0.56-0.5,1.49-0.44,2.12s-0.07,1.09,0.19,1.66c0.25,0.57,0.24,1.18,0.56,1.37s-0.04,1.29,1.09,0.6c1.14-0.7,1.63-1.34,1.82-1.79,0.19-0.44,0.53-2.09,0.72-2.34,0.18-0.25,0.56-1.43,0.68-1.81,0.13-0.38,0.63-1.9,0.63-2.22s0.06-1.59-0.25-2.22c-0.32-0.63-1.19-1.31-1.19-1.31l-0.91-1zm-4.9,15.4c-0.26,0.07-0.97,0.19-1.28,0.44-0.32,0.26-0.63,0.56-0.69,0.75s-0.5,0.94-0.5,1.19,0.06,1.15,0,1.41c-0.06,0.25,0,0.56-0.56,0.81-0.57,0.25-1.22,0.43-1.6,0.56s-0.81,0.44-1.06,0.69-0.94,0.72-0.94,0.72-0.53,0.18-0.53,0.5c0,0.31,0.41,0.99,0.53,1.25,0.13,0.25,0.75,1.22,0.75,1.22l-0.18,0.75s-1.04,0.74-1.1,1.06c-0.06,0.31-0.12,1.59-0.12,1.97s0.06,1.74,0.06,2c0,0.25,0.19,1.84,0.19,2.09s0.15,1.34,0.28,1.97c0.12,0.63,0.12,1.06,0.43,1.44,0.32,0.38,0.56,1.03,0.88,1.22s0.5,0.68,0.88,0.62c0.37-0.06,1.71-1.03,1.71-1.03s0.63-0.62,0.75-1.06c0.13-0.44,0.44-2.16,0.44-2.16s0.19-1.37,0.13-1.69c-0.07-0.31-0.69-0.65-0.75-1.22-0.07-0.56-0.07-0.8,0-1.68,0.06-0.89,0.87-2.09,1.06-2.35,0.19-0.25,0.84-1.18,0.97-1.93,0.12-0.76-0.07-1.84,0.19-2.16,0.25-0.32,0.8-0.75,1.06-1.06,0.25-0.32,1.06-1.65,1.18-2.03,0.13-0.38,0.13-1.4,0.13-1.91s-0.31-1.37-0.56-1.56c-0.26-0.19-1.75-0.82-1.75-0.82zm-8.35,23.69c-0.31-0.01-0.62,0-0.75,0.03-0.25,0.07-0.56,0-0.81,0.32-0.25,0.31-0.78,0.71-1.22,0.84s-0.87,0-0.93,0.31c-0.07,0.32-0.26,0.87-0.26,1.13,0,0.25,0.06,0.74,0.32,1,0.25,0.25,0.62,0.21,0.75,0.78,0.12,0.57,0.19,1.18,0.12,1.44-0.06,0.25-0.31,1.12-0.37,1.43-0.07,0.32-0.19,0.4-0.38,1.03-0.19,0.64-0.31,1.38-0.31,1.76v1.15c0,0.38-0.06,1.19,0.13,1.44,0.18,0.25,0.62,0.56,0.87,0.81s1.47,0.47,1.72,0.47,0.5-0.28,0.75-0.66,0.56-0.99,0.56-1.56-0.12-2.96-0.06-3.28,1.12-0.84,1.19-1.41c0.06-0.56,0.03-1.74,0.09-2,0.06-0.25,0.31-1.15,0.31-1.15s0.75-0.44,0.88-0.81c0.12-0.38,0.25-1.13,0.25-1.5,0-0.38-0.19-1.54-0.19-1.54h-1.84c-0.19,0-0.5-0.02-0.82-0.03zm7.85,1.88c-0.57,1.01-0.72,0.99-0.78,1.75-0.07,0.76-0.88,1.53-0.88,1.53s-0.31,0.31-0.44,0.62c-0.12,0.32-0.69,0.81-0.06,1s1.72,0.19,1.97,0.07c0.25-0.13,0.75-0.69,1-0.82,0.25-0.12,0.44-0.49,0.44-1.37,0-0.89-0.19-1.9-0.31-2.16-0.13-0.25-0.94-0.62-0.94-0.62z",
  "city_population": 398621,
  "fed_okrug": "Дальневосточный федеральный округ",
  "country_population": 88370,
  "area": 87101,
  "city_natural_increase": 543,
  "city_migration_increase": -481,
  "country_natural_increase": -347,
  "country_migration_increase": -813,
  "average_nominal_wage": 61311,
  "average_consumer_rate": 32824,
  "average_annual_buzy": 285.4,
  "per_capita_income": 49654,
  "kladr": "6500000000000"
}, {
  "id": 396,
  "name": "Еврейская автономная область",
  "path": "m811.96,462.82c0.98214,1.875,1.1607,1.875,1.875,2.5893l2.6786,2.6786s0.80357,1.1607,1.0714,1.7857c0.26786,0.625-0.0893,1.6964,0.625,1.9643,0.71429,0.26785,2.3214,0.53571,2.7679,0.625,0.44643,0.0893,1.4286,1.0714,2.3214,1.1607,0.89285,0.0893,1.6071,0.0893,2.1428-0.35714,0.53572-0.44643,1.0714-1.25,1.6964-1.7857,0.625-0.53571,2.5893-1.4286,3.125-1.6964,0.53572-0.26785,1.875-0.625,2.3214-1.0714,0.44643-0.44643,1.1607-0.98215,1.1607-2.0536s0.26785-2.7678,0.71428-3.125c0.44643-0.35714,2.9464-1.9643,3.5714-2.5,0.625-0.53571,1.6964-2.2321,2.1429-2.8571,0.44643-0.625,1.875-2.6786,2.2321-3.2143,0.35714-0.53572,2.1429-2.0536,2.1429-2.0536l2.0536-2.3214,0.98214-1.0714,2.6786-1.875,0.71429-0.80357,0.17857-1.1607,0.0893-0.35714-1.5179-0.17857-1.875-0.0893-1.6964,0.44643-1.6964,1.1607-1.3393,1.25-0.80358,1.0714-1.25,1.6072-1.4286,0.98214-1.7857,0.625s-1.25,0.17857-1.7857,0c-0.53571-0.17857-2.1428-0.71429-2.1428-0.71429l-1.4286-0.625-0.80358-0.98214-0.89285-0.625s-0.80357-0.26786-1.1607-0.17857c-0.35714,0.0893-1.7857,0.625-1.7857,0.625l-2.0536,0.71429-2.4107,0.17857s-1.0714,0.44643-1.7857,0.625c-0.71429,0.17857-2.4107,0.80357-2.4107,0.80357l-1.4286,0.89285-1.875,0.26786-0.80357,0.17857-0.35714,0.98215-0.0893,1.4286s-0.44643,1.1607-0.44643,1.5178c0,0.35715-0.53571,1.875-0.53571,1.875l-0.53571,1.1607-0.71429,1.4286z",
  "city_population": 112697,
  "fed_okrug": "Дальневосточный федеральный округ",
  "country_population": 51502,
  "area": 36271,
  "city_natural_increase": -131,
  "city_migration_increase": -830,
  "country_natural_increase": -103,
  "country_migration_increase": -1184,
  "average_nominal_wage": 30896,
  "average_consumer_rate": 15642,
  "average_annual_buzy": 75.1,
  "per_capita_income": 24459,
  "kladr": "7900000000000"
}, {
  "id": 397,
  "name": "Чукотский автономный округ",
  "path": "M906.72,53.094c-0.34,0-0.66,0.094-0.66,0.094l-1.78,2.124-4.47,1.969s-6.05,2.853-7.12,3.031c-1.07,0.179-1.44,1.969-1.44,1.969s0.37,2.514,0.19,3.407c-0.18,0.892-1.44,1.406-1.44,1.406s-2.32,1.428-2.5,2.5c-0.18,1.071,0.91,2.156,0.91,2.156s2.66,0.906,3.37,0.906c0.72,0,2.85-0.375,3.56-0.375,0.72,0-0.34,1.625-0.34,1.625l-0.91,1.782-2.31-0.907-3.03-0.719s-2.14,0.554-3.03,0.376c-0.89-0.179-2.31-1.438-2.31-1.438l-2.69,0.531-2.88,0.375h-1.06s-0.53,2.656-1.25,2.656c-0.71,0-2.12,1.782-2.12,1.782l-3.41,0.187-2.84,2.875s-2.86,2.496-3.75,3.032c-0.9,0.535-1.61,0.531-2.5,0.531-0.9,0-2.5,1.062-2.5,1.062l-4.85,3.219-5.15,1.062-3.07,0.907s-1.04,2.861-1.93,3.219c-0.9,0.357-2.88,1.968-2.88,1.968l-3.22,1.938-2.12,1.966-2.16,3.03-1.25,1.97-1.06,2.5v3.22s-0.91,0.72-1.63,0.72c-0.71,0-2.84,1.25-2.84,1.25s-0.9,2.51-1.44,3.41c-0.53,0.89-2.85,1.76-3.56,2.12s0.34,1.25,0.34,1.25l2.35,0.53,0.53,2.16,2.69,0.53h2.65,3.75s1.44,1.07,1.97,1.78c0.54,0.72,1.63,1.78,1.63,1.78l-1.82,2.5-2.5,1.1-2.31-0.72s-1.6,1.25-2.31,1.25c-0.72,0-2.16,1.59-2.16,1.59s-1.42-0.71-2.31-1.25c-0.89-0.53-1.96,0-3.03,0s-1.26,1.26-1.44,1.97-0.87,2.84-0.87,2.84-1.09,1.79-1.63,2.5c-0.53,0.72-2.66,2.69-3.37,3.22-0.72,0.54-1.81,0.54-4.13,0.72s-1.07,1.26-1.25,2.16c-0.18,0.89-1.06,3.03-1.06,3.03s-2.15,1.24-2.69,2.31c-0.53,1.07-0.53,2.67-0.53,3.56,0,0.9,0.53,1.82,0.53,1.82h1.06l0.19-0.72,0.19-1.97,0.72-1.06,0.72,0.53,3.9,1.59,5,3.41,0.38,0.87-0.38,5.19-1.06,2.84-4.09,4.47-2.88,3.94-0.34,2.5,1.25,0.19h1.59s-0.17,1.42-0.53,2.31,0.34,1.59,0.34,1.59l2.88,1.25,3.75,0.38,4.62-0.19,2.69,3.41,2.16,1.78h4.47c1.25,0,1.06,2.5,1.06,2.5l1.06,1.59,3.94-0.34s5.36-1.44,6.25-1.44,3.2-0.53,3.56-1.25c0.36-0.71,2.69-1.59,2.69-1.59l1.97-0.91h3.75s2.66-1.24,3.37-1.59c0.72-0.36,0.74-1.98,1.1-2.69,0.35-0.71,0.87-3.03,0.87-3.03l1.25-2.5h1.63l1.78-1.06,1.06-1.63,1.44-0.34,2.31-1.44,1.06-1.25s0.91-0.89,1.63-1.78c0.71-0.89,0.87-1.6,1.4-2.31,0.54-0.72,2.51-1.44,3.22-1.97,0.72-0.54,2.15-2.14,2.5-3.03,0.36-0.9,1.63,0,1.63,0l4.09,0.68s3.22-1.04,5.72-1.93c2.5-0.9,1.08,1.06,0.91,1.78-0.18,0.71,0,3.2,0,4.09s0.88,3.22,1.78,4.47c0.89,1.25,3.9-1.44,3.9-1.44s3.05-1.78,3.94-2.5c0.89-0.71,3.94,0,3.94,0h6.06v-2.84c0-0.72,1.43-3.23,1.97-4.13,0.54-0.89,1.25-3.56,1.25-3.56l0.72-2.5-0.19-4.81s1.79-1.97,3.22-1.97,2.69,1.59,2.69,1.59l4.28,0.91,1.44-0.53s-0.19-3.22-0.19-3.94c0-0.71-0.19-2.84-0.19-2.84l-0.53-3.22s-0.54-2.51-0.72-3.41c-0.18-0.89-0.87-2.12-0.87-2.12l-2.5-1.63,1.25-0.87,4.09-0.38s1.96-2.66,2.5-3.37c0.54-0.72,2.84-2.35,2.84-2.35v-2.5s-1.04-2.13-1.93-3.03c-0.9-0.89-2.35,0.18-3.07,0.53-0.71,0.36-3.03-0.34-3.03-0.34s-1.41-0.88-2.12-0.34c-0.72,0.53-1.63,1.06-1.63,1.06l-1.4-1.06-1.97,1.78-1.44-0.72s-2.84-1.79-4.09-1.25c-1.25,0.53-1.97-0.72-1.97-0.72h-2.5s-0.56,1.25-1.1,1.97c-0.53,0.71-3.03,0.87-3.03,0.87l-2.84,0.91-2.69,3.75-2.69,0.53,1.25-2.5,0.19-1.59-3.03-0.38s2.13-0.88,2.84-1.06c0.72-0.18,3.41-1.06,3.41-1.06l1.97-0.91,0.34-1.59s1.78-3.41,1.78-4.13c0-0.71-0.68-3.22-0.68-3.22l-0.91-2.31s-2.5-4.63-3.22-5.34c-0.71-0.72-1.05-1.78-2.12-1.78-1.08,0-3.07,0.68-3.07,0.68l-1.4,0.91-1.25-1.06s-2.17-1.98-3.6-2.159c-1.42-0.178,0.38-0.719,0.38-0.719l0.87-1.593s-0.16-1.973,0.38-2.688c0.53-0.714,1.97,1.25,1.97,1.25s2.67,1.438,3.56,1.438,1.78,0.531,1.78,0.531,3.41-0.371,4.13-0.906c0.71-0.536,0.68-2.313,0.68-2.313l0.19-2.687,0.72-1.25,1.25-1.782s0.36-1.964,1.25-2.5c0.89-0.535,1.79,0,2.69,0,0.89,0,2.31,1.626,2.31,1.626l1.59,0.718,2.5-1.437s1.28-2.139,1.82-3.031c0.53-0.893,2.84-1.782,2.84-1.782l2.84-2.156,1.44-3.219s2.14-1.973,2.5-2.687c0.36-0.715-0.34-1.782-1.59-1.782h-1.78l-1.82-1.062-1.93-0.188-3.07-1.781-3.18-0.187h-3.75c-0.9,0,0-0.875,0-0.875l2.5-1.625,0.68-2.5-1.06-1.25-2.5-0.532,1.78-1.25,0.53-1.25-2.31-0.531v-2.5s-0.35-1.785-0.53-2.5c-0.09-0.357-0.45-0.437-0.78-0.437zm-77.19,16.062c-0.22-0.01-0.48,0.081-0.78,0.282-1.61,1.071-3.94,2.312-3.94,2.312-1.07,0.357-1.79,1.42-1.97,2.312-0.17,0.893-0.53,2.88-0.53,3.594,0,0.715,0.2,2.496,1.1,3.032,0.89,0.535,3.03,1.598,3.03,2.312s-0.56,2.321,0.15,2.5c0.72,0.179,1.44-0.522,1.97-1.594,0.54-1.071,0.36-3.419,0.72-4.312s1.45-2.491,1.63-3.563c0.17-1.071-0.19-5.187-0.19-5.187s-0.24-1.644-1.19-1.688z",
  "city_population": 34825,
  "fed_okrug": "Дальневосточный федеральный округ",
  "country_population": 14899,
  "area": 721481,
  "city_natural_increase": 146,
  "city_migration_increase": 52,
  "country_natural_increase": 60,
  "country_migration_increase": -641,
  "average_nominal_wage": 79531,
  "average_consumer_rate": 18659,
  "average_annual_buzy": 30.7,
  "per_capita_income": 61704,
  "kladr": "8700000000000"
}, {
  "id": 399,
  "name": "Республика Крым",
  "path": "m7.63 300.28 3.08 -4.47 -2.39 -5.96 -2.32 -1.30 -0.26 -1.56 5.37 0.27 5.62 1.13 3.78 3.17 -0.68 -4.60 2.99 3.45 0.38 1.58 3.51 3.18 1.69 4.34 -1.36 3.53 -0.62 6.67 2.20 0.60 1.62 -0.23 0.49 2.00 2.15 0.47 2.86 3.79 -3.47 0.05 -1.26 2.11 -4.89 -4.06 -1.13 -2.79 -2.69 -0.25 -5.54 -2.16 -3.75 -1.18 -4.89 0.14z m0,0 a3,3 0 1,0 6,0a3,3 0 1,0 -6,0z",
  "city_population": 973396,
  "fed_okrug": "Крымский федеральный округ",
  "country_population": 938683,
  "area": 26081,
  "city_natural_increase": -3436,
  "city_migration_increase": 9996,
  "country_natural_increase": -1670,
  "country_migration_increase": 6301,
  "average_nominal_wage": 22440,
  "average_consumer_rate": 12975,
  "average_annual_buzy": 767.3,
  "per_capita_income": 15672,
  "kladr": "9100000000000"
}, {
  "id": 401,
  "name": "г. Севастополь",
  "path": "m7.63 300.28 a3,3 0 1,0 12,0a3,3 0 1,0 -12,0",
  "city_population": 398016,
  "fed_okrug": "Крымский федеральный округ",
  "country_population": 30683,
  "area": 1080,
  "city_natural_increase": -567,
  "city_migration_increase": 17743,
  "country_natural_increase": -26,
  "country_migration_increase": 140,
  "average_nominal_wage": 21848,
  "average_consumer_rate": 13425,
  "average_annual_buzy": 167.9,
  "per_capita_income": 17892,
  "kladr": "9200000000000"
}, {
  "id": 402,
  "name": "г. Москва",
  "path": "m148,250a3,3 0 1,0 12,0a3,3 0 1,0 -12,0",
  "city_population": 12225248,
  "fed_okrug": "Центральный федеральный округ",
  "country_population": 151957,
  "area": 1091,
  "city_natural_increase": 19603,
  "city_migration_increase": 105298,
  "country_natural_increase": 716,
  "country_migration_increase": 6913,
  "average_nominal_wage": 64310,
  "average_consumer_rate": 43798,
  "average_annual_buzy": 6762.2,
  "per_capita_income": 59898,
  "kladr": "7700000000000"
}, {
  "id": 403,
  "name": "г.Санкт-Петербург",
  "path": "m169.49,181.57 a3,3 0 1,0 12,0a3,3 0 1,0 -12,0",
  "city_population": 5279299,
  "fed_okrug": "Северо-западный федеральный округ",
  "country_population": 0,
  "area": 1403,
  "city_natural_increase": 8737,
  "city_migration_increase": 25263,
  "country_natural_increase": 0,
  "country_migration_increase": 0,
  "average_nominal_wage": 44187,
  "average_consumer_rate": 27495,
  "average_annual_buzy": 2589.9,
  "per_capita_income": 39948,
  "kladr": "7800000000000"
}];

var script$Z = {
  components: {
    RegionPath: __vue_component__$_
  },
  props: {
    value: Object
  },

  data() {
    return {
      regions: data_json,
      tooltipRegion: null,
      tooltipShow: false,
      tooltipWidth: null,
      rootWidth: null,
      tooltipStyle: {
        position: 'absolute',
        color: 'white',
        top: '10px',
        left: '10px'
      }
    };
  },

  computed: {
    regionsSort() {
      let {
        regions,
        value
      } = this;
      if (!value) return regions;
      let regionsSort = [...regions];
      regionsSort.sort((a, b) => {
        let aV = value[a.kladr];
        let bV = value[b.kladr];
        if (!aV && !bV) return 0;
        if (aV && aV.border && (!bV || !bV.border)) return 1;
        if ((!aV || !aV.border) && bV && bV.border) return -1;
        return 0;
      });
      return regionsSort;
    }

  },
  methods: {
    handlerClickToRegion({
      region,
      value
    }) {
      this.$emit('clickRegion', {
        region,
        value
      }); //console.log('handlerClickToRegion');
    },

    handlerMousemove(e, region) {
      const {
        layerX,
        layerY
      } = e;
      let offsetX = layerX;
      let offsetY = layerY;
      let TOP = -35;
      let LEFT = 30; //let INVERT = false;

      let refTooltip = this.$refs.tooltip;

      if (refTooltip) {
        let refRoot = this.$refs.root;
        let rootRect = refRoot.getBoundingClientRect();
        let rootWidth = rootRect.width;
        this.rootWidth = rootWidth;
        let tooltipRect = refTooltip.getBoundingClientRect();
        let tooltipWidth = tooltipRect.width;
        this.tooltipWidth = tooltipWidth;
      } else {
        //tooltip не отображается?
        // провести корректировку расчетов когда появится и будет понятна его ширина
        this.$nextTick(() => {
          this.handlerMousemove(e, region);
        });
      }

      if (this.tooltipWidth) {
        let {
          tooltipWidth,
          rootWidth
        } = this;
        let calc = offsetX + LEFT + tooltipWidth;

        if (calc >= rootWidth - 10) {
          LEFT = (LEFT + tooltipWidth) * -1;
        }
      }

      this.tooltipStyle.top = `${offsetY + TOP}px`;
      this.tooltipStyle.left = `${offsetX + LEFT}px`;
      this.tooltipRegion = region;
      this.tooltipShow = true;
    },

    handlerMouseout(e) {
      this.tooltipShow = false;
    }

  }
};

/* script */
const __vue_script__$Z = script$Z;
/* template */

var __vue_render__$Z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    ref: "root",
    staticStyle: {
      "position": "relative"
    }
  }, [_vm.tooltipShow ? [_c('div', {
    ref: "tooltip",
    style: _vm.tooltipStyle
  }, [_vm._t("tooltip", null, null, {
    region: _vm.tooltipRegion,
    value: _vm.value && _vm.tooltipRegion && _vm.value[_vm.tooltipRegion.kladr] || {}
  })], 2)] : _vm._e(), _vm._v(" "), _c('svg', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "viewBox": "0 50 990 480",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', _vm._l(_vm.regionsSort, function (item, key) {
    return _c('RegionPath', {
      key: key,
      attrs: {
        "index": key,
        "region": item,
        "fill": _vm.value && _vm.value[item.kladr] && _vm.value[item.kladr].color || '#67b7dc',
        "stroke": _vm.value && _vm.value[item.kladr] && _vm.value[item.kladr].border || '#fff',
        "stroke-width": _vm.value && _vm.value[item.kladr] && _vm.value[item.kladr].borderWidth ? _vm.value[item.kladr].borderWidth : 1
      },
      on: {
        "mousemove": _vm.handlerMousemove,
        "mouseout": _vm.handlerMouseout
      },
      nativeOn: {
        "click": function ($event) {
          _vm.handlerClickToRegion({
            region: item,
            value: _vm.value && _vm.value[item.kladr] || null
          });
        }
      }
    });
  }), 1)])], 2);
};

var __vue_staticRenderFns__$Z = [];
/* style */

const __vue_inject_styles__$Z = function (inject) {
  if (!inject) return;
  inject("data-v-6f845aa6_0", {
    source: "svg .state[data-v-6f845aa6]{-webkit-transition:stroke .5s,stroke-width .5s;-o-transition:stroke .5s,stroke-width .5s;transition:stroke .5s,stroke-width .5s}.state.active[data-v-6f845aa6],svg .state[data-v-6f845aa6]:hover{cursor:pointer;stroke:#fff;stroke-width:3}path[data-v-6f845aa6]{opacity:1}.regionActive[data-v-6f845aa6]{opacity:1}p[data-v-6f845aa6]{margin:0 0 10px}.close[data-v-6f845aa6]{float:right;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.5}.close[data-v-6f845aa6]:focus,.close[data-v-6f845aa6]:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.75}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$Z = "data-v-6f845aa6";
/* module identifier */

const __vue_module_identifier__$Z = undefined;
/* functional template */

const __vue_is_functional_template__$Z = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Z,
  staticRenderFns: __vue_staticRenderFns__$Z
}, __vue_inject_styles__$Z, __vue_script__$Z, __vue_scope_id__$Z, __vue_is_functional_template__$Z, __vue_module_identifier__$Z, false, createInjector, undefined, undefined);

var script$Y = {
  components: {
    RegionPath: __vue_component__$_
  },
  props: {
    value: Object
  },

  data() {
    return {
      regions: data_json,
      tooltipRegion: null,
      tooltipShow: false,
      tooltipWidth: null,
      rootWidth: null,
      tooltipStyle: {
        position: 'absolute',
        color: 'white',
        top: '10px',
        left: '10px'
      }
    };
  },

  computed: {
    regionsSort() {
      let {
        regions,
        value
      } = this;
      if (!value) return regions;
      let regionsSort = [...regions];
      regionsSort.sort((a, b) => {
        let aV = value[a.kladr];
        let bV = value[b.kladr];
        if (!aV && !bV) return 0;
        if (aV && aV.border && (!bV || !bV.border)) return 1;
        if ((!aV || !aV.border) && bV && bV.border) return -1;
        return 0;
      });
      return regionsSort;
    }

  },
  methods: {
    handlerClickToRegion({
      region,
      value
    }) {
      this.$emit('clickRegion', {
        region,
        value
      }); //console.log('handlerClickToRegion');
    },

    handlerMousemove(e, region) {
      const {
        layerX,
        layerY
      } = e;
      let offsetX = layerX;
      let offsetY = layerY;
      let TOP = -35;
      let LEFT = 30; //let INVERT = false;

      let refTooltip = this.$refs.tooltip;

      if (refTooltip) {
        let refRoot = this.$refs.root;
        let rootRect = refRoot.getBoundingClientRect();
        let rootWidth = rootRect.width;
        this.rootWidth = rootWidth;
        let tooltipRect = refTooltip.getBoundingClientRect();
        let tooltipWidth = tooltipRect.width;
        this.tooltipWidth = tooltipWidth;
      } else {
        //tooltip не отображается?
        // провести корректировку расчетов когда появится и будет понятна его ширина
        this.$nextTick(() => {
          this.handlerMousemove(e, region);
        });
      }

      if (this.tooltipWidth) {
        let {
          tooltipWidth,
          rootWidth
        } = this;
        let calc = offsetX + LEFT + tooltipWidth;

        if (calc >= rootWidth - 10) {
          LEFT = (LEFT + tooltipWidth) * -1;
        }
      }

      this.tooltipStyle.top = `${offsetY + TOP}px`;
      this.tooltipStyle.left = `${offsetX + LEFT}px`;
      this.tooltipRegion = region;
      this.tooltipShow = true;
    },

    handlerMouseout(e) {
      this.tooltipShow = false;
    }

  }
};

/* script */
const __vue_script__$Y = script$Y;
/* template */

var __vue_render__$Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    ref: "root",
    staticStyle: {
      "width": "990px"
    }
  }, [_vm.tooltipShow ? [_c('div', {
    ref: "tooltip",
    style: _vm.tooltipStyle
  }, [_vm._t("tooltip", null, null, {
    region: _vm.tooltipRegion,
    value: _vm.value && _vm.tooltipRegion && _vm.value[_vm.tooltipRegion.kladr] || {}
  })], 2)] : _vm._e(), _vm._v(" "), _c('svg', {
    attrs: {
      "viewBox": "0 50 3300 1100",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', _vm._l(_vm.regionsSort, function (item, key) {
    return _c('RegionPath', {
      key: key,
      attrs: {
        "index": key,
        "region": item,
        "fill": _vm.value && _vm.value[item.kladr] && _vm.value[item.kladr].color || '#67b7dc',
        "stroke": _vm.value && _vm.value[item.kladr] && _vm.value[item.kladr].border || '#fff',
        "stroke-width": _vm.value && _vm.value[item.kladr] && _vm.value[item.kladr].borderWidth ? _vm.value[item.kladr].borderWidth : 1
      },
      on: {
        "mousemove": _vm.handlerMousemove,
        "mouseout": _vm.handlerMouseout
      },
      nativeOn: {
        "click": function ($event) {
          _vm.handlerClickToRegion({
            region: item,
            value: _vm.value && _vm.value[item.kladr] || null
          });
        }
      }
    });
  }), 1)])], 2);
};

var __vue_staticRenderFns__$Y = [];
/* style */

const __vue_inject_styles__$Y = function (inject) {
  if (!inject) return;
  inject("data-v-0d932a22_0", {
    source: "svg .state[data-v-0d932a22]{-webkit-transition:stroke .5s,stroke-width .5s;-o-transition:stroke .5s,stroke-width .5s;transition:stroke .5s,stroke-width .5s}.state.active[data-v-0d932a22],svg .state[data-v-0d932a22]:hover{cursor:pointer;stroke:#fff;stroke-width:3}path[data-v-0d932a22]{opacity:1}.regionActive[data-v-0d932a22]{opacity:1}p[data-v-0d932a22]{margin:0 0 10px}.close[data-v-0d932a22]{float:right;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.5}.close[data-v-0d932a22]:focus,.close[data-v-0d932a22]:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.75}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$Y = "data-v-0d932a22";
/* module identifier */

const __vue_module_identifier__$Y = undefined;
/* functional template */

const __vue_is_functional_template__$Y = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Y,
  staticRenderFns: __vue_staticRenderFns__$Y
}, __vue_inject_styles__$Y, __vue_script__$Y, __vue_scope_id__$Y, __vue_is_functional_template__$Y, __vue_module_identifier__$Y, false, createInjector, undefined, undefined);

//
let KLADRS$1 = data_json.reduce((r, a) => {
  r[a.kladr] = true;
  return r;
}, {});
let clr1$1 = "#67b7dc";
let clr2$1 = "#a367dc";
let clr3$1 = "#dc6788";

function colorGradient$1(fadeFraction, rgbColor1, rgbColor2, rgbColor3) {
  let color1 = colorParse(rgbColor1);
  let color2 = colorParse(rgbColor2);
  let fade = fadeFraction;

  if (rgbColor3) {
    fade = fade * 2;

    if (fade >= 1) {
      fade -= 1;
      color1 = colorParse(rgbColor2);
      color2 = colorParse(rgbColor3);
    }
  }

  let diffRed = color2.r - color1.r;
  let diffGreen = color2.g - color1.g;
  let diffBlue = color2.b - color1.b;
  let gradient = {
    r: parseInt(Math.floor(color1.r + diffRed * fade), 10),
    g: parseInt(Math.floor(color1.g + diffGreen * fade), 10),
    b: parseInt(Math.floor(color1.b + diffBlue * fade), 10)
  };
  return 'rgb(' + gradient.r + ',' + gradient.g + ',' + gradient.b + ')';
}

let LEGEND_COLORS$1 = [];

for (let i = 0; i < 60; i++) {
  let f = 100 / 60 * i / 100;
  let rgb = colorGradient$1(f, clr1$1, clr2$1);
  LEGEND_COLORS$1.push(rgb);
}

for (let i = 0; i < 40; i++) {
  let f = 100 / 40 * i / 100;
  let rgb = colorGradient$1(f, clr2$1, clr3$1);
  LEGEND_COLORS$1.push(rgb);
}

var script$X = {
  name: 'MapHeat',
  components: {
    RussianMap: __vue_component__$Z
  },
  inject: {
    team: {
      default: () => 'default'
    }
  },
  props: {
    value: Object,
    field: String,
    calcLog: {
      type: Function,
      default: null
    }
  },
  computed: {
    LEGEND_COLORS() {
      return LEGEND_COLORS$1;
    },

    map() {
      let {
        field,
        value,
        calcLog
      } = this;
      if (!calcLog) calcLog = Math.log2;
      value = { ...value
      };
      let valueKeys = Object.keys(value).filter(k => KLADRS$1[k]);
      let valueVal = valueKeys.map(k => value[k][field] || 0);
      let valueValSorted = valueVal.sort((a, b) => a < b ? -1 : 1);
      let min = valueValSorted[0];
      let max = valueValSorted[valueValSorted.length - 1];

      for (let k in KLADRS$1) {
        if (!value[k]) {
          min = 0;
          break;
        }
      }

      let lgMax = calcLog(max + 1);
      let lgMin = calcLog(min + 1);

      for (let k in value) {
        if (!KLADRS$1[k]) continue;
        if (value[k].color) continue;
        let v = { ...value[k]
        };
        let x = v[field];

        if (x) {
          let lgVal = calcLog(x + 1);
          let lgPercent = (lgVal - lgMin) / (lgMax - lgMin) * 100;
          let val = Math.floor(lgPercent);
          let color = LEGEND_COLORS$1[val];
          if (!color && val) color = clr3$1;

          if (!v.color) {
            v.color = color;
          }
        }

        value[k] = v;
      }

      if (max === 0) max = null;
      return {
        min: this.legendItemText(min),
        max: this.legendItemText(max),
        value
      };
    }

  },
  methods: {
    hasValue: hasValue$1,
    toMoney: toMoney$1,
    toFloatString,

    legendItemText(max) {
      if (!hasValue$1(max)) return null;
      let maxText = null;
      let maxTextEnding = '';

      if (max > 1000000000) {
        maxText = Math.floor(max / 1000000000).toString();
        maxTextEnding = ' млрд';
      } else if (max > 1000000) {
        maxText = Math.floor(max / 1000000).toString();
        maxTextEnding = ' млн';
      } else if (max > 1000) {
        maxText = Math.floor(max / 1000).toString();
        maxTextEnding = ' тыс.';
      } else {
        maxText = max.toString();
      }

      maxText = maxText[0] + maxText.substr(1, maxText.length);
      maxText = toMoney$1(maxText, 0);
      maxText = maxText + maxTextEnding;
      let mt = max.toString();
      mt = mt[0] + mt.substr(1, mt.length);
      return maxText;
    }

  }
};

/* script */
const __vue_script__$X = script$X;
/* template */

var __vue_render__$X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticStyle: {
      "padding-right": "20px"
    }
  }, [_c('RussianMap', {
    attrs: {
      "value": _vm.map.value
    },
    on: {
      "clickRegion": function (v) {
        return _vm.$emit('clickRegion', v);
      }
    },
    scopedSlots: _vm._u([{
      key: "tooltip",
      fn: function (ref) {
        var region = ref.region;
        var value = ref.value;
        return [_c('div', {
          staticStyle: {
            "border-radius": "6px",
            "padding": "3px"
          },
          style: {
            'background-color': value.color || '#67b7dc',
            color: value.color === 'white' ? 'black' : 'white'
          }
        }, [_c('div', [_c('span', [_vm._v(_vm._s(region.name))]), _vm._v(" "), _vm._t("tooltip", [_c('span', [_vm._v(": " + _vm._s(_vm.toFloatString(value && value[_vm.field] || 0)))])], null, {
          region: region,
          value: value
        })], 2)])];
      }
    }], null, true)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "5px"
    },
    style: _vm.team == 'dark' && 'color: white'
  }, [_vm._v(_vm._s(_vm.map.min))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "5px"
    },
    style: _vm.team == 'dark' && 'color: white'
  }, [_vm._v(_vm._s(_vm.map.max))])])], 1);
};

var __vue_staticRenderFns__$X = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticStyle: {
      "max-width": "500px",
      "height": "20px",
      "flex": "1"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "border-radius": "6px !important",
      "background": "linear-gradient(90deg, rgba(103,183,220,1) 0%, rgba(163,103,220,1) 60%, rgba(220,103,136,1) 100%)"
    }
  })]);
}];
/* style */

const __vue_inject_styles__$X = function (inject) {
  if (!inject) return;
  inject("data-v-6ec1c6e1_0", {
    source: ".fdgd[data-v-6ec1c6e1]{background-color:#424242}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$X = "data-v-6ec1c6e1";
/* module identifier */

const __vue_module_identifier__$X = undefined;
/* functional template */

const __vue_is_functional_template__$X = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$X,
  staticRenderFns: __vue_staticRenderFns__$X
}, __vue_inject_styles__$X, __vue_script__$X, __vue_scope_id__$X, __vue_is_functional_template__$X, __vue_module_identifier__$X, false, createInjector, undefined, undefined);

//
let KLADRS = data_json.reduce((r, a) => {
  r[a.kladr] = true;
  return r;
}, {});
let clr1 = "#67b7dc";
let clr2 = "#a367dc";
let clr3 = "#dc6788";

function colorGradient(fadeFraction, rgbColor1, rgbColor2, rgbColor3) {
  let color1 = colorParse(rgbColor1);
  let color2 = colorParse(rgbColor2);
  let fade = fadeFraction;

  if (rgbColor3) {
    fade = fade * 2;

    if (fade >= 1) {
      fade -= 1;
      color1 = colorParse(rgbColor2);
      color2 = colorParse(rgbColor3);
    }
  }

  let diffRed = color2.r - color1.r;
  let diffGreen = color2.g - color1.g;
  let diffBlue = color2.b - color1.b;
  let gradient = {
    r: parseInt(Math.floor(color1.r + diffRed * fade), 10),
    g: parseInt(Math.floor(color1.g + diffGreen * fade), 10),
    b: parseInt(Math.floor(color1.b + diffBlue * fade), 10)
  };
  return "rgb(" + gradient.r + "," + gradient.g + "," + gradient.b + ")";
}

let LEGEND_COLORS = [];

for (let i = 0; i < 60; i++) {
  let f = 100 / 60 * i / 100;
  let rgb = colorGradient(f, clr1, clr2);
  LEGEND_COLORS.push(rgb);
}

for (let i = 0; i < 40; i++) {
  let f = 100 / 40 * i / 100;
  let rgb = colorGradient(f, clr2, clr3);
  LEGEND_COLORS.push(rgb);
}

var script$W = {
  name: "MapHeatForPrint",
  components: {
    RussianMap: __vue_component__$Y
  },
  inject: {
    team: {
      default: () => "default"
    }
  },
  props: {
    value: Object,
    field: String,
    calcLog: {
      type: Function,
      default: null
    }
  },

  data() {
    return {
      mapSrc: null
    };
  },

  computed: {
    LEGEND_COLORS() {
      return LEGEND_COLORS;
    },

    map() {
      let {
        field,
        value,
        calcLog
      } = this;
      if (!calcLog) calcLog = Math.log2;
      value = { ...value
      };
      let valueKeys = Object.keys(value).filter(k => KLADRS[k]);
      let valueVal = valueKeys.map(k => value[k][field] || 0);
      let valueValSorted = valueVal.sort((a, b) => a < b ? -1 : 1);
      let min = valueValSorted[0];
      let max = valueValSorted[valueValSorted.length - 1];

      for (let k in KLADRS) {
        if (!value[k]) {
          min = 0;
          break;
        }
      }

      let lgMax = calcLog(max + 1);
      let lgMin = calcLog(min + 1);

      for (let k in value) {
        if (!KLADRS[k]) continue;
        if (value[k].color) continue;
        let v = { ...value[k]
        };
        let x = v[field];

        if (x) {
          let lgVal = calcLog(x + 1);
          let lgPercent = (lgVal - lgMin) / (lgMax - lgMin) * 100;
          let val = Math.floor(lgPercent);
          let color = LEGEND_COLORS[val];
          if (!color && val) color = clr3;

          if (!v.color) {
            v.color = color;
          }
        }

        value[k] = v;
      }

      if (max === 0) max = null;
      return {
        min: this.legendItemText(min),
        max: this.legendItemText(max),
        value
      };
    }

  },
  methods: {
    hasValue: hasValue$1,
    toMoney: toMoney$1,
    toFloatString,

    legendItemText(max) {
      if (!hasValue$1(max)) return null;
      let maxText = null;
      let maxTextEnding = "";

      if (max > 1000000000) {
        maxText = Math.floor(max / 1000000000).toString();
        maxTextEnding = " млрд";
      } else if (max > 1000000) {
        maxText = Math.floor(max / 1000000).toString();
        maxTextEnding = " млн";
      } else if (max > 1000) {
        maxText = Math.floor(max / 1000).toString();
        maxTextEnding = " тыс.";
      } else {
        maxText = max.toString();
      }

      maxText = maxText[0] + maxText.substr(1, maxText.length);
      maxText = toMoney$1(maxText, 0);
      maxText = maxText + maxTextEnding;
      let mt = max.toString();
      mt = mt[0] + mt.substr(1, mt.length);
      return maxText;
    }

  }
};

/* script */
const __vue_script__$W = script$W;
/* template */

var __vue_render__$W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticStyle: {
      "padding-right": "20px"
    }
  }, [_c('RussianMap', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.forExport,
      expression: "!forExport"
    }],
    ref: "mapSource",
    attrs: {
      "value": _vm.map.value
    },
    on: {
      "clickRegion": function (v) {
        return _vm.$emit('clickRegion', v);
      }
    },
    scopedSlots: _vm._u([{
      key: "tooltip",
      fn: function (ref) {
        var region = ref.region;
        var value = ref.value;
        return [_c('div', {
          staticStyle: {
            "border-radius": "6px",
            "padding": "3px"
          },
          style: {
            'background-color': value.color || '#67b7dc',
            color: value.color === 'white' ? 'black' : 'white'
          }
        }, [_c('div', [_c('span', [_vm._v(_vm._s(region.name))]), _vm._v(" "), _vm._t("tooltip", [_c('span', [_vm._v(": " + _vm._s(_vm.toFloatString(value && value[_vm.field] || 0)))])], null, {
          region: region,
          value: value
        })], 2)])];
      }
    }], null, true)
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.forExport,
      expression: "forExport"
    }],
    attrs: {
      "src": _vm.mapSrc
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "width": "650px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "5px"
    },
    style: _vm.team == 'dark' && 'color: white'
  }, [_vm._v("\n      " + _vm._s(_vm.map.min) + "\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "5px"
    },
    style: _vm.team == 'dark' && 'color: white'
  }, [_vm._v("\n      " + _vm._s(_vm.map.max) + "\n    ")])])], 1);
};

var __vue_staticRenderFns__$W = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticStyle: {
      "max-width": "400px",
      "height": "10px",
      "flex": "1"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "border-radius": "6px !important",
      "background": "linear-gradient(90deg, rgba(103,183,220,1) 0%, rgba(163,103,220,1) 60%, rgba(220,103,136,1) 100%)"
    }
  })]);
}];
/* style */

const __vue_inject_styles__$W = function (inject) {
  if (!inject) return;
  inject("data-v-6132e390_0", {
    source: ".fdgd[data-v-6132e390]{background-color:#424242}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$W = "data-v-6132e390";
/* module identifier */

const __vue_module_identifier__$W = undefined;
/* functional template */

const __vue_is_functional_template__$W = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$W,
  staticRenderFns: __vue_staticRenderFns__$W
}, __vue_inject_styles__$W, __vue_script__$W, __vue_scope_id__$W, __vue_is_functional_template__$W, __vue_module_identifier__$W, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$V = {
  name: "CustomersTable",
  components: {},
  props: {
    customers: {
      type: Array,
      itemsByCount: [],
      itemsBySum: []
    }
  },

  data() {
    return {
      pageMultiplier: 5,
      pageSelected: 1,
      mapTableField: 'count'
    };
  },

  computed: {
    loaderDefaultText() {
      return 'Загрузка графиков. Пожалуйста, подождите.';
    },

    customersPaged() {
      if (this.customers == null) return [];
      let customers = this.customers;
      if (customers.length === 0) return [];
      let slice = (this.pageSelected || 1) * this.pageMultiplier;
      if (slice > customers.length) slice = customers.length;
      return customers.slice(0, slice);
    },

    showNextButtonVisible() {
      return this.customers.length > this.currentPage;
    },

    showCollapseButtonVisible() {
      return this.pageSelected !== 1;
    },

    currentPage() {
      return (this.pageSelected || 1) * this.pageMultiplier;
    }

  },
  methods: {
    showNext() {
      this.pageSelected += 1;
    },

    switchTableField(value) {
      this.pageSelected = 1;
      this.mapTableField = value;
    },

    collapseAll() {
      this.pageSelected = 1;
    }

  }
};

/* script */
const __vue_script__$V = script$V;
/* template */

var __vue_render__$V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.$style.tableBox
  }, [_c('table', {
    class: _vm.$style.tableData
  }, [_c('thead', {
    class: _vm.$style.header
  }, [_c('th', [_vm._v("Наименование")]), _vm._v(" "), _c('th', [_vm._v("ИНН")]), _vm._v(" "), _c('th', [_vm._v("Регион")]), _vm._v(" "), _c('th', [_vm._v("Проведено тендеров")]), _vm._v(" "), _c('th', [_vm._v("Текущие тендеры")]), _vm._v(" "), _c('th', [_vm._v("Планируемые тендеры")])]), _vm._v(" "), _c('tbody', {
    class: _vm.$style.body
  }, [_vm._l(_vm.customersPaged, function (customer, index) {
    return [_c('tr', {
      key: 'item_' + index
    }, [_c('td', {
      class: _vm.$style.columnName
    }, [_vm._v(_vm._s(customer.name))]), _vm._v(" "), _c('td', {
      class: _vm.$style.columnInn
    }, [_vm._v(_vm._s(customer.inn))]), _vm._v(" "), _c('td', {
      class: _vm.$style.columnRegion
    }, [_vm._v(_vm._s(customer.region))]), _vm._v(" "), _c('td', {
      class: _vm.$style.columnTendersDone
    }, [_vm._v(_vm._s(customer.tendersDoneCount) + " шт"), _c('br'), _vm._v(_vm._s(customer.tendersDoneSum) + " ₽")]), _vm._v(" "), _c('td', {
      class: _vm.$style.columnTendersActive
    }, [_vm._v(_vm._s(customer.tendersActiveCount) + " шт"), _c('br'), _vm._v(_vm._s(customer.tendersActiveSum) + " ₽")]), _vm._v(" "), _c('td', {
      class: _vm.$style.columnTendersPlanned
    }, [_vm._v(_vm._s(customer.tendersPlannedCount) + " шт"), _c('br'), _vm._v(_vm._s(customer.tendersPlannedSum) + " ₽")])])];
  }), _vm._v(" "), _c('tr', [_c('td', {
    class: _vm.$style.footer,
    attrs: {
      "colspan": "6"
    }
  }, [_vm.showNextButtonVisible ? _c('a', {
    on: {
      "click": _vm.showNext
    }
  }, [_vm._v("Показать ещё")]) : _vm._e(), _vm.showCollapseButtonVisible ? _c('a', {
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": _vm.collapseAll
    }
  }, [_vm._v("Свернуть")]) : _vm._e()])])], 2)])]);
};

var __vue_staticRenderFns__$V = [];
/* style */

const __vue_inject_styles__$V = function (inject) {
  if (!inject) return;
  inject("data-v-b17af3c2_0", {
    source: ".src-components-box-3y3s{font-family:IBM Plex Sans;font-style:normal;font-weight:400;font-size:16px;line-height:24px;color:#fff;padding-bottom:30px}.src-components-tableBox-3_PH{border-radius:4px!important;border:1px solid #fff;padding:0 5px 8px 8px}.src-components-tableData-1-Ok{width:100%;text-align:left;background:#364150;border-spacing:0}.src-components-header-1-jv{padding:24px 0 8px 0}.src-components-tableData-1-Ok tr:nth-child(even){background:linear-gradient(0deg,rgba(110,124,141,.1),rgba(110,124,141,.1)),#fff}.src-components-tableData-1-Ok tr:nth-child(odd){background:#fff}.src-components-tableData-1-Ok tr:first-child td:first-child{border-top-left-radius:4px!important;border-bottom:1px solid #6e7c8d}.src-components-tableData-1-Ok tr:first-child td:last-child{border-top-right-radius:4px!important;border-bottom:1px solid #6e7c8d}.src-components-tableData-1-Ok tr:last-child td:first-child{border-bottom-left-radius:4px!important}.src-components-tableData-1-Ok tr:last-child td:last-child{border-bottom-right-radius:4px!important}.src-components-header-1-jv th{font-weight:500;font-size:13px;line-height:1;color:#fff;padding-left:8px}.src-components-body-3C-a{font-weight:400;font-size:13px;line-height:1;line-height:16px;color:#202020;background:#6e7c8d}.src-components-body-3C-a td{padding:8px}.src-components-columnName-3PK3{border-bottom:1px solid #6e7c8d;border-right:1px solid #6e7c8d}.src-components-columnInn-2Ehg{min-width:80px;border-bottom:1px solid #6e7c8d;border-right:1px solid #6e7c8d}.src-components-columnRegion-1cgE{min-width:96px;border-bottom:1px solid #6e7c8d;border-right:1px solid #6e7c8d}.src-components-columnTendersDone-pzQo{min-width:134px;border-bottom:1px solid #6e7c8d;border-right:1px solid #6e7c8d}.src-components-columnTendersActive-1WGH{min-width:134px;border-bottom:1px solid #6e7c8d;border-right:1px solid #6e7c8d}.src-components-columnTendersPlanned-1Vxu{min-width:134px;border-bottom:1px solid #6e7c8d}.src-components-footer-1buV{text-align:center}.src-components-footer-1buV a{text-decoration:underline;cursor:pointer;color:#202020}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-box-3y3s",
      "tableBox": "src-components-tableBox-3_PH",
      "tableData": "src-components-tableData-1-Ok",
      "header": "src-components-header-1-jv",
      "body": "src-components-body-3C-a",
      "columnName": "src-components-columnName-3PK3",
      "columnInn": "src-components-columnInn-2Ehg",
      "columnRegion": "src-components-columnRegion-1cgE",
      "columnTendersDone": "src-components-columnTendersDone-pzQo",
      "columnTendersActive": "src-components-columnTendersActive-1WGH",
      "columnTendersPlanned": "src-components-columnTendersPlanned-1Vxu",
      "footer": "src-components-footer-1buV"
    }
  });
};
/* scoped */


const __vue_scope_id__$V = undefined;
/* module identifier */

const __vue_module_identifier__$V = undefined;
/* functional template */

const __vue_is_functional_template__$V = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$V,
  staticRenderFns: __vue_staticRenderFns__$V
}, __vue_inject_styles__$V, __vue_script__$V, __vue_scope_id__$V, __vue_is_functional_template__$V, __vue_module_identifier__$V, false, createInjector, undefined, undefined);

//
var script$U = {
  name: "LoaderSmallColored",
  props: {
    zoom: {
      type: Number,
      default: 1
    },
    delay: {
      type: [String, Number],
      default: 250
    },
    color: String
  },

  data() {
    return {
      show: false
    };
  },

  computed: {
    isIEBrowser() {
      return isIE();
    },

    delayMilliseconds() {
      if (!this.delay) return 0;
      return parseInt(this.delay);
    }

  },

  mounted() {
    if (this.delayMilliseconds && this.delayMilliseconds > 0) {
      let th = this;
      setTimeout(() => {
        th.show = true;
      }, this.delayMilliseconds);
    } else {
      this.show = true;
    }
  }

};

/* script */
const __vue_script__$U = script$U;
/* template */

var __vue_render__$U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.show && _vm.isIEBrowser ? _c('div', {
    style: "font-size: " + _vm.zoom * 10 + "px !important; padding-top: 3px;"
  }, [_vm._v("\n  ...\n")]) : _vm.show ? _c('div', {
    class: _vm.$style.ldsLoader,
    style: "font-size: " + _vm.zoom * 10 + "px !important; padding-top: 3px;"
  }, [_c('div', {
    style: {
      backgroundColor: _vm.color + ' !important'
    }
  }), _c('div', {
    style: {
      backgroundColor: _vm.color + ' !important'
    }
  }), _c('div', {
    style: {
      backgroundColor: _vm.color + ' !important'
    }
  })]) : _vm._e();
};

var __vue_staticRenderFns__$U = [];
/* style */

const __vue_inject_styles__$U = function (inject) {
  if (!inject) return;
  inject("data-v-429beda0_0", {
    source: ".src-components-ldsLoader-2BZH{display:inline-block!important;position:relative!important;width:7.1em!important;height:.3em!important}.src-components-ldsLoader-2BZH div{display:inline-block!important;position:absolute!important;width:1em!important;border-radius:.3em!important;background:#c4c4c4;animation:src-components-ldsLoader-2BZH 1.2s cubic-bezier(0,.5,.5,1) infinite}.src-components-ldsLoader-2BZH div:nth-child(1){left:.1em!important;animation-delay:-.24s}.src-components-ldsLoader-2BZH div:nth-child(2){left:1.4em!important;animation-delay:-.12s}.src-components-ldsLoader-2BZH div:nth-child(3){left:2.7em!important;animation-delay:0s}@keyframes src-components-ldsLoader-2BZH{0%{background:#000}100%,50%{height:.8em}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "ldsLoader": "src-components-ldsLoader-2BZH"
    }
  });
};
/* scoped */


const __vue_scope_id__$U = undefined;
/* module identifier */

const __vue_module_identifier__$U = undefined;
/* functional template */

const __vue_is_functional_template__$U = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$U,
  staticRenderFns: __vue_staticRenderFns__$U
}, __vue_inject_styles__$U, __vue_script__$U, __vue_scope_id__$U, __vue_is_functional_template__$U, __vue_module_identifier__$U, false, createInjector, undefined, undefined);

var script$T = {
  name: "CounterpartyTable",
  components: {
    IconRub: __vue_component__$1k
  },
  props: {
    cols: Array,
    rows: Array,
    hasPaging: {
      type: Boolean,
      default: true
    },
    pageSize: {
      type: Number,
      default: 5
    },
    pagingSpread: {
      type: Number,
      default: 2
    }
  },

  data() {
    return {
      page: 1
    };
  },

  computed: {
    rowsData() {
      if (!this.totalPages) {
        return null;
      }

      const firstIndex = this.hasPaging && (this.page - 1) * this.pageSize || 0;
      const rowsLength = this.hasPaging && Math.min(firstIndex + this.pageSize, this.rows.length) - firstIndex || this.rows.length;
      return Array.from(Array(rowsLength)).map((x, index) => this.mapRow(this.rows[firstIndex + index], index, rowsLength));
    },

    totalPages() {
      return this.rows && this.rows.length && Math.floor((this.rows.length - 1) / this.pageSize) + 1 || 0;
    },

    pager() {
      if (!this.hasPaging || !this.totalPages || this.totalPages <= 1) {
        return null;
      }

      const page = Math.min(Math.max(this.page || 1, 1), this.totalPages);
      const indices = Array.from(Array(this.pagingSpread * 2 + 1)).map((x, i) => page + i - this.pagingSpread);
      const first = indices[0];

      if (first < 1) {
        indices.splice(0, 1 - first);
      } else if (first === 2) {
        indices.splice(0, 0, 1);
      } else if (first === 3) {
        indices.splice(0, 0, 1, 2);
      } else if (first > 3) {
        indices.splice(0, 0, 1, null);
      }

      const last = indices[indices.length - 1];

      if (last > this.totalPages) {
        indices.splice(indices.length - (last - this.totalPages), last - this.totalPages);
      } else if (last === this.totalPages - 1) {
        indices.splice(indices.length, 0, this.totalPages);
      } else if (last === this.totalPages - 2) {
        indices.splice(indices.length, 0, this.totalPages - 1, this.totalPages);
      } else if (last < this.totalPages - 2) {
        indices.splice(indices.length, 0, null, this.totalPages);
      }

      return indices.map((page, index) => ({
        id: index,
        page: page != this.page && page || null,
        text: page || "...",
        cls: {
          [this.$style.page]: true,
          [this.$style.pageSpacer]: !page,
          [this.$style.pageActive]: page == this.page
        }
      }));
    }

  },
  methods: {
    mapRow(row, rowIndex, rowsLength) {
      return { ...row,
        cells: this.cols.map((col, cellIndex) => this.mapCell(col, row.cells[cellIndex], cellIndex, rowIndex, rowsLength)),
        cls: {
          [this.$style.row]: true,
          [this.$style.rowEven]: rowIndex % 2 != 0
        }
      };
    },

    mapCell(col, cell, cellIndex, rowIndex, rowsLength) {
      const data = { ...col,
        ...cell,
        isFirstCell: cellIndex == 0,
        isLastCell: cellIndex == this.cols.length - 1,
        isFirstRow: rowIndex == 0,
        isLastRow: rowIndex == rowsLength - 1
      };
      return { ...data,
        id: cellIndex,
        cls: {
          [this.$style.cell]: true,
          [this.$style.cellNowrap]: data.nowrap || data.isNumber || data.isRur,
          [this.$style.cellNumber]: data.isNumber || data.isRur,
          [this.$style.cellTL]: data.isFirstCell && data.isFirstRow,
          [this.$style.cellTR]: data.isLastCell && data.isFirstRow,
          [this.$style.cellBL]: data.isFirstCell && data.isLastRow,
          [this.$style.cellBR]: data.isLastCell && data.isLastRow,
          [this.$style.cellR]: data.isLastCell,
          [this.$style.cellB]: data.isLastRow
        }
      };
    },

    go(page) {
      if (page) {
        this.page = Math.min(Math.max(page || 1, 1), this.totalPages);
      }
    }

  }
};

/* script */
const __vue_script__$T = script$T;
/* template */

var __vue_render__$T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('table', {
    class: _vm.$style.table
  }, [_c('thead', [_c('tr', {
    class: _vm.$style.rowHead
  }, _vm._l(_vm.cols, function (col, index) {
    return _c('th', {
      key: index,
      class: _vm.$style.col
    }, [_vm._v("\n        " + _vm._s(col.name) + "\n      ")]);
  }), 0)]), _vm._v(" "), _vm.rowsData ? _c('tbody', _vm._l(_vm.rowsData, function (row) {
    return _c('tr', {
      key: row.id,
      class: row.cls
    }, _vm._l(row.cells, function (cell, index) {
      return _c('td', {
        key: index,
        class: cell.cls
      }, [cell.html ? _c('div', {
        domProps: {
          "innerHTML": _vm._s(cell.text)
        }
      }) : cell.link && cell.text ? _c('nuxt-link', {
        attrs: {
          "to": cell.link
        }
      }, [_vm._v("\n          " + _vm._s(cell.text) + "\n        ")]) : cell.text ? _c('span', [_vm._v("\n          " + _vm._s(cell.text)), cell.isRur ? _c('IconRub', {
        class: _vm.$style.cellRur,
        attrs: {
          "height": "10px",
          "width": "10px"
        }
      }) : _vm._e()], 1) : _vm._e()], 1);
    }), 0);
  }), 0) : _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.cols.length
    }
  }, [_vm._t("nodata")], 2)])]), _vm._v(" "), _vm.pager ? _c('tfoot', [_c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.cols.length
    }
  }, [_c('div', {
    class: _vm.$style.footerBox
  }, [_c('div', _vm._l(_vm.pager, function (item) {
    return _c('a', {
      key: item.id,
      class: item.cls,
      on: {
        "click": function ($event) {
          return _vm.go(item.page);
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.text) + "\n            ")]);
  }), 0), _vm._v(" "), _vm.page < _vm.totalPages ? _c('div', [_c('a', {
    class: _vm.$style.nextPage,
    on: {
      "click": function ($event) {
        return _vm.go(_vm.page + 1);
      }
    }
  }, [_vm._v("\n              Показать следующие " + _vm._s(_vm.pageSize) + "\n            ")])]) : _vm._e()])])])]) : _vm._e()]);
};

var __vue_staticRenderFns__$T = [];
/* style */

const __vue_inject_styles__$T = function (inject) {
  if (!inject) return;
  inject("data-v-51800be1_0", {
    source: ".src-components-table-1OFW{border:1px solid #fff;border-radius:4px!important;border-spacing:0;border-collapse:separate;margin:10px 0;padding:0 8px 8px 8px}.src-components-col-3BS-{color:#fff;padding:0 10px;font-weight:500;font-size:13px;line-height:24px}.src-components-rowHead-1PAe{background:0 0}.src-components-row-2Buo{background:#fff}.src-components-rowEven-1Vne{background:#f0f1f3}.src-components-cell-3PVm{color:#202020;border:solid #6e7c8d;border-width:1px 0 0 1px;padding:8px;font-size:13px;line-height:24px}.src-components-cell-3PVm a,.src-components-cell-3PVm div>a{color:#202020!important;text-decoration:underline!important}.src-components-cell-3PVm a:hover,.src-components-cell-3PVm div>a:hover{color:#202020!important}.src-components-cellNowrap-1fsd{white-space:nowrap}.src-components-cellNumber-AT_O{text-align:right}.src-components-cellRur-TEG4 path{fill:#202020}.src-components-cellTL-3iTD{border-top-left-radius:4px!important}.src-components-cellTR-S01F{border-top-right-radius:4px!important}.src-components-cellBL-2fCO{border-bottom-left-radius:4px!important}.src-components-cellBR-1Vlf{border-bottom-right-radius:4px!important}.src-components-cellR-1tcA{border-right-width:1px}.src-components-cellB-WOX8{border-bottom-width:1px}.src-components-footerBox-ynyZ{color:#fff;display:flex;font-size:13px;line-height:24px}.src-components-footerBox-ynyZ div{flex:auto}.src-components-page-9lIQ{padding:0 5px;text-decoration:none;cursor:pointer;user-select:none}.src-components-pageActive-3CP-{font-weight:700;cursor:default}.src-components-pageSpacer-m_YH{cursor:default}.src-components-nextPage-3nuZ{text-decoration:underline;cursor:pointer;user-select:none}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "table": "src-components-table-1OFW",
      "col": "src-components-col-3BS-",
      "rowHead": "src-components-rowHead-1PAe",
      "row": "src-components-row-2Buo",
      "rowEven": "src-components-rowEven-1Vne",
      "cell": "src-components-cell-3PVm",
      "cellNowrap": "src-components-cellNowrap-1fsd",
      "cellNumber": "src-components-cellNumber-AT_O",
      "cellRur": "src-components-cellRur-TEG4",
      "cellTL": "src-components-cellTL-3iTD",
      "cellTR": "src-components-cellTR-S01F",
      "cellBL": "src-components-cellBL-2fCO",
      "cellBR": "src-components-cellBR-1Vlf",
      "cellR": "src-components-cellR-1tcA",
      "cellB": "src-components-cellB-WOX8",
      "footerBox": "src-components-footerBox-ynyZ",
      "page": "src-components-page-9lIQ",
      "pageActive": "src-components-pageActive-3CP-",
      "pageSpacer": "src-components-pageSpacer-m_YH",
      "nextPage": "src-components-nextPage-3nuZ"
    }
  });
};
/* scoped */


const __vue_scope_id__$T = undefined;
/* module identifier */

const __vue_module_identifier__$T = undefined;
/* functional template */

const __vue_is_functional_template__$T = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$T,
  staticRenderFns: __vue_staticRenderFns__$T
}, __vue_inject_styles__$T, __vue_script__$T, __vue_scope_id__$T, __vue_is_functional_template__$T, __vue_module_identifier__$T, false, createInjector, undefined, undefined);

var script$S = {
  name: 'SpeedometerLabel',
  components: {
    IconRub: __vue_component__$1k
  },
  props: {
    loading: Boolean,
    text1: String,
    value1: [String, Number],
    text2: String,
    value2: [String, Number],
    separatorWidth: {
      type: [Number],
      default: 190
    },
    zoom: {
      type: Number,
      default: 1
    }
  },
  methods: {
    toMoney: toMoney$1
  }
};

/* script */
const __vue_script__$S = script$S;
/* template */

var __vue_render__$S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    style: "font-size: " + 10 * _vm.zoom + "px; line-height: 1;"
  }, [_c('div', {
    class: _vm.$style.text,
    style: "font-size: 1.2em;"
  }, [_vm._v(_vm._s(_vm.text1))]), _vm._v(" "), _vm.loading && _vm.value1 == null ? _c('div', {
    class: _vm.$style.value,
    style: "font-size: 1.2em;"
  }, [_vm._v("—")]) : _c('div', {
    class: _vm.$style.value,
    style: "font-size: 1.2em;"
  }, [_vm._v("\r\n    " + _vm._s(_vm.toMoney(_vm.value1 || 0)) + " "), _c('IconRub', {
    attrs: {
      "height": "0.75em",
      "width": "0.75em",
      "color": "#4FA5EF"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('div', {
    class: _vm.$style.separator,
    style: "width: " + _vm.separatorWidth * _vm.zoom + "px;"
  })]), _vm._v(" "), _c('div', {
    class: _vm.$style.text,
    style: "font-size: 1.2em"
  }, [_vm._v(_vm._s(_vm.text2))]), _vm._v(" "), _vm.loading && _vm.value2 == null ? _c('div', {
    class: _vm.$style.value
  }, [_vm._v("—")]) : _c('div', {
    class: _vm.$style.value,
    style: "font-size: 1.2em;"
  }, [_vm._v("\r\n    " + _vm._s(_vm.toMoney(_vm.value2 || 0)) + " "), _c('IconRub', {
    attrs: {
      "height": "0.75em",
      "width": "0.75em",
      "color": "#4FA5EF"
    }
  })], 1)]);
};

var __vue_staticRenderFns__$S = [];
/* style */

const __vue_inject_styles__$S = function (inject) {
  if (!inject) return;
  inject("data-v-38d95167_0", {
    source: ".src-components-text-bix9{margin:0 0;font-size:12px}.src-components-value-2Jf8{margin:0 0;color:#4fa5ef;font-size:12px}.src-components-separator-ppQ8{height:0;border-bottom:1px solid #c4c4c4;margin:4px 0}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "text": "src-components-text-bix9",
      "value": "src-components-value-2Jf8",
      "separator": "src-components-separator-ppQ8"
    }
  });
};
/* scoped */


const __vue_scope_id__$S = undefined;
/* module identifier */

const __vue_module_identifier__$S = undefined;
/* functional template */

const __vue_is_functional_template__$S = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$S,
  staticRenderFns: __vue_staticRenderFns__$S
}, __vue_inject_styles__$S, __vue_script__$S, __vue_scope_id__$S, __vue_is_functional_template__$S, __vue_module_identifier__$S, false, createInjector, undefined, undefined);

var script$R = {
  name: "CounterpartyWidgetSmall",
  components: {
    Speedometer: __vue_component__$$,
    CounterpartySlider: __vue_component__$18,
    Loader: __vue_component__$15,
    SpeedometerLabel: __vue_component__$S,
    CounterpartyLoading: __vue_component__$14
  },
  mixins: [base],
  props: {
    counterparty: Object,
    urlCounterpartyPage: String,
    inn: String,
    kpp: String,
    externalId: [String, Number],
    marketPlaceId: String
  },
  computed: {
    cHref() {
      let url = this.urlCounterpartyPage + '?inn=' + this.cInn;
      let externalId = this.externalId;
      let kpp = this.kpp;
      let mpId = this.marketPlaceId;

      if (kpp) {
        url = url + "&kpp=" + kpp;
      }

      if (externalId) {
        url = url + "&externalId=" + externalId;
      }

      if (mpId) {
        url = url + "&marketPlaceId=" + mpId;
      }

      return url;
    },

    cInn() {
      let inn = this.counterparty && this.counterparty.data && this.counterparty.data.inn || this.inn;
      return inn;
    },

    city() {
      let counteragentAddresses = get(this.counterparty, 'data.counteragentAddresses');
      if (!counteragentAddresses) return null;
      let addresses = counteragentAddresses.find(a => a.addressType == 1);
      if (!addresses) return null;
      return addresses.city;
    },

    shortNameLoading() {
      return get(this.counterparty, 'loading') && get(this.counterparty, 'dataIsEmpty') !== false;
    },

    shortName() {
      return get(this.counterparty, 'data.shortName');
    },

    stopFactors() {
      let reliabilityData = this.reliability && this.reliability.data;
      let stopResults = reliabilityData && reliabilityData.stopResults;
      if (!stopResults || stopResults.length <= 0) return [{
        style: {
          visibility: 'hidden'
        }
      }]; // отображаем скрытый элемент чтобы просто занимал место

      let contRed = stopResults.filter(a => a.value === true).length;
      let contGreen = stopResults.filter(a => a.value === false).length;
      let contYellow = stopResults.filter(a => a.value === null).length;
      return [{
        value: contGreen,
        style: {
          backgroundColor: '#5FD18F'
        }
      }, {
        value: contRed,
        style: {
          backgroundColor: '#E43C46'
        }
      }, {
        value: contYellow,
        style: {
          backgroundColor: '#F4B50A'
        }
      }].filter(a => a.value);
    },

    speedometerLabelStyle() {
      return {
        zoom: this.zoom * 0.5,
        separatorWidth: 50
      };
    },

    speedometerStyle() {
      return {
        firstControlPoint: 0.1,
        secondControlPoint: 0.4,
        zoom: this.zoom * 0.45
      };
    },

    counterpartySliderStyle() {
      return {
        zoom: this.zoom * 0.8
      };
    },

    zoom() {
      return 0.5;
    }

  }
};

/* script */
const __vue_script__$R = script$R;
/* template */

var __vue_render__$R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    style: "font-size: " + _vm.zoom * 10 + "px; line-height: 1.6em;"
  }, [_c('CounterpartyLoading', {
    staticStyle: {
      "color": "#53565A",
      "cursor": "pointer",
      "margin-bottom": "1em"
    },
    attrs: {
      "loading": _vm.shortNameLoading,
      "value": _vm.shortName,
      "zoom": _vm.zoom,
      "height": "0.8em",
      "mode": "small"
    }
  }, [_vm.shortName ? _c('div', {
    staticStyle: {
      "font-size": "2em"
    }
  }, [_c('span', {
    staticStyle: {
      "text-decoration-line": "underline"
    }
  }, [_vm.urlCounterpartyPage ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.cHref
    }
  }, [_vm._v(" " + _vm._s(_vm.shortName) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.shortName) + " ")])]), _vm._v(" "), _c('span', [_vm._v(" >")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "color": "#53565A",
      "justify-content": "space-between",
      "margin": "2em 1.2em 1.5em 0",
      "height": "1.5em"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "1.8em"
    }
  }, [_vm._v(_vm._s(_vm.cInn))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "1.8em"
    }
  }, [_vm._v(_vm._s(_vm.city))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "stretch"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "flex": "1",
      "position": "relative",
      "margin-right": "8em",
      "top": "-0.2em",
      "min-width": "20em"
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "0.2em"
    }
  }, [!(_vm.reliabilityLoading && !_vm.sliderInvert) ? _c('div', {
    staticStyle: {
      "font-size": "1.6em",
      "line-height": "1.6em"
    }
  }, [_vm._v("Риски")]) : _vm._e(), _vm._v(" "), _vm.reliabilityLoading && !_vm.sliderInvert ? _c('div', [_c('div', {
    staticStyle: {
      "font-size": "1.6em",
      "line-height": "1.6em"
    }
  }, [_vm._v("\r\n              рассчитываем скоринг ...\r\n            ")])]) : _vm._e()]), _vm._v(" "), _c('CounterpartySlider', _vm._b({
    attrs: {
      "value": _vm.sliderInvert,
      "text1": "Не справится",
      "text2": "Справится"
    }
  }, 'CounterpartySlider', _vm.counterpartySliderStyle, false))], 1), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "0.2em"
    }
  }, [!(_vm.risksLoading || _vm.limitLoading) ? _c('div', {
    staticStyle: {
      "font-size": "1.6em",
      "line-height": "1.6em"
    }
  }, [_vm._v("Аванс")]) : _vm._e(), _vm._v(" "), _vm.risksLoading || _vm.limitLoading ? _c('div', [_c('div', {
    staticStyle: {
      "font-size": "1.6em",
      "line-height": "1.6em"
    }
  }, [_vm._v("\r\n              рассчитываем лимит ...\r\n            ")])]) : _vm._e()]), _vm._v(" "), _c('CounterpartySlider', _vm._b({
    attrs: {
      "backgroundAdaptive": true,
      "border": '1px solid black',
      "value": 40,
      "text1": "Сумма",
      "text2": "НМЦ"
    }
  }, 'CounterpartySlider', _vm.counterpartySliderStyle, false))], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "0.5em"
    }
  }, _vm._l(_vm.stopFactors, function (item, i) {
    return _c('div', {
      key: i,
      staticStyle: {
        "color": "#fff",
        "border-radius": "100% !important",
        "width": "2.5em",
        "height": "2.5em",
        "margin-right": "0.2em",
        "margin-top": "1em",
        "background-color": "gray",
        "display": "flex",
        "align-items": "center",
        "justify-content": "center",
        "font-weight": "bold"
      },
      style: item.style
    }, [_c('div', {
      staticStyle: {
        "font-size": "1.6em",
        "line-height": "1.6em",
        "position": "relative"
      }
    }, [_vm._v(_vm._s(item.value))])]);
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "12em",
      "overflow": "hidden",
      "min-width": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap",
      "margin-top": "-100px"
    }
  }, [_c('Speedometer', _vm._b({
    staticStyle: {
      "margin-top": "100px"
    },
    attrs: {
      "value": _vm.risks.revenueRate
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('div', {
          staticStyle: {
            "margin-top": "1.2em",
            "font-size": "1.6em",
            "line-height": "1.6em"
          }
        }, [_vm._v("Выручка")])];
      },
      proxy: true
    }])
  }, 'Speedometer', _vm.speedometerStyle, false)), _vm._v(" "), _c('Speedometer', _vm._b({
    staticStyle: {
      "margin-left": "6em",
      "margin-top": "100px"
    },
    attrs: {
      "value": _vm.risks.assetsRate
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('div', {
          staticStyle: {
            "margin-top": "1.2em",
            "font-size": "1.6em",
            "line-height": "1.6em",
            "text-align": "center"
          }
        }, [_vm._v("Баланс")])];
      },
      proxy: true
    }])
  }, 'Speedometer', _vm.speedometerStyle, false)), _vm._v(" "), _c('Speedometer', _vm._b({
    staticStyle: {
      "margin-left": "6em",
      "margin-top": "100px"
    },
    attrs: {
      "value": _vm.risks.contractsSumRate
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('div', {
          staticStyle: {
            "margin-top": "1.2em",
            "font-size": "1.6em",
            "line-height": "1.6em",
            "text-align": "center"
          }
        }, [_vm._v("Исполненные за 2 года контракты")])];
      },
      proxy: true
    }])
  }, 'Speedometer', _vm.speedometerStyle, false)), _vm._v(" "), _c('Speedometer', _vm._b({
    staticStyle: {
      "margin-left": "6em",
      "margin-top": "100px"
    },
    attrs: {
      "value": _vm.risks.maxContractPriceRate
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('div', {
          staticStyle: {
            "margin-top": "1.2em",
            "font-size": "1.6em",
            "line-height": "1.6em",
            "text-align": "center"
          }
        }, [_vm._v("Макс. сумма исполненного контракта")])];
      },
      proxy: true
    }])
  }, 'Speedometer', _vm.speedometerStyle, false))], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_vm.urlCounterpartyPage ? _c('div', {
    staticStyle: {
      "margin-left": "auto",
      "color": "#005BAA",
      "cursor": "pointer",
      "position": "relative",
      "margin-top": "0.8em",
      "top": "0em"
    }
  }, [_c('span', {
    staticStyle: {
      "text-decoration-line": "underline",
      "font-size": "2.8em",
      "line-height": "1"
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.cHref
    }
  }, [_vm._v("Подробнее")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "2.8em",
      "line-height": "1"
    }
  }, [_vm._v(">")])]) : _vm._e()])], 1);
};

var __vue_staticRenderFns__$R = [];
/* style */

const __vue_inject_styles__$R = undefined;
/* scoped */

const __vue_scope_id__$R = undefined;
/* module identifier */

const __vue_module_identifier__$R = undefined;
/* functional template */

const __vue_is_functional_template__$R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$R,
  staticRenderFns: __vue_staticRenderFns__$R
}, __vue_inject_styles__$R, __vue_script__$R, __vue_scope_id__$R, __vue_is_functional_template__$R, __vue_module_identifier__$R, false, undefined, undefined, undefined);

var script$Q = {
  name: "CounterpartyWidget",
  components: {
    Speedometer: __vue_component__$$,
    CounterpartySlider: __vue_component__$18,
    Loader: __vue_component__$15,
    SpeedometerLabel: __vue_component__$S
  },
  mixins: [base]
};

/* script */
const __vue_script__$Q = script$Q;
/* template */

var __vue_render__$Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('div', {
    staticStyle: {
      "margin-top": "26px"
    }
  }, [_vm.reliabilityLoading && !_vm.sliderInvert ? _c('div', {
    class: _vm.$style.sliderPointText
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "-4px",
      "top": "-3px"
    }
  }, [_vm._v("\n        рассчитываем скоринг ...\n      ")])]) : _vm._e(), _vm._v(" "), _c('CounterpartySlider', {
    attrs: {
      "value": _vm.sliderInvert,
      "modeText": "bottom",
      "text1": "Не справится",
      "text2": "Справится"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.speedometers,
    staticStyle: {
      "margin-top": "34px"
    }
  }, [_c('Speedometer', {
    attrs: {
      "firstControlPoint": 0.15,
      "secondControlPoint": 0.45,
      "value": _vm.risks.revenueRate,
      "label": 'Риски при участии в тендере',
      "zoom": 0.9
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('SpeedometerLabel', {
          attrs: {
            "loading": _vm.risksLoading,
            "text1": "НМЦ",
            "value1": _vm.risks.tenderPrice,
            "text2": "Выручка",
            "value2": _vm.risks.revenue
          }
        })];
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Speedometer', {
    attrs: {
      "firstControlPoint": 0.01,
      "secondControlPoint": 0.04,
      "value": _vm.risks.assetsRate,
      "label": 'Риски при заключении контракта',
      "zoom": 0.9
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('SpeedometerLabel', {
          attrs: {
            "loading": _vm.risksLoading,
            "text1": "НМЦ",
            "value1": _vm.risks.tenderPrice,
            "text2": "Баланс",
            "value2": _vm.risks.assets
          }
        })];
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Speedometer', {
    attrs: {
      "firstControlPoint": 0.1,
      "secondControlPoint": 0.4,
      "value": _vm.risks.contractsSumRate,
      "label": 'Риски при исполнении контракта',
      "zoom": 0.9
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('SpeedometerLabel', {
          attrs: {
            "loading": _vm.risksLoading,
            "text1": "НМЦ",
            "value1": _vm.risks.tenderPrice,
            "text2": "Исполненные за 2 года контракты",
            "value2": _vm.risks.contractsSum
          }
        })];
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Speedometer', {
    attrs: {
      "firstControlPoint": 0.5,
      "secondControlPoint": 1.0,
      "value": _vm.risks.maxContractPriceRate,
      "label": 'Риски при получении оплаты',
      "zoom": 0.9
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('SpeedometerLabel', {
          attrs: {
            "loading": _vm.risksLoading,
            "text1": "НМЦ",
            "value1": _vm.risks.tenderPrice,
            "text2": "Макс. сумма исполненного контракта",
            "value2": _vm.risks.maxContractPrice
          }
        })];
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.price,
    staticStyle: {
      "margin": "25px 0"
    }
  }, [_c('div', {
    class: _vm.$style.name,
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("Лимит аванса")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "28px"
    }
  }, [_vm.risksLoading || _vm.limitLoading ? _c('div', {
    class: _vm.$style.sliderPointText
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "-4px",
      "top": "-3px"
    }
  }, [_vm._v("\n          рассчитываем лимит ...\n        ")])]) : _vm._e(), _vm._v(" "), _c('CounterpartySlider', {
    attrs: {
      "backgroundAdaptive": _vm.limitSlider !== 100,
      "value": _vm.limitSlider,
      "textPoint": _vm.limitText,
      "text1": "Аванс",
      "text2": "НМЦ",
      "modeText": "bottom"
    }
  })], 1)])]);
};

var __vue_staticRenderFns__$Q = [];
/* style */

const __vue_inject_styles__$Q = function (inject) {
  if (!inject) return;
  inject("data-v-f5cc53b2_0", {
    source: ".src-components-box-2UDd{color:#000}.src-components-title-2Ubb .src-components-name-MxLN{font-style:normal;font-weight:700;font-size:16px;line-height:24px;color:#fff}.src-components-title-2Ubb .src-components-description-2mGr{font-style:normal;font-weight:700;font-size:16px;line-height:16px;color:#fff}.src-components-title-2Ubb .src-components-footnote-1SBK{font-size:10px;line-height:12px;color:#fff}.src-components-col2-2qjf{display:flex;justify-content:space-between;margin-right:-20px;margin-bottom:-20px}.src-components-col2-2qjf>*{margin-right:20px;margin-bottom:20px}.src-components-price-2Lxv{color:#fff}.src-components-price-2Lxv .src-components-name-MxLN{font-size:16px;line-height:16px}.src-components-price-2Lxv .src-components-value-1smG{font-size:40px;line-height:1}.src-components-h-1poW{font-weight:700;font-size:20px;line-height:24px;color:#fff}.src-components-speedometers-3WBP{display:flex;justify-content:space-between;flex-wrap:wrap;margin-right:-5px;margin-bottom:-5px}.src-components-speedometers-3WBP>*{margin-right:5px;margin-bottom:5px}.src-components-speedometers-3WBP .src-components-text-5Oly{margin:4px 0}.src-components-speedometers-3WBP .src-components-value-1smG{margin:4px 0}.src-components-speedometers-3WBP .src-components-separator-18kl{height:0;border-bottom:1px solid #fff;margin:8px 0}.src-components-sales-1znE .src-components-content-1vU2{border:1px solid rgba(255,255,255,.9);border-radius:4px!important}.src-components-sliderLabel-3c2J{display:flex;justify-content:space-between;color:#fff;margin:5px 10px 0}.src-components-sliderPointText-3yz-{position:relative;top:-25px;left:5px;color:#fff;font-size:16px;line-height:1;display:flex;align-items:center;justify-content:center;white-space:nowrap}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-box-2UDd",
      "title": "src-components-title-2Ubb",
      "name": "src-components-name-MxLN",
      "description": "src-components-description-2mGr",
      "footnote": "src-components-footnote-1SBK",
      "col2": "src-components-col2-2qjf",
      "price": "src-components-price-2Lxv",
      "value": "src-components-value-1smG",
      "h": "src-components-h-1poW",
      "speedometers": "src-components-speedometers-3WBP",
      "text": "src-components-text-5Oly",
      "separator": "src-components-separator-18kl",
      "sales": "src-components-sales-1znE",
      "content": "src-components-content-1vU2",
      "sliderLabel": "src-components-sliderLabel-3c2J",
      "sliderPointText": "src-components-sliderPointText-3yz-"
    }
  });
};
/* scoped */


const __vue_scope_id__$Q = undefined;
/* module identifier */

const __vue_module_identifier__$Q = undefined;
/* functional template */

const __vue_is_functional_template__$Q = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Q,
  staticRenderFns: __vue_staticRenderFns__$Q
}, __vue_inject_styles__$Q, __vue_script__$Q, __vue_scope_id__$Q, __vue_is_functional_template__$Q, __vue_module_identifier__$Q, false, createInjector, undefined, undefined);

var script$P = {
  name: "CounterpartyWidgetSmallPage",
  components: {
    CounterpartyWidgetSmall: __vue_component__$R
  },
  props: {
    apiCounteragent: {
      type: String,
      default: "/microservices-otc/counteragent/api/"
    },
    urlCounterpartyPage: {
      type: String,
      default: "/counterparty"
    },
    inn: String,
    kpp: String,
    externalId: String,
    marketPlaceId: String
  },

  data() {
    return {
      reliability: create({
        loading: true
      }),
      limit: create({
        loading: true
      }),
      contractExecutionRisks: create({
        loading: true
      }),
      counterparty: create({
        loading: true
      })
    };
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      let param = {
        inn: this.inn,
        kpp: this.kpp,
        externalId: this.externalId,
        marketPlaceId: this.marketPlaceId,
        isWidget: true
      };
      await Promise.all([fetch(this.counterparty, () => this.fetchCounteragent(param)), fetch(this.reliability, () => this.fetchReliability(param)), fetch(this.limit, () => this.fetchLimit(param)), fetch(this.contractExecutionRisks, () => this.fetchContractExecutionRisks(param))]);
    },

    fetchCounteragent(param) {
      return httpPost(urlConcat(this.apiCounteragent, "counteragent/get"), param);
    },

    async fetchReliability(param) {
      let url = urlConcat(this.apiCounteragent, "counteragent/get-reliability");
      let result = await httpPost(url, param);
      return result;
    },

    fetchLimit(param) {
      return httpPost(urlConcat(this.apiCounteragent, "counteragent/get-limit"), param);
    },

    async fetchContractExecutionRisks(param) {
      let data = await httpPost(urlConcat(this.apiCounteragent, "counteragent/get-contract-execution-risks"), param);
      return data;
    }

  }
};

/* script */
const __vue_script__$P = script$P;
/* template */

var __vue_render__$P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('CounterpartyWidgetSmall', _vm._b({
    attrs: {
      "inn": _vm.inn,
      "kpp": _vm.kpp,
      "marketPlaceId": _vm.marketPlaceId,
      "externalId": _vm.externalId,
      "urlCounterpartyPage": _vm.urlCounterpartyPage
    }
  }, 'CounterpartyWidgetSmall', _vm.$data, false));
};

var __vue_staticRenderFns__$P = [];
/* style */

const __vue_inject_styles__$P = undefined;
/* scoped */

const __vue_scope_id__$P = undefined;
/* module identifier */

const __vue_module_identifier__$P = undefined;
/* functional template */

const __vue_is_functional_template__$P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$P,
  staticRenderFns: __vue_staticRenderFns__$P
}, __vue_inject_styles__$P, __vue_script__$P, __vue_scope_id__$P, __vue_is_functional_template__$P, __vue_module_identifier__$P, false, undefined, undefined, undefined);

var script$O = {
  name: 'ThemeDark',
  provide: {
    team: 'dark'
  },
  computed: {
    DEBUG: () => "production" === 'development'
  }
};

/* script */
const __vue_script__$O = script$O;
/* template */

var __vue_render__$O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    style: _vm.DEBUG && {
      backgroundColor: 'gray'
    } || {}
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$O = [];
/* style */

const __vue_inject_styles__$O = undefined;
/* scoped */

const __vue_scope_id__$O = undefined;
/* module identifier */

const __vue_module_identifier__$O = undefined;
/* functional template */

const __vue_is_functional_template__$O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$O,
  staticRenderFns: __vue_staticRenderFns__$O
}, __vue_inject_styles__$O, __vue_script__$O, __vue_scope_id__$O, __vue_is_functional_template__$O, __vue_module_identifier__$O, false, undefined, undefined, undefined);

var script$N = {
  name: "ThemeWhite",
  provide: {
    team: "white"
  }
};

/* script */
const __vue_script__$N = script$N;
/* template */

var __vue_render__$N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$N = [];
/* style */

const __vue_inject_styles__$N = undefined;
/* scoped */

const __vue_scope_id__$N = undefined;
/* module identifier */

const __vue_module_identifier__$N = undefined;
/* functional template */

const __vue_is_functional_template__$N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$N,
  staticRenderFns: __vue_staticRenderFns__$N
}, __vue_inject_styles__$N, __vue_script__$N, __vue_scope_id__$N, __vue_is_functional_template__$N, __vue_module_identifier__$N, false, undefined, undefined, undefined);

function indices(page, count, spread) {
  if (!count || count < 0) {
    return null;
  }

  page = Math.min(Math.max(page || 1, 1), count);
  const indices = Array(spread * 2 + 1).fill().map((x, i) => page + i - spread);
  const first = indices[0];

  if (first < 1) {
    indices.splice(0, 1 - first);
  } else if (first === 2) {
    indices.splice(0, 0, 1);
  } else if (first === 3) {
    indices.splice(0, 0, 1, 2);
  } else if (first > 3) {
    indices.splice(0, 0, 1, null);
  }

  const last = indices[indices.length - 1];

  if (last > count) {
    indices.splice(indices.length - (last - count), last - count);
  } else if (last === count - 1) {
    indices.splice(indices.length, 0, count);
  } else if (last === count - 2) {
    indices.splice(indices.length, 0, count - 1, count);
  } else if (last < count - 2) {
    indices.splice(indices.length, 0, null, count);
  }

  return indices;
}

var paging = /*#__PURE__*/Object.freeze({
  __proto__: null,
  indices: indices
});

var script$M = {
  name: 'Pager',
  components: {
    ButtonGrey: __vue_component__$1n
  },
  props: {
    page: Number,
    count: Number,
    isPolza: String,
    spread: {
      type: Number,
      default: 2
    },
    url: String
  },
  computed: {
    indices() {
      let items = indices(this.page, this.count, this.spread);
      if (items && items.length <= 1) return [];
      return items;
    }

  },
  methods: {
    getArrowButtonModel() {
      return this.isPolza === 'true' ? {
        borderRadius: '0',
        color: '#FFFFFF',
        background: '#3F4047',
        hoverColor: '#3F4047',
        hoverBackground: '#FFFFFF',
        border: '1px solid #3F4047'
      } : {
        borderRadius: '4px 4px 4px 4px'
      };
    },

    getPageButtonModel(pageIndex) {
      return this.isPolza === 'true' ? {
        borderRadius: '0',
        color: pageIndex == this.page ? '#3F4047' : '#FFFFFF',
        background: pageIndex == this.page ? '#FFFFFF' : '#3F4047',
        hoverColor: '#3F4047',
        hoverBackground: '#FFFFFF',
        border: '1px solid #3F4047'
      } : {
        borderRadius: '4px 4px 4px 4px',
        color: pageIndex == this.page ? 'rgb(166, 166, 166)' : undefined,
        background: pageIndex == this.page ? 'rgb(249, 249, 249)' : undefined
      };
    },

    enablePageLink(pageIndex) {
      return !this.isPolza && this.page != pageIndex && this.url;
    },

    getTagAModel(pageIndex) {
      return {
        color: pageIndex == this.page ? 'rgb(166, 166, 166)' : 'rgb(255, 255, 255)',
        textDecoration: 'none'
      };
    },

    getPageHref(pageIndex) {
      if (pageIndex === 1) {
        return this.url && this.url.replace(/[?,&]([^\d]*)={pageIndex}/, '') || null;
      }

      return this.url && this.url.replace('{pageIndex}', pageIndex) || null;
    }

  }
};

/* script */
const __vue_script__$M = script$M;
/* template */

var __vue_render__$M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.$style.box
  }, [_vm.count && _vm.count > 0 && _vm.page > 1 ? _c('div', [_c('ButtonGrey', _vm._b({
    attrs: {
      "small": true,
      "height": "32px"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('page', _vm.page - 1);
      }
    }
  }, 'ButtonGrey', _vm.getArrowButtonModel(), false), [_vm._v("\n      <\n    ")])], 1) : _vm._e(), _vm._v(" "), _vm._l(_vm.indices, function (pageIndex, index) {
    return _c('div', {
      key: index,
      class: _vm.$style.item
    }, [pageIndex ? _c('ButtonGrey', _vm._b({
      attrs: {
        "small": true,
        "disabled": pageIndex == _vm.page,
        "height": "32px"
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('page', pageIndex);
        }
      }
    }, 'ButtonGrey', _vm.getPageButtonModel(pageIndex), false), [_vm.enablePageLink(pageIndex) ? _c('a', {
      style: _vm.getTagAModel(pageIndex),
      attrs: {
        "href": _vm.getPageHref(pageIndex)
      },
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return false;
        }
      }
    }, [_vm._v("\n        " + _vm._s(pageIndex || '...') + "\n      ")]) : [_vm._v("\n        " + _vm._s(pageIndex || '...') + "\n      ")]], 2) : _c('div', {
      class: !_vm.isPolza ? _vm.$style.spacer : _vm.$style.spacer_polza
    }, [_vm._v("...")])], 1);
  }), _vm._v(" "), _vm.count && _vm.count > 0 && _vm.page < _vm.count ? _c('div', [_c('ButtonGrey', _vm._b({
    attrs: {
      "small": true,
      "height": "32px"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('page', _vm.page + 1);
      }
    }
  }, 'ButtonGrey', _vm.getArrowButtonModel(), false), [_vm._v("\n      >\n    ")])], 1) : _vm._e()], 2);
};

var __vue_staticRenderFns__$M = [];
/* style */

const __vue_inject_styles__$M = function (inject) {
  if (!inject) return;
  inject("data-v-583b3ec2_0", {
    source: ".src-components-box-1twM{display:flex;justify-content:center}.src-components-item-2--T{margin:0 5px}.src-components-spacer-2E9W{color:#fff;margin:0 10px}.src-components-spacer_polza-1G9j{color:#a6a6a6;margin:0 10px}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-box-1twM",
      "item": "src-components-item-2--T",
      "spacer": "src-components-spacer-2E9W",
      "spacer_polza": "src-components-spacer_polza-1G9j"
    }
  });
};
/* scoped */


const __vue_scope_id__$M = undefined;
/* module identifier */

const __vue_module_identifier__$M = undefined;
/* functional template */

const __vue_is_functional_template__$M = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$M,
  staticRenderFns: __vue_staticRenderFns__$M
}, __vue_inject_styles__$M, __vue_script__$M, __vue_scope_id__$M, __vue_is_functional_template__$M, __vue_module_identifier__$M, false, createInjector, undefined, undefined);

//
var script$L = {
  name: "ButtonRed",
  components: {
    Button: __vue_component__$1Y
  },
  props: {
    padding: String,
    bold: Boolean,
    disable: Boolean,
    textAlign: String,
    height: String,
    width: String
  },
  methods: {
    handlerOnClick(e) {
      this.$emit('click', e);
    }

  }
};

/* script */
const __vue_script__$L = script$L;
/* template */

var __vue_render__$L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('Button', {
    staticClass: "ButtonRed",
    attrs: {
      "padding": _vm.padding,
      "bold": _vm.bold,
      "disable": _vm.disable,
      "height": _vm.height,
      "width": _vm.width,
      "textAlign": _vm.textAlign,
      "color": '#FFFFFF',
      "background": '#446baa',
      "hoverBackground": '#677da0',
      "activeBackground": '#536480',
      "disableBackground": '#446baa',
      "disableColor": '#FFFFFF'
    },
    on: {
      "click": _vm.handlerOnClick
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$L = [];
/* style */

const __vue_inject_styles__$L = undefined;
/* scoped */

const __vue_scope_id__$L = undefined;
/* module identifier */

const __vue_module_identifier__$L = undefined;
/* functional template */

const __vue_is_functional_template__$L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$L,
  staticRenderFns: __vue_staticRenderFns__$L
}, __vue_inject_styles__$L, __vue_script__$L, __vue_scope_id__$L, __vue_is_functional_template__$L, __vue_module_identifier__$L, false, undefined, undefined, undefined);

const colors = ['red', 'grey', 'clear'];
const defaultColor = 'red';
const sizes = ['tiny', 'small', 'normal', 'big'];
const defaultSize$1 = 'normal';
var script$K = {
  name: 'ButtonBoat',
  props: {
    color: {
      type: String,
      default: defaultColor
    },
    size: {
      type: String,
      default: defaultSize$1
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonClass() {
      const size = sizes.includes(this.size) && this.size || defaultSize$1;
      const color = colors.includes(this.color) && this.color || defaultColor;
      return [this.$style.button, this.$style[size + 'Size'], this.$style[color + 'Color'], this.disabled && this.$style.disabled || this.$style.enabled];
    }

  },
  methods: {
    handleClick(ev) {
      if (!this.disabled) {
        this.$emit('click', ev);
      }
    }

  }
};

/* script */
const __vue_script__$K = script$K;
/* template */

var __vue_render__$K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('button', {
    class: _vm.buttonClass,
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.handleClick($event);
      }
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$K = [];
/* style */

const __vue_inject_styles__$K = function (inject) {
  if (!inject) return;
  inject("data-v-67e922b4_0", {
    source: ".src-components-button-2LOY{border:0;border-radius:4px 4px 20px 4px!important;outline:0;line-height:24px;text-align:center}.src-components-enabled-1EJc{cursor:pointer}.src-components-tinySize-4pgw{padding:0 16px;font-size:13px;font-weight:400}.src-components-smallSize-1YNr{padding:4px 16px;font-size:16px;font-weight:600}.src-components-normalSize-3EZP{padding:8px 16px;font-size:16px;font-weight:600}.src-components-bigSize-1cng{padding:16px 16px;font-size:16px;font-weight:600}.src-components-redColor-2r6G.src-components-enabled-1EJc{color:#fff;background-color:#ee2b45}.src-components-redColor-2r6G.src-components-enabled-1EJc:hover{background-color:#ee6865}.src-components-redColor-2r6G.src-components-enabled-1EJc:active{background-color:#ee2b45}.src-components-redColor-2r6G.src-components-disabled-JTDP{color:rgba(255,255,255,.5);background-color:rgba(238,43,69,.5)}.src-components-greyColor-1O88.src-components-enabled-1EJc{color:#fff;background-color:#6e7c8d}.src-components-greyColor-1O88.src-components-enabled-1EJc:hover{background-color:#ee6865}.src-components-greyColor-1O88.src-components-enabled-1EJc:active{background-color:#6e7c8d}.src-components-greyColor-1O88.src-components-disabled-JTDP{color:rgba(255,255,255,.5);background-color:rgba(110,124,141,.5)}.src-components-clearColor-a8md.src-components-enabled-1EJc{color:#202020;background:0 0}.src-components-clearColor-a8md.src-components-enabled-1EJc:hover{color:#fff;background-color:#ee6865}.src-components-clearColor-a8md.src-components-enabled-1EJc:active{color:#202020;background:0 0}.src-components-clearColor-a8md.src-components-disabled-JTDP{color:rgba(255,255,255,.5);background-color:rgba(110,124,141,.5)}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "button": "src-components-button-2LOY",
      "enabled": "src-components-enabled-1EJc",
      "tinySize": "src-components-tinySize-4pgw",
      "smallSize": "src-components-smallSize-1YNr",
      "normalSize": "src-components-normalSize-3EZP",
      "bigSize": "src-components-bigSize-1cng",
      "redColor": "src-components-redColor-2r6G",
      "disabled": "src-components-disabled-JTDP",
      "greyColor": "src-components-greyColor-1O88",
      "clearColor": "src-components-clearColor-a8md"
    }
  });
};
/* scoped */


const __vue_scope_id__$K = undefined;
/* module identifier */

const __vue_module_identifier__$K = undefined;
/* functional template */

const __vue_is_functional_template__$K = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$K,
  staticRenderFns: __vue_staticRenderFns__$K
}, __vue_inject_styles__$K, __vue_script__$K, __vue_scope_id__$K, __vue_is_functional_template__$K, __vue_module_identifier__$K, false, createInjector, undefined, undefined);

var script$J = {
  name: 'ButtonTiny',
  props: {
    label: String,
    disabled: {
      type: Boolean,
      default: false
    }
  }
};

/* script */
const __vue_script__$J = script$J;
/* template */

var __vue_render__$J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: !_vm.disabled && _vm.$style.enabledBox || _vm.$style.disabledBox
  }, [_c('button', {
    class: _vm.$style.button
  }, [_vm._t("default")], 2), _vm._v("\n  " + _vm._s(_vm.label) + "\n")]);
};

var __vue_staticRenderFns__$J = [];
/* style */

const __vue_inject_styles__$J = function (inject) {
  if (!inject) return;
  inject("data-v-a49ac0b8_0", {
    source: ".src-components-disabledBox-3Q6O,.src-components-enabledBox-ClOy{position:relative;padding:4px 8px 4px 40px;font-weight:400;font-size:16px;line-height:24px;user-select:none;color:#202020}.src-components-button-2h0F{position:absolute;top:0;left:0;box-sizing:border-box;width:32px;height:32px;border:1px solid #6e7c8d;padding:3px;border-radius:4px!important;outline:0;color:#6e7c8d;background:#fff;text-align:center}.src-components-enabledBox-ClOy{cursor:pointer}.src-components-enabledBox-ClOy .src-components-button-2h0F{cursor:pointer}.src-components-enabledBox-ClOy:hover .src-components-button-2h0F{border-color:#202020;background:#f0f0f0}.src-components-enabledBox-ClOy:active .src-components-button-2h0F{border-color:#6e7c8d;background:#fff}.src-components-disabledBox-3Q6O{opacity:.5}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "enabledBox": "src-components-enabledBox-ClOy",
      "disabledBox": "src-components-disabledBox-3Q6O",
      "button": "src-components-button-2h0F"
    }
  });
};
/* scoped */


const __vue_scope_id__$J = undefined;
/* module identifier */

const __vue_module_identifier__$J = undefined;
/* functional template */

const __vue_is_functional_template__$J = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$J,
  staticRenderFns: __vue_staticRenderFns__$J
}, __vue_inject_styles__$J, __vue_script__$J, __vue_scope_id__$J, __vue_is_functional_template__$J, __vue_module_identifier__$J, false, createInjector, undefined, undefined);

var script$I = {
  name: 'IconPenWhite'
};

/* script */
const __vue_script__$I = script$I;
/* template */

var __vue_render__$I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('rect', {
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "url(#pattern0)"
    }
  }), _vm._v(" "), _c('defs', [_c('pattern', {
    attrs: {
      "id": "pattern0",
      "patternContentUnits": "objectBoundingBox",
      "width": "1",
      "height": "1"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#image0",
      "transform": "scale(0.0078125)"
    }
  })]), _vm._v(" "), _c('image', {
    attrs: {
      "id": "image0",
      "width": "128",
      "height": "128",
      "xlink:href": "data:image/png;base64,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"
    }
  })])]);
};

var __vue_staticRenderFns__$I = [];
/* style */

const __vue_inject_styles__$I = undefined;
/* scoped */

const __vue_scope_id__$I = undefined;
/* module identifier */

const __vue_module_identifier__$I = undefined;
/* functional template */

const __vue_is_functional_template__$I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$I,
  staticRenderFns: __vue_staticRenderFns__$I
}, __vue_inject_styles__$I, __vue_script__$I, __vue_scope_id__$I, __vue_is_functional_template__$I, __vue_module_identifier__$I, false, undefined, undefined, undefined);

var script$H = {
  name: 'IconPenSmall'
};

/* script */
const __vue_script__$H = script$H;
/* template */

var __vue_render__$H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('img', {
    attrs: {
      "width": "12",
      "height": "12",
      "src": "data:image/png;base64,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"
    }
  });
};

var __vue_staticRenderFns__$H = [];
/* style */

const __vue_inject_styles__$H = undefined;
/* scoped */

const __vue_scope_id__$H = undefined;
/* module identifier */

const __vue_module_identifier__$H = undefined;
/* functional template */

const __vue_is_functional_template__$H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$H,
  staticRenderFns: __vue_staticRenderFns__$H
}, __vue_inject_styles__$H, __vue_script__$H, __vue_scope_id__$H, __vue_is_functional_template__$H, __vue_module_identifier__$H, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$G = {
  name: "StarsRating",
  components: {},
  directives: {},
  props: {
    meta: {
      type: Boolean,
      default: true
    },
    styleStarWidth: {
      type: Number,
      default: 15
    },
    styleStarHeight: {
      type: Number,
      default: 15
    },
    styleEmptyStarColor: {
      type: String,
      default: "rgb(217, 217, 217)"
    },
    styleFullStarColor: {
      type: String,
      default: "rgb(241, 199, 69)"
    },
    rating: {
      type: Number,
      default: 4.3
    },
    starStyle: {
      type: Object
    },
    isIndicatorActive: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      stars: [],
      emptyStar: 0,
      fullStar: 1,
      totalStars: 5 //ratingCount: 100

    };
  },
  computed: {
    ratingCount() {
      function getRandomArbitrary(min, max) {
        return Math.round(Math.random() * (max - min) + min);
      }

      let value = getRandomArbitrary(10, 500);
      return value;
    },

    getStarPoints: function () {
      let centerX = this.styleStarWidth / 2;
      let centerY = this.styleStarWidth / 2;
      let innerCircleArms = 5; // a 5 arms star

      let innerRadius = this.styleStarWidth / innerCircleArms;
      let innerOuterRadiusRatio = 2.5; // Unique value - determines fatness/sharpness of star

      let outerRadius = innerRadius * innerOuterRadiusRatio;
      return this.calcStarPoints(centerX, centerY, innerCircleArms, innerRadius, outerRadius);
    }
  },
  watch: {
    rating: function () {
      this.setStars();
    }
  },

  created() {
    //this.setNestedConfigStyles(this.starStyle);
    this.initStars();
    this.setStars();
  },

  methods: {
    calcStarPoints(centerX, centerY, innerCircleArms, innerRadius, outerRadius) {
      let angle = Math.PI / innerCircleArms;
      let angleOffsetToCenterStar = 60;
      let totalArms = innerCircleArms * 2;
      let points = "";

      for (let i = 0; i < totalArms; i++) {
        let isEvenIndex = i % 2 == 0;
        let r = isEvenIndex ? outerRadius : innerRadius;
        let currX = centerX + Math.cos(i * angle + angleOffsetToCenterStar) * r;
        let currY = centerY + Math.sin(i * angle + angleOffsetToCenterStar) * r;
        points += currX + "," + currY + " ";
      }

      return points;
    },

    initStars() {
      for (let i = 0; i < this.totalStars; i++) {
        this.stars.push({
          raw: this.emptyStar,
          percent: this.emptyStar + "%"
        });
      }
    },

    setStars() {
      let fullStarsCounter = Math.floor(this.rating);
      let otherEmpty = false;

      for (let i = 0; i < this.stars.length; i++) {
        if (fullStarsCounter !== 0) {
          this.stars[i].raw = this.fullStar;
          this.stars[i].percent = this.calcStarFullness(this.stars[i]);
          fullStarsCounter--;
        } else if (!otherEmpty) {
          let surplus = Math.round(this.rating % 1 * 10) / 10; // Support just one decimal

          let roundedOneDecimalPoint = Math.round(surplus * 10) / 10;
          this.stars[i].raw = roundedOneDecimalPoint;
          this.stars[i].percent = this.calcStarFullness(this.stars[i]);
          otherEmpty = true;
        } else {
          this.stars[i].raw = 0;
          this.stars[i].percent = "0%";
        }
      }
    },

    getFullFillColor(starData) {
      return starData.raw !== this.emptyStar ? this.styleFullStarColor : this.styleEmptyStarColor;
    },

    calcStarFullness(starData) {
      let starFullnessPercent = starData.raw * 100 + "%";
      return starFullnessPercent;
    }

  }
};

/* script */
const __vue_script__$G = script$G;
/* template */

var __vue_render__$G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "star-rating"
  }, [_vm._l(_vm.stars, function (star, index) {
    return _c('div', {
      key: index,
      staticClass: "star-container"
    }, [_c('svg', {
      staticClass: "star-svg",
      style: {
        fill: "url(#gradient" + star.raw + ")",
        width: _vm.styleStarWidth,
        height: _vm.styleStarHeight
      },
      attrs: {
        "width": _vm.styleStarWidth,
        "height": _vm.styleStarHeight
      }
    }, [_c('polygon', {
      staticStyle: {
        "fill-rule": "nonzero"
      },
      attrs: {
        "points": _vm.getStarPoints
      }
    }), _vm._v(" "), _c('defs', [_c('linearGradient', {
      attrs: {
        "id": "gradient" + star.raw
      }
    }, [_c('stop', {
      attrs: {
        "id": "stop1",
        "offset": star.percent,
        "stop-opacity": "1",
        "stop-color": _vm.getFullFillColor(star)
      }
    }), _vm._v(" "), _c('stop', {
      attrs: {
        "id": "stop2",
        "offset": star.percent,
        "stop-opacity": "0",
        "stop-color": _vm.getFullFillColor(star)
      }
    }), _vm._v(" "), _c('stop', {
      attrs: {
        "id": "stop3",
        "offset": star.percent,
        "stop-opacity": "1",
        "stop-color": _vm.styleEmptyStarColor
      }
    }), _vm._v(" "), _c('stop', {
      attrs: {
        "id": "stop4",
        "offset": "100%",
        "stop-opacity": "1",
        "stop-color": _vm.styleEmptyStarColor
      }
    })], 1)], 1)])]);
  }), _vm._v(" "), _vm.isIndicatorActive ? _c('div', {
    staticClass: "indicator"
  }, [_vm._v(_vm._s(_vm.rating))]) : _vm._e(), _vm._v(" "), _vm.meta ? _c('span', {
    attrs: {
      "itemprop": "aggregateRating",
      "itemscope": "",
      "itemtype": "https://schema.org/AggregateRating"
    }
  }, [_c('meta', {
    attrs: {
      "itemprop": "ratingValue",
      "content": _vm.rating
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "itemprop": "bestRating",
      "content": _vm.totalStars
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "itemprop": "ratingCount",
      "content": _vm.ratingCount
    }
  })]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$G = [];
/* style */

const __vue_inject_styles__$G = function (inject) {
  if (!inject) return;
  inject("data-v-19545507_0", {
    source: ".star-rating[data-v-19545507]{display:flex;align-items:center}.star-rating .star-container[data-v-19545507]{display:flex}.star-rating .star-container .star-svg[data-v-19545507]{width:15px;height:15px}.star-rating .star-container[data-v-19545507]:not(:last-child){margin-right:5px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$G = "data-v-19545507";
/* module identifier */

const __vue_module_identifier__$G = undefined;
/* functional template */

const __vue_is_functional_template__$G = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$G,
  staticRenderFns: __vue_staticRenderFns__$G
}, __vue_inject_styles__$G, __vue_script__$G, __vue_scope_id__$G, __vue_is_functional_template__$G, __vue_module_identifier__$G, false, createInjector, undefined, undefined);

//
var script$F = {
  name: "StaticText",
  props: {
    isPolza: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      polzaStyle: polzaStyle$1
    };
  },

  methods: {
    getClass(className) {
      return this.isPolza && this.polzaStyle[className] || this.$style[className];
    }

  }
};

/* script */
const __vue_script__$F = script$F;
/* template */

var __vue_render__$F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', _vm._g({
    class: _vm.getClass('box')
  }, _vm.$listeners), [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$F = [];
/* style */

const __vue_inject_styles__$F = function (inject) {
  if (!inject) return;
  inject("data-v-8917cb36_0", {
    source: ".src-components-box-3QrS{position:relative;border-radius:4px!important;border:.75px solid #6e7c8d;padding:4px 7px}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-box-3QrS"
    }
  });
};
/* scoped */


const __vue_scope_id__$F = undefined;
/* module identifier */

const __vue_module_identifier__$F = undefined;
/* functional template */

const __vue_is_functional_template__$F = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$F,
  staticRenderFns: __vue_staticRenderFns__$F
}, __vue_inject_styles__$F, __vue_script__$F, __vue_scope_id__$F, __vue_is_functional_template__$F, __vue_module_identifier__$F, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$E = {
  name: "IconDown"
};

/* script */
const __vue_script__$E = script$E;
/* template */

var __vue_render__$E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "width": "12",
      "height": "7",
      "viewBox": "0 0 12 7",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.10149 6.41603C6.43333 6.8569 5.56667 6.8569 4.89852 6.41603L1.16876 3.95503C-0.48701 2.86251 0.286513 0.285679 2.27024 0.285679L9.72976 0.285679C11.7135 0.285679 12.487 2.8625 10.8312 3.95503L7.10149 6.41603Z",
      "fill": "#202020"
    }
  })]);
};

var __vue_staticRenderFns__$E = [];
/* style */

const __vue_inject_styles__$E = undefined;
/* scoped */

const __vue_scope_id__$E = "data-v-05bb8f2a";
/* module identifier */

const __vue_module_identifier__$E = undefined;
/* functional template */

const __vue_is_functional_template__$E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$E,
  staticRenderFns: __vue_staticRenderFns__$E
}, __vue_inject_styles__$E, __vue_script__$E, __vue_scope_id__$E, __vue_is_functional_template__$E, __vue_module_identifier__$E, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$D = {
  name: 'ItemsList',
  props: {
    items: Array,
    getItemKey: {
      type: Function,
      default: item => item.key
    }
  },
  methods: {
    handleClick(item) {}

  }
};

/* script */
const __vue_script__$D = script$D;
/* template */

var __vue_render__$D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('ul', {
    class: _vm.$style.box
  }, _vm._l(_vm.items, function (item) {
    return _c('li', {
      key: _vm.getItemKey(item),
      class: _vm.$style.item,
      on: {
        "click": function ($event) {
          return _vm.$emit('select', item);
        }
      }
    }, [_vm._t("item", null, {
      "item": item
    })], 2);
  }), 0)]);
};

var __vue_staticRenderFns__$D = [];
/* style */

const __vue_inject_styles__$D = function (inject) {
  if (!inject) return;
  inject("data-v-522d4678_0", {
    source: ".src-components-box-LPWT{list-style-type:none;margin:0;padding:4px 7px}.src-components-item-21mB{cursor:pointer}.src-components-item-21mB:hover{background-color:#f0f2f4}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-box-LPWT",
      "item": "src-components-item-21mB"
    }
  });
};
/* scoped */


const __vue_scope_id__$D = undefined;
/* module identifier */

const __vue_module_identifier__$D = undefined;
/* functional template */

const __vue_is_functional_template__$D = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$D,
  staticRenderFns: __vue_staticRenderFns__$D
}, __vue_inject_styles__$D, __vue_script__$D, __vue_scope_id__$D, __vue_is_functional_template__$D, __vue_module_identifier__$D, false, createInjector, undefined, undefined);

//
var script$C = {
  name: "DropDownList",
  components: {
    StaticText: __vue_component__$F,
    ItemsList: __vue_component__$D,
    IconDown: __vue_component__$E
  },
  props: {
    value: Object,
    items: Array,
    getItemKey: {
      type: Function,
      default: item => item.key
    },
    getItemText: {
      type: Function,
      default: item => item.text
    },
    isPolza: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isOpened: false,
      polzaStyle: polzaStyle$1
    };
  },

  computed: {
    valueText() {
      return this.value && this.getItemText(this.value);
    }

  },

  mounted() {
    document.addEventListener("click", this.tryClose);
    document.addEventListener("keyup", this.tryClose);
  },

  methods: {
    tryClose(e) {
      let el = e.target;

      while (el) {
        if (el === this.$el) {
          return;
        }

        el = el.parentElement;
      }

      this.isOpened = false;
    },

    handleSelect(item) {
      this.isOpened = false;
      this.$emit("input", item);
    },

    getClass(className) {
      return this.isPolza && this.polzaStyle[className] || this.$style[className];
    }

  }
};

/* script */
const __vue_script__$C = script$C;
/* template */

var __vue_render__$C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.$style.box
  }, [_c('static-text', {
    attrs: {
      "isPolza": _vm.isPolza
    },
    on: {
      "click": function ($event) {
        _vm.isOpened = !_vm.isOpened;
      }
    }
  }, [_c('div', {
    class: _vm.$style.value
  }, [_vm._t("selectedItem", null, {
    "item": _vm.value
  }), _vm._v(" "), _c('icon-down', {
    class: _vm.$style.icon
  })], 2)]), _vm._v(" "), _c('items-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isOpened,
      expression: "isOpened"
    }],
    class: _vm.getClass('items'),
    attrs: {
      "items": _vm.items,
      "getItemKey": _vm.getItemKey
    },
    on: {
      "select": _vm.handleSelect
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (ref) {
        var item = ref.item;
        return [_vm._t("item", null, {
          "item": item
        })];
      }
    }], null, true)
  })], 1);
};

var __vue_staticRenderFns__$C = [];
/* style */

const __vue_inject_styles__$C = function (inject) {
  if (!inject) return;
  inject("data-v-77859371_0", {
    source: ".src-components-box-YY1y{position:relative;user-select:none}.src-components-value-3-rz{padding-right:22px;cursor:pointer}.src-components-icon-3_9Z{position:absolute;top:9px;right:6px;cursor:pointer;fill:#3c3c3c}.src-components-items-1Jt2{position:absolute;top:100%;width:100%;z-index:100;margin-top:4px;box-sizing:border-box;border-radius:4px!important;border:.75px solid #6e7c8d;background-color:#fff}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-box-YY1y",
      "value": "src-components-value-3-rz",
      "icon": "src-components-icon-3_9Z",
      "items": "src-components-items-1Jt2"
    }
  });
};
/* scoped */


const __vue_scope_id__$C = undefined;
/* module identifier */

const __vue_module_identifier__$C = undefined;
/* functional template */

const __vue_is_functional_template__$C = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$C,
  staticRenderFns: __vue_staticRenderFns__$C
}, __vue_inject_styles__$C, __vue_script__$C, __vue_scope_id__$C, __vue_is_functional_template__$C, __vue_module_identifier__$C, false, createInjector, undefined, undefined);

//
var script$B = {
  name: "SelectVue",
  components: {
    DropDownList: __vue_component__$C
  },
  props: {
    //{ key: 1, text: 'По релевантности', field: 'Weight' }
    items: Array,
    value: null
  }
};

/* script */
const __vue_script__$B = script$B;
/* template */

var __vue_render__$B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.items && _vm.items.length > 0 ? _c('drop-down-list', {
    class: _vm.$style.sort,
    attrs: {
      "items": _vm.items,
      "value": _vm.value
    },
    on: {
      "input": function (x) {
        return _vm.$emit('input', x);
      }
    },
    scopedSlots: _vm._u([{
      key: "selectedItem",
      fn: function (ref) {
        var item = ref.item;
        return [_c('div', {
          class: _vm.$style.selectedSortItemText
        }, [_vm._v(_vm._s(item && item.text || ''))])];
      }
    }, {
      key: "item",
      fn: function (ref) {
        var item = ref.item;
        return [_c('div', {
          class: _vm.$style.sortItemText
        }, [_vm._v(_vm._s(item && item.text || ''))])];
      }
    }], null, false, 1556563145)
  }) : _vm._e();
};

var __vue_staticRenderFns__$B = [];
/* style */

const __vue_inject_styles__$B = function (inject) {
  if (!inject) return;
  inject("data-v-b9182428_0", {
    source: ".src-components-sort-Wz02{background-color:#fff;border-radius:4px!important;margin-left:auto;margin-top:17px;min-width:304px}.src-components-selectedSortItemText-268V{font-size:16px;line-height:16px}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "sort": "src-components-sort-Wz02",
      "selectedSortItemText": "src-components-selectedSortItemText-268V"
    }
  });
};
/* scoped */


const __vue_scope_id__$B = undefined;
/* module identifier */

const __vue_module_identifier__$B = undefined;
/* functional template */

const __vue_is_functional_template__$B = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$B,
  staticRenderFns: __vue_staticRenderFns__$B
}, __vue_inject_styles__$B, __vue_script__$B, __vue_scope_id__$B, __vue_is_functional_template__$B, __vue_module_identifier__$B, false, createInjector, undefined, undefined);

var script$A = {
  name: 'MoneyInput',
  components: {
    TextInput: __vue_component__$1L
  },
  props: {
    tabindex: Number,
    classField: String,
    placeholder: String,
    value: Number
  },

  data() {
    return {
      text: ''
    };
  },

  watch: {
    value: {
      handler(v) {
        this.text = v && v.toString();
      },

      immediate: true
    }
  },
  methods: {
    toMoney: toMoney$1,

    filter(n) {
      if (n === null || n === undefined) return n;
      let txt = n.replace(/[^0-9 | ^, | ^. | ^\s]/gi, "");
      txt = txt.replace(".", ",");
      let txtArray = txt.split(",");

      if (txtArray.length > 1) {
        let end = txtArray[txtArray.length - 1];
        txtArray[txtArray.length - 1] = "";
        txt = txtArray.join("");

        if (end && end.length > 2) {
          end = end.replace(/\s/gi, "");

          if (end.length > 2) {
            end = end.substring(0, 2);
          }
        }

        txt = txt + "," + end;
      }

      return txt;
    },

    handleChange(v, e) {
      this.text = v;
      let number = null;

      if (!v) {
        this.$emit("input", null, e);
      } else {
        let sNumber = v.replace(/\s/gi, "").replace(",", ".");
        number = parseFloat(sNumber);
        this.$emit("input", number, e);
      }

      setTimeout(() => this.$emit("change", v, e), 100);
    }

  }
};

/* script */
const __vue_script__$A = script$A;
/* template */

var __vue_render__$A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.$style.box
  }, [_c('TextInput', {
    class: _vm.$style.input,
    attrs: {
      "tabindex": _vm.tabindex,
      "inputClass": _vm.classField,
      "maxlength": 20,
      "placeholder": _vm.placeholder,
      "filter": _vm.filter,
      "format": _vm.toMoney
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: _vm.text,
      callback: function ($$v) {
        _vm.text = $$v;
      },
      expression: "text"
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.$style.rub
  }, [_vm._v("₽")])], 1);
};

var __vue_staticRenderFns__$A = [];
/* style */

const __vue_inject_styles__$A = function (inject) {
  if (!inject) return;
  inject("data-v-f75efd86_0", {
    source: ".src-components-box-2f_u{position:relative}.src-components-input-7WTR{box-sizing:border-box;width:100%;border-radius:4px!important;border:1px solid #6e7c8d;height:32px;padding:0 20px 0 6px;font-size:16px;line-height:24px;text-align:right}.src-components-input-7WTR:focus{border:1.5px solid #6e7c8d;outline:0}.src-components-rub-2Rk-{position:absolute;top:2px;right:6px;font-size:16px;line-height:24px}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-box-2f_u",
      "input": "src-components-input-7WTR",
      "rub": "src-components-rub-2Rk-"
    }
  });
};
/* scoped */


const __vue_scope_id__$A = undefined;
/* module identifier */

const __vue_module_identifier__$A = undefined;
/* functional template */

const __vue_is_functional_template__$A = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$A,
  staticRenderFns: __vue_staticRenderFns__$A
}, __vue_inject_styles__$A, __vue_script__$A, __vue_scope_id__$A, __vue_is_functional_template__$A, __vue_module_identifier__$A, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$z = {
  name: "IconSettings",
  inject: {
    team: {
      default: () => ({
        nm: "default",
        stl: {}
      })
    }
  }
};

/* script */
const __vue_script__$z = script$z;
/* template */

var __vue_render__$z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "width": "12",
      "height": "11",
      "viewBox": "0 0 12 11",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('line', {
    attrs: {
      "y1": "1.5",
      "x2": "12",
      "y2": "1.5",
      "stroke": _vm.team === 'dark' ? '#FFF' : 'black'
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "y1": "5.5",
      "x2": "12",
      "y2": "5.5",
      "stroke": _vm.team === 'dark' ? '#FFF' : 'black'
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "y1": "9.5",
      "x2": "12",
      "y2": "9.5",
      "stroke": _vm.team === 'dark' ? '#FFF' : 'black'
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "1.5",
      "cy": "1.5",
      "r": "1.5",
      "fill": _vm.team === 'dark' ? '#FFF' : '#202020'
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "6.5",
      "cy": "5.5",
      "r": "1.5",
      "fill": _vm.team === 'dark' ? '#FFF' : '#202020'
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "3.5",
      "cy": "9.5",
      "r": "1.5",
      "fill": _vm.team === 'dark' ? '#FFF' : '#202020'
    }
  })]);
};

var __vue_staticRenderFns__$z = [];
/* style */

const __vue_inject_styles__$z = undefined;
/* scoped */

const __vue_scope_id__$z = "data-v-06ef4174";
/* module identifier */

const __vue_module_identifier__$z = undefined;
/* functional template */

const __vue_is_functional_template__$z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$z,
  staticRenderFns: __vue_staticRenderFns__$z
}, __vue_inject_styles__$z, __vue_script__$z, __vue_scope_id__$z, __vue_is_functional_template__$z, __vue_module_identifier__$z, false, undefined, undefined, undefined);

var script$y = {
  name: "DropDown",
  props: {
    mobile: {
      type: Boolean,
      default: false
    },
    overflow: {
      type: Boolean,
      default: false
    },
    dropDownAboveBackground: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      open: false
    };
  },

  computed: {
    top() {
      let overflow = this.overflow;

      if (overflow) {
        let refAlignBy = this.$refs.alignBy;

        if (refAlignBy) {
          let rectAlignBy = refAlignBy && refAlignBy.getBoundingClientRect();
          const {
            height
          } = rectAlignBy;
          return `-${height}px`;
        }
      }

      return null;
    }

  },

  mounted() {
    document.addEventListener('click', this.closeIfOutClick);
    document.addEventListener('keyup', this.handlerGlobalOnKeyUp);
  },

  methods: {
    closeIfOutClick(e) {
      if (!this.open) return;
      let refAlign = this.$refs.align;
      let refAlignBy = this.$refs.alignBy;
      let rectAlign = refAlign && refAlign.getBoundingClientRect();
      let rectAlignBy = refAlignBy && refAlignBy.getBoundingClientRect();
      const {
        clientX,
        clientY
      } = e;

      const out = (rect, x, y) => {
        if (!rect) return false;
        const {
          top,
          right,
          bottom,
          left
        } = rect;

        if (hasValue$1(top) && hasValue$1(right) && hasValue$1(bottom) && hasValue$1(left)) {
          const delta = 3;

          if (top - delta > y || bottom + delta < y || x < left - delta || x > right + delta) {
            return true;
          }
        }

        return false;
      };

      let outAlign = out(rectAlign, clientX, clientY);
      let outAlignBy = out(rectAlignBy, clientX, clientY);

      if (outAlign && outAlignBy) {
        this.close();
      }
    },

    handlerOnOpenChange() {
      let open = !this.open;
      this.open = open;

      if (open) {
        this.$emit('open');
      } else {
        this.$emit('close');
      }
    },

    show() {
      if (this.open === true) return;
      this.open = true;
      this.$emit('open');
    },

    close() {
      if (this.open === false) return;
      this.open = false;
      this.$emit('close');
    },

    handlerOnKeyUp(e) {
      e.stopPropagation();
    },

    handlerGlobalOnKeyUp(e) {
      let {
        open
      } = this.$data;

      if (open) {
        if (e.code === "Tab") {
          this.close();
        } else if (e.code === "Escape") {
          this.close();
        }
      }
    }

  }
};

/* script */
const __vue_script__$y = script$y;
/* template */

var __vue_render__$y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    ref: "alignBy",
    staticClass: "DropDown"
  }, [_c('div', {
    style: {
      visibility: _vm.overflow && _vm.open && _vm.dropDownAboveBackground ? 'hidden' : null,
      height: _vm.dropDownAboveBackground ? '100%' : _vm.auto
    },
    on: {
      "click": _vm.handlerOnOpenChange
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    class: _vm.$style.dropdownBox,
    style: {
      position: 'relative',
      top: _vm.dropDownAboveBackground ? _vm.top : _vm.auto
    }
  }, [_vm.open ? _c('div', {
    ref: "align",
    class: [(_vm.overflow || !_vm.mobile) && _vm.$style.dropdown],
    style: {
      position: _vm.dropDownAboveBackground ? 'absolute' : 'relative'
    },
    on: {
      "keyup": function (e) {
        _vm.handlerOnKeyUp(e);
      }
    }
  }, [_vm._t("dropdown")], 2) : _vm._e()])]);
};

var __vue_staticRenderFns__$y = [];
/* style */

const __vue_inject_styles__$y = function (inject) {
  if (!inject) return;
  inject("data-v-37de4fc6_0", {
    source: ".src-components-dropdownBox-3Eug{position:relative}.src-components-dropdown-39ZM{top:0;left:0;right:0;box-sizing:border-box;z-index:9}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "dropdownBox": "src-components-dropdownBox-3Eug",
      "dropdown": "src-components-dropdown-39ZM"
    }
  });
};
/* scoped */


const __vue_scope_id__$y = undefined;
/* module identifier */

const __vue_module_identifier__$y = undefined;
/* functional template */

const __vue_is_functional_template__$y = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$y,
  staticRenderFns: __vue_staticRenderFns__$y
}, __vue_inject_styles__$y, __vue_script__$y, __vue_scope_id__$y, __vue_is_functional_template__$y, __vue_module_identifier__$y, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$x = {
  name: "IconTagClose"
};

/* script */
const __vue_script__$x = script$x;
/* template */

var __vue_render__$x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "width": "10",
      "height": "10",
      "viewBox": "0 0 10 10",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1 8.74939L9 0.749914",
      "stroke": "#6E7C8D",
      "stroke-opacity": "0.75",
      "stroke-width": "0.75",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1 0.75061L9 8.75009",
      "stroke": "#6E7C8D",
      "stroke-opacity": "0.75",
      "stroke-width": "0.75",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};

var __vue_staticRenderFns__$x = [];
/* style */

const __vue_inject_styles__$x = undefined;
/* scoped */

const __vue_scope_id__$x = "data-v-6a0e18cd";
/* module identifier */

const __vue_module_identifier__$x = undefined;
/* functional template */

const __vue_is_functional_template__$x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$x,
  staticRenderFns: __vue_staticRenderFns__$x
}, __vue_inject_styles__$x, __vue_script__$x, __vue_scope_id__$x, __vue_is_functional_template__$x, __vue_module_identifier__$x, false, undefined, undefined, undefined);

//
const TEXT_OVERFLOW_ENDING$1 = "...";
var script$w = {
  name: "TextTagsItem",
  components: {
    IconTagClose: __vue_component__$x,
    Tooltip: __vue_component__$1N
  },
  props: {
    value: String,
    maxTextLength: {
      type: Number,
      default: 26
    },
    onClose: {
      type: Function,
      default: () => {}
    },
    isPolza: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      polzaStyle: polzaStyle$1
    };
  },

  computed: {
    maxtxt() {
      if (!this.maxTextLength || this.maxTextLength < 0) return null;
      return this.maxTextLength - TEXT_OVERFLOW_ENDING$1.length;
    },

    text() {
      let {
        value,
        maxtxt
      } = this;
      if (maxtxt && value && value.length > maxtxt) return value.substring(0, maxtxt) + TEXT_OVERFLOW_ENDING$1;
      return value;
    },

    tooltipText() {
      return this.value && this.value.length > this.maxtxt ? this.value : "";
    }

  },
  methods: {
    handlerOnClose(e) {
      this.$emit("close", e);
      if (this.onClose) this.onClose(e);
    },

    getClass(className) {
      return this.isPolza && this.polzaStyle[className] || this.$style[className];
    }

  }
};

/* script */
const __vue_script__$w = script$w;
/* template */

var __vue_render__$w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.getClass('box2')
  }, [_c('Tooltip', {
    class: _vm.$style.text,
    attrs: {
      "text": _vm.tooltipText
    }
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.close,
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.handlerOnClose($event);
      }
    }
  }, [_c('IconTagClose')], 1)], 1);
};

var __vue_staticRenderFns__$w = [];
/* style */

const __vue_inject_styles__$w = function (inject) {
  if (!inject) return;
  inject("data-v-30b7ad90_0", {
    source: ".src-components-text-2Zlx{white-space:nowrap}.src-components-box2-1fUn{user-select:none;padding:1px 3px 1px 4px;border-radius:4px 4px 20px 4px!important;border:1px solid rgba(41,47,54,.4);background:#f0f2f3;color:#202020;text-decoration:none;text-align:left;display:flex;justify-content:center;align-items:center;font-size:13px;line-height:13px;min-height:20px;box-sizing:border-box}.src-components-box2-1fUn .src-components-close-139w{margin:2px 4px 0 5px;cursor:pointer;border-radius:100%!important;min-width:10px}.src-components-box2-1fUn .src-components-close-139w:hover{background-color:rgba(110,124,141,.1)}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "text": "src-components-text-2Zlx",
      "box2": "src-components-box2-1fUn",
      "close": "src-components-close-139w"
    }
  });
};
/* scoped */


const __vue_scope_id__$w = undefined;
/* module identifier */

const __vue_module_identifier__$w = undefined;
/* functional template */

const __vue_is_functional_template__$w = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$w,
  staticRenderFns: __vue_staticRenderFns__$w
}, __vue_inject_styles__$w, __vue_script__$w, __vue_scope_id__$w, __vue_is_functional_template__$w, __vue_module_identifier__$w, false, createInjector, undefined, undefined);

var script$v = {
  name: "KeywordsTags",
  components: {
    TextTagsItem: __vue_component__$w,
    LabelInfo: __vue_component__$1M,
    DropDown: __vue_component__$y,
    TextEditor: __vue_component__$1K,
    ThemeWhite: __vue_component__$N
  },
  props: {
    mobile: Boolean,
    classDropdown: String,
    classField: String,
    classTag: String,
    name: String,
    description: String,
    placeholder: String,
    placeholderEditor: String,
    value: Array,
    onChange: Function,
    tabindex: Number,
    isPolza: Boolean
  },

  data() {
    return {
      mouseInList: false,
      listOpen: true,
      inputRef: null,
      editTag: null,
      changeValue: false,
      text: "",
      open: false,
      searchType: "EXACT_MATCH",
      wordSpacing: null,
      searchTypes: {
        all: "ALL",
        exactMatch: "EXACT_MATCH",
        wordSpacing: "WORD_SPACING"
      },
      polzaStyle: polzaStyle$1
    };
  },

  computed: {
    showSearchTypes() {
      if (this.text && this.text.match(/.\s./)) return true;
      return false;
    },

    searchTypeValue: {
      get() {
        let searchType = this.searchType;
        let wordSpacing = this.wordSpacing;
        if (searchType == null) searchType = this.searchTypes.all;
        if (searchType !== this.searchTypes.wordSpacing) wordSpacing = null;
        return JSON.stringify({
          searchType,
          wordSpacing
        });
      },

      set(v) {
        let ov = JSON.parse(v);
        this.searchType = ov.searchType;
        this.wordSpacing = ov.wordSpacing;
      }

    },

    wordSpacingElements() {
      return [{
        key: JSON.stringify({
          searchType: this.searchTypes.exactMatch,
          wordSpacing: null
        }),
        value: "точное соответствие с соблюдением порядка слов"
      }, {
        key: JSON.stringify({
          searchType: this.searchTypes.wordSpacing,
          wordSpacing: 1
        }),
        value: "не более 1 слова между ключевыми словами"
      }, {
        key: JSON.stringify({
          searchType: this.searchTypes.wordSpacing,
          wordSpacing: 2
        }),
        value: "не более 2 слов между ключевыми словами"
      }, {
        key: JSON.stringify({
          searchType: this.searchTypes.wordSpacing,
          wordSpacing: 3
        }),
        value: "не более 3 слов между ключевыми словами"
      }, {
        key: JSON.stringify({
          searchType: this.searchTypes.all,
          wordSpacing: null
        }),
        value: "расстояние между ключевыми словами не важно"
      }];
    },

    displayValue() {
      if (!this.value) return this.value;else if (!this.editTag) return this.value;else return this.value.filter(a => a !== this.editTag);
    },

    dropDownOverflow() {
      return this.open && (!this.displayValue || this.displayValue.length <= 0);
    }

  },
  methods: {
    dropDownAboveBackgroundCalc() {
      if (process.browser) {
        return window.innerWidth > 900;
      }
    },

    handlerOnBlur() {
      if (this.mouseInList) return;
      this.change(this.text);
    },

    handlerMouseLeave() {
      if (this.mouseInList !== false) this.mouseInList = false;
    },

    handlerOnMouseMove() {
      if (this.mouseInList !== true) this.mouseInList = true;
    },

    handlerListItemClick(item) {
      if (this.listOpen) {
        this.changeValue = true;
        this.searchTypeValue = item.key;
      }

      this.$refs.searchInput.focus(); //this.listOpen = !this.listOpen;
    },

    handlerEditorOnEnter() {
      if (!this.text) {
        this.$refs.dropdown.close();
        this.$emit("search");
      } else {
        this.change(this.text);
      }
    },

    handlerDropDownOpen() {
      this.open = true;
    },

    handlerDropDownClose() {
      if (this.text && (this.text !== this.editTag || this.changeValue)) {
        this.change(this.text);
      }

      this.open = false;
      this.editTag = null;
      this.text = null;
      this.searchType = this.searchTypes.exactMatch;
    },

    inputFocus(r) {
      if (r) this.inputRef = r;else r = this.inputRef;
      if (!r) return;
      r.focus();
    },

    edit(tag) {
      if (!this.value || this.value.length <= 0) return;

      if (tag && tag.match(/^["'].*["']$/g)) {
        this.searchType = this.searchTypes.exactMatch;
      } else if (tag && (tag[0] === '"' || tag[0] === "'") && tag.match(/~\d*$/g)) {
        this.searchType = this.searchTypes.wordSpacing;
      } else {
        this.searchType = this.searchTypes.all;
      }

      let matchs = tag && tag.match(/~\s*\d*\s*$/) || null;
      this.wordSpacing = matchs ? parseInt(matchs[0].replace("~", "").replace(/\s*/, "") || "2") : null;
      let txt = tag;
      if (txt.match(/^["'].*["']\s*(~\s*\d*)?$/g)) txt = txt.match(/^["'](.*)["']/)[1];
      txt = txt.replace(/["']/g, "");
      this.text = txt;
      this.editTag = tag;
      this.$refs.dropdown.show();
      this.inputFocus();
    },

    change(text) {
      this.changeValue = false;
      if (!text) return;
      let tag = text.trim();
      if (!tag) return;
      let txt = tag;
      if (txt.match(/^["'].*["']\s*(~\s*\d*)?$/g)) txt = txt.match(/^["'](.*)["']/)[1];
      txt = txt.replace(/["']/g, "");

      if (this.searchType == null) {
        this.searchType = this.searchTypes.exactMatch;
      }

      if (this.wordSpacing > 0 && this.searchType === this.searchTypes.all) {
        this.searchType = this.searchTypes.wordSpacing;
      }

      if (!(this.wordSpacing > 0) && this.searchType === this.searchTypes.wordSpacing) {
        this.searchType = this.searchTypes.all;
        this.wordSpacing = null;
      } // если в ключевом слове меньше 2-х слов
      // то не учитываем выбранный тип запроса


      if (!txt.match(/.\s./)) {
        tag = txt;
      } else if (this.searchType === this.searchTypes.exactMatch) {
        tag = `"${tag.replace(/~\s*\d*$/g, "").replace(/"/g, "").trim()}"`;
      } else if (this.searchType === this.searchTypes.wordSpacing) {
        if (tag.includes('"') || tag.includes("'")) {
          let matchs = tag.match(/["'].*["']/g);
          if (matchs && matchs.length > 0) tag = matchs[0];
        }

        let matchs = text.match(/~\s*\d*$/g);
        let wordSpacing = matchs ? parseInt(matchs[0].replace("~", "").replace(/\s*/g, "") || "2") : this.wordSpacing;
        tag = `'${tag.replace(/["']/g, "")}' ~${wordSpacing}`;
      } else {
        let mtchs = tag.match(/^["'].*["']\s*(~\s*\d*)?$/g);
        if (mtchs) tag = tag.match(/^["'](.*)["']/)[1];
        tag = tag.replace(/["']/g, "");
      }

      let tags = this.value && this.value.filter(a => a !== tag) || [];
      let editTag = this.editTag;

      if (editTag) {
        tags = this.value.filter(a => a !== editTag);
        this.editTag = null;
      }

      tags.push(tag);
      this.text = "";
      this.onChange && this.onChange(tags);
      this.$emit("input", tags);
      return tag;
    },

    remove(tag) {
      if (!this.value || this.value.length <= 0) return;
      let tags = this.value.filter(a => a !== tag);
      this.onChange && this.onChange(tags);
      this.$emit("input", tags);
    },

    getClass(className) {
      return this.isPolza && this.polzaStyle[className] || this.$style[className];
    }

  }
};

/* script */
const __vue_script__$v = script$v;
/* template */

var __vue_render__$v = function () {
  var _obj;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "KeywordsTags",
    class: _vm.$style.box
  }, [_vm.description || _vm.name ? _c('LabelInfo', {
    class: _vm.$style.labelInfo,
    attrs: {
      "description": _vm.description
    }
  }, [_vm._v("\n    " + _vm._s(_vm.name) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('DropDown', {
    ref: "dropdown",
    class: _vm.$style.dropBox,
    attrs: {
      "overflow": _vm.dropDownOverflow,
      "mobile": _vm.mobile,
      "dropDownAboveBackground": _vm.dropDownAboveBackgroundCalc()
    },
    on: {
      "open": _vm.handlerDropDownOpen,
      "close": _vm.handlerDropDownClose
    },
    scopedSlots: _vm._u([{
      key: "dropdown",
      fn: function () {
        var _obj;

        return [_c('ThemeWhite', {
          class: [_vm.getClass('keyword-items'), (_obj = {}, _obj[_vm.getClass('keyword-itemsNoOverflow')] = !_vm.dropDownOverflow, _obj), _vm.classDropdown],
          nativeOn: {
            "click": function ($event) {
              $event.stopPropagation();
              return function () {}();
            }
          }
        }, [_c('TextEditor', {
          ref: "searchInput",
          class: _vm.$style.searchInput,
          attrs: {
            "placeholder": _vm.placeholderEditor,
            "input-ref": _vm.inputFocus,
            "isPolza": _vm.isPolza
          },
          on: {
            "input": function ($event) {
              _vm.changeValue = true;
            },
            "blur": _vm.handlerOnBlur,
            "keyup": function ($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
                return null;
              }

              return _vm.handlerEditorOnEnter($event);
            }
          },
          model: {
            value: _vm.text,
            callback: function ($$v) {
              _vm.text = $$v;
            },
            expression: "text"
          }
        }), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.showSearchTypes,
            expression: "showSearchTypes"
          }],
          staticStyle: {
            "margin": "0 5px 5px"
          },
          on: {
            "mousemove": _vm.handlerOnMouseMove,
            "mouseleave": _vm.handlerMouseLeave
          }
        }, [_vm.listOpen ? _c('div', {
          staticStyle: {
            "color": "#909090"
          }
        }, [_vm._v("\n            Расскажите, как нам искать\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
          class: _vm.$style.list,
          style: {
            border: !_vm.listOpen ? '0px solid white' : null
          }
        }, _vm._l(_vm.wordSpacingElements.filter(function (a) {
          return _vm.listOpen || a.key === _vm.searchTypeValue;
        }), function (item) {
          var _obj;

          return _c('div', {
            key: item.key,
            class: (_obj = {}, _obj[_vm.$style.listItem] = true, _obj[_vm.$style.listItemHover] = _vm.listOpen, _obj),
            style: {
              backgroundColor: _vm.listOpen && item.key === _vm.searchTypeValue ? '#c4c4c4' : null,
              color: _vm.listOpen ? '#202020' : '#909090'
            },
            on: {
              "click": function ($event) {
                return _vm.handlerListItemClick(item);
              }
            }
          }, [_vm._v("\n              " + _vm._s(item.value) + "\n            ")]);
        }), 0)])], 1)];
      },
      proxy: true
    }])
  }, [[_c('div', {
    class: _vm.$style.input
  }, [_c('div', {
    class: [_vm.$style.tagBox, (_obj = {}, _obj[_vm.$style.tagBoxNoOverflow] = !_vm.dropDownOverflow && _vm.open, _obj), _vm.classField],
    attrs: {
      "tabindex": _vm.tabindex
    }
  }, [!_vm.value || _vm.value.length <= 0 ? _c('div', {
    class: _vm.$style.placeholderBox
  }, [_c('div', [_vm._v(_vm._s(_vm.placeholder))])]) : _vm._e(), _vm._v(" "), _vm._l(_vm.displayValue, function (key, index) {
    return _c('TextTagsItem', {
      key: index,
      class: [_vm.$style.tag, _vm.classTag],
      attrs: {
        "value": key,
        "isPolza": _vm.isPolza
      },
      on: {
        "close": function ($event) {
          return _vm.remove(key);
        }
      },
      nativeOn: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.edit(key);
        }
      }
    });
  })], 2)])]], 2)], 1);
};

var __vue_staticRenderFns__$v = [];
/* style */

const __vue_inject_styles__$v = function (inject) {
  if (!inject) return;
  inject("data-v-4dcf810c_0", {
    source: ".src-components-box-tO_u{box-sizing:border-box;display:flex;flex-direction:column}.src-components-itemsBox-2JL8{position:relative}.src-components-keyword-items-yLjd{padding-top:5px;background-color:#fff;border:.75px solid #6e7c8d;border-radius:4px 4px 8px 8px!important}.src-components-tagBox-22jR{background-color:#fff;display:flex;align-items:center;flex-wrap:wrap;box-sizing:border-box;border-radius:4px!important;border:.75px solid #6e7c8d;padding-left:7px;padding-right:14px;min-height:32px;height:100%}.src-components-tagBox-22jR:focus{border:2px solid #6e7c8d;outline:0;padding-left:5.75px}.src-components-tag-31JO{margin-top:3px;margin-bottom:3px;margin-right:6px;height:20px}.src-components-input-8I_8{position:relative;height:100%;box-sizing:border-box}.src-components-iconBox-oS52{position:absolute;right:6px;top:13px;display:flex;align-items:center;justify-content:center}.src-components-name-36lE{font-size:16px;line-height:17px;padding-left:4px;padding-top:4px;padding-bottom:4px}.src-components-nameText-2W_4:hover{background:rgba(110,124,141,.5);color:#fff}.src-components-searchBox-2bXm{margin:5px 5px 0;position:relative}.src-components-searchBox-2bXm .src-components-searchIcon-3JfA{left:10px;top:6px;position:absolute;z-index:1}.src-components-tree-2bnI{margin:5px 5px 5px 5px;max-height:350px;overflow:auto}.src-components-tree-2bnI::-webkit-scrollbar{width:7px}.src-components-tree-2bnI::-webkit-scrollbar-track{background:rgba(0,0,0,0)}.src-components-tree-2bnI::-webkit-scrollbar-thumb{background:#c4c4c4;border:0 solid transparent;border-radius:10px!important}.src-components-searchInput-1_nc{margin:0 5px 5px}.src-components-tagBoxNoOverflow-2sm2{border-bottom:none;box-sizing:border-box;border-radius:4px 4px 0 0!important}.src-components-keyword-itemsNoOverflow-1Tkr{border-top:0;box-sizing:border-box;border-radius:0 0 8px 8px!important}.src-components-placeholderBox-2d4W{font-size:16px;color:#6e7c8d;display:flex;align-items:center}.src-components-dropBox-3EBi{flex-grow:1}.src-components-list-1f0S{border:1px solid #9d9d9d;border-radius:4px!important;padding:4px 0 4px;cursor:pointer;margin-bottom:5px}.src-components-list-1f0S .src-components-listItem-3E6E{padding:0 4px 0;cursor:pointer}.src-components-list-1f0S .src-components-listItemHover-38-0:hover{background-color:#f0f2f4}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-box-tO_u",
      "itemsBox": "src-components-itemsBox-2JL8",
      "keyword-items": "src-components-keyword-items-yLjd",
      "tagBox": "src-components-tagBox-22jR",
      "tag": "src-components-tag-31JO",
      "input": "src-components-input-8I_8",
      "iconBox": "src-components-iconBox-oS52",
      "name": "src-components-name-36lE",
      "nameText": "src-components-nameText-2W_4",
      "searchBox": "src-components-searchBox-2bXm",
      "searchIcon": "src-components-searchIcon-3JfA",
      "tree": "src-components-tree-2bnI",
      "searchInput": "src-components-searchInput-1_nc",
      "tagBoxNoOverflow": "src-components-tagBoxNoOverflow-2sm2",
      "keyword-itemsNoOverflow": "src-components-keyword-itemsNoOverflow-1Tkr",
      "placeholderBox": "src-components-placeholderBox-2d4W",
      "dropBox": "src-components-dropBox-3EBi",
      "list": "src-components-list-1f0S",
      "listItem": "src-components-listItem-3E6E",
      "listItemHover": "src-components-listItemHover-38-0"
    }
  });
};
/* scoped */


const __vue_scope_id__$v = undefined;
/* module identifier */

const __vue_module_identifier__$v = undefined;
/* functional template */

const __vue_is_functional_template__$v = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$v,
  staticRenderFns: __vue_staticRenderFns__$v
}, __vue_inject_styles__$v, __vue_script__$v, __vue_scope_id__$v, __vue_is_functional_template__$v, __vue_module_identifier__$v, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
var script$u = {
  name: "IconLoupe"
};

/* script */
const __vue_script__$u = script$u;
/* template */

var __vue_render__$u = function (_h, _vm) {
  var _c = _vm._c;
  return _c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "10",
      "cy": "10",
      "r": "8.5",
      "stroke": "white",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "21.0382",
      "y1": "21.9261",
      "x2": "16.361",
      "y2": "16.9112",
      "stroke": "white",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};

var __vue_staticRenderFns__$u = [];
/* style */

const __vue_inject_styles__$u = undefined;
/* scoped */

const __vue_scope_id__$u = "data-v-2ed905a0";
/* module identifier */

const __vue_module_identifier__$u = undefined;
/* functional template */

const __vue_is_functional_template__$u = true;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$u,
  staticRenderFns: __vue_staticRenderFns__$u
}, __vue_inject_styles__$u, __vue_script__$u, __vue_scope_id__$u, __vue_is_functional_template__$u, __vue_module_identifier__$u, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$t = {
  name: "IconSortDirection",
  props: {
    direction: String
  }
};

/* script */
const __vue_script__$t = script$t;
/* template */

var __vue_render__$t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', [_vm.direction == 'Desc' ? _c('svg', {
    class: _vm.$style.icon,
    attrs: {
      "viewBox": "0 0 8 11",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3.75533 10.3536C3.9506 10.5488 4.26718 10.5488 4.46244 10.3536L7.64442 7.17157C7.83968 6.97631 7.83968 6.65973 7.64442 6.46447C7.44916 6.2692 7.13258 6.2692 6.93731 6.46447L4.10889 9.29289L1.28046 6.46447C1.0852 6.2692 0.768615 6.2692 0.573353 6.46447C0.378091 6.65973 0.378091 6.97631 0.573353 7.17157L3.75533 10.3536ZM3.60889 0L3.60889 10H4.60889L4.60889 0L3.60889 0Z"
    }
  })]) : _vm.direction == 'Asc' ? _c('svg', {
    class: _vm.$style.icon,
    attrs: {
      "viewBox": "0 0 8 11",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4.46421 0.645981C4.26842 0.450997 3.95184 0.451447 3.7571 0.646986L0.583658 3.83348C0.38892 4.02902 0.389769 4.3456 0.585555 4.54058C0.781341 4.73557 1.09792 4.73512 1.29266 4.53958L4.1135 1.70714L6.94951 4.53154C7.1453 4.72652 7.46188 4.72607 7.65662 4.53053C7.85135 4.33499 7.8505 4.01841 7.65472 3.82343L4.46421 0.645981ZM4.63843 10.9993L4.6116 0.999325L3.6116 1.00075L3.63843 11.0007L4.63843 10.9993Z"
    }
  })]) : _c('span', {
    class: _vm.$style.spacer
  })]);
};

var __vue_staticRenderFns__$t = [];
/* style */

const __vue_inject_styles__$t = function (inject) {
  if (!inject) return;
  inject("data-v-649663aa_0", {
    source: ".src-components-icon-3BLB{width:8px;height:11px}.src-components-spacer-1Tu8{display:inline-block;width:8px;height:11px}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "icon": "src-components-icon-3BLB",
      "spacer": "src-components-spacer-1Tu8"
    }
  });
};
/* scoped */


const __vue_scope_id__$t = undefined;
/* module identifier */

const __vue_module_identifier__$t = undefined;
/* functional template */

const __vue_is_functional_template__$t = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$t,
  staticRenderFns: __vue_staticRenderFns__$t
}, __vue_inject_styles__$t, __vue_script__$t, __vue_scope_id__$t, __vue_is_functional_template__$t, __vue_module_identifier__$t, false, createInjector, undefined, undefined);

var script$s = {
  name: "OrderType",
  components: {
    FilterTag: __vue_component__$11,
    IconSortDirection: __vue_component__$t,
    DropDownList: __vue_component__$C
  },
  props: {
    items: Array,
    value: Object,
    isPolza: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sortItems() {
      return this.items;
    },

    sortValue() {
      return this.value;
    }

  }
};

/* script */
const __vue_script__$s = script$s;
/* template */

var __vue_render__$s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.sortItems && _vm.sortItems.length > 0 ? _c('DropDownList', {
    class: _vm.$style.sort,
    attrs: {
      "items": _vm.sortItems,
      "value": _vm.sortValue,
      "isPolza": _vm.isPolza
    },
    on: {
      "input": function (x) {
        return _vm.$emit('sort', x);
      }
    },
    scopedSlots: _vm._u([{
      key: "selectedItem",
      fn: function (ref) {
        var item = ref.item;
        return [_c('IconSortDirection', {
          class: _vm.$style.sortItemIcon,
          attrs: {
            "direction": item && item.direction
          }
        }), _vm._v(" "), _c('span', {
          class: _vm.$style.selectedSortItemText
        }, [_vm._v(_vm._s(item && item.text || ""))])];
      }
    }, {
      key: "item",
      fn: function (ref) {
        var item = ref.item;
        return [_c('IconSortDirection', {
          class: _vm.$style.sortItemIcon,
          attrs: {
            "direction": item && item.direction
          }
        }), _vm._v(" "), _c('span', {
          class: _vm.$style.sortItemText
        }, [_vm._v(_vm._s(item && item.text || ""))])];
      }
    }], null, false, 2324994697)
  }) : _vm._e();
};

var __vue_staticRenderFns__$s = [];
/* style */

const __vue_inject_styles__$s = function (inject) {
  if (!inject) return;
  inject("data-v-d2224318_0", {
    source: ".src-components-box-10B1{color:#000}.src-components-tagsAndSort-2J7b{display:flex;align-items:baseline;flex-wrap:wrap}.src-components-tag-13YT{margin-right:3px;margin-top:17px;color:#6e7c8d!important;background-color:rgba(0,0,0,0);border:1px solid #6e7c8d!important;cursor:pointer}.src-components-sort-2tkz{background-color:#fff;border-radius:4px!important;margin-top:0;min-width:304px}.src-components-sortItemIcon-1BwX{padding-right:4px;fill:#000}.src-components-selectedSortItemText-1V90{font-size:16px;line-height:16px}.src-components-sortItemText-1SXk{font-size:14px;line-height:19px}.src-components-title-3rWn{font-size:16px;line-height:26px;color:#202020}.src-components-item-3wsw{margin:32px 0}.src-components-label300-2xqs{font-size:16px;color:#6e7c8d;line-height:26px}.src-components-paper-3yYY{margin:24px 0 24px;padding:16px 16px 16px 24px}.src-components-paper-3yYY .src-components-paperTitle-3pNe{font-size:32px;line-height:40px;color:#202020}.src-components-paperFilter-2umr{margin:24px 0 24px;padding:16px 22px 16px 24px;display:flex;justify-content:space-between;align-items:center}.src-components-paperFilter-2umr .src-components-paperFilterText-2p2P{font-size:16px;line-height:24px;color:#202020}.src-components-lotName-2O0E em{background-color:#fff240;font-style:normal}.src-components-regionName-1zMU{font-size:16px;line-height:24px;color:rgba(0,0,0,.5);font-weight:400;font-style:normal;padding-left:20px}.src-components-regionName-1zMU em{background-color:#fff240;font-style:normal}.src-components-lotNameTitle-SUlv{font-size:24px!important;line-height:30px!important}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-box-10B1",
      "tagsAndSort": "src-components-tagsAndSort-2J7b",
      "tag": "src-components-tag-13YT",
      "sort": "src-components-sort-2tkz",
      "sortItemIcon": "src-components-sortItemIcon-1BwX",
      "selectedSortItemText": "src-components-selectedSortItemText-1V90",
      "sortItemText": "src-components-sortItemText-1SXk",
      "title": "src-components-title-3rWn",
      "item": "src-components-item-3wsw",
      "label300": "src-components-label300-2xqs",
      "paper": "src-components-paper-3yYY",
      "paperTitle": "src-components-paperTitle-3pNe",
      "paperFilter": "src-components-paperFilter-2umr",
      "paperFilterText": "src-components-paperFilterText-2p2P",
      "paperFilterButtonBox": "src-components-paperFilterButtonBox-kNz9",
      "lotName": "src-components-lotName-2O0E",
      "regionName": "src-components-regionName-1zMU",
      "lotNameTitle": "src-components-lotNameTitle-SUlv"
    }
  });
};
/* scoped */


const __vue_scope_id__$s = undefined;
/* module identifier */

const __vue_module_identifier__$s = undefined;
/* functional template */

const __vue_is_functional_template__$s = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$s,
  staticRenderFns: __vue_staticRenderFns__$s
}, __vue_inject_styles__$s, __vue_script__$s, __vue_scope_id__$s, __vue_is_functional_template__$s, __vue_module_identifier__$s, false, createInjector, undefined, undefined);

//
const TEXT_OVERFLOW_ENDING = "...";
var script$r = {
  name: "TextTagsItem",
  components: {
    IconTagClose: __vue_component__$x,
    Tooltip: __vue_component__$1N
  },
  props: {
    value: String,
    maxTextLength: {
      type: Number,
      default: 26
    },
    onClose: {
      type: Function,
      default: () => {}
    },
    isPolza: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      polzaStyle: polzaStyle$1
    };
  },

  computed: {
    maxtxt() {
      if (!this.maxTextLength || this.maxTextLength < 0) return null;
      return this.maxTextLength - TEXT_OVERFLOW_ENDING.length;
    },

    text() {
      let {
        value,
        maxtxt
      } = this;
      if (maxtxt && value && value.length > maxtxt) return value.substring(0, maxtxt) + TEXT_OVERFLOW_ENDING;
      return value;
    },

    tooltipText() {
      return this.value && this.value.length > this.maxtxt ? this.value : "";
    }

  },
  methods: {
    handlerOnClose(e) {
      this.$emit("close", e);
      if (this.onClose) this.onClose(e);
    },

    getClass(className) {
      return this.isPolza && this.polzaStyle[className] || this.$style[className];
    }

  }
};

/* script */
const __vue_script__$r = script$r;
/* template */

var __vue_render__$r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.getClass('item-box')
  }, [_c('Tooltip', {
    class: _vm.$style.text,
    attrs: {
      "text": _vm.tooltipText
    }
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.close,
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.handlerOnClose($event);
      }
    }
  }, [_c('IconTagClose')], 1)], 1);
};

var __vue_staticRenderFns__$r = [];
/* style */

const __vue_inject_styles__$r = function (inject) {
  if (!inject) return;
  inject("data-v-653b43d8_0", {
    source: ".src-components-text-1RkZ{white-space:nowrap}.src-components-item-box-3kYa{user-select:none;padding:1px 3px 1px 4px;border-radius:4px 4px 20px 4px!important;border:1px solid rgba(41,47,54,.4);background:#f0f2f3;color:#202020;text-decoration:none;text-align:left;display:flex;justify-content:center;align-items:center;font-size:13px;line-height:13px;min-height:20px;box-sizing:border-box}.src-components-item-box-3kYa .src-components-close-32zT{margin:2px 4px 0 5px;cursor:pointer;border-radius:100%!important;min-width:10px}.src-components-item-box-3kYa .src-components-close-32zT:hover{background-color:rgba(110,124,141,.1)}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "text": "src-components-text-1RkZ",
      "item-box": "src-components-item-box-3kYa",
      "close": "src-components-close-32zT"
    }
  });
};
/* scoped */


const __vue_scope_id__$r = undefined;
/* module identifier */

const __vue_module_identifier__$r = undefined;
/* functional template */

const __vue_is_functional_template__$r = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$r,
  staticRenderFns: __vue_staticRenderFns__$r
}, __vue_inject_styles__$r, __vue_script__$r, __vue_scope_id__$r, __vue_is_functional_template__$r, __vue_module_identifier__$r, false, createInjector, undefined, undefined);

var script$q = {
  name: "IconCheckBox",
  inject: {
    team: {
      default: () => "default"
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    isPolza: {
      type: Boolean,
      default: false
    }
  }
};

/* script */
const __vue_script__$q = script$q;
/* template */

var __vue_render__$q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.team === 'dark' && _vm.value && !_vm.isPolza ? _c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5.99902 10.9709L10.772 15.7439L18.7269 7.78896",
      "stroke": "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3ZM4 0C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0H4Z",
      "fill": "white"
    }
  })]) : _vm.team === 'dark' && !_vm.value && !_vm.isPolza ? _c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3ZM4 0C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0H4Z",
      "fill": "white"
    }
  })]) : _vm.team !== 'dark' && _vm.value && !_vm.isPolza ? _c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
      "fill": "#6E7C8D"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 6C3 4.34315 4.34315 3 6 3H18C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6Z",
      "fill": "#6E7C8D"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7 12.3137L10.6066 15.9203L16.9203 9.60661",
      "stroke": "white",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]) : _vm.team !== 'dark' && !_vm.value && !_vm.isPolza ? _c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M20 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3ZM4 0C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0H4Z",
      "fill": "#6E7C8D"
    }
  })]) : !_vm.value && _vm.isPolza ? _c('svg', {
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "x": "0.5",
      "y": "0.5",
      "width": "19",
      "height": "19",
      "stroke": "#34495E"
    }
  })]) : _vm.value && _vm.isPolza ? _c('svg', {
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "x": "0.5",
      "y": "0.5",
      "width": "19",
      "height": "19",
      "stroke": "#34495E"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5.5 9.48535L9.1066 12.61875L15.4203 7.13343",
      "stroke": "#61CFC5",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]) : _vm._e();
};

var __vue_staticRenderFns__$q = [];
/* style */

const __vue_inject_styles__$q = undefined;
/* scoped */

const __vue_scope_id__$q = undefined;
/* module identifier */

const __vue_module_identifier__$q = undefined;
/* functional template */

const __vue_is_functional_template__$q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$q,
  staticRenderFns: __vue_staticRenderFns__$q
}, __vue_inject_styles__$q, __vue_script__$q, __vue_scope_id__$q, __vue_is_functional_template__$q, __vue_module_identifier__$q, false, undefined, undefined, undefined);

var script$p = {
  name: "CheckBox",
  components: {
    LabelInfo: __vue_component__$1M,
    IconCheckBox: __vue_component__$q
  },
  inject: {
    team: {
      default: () => "default"
    }
  },
  props: {
    name: {
      type: String
    },
    description: {
      type: String
    },
    value: {
      type: Boolean,
      default: false
    },
    isPolza: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      polzaStyle: polzaStyle$1
    };
  },

  methods: {
    hasValue: hasValue$1,

    getClass(className) {
      return this.isPolza && this.polzaStyle[className] || this.$style[className];
    }

  }
};

/* script */
const __vue_script__$p = script$p;
/* template */

var __vue_render__$p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.$style.box
  }, [_c('div', {
    staticStyle: {
      "cursor": "pointer",
      "height": "24px"
    },
    on: {
      "click": function (a) {
        return _vm.$emit('input', !_vm.value);
      }
    }
  }, [_c('IconCheckBox', {
    attrs: {
      "value": _vm.value,
      "isPolza": _vm.isPolza
    }
  })], 1), _vm._v(" "), _c('LabelInfo', {
    attrs: {
      "description": _vm.description,
      "className": _vm.getClass('name')
    },
    on: {
      "clickName": function (a) {
        return _vm.$emit('input', !_vm.value);
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.name) + "\n  ")])], 1);
};

var __vue_staticRenderFns__$p = [];
/* style */

const __vue_inject_styles__$p = function (inject) {
  if (!inject) return;
  inject("data-v-04500e7e_0", {
    source: ".src-components-box-36Jp{display:flex;align-items:center}.src-components-box-36Jp>*+*{margin-left:10px}.src-components-box-36Jp .src-components-name-3dgT{user-select:none;cursor:pointer}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-box-36Jp",
      "name": "src-components-name-3dgT"
    }
  });
};
/* scoped */


const __vue_scope_id__$p = undefined;
/* module identifier */

const __vue_module_identifier__$p = undefined;
/* functional template */

const __vue_is_functional_template__$p = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$p,
  staticRenderFns: __vue_staticRenderFns__$p
}, __vue_inject_styles__$p, __vue_script__$p, __vue_scope_id__$p, __vue_is_functional_template__$p, __vue_module_identifier__$p, false, createInjector, undefined, undefined);

var script$o = {
  name: "CheckBoxGroup",
  components: {
    CheckBox: __vue_component__$p,
    LabelInfo: __vue_component__$1M
  },
  props: {
    name: String,
    description: String,
    value: [Object, Array],
    valueType: String,
    classCheckBox: String,
    classContentBox: String,
    validate: Function,
    elements: Array,
    externalError: String
  },

  data() {
    return {
      error: null
    };
  },

  computed: {
    valueIsArrayElements() {
      if (!this.valueIsArray) return null;
      let elmnts = this.elements.reduce((r, a) => {
        r[a.field] = true;
        return r;
      }, {});
      return elmnts;
    },

    valueIsArray() {
      let value = this.value;

      if (!value) {
        // если value отсутствует то создать value соответствующего типа
        if (this.valueType) return this.valueType.toLowerCase() === "array";else return false;
      } else {
        return Array.isArray(value);
      }
    }

  },
  methods: {
    getCheckBoxValue(field) {
      if (!this.value) return false;

      if (this.valueIsArray) {
        if (this.value.length <= 0) return false;
        return this.value.some(a => a == field);
      } else {
        return toBoolean(this.value[field]);
      }
    },

    validateValue(value) {
      if (!this.validate) return true;
      this.error = this.validate(value);
      return !this.error;
    },

    handlerInput(field, v) {
      this.error = null;
      let value = this.value;
      if (!value) value = this.valueIsArray ? [] : {};

      if (this.valueIsArray) {
        if (value.length > 0) value = value.filter(a => this.valueIsArrayElements[a]);
        if (!v) value = value.filter(a => a !== field);else value.push(field);
        if (!this.validateValue(value)) return;
        this.$emit("input", value);
      } else {
        if (!this.validateValue(value)) return;
        this.$emit("input", { ...value,
          [field]: v
        });
      }
    }

  }
};

/* script */
const __vue_script__$o = script$o;
/* template */

var __vue_render__$o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "CheckBoxGroup",
    on: {
      "mouseleave": function ($event) {
        _vm.error = null;
      }
    }
  }, [_c('LabelInfo', {
    attrs: {
      "description": _vm.description
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
    class: _vm.classContentBox
  }, _vm._l(_vm.elements, function (element, index) {
    return _c('CheckBox', {
      key: index,
      class: _vm.classCheckBox,
      attrs: {
        "name": element.label,
        "description": element.description,
        "value": _vm.getCheckBoxValue(element.field)
      },
      on: {
        "input": function (v) {
          return _vm.handlerInput(element.field, v);
        }
      }
    });
  }), 1), _vm._v(" "), _vm.error ? _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#EE2B45",
      "position": "absolute",
      "top": "2px",
      "font-size": "15px",
      "line-height": "15px"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.error) + "\n    ")])]) : _vm._e(), _vm._v(" "), _vm.externalError ? _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "externalErrorClass",
    domProps: {
      "innerHTML": _vm._s(_vm.externalError)
    }
  })]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$o = [];
/* style */

const __vue_inject_styles__$o = function (inject) {
  if (!inject) return;
  inject("data-v-e7f019c8_0", {
    source: ".externalErrorClass[data-v-e7f019c8]{color:#ee2b45;position:absolute;top:2px;font-size:14px;line-height:14px;font-weight:700}@media screen and (max-width:767px){.externalErrorClass[data-v-e7f019c8]{font-size:12px;line-height:12px}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$o = "data-v-e7f019c8";
/* module identifier */

const __vue_module_identifier__$o = undefined;
/* functional template */

const __vue_is_functional_template__$o = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$o,
  staticRenderFns: __vue_staticRenderFns__$o
}, __vue_inject_styles__$o, __vue_script__$o, __vue_scope_id__$o, __vue_is_functional_template__$o, __vue_module_identifier__$o, false, createInjector, undefined, undefined);

var script$n = {
  name: "SelectField",
  inject: {
    team: {
      default: () => "default"
    }
  },
  props: {
    name: String,
    description: String,
    value: null,
    fontSize: String,
    dict: Object,
    empty: {
      type: Boolean,
      default: true
    },
    emptyText: {
      type: String,
      default: "-"
    }
  },
  computed: {
    items() {
      const array = toArray(this.dict);
      return array;
    }

  },
  methods: {
    change(e) {
      this.$emit("input", e.target.value);
    }

  }
};

/* script */
const __vue_script__$n = script$n;
/* template */

var __vue_render__$n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('select', {
    staticClass: "SelectField",
    class: [_vm.$style.box, _vm.team == 'dark' && _vm.$style.select],
    on: {
      "change": _vm.change
    }
  }, [_vm.empty ? _c('option', {
    class: _vm.$style.elementNone,
    domProps: {
      "value": null
    }
  }, [_vm._v("\n    " + _vm._s(_vm.emptyText) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm._l(_vm.items, function (item) {
    return _c('option', {
      key: item.key,
      domProps: {
        "selected": item.key == _vm.value,
        "value": item.key
      }
    }, [_vm._v("\n    " + _vm._s(item.value) + "\n  ")]);
  })], 2);
};

var __vue_staticRenderFns__$n = [];
/* style */

const __vue_inject_styles__$n = function (inject) {
  if (!inject) return;
  inject("data-v-3b535cc2_0", {
    source: ".src-components-box-2Wvy{height:32px;border:.75px solid #6e7c8d;border-radius:4px!important;box-sizing:border-box;padding:0 0 0 6px;font-size:16px;font-family:\"IBM Plex Sans\",Avenir,Helvetica,Arial,sans-serif;font-display:swap;color:#000;background-color:#fff}.src-components-elementNone-1atL{color:#6e7c8d;font-style:italic}.src-components-select-21Uu{background-color:#000;color:#fff}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-box-2Wvy",
      "elementNone": "src-components-elementNone-1atL",
      "select": "src-components-select-21Uu"
    }
  });
};
/* scoped */


const __vue_scope_id__$n = undefined;
/* module identifier */

const __vue_module_identifier__$n = undefined;
/* functional template */

const __vue_is_functional_template__$n = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$n,
  staticRenderFns: __vue_staticRenderFns__$n
}, __vue_inject_styles__$n, __vue_script__$n, __vue_scope_id__$n, __vue_is_functional_template__$n, __vue_module_identifier__$n, false, createInjector, undefined, undefined);

var script$m = {
  name: "DatePickerRange",
  inject: {
    team: {
      default: () => ({
        nm: "default",
        stl: {}
      })
    }
  },
  components: {
    LabelInfo: __vue_component__$1M,
    Calendar: __vue_component__$1B
  },
  props: {
    minTabindex: Number,
    maxTabindex: Number,
    classField: String,
    name: String,
    value: {
      type: Object,

      default() {
        return {
          from: null,
          to: null
        };
      }

    }
  },
  methods: {
    handleInputFrom(valueFrom) {
      const value = { ...this.value,
        from: valueFrom
      };

      if (value.from && value.to && value.from.getTime() > value.to.getTime()) {
        value.to = new Date(value.from);
      }

      this.$emit("input", value);
    },

    handleInputTo(valueTo) {
      const value = { ...this.value,
        to: valueTo
      };

      if (value.from && value.to && value.from.getTime() > value.to.getTime()) {
        value.from = new Date(value.to);
      }

      this.$emit("input", value);
    }

  }
};

/* script */
const __vue_script__$m = script$m;
/* template */

var __vue_render__$m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('LabelInfo', {
    staticStyle: {
      "margin-bottom": "2px"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
    class: _vm.$style.box
  }, [_c('div', {
    class: _vm.$style.item
  }, [_c('Calendar', {
    attrs: {
      "value": _vm.value.from,
      "placeholder": 'с',
      "tabindex": _vm.minTabindex,
      "classField": _vm.classField
    },
    on: {
      "input": _vm.handleInputFrom
    }
  })], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.separate
  }, [_c('svg', {
    attrs: {
      "width": "17",
      "height": "1",
      "viewBox": "0 0 17 1",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('line', {
    attrs: {
      "y1": "0.5",
      "x2": "16.0312",
      "y2": "0.5",
      "stroke": _vm.team === 'dark' ? '#FFF' : 'black'
    }
  })])]), _vm._v(" "), _c('div', {
    class: _vm.$style.item
  }, [_c('Calendar', {
    attrs: {
      "value": _vm.value.to,
      "placeholder": 'по',
      "tabindex": _vm.maxTabindex,
      "classField": _vm.classField
    },
    on: {
      "input": _vm.handleInputTo
    }
  })], 1)])], 1);
};

var __vue_staticRenderFns__$m = [];
/* style */

const __vue_inject_styles__$m = function (inject) {
  if (!inject) return;
  inject("data-v-20fae172_0", {
    source: ".src-components-box-ppyU{display:flex;align-items:center}.src-components-box-ppyU .src-components-separate-Kkvv{margin:0 5px 7px 7px;width:17px}.src-components-box-ppyU .src-components-item-1FK8{flex:1}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-box-ppyU",
      "separate": "src-components-separate-Kkvv",
      "item": "src-components-item-1FK8"
    }
  });
};
/* scoped */


const __vue_scope_id__$m = undefined;
/* module identifier */

const __vue_module_identifier__$m = undefined;
/* functional template */

const __vue_is_functional_template__$m = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$m,
  staticRenderFns: __vue_staticRenderFns__$m
}, __vue_inject_styles__$m, __vue_script__$m, __vue_scope_id__$m, __vue_is_functional_template__$m, __vue_module_identifier__$m, false, createInjector, undefined, undefined);

var script$l = {
  name: 'DateRangeInput',
  components: {
    Calendar: __vue_component__$1B
  },
  props: {
    minTabindex: Number,
    maxTabindex: Number,
    classField: String,
    value: {
      type: Object,

      default() {
        return {
          from: null,
          to: null
        };
      }

    }
  },
  methods: {
    handleInputFrom(valueFrom) {
      const value = { ...this.value,
        from: valueFrom
      };

      if (value.from && value.to && value.from.getTime() > value.to.getTime()) {
        value.to = new Date(value.from);
      }

      this.$emit("input", value);
    },

    handleInputTo(valueTo) {
      const value = { ...this.value,
        to: valueTo
      };

      if (value.from && value.to && value.from.getTime() > value.to.getTime()) {
        value.from = new Date(value.to);
      }

      this.$emit("input", value);
    }

  }
};

/* script */
const __vue_script__$l = script$l;
/* template */

var __vue_render__$l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.$style.box
  }, [_c('Calendar', {
    class: _vm.$style.item,
    attrs: {
      "value": _vm.value.from,
      "placeholder": 'с',
      "tabindex": _vm.minTabindex,
      "classField": _vm.classField
    },
    on: {
      "input": _vm.handleInputFrom
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.$style.dash
  }, [_vm._v("—")]), _vm._v(" "), _c('Calendar', {
    class: _vm.$style.item,
    attrs: {
      "value": _vm.value.to,
      "placeholder": 'по',
      "tabindex": _vm.maxTabindex,
      "classField": _vm.classField
    },
    on: {
      "input": _vm.handleInputTo
    }
  })], 1);
};

var __vue_staticRenderFns__$l = [];
/* style */

const __vue_inject_styles__$l = function (inject) {
  if (!inject) return;
  inject("data-v-34affd76_0", {
    source: ".src-components-box-28iD{display:flex;align-items:baseline}.src-components-box-28iD .src-components-item-33gI{flex:1}.src-components-box-28iD .src-components-dash-CbB5{margin:0 5px 7px 7px;width:17px}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-box-28iD",
      "item": "src-components-item-33gI",
      "dash": "src-components-dash-CbB5"
    }
  });
};
/* scoped */


const __vue_scope_id__$l = undefined;
/* module identifier */

const __vue_module_identifier__$l = undefined;
/* functional template */

const __vue_is_functional_template__$l = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$l,
  staticRenderFns: __vue_staticRenderFns__$l
}, __vue_inject_styles__$l, __vue_script__$l, __vue_scope_id__$l, __vue_is_functional_template__$l, __vue_module_identifier__$l, false, createInjector, undefined, undefined);

var script$k = {
  name: 'SimpleTable',
  components: {
    IconRub: __vue_component__$1k
  },
  props: {
    tableClass: {
      type: Array,

      default() {
        return [];
      }

    },
    columnsClass: {
      type: Array,

      default() {
        return [];
      }

    },
    columns: Array,
    rows: Array
  },
  methods: {
    getRowClasses(array, index, first, last, summ) {
      let size = array.length - 1;
      let classes = [this.$style.cell];

      if (index === 0) {
        if (first) classes.push(this.$style.cellTL);
        if (last) classes.push(this.$style.cellTR);
      }

      if (index === size) {
        classes.push(this.$style.cellB);
        if (first) classes.push(this.$style.cellBL);
        if (last) classes.push(this.$style.cellBR);
      }

      if (last) classes.push(this.$style.cellR);

      if (summ) {
        classes.push(this.$style.cellSumm);
        classes.push(this.$style.cellNowrap);
      }

      return classes;
    },

    isRur(column, row) {
      return column.isRur && row[column.field] && row[column.field] !== 0 && row[column.field] !== '0' && row[column.field] !== '-';
    },

    getHtmlValue(row) {
      if (row) {
        return row.toString().replace('font-size: 13px; ', '');
      }

      return row;
    },

    getCustomRowStyle(column) {
      return column.customRowStyle || '';
    }

  }
};

/* script */
const __vue_script__$k = script$k;
/* template */

var __vue_render__$k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('table', {
    class: [_vm.$style.table, _vm.tableClass]
  }, [_c('thead', [_c('tr', _vm._l(_vm.columns, function (column, ci) {
    return _c('th', {
      key: ci,
      class: [column.class, _vm.columnsClass]
    }, [_vm._v(_vm._s(column.name))]);
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l(_vm.rows, function (row, ri) {
    return _c('tr', {
      key: ri
    }, _vm._l(_vm.columns, function (column, ci) {
      return _c('td', {
        key: ci,
        class: _vm.getRowClasses(_vm.rows, ri, ci === 0, ci === _vm.columns.length - 1, column.isRur),
        style: _vm.getCustomRowStyle(column)
      }, [column.isHtml ? _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.getHtmlValue(row[column.field]))
        }
      }) : _c('span', [_vm._v(_vm._s(row[column.field]))]), _vm._v(" "), _vm.isRur(column, row) ? _c('IconRub', {
        class: _vm.$style.cellRur,
        attrs: {
          "height": "6px",
          "width": "6px"
        }
      }) : _vm._e()], 1);
    }), 0);
  }), 0)])]);
};

var __vue_staticRenderFns__$k = [];
/* style */

const __vue_inject_styles__$k = function (inject) {
  if (!inject) return;
  inject("data-v-06cd0e92_0", {
    source: ".src-components-table-tnmj{border-spacing:0 0;border-collapse:separate}.src-components-table-tnmj tbody tr:nth-child(even){background:#f0f1f3}.src-components-table-tnmj tbody tr:nth-child(odd){background:#fff}.src-components-cell-3mxq{color:#000;border:solid #000;border-width:1px 0 0 1px;padding:8px;line-height:24px}.src-components-cellTL-2NgL{border-top-left-radius:4px}.src-components-cellTR-3fzf{border-top-right-radius:4px}.src-components-cellBL-16Rw{border-bottom-left-radius:4px}.src-components-cellBR-3_oi{border-bottom-right-radius:4px}.src-components-cellR-19gg{border-right-width:1px}.src-components-cellB-TuUA{border-bottom-width:1px}.src-components-cellSumm-2jSP{text-align:right!important}.src-components-cellRur-11PS path{fill:#202020}.src-components-cellNowrap-1-yd{white-space:nowrap}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "table": "src-components-table-tnmj",
      "cell": "src-components-cell-3mxq",
      "cellTL": "src-components-cellTL-2NgL",
      "cellTR": "src-components-cellTR-3fzf",
      "cellBL": "src-components-cellBL-16Rw",
      "cellBR": "src-components-cellBR-3_oi",
      "cellR": "src-components-cellR-19gg",
      "cellB": "src-components-cellB-TuUA",
      "cellSumm": "src-components-cellSumm-2jSP",
      "cellRur": "src-components-cellRur-11PS",
      "cellNowrap": "src-components-cellNowrap-1-yd"
    }
  });
};
/* scoped */


const __vue_scope_id__$k = undefined;
/* module identifier */

const __vue_module_identifier__$k = undefined;
/* functional template */

const __vue_is_functional_template__$k = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$k,
  staticRenderFns: __vue_staticRenderFns__$k
}, __vue_inject_styles__$k, __vue_script__$k, __vue_scope_id__$k, __vue_is_functional_template__$k, __vue_module_identifier__$k, false, createInjector, undefined, undefined);

var script$j = {
  name: "ModalShow",

  data() {
    return {
      open: false
    };
  },

  components: {
    Modal: __vue_component__$1V
  },
  methods: {
    switchOpen() {
      console.log('switchOpen');
      this.open = !this.open;
    }

  }
};

/* script */
const __vue_script__$j = script$j;
/* template */

var __vue_render__$j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.switchOpen($event);
      }
    }
  }, [[_vm._t("default")], _vm._v(" "), _vm.open ? _c('Modal', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      },
      "close": _vm.switchOpen
    }
  }, [_vm._t("modal")], 2) : _vm._e()], 2);
};

var __vue_staticRenderFns__$j = [];
/* style */

const __vue_inject_styles__$j = undefined;
/* scoped */

const __vue_scope_id__$j = undefined;
/* module identifier */

const __vue_module_identifier__$j = undefined;
/* functional template */

const __vue_is_functional_template__$j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$j,
  staticRenderFns: __vue_staticRenderFns__$j
}, __vue_inject_styles__$j, __vue_script__$j, __vue_scope_id__$j, __vue_is_functional_template__$j, __vue_module_identifier__$j, false, undefined, undefined, undefined);

var css_248z = "@charset \"UTF-8\";\n.style-polza-module_breadcrumbs__2gb9k {\n  display: block;\n  margin: 4px 0 4px 0;\n  padding: 0;\n  list-style: none;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n}\n\n.style-polza-module_breadcrumbCell__3tZNd {\n  display: inline;\n  margin: 0;\n  padding: 0 0 0 2px;\n}\n.style-polza-module_breadcrumbCell__3tZNd.style-polza-module_black__3bVId {\n  color: #212529;\n}\n.style-polza-module_breadcrumbCell__3tZNd.style-polza-module_white__15Yrf {\n  color: #fff;\n}\n.style-polza-module_breadcrumbCell__3tZNd > a {\n  cursor: default;\n  font-size: 20px;\n  font-family: \"Oswald\", sans-serif;\n}\n.style-polza-module_breadcrumbCell__3tZNd > a.style-polza-module_black__3bVId {\n  color: #212529;\n}\n.style-polza-module_breadcrumbCell__3tZNd > a.style-polza-module_black__3bVId.style-polza-module_breadcrumbLink__1sh1b:link, .style-polza-module_breadcrumbCell__3tZNd > a.style-polza-module_black__3bVId.style-polza-module_breadcrumbLink__1sh1b:active, .style-polza-module_breadcrumbCell__3tZNd > a.style-polza-module_black__3bVId.style-polza-module_breadcrumbLink__1sh1b:visited {\n  text-decoration: none;\n  color: #212529;\n}\n.style-polza-module_breadcrumbCell__3tZNd > a.style-polza-module_black__3bVId.style-polza-module_breadcrumbLink__1sh1b, .style-polza-module_breadcrumbCell__3tZNd > a.style-polza-module_black__3bVId.style-polza-module_breadcrumbLink__1sh1b > * {\n  cursor: pointer;\n}\n.style-polza-module_breadcrumbCell__3tZNd > a.style-polza-module_black__3bVId.style-polza-module_breadcrumbLink__1sh1b:hover, .style-polza-module_breadcrumbCell__3tZNd > a.style-polza-module_black__3bVId.style-polza-module_breadcrumbLink__1sh1b > *:hover {\n  color: #61cfc5;\n  text-decoration: underline;\n}\n.style-polza-module_breadcrumbCell__3tZNd > a.style-polza-module_white__15Yrf {\n  color: #fff;\n}\n.style-polza-module_breadcrumbCell__3tZNd > a.style-polza-module_white__15Yrf.style-polza-module_breadcrumbLink__1sh1b:link, .style-polza-module_breadcrumbCell__3tZNd > a.style-polza-module_white__15Yrf.style-polza-module_breadcrumbLink__1sh1b:active, .style-polza-module_breadcrumbCell__3tZNd > a.style-polza-module_white__15Yrf.style-polza-module_breadcrumbLink__1sh1b:visited {\n  text-decoration: none;\n  color: #fff;\n}\n.style-polza-module_breadcrumbCell__3tZNd > a.style-polza-module_white__15Yrf.style-polza-module_breadcrumbLink__1sh1b, .style-polza-module_breadcrumbCell__3tZNd > a.style-polza-module_white__15Yrf.style-polza-module_breadcrumbLink__1sh1b > * {\n  cursor: pointer;\n}\n.style-polza-module_breadcrumbCell__3tZNd > a.style-polza-module_white__15Yrf.style-polza-module_breadcrumbLink__1sh1b:hover, .style-polza-module_breadcrumbCell__3tZNd > a.style-polza-module_white__15Yrf.style-polza-module_breadcrumbLink__1sh1b > *:hover {\n  color: #61cfc5;\n  text-decoration: underline;\n}\n.style-polza-module_breadcrumbCell__3tZNd > a.style-polza-module_breadcrumb-text__m3fec {\n  text-decoration: none;\n}\n.style-polza-module_breadcrumbCell__3tZNd > a.style-polza-module_breadcrumb-text__m3fec:link, .style-polza-module_breadcrumbCell__3tZNd > a.style-polza-module_breadcrumb-text__m3fec:active, .style-polza-module_breadcrumbCell__3tZNd > a.style-polza-module_breadcrumb-text__m3fec:visited, .style-polza-module_breadcrumbCell__3tZNd > a.style-polza-module_breadcrumb-text__m3fec:hover {\n  text-decoration: none;\n}\n.style-polza-module_breadcrumbCell__3tZNd > a.style-polza-module_hidden__3AAcP {\n  display: none !important;\n}\n.style-polza-module_breadcrumbCell__3tZNd:not(:last-of-type).style-polza-module_white__15Yrf::after {\n  content: \">\\A0\";\n  padding-left: 2px;\n  font-size: 20px;\n  color: #fff;\n}\n.style-polza-module_breadcrumbCell__3tZNd:not(:last-of-type).style-polza-module_black__3bVId::after {\n  content: \">\";\n  padding-left: 2px;\n  font-size: 20px;\n  color: #212529;\n}";
var polzaStyle = {"breadcrumbs":"style-polza-module_breadcrumbs__2gb9k","breadcrumbCell":"style-polza-module_breadcrumbCell__3tZNd","black":"style-polza-module_black__3bVId","white":"style-polza-module_white__15Yrf","breadcrumbLink":"style-polza-module_breadcrumbLink__1sh1b","breadcrumb-text":"style-polza-module_breadcrumb-text__m3fec","hidden":"style-polza-module_hidden__3AAcP"};
styleInject(css_248z);

//
var script$i = {
  name: "BreadCrumb",
  components: {},
  props: {
    crumbs: null,
    noTarget: Boolean,
    color: String,
    isPolza: {
      type: Boolean,
      required: false
    }
  },

  data() {
    return {
      polzaStyle: polzaStyle
    };
  },

  computed: {
    breadCrumbs() {
      if (!this.crumbs || this.crumbs.length <= 0) return [];
      let crumbs = this.crumbs.filter(i => i && i.text && i.text.length > 0 && i.url.length > 0);
      if (crumbs.length <= 1) return [];
      return crumbs;
    },

    colorClass() {
      if (this.isPolza) {
        return this.color && this.color === 'white' ? this.polzaStyle.white : this.polzaStyle.black;
      } else {
        return this.color && this.color === 'white' ? this.$style.white : this.$style.black;
      }
    }

  },
  methods: {
    getClass(className) {
      return this.isPolza && this.polzaStyle[className] || this.$style[className];
    },

    handleClick(ev, val) {
      this.$emit('crumbclick', val);

      if (val.preventClick) {
        ev.preventDefault();
      }
    }

  }
};

/* script */
const __vue_script__$i = script$i;
/* template */

var __vue_render__$i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.breadCrumbs.length > 0 && _vm.getClass('breadcrumbs') ? _c('div', [_c('ol', {
    class: _vm.getClass('breadcrumbs'),
    attrs: {
      "itemscope": "itemscope",
      "itemtype": "http://schema.org/BreadcrumbList"
    }
  }, _vm._l(_vm.breadCrumbs, function (val, index) {
    return _c('li', {
      key: index,
      class: [_vm.getClass('breadcrumbCell'), _vm.colorClass],
      attrs: {
        "itemprop": "itemListElement",
        "itemscope": "itemscope",
        "itemtype": "http://schema.org/ListItem"
      }
    }, [_c('a', {
      class: [_vm.colorClass, val.url ? _vm.getClass('breadcrumbLink') : _vm.getClass('breadcrumbText'), val.noLink ? _vm.getClass('hidden') : null],
      attrs: {
        "href": val.url && val.url.toLowerCase(),
        "itemprop": "item",
        "target": _vm.noTarget && val.url ? null : '_blank'
      },
      on: {
        "click": function (ev) {
          return _vm.handleClick(ev, val);
        }
      }
    }, [_c('span', {
      attrs: {
        "itemprop": "name"
      }
    }, [_vm._v(_vm._s(val.text))])]), _vm._v("\n      " + _vm._s(val.noLink ? val.text : null) + "\n      "), _c('meta', {
      attrs: {
        "itemprop": "position",
        "content": index + 1
      }
    })]);
  }), 0)]) : _vm._e();
};

var __vue_staticRenderFns__$i = [];
/* style */

const __vue_inject_styles__$i = function (inject) {
  if (!inject) return;
  inject("data-v-6b028702_0", {
    source: ".src-components-BreadCrumbs-breadcrumbs-3tr-{display:block;margin:4px 0 4px 0;padding:0;list-style:none}.src-components-BreadCrumbs-breadcrumbCell-1W_T{display:inline;margin:0;padding:0 0 0 2px}.src-components-BreadCrumbs-breadcrumbCell-1W_T.src-components-BreadCrumbs-black-1sZV{color:#202020}.src-components-BreadCrumbs-breadcrumbCell-1W_T.src-components-BreadCrumbs-white-30O-{color:#fff}.src-components-BreadCrumbs-breadcrumbCell-1W_T>a{cursor:default;font-size:16px;font-family:\"IBM Plex Sans\",Avenir,Helvetica,Arial,sans-serif}.src-components-BreadCrumbs-breadcrumbCell-1W_T>a.src-components-BreadCrumbs-black-1sZV{color:#202020}.src-components-BreadCrumbs-breadcrumbCell-1W_T>a.src-components-BreadCrumbs-black-1sZV.src-components-BreadCrumbs-breadcrumbLink-1_g6:active,.src-components-BreadCrumbs-breadcrumbCell-1W_T>a.src-components-BreadCrumbs-black-1sZV.src-components-BreadCrumbs-breadcrumbLink-1_g6:link,.src-components-BreadCrumbs-breadcrumbCell-1W_T>a.src-components-BreadCrumbs-black-1sZV.src-components-BreadCrumbs-breadcrumbLink-1_g6:visited{text-decoration:none;color:#202020}.src-components-BreadCrumbs-breadcrumbCell-1W_T>a.src-components-BreadCrumbs-black-1sZV.src-components-BreadCrumbs-breadcrumbLink-1_g6,.src-components-BreadCrumbs-breadcrumbCell-1W_T>a.src-components-BreadCrumbs-black-1sZV.src-components-BreadCrumbs-breadcrumbLink-1_g6>*{cursor:pointer}.src-components-BreadCrumbs-breadcrumbCell-1W_T>a.src-components-BreadCrumbs-black-1sZV.src-components-BreadCrumbs-breadcrumbLink-1_g6:hover,.src-components-BreadCrumbs-breadcrumbCell-1W_T>a.src-components-BreadCrumbs-black-1sZV.src-components-BreadCrumbs-breadcrumbLink-1_g6>:hover{color:#ee6865;text-decoration:underline}.src-components-BreadCrumbs-breadcrumbCell-1W_T>a.src-components-BreadCrumbs-white-30O-{color:#fff}.src-components-BreadCrumbs-breadcrumbCell-1W_T>a.src-components-BreadCrumbs-white-30O-.src-components-BreadCrumbs-breadcrumbLink-1_g6:active,.src-components-BreadCrumbs-breadcrumbCell-1W_T>a.src-components-BreadCrumbs-white-30O-.src-components-BreadCrumbs-breadcrumbLink-1_g6:link,.src-components-BreadCrumbs-breadcrumbCell-1W_T>a.src-components-BreadCrumbs-white-30O-.src-components-BreadCrumbs-breadcrumbLink-1_g6:visited{text-decoration:none;color:#fff}.src-components-BreadCrumbs-breadcrumbCell-1W_T>a.src-components-BreadCrumbs-white-30O-.src-components-BreadCrumbs-breadcrumbLink-1_g6,.src-components-BreadCrumbs-breadcrumbCell-1W_T>a.src-components-BreadCrumbs-white-30O-.src-components-BreadCrumbs-breadcrumbLink-1_g6>*{cursor:pointer}.src-components-BreadCrumbs-breadcrumbCell-1W_T>a.src-components-BreadCrumbs-white-30O-.src-components-BreadCrumbs-breadcrumbLink-1_g6:hover,.src-components-BreadCrumbs-breadcrumbCell-1W_T>a.src-components-BreadCrumbs-white-30O-.src-components-BreadCrumbs-breadcrumbLink-1_g6>:hover{color:#ee6865;text-decoration:underline}.src-components-BreadCrumbs-breadcrumbCell-1W_T>a.src-components-BreadCrumbs-breadcrumb-text-1vlV{text-decoration:none}.src-components-BreadCrumbs-breadcrumbCell-1W_T>a.src-components-BreadCrumbs-breadcrumb-text-1vlV:active,.src-components-BreadCrumbs-breadcrumbCell-1W_T>a.src-components-BreadCrumbs-breadcrumb-text-1vlV:hover,.src-components-BreadCrumbs-breadcrumbCell-1W_T>a.src-components-BreadCrumbs-breadcrumb-text-1vlV:link,.src-components-BreadCrumbs-breadcrumbCell-1W_T>a.src-components-BreadCrumbs-breadcrumb-text-1vlV:visited{text-decoration:none}.src-components-BreadCrumbs-breadcrumbCell-1W_T>a.src-components-BreadCrumbs-hidden-29-w{display:none!important}.src-components-BreadCrumbs-breadcrumbCell-1W_T:not(:last-of-type).src-components-BreadCrumbs-white-30O-::after{content:\">\";padding-left:2px;font-size:16px;color:#fff}.src-components-BreadCrumbs-breadcrumbCell-1W_T:not(:last-of-type).src-components-BreadCrumbs-black-1sZV::after{content:\">\";padding-left:2px;font-size:16px;color:#202020}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "breadcrumbs": "src-components-BreadCrumbs-breadcrumbs-3tr-",
      "breadcrumbCell": "src-components-BreadCrumbs-breadcrumbCell-1W_T",
      "black": "src-components-BreadCrumbs-black-1sZV",
      "white": "src-components-BreadCrumbs-white-30O-",
      "breadcrumbLink": "src-components-BreadCrumbs-breadcrumbLink-1_g6",
      "breadcrumb-text": "src-components-BreadCrumbs-breadcrumb-text-1vlV",
      "hidden": "src-components-BreadCrumbs-hidden-29-w"
    }
  });
};
/* scoped */


const __vue_scope_id__$i = undefined;
/* module identifier */

const __vue_module_identifier__$i = undefined;
/* functional template */

const __vue_is_functional_template__$i = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$i,
  staticRenderFns: __vue_staticRenderFns__$i
}, __vue_inject_styles__$i, __vue_script__$i, __vue_scope_id__$i, __vue_is_functional_template__$i, __vue_module_identifier__$i, false, createInjector, undefined, undefined);

var script$h = {
  name: 'IconCloseBig',
  props: {
    color: {
      type: String,
      default: '#6E7C8D'
    }
  }
};

/* script */
const __vue_script__$h = script$h;
/* template */

var __vue_render__$h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "width": "12",
      "height": "18",
      "viewBox": "0 0 12 18",
      "fill": "none",
      "stroke": _vm.color,
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('line', {
    attrs: {
      "x1": "1",
      "y1": "5",
      "x2": "11",
      "y2": "15",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "1",
      "y1": "15",
      "x2": "11",
      "y2": "5",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })]);
};

var __vue_staticRenderFns__$h = [];
/* style */

const __vue_inject_styles__$h = undefined;
/* scoped */

const __vue_scope_id__$h = undefined;
/* module identifier */

const __vue_module_identifier__$h = undefined;
/* functional template */

const __vue_is_functional_template__$h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$h,
  staticRenderFns: __vue_staticRenderFns__$h
}, __vue_inject_styles__$h, __vue_script__$h, __vue_scope_id__$h, __vue_is_functional_template__$h, __vue_module_identifier__$h, false, undefined, undefined, undefined);

const defaultSize = 'normal';
var script$g = {
  name: 'Icon',
  props: {
    png: String,
    size: {
      type: String,
      default: defaultSize
    }
  },
  computed: {
    svgSize() {
      switch (this.size) {
        case 'tiny':
          return 8;

        case 'small':
          return 12;

        case 'big':
          return 30;

        default:
          return 24;
      }
    }

  }
};

/* script */
const __vue_script__$g = script$g;
/* template */

var __vue_render__$g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "display": "inline-block",
      "width": _vm.svgSize,
      "height": _vm.svgSize,
      "viewBox": "0 0 100 100",
      "stroke": "currentColor",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_vm.png == 'plus' ? [_c('path', {
    attrs: {
      "d": "M8 50L92 50",
      "stroke-width": "8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M50 8L50 92",
      "stroke-width": "8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })] : _vm.png == 'close' ? [_c('path', {
    attrs: {
      "d": "M10 10L90 90",
      "stroke-width": "8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10 90L90 10",
      "stroke-width": "8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })] : _vm._e()], 2);
};

var __vue_staticRenderFns__$g = [];
/* style */

const __vue_inject_styles__$g = undefined;
/* scoped */

const __vue_scope_id__$g = undefined;
/* module identifier */

const __vue_module_identifier__$g = undefined;
/* functional template */

const __vue_is_functional_template__$g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g,
  staticRenderFns: __vue_staticRenderFns__$g
}, __vue_inject_styles__$g, __vue_script__$g, __vue_scope_id__$g, __vue_is_functional_template__$g, __vue_module_identifier__$g, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$f = {
  name: "IconDelete"
};

/* script */
const __vue_script__$f = script$f;
/* template */

var __vue_render__$f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "width": "17",
      "height": "25",
      "viewBox": "0 0 17 25",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 11H15L13 23H5L3 11Z",
      "fill": "#202020",
      "stroke": "#202020",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "1.98058",
      "y1": "6.14823",
      "x2": "14.5376",
      "y2": "2.78359",
      "stroke": "#202020",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8.25859",
      "y1": "4.46595",
      "x2": "7.74095",
      "y2": "2.5341",
      "stroke": "#202020",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};

var __vue_staticRenderFns__$f = [];
/* style */

const __vue_inject_styles__$f = undefined;
/* scoped */

const __vue_scope_id__$f = "data-v-5a93c851";
/* module identifier */

const __vue_module_identifier__$f = undefined;
/* functional template */

const __vue_is_functional_template__$f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f,
  staticRenderFns: __vue_staticRenderFns__$f
}, __vue_inject_styles__$f, __vue_script__$f, __vue_scope_id__$f, __vue_is_functional_template__$f, __vue_module_identifier__$f, false, undefined, undefined, undefined);

var script$e = {
  name: 'IconTrash',
  props: {
    color: {
      type: String,
      default: '#6E7C8D'
    }
  }
};

/* script */
const __vue_script__$e = script$e;
/* template */

var __vue_render__$e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "display": "block",
      "width": "15",
      "height": "18",
      "viewBox": "0 0 15 18",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "stroke": _vm.color
    }
  }, [_c('path', {
    attrs: {
      "d": "M2.25 3.5H12.5V15.25C12.5 16.0784 11.8284 16.75 11 16.75H3.75C2.92157 16.75 2.25 16.0784 2.25 15.25V3.5Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3.75 3.25H11V2.75C11 1.92157 10.3284 1.25 9.5 1.25H5.25C4.42157 1.25 3.75 1.92157 3.75 2.75V3.25Z"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "5.25",
      "y1": "6",
      "x2": "5.25",
      "y2": "14.25"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "7.5",
      "y1": "6",
      "x2": "7.5",
      "y2": "14.25"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "9.75",
      "y1": "6",
      "x2": "9.75",
      "y2": "14.25"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "0.75",
      "y1": "3.25",
      "x2": "14",
      "y2": "3.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};

var __vue_staticRenderFns__$e = [];
/* style */

const __vue_inject_styles__$e = undefined;
/* scoped */

const __vue_scope_id__$e = undefined;
/* module identifier */

const __vue_module_identifier__$e = undefined;
/* functional template */

const __vue_is_functional_template__$e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$e, __vue_script__$e, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
var script$d = {
  name: 'IconCheckMark'
};

/* script */
const __vue_script__$d = script$d;
/* template */

var __vue_render__$d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "width": "18",
      "height": "15",
      "viewBox": "0 0 18 15",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('line', {
    attrs: {
      "x1": "6.55425",
      "y1": "13.4683",
      "x2": "1.03157",
      "y2": "7.94566",
      "stroke": "#6E7C8D",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "6.29289",
      "y1": "12.2929",
      "x2": "17.2929",
      "y2": "1.29289",
      "stroke": "#6E7C8D",
      "stroke-width": "2"
    }
  })]);
};

var __vue_staticRenderFns__$d = [];
/* style */

const __vue_inject_styles__$d = undefined;
/* scoped */

const __vue_scope_id__$d = undefined;
/* module identifier */

const __vue_module_identifier__$d = undefined;
/* functional template */

const __vue_is_functional_template__$d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$d, __vue_script__$d, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, undefined, undefined, undefined);

var script$c = {
  name: 'IconCheckMarkBig',
  props: {
    color: {
      type: String,
      default: '#6E7C8D'
    }
  }
};

/* script */
const __vue_script__$c = script$c;
/* template */

var __vue_render__$c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "width": "17",
      "height": "18",
      "viewBox": "0 0 17 18",
      "fill": "none",
      "stroke": _vm.color,
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('line', {
    attrs: {
      "x1": "1",
      "y1": "10",
      "x2": "6",
      "y2": "15",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "15",
      "x2": "16",
      "y2": "5",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })]);
};

var __vue_staticRenderFns__$c = [];
/* style */

const __vue_inject_styles__$c = undefined;
/* scoped */

const __vue_scope_id__$c = undefined;
/* module identifier */

const __vue_module_identifier__$c = undefined;
/* functional template */

const __vue_is_functional_template__$c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
var script$b = {
  name: 'IconBan'
};

/* script */
const __vue_script__$b = script$b;
/* template */

var __vue_render__$b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "8",
      "cy": "8",
      "r": "7",
      "stroke": "#6E7C8D",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "2.29289",
      "y1": "13.6064",
      "x2": "13.6066",
      "y2": "2.29266",
      "stroke": "#6E7C8D",
      "stroke-width": "2"
    }
  })]);
};

var __vue_staticRenderFns__$b = [];
/* style */

const __vue_inject_styles__$b = undefined;
/* scoped */

const __vue_scope_id__$b = undefined;
/* module identifier */

const __vue_module_identifier__$b = undefined;
/* functional template */

const __vue_is_functional_template__$b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
var script$a = {
  name: 'IconPlus'
};

/* script */
const __vue_script__$a = script$a;
/* template */

var __vue_render__$a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "display": "block",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2 12L22 12",
      "stroke": "#6E7C8D",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 2L12 22",
      "stroke": "#6E7C8D",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};

var __vue_staticRenderFns__$a = [];
/* style */

const __vue_inject_styles__$a = undefined;
/* scoped */

const __vue_scope_id__$a = undefined;
/* module identifier */

const __vue_module_identifier__$a = undefined;
/* functional template */

const __vue_is_functional_template__$a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, undefined, undefined, undefined);

//
//
//
//
//
//
var script$9 = {
  name: 'IconMinus'
};

/* script */
const __vue_script__$9 = script$9;
/* template */

var __vue_render__$9 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "display": "block",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2 12L22 12",
      "stroke": "#6E7C8D",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};

var __vue_staticRenderFns__$9 = [];
/* style */

const __vue_inject_styles__$9 = undefined;
/* scoped */

const __vue_scope_id__$9 = undefined;
/* module identifier */

const __vue_module_identifier__$9 = undefined;
/* functional template */

const __vue_is_functional_template__$9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
var script$8 = {
  name: 'IconGripVert'
};

/* script */
const __vue_script__$8 = script$8;
/* template */

var __vue_render__$8 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "width": "10",
      "height": "24",
      "display": "block",
      "viewBox": "0 0 10 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 2L3 22",
      "stroke": "#6E7C8D",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7 2L7 22",
      "stroke": "#6E7C8D",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};

var __vue_staticRenderFns__$8 = [];
/* style */

const __vue_inject_styles__$8 = undefined;
/* scoped */

const __vue_scope_id__$8 = undefined;
/* module identifier */

const __vue_module_identifier__$8 = undefined;
/* functional template */

const __vue_is_functional_template__$8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, undefined, undefined, undefined);

//
var script$7 = {
  name: "SearchTextEditor",
  components: {
    TextEditor: __vue_component__$1K
  },
  props: {
    inputRef: Function,
    value: String,
    defaultValue: String
  }
};

/* script */
const __vue_script__$7 = script$7;
/* template */

var __vue_render__$7 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.$style.searchBox
  }, [!_vm.value ? [_c('svg', {
    class: _vm.$style.searchIcon,
    attrs: {
      "fill": "#F5F5F5",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "viewBox": "0 0 26 26",
      "version": "1.1",
      "width": "21px",
      "height": "21px"
    }
  }, [_c('g', {
    attrs: {
      "id": "surface1"
    }
  }, [_c('path', {
    attrs: {
      "d": "M 10 0.1875 C 4.578125 0.1875 0.1875 4.578125 0.1875 10 C 0.1875 15.421875 4.578125 19.8125 10 19.8125 C 12.289063 19.8125 14.394531 19.003906 16.0625 17.6875 L 16.9375 18.5625 C 16.570313 19.253906 16.699219 20.136719 17.28125 20.71875 L 21.875 25.34375 C 22.589844 26.058594 23.753906 26.058594 24.46875 25.34375 L 25.34375 24.46875 C 26.058594 23.753906 26.058594 22.589844 25.34375 21.875 L 20.71875 17.28125 C 20.132813 16.695313 19.253906 16.59375 18.5625 16.96875 L 17.6875 16.09375 C 19.011719 14.421875 19.8125 12.300781 19.8125 10 C 19.8125 4.578125 15.421875 0.1875 10 0.1875 Z M 10 2 C 14.417969 2 18 5.582031 18 10 C 18 14.417969 14.417969 18 10 18 C 5.582031 18 2 14.417969 2 10 C 2 5.582031 5.582031 2 10 2 Z M 4.9375 7.46875 C 4.421875 8.304688 4.125 9.289063 4.125 10.34375 C 4.125 13.371094 6.566406 15.8125 9.59375 15.8125 C 10.761719 15.8125 11.859375 15.433594 12.75 14.8125 C 12.511719 14.839844 12.246094 14.84375 12 14.84375 C 8.085938 14.84375 4.9375 11.695313 4.9375 7.78125 C 4.9375 7.675781 4.933594 7.574219 4.9375 7.46875 Z "
    }
  })])])] : _vm._e(), _vm._v(" "), _c('TextEditor', {
    attrs: {
      "tabindex": -1,
      "value": _vm.value,
      "defaultValue": _vm.defaultValue,
      "inputRef": _vm.inputRef
    },
    on: {
      "input": function (e) {
        return _vm.$emit('input', e);
      },
      "change": function (e) {
        return _vm.$emit('change', e);
      },
      "keyup": function (e) {
        return _vm.$emit('keyup', e);
      },
      "blur": function (e) {
        return _vm.$emit('blur', e);
      },
      "click": function (e) {
        return _vm.$emit('click', e);
      },
      "keydown": function (e) {
        return _vm.$emit('keydown', e);
      }
    }
  })], 2);
};

var __vue_staticRenderFns__$7 = [];
/* style */

const __vue_inject_styles__$7 = function (inject) {
  if (!inject) return;
  inject("data-v-89caa4fe_0", {
    source: ".src-components-SearchTextEditor-searchBox-1f87{position:relative}.src-components-SearchTextEditor-searchBox-1f87 .src-components-SearchTextEditor-searchIcon-7f0T{left:10px;top:6px;position:absolute;z-index:1}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "searchBox": "src-components-SearchTextEditor-searchBox-1f87",
      "searchIcon": "src-components-SearchTextEditor-searchIcon-7f0T"
    }
  });
};
/* scoped */


const __vue_scope_id__$7 = undefined;
/* module identifier */

const __vue_module_identifier__$7 = undefined;
/* functional template */

const __vue_is_functional_template__$7 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
const ORIGIN_SIZE = 88;
var script$6 = {
  name: "IconSuccess",
  props: {
    size: {
      type: Number,

      default() {
        return ORIGIN_SIZE;
      }

    }
  },
  computed: {
    zoom() {
      return this.size / ORIGIN_SIZE;
    }

  }
};

/* script */
const __vue_script__$6 = script$6;
/* template */

var __vue_render__$6 = function () {
  var _obj;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "sa",
    style: (_obj = {}, _obj['zoom'] = _vm.zoom, _obj['-ms-zoom'] = _vm.zoom, _obj['-webkit-zoom'] = _vm.zoom, _obj['-moz-transform'] = "scale(" + _vm.zoom + "," + _vm.zoom + ")", _obj['-moz-transform-origin'] = 'left top', _obj.maxWidth = _vm.size + 'px', _obj.maxHeight = _vm.size + 'px', _obj)
  }, [_vm._m(0)]);
};

var __vue_staticRenderFns__$6 = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "sa-success"
  }, [_c('div', {
    staticClass: "sa-success-tip"
  }), _vm._v(" "), _c('div', {
    staticClass: "sa-success-long"
  }), _vm._v(" "), _c('div', {
    staticClass: "sa-success-placeholder"
  }), _vm._v(" "), _c('div', {
    staticClass: "sa-success-fix"
  })]);
}];
/* style */

const __vue_inject_styles__$6 = function (inject) {
  if (!inject) return;
  inject("data-v-52243498_0", {
    source: ".sa[data-v-52243498]{margin:16px 16px 24px 16px;width:88px;height:88px;background-color:#f1f2f4}.sa-success[data-v-52243498]{border-radius:50%!important;border:4px solid #a5dc86;box-sizing:content-box;height:80px;padding:0;position:relative;background-color:#f1f2f4;width:80px}.sa-success[data-v-52243498]:after,.sa-success[data-v-52243498]:before{background-color:#f1f2f4;content:\"\";height:120px;position:absolute;transform:rotate(45deg);width:60px}.sa-success[data-v-52243498]:before{border-radius:40px 0 0 40px!important;width:26px;height:80px;top:-17px;left:5px;transform-origin:60px 60px;transform:rotate(-45deg)}.sa-success[data-v-52243498]:after{border-radius:0 120px 120px 0!important;left:30px;top:-11px;transform-origin:0 60px;transform:rotate(-45deg);animation:rotatePlaceholder-data-v-52243498 4.25s ease-in}.sa-success-placeholder[data-v-52243498]{border-radius:50%!important;border:4px solid rgba(165,220,134,.25);box-sizing:content-box;height:80px;left:-4px;position:absolute;top:-4px;width:80px;z-index:2}.sa-success-fix[data-v-52243498]{background-color:#f1f2f4;height:90px;left:28px;position:absolute;top:8px;transform:rotate(-45deg);width:5px;z-index:1}.sa-success-long[data-v-52243498],.sa-success-tip[data-v-52243498]{background-color:#a5dc86;border-radius:2px!important;height:5px;position:absolute;z-index:2}.sa-success-tip[data-v-52243498]{left:14px;top:46px;transform:rotate(45deg);width:25px;animation:animateSuccessTip-data-v-52243498 .75s}.sa-success-long[data-v-52243498]{right:8px;top:38px;transform:rotate(-45deg);width:47px;animation:animateSuccessLong-data-v-52243498 .75s}@keyframes animateSuccessTip-data-v-52243498{0%,54%{width:0;left:1px;top:19px}70%{width:50px;left:-8px;top:37px}84%{width:17px;left:21px;top:48px}100%{width:25px;left:14px;top:45px}}@keyframes animateSuccessLong-data-v-52243498{0%,65%{width:0;right:46px;top:54px}84%{width:55px;right:0;top:35px}100%{width:47px;right:8px;top:38px}}@keyframes rotatePlaceholder-data-v-52243498{0%,5%{transform:rotate(-45deg)}100%,12%{transform:rotate(-405deg)}}.saSoftHidden[data-v-52243498]{display:none}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$6 = "data-v-52243498";
/* module identifier */

const __vue_module_identifier__$6 = undefined;
/* functional template */

const __vue_is_functional_template__$6 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, createInjector, undefined, undefined);

//
var script$5 = {
  name: "PopupItem",
  components: {
    IconSuccess: __vue_component__$6
  },
  props: {
    softHidden: {
      type: Boolean,

      default() {
        return false;
      }

    },
    text: {
      type: String,

      default() {
        return '';
      }

    }
  }
};

/* script */
const __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function () {
  var this$1 = this;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "PopupItem"
  }, [_c('div', {
    staticClass: "popupItemIconClose",
    class: {
      popupItemIconCloseSoftHidden: _vm.softHidden
    },
    on: {
      "click": function () {
        return this$1.$emit('close');
      }
    }
  }, [_vm._v("\n    х\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "popupItemContent"
  }, [_c('div', {
    staticClass: "popupItemIconVBox",
    style: {
      visibility: _vm.softHidden ? 'hidden' : null
    }
  }, [_c('IconSuccess', {
    staticStyle: {
      "position": "relative",
      "top": "-10px"
    },
    attrs: {
      "size": 41
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "popupItemText",
    class: {
      popupItemTextSoftHidden: _vm.softHidden
    },
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })])]);
};

var __vue_staticRenderFns__$5 = [];
/* style */

const __vue_inject_styles__$5 = function (inject) {
  if (!inject) return;
  inject("data-v-40e62a30_0", {
    source: ".PopupItem[data-v-40e62a30]{display:inline-block;background:#f1f2f4;box-shadow:0 4px 4px rgba(0,0,0,.25);border-radius:8px 8px 40px 8px!important;position:relative;min-height:60px;padding-left:7px}.PopupItem .popupItemIconClose[data-v-40e62a30]{position:absolute;color:rgba(0,0,0,.5);font-size:19px;right:13px;top:1px;cursor:pointer}.PopupItem .popupItemIconCloseSoftHidden[data-v-40e62a30]{color:transparent;transition-duration:3s}.PopupItem .popupItemContent[data-v-40e62a30]{display:flex}.PopupItem .popupItemContent .popupItemIconVBox[data-v-40e62a30]{display:flex;align-items:center;justify-content:center}.PopupItem .popupItemContent .popupItemText[data-v-40e62a30]{margin:10px 46px 5px 27px;color:#202020;font-size:16px;width:222px}.PopupItem .popupItemContent .popupItemTextSoftHidden[data-v-40e62a30]{color:transparent;transition-duration:3s}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$5 = "data-v-40e62a30";
/* module identifier */

const __vue_module_identifier__$5 = undefined;
/* functional template */

const __vue_is_functional_template__$5 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
const CLOSE_TIMEOUT = 3000;
const CLOSE_ANIMATION_TIMEOUT = 3000;
const TEXT_SESSION_ITEM_KEY = '$_orders_popupMessage';

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = Math.random() * 16 | 0,
        v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

const globalStack = [];

function getPopup(key) {
  let popup;

  if (key) {
    popup = globalStack.find(popup => popup.key === key);
  } else {
    if (globalStack.length > 0) {
      popup = globalStack[0];
    }
  }

  return popup;
}

function updatePopup(popup) {
  globalStack.splice(globalStack.indexOf(popup), 1, { ...popup
  });
}
function popupShow(text, close = true) {
  const key = uuidv4();
  let popup = {
    text,
    key
  };
  globalStack.push(popup);

  if (close) {
    popupClose(key);
  }

  return key;
}
function popupClose(key) {
  let popup = getPopup(key);
  popup.closeTaskId = setTimeout(() => {
    popupSoftDel(key);
  }, CLOSE_TIMEOUT);
  updatePopup(popup);
}
function popupDel(key) {
  let popup = getPopup(key);

  if (popup) {
    globalStack.splice(globalStack.indexOf(popup), 1);
  }
}
function popupSoftDel(key) {
  let popup = getPopup(key);

  if (popup) {
    popup.softDel = true;
    popup.softDelTaskId = setTimeout(() => {
      popupDel(popup.key);
    }, CLOSE_ANIMATION_TIMEOUT);
    updatePopup(popup);
  }
}
var script$4 = {
  name: "PopupComponent",
  components: {
    PopupItem: __vue_component__$5
  },

  data() {
    return {
      stack: globalStack,
      closeTaskId: null
    };
  },

  mounted() {
    var text = window.sessionStorage.getItem(TEXT_SESSION_ITEM_KEY);

    if (text) {
      window.sessionStorage.removeItem(TEXT_SESSION_ITEM_KEY);
      popupShow(text);
    }
  },

  methods: {
    popupDel,
    popupSoftDel,

    handlerPopupOnMouseover(popup) {
      let any = false;

      if (popup && popup.softDelTaskId) {
        clearTimeout(popup.softDelTaskId);
        popup.softDelTaskId = null;
        popup.softDel = false;
        any = true;
      }

      if (popup && popup.closeTaskId) {
        clearTimeout(popup.closeTaskId);
        popup.closeTaskId = null;
        popup.softDel = false;
        any = true;
      }

      if (any) updatePopup(popup);
    },

    handlerPopupOnMouseleave(popup) {//popupClose(popup.key);
    }

  }
};

/* script */
const __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "PopupComponent"
  }, _vm._l(_vm.stack, function (popup) {
    return _c('PopupItem', {
      key: popup.key,
      staticClass: "popupItemShow",
      class: {
        popupItemSoftDel: popup.softDel
      },
      attrs: {
        "text": popup.text,
        "softHidden": popup.softDel
      },
      on: {
        "close": function ($event) {
          return _vm.popupDel(popup.key);
        }
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.popupDel(popup.key);
        },
        "mouseover": function ($event) {
          return _vm.handlerPopupOnMouseover(popup);
        },
        "mouseleave": function ($event) {
          return _vm.handlerPopupOnMouseleave(popup);
        }
      }
    });
  }), 1);
};

var __vue_staticRenderFns__$4 = [];
/* style */

const __vue_inject_styles__$4 = function (inject) {
  if (!inject) return;
  inject("data-v-06b5d996_0", {
    source: ".PopupComponent[data-v-06b5d996]{z-index:100;display:flex;flex-direction:column;padding:10px;overflow:hidden}.PopupComponent>*+*[data-v-06b5d996]{margin-top:10px}.PopupComponent .popupItemSoftDel[data-v-06b5d996]{box-shadow:none;background-color:rgba(0,0,0,0);transform:translateY(0);color:transparent;opacity:0;transition-duration:3s}.PopupComponent .popupItemShow[data-v-06b5d996]{animation:show-data-v-06b5d996 .1s 1}@keyframes show-data-v-06b5d996{0%{transform:translateY(0)}100%{transform:translateY(0)}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$4 = "data-v-06b5d996";
/* module identifier */

const __vue_module_identifier__$4 = undefined;
/* functional template */

const __vue_is_functional_template__$4 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, createInjector, undefined, undefined);

var script$3 = {
  name: 'ComponentsTable',
  props: {
    headers: Array,
    rows: Array,
    enableRowMove: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      dragRowIndex: null,
      dropRowIndex: null
    };
  },

  computed: {
    hasFooter() {
      return !!this.$slots.footer || this.enableRowMove;
    },

    colCount() {
      return this.rows.reduce((x, row) => Math.max(row.cells.length, x), 0);
    },

    moveType() {
      return 'x-row-move/' + v4();
    }

  },
  methods: {
    rowClass(rIndex) {
      return {
        [this.$style.row]: true,
        [this.$style.rowEven]: rIndex % 2 == 1,
        [this.$style.rowMovable]: this.enableRowMove
      };
    },

    cellClass(rIndex, cIndex) {
      return {
        [this.$style.cell]: true,
        [this.$style.cellR]: cIndex == this.rows[rIndex].cells.length - 1,
        [this.$style.cellB]: !this.hasFooter && rIndex == this.rows.length - 1,
        [this.$style.cellTL]: rIndex == 0 && cIndex == 0,
        [this.$style.cellTR]: rIndex == 0 && cIndex == this.rows[0].cells.length - 1,
        [this.$style.cellBL]: !this.hasFooter && rIndex == this.rows.length - 1 && cIndex == 0,
        [this.$style.cellBR]: !this.hasFooter && rIndex == this.rows.length - 1 && cIndex == this.rows[this.rows.length - 1].cells.length - 1,
        [this.$style.cellDrop]: rIndex == this.dropRowIndex
      };
    },

    rowDragStart(ev, rIndex) {
      ev.dataTransfer.setData(this.moveType, 'foo');
      let el = ev.target;

      while (el != null && el.tagName != 'TR') {
        el = el.parentElement;
      }

      if (el != null) {
        ev.dataTransfer.setDragImage(el, 25, 25);
      }

      ev.dataTransfer.effectAllowed = 'move';
      this.dragRowIndex = rIndex;
      this.dropRowIndex = null;
    },

    rowDragEnd() {
      this.dragRowIndex = null;
      this.dropRowIndex = null;
    },

    rowDragOver(ev, rIndex) {
      if (this.enableRowMove && rIndex != this.dragRowIndex && rIndex != this.dragRowIndex + 1 && ev.dataTransfer.types.includes(this.moveType)) {
        ev.preventDefault();
        this.dropRowIndex = rIndex;
        ev.dataTransfer.dropEffect = 'move';
      } else {
        this.dropRowIndex = null;
      }
    },

    rowDrop() {
      this.$emit('moverow', {
        from: this.dragRowIndex,
        to: this.dropRowIndex
      });
    }

  }
};

/* script */
const __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function () {
  var _obj;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.$style.box
  }, [_c('table', {
    class: _vm.$style.table
  }, [_c('thead', [_c('tr', _vm._l(_vm.headers, function (header, index) {
    return _c('th', {
      key: index,
      style: {
        width: header.width
      },
      attrs: {
        "title": header.tooltip
      }
    }, [_vm._v("\n          " + _vm._s(header.name) + "\n        ")]);
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l(_vm.rows, function (row, rIndex) {
    return _c('tr', {
      key: rIndex,
      class: _vm.rowClass(rIndex),
      attrs: {
        "draggable": !!_vm.enableRowMove
      },
      on: {
        "dragstart": function (ev) {
          return _vm.rowDragStart(ev, rIndex);
        },
        "dragend": _vm.rowDragEnd,
        "dragover": function (ev) {
          return _vm.rowDragOver(ev, rIndex);
        },
        "drop": _vm.rowDrop
      }
    }, _vm._l(row.cells, function (cell, cIndex) {
      return _c('td', {
        key: cIndex,
        class: _vm.cellClass(rIndex, cIndex)
      }, [cell.slotName ? [_vm._t(cell.slotName, null, {
        "cell": cell
      })] : cell.html ? [_c('div', {
        domProps: {
          "innerHTML": _vm._s(cell.html)
        }
      })] : [_vm._v("\n            " + _vm._s(cell.text) + "\n          ")]], 2);
    }), 0);
  }), 0), _vm._v(" "), _vm.hasFooter ? _c('tfoot', [_c('tr', {
    on: {
      "dragover": function (ev) {
        return _vm.rowDragOver(ev, _vm.rows.length);
      },
      "drop": _vm.rowDrop
    }
  }, [_c('td', {
    class: (_obj = {}, _obj[_vm.$style.cellF] = true, _obj[_vm.$style.cellDrop] = _vm.dropRowIndex == _vm.rows.length, _obj),
    attrs: {
      "colspan": _vm.colCount
    }
  }, [_vm._t("footer", [_c('div', {
    class: _vm.$style.emptyFooter
  })])], 2)])]) : _vm._e()])]);
};

var __vue_staticRenderFns__$3 = [];
/* style */

const __vue_inject_styles__$3 = function (inject) {
  if (!inject) return;
  inject("data-v-01ee707c_0", {
    source: ".src-components-Grids-box-2ZsP{background:#404958;border-radius:4px!important;padding:0 9px 9px 9px}.src-components-Grids-table-TqqH{width:100%;border-spacing:0;border-collapse:separate}.src-components-Grids-table-TqqH thead{color:#fff}.src-components-Grids-table-TqqH thead th{box-sizing:border-box;padding:0;font-size:13px;line-height:24px;font-weight:300;text-align:center}.src-components-Grids-table-TqqH tbody,.src-components-Grids-table-TqqH tfoot{background-color:#fff}.src-components-Grids-row-2l2J:hover{background-color:rgba(110,124,141,.2)}.src-components-Grids-rowMovable-159R{cursor:grab}.src-components-Grids-rowEven-3pMH{background-color:rgba(110,124,141,.1)}.src-components-Grids-cell-1hyV{border:solid #6e7c8d;border-width:.75px 0 0 .75px;padding-top:2px}.src-components-Grids-cellR-2VKo{border-right-width:.75px}.src-components-Grids-cellB-vsPG{border-bottom-width:.75px}.src-components-Grids-cellTL-2w1l{border-top-left-radius:4px!important}.src-components-Grids-cellTR-2bkV{border-top-right-radius:4px!important}.src-components-Grids-cellBL-8CUf{border-bottom-left-radius:4px!important}.src-components-Grids-cellBR-1pI4{border-bottom-right-radius:4px!important}.src-components-Grids-cellF-1EHo{border:.75px solid #6e7c8d;border-bottom-left-radius:4px!important;border-bottom-right-radius:4px!important;padding-top:2px}.src-components-Grids-cell-1hyV.src-components-Grids-cellDrop-2hgx,.src-components-Grids-cellF-1EHo.src-components-Grids-cellDrop-2hgx{border-top:2.75px solid #202020;padding-top:0}.src-components-Grids-emptyFooter-2lu4{height:10px}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-Grids-box-2ZsP",
      "table": "src-components-Grids-table-TqqH",
      "row": "src-components-Grids-row-2l2J",
      "rowMovable": "src-components-Grids-rowMovable-159R",
      "rowEven": "src-components-Grids-rowEven-3pMH",
      "cell": "src-components-Grids-cell-1hyV",
      "cellR": "src-components-Grids-cellR-2VKo",
      "cellB": "src-components-Grids-cellB-vsPG",
      "cellTL": "src-components-Grids-cellTL-2w1l",
      "cellTR": "src-components-Grids-cellTR-2bkV",
      "cellBL": "src-components-Grids-cellBL-8CUf",
      "cellBR": "src-components-Grids-cellBR-1pI4",
      "cellF": "src-components-Grids-cellF-1EHo",
      "cellDrop": "src-components-Grids-cellDrop-2hgx",
      "emptyFooter": "src-components-Grids-emptyFooter-2lu4"
    }
  });
};
/* scoped */


const __vue_scope_id__$3 = undefined;
/* module identifier */

const __vue_module_identifier__$3 = undefined;
/* functional template */

const __vue_is_functional_template__$3 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, createInjector, undefined, undefined);

var script$2 = {
  name: 'TablePager',
  props: {
    value: {
      type: Number,
      default: 1
    },
    itemsCount: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 5
    },
    pagingSpread: {
      type: Number,
      default: 2
    }
  },
  computed: {
    totalPages() {
      return this.itemsCount && Math.floor((this.itemsCount - 1) / this.pageSize) + 1 || 0;
    },

    pageItems() {
      if (this.totalPages <= 1) {
        return null;
      }

      const page = Math.min(Math.max(this.value || 1, 1), this.totalPages);
      const indices = Array.from(Array(this.pagingSpread * 2 + 1)).map((x, i) => page + i - this.pagingSpread);
      const first = indices[0];

      if (first < 1) {
        indices.splice(0, 1 - first);
      } else if (first === 2) {
        indices.splice(0, 0, 1);
      } else if (first === 3) {
        indices.splice(0, 0, 1, 2);
      } else if (first > 3) {
        indices.splice(0, 0, 1, null);
      }

      const last = indices[indices.length - 1];

      if (last > this.totalPages) {
        indices.splice(indices.length - (last - this.totalPages), last - this.totalPages);
      } else if (last === this.totalPages - 1) {
        indices.splice(indices.length, 0, this.totalPages);
      } else if (last === this.totalPages - 2) {
        indices.splice(indices.length, 0, this.totalPages - 1, this.totalPages);
      } else if (last < this.totalPages - 2) {
        indices.splice(indices.length, 0, null, this.totalPages);
      }

      return indices.map((page, index) => ({
        id: index,
        page: page != this.value && page || null,
        text: page || "...",
        cls: {
          [this.$style.page]: true,
          [this.$style.pageSpacer]: !page,
          [this.$style.pageActive]: page == this.value
        }
      }));
    }

  }
};

/* script */
const __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.$style.box
  }, [_vm.pageItems ? _c('div', _vm._l(_vm.pageItems, function (item) {
    return _c('a', {
      key: item.id,
      class: item.cls,
      on: {
        "click": function ($event) {
          return _vm.$emit('input', item.page);
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.text) + "\n    ")]);
  }), 0) : _vm._e(), _vm._v(" "), _vm.value < _vm.totalPages ? _c('div', [_c('a', {
    class: _vm.$style.nextPage,
    on: {
      "click": function ($event) {
        return _vm.$emit('input', _vm.value + 1);
      }
    }
  }, [_vm._v("\n      Показать следующие " + _vm._s(_vm.pageSize) + "\n    ")])]) : _vm._e()]);
};

var __vue_staticRenderFns__$2 = [];
/* style */

const __vue_inject_styles__$2 = function (inject) {
  if (!inject) return;
  inject("data-v-4ddaacfe_0", {
    source: ".src-components-Grids-box-1Duc{display:flex;font-size:13px;line-height:24px}.src-components-Grids-box-1Duc div{flex:auto}.src-components-Grids-page-1IZ_{padding:0 5px;text-decoration:none;cursor:pointer;user-select:none}.src-components-Grids-pageSpacer-34Vy{cursor:default}.src-components-Grids-pageActive-Wumg{font-weight:700;cursor:default}.src-components-Grids-nextPage-19kh{text-decoration:underline;cursor:pointer;user-select:none}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "box": "src-components-Grids-box-1Duc",
      "page": "src-components-Grids-page-1IZ_",
      "pageSpacer": "src-components-Grids-pageSpacer-34Vy",
      "pageActive": "src-components-Grids-pageActive-Wumg",
      "nextPage": "src-components-Grids-nextPage-19kh"
    }
  });
};
/* scoped */


const __vue_scope_id__$2 = undefined;
/* module identifier */

const __vue_module_identifier__$2 = undefined;
/* functional template */

const __vue_is_functional_template__$2 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, createInjector, undefined, undefined);

var script$1 = {
  name: 'ComponentsPagableTable',
  components: {
    ComponentsTable: __vue_component__$3,
    TablePager: __vue_component__$2
  },
  props: {
    headers: Array,
    rows: Array,
    pageSize: {
      type: Number,
      default: 5
    }
  },

  data() {
    return {
      page: 1
    };
  },

  computed: {
    rowsPage() {
      return this.rows.slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
    }

  }
};

/* script */
const __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('ComponentsTable', {
    attrs: {
      "headers": _vm.headers,
      "rows": _vm.rowsPage
    },
    scopedSlots: _vm._u([_vm.rows.length > _vm.pageSize ? {
      key: "footer",
      fn: function () {
        return [_c('TablePager', {
          attrs: {
            "itemsCount": _vm.rows.length,
            "pageSize": _vm.pageSize
          },
          model: {
            value: _vm.page,
            callback: function ($$v) {
              _vm.page = $$v;
            },
            expression: "page"
          }
        })];
      },
      proxy: true
    } : null, _vm._l(_vm.$scopedSlots, function (index, name) {
      return {
        key: name,
        fn: function (data) {
          return [_vm._t(name, null, null, data)];
        }
      };
    })], null, true)
  });
};

var __vue_staticRenderFns__$1 = [];
/* style */

const __vue_inject_styles__$1 = function (inject) {
  if (!inject) return;
  inject("data-v-1b6574cf_0", {
    source: "",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {}
  });
};
/* scoped */


const __vue_scope_id__$1 = undefined;
/* module identifier */

const __vue_module_identifier__$1 = undefined;
/* functional template */

const __vue_is_functional_template__$1 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, createInjector, undefined, undefined);

var script = {
  name: 'ComponentsCollapsableTable',
  components: {
    ComponentsTable: __vue_component__$3
  },
  props: {
    headers: Array,
    rows: Array,
    enableRowMove: {
      type: Boolean,
      default: false
    },
    moveColWidth: {
      type: String,
      default: '10px'
    },
    showCount: {
      type: Number,
      default: 5
    }
  },

  data() {
    return {
      showAll: false
    };
  },

  computed: {
    visibleRows() {
      return this.showAll ? this.rows : this.rows.slice(0, this.showCount);
    }

  }
};

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('ComponentsTable', _vm._g({
    attrs: {
      "headers": _vm.headers,
      "rows": _vm.visibleRows,
      "enableRowMove": _vm.enableRowMove,
      "moveColWidth": _vm.moveColWidth
    },
    scopedSlots: _vm._u([_vm.rows.length > _vm.showCount ? {
      key: "footer",
      fn: function () {
        return [_c('div', {
          class: _vm.$style.toggleBox
        }, [_vm.showAll ? _c('a', {
          class: _vm.$style.toggle,
          on: {
            "click": function ($event) {
              _vm.showAll = false;
            }
          }
        }, [_vm._v("свернуть")]) : _c('a', {
          class: _vm.$style.toggle,
          on: {
            "click": function ($event) {
              _vm.showAll = true;
            }
          }
        }, [_vm._v("показать все")])])];
      },
      proxy: true
    } : null, _vm._l(_vm.$scopedSlots, function (index, name) {
      return {
        key: name,
        fn: function (data) {
          return [_vm._t(name, null, null, data)];
        }
      };
    })], null, true)
  }, _vm.$listeners));
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-0ab2e404_0", {
    source: ".src-components-Grids-toggleBox-28GL{text-align:center;font-size:13px;line-height:24px}.src-components-Grids-toggle-31_Q{color:#202020;text-decoration:underline;cursor:pointer;user-select:none}.src-components-Grids-toggle-31_Q:hover{color:#202020}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "toggleBox": "src-components-Grids-toggleBox-28GL",
      "toggle": "src-components-Grids-toggle-31_Q"
    }
  });
};
/* scoped */


const __vue_scope_id__ = undefined;
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

function decline(number, form1, form2, form5) {
  if (number != Math.floor(number)) {
    return form2;
  }

  form5 = form5 || form2;
  number = number % 100;

  if (number >= 11 && number <= 19) {
    return form5;
  }

  number = number % 10;

  if (number == 1) {
    return form1;
  }

  if (number == 2 || number == 3 || number == 4) {
    return form2;
  }

  return form5;
}

var numeric = /*#__PURE__*/Object.freeze({
  __proto__: null,
  decline: decline
});

const orders = Object.freeze({
  priceAsc: {
    value: 1,
    name: 'по цене',
    isAsc: true
  },
  priceDesc: {
    value: 2,
    name: 'по цене',
    isAsc: false
  },
  publishDateAsc: {
    value: 3,
    name: 'по дате публикации',
    isAsc: true
  },
  publishDateDesc: {
    value: 4,
    name: 'по дате публикации',
    isAsc: false
  }
});
const orderDefault = orders.priceAsc.value;
const pageSizeDefault = 20;
const maxPageCount = 50;
const queryKeys = Object.freeze({
  keywords: 'k',
  kladr: 'r',
  okpd2: 'ok',
  supplier: 'su',
  supplierKeys: 'sk',
  minPrice: 'pf',
  maxPrice: 'pt',
  order: 'o',
  page: 'p',
  pageSize: 's',
  categories: 'ct'
});

function toOrderItem(order) {
  return {
    key: order.value,
    text: order.name,
    direction: order.isAsc && 'Asc' || 'Desc'
  };
}

function getOrderItems() {
  return [toOrderItem(orders.priceAsc), toOrderItem(orders.priceDesc), toOrderItem(orders.publishDateAsc), toOrderItem(orders.publishDateDesc)];
}

function getQueryArray(value) {
  if (isString(value)) {
    return [value];
  }

  if (isArray(value)) {
    return value.filter(isString);
  }

  return [];
}

function getEmptyFilter() {
  return {
    keywords: [],
    kladr: null,
    okpd2: null,
    supplier: null,
    suppliers: null,
    supplierKeys: null,
    minPrice: null,
    maxPrice: null,
    categories: null
  };
}
function getQueryData(query) {
  if (!query) {
    return {
      filter: {},
      order: orderDefault,
      paging: {
        page: 1,
        pageSize: pageSizeDefault
      }
    };
  }

  let page = parseInt(query[queryKeys.page]) > maxPageCount ? maxPageCount : parseInt(query[queryKeys.page]);
  const data = {
    filter: {
      keywords: getQueryArray(query[queryKeys.keywords]),
      kladr: getQueryArray(query[queryKeys.kladr]).map(key => ({
        key
      })),
      okpd2: getQueryArray(query[queryKeys.okpd2]).map(key => ({
        key
      })),
      categories: getQueryArray(query[queryKeys.categories]).map(key => ({
        key
      })),
      supplier: query[queryKeys.supplier],
      supplierKeys: getQueryArray(query[queryKeys.supplierKeys]),
      minPrice: parseFloat(query[queryKeys.minPrice]) || null,
      maxPrice: parseFloat(query[queryKeys.maxPrice]) || null
    },
    order: parseInt(query[queryKeys.order]) || orderDefault,
    paging: {
      page: page || 1,
      pageSize: parseInt(query[queryKeys.pageSize]) || pageSizeDefault
    }
  };
  return data;
}
function assignQueryData(data, query, seo) {
  const queryData = getQueryData(query);
  let filter = queryData.filter;

  if (seo && seo.filter) {
    if (seo.filter.keyword) filter.keywords = [seo.filter.keyword];
    if (seo.filter.categoryCode) filter.categories = [{
      key: seo.filter.categoryCode.value,
      name: seo.filter.categoryCode.urlPart
    }];
    if (seo.filter.deliveryKladr) filter.kladr = [{
      key: seo.filter.deliveryKladr.value,
      name: seo.filter.deliveryKladr.urlPart
    }];
    if (seo.filter.supplierKey) filter.supplierKeys = [seo.filter.supplierKey.value];
  }

  Object.assign(data.filter, filter);
  Object.assign(data.paging, queryData.paging);
  data.order = queryData.order;
}
function getQuery(data, seoData) {
  const query = {};
  let seo = seoData && seoData.url;

  if (seo) {
    query.seo = true;
    query.url = seoData.url;
    query.noTranslitSections = seoData.noTranslitSections;
  }

  if (data.filter && !seo) {
    if (isArray(data.filter.keywords) && data.filter.keywords.length) {
      query[queryKeys.keywords] = data.filter.keywords.filter(isString);
    }

    if (isArray(data.filter.kladr) && data.filter.kladr.length) {
      query[queryKeys.kladr] = data.filter.kladr.map(x => x.key);
    }

    if (isArray(data.filter.okpd2) && data.filter.okpd2.length) {
      query[queryKeys.okpd2] = data.filter.okpd2.map(x => x.key);
    }

    if (isArray(data.filter.categories) && data.filter.categories.length) {
      query[queryKeys.categories] = data.filter.categories.map(x => x.key);
    }

    if (isString(data.filter.supplier)) {
      query[queryKeys.supplier] = data.filter.supplier;
    }

    if (isArray(data.filter.suppliers) && data.filter.suppliers.length) {
      query[queryKeys.supplierKeys] = data.filter.suppliers.map(x => x.inn + '_' + (x.kpp || ''));
    }

    if (isNumber(data.filter.minPrice)) {
      query[queryKeys.minPrice] = data.filter.minPrice;
    }

    if (isNumber(data.filter.maxPrice)) {
      query[queryKeys.maxPrice] = data.filter.maxPrice;
    }
  }

  if (isNumber(data.order) && data.order !== orderDefault) {
    query[queryKeys.order] = data.order;
  }

  if (data.paging) {
    if (isNumber(data.paging.page) && data.paging.page > 1) {
      query[queryKeys.page] = data.paging.page;
    }

    if (isNumber(data.paging.pageSize) && data.paging.pageSize != pageSizeDefault && data.paging.pageSize > 1) {
      query[queryKeys.pageSize] = data.paging.pageSize;
    }
  }

  return query;
}
function getSearchParam(data, seo) {
  const keywords = seo && seo.filter && seo.filter.keyword && [seo.filter.keyword] || data.filter && data.filter.keywords || null;
  const kladr = seo && seo.filter && seo.filter.deliveryKladr && [seo.filter.deliveryKladr.value] || data.filter && data.filter.kladr && data.filter.kladr.length && data.filter.kladr.map(x => x.key) || null;
  const okpd2 = data.filter && data.filter.okpd2 && data.filter.okpd2.length && data.filter.okpd2.map(x => x.key) || null;
  const categories = seo && seo.filter && seo.filter.categoryCode && [seo.filter.categoryCode.value] || data.filter && data.filter.categories && data.filter.categories.length && data.filter.categories.map(x => x.key) || null;
  const supplierKeys = seo && seo.filter && seo.filter.supplierKey && [seo.filter.supplierKey.value] || data.filter.supplierKeys;
  return {
    filter: {
      keywords: keywords,
      deliveryKladrs: kladr,
      okpd2Codes: okpd2,
      categoryCodes: categories,
      supplier: data.filter.supplier,
      supplierKeys: supplierKeys,
      minPrice: data.filter.minPrice,
      maxPrice: data.filter.maxPrice
    },
    order: data.order,
    ...data.paging
  };
}
function translitName(name) {
  return getSlug(name);
}
function getCardUri(id, name, cardUriTemplate = OFFER_CARD_URI_TEMPLATE) {
  const slug = getSlug(name);
  const slugSegment = slug && '/' + slug || '';
  const idSegment = '/' + id;
  return cardUriTemplate + slugSegment + idSegment;
}

function isArray(value) {
  return Array.isArray(value);
}

function isString(value) {
  return typeof value === 'string' || value instanceof String;
}

function isNumber(value) {
  return typeof value === 'number' && isFinite(value);
}

const symbolMap = {
  'а': 'a',
  'к': 'k',
  'х': 'h',
  'б': 'b',
  'л': 'l',
  'ц': 'c',
  'в': 'v',
  'м': 'm',
  'ч': 'ch',
  'г': 'g',
  'н': 'n',
  'ш': 'sh',
  'д': 'd',
  'о': 'o',
  'щ': 'sch',
  'е': 'e',
  'п': 'p',
  'ъ': '',
  'ё': 'yo',
  'р': 'r',
  'ы': 'y',
  'ж': 'zh',
  'с': 's',
  'ь': '',
  'з': 'z',
  'т': 't',
  'э': 'e',
  'и': 'i',
  'у': 'u',
  'ю': 'yu',
  'й': 'j',
  'ф': 'f',
  'я': 'ya'
};
const prepositions = ['в', 'без', 'до', 'из', 'к', 'на', 'по', 'о', 'от', 'перед', 'при', 'через', 'с', 'у', 'за', 'над', 'об', 'под', 'про', 'для'];

function getSlugLetter(letter) {
  return symbolMap[letter] || /[a-z0-9]/.test(letter) && letter || '';
}

function getSlugWord(word) {
  return Array.from(word).map(getSlugLetter).join('');
}

function getSlug(str) {
  if (!str || !str.length) {
    return null;
  }

  const words = str.split(/[- !#"$%&'()*+,.:;<=>?@^_`{}|~[/\\\]]/).filter(x => x.length).map(x => x.toLowerCase());

  if (!words.length) {
    return null;
  }

  let wordsInSlug = 0;
  const slugWords = [];

  for (const word of words) {
    const slugWord = getSlugWord(word);

    if (!slugWord.length) {
      continue;
    }

    slugWords.push(slugWord);

    if (!prepositions.includes(word)) {
      if (++wordsInSlug >= 7) {
        break;
      }
    }
  }

  return slugWords.join('-') || null;
}

var offersSearch = /*#__PURE__*/Object.freeze({
  __proto__: null,
  orders: orders,
  orderDefault: orderDefault,
  pageSizeDefault: pageSizeDefault,
  maxPageCount: maxPageCount,
  getOrderItems: getOrderItems,
  getEmptyFilter: getEmptyFilter,
  getQueryData: getQueryData,
  assignQueryData: assignQueryData,
  getQuery: getQuery,
  getSearchParam: getSearchParam,
  translitName: translitName,
  getCardUri: getCardUri
});

export { __vue_component__$i as BreadCrumbs, __vue_component__$1Y as Button, __vue_component__$L as ButtonBlue, __vue_component__$K as ButtonBoat, __vue_component__$1P as ButtonClean, __vue_component__$1n as ButtonGrey, __vue_component__$1X as ButtonRed, __vue_component__$J as ButtonTiny, __vue_component__$1m as ButtonWhite, __vue_component__$1B as Calendar, __vue_component__$p as CheckBox, __vue_component__$o as CheckBoxGroup, __vue_component__$1a as CheckBoxSmall, __vue_component__ as ComponentsCollapsableTable, __vue_component__$1 as ComponentsPagableTable, __vue_component__$3 as ComponentsTable, __vue_component__$14 as CounterpartyLoading, __vue_component__$18 as CounterpartySlider, __vue_component__$T as CounterpartyTable, __vue_component__$Q as CounterpartyWidget, __vue_component__$R as CounterpartyWidgetSmall, __vue_component__$P as CounterpartyWidgetSmallPage, __vue_component__$V as CustomersTable, __vue_component__$m as DateRange, __vue_component__$l as DateRangeInput, __vue_component__$y as DropDown, __vue_component__$C as DropDownList, __vue_component__$1y as FileUploader, __vue_component__$11 as FilterTag, __vue_component__$g as Icon, __vue_component__$1U as IconAdd, __vue_component__$b as IconBan, __vue_component__$q as IconCheckBox, __vue_component__$d as IconCheckMark, __vue_component__$c as IconCheckMarkBig, __vue_component__$1Q as IconClose, __vue_component__$h as IconCloseBig, __vue_component__$f as IconDelete, __vue_component__$E as IconDown, __vue_component__$8 as IconGripVert, __vue_component__$1O as IconInfo, __vue_component__$u as IconLoupe, __vue_component__$9 as IconMinus, __vue_component__$1T as IconPen, __vue_component__$H as IconPenSmall, __vue_component__$I as IconPenWhite, __vue_component__$a as IconPlus, __vue_component__$1u as IconRemove, __vue_component__$1k as IconRub, __vue_component__$z as IconSettings, __vue_component__$t as IconSortDirection, __vue_component__$x as IconTagClose, __vue_component__$e as IconTrash, __vue_component__$1S as IconXls, __vue_component__$v as KeywordsTags, __vue_component__$1M as LabelInfo, __vue_component__$15 as Loader, __vue_component__$1l as LoaderSmall, __vue_component__$U as LoaderSmallColored, __vue_component__$X as MapHeat, __vue_component__$W as MapHeatForPrint, __vue_component__$1V as Modal, __vue_component__$1v as ModalEdit1, __vue_component__$1q as ModalEdit2, __vue_component__$j as ModalShow, __vue_component__$1s as MoneyEditor, __vue_component__$A as MoneyInput, __vue_component__$1r as MoneyRange, __vue_component__$1t as NumberInput, __vue_component__$12 as OfferForProcedurePage, __vue_component__$s as OrderType, __vue_component__$M as Pager, __vue_component__$4 as PopupComponent, __vue_component__$1I as RadioButton, __vue_component__$1G as RadioGroup, __vue_component__$Z as RussianMap, __vue_component__$Y as RussianMapForPrint, __vue_component__$7 as SearchTextEditor, __vue_component__$B as Select, __vue_component__$n as SelectField, __vue_component__$k as SimpleTable, __vue_component__$$ as Speedometer, __vue_component__$S as SpeedometerLabel, __vue_component__$G as StarsRating, __vue_component__$1K as TextEditor, __vue_component__$r as TextTagsItem, __vue_component__$O as ThemeDark, __vue_component__$N as ThemeWhite, __vue_component__$1N as Tooltip, asyncData, converter, http, numeric, obj, offersSearch, paging, popupShow, __vue_component__$1w as spinner, str, types };
